var XB = Object.defineProperty, JB = Object.defineProperties;
var eU = Object.getOwnPropertyDescriptors;
var Wv = Object.getOwnPropertySymbols;
var VT = Object.prototype.hasOwnProperty, WT = Object.prototype.propertyIsEnumerable;
var UT = (e, r, t) => r in e ? XB(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Yt = (e, r) => {
  for (var t in r || (r = {}))
    VT.call(r, t) && UT(e, t, r[t]);
  if (Wv)
    for (var t of Wv(r))
      WT.call(r, t) && UT(e, t, r[t]);
  return e;
}, Fo = (e, r) => JB(e, eU(r));
var Hv = (e, r) => {
  var t = {};
  for (var n in e)
    VT.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Wv)
    for (var n of Wv(e))
      r.indexOf(n) < 0 && WT.call(e, n) && (t[n] = e[n]);
  return t;
};
var Gr = (e, r, t) => new Promise((n, a) => {
  var i = (c) => {
    try {
      u(t.next(c));
    } catch (f) {
      a(f);
    }
  }, l = (c) => {
    try {
      u(t.throw(c));
    } catch (f) {
      a(f);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(i, l);
  u((t = t.apply(e, r)).next());
});
import * as I from "react";
import $o, { forwardRef as H0, useContext as Ur, createContext as Pn, createElement as Di, Fragment as R2, useRef as Ze, useState as He, useMemo as Rt, useLayoutEffect as TO, useEffect as er, useCallback as Le, cloneElement as rU, Children as tU, isValidElement as nU, PureComponent as aU, useReducer as oU, useImperativeHandle as iU } from "react";
import sU from "react-dom";
var Pi = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function G0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var CO = { exports: {} }, Rf = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lU = $o, EO = 60103;
Rf.Fragment = 60107;
if (typeof Symbol == "function" && Symbol.for) {
  var HT = Symbol.for;
  EO = HT("react.element"), Rf.Fragment = HT("react.fragment");
}
var uU = lU.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, cU = Object.prototype.hasOwnProperty, dU = { key: !0, ref: !0, __self: !0, __source: !0 };
function AO(e, r, t) {
  var n, a = {}, i = null, l = null;
  t !== void 0 && (i = "" + t), r.key !== void 0 && (i = "" + r.key), r.ref !== void 0 && (l = r.ref);
  for (n in r)
    cU.call(r, n) && !dU.hasOwnProperty(n) && (a[n] = r[n]);
  if (e && e.defaultProps)
    for (n in r = e.defaultProps, r)
      a[n] === void 0 && (a[n] = r[n]);
  return { $$typeof: EO, type: e, key: i, ref: l, props: a, _owner: uU.current };
}
Rf.jsx = AO;
Rf.jsxs = AO;
CO.exports = Rf;
var _ = CO.exports;
function fU(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function vU(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var hU = /* @__PURE__ */ function() {
  function e(t) {
    var n = this;
    this._insertTag = function(a) {
      var i;
      n.tags.length === 0 ? n.insertionPoint ? i = n.insertionPoint.nextSibling : n.prepend ? i = n.container.firstChild : i = n.before : i = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(a, i), n.tags.push(a);
    }, this.isSpeedy = t.speedy === void 0 ? !0 : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, r.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(vU(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = fU(a);
      try {
        i.insertRule(n, i.cssRules.length);
      } catch (l) {
      }
    } else
      a.appendChild(document.createTextNode(n));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), wn = "-ms-", Gp = "-moz-", Ir = "-webkit-", IO = "comm", P2 = "rule", k2 = "decl", pU = "@import", OO = "@keyframes", gU = "@layer", mU = Math.abs, Y0 = String.fromCharCode, bU = Object.assign;
function yU(e, r) {
  return on(e, 0) ^ 45 ? (((r << 2 ^ on(e, 0)) << 2 ^ on(e, 1)) << 2 ^ on(e, 2)) << 2 ^ on(e, 3) : 0;
}
function MO(e) {
  return e.trim();
}
function SU(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function Mr(e, r, t) {
  return e.replace(r, t);
}
function vS(e, r) {
  return e.indexOf(r);
}
function on(e, r) {
  return e.charCodeAt(r) | 0;
}
function Zd(e, r, t) {
  return e.slice(r, t);
}
function Zo(e) {
  return e.length;
}
function j2(e) {
  return e.length;
}
function Gv(e, r) {
  return r.push(e), e;
}
function xU(e, r) {
  return e.map(r).join("");
}
var K0 = 1, pc = 1, RO = 0, Zn = 0, Pt = 0, Tc = "";
function q0(e, r, t, n, a, i, l) {
  return { value: e, root: r, parent: t, type: n, props: a, children: i, line: K0, column: pc, length: l, return: "" };
}
function td(e, r) {
  return bU(q0("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function $U() {
  return Pt;
}
function wU() {
  return Pt = Zn > 0 ? on(Tc, --Zn) : 0, pc--, Pt === 10 && (pc = 1, K0--), Pt;
}
function ma() {
  return Pt = Zn < RO ? on(Tc, Zn++) : 0, pc++, Pt === 10 && (pc = 1, K0++), Pt;
}
function ri() {
  return on(Tc, Zn);
}
function mp() {
  return Zn;
}
function Pf(e, r) {
  return Zd(Tc, e, r);
}
function Qd(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function PO(e) {
  return K0 = pc = 1, RO = Zo(Tc = e), Zn = 0, [];
}
function kO(e) {
  return Tc = "", e;
}
function bp(e) {
  return MO(Pf(Zn - 1, hS(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function _U(e) {
  for (; (Pt = ri()) && Pt < 33; )
    ma();
  return Qd(e) > 2 || Qd(Pt) > 3 ? "" : " ";
}
function TU(e, r) {
  for (; --r && ma() && !(Pt < 48 || Pt > 102 || Pt > 57 && Pt < 65 || Pt > 70 && Pt < 97); )
    ;
  return Pf(e, mp() + (r < 6 && ri() == 32 && ma() == 32));
}
function hS(e) {
  for (; ma(); )
    switch (Pt) {
      case e:
        return Zn;
      case 34:
      case 39:
        e !== 34 && e !== 39 && hS(Pt);
        break;
      case 40:
        e === 41 && hS(e);
        break;
      case 92:
        ma();
        break;
    }
  return Zn;
}
function CU(e, r) {
  for (; ma() && e + Pt !== 47 + 10; )
    if (e + Pt === 42 + 42 && ri() === 47)
      break;
  return "/*" + Pf(r, Zn - 1) + "*" + Y0(e === 47 ? e : ma());
}
function EU(e) {
  for (; !Qd(ri()); )
    ma();
  return Pf(e, Zn);
}
function AU(e) {
  return kO(yp("", null, null, null, [""], e = PO(e), 0, [0], e));
}
function yp(e, r, t, n, a, i, l, u, c) {
  for (var f = 0, h = 0, p = l, g = 0, y = 0, S = 0, x = 1, T = 1, A = 1, O = 0, P = "", j = a, k = i, L = n, M = P; T; )
    switch (S = O, O = ma()) {
      case 40:
        if (S != 108 && on(M, p - 1) == 58) {
          vS(M += Mr(bp(O), "&", "&\f"), "&\f") != -1 && (A = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        M += bp(O);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        M += _U(S);
        break;
      case 92:
        M += TU(mp() - 1, 7);
        continue;
      case 47:
        switch (ri()) {
          case 42:
          case 47:
            Gv(IU(CU(ma(), mp()), r, t), c);
            break;
          default:
            M += "/";
        }
        break;
      case 123 * x:
        u[f++] = Zo(M) * A;
      case 125 * x:
      case 59:
      case 0:
        switch (O) {
          case 0:
          case 125:
            T = 0;
          case 59 + h:
            A == -1 && (M = Mr(M, /\f/g, "")), y > 0 && Zo(M) - p && Gv(y > 32 ? YT(M + ";", n, t, p - 1) : YT(Mr(M, " ", "") + ";", n, t, p - 2), c);
            break;
          case 59:
            M += ";";
          default:
            if (Gv(L = GT(M, r, t, f, h, a, u, P, j = [], k = [], p), i), O === 123)
              if (h === 0)
                yp(M, r, L, L, j, i, p, u, k);
              else
                switch (g === 99 && on(M, 3) === 110 ? 100 : g) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    yp(e, L, L, n && Gv(GT(e, L, L, 0, 0, a, u, P, a, j = [], p), k), a, k, p, u, n ? j : k);
                    break;
                  default:
                    yp(M, L, L, L, [""], k, 0, u, k);
                }
        }
        f = h = y = 0, x = A = 1, P = M = "", p = l;
        break;
      case 58:
        p = 1 + Zo(M), y = S;
      default:
        if (x < 1) {
          if (O == 123)
            --x;
          else if (O == 125 && x++ == 0 && wU() == 125)
            continue;
        }
        switch (M += Y0(O), O * x) {
          case 38:
            A = h > 0 ? 1 : (M += "\f", -1);
            break;
          case 44:
            u[f++] = (Zo(M) - 1) * A, A = 1;
            break;
          case 64:
            ri() === 45 && (M += bp(ma())), g = ri(), h = p = Zo(P = M += EU(mp())), O++;
            break;
          case 45:
            S === 45 && Zo(M) == 2 && (x = 0);
        }
    }
  return i;
}
function GT(e, r, t, n, a, i, l, u, c, f, h) {
  for (var p = a - 1, g = a === 0 ? i : [""], y = j2(g), S = 0, x = 0, T = 0; S < n; ++S)
    for (var A = 0, O = Zd(e, p + 1, p = mU(x = l[S])), P = e; A < y; ++A)
      (P = MO(x > 0 ? g[A] + " " + O : Mr(O, /&\f/g, g[A]))) && (c[T++] = P);
  return q0(e, r, t, a === 0 ? P2 : u, c, f, h);
}
function IU(e, r, t) {
  return q0(e, r, t, IO, Y0($U()), Zd(e, 2, -2), 0);
}
function YT(e, r, t, n) {
  return q0(e, r, t, k2, Zd(e, 0, n), Zd(e, n + 1, -1), n);
}
function nc(e, r) {
  for (var t = "", n = j2(e), a = 0; a < n; a++)
    t += r(e[a], a, e, r) || "";
  return t;
}
function OU(e, r, t, n) {
  switch (e.type) {
    case gU:
      if (e.children.length)
        break;
    case pU:
    case k2:
      return e.return = e.return || e.value;
    case IO:
      return "";
    case OO:
      return e.return = e.value + "{" + nc(e.children, n) + "}";
    case P2:
      e.value = e.props.join(",");
  }
  return Zo(t = nc(e.children, n)) ? e.return = e.value + "{" + t + "}" : "";
}
function MU(e) {
  var r = j2(e);
  return function(t, n, a, i) {
    for (var l = "", u = 0; u < r; u++)
      l += e[u](t, n, a, i) || "";
    return l;
  };
}
function RU(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
var KT = function(r) {
  var t = /* @__PURE__ */ new WeakMap();
  return function(n) {
    if (t.has(n))
      return t.get(n);
    var a = r(n);
    return t.set(n, a), a;
  };
};
function jO(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var PU = function(r, t, n) {
  for (var a = 0, i = 0; a = i, i = ri(), a === 38 && i === 12 && (t[n] = 1), !Qd(i); )
    ma();
  return Pf(r, Zn);
}, kU = function(r, t) {
  var n = -1, a = 44;
  do
    switch (Qd(a)) {
      case 0:
        a === 38 && ri() === 12 && (t[n] = 1), r[n] += PU(Zn - 1, t, n);
        break;
      case 2:
        r[n] += bp(a);
        break;
      case 4:
        if (a === 44) {
          r[++n] = ri() === 58 ? "&\f" : "", t[n] = r[n].length;
          break;
        }
      default:
        r[n] += Y0(a);
    }
  while (a = ma());
  return r;
}, jU = function(r, t) {
  return kO(kU(PO(r), t));
}, qT = /* @__PURE__ */ new WeakMap(), DU = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, n = r.parent, a = r.column === n.column && r.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !qT.get(n)) && !a) {
      qT.set(r, !0);
      for (var i = [], l = jU(t, i), u = n.props, c = 0, f = 0; c < l.length; c++)
        for (var h = 0; h < u.length; h++, f++)
          r.props[f] = i[c] ? l[c].replace(/&\f/g, u[h]) : u[h] + " " + l[c];
    }
  }
}, NU = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
};
function DO(e, r) {
  switch (yU(e, r)) {
    case 5103:
      return Ir + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Ir + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Ir + e + Gp + e + wn + e + e;
    case 6828:
    case 4268:
      return Ir + e + wn + e + e;
    case 6165:
      return Ir + e + wn + "flex-" + e + e;
    case 5187:
      return Ir + e + Mr(e, /(\w+).+(:[^]+)/, Ir + "box-$1$2" + wn + "flex-$1$2") + e;
    case 5443:
      return Ir + e + wn + "flex-item-" + Mr(e, /flex-|-self/, "") + e;
    case 4675:
      return Ir + e + wn + "flex-line-pack" + Mr(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Ir + e + wn + Mr(e, "shrink", "negative") + e;
    case 5292:
      return Ir + e + wn + Mr(e, "basis", "preferred-size") + e;
    case 6060:
      return Ir + "box-" + Mr(e, "-grow", "") + Ir + e + wn + Mr(e, "grow", "positive") + e;
    case 4554:
      return Ir + Mr(e, /([^-])(transform)/g, "$1" + Ir + "$2") + e;
    case 6187:
      return Mr(Mr(Mr(e, /(zoom-|grab)/, Ir + "$1"), /(image-set)/, Ir + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Mr(e, /(image-set\([^]*)/, Ir + "$1$`$1");
    case 4968:
      return Mr(Mr(e, /(.+:)(flex-)?(.*)/, Ir + "box-pack:$3" + wn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Ir + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Mr(e, /(.+)-inline(.+)/, Ir + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Zo(e) - 1 - r > 6)
        switch (on(e, r + 1)) {
          case 109:
            if (on(e, r + 4) !== 45)
              break;
          case 102:
            return Mr(e, /(.+:)(.+)-([^]+)/, "$1" + Ir + "$2-$3$1" + Gp + (on(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~vS(e, "stretch") ? DO(Mr(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (on(e, r + 1) !== 115)
        break;
    case 6444:
      switch (on(e, Zo(e) - 3 - (~vS(e, "!important") && 10))) {
        case 107:
          return Mr(e, ":", ":" + Ir) + e;
        case 101:
          return Mr(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Ir + (on(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Ir + "$2$3$1" + wn + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (on(e, r + 11)) {
        case 114:
          return Ir + e + wn + Mr(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Ir + e + wn + Mr(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Ir + e + wn + Mr(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Ir + e + wn + e + e;
  }
  return e;
}
var LU = function(r, t, n, a) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case k2:
        r.return = DO(r.value, r.length);
        break;
      case OO:
        return nc([td(r, {
          value: Mr(r.value, "@", "@" + Ir)
        })], a);
      case P2:
        if (r.length)
          return xU(r.props, function(i) {
            switch (SU(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return nc([td(r, {
                  props: [Mr(i, /:(read-\w+)/, ":" + Gp + "$1")]
                })], a);
              case "::placeholder":
                return nc([td(r, {
                  props: [Mr(i, /:(plac\w+)/, ":" + Ir + "input-$1")]
                }), td(r, {
                  props: [Mr(i, /:(plac\w+)/, ":" + Gp + "$1")]
                }), td(r, {
                  props: [Mr(i, /:(plac\w+)/, wn + "input-$1")]
                })], a);
            }
            return "";
          });
    }
}, FU = [LU], zU = function(r) {
  var t = r.key;
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(x) {
      var T = x.getAttribute("data-emotion");
      T.indexOf(" ") !== -1 && (document.head.appendChild(x), x.setAttribute("data-s", ""));
    });
  }
  var a = r.stylisPlugins || FU, i = {}, l, u = [];
  l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(x) {
      for (var T = x.getAttribute("data-emotion").split(" "), A = 1; A < T.length; A++)
        i[T[A]] = !0;
      u.push(x);
    }
  );
  var c, f = [DU, NU];
  {
    var h, p = [OU, RU(function(x) {
      h.insert(x);
    })], g = MU(f.concat(a, p)), y = function(T) {
      return nc(AU(T), g);
    };
    c = function(T, A, O, P) {
      h = O, y(T ? T + "{" + A.styles + "}" : A.styles), P && (S.inserted[A.name] = !0);
    };
  }
  var S = {
    key: t,
    sheet: new hU({
      key: t,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return S.sheet.hydrate(u), S;
};
function Yp() {
  return Yp = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Yp.apply(this, arguments);
}
var NO = { exports: {} }, Vr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zt = typeof Symbol == "function" && Symbol.for, D2 = Zt ? Symbol.for("react.element") : 60103, N2 = Zt ? Symbol.for("react.portal") : 60106, Z0 = Zt ? Symbol.for("react.fragment") : 60107, Q0 = Zt ? Symbol.for("react.strict_mode") : 60108, X0 = Zt ? Symbol.for("react.profiler") : 60114, J0 = Zt ? Symbol.for("react.provider") : 60109, eg = Zt ? Symbol.for("react.context") : 60110, L2 = Zt ? Symbol.for("react.async_mode") : 60111, rg = Zt ? Symbol.for("react.concurrent_mode") : 60111, tg = Zt ? Symbol.for("react.forward_ref") : 60112, ng = Zt ? Symbol.for("react.suspense") : 60113, BU = Zt ? Symbol.for("react.suspense_list") : 60120, ag = Zt ? Symbol.for("react.memo") : 60115, og = Zt ? Symbol.for("react.lazy") : 60116, UU = Zt ? Symbol.for("react.block") : 60121, VU = Zt ? Symbol.for("react.fundamental") : 60117, WU = Zt ? Symbol.for("react.responder") : 60118, HU = Zt ? Symbol.for("react.scope") : 60119;
function xa(e) {
  if (typeof e == "object" && e !== null) {
    var r = e.$$typeof;
    switch (r) {
      case D2:
        switch (e = e.type, e) {
          case L2:
          case rg:
          case Z0:
          case X0:
          case Q0:
          case ng:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case eg:
              case tg:
              case og:
              case ag:
              case J0:
                return e;
              default:
                return r;
            }
        }
      case N2:
        return r;
    }
  }
}
function LO(e) {
  return xa(e) === rg;
}
Vr.AsyncMode = L2;
Vr.ConcurrentMode = rg;
Vr.ContextConsumer = eg;
Vr.ContextProvider = J0;
Vr.Element = D2;
Vr.ForwardRef = tg;
Vr.Fragment = Z0;
Vr.Lazy = og;
Vr.Memo = ag;
Vr.Portal = N2;
Vr.Profiler = X0;
Vr.StrictMode = Q0;
Vr.Suspense = ng;
Vr.isAsyncMode = function(e) {
  return LO(e) || xa(e) === L2;
};
Vr.isConcurrentMode = LO;
Vr.isContextConsumer = function(e) {
  return xa(e) === eg;
};
Vr.isContextProvider = function(e) {
  return xa(e) === J0;
};
Vr.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === D2;
};
Vr.isForwardRef = function(e) {
  return xa(e) === tg;
};
Vr.isFragment = function(e) {
  return xa(e) === Z0;
};
Vr.isLazy = function(e) {
  return xa(e) === og;
};
Vr.isMemo = function(e) {
  return xa(e) === ag;
};
Vr.isPortal = function(e) {
  return xa(e) === N2;
};
Vr.isProfiler = function(e) {
  return xa(e) === X0;
};
Vr.isStrictMode = function(e) {
  return xa(e) === Q0;
};
Vr.isSuspense = function(e) {
  return xa(e) === ng;
};
Vr.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === Z0 || e === rg || e === X0 || e === Q0 || e === ng || e === BU || typeof e == "object" && e !== null && (e.$$typeof === og || e.$$typeof === ag || e.$$typeof === J0 || e.$$typeof === eg || e.$$typeof === tg || e.$$typeof === VU || e.$$typeof === WU || e.$$typeof === HU || e.$$typeof === UU);
};
Vr.typeOf = xa;
NO.exports = Vr;
var GU = NO.exports, FO = GU, YU = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, KU = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, zO = {};
zO[FO.ForwardRef] = YU;
zO[FO.Memo] = KU;
var qU = !0;
function BO(e, r, t) {
  var n = "";
  return t.split(" ").forEach(function(a) {
    e[a] !== void 0 ? r.push(e[a] + ";") : n += a + " ";
  }), n;
}
var F2 = function(r, t, n) {
  var a = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  qU === !1) && r.registered[a] === void 0 && (r.registered[a] = t.styles);
}, z2 = function(r, t, n) {
  F2(r, t, n);
  var a = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var i = t;
    do
      r.insert(t === i ? "." + a : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function ZU(e) {
  for (var r = 0, t, n = 0, a = e.length; a >= 4; ++n, a -= 4)
    t = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      r ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(n) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var QU = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, XU = /[A-Z]|^ms/g, JU = /_EMO_([^_]+?)_([^]*?)_EMO_/g, UO = function(r) {
  return r.charCodeAt(1) === 45;
}, ZT = function(r) {
  return r != null && typeof r != "boolean";
}, Ib = /* @__PURE__ */ jO(function(e) {
  return UO(e) ? e : e.replace(XU, "-$&").toLowerCase();
}), QT = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(JU, function(n, a, i) {
          return Qo = {
            name: a,
            styles: i,
            next: Qo
          }, a;
        });
  }
  return QU[r] !== 1 && !UO(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
function Xd(e, r, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0)
    return t;
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return Qo = {
          name: t.name,
          styles: t.styles,
          next: Qo
        }, t.name;
      if (t.styles !== void 0) {
        var n = t.next;
        if (n !== void 0)
          for (; n !== void 0; )
            Qo = {
              name: n.name,
              styles: n.styles,
              next: Qo
            }, n = n.next;
        var a = t.styles + ";";
        return a;
      }
      return eV(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var i = Qo, l = t(e);
        return Qo = i, Xd(e, r, l);
      }
      break;
    }
  }
  if (r == null)
    return t;
  var u = r[t];
  return u !== void 0 ? u : t;
}
function eV(e, r, t) {
  var n = "";
  if (Array.isArray(t))
    for (var a = 0; a < t.length; a++)
      n += Xd(e, r, t[a]) + ";";
  else
    for (var i in t) {
      var l = t[i];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? n += i + "{" + r[l] + "}" : ZT(l) && (n += Ib(i) + ":" + QT(i, l) + ";");
      else if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
        for (var u = 0; u < l.length; u++)
          ZT(l[u]) && (n += Ib(i) + ":" + QT(i, l[u]) + ";");
      else {
        var c = Xd(e, r, l);
        switch (i) {
          case "animation":
          case "animationName": {
            n += Ib(i) + ":" + c + ";";
            break;
          }
          default:
            n += i + "{" + c + "}";
        }
      }
    }
  return n;
}
var XT = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Qo, ig = function(r, t, n) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var a = !0, i = "";
  Qo = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (a = !1, i += Xd(n, t, l)) : i += l[0];
  for (var u = 1; u < r.length; u++)
    i += Xd(n, t, r[u]), a && (i += l[u]);
  XT.lastIndex = 0;
  for (var c = "", f; (f = XT.exec(i)) !== null; )
    c += "-" + // $FlowFixMe we know it's not null
    f[1];
  var h = ZU(i) + c;
  return {
    name: h,
    styles: i,
    next: Qo
  };
}, rV = function(r) {
  return r();
}, VO = I["useInsertionEffect"] ? I["useInsertionEffect"] : !1, WO = VO || rV, JT = VO || I.useLayoutEffect, sg = {}.hasOwnProperty, HO = /* @__PURE__ */ Pn(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement != "undefined" ? /* @__PURE__ */ zU({
    key: "css"
  }) : null
);
HO.Provider;
var B2 = function(r) {
  return /* @__PURE__ */ H0(function(t, n) {
    var a = Ur(HO);
    return r(t, a, n);
  });
}, tu = /* @__PURE__ */ Pn({}), tV = function(r, t) {
  if (typeof t == "function") {
    var n = t(r);
    return n;
  }
  return Yp({}, r, t);
}, nV = /* @__PURE__ */ KT(function(e) {
  return KT(function(r) {
    return tV(e, r);
  });
}), aV = function(r) {
  var t = Ur(tu);
  return r.theme !== t && (t = nV(t)(r.theme)), /* @__PURE__ */ Di(tu.Provider, {
    value: t
  }, r.children);
}, pS = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", GO = function(r, t) {
  var n = {};
  for (var a in t)
    sg.call(t, a) && (n[a] = t[a]);
  return n[pS] = r, n;
}, oV = function(r) {
  var t = r.cache, n = r.serialized, a = r.isStringTag;
  return F2(t, n, a), WO(function() {
    return z2(t, n, a);
  }), null;
}, YO = /* @__PURE__ */ B2(function(e, r, t) {
  var n = e.css;
  typeof n == "string" && r.registered[n] !== void 0 && (n = r.registered[n]);
  var a = e[pS], i = [n], l = "";
  typeof e.className == "string" ? l = BO(r.registered, i, e.className) : e.className != null && (l = e.className + " ");
  var u = ig(i, void 0, Ur(tu));
  l += r.key + "-" + u.name;
  var c = {};
  for (var f in e)
    sg.call(e, f) && f !== "css" && f !== pS && (c[f] = e[f]);
  return c.ref = t, c.className = l, /* @__PURE__ */ Di(R2, null, /* @__PURE__ */ Di(oV, {
    cache: r,
    serialized: u,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ Di(a, c));
}), U2 = /* @__PURE__ */ B2(function(e, r) {
  var t = e.styles, n = ig([t], void 0, Ur(tu)), a = Ze();
  return JT(function() {
    var i = r.key + "-global", l = new r.sheet.constructor({
      key: i,
      nonce: r.sheet.nonce,
      container: r.sheet.container,
      speedy: r.sheet.isSpeedy
    }), u = !1, c = document.querySelector('style[data-emotion="' + i + " " + n.name + '"]');
    return r.sheet.tags.length && (l.before = r.sheet.tags[0]), c !== null && (u = !0, c.setAttribute("data-emotion", i), l.hydrate([c])), a.current = [l, u], function() {
      l.flush();
    };
  }, [r]), JT(function() {
    var i = a.current, l = i[0], u = i[1];
    if (u) {
      i[1] = !1;
      return;
    }
    if (n.next !== void 0 && z2(r, n.next, !0), l.tags.length) {
      var c = l.tags[l.tags.length - 1].nextElementSibling;
      l.before = c, l.flush();
    }
    r.insert("", n, l, !1);
  }, [r, n.name]), null;
});
function iV() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return ig(r);
}
var KO = function() {
  var r = iV.apply(void 0, arguments), t = "animation-" + r.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + r.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, sV = function() {
  return /* @__PURE__ */ I.createElement(U2, {
    styles: `
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        font-feature-settings: 'kern';
      }

      *,
      *::before,
      *::after {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
      }

      main {
        display: block;
      }

      hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      pre,
      code,
      kbd,
      samp {
        font-family: SFMono-Regular,  Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      b,
      strong {
        font-weight: bold;
      }

      small {
        font-size: 80%;
      }

      sub,
      sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      sub {
        bottom: -0.25em;
      }

      sup {
        top: -0.5em;
      }

      img {
        border-style: none;
      }

      button,
      input,
      optgroup,
      select,
      textarea {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      button,
      input {
        overflow: visible;
      }

      button,
      select {
        text-transform: none;
      }

      button::-moz-focus-inner,
      [type="button"]::-moz-focus-inner,
      [type="reset"]::-moz-focus-inner,
      [type="submit"]::-moz-focus-inner {
        border-style: none;
        padding: 0;
      }

      fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      progress {
        vertical-align: baseline;
      }

      textarea {
        overflow: auto;
      }

      [type="checkbox"],
      [type="radio"] {
        box-sizing: border-box;
        padding: 0;
      }

      [type="number"]::-webkit-inner-spin-button,
      [type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      input[type="number"] {
        -moz-appearance: textfield;
      }

      [type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      [type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      details {
        display: block;
      }

      summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      body,
      blockquote,
      dl,
      dd,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      hr,
      figure,
      p,
      pre {
        margin: 0;
      }

      button {
        background: transparent;
        padding: 0;
      }

      fieldset {
        margin: 0;
        padding: 0;
      }

      ol,
      ul {
        margin: 0;
        padding: 0;
      }

      textarea {
        resize: vertical;
      }

      button,
      [role="button"] {
        cursor: pointer;
      }

      button::-moz-focus-inner {
        border: 0 !important;
      }

      table {
        border-collapse: collapse;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-size: inherit;
        font-weight: inherit;
      }

      button,
      input,
      optgroup,
      select,
      textarea {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      img,
      svg,
      video,
      canvas,
      audio,
      iframe,
      embed,
      object {
        display: block;
      }

      img,
      video {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible] :focus:not([data-focus-visible-added]) {
        outline: none;
        box-shadow: none;
      }

      select::-ms-expand {
        display: none;
      }
    `
  });
}, lV = sV, Kp = { exports: {} };
Kp.exports;
(function(e, r) {
  var t = 200, n = "__lodash_hash_undefined__", a = 800, i = 16, l = 9007199254740991, u = "[object Arguments]", c = "[object Array]", f = "[object AsyncFunction]", h = "[object Boolean]", p = "[object Date]", g = "[object Error]", y = "[object Function]", S = "[object GeneratorFunction]", x = "[object Map]", T = "[object Number]", A = "[object Null]", O = "[object Object]", P = "[object Proxy]", j = "[object RegExp]", k = "[object Set]", L = "[object String]", M = "[object Undefined]", W = "[object WeakMap]", q = "[object ArrayBuffer]", oe = "[object DataView]", Ae = "[object Float32Array]", Te = "[object Float64Array]", $e = "[object Int8Array]", Ee = "[object Int16Array]", ze = "[object Int32Array]", Ke = "[object Uint8Array]", Be = "[object Uint8ClampedArray]", ue = "[object Uint16Array]", he = "[object Uint32Array]", _e = /[\\^$.*+?()[\]{}|]/g, Oe = /^\[object .+?Constructor\]$/, Me = /^(?:0|[1-9]\d*)$/, Z = {};
  Z[Ae] = Z[Te] = Z[$e] = Z[Ee] = Z[ze] = Z[Ke] = Z[Be] = Z[ue] = Z[he] = !0, Z[u] = Z[c] = Z[q] = Z[h] = Z[oe] = Z[p] = Z[g] = Z[y] = Z[x] = Z[T] = Z[O] = Z[j] = Z[k] = Z[L] = Z[W] = !1;
  var se = typeof Pi == "object" && Pi && Pi.Object === Object && Pi, te = typeof self == "object" && self && self.Object === Object && self, fe = se || te || Function("return this")(), je = r && !r.nodeType && r, ve = je && !0 && e && !e.nodeType && e, rr = ve && ve.exports === je, br = rr && se.process, ur = function() {
    try {
      var v = ve && ve.require && ve.require("util").types;
      return v || br && br.binding && br.binding("util");
    } catch (b) {
    }
  }(), $r = ur && ur.isTypedArray;
  function Qe(v, b, $) {
    switch ($.length) {
      case 0:
        return v.call(b);
      case 1:
        return v.call(b, $[0]);
      case 2:
        return v.call(b, $[0], $[1]);
      case 3:
        return v.call(b, $[0], $[1], $[2]);
    }
    return v.apply(b, $);
  }
  function yr(v, b) {
    for (var $ = -1, N = Array(v); ++$ < v; )
      N[$] = b($);
    return N;
  }
  function at(v) {
    return function(b) {
      return v(b);
    };
  }
  function Zr(v, b) {
    return v == null ? void 0 : v[b];
  }
  function Nr(v, b) {
    return function($) {
      return v(b($));
    };
  }
  var jt = Array.prototype, mt = Function.prototype, gr = Object.prototype, Sr = fe["__core-js_shared__"], G = mt.toString, ne = gr.hasOwnProperty, Y = function() {
    var v = /[^.]+$/.exec(Sr && Sr.keys && Sr.keys.IE_PROTO || "");
    return v ? "Symbol(src)_1." + v : "";
  }(), Q = gr.toString, we = G.call(Object), be = RegExp(
    "^" + G.call(ne).replace(_e, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Re = rr ? fe.Buffer : void 0, cr = fe.Symbol, wr = fe.Uint8Array, lr = Re ? Re.allocUnsafe : void 0, dt = Nr(Object.getPrototypeOf, Object), ot = Object.create, bt = gr.propertyIsEnumerable, Ct = jt.splice, fr = cr ? cr.toStringTag : void 0, Qr = function() {
    try {
      var v = zn(Object, "defineProperty");
      return v({}, "", {}), v;
    } catch (b) {
    }
  }(), vn = Re ? Re.isBuffer : void 0, hn = Math.max, Za = Date.now, Cn = zn(fe, "Map"), ge = zn(Object, "create"), De = function() {
    function v() {
    }
    return function(b) {
      if (!Xr(b))
        return {};
      if (ot)
        return ot(b);
      v.prototype = b;
      var $ = new v();
      return v.prototype = void 0, $;
    };
  }();
  function tr(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Dt() {
    this.__data__ = ge ? ge(null) : {}, this.size = 0;
  }
  function it(v) {
    var b = this.has(v) && delete this.__data__[v];
    return this.size -= b ? 1 : 0, b;
  }
  function Fn(v) {
    var b = this.__data__;
    if (ge) {
      var $ = b[v];
      return $ === n ? void 0 : $;
    }
    return ne.call(b, v) ? b[v] : void 0;
  }
  function Se(v) {
    var b = this.__data__;
    return ge ? b[v] !== void 0 : ne.call(b, v);
  }
  function Ce(v, b) {
    var $ = this.__data__;
    return this.size += this.has(v) ? 0 : 1, $[v] = ge && b === void 0 ? n : b, this;
  }
  tr.prototype.clear = Dt, tr.prototype.delete = it, tr.prototype.get = Fn, tr.prototype.has = Se, tr.prototype.set = Ce;
  function ye(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Pe() {
    this.__data__ = [], this.size = 0;
  }
  function nr(v) {
    var b = this.__data__, $ = Nt(b, v);
    if ($ < 0)
      return !1;
    var N = b.length - 1;
    return $ == N ? b.pop() : Ct.call(b, $, 1), --this.size, !0;
  }
  function Hr(v) {
    var b = this.__data__, $ = Nt(b, v);
    return $ < 0 ? void 0 : b[$][1];
  }
  function Jt(v) {
    return Nt(this.__data__, v) > -1;
  }
  function en(v, b) {
    var $ = this.__data__, N = Nt($, v);
    return N < 0 ? (++this.size, $.push([v, b])) : $[N][1] = b, this;
  }
  ye.prototype.clear = Pe, ye.prototype.delete = nr, ye.prototype.get = Hr, ye.prototype.has = Jt, ye.prototype.set = en;
  function Rr(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Qa() {
    this.size = 0, this.__data__ = {
      hash: new tr(),
      map: new (Cn || ye)(),
      string: new tr()
    };
  }
  function Ks(v) {
    var b = mn(this, v).delete(v);
    return this.size -= b ? 1 : 0, b;
  }
  function qs(v) {
    return mn(this, v).get(v);
  }
  function Zs(v) {
    return mn(this, v).has(v);
  }
  function Qs(v, b) {
    var $ = mn(this, v), N = $.size;
    return $.set(v, b), this.size += $.size == N ? 0 : 1, this;
  }
  Rr.prototype.clear = Qa, Rr.prototype.delete = Ks, Rr.prototype.get = qs, Rr.prototype.has = Zs, Rr.prototype.set = Qs;
  function yt(v) {
    var b = this.__data__ = new ye(v);
    this.size = b.size;
  }
  function Xs() {
    this.__data__ = new ye(), this.size = 0;
  }
  function Js(v) {
    var b = this.__data__, $ = b.delete(v);
    return this.size = b.size, $;
  }
  function el(v) {
    return this.__data__.get(v);
  }
  function rl(v) {
    return this.__data__.has(v);
  }
  function tl(v, b) {
    var $ = this.__data__;
    if ($ instanceof ye) {
      var N = $.__data__;
      if (!Cn || N.length < t - 1)
        return N.push([v, b]), this.size = ++$.size, this;
      $ = this.__data__ = new Rr(N);
    }
    return $.set(v, b), this.size = $.size, this;
  }
  yt.prototype.clear = Xs, yt.prototype.delete = Js, yt.prototype.get = el, yt.prototype.has = rl, yt.prototype.set = tl;
  function nl(v, b) {
    var $ = na(v), N = !$ && ta(v), ie = !$ && !N && Mo(v), pe = !$ && !N && !ie && Po(v), ce = $ || N || ie || pe, ae = ce ? yr(v.length, String) : [], me = ae.length;
    for (var ar in v)
      (b || ne.call(v, ar)) && !(ce && // Safari 9 has enumerable `arguments.length` in strict mode.
      (ar == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      ie && (ar == "offset" || ar == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      pe && (ar == "buffer" || ar == "byteLength" || ar == "byteOffset") || // Skip index properties.
      Oo(ar, me))) && ae.push(ar);
    return ae;
  }
  function pn(v, b, $) {
    ($ !== void 0 && !bn(v[b], $) || $ === void 0 && !(b in v)) && ra(v, b, $);
  }
  function al(v, b, $) {
    var N = v[b];
    (!(ne.call(v, b) && bn(N, $)) || $ === void 0 && !(b in v)) && ra(v, b, $);
  }
  function Nt(v, b) {
    for (var $ = v.length; $--; )
      if (bn(v[$][0], b))
        return $;
    return -1;
  }
  function ra(v, b, $) {
    b == "__proto__" && Qr ? Qr(v, b, {
      configurable: !0,
      enumerable: !0,
      value: $,
      writable: !0
    }) : v[b] = $;
  }
  var ol = Zi();
  function gn(v) {
    return v == null ? v === void 0 ? M : A : fr && fr in Object(v) ? Qi(v) : es(v);
  }
  function Xa(v) {
    return Lt(v) && gn(v) == u;
  }
  function Wi(v) {
    if (!Xr(v) || hi(v))
      return !1;
    var b = aa(v) ? be : Oe;
    return b.test(ns(v));
  }
  function Hi(v) {
    return Lt(v) && Ro(v.length) && !!Z[gn(v)];
  }
  function il(v) {
    if (!Xr(v))
      return Ji(v);
    var b = En(v), $ = [];
    for (var N in v)
      N == "constructor" && (b || !ne.call(v, N)) || $.push(N);
    return $;
  }
  function Ao(v, b, $, N, ie) {
    v !== b && ol(b, function(pe, ce) {
      if (ie || (ie = new yt()), Xr(pe))
        sl(v, b, ce, $, Ao, N, ie);
      else {
        var ae = N ? N(Bn(v, ce), pe, ce + "", v, b, ie) : void 0;
        ae === void 0 && (ae = pe), pn(v, ce, ae);
      }
    }, ko);
  }
  function sl(v, b, $, N, ie, pe, ce) {
    var ae = Bn(v, $), me = Bn(b, $), ar = ce.get(me);
    if (ar) {
      pn(v, $, ar);
      return;
    }
    var qe = pe ? pe(ae, me, $ + "", v, b, ce) : void 0, Pr = qe === void 0;
    if (Pr) {
      var Vn = na(me), Wn = !Vn && Mo(me), Ja = !Vn && !Wn && Po(me);
      qe = me, Vn || Wn || Ja ? na(ae) ? qe = ae : dl(ae) ? qe = ul(ae) : Wn ? (Pr = !1, qe = Yi(me, !0)) : Ja ? (Pr = !1, qe = di(me, !0)) : qe = [] : fl(me) || ta(me) ? (qe = ae, ta(ae) ? qe = vl(ae) : (!Xr(ae) || aa(ae)) && (qe = fi(me))) : Pr = !1;
    }
    Pr && (ce.set(me, qe), ie(qe, me, N, pe, ce), ce.delete(me)), pn(v, $, qe);
  }
  function ll(v, b) {
    return rs(cl(v, b, jo), v + "");
  }
  var Gi = Qr ? function(v, b) {
    return Qr(v, "toString", {
      configurable: !0,
      enumerable: !1,
      value: xr(b),
      writable: !0
    });
  } : jo;
  function Yi(v, b) {
    if (b)
      return v.slice();
    var $ = v.length, N = lr ? lr($) : new v.constructor($);
    return v.copy(N), N;
  }
  function Ki(v) {
    var b = new v.constructor(v.byteLength);
    return new wr(b).set(new wr(v)), b;
  }
  function di(v, b) {
    var $ = b ? Ki(v.buffer) : v.buffer;
    return new v.constructor($, v.byteOffset, v.length);
  }
  function ul(v, b) {
    var $ = -1, N = v.length;
    for (b || (b = Array(N)); ++$ < N; )
      b[$] = v[$];
    return b;
  }
  function qi(v, b, $, N) {
    var ie = !$;
    $ || ($ = {});
    for (var pe = -1, ce = b.length; ++pe < ce; ) {
      var ae = b[pe], me = N ? N($[ae], v[ae], ae, $, v) : void 0;
      me === void 0 && (me = v[ae]), ie ? ra($, ae, me) : al($, ae, me);
    }
    return $;
  }
  function Io(v) {
    return ll(function(b, $) {
      var N = -1, ie = $.length, pe = ie > 1 ? $[ie - 1] : void 0, ce = ie > 2 ? $[2] : void 0;
      for (pe = v.length > 3 && typeof pe == "function" ? (ie--, pe) : void 0, ce && Xi($[0], $[1], ce) && (pe = ie < 3 ? void 0 : pe, ie = 1), b = Object(b); ++N < ie; ) {
        var ae = $[N];
        ae && v(b, ae, N, pe);
      }
      return b;
    });
  }
  function Zi(v) {
    return function(b, $, N) {
      for (var ie = -1, pe = Object(b), ce = N(b), ae = ce.length; ae--; ) {
        var me = ce[v ? ae : ++ie];
        if ($(pe[me], me, pe) === !1)
          break;
      }
      return b;
    };
  }
  function mn(v, b) {
    var $ = v.__data__;
    return vi(b) ? $[typeof b == "string" ? "string" : "hash"] : $.map;
  }
  function zn(v, b) {
    var $ = Zr(v, b);
    return Wi($) ? $ : void 0;
  }
  function Qi(v) {
    var b = ne.call(v, fr), $ = v[fr];
    try {
      v[fr] = void 0;
      var N = !0;
    } catch (pe) {
    }
    var ie = Q.call(v);
    return N && (b ? v[fr] = $ : delete v[fr]), ie;
  }
  function fi(v) {
    return typeof v.constructor == "function" && !En(v) ? De(dt(v)) : {};
  }
  function Oo(v, b) {
    var $ = typeof v;
    return b = b == null ? l : b, !!b && ($ == "number" || $ != "symbol" && Me.test(v)) && v > -1 && v % 1 == 0 && v < b;
  }
  function Xi(v, b, $) {
    if (!Xr($))
      return !1;
    var N = typeof b;
    return (N == "number" ? Un($) && Oo(b, $.length) : N == "string" && b in $) ? bn($[b], v) : !1;
  }
  function vi(v) {
    var b = typeof v;
    return b == "string" || b == "number" || b == "symbol" || b == "boolean" ? v !== "__proto__" : v === null;
  }
  function hi(v) {
    return !!Y && Y in v;
  }
  function En(v) {
    var b = v && v.constructor, $ = typeof b == "function" && b.prototype || gr;
    return v === $;
  }
  function Ji(v) {
    var b = [];
    if (v != null)
      for (var $ in Object(v))
        b.push($);
    return b;
  }
  function es(v) {
    return Q.call(v);
  }
  function cl(v, b, $) {
    return b = hn(b === void 0 ? v.length - 1 : b, 0), function() {
      for (var N = arguments, ie = -1, pe = hn(N.length - b, 0), ce = Array(pe); ++ie < pe; )
        ce[ie] = N[b + ie];
      ie = -1;
      for (var ae = Array(b + 1); ++ie < b; )
        ae[ie] = N[ie];
      return ae[b] = $(ce), Qe(v, this, ae);
    };
  }
  function Bn(v, b) {
    if (!(b === "constructor" && typeof v[b] == "function") && b != "__proto__")
      return v[b];
  }
  var rs = ts(Gi);
  function ts(v) {
    var b = 0, $ = 0;
    return function() {
      var N = Za(), ie = i - (N - $);
      if ($ = N, ie > 0) {
        if (++b >= a)
          return arguments[0];
      } else
        b = 0;
      return v.apply(void 0, arguments);
    };
  }
  function ns(v) {
    if (v != null) {
      try {
        return G.call(v);
      } catch (b) {
      }
      try {
        return v + "";
      } catch (b) {
      }
    }
    return "";
  }
  function bn(v, b) {
    return v === b || v !== v && b !== b;
  }
  var ta = Xa(function() {
    return arguments;
  }()) ? Xa : function(v) {
    return Lt(v) && ne.call(v, "callee") && !bt.call(v, "callee");
  }, na = Array.isArray;
  function Un(v) {
    return v != null && Ro(v.length) && !aa(v);
  }
  function dl(v) {
    return Lt(v) && Un(v);
  }
  var Mo = vn || hl;
  function aa(v) {
    if (!Xr(v))
      return !1;
    var b = gn(v);
    return b == y || b == S || b == f || b == P;
  }
  function Ro(v) {
    return typeof v == "number" && v > -1 && v % 1 == 0 && v <= l;
  }
  function Xr(v) {
    var b = typeof v;
    return v != null && (b == "object" || b == "function");
  }
  function Lt(v) {
    return v != null && typeof v == "object";
  }
  function fl(v) {
    if (!Lt(v) || gn(v) != O)
      return !1;
    var b = dt(v);
    if (b === null)
      return !0;
    var $ = ne.call(b, "constructor") && b.constructor;
    return typeof $ == "function" && $ instanceof $ && G.call($) == we;
  }
  var Po = $r ? at($r) : Hi;
  function vl(v) {
    return qi(v, ko(v));
  }
  function ko(v) {
    return Un(v) ? nl(v, !0) : il(v);
  }
  var _r = Io(function(v, b, $, N) {
    Ao(v, b, $, N);
  });
  function xr(v) {
    return function() {
      return v;
    };
  }
  function jo(v) {
    return v;
  }
  function hl() {
    return !1;
  }
  e.exports = _r;
})(Kp, Kp.exports);
var uV = Kp.exports;
const Ba = /* @__PURE__ */ G0(uV);
function cV(e) {
  var r = e == null ? 0 : e.length;
  return r ? e[r - 1] : void 0;
}
function Td(e) {
  return typeof e == "number";
}
function V2(e) {
  return Array.isArray(e);
}
function Gu(e) {
  return typeof e == "function";
}
function Rn(e) {
  var r = typeof e;
  return e != null && (r === "object" || r === "function") && !V2(e);
}
function dV(e) {
  return Rn(e) && Object.keys(e).length === 0;
}
function W2(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
function qO(e) {
  return /^var\(--.+\)$/.test(e);
}
var fV = !1;
function ZO(e, r) {
  var t = {};
  return Object.keys(e).forEach(function(n) {
    r.includes(n) || (t[n] = e[n]);
  }), t;
}
function vV(e, r) {
  var t = {};
  return r.forEach(function(n) {
    n in e && (t[n] = e[n]);
  }), t;
}
function hV(e, r, t, n) {
  var a = typeof r == "string" ? r.split(".") : [r];
  for (n = 0; n < a.length && e; n += 1)
    e = e[a[n]];
  return e === void 0 ? t : e;
}
var pV = function(r) {
  var t = /* @__PURE__ */ new WeakMap(), n = function(i, l, u, c) {
    if (typeof i == "undefined")
      return r(i, l, u);
    t.has(i) || t.set(i, /* @__PURE__ */ new Map());
    var f = t.get(i);
    if (f.has(l))
      return f.get(l);
    var h = r(i, l, u, c);
    return f.set(l, h), h;
  };
  return n;
}, lg = pV(hV);
function QO(e, r) {
  var t = {};
  return Object.keys(e).forEach(function(n) {
    var a = e[n], i = r(a, n, e);
    i && (t[n] = a);
  }), t;
}
var H2 = function(r) {
  return QO(r, function(t) {
    return t != null;
  });
}, G2 = function(r) {
  return Object.keys(r);
}, Jd = function(r) {
  return r.reduce(function(t, n) {
    var a = n[0], i = n[1];
    return t[a] = i, t;
  }, {});
};
function gV(e) {
  var r = parseFloat(e.toString()), t = e.toString().replace(String(r), "");
  return {
    unitless: !t,
    value: r,
    unit: t
  };
}
function gS(e) {
  if (e == null)
    return e;
  var r = gV(e), t = r.unitless;
  return t || Td(e) ? e + "px" : e;
}
var XO = function(r, t) {
  return parseInt(r[1], 10) > parseInt(t[1], 10) ? 1 : -1;
}, Y2 = function(r) {
  return Jd(Object.entries(r).sort(XO));
};
function eC(e) {
  var r = Y2(e);
  return Object.assign(Object.values(r), r);
}
function mV(e) {
  var r = Object.keys(Y2(e));
  return new Set(r);
}
function bV(e) {
  var r;
  if (!e)
    return e;
  e = (r = gS(e)) != null ? r : e;
  var t = e.endsWith("px") ? -1 : (
    // the equivalent of 1px in em using a 16px base
    -0.0635
  );
  return Td(e) ? "" + (e + t) : e.replace(/([0-9]+\.?[0-9]*)/, function(n) {
    return "" + (parseFloat(n) + t);
  });
}
function Yv(e, r) {
  var t = ["@media screen"];
  return e && t.push("and", "(min-width: " + gS(e) + ")"), r && t.push("and", "(max-width: " + gS(r) + ")"), t.join(" ");
}
function yV(e) {
  var r;
  if (!e)
    return null;
  e.base = (r = e.base) != null ? r : "0px";
  var t = eC(e), n = Object.entries(e).sort(XO).map(function(l, u, c) {
    var f, h = l[0], p = l[1], g = (f = c[u + 1]) != null ? f : [], y = g[1];
    return y = parseFloat(y) > 0 ? bV(y) : void 0, {
      breakpoint: h,
      minW: p,
      maxW: y,
      maxWQuery: Yv(null, y),
      minWQuery: Yv(p),
      minMaxQuery: Yv(p, y)
    };
  }), a = mV(e), i = Array.from(a.values());
  return {
    keys: a,
    normalized: t,
    isResponsive: function(u) {
      var c = Object.keys(u);
      return c.length > 0 && c.every(function(f) {
        return a.has(f);
      });
    },
    asObject: Y2(e),
    asArray: eC(e),
    details: n,
    media: [null].concat(t.map(function(l) {
      return Yv(l);
    }).slice(1)),
    toArrayValue: function(u) {
      if (!Rn(u))
        throw new Error("toArrayValue: value must be an object");
      for (var c = i.map(function(f) {
        var h;
        return (h = u[f]) != null ? h : null;
      }); cV(c) === null; )
        c.pop();
      return c;
    },
    toObjectValue: function(u) {
      if (!Array.isArray(u))
        throw new Error("toObjectValue: value must be an array");
      return u.reduce(function(c, f, h) {
        var p = i[h];
        return p != null && f != null && (c[p] = f), c;
      }, {});
    }
  };
}
function SV() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
var Cc = SV(), rC = function(r) {
  return r ? "" : void 0;
}, Ob = function(r) {
  return r ? !0 : void 0;
}, Ha = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return t.filter(Boolean).join(" ");
};
function ei(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  return Gu(e) ? e.apply(void 0, t) : e;
}
function tC() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(a) {
    r.some(function(i) {
      return i == null || i(a), a == null ? void 0 : a.defaultPrevented;
    });
  };
}
function xV(e) {
  var r;
  return function() {
    if (e) {
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      r = e.apply(this, a), e = null;
    }
    return r;
  };
}
var ef = function() {
}, $V = xV(function(e) {
  return function() {
    var r = e.condition, t = e.message;
    r && fV && console.warn(t);
  };
}), wV = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return function(a) {
    return t.reduce(function(i, l) {
      return l(i);
    }, a);
  };
};
function mS(e, r) {
  return r === void 0 && (r = 1 / 0), !Rn(e) && !Array.isArray(e) || !r ? e : Object.entries(e).reduce(function(t, n) {
    var a = n[0], i = n[1];
    return Rn(i) || V2(i) ? Object.entries(mS(i, r - 1)).forEach(function(l) {
      var u = l[0], c = l[1];
      t[a + "." + u] = c;
    }) : t[a] = i, t;
  }, {});
}
function JO(e, r) {
  return V2(e) ? e.map(function(t) {
    return t === null ? null : r(t);
  }) : Rn(e) ? G2(e).reduce(function(t, n) {
    return t[n] = r(e[n]), t;
  }, {}) : e != null ? r(e) : null;
}
function Ec(e) {
  e === void 0 && (e = {});
  var r = e, t = r.strict, n = t === void 0 ? !0 : t, a = r.errorMessage, i = a === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : a, l = r.name, u = /* @__PURE__ */ I.createContext(void 0);
  u.displayName = l;
  function c() {
    var f = I.useContext(u);
    if (!f && n) {
      var h = new Error(i);
      throw h.name = "ContextError", Error.captureStackTrace == null || Error.captureStackTrace(h, c), h;
    }
    return f;
  }
  return [u.Provider, c, u];
}
function _V(e) {
  return I.Children.toArray(e).filter(function(r) {
    return /* @__PURE__ */ I.isValidElement(r);
  });
}
var TV = {
  current: 1
}, CV = /* @__PURE__ */ I.createContext(TV), EV = /* @__PURE__ */ I.memo(function(e) {
  var r = e.children;
  return /* @__PURE__ */ I.createElement(CV.Provider, {
    value: {
      current: 1
    }
  }, r);
});
function AV(e, r) {
  if (e != null) {
    if (typeof e == "function") {
      e(r);
      return;
    }
    try {
      e.current = r;
    } catch (t) {
      throw new Error("Cannot assign value '" + r + "' to ref '" + e + "'");
    }
  }
}
function IV() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return I.useMemo(function() {
    return r.every(function(n) {
      return n == null;
    }) ? null : function(n) {
      r.forEach(function(a) {
        a && AV(a, n);
      });
    };
  }, r);
}
var OV = Ec({
  strict: !1,
  name: "PortalManagerContext"
}), MV = OV[0];
function RV(e) {
  var r = e.children, t = e.zIndex;
  return /* @__PURE__ */ I.createElement(MV, {
    value: {
      zIndex: t
    }
  }, r);
}
Ec({
  strict: !1,
  name: "PortalContext"
});
var PV = {
  body: {
    classList: {
      add: function() {
      },
      remove: function() {
      }
    }
  },
  addEventListener: function() {
  },
  removeEventListener: function() {
  },
  activeElement: {
    blur: function() {
    },
    nodeName: ""
  },
  querySelector: function() {
    return null;
  },
  querySelectorAll: function() {
    return [];
  },
  getElementById: function() {
    return null;
  },
  createEvent: function() {
    return {
      initEvent: function() {
      }
    };
  },
  createElement: function() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function() {
      },
      getElementsByTagName: function() {
        return [];
      }
    };
  }
}, eM = PV, Ou = function() {
}, kV = {
  document: eM,
  navigator: {
    userAgent: ""
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener: Ou,
  removeEventListener: Ou,
  getComputedStyle: function() {
    return {
      getPropertyValue: function() {
        return "";
      }
    };
  },
  matchMedia: function() {
    return {
      matches: !1,
      addListener: Ou,
      removeListener: Ou
    };
  },
  requestAnimationFrame: function(r) {
    return typeof setTimeout == "undefined" ? (r(), null) : setTimeout(r, 0);
  },
  cancelAnimationFrame: function(r) {
    typeof setTimeout != "undefined" && clearTimeout(r);
  },
  setTimeout: function() {
    return 0;
  },
  clearTimeout: Ou,
  setInterval: function() {
    return 0;
  },
  clearInterval: Ou
}, jV = kV, DV = {
  window: jV,
  document: eM
}, rM = Cc ? {
  window,
  document
} : DV, tM = /* @__PURE__ */ Pn(rM);
function nM() {
  return Ur(tM);
}
function NV(e) {
  var r = e.children, t = e.environment, n = He(null), a = n[0], i = n[1], l = Rt(function() {
    var c, f = a == null ? void 0 : a.ownerDocument, h = a == null ? void 0 : a.ownerDocument.defaultView, p = f ? {
      document: f,
      window: h
    } : void 0, g = (c = t != null ? t : p) != null ? c : rM;
    return g;
  }, [a, t]), u = !a && !t;
  return /* @__PURE__ */ $o.createElement(tM.Provider, {
    value: l
  }, r, u && /* @__PURE__ */ $o.createElement("span", {
    ref: function(f) {
      f && i(f);
    }
  }));
}
var Kv = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
}, LV = {
  classList: {
    add: ef,
    remove: ef
  }
}, FV = function(r) {
  return Cc ? r.body : LV;
};
function zV(e, r) {
  var t = FV(r);
  t.classList.add(e ? Kv.dark : Kv.light), t.classList.remove(e ? Kv.light : Kv.dark);
}
function BV(e) {
  var r = window.matchMedia == null ? void 0 : window.matchMedia(e);
  if (r)
    return !!r.media === r.matches;
}
var aM = {
  light: "(prefers-color-scheme: light)",
  dark: "(prefers-color-scheme: dark)"
};
function UV(e) {
  var r, t = (r = BV(aM.dark)) != null ? r : e === "dark";
  return t ? "dark" : "light";
}
function VV(e) {
  if (!("matchMedia" in window))
    return ef;
  var r = window.matchMedia(aM.dark), t = function() {
    e(r.matches ? "dark" : "light", !0);
  };
  return r.addEventListener("change", t), function() {
    r.removeEventListener("change", t);
  };
}
var nC = {
  get: function() {
    return document.documentElement.style.getPropertyValue("--chakra-ui-color-mode") || document.documentElement.dataset.theme;
  },
  set: function(r) {
    Cc && (document.documentElement.style.setProperty("--chakra-ui-color-mode", r), document.documentElement.setAttribute("data-theme", r));
  }
}, aC = function() {
  return typeof Storage != "undefined";
}, oC = "chakra-ui-color-mode", WV = {
  get: function(r) {
    if (!aC())
      return r;
    try {
      var t = localStorage.getItem(oC);
      return t != null ? t : r;
    } catch (n) {
      return r;
    }
  },
  set: function(r) {
    if (aC())
      try {
        localStorage.setItem(oC, r);
      } catch (t) {
      }
  },
  type: "localStorage"
}, oM = /* @__PURE__ */ I.createContext({}), iM = function() {
  var r = I.useContext(oM);
  if (r === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return r;
};
function HV(e) {
  var r = e.value, t = e.children, n = e.options, a = n.useSystemColorMode, i = n.initialColorMode, l = e.colorModeManager, u = l === void 0 ? WV : l, c = i === "dark" ? "dark" : "light", f = I.useState(u.type === "cookie" ? u.get(c) : c), h = f[0], p = f[1], g = nM(), y = g.document;
  I.useEffect(function() {
    if (Cc && u.type === "localStorage") {
      var A = UV(c);
      if (a)
        return p(A);
      var O = nC.get(), P = u.get();
      return p(O || P || (i === "system" ? A : c));
    }
  }, [u, a, c, i]), I.useEffect(function() {
    var A = h === "dark";
    zV(A, y), nC.set(A ? "dark" : "light");
  }, [h, y]);
  var S = I.useCallback(function(A, O) {
    if (O === void 0 && (O = !1), !O)
      u.set(A);
    else if (u.get() && !a)
      return;
    p(A);
  }, [u, a]), x = I.useCallback(function() {
    S(h === "light" ? "dark" : "light");
  }, [h, S]);
  I.useEffect(function() {
    var A = a || i === "system", O;
    return A && (O = VV(S)), function() {
      O && A && O();
    };
  }, [S, a, i]);
  var T = I.useMemo(function() {
    return {
      colorMode: r != null ? r : h,
      toggleColorMode: r ? ef : x,
      setColorMode: r ? ef : S
    };
  }, [h, S, x, r]);
  return /* @__PURE__ */ I.createElement(oM.Provider, {
    value: T
  }, t);
}
function rf() {
  return rf = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, rf.apply(this, arguments);
}
var GV = function(r, t) {
  return function(n) {
    var a = String(t), i = r ? r + "." + a : a;
    return Rn(n.__cssMap) && i in n.__cssMap ? n.__cssMap[i].varRef : t;
  };
};
function tf(e) {
  var r = e.scale, t = e.transform, n = e.compose, a = function(l, u) {
    var c, f = GV(r, l)(u), h = (c = t == null ? void 0 : t(f, u)) != null ? c : f;
    return n && (h = n(h, u)), h;
  };
  return a;
}
function ao(e, r) {
  return function(t) {
    var n = {
      property: t,
      scale: e
    };
    return n.transform = tf({
      scale: e,
      transform: r
    }), n;
  };
}
var YV = function(r) {
  var t = r.rtl, n = r.ltr;
  return function(a) {
    return a.direction === "rtl" ? t : n;
  };
};
function KV(e) {
  var r = e.property, t = e.scale, n = e.transform;
  return {
    scale: t,
    property: YV(r),
    transform: t ? tf({
      scale: t,
      compose: n
    }) : n
  };
}
var Mb, Rb, sM = ["rotate(var(--chakra-rotate, 0))", "scaleX(var(--chakra-scale-x, 1))", "scaleY(var(--chakra-scale-y, 1))", "skewX(var(--chakra-skew-x, 0))", "skewY(var(--chakra-skew-y, 0))"];
function qV() {
  return ["translateX(var(--chakra-translate-x, 0))", "translateY(var(--chakra-translate-y, 0))"].concat(sM).join(" ");
}
function ZV() {
  return ["translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)"].concat(sM).join(" ");
}
var QV = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: ["var(--chakra-blur)", "var(--chakra-brightness)", "var(--chakra-contrast)", "var(--chakra-grayscale)", "var(--chakra-hue-rotate)", "var(--chakra-invert)", "var(--chakra-saturate)", "var(--chakra-sepia)", "var(--chakra-drop-shadow)"].join(" ")
}, XV = {
  backdropFilter: ["var(--chakra-backdrop-blur)", "var(--chakra-backdrop-brightness)", "var(--chakra-backdrop-contrast)", "var(--chakra-backdrop-grayscale)", "var(--chakra-backdrop-hue-rotate)", "var(--chakra-backdrop-invert)", "var(--chakra-backdrop-opacity)", "var(--chakra-backdrop-saturate)", "var(--chakra-backdrop-sepia)"].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function JV(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: ["var(--chakra-ring-offset-shadow)", "var(--chakra-ring-shadow)", "var(--chakra-shadow, 0 0 #0000)"].join(", ")
  };
}
var eW = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, lM = "& > :not(style) ~ :not(style)", rW = (Mb = {}, Mb[lM] = {
  marginInlineStart: "calc(var(--chakra-space-x) * calc(1 - var(--chakra-space-x-reverse)))",
  marginInlineEnd: "calc(var(--chakra-space-x) * var(--chakra-space-x-reverse))"
}, Mb), tW = (Rb = {}, Rb[lM] = {
  marginTop: "calc(var(--chakra-space-y) * calc(1 - var(--chakra-space-y-reverse)))",
  marginBottom: "calc(var(--chakra-space-y) * var(--chakra-space-y-reverse))"
}, Rb);
function qp(e, r) {
  return qp = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, qp(e, r);
}
function nW(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), r && qp(e, r);
}
function bS() {
  bS = function(a, i) {
    return new t(a, void 0, i);
  };
  var e = RegExp.prototype, r = /* @__PURE__ */ new WeakMap();
  function t(a, i, l) {
    var u = new RegExp(a, i);
    return r.set(u, l || r.get(a)), qp(u, t.prototype);
  }
  nW(t, RegExp), t.prototype.exec = function(a) {
    var i = e.exec.call(this, a);
    return i && (i.groups = n(i, this)), i;
  }, t.prototype[Symbol.replace] = function(a, i) {
    if (typeof i == "string") {
      var l = r.get(this);
      return e[Symbol.replace].call(this, a, i.replace(/\$<([^>]+)>/g, function(c, f) {
        return "$" + l[f];
      }));
    } else if (typeof i == "function") {
      var u = this;
      return e[Symbol.replace].call(this, a, function() {
        var c = arguments;
        return typeof c[c.length - 1] != "object" && (c = [].slice.call(c), c.push(n(c, u))), i.apply(this, c);
      });
    } else
      return e[Symbol.replace].call(this, a, i);
  };
  function n(a, i) {
    var l = r.get(i);
    return Object.keys(l).reduce(function(u, c) {
      return u[c] = a[l[c]], u;
    }, /* @__PURE__ */ Object.create(null));
  }
  return bS.apply(this, arguments);
}
var yS = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, aW = new Set(Object.values(yS)), uM = /* @__PURE__ */ new Set(["none", "-moz-initial", "inherit", "initial", "revert", "unset"]), oW = function(r) {
  return r.trim();
};
function iW(e, r) {
  var t, n;
  if (e == null || uM.has(e))
    return e;
  var a = /* @__PURE__ */ bS(/(^[\x2DA-Za-z]+)\(((.*))\)/g, {
    type: 1,
    values: 2
  }), i = (t = (n = a.exec(e)) == null ? void 0 : n.groups) != null ? t : {}, l = i.type, u = i.values;
  if (!l || !u)
    return e;
  var c = l.includes("-gradient") ? l : l + "-gradient", f = u.split(",").map(oW).filter(Boolean), h = f[0], p = f.slice(1);
  if ((p == null ? void 0 : p.length) === 0)
    return e;
  var g = h in yS ? yS[h] : h;
  p.unshift(g);
  var y = p.map(function(S) {
    if (aW.has(S))
      return S;
    var x = S.indexOf(" "), T = x !== -1 ? [S.substr(0, x), S.substr(x + 1)] : [S], A = T[0], O = T[1], P = cM(O) ? O : O && O.split(" "), j = "colors." + A, k = j in r.__cssMap ? r.__cssMap[j].varRef : A;
    return P ? [k].concat(Array.isArray(P) ? P : [P]).join(" ") : k;
  });
  return c + "(" + y.join(", ") + ")";
}
var cM = function(r) {
  return W2(r) && r.includes("(") && r.includes(")");
}, sW = function(r, t) {
  return iW(r, t != null ? t : {});
}, lW = function(r) {
  var t = parseFloat(r.toString()), n = r.toString().replace(String(t), "");
  return {
    unitless: !n,
    value: t,
    unit: n
  };
}, zo = function(r) {
  return function(t) {
    return r + "(" + t + ")";
  };
}, Fr = {
  filter: function(r) {
    return r !== "auto" ? r : QV;
  },
  backdropFilter: function(r) {
    return r !== "auto" ? r : XV;
  },
  ring: function(r) {
    return JV(Fr.px(r));
  },
  bgClip: function(r) {
    return r === "text" ? {
      color: "transparent",
      backgroundClip: "text"
    } : {
      backgroundClip: r
    };
  },
  transform: function(r) {
    return r === "auto" ? qV() : r === "auto-gpu" ? ZV() : r;
  },
  px: function(r) {
    if (r == null)
      return r;
    var t = lW(r), n = t.unitless;
    return n || Td(r) ? r + "px" : r;
  },
  fraction: function(r) {
    return !Td(r) || r > 1 ? r : r * 100 + "%";
  },
  float: function(r, t) {
    var n = {
      left: "right",
      right: "left"
    };
    return t.direction === "rtl" ? n[r] : r;
  },
  degree: function(r) {
    if (qO(r) || r == null)
      return r;
    var t = W2(r) && !r.endsWith("deg");
    return Td(r) || t ? r + "deg" : r;
  },
  gradient: sW,
  blur: zo("blur"),
  opacity: zo("opacity"),
  brightness: zo("brightness"),
  contrast: zo("contrast"),
  dropShadow: zo("drop-shadow"),
  grayscale: zo("grayscale"),
  hueRotate: zo("hue-rotate"),
  invert: zo("invert"),
  saturate: zo("saturate"),
  sepia: zo("sepia"),
  bgImage: function(r) {
    if (r == null)
      return r;
    var t = cM(r) || uM.has(r);
    return t ? r : "url(" + r + ")";
  },
  outline: function(r) {
    var t = String(r) === "0" || String(r) === "none";
    return r !== null && t ? {
      outline: "2px solid transparent",
      outlineOffset: "2px"
    } : {
      outline: r
    };
  },
  flexDirection: function(r) {
    var t, n = (t = eW[r]) != null ? t : {}, a = n.space, i = n.divide, l = {
      flexDirection: r
    };
    return a && (l[a] = 1), i && (l[i] = 1), l;
  }
}, F = {
  borderWidths: ao("borderWidths"),
  borderStyles: ao("borderStyles"),
  colors: ao("colors"),
  borders: ao("borders"),
  radii: ao("radii", Fr.px),
  space: ao("space", Fr.px),
  spaceT: ao("space", Fr.px),
  degreeT: function(r) {
    return {
      property: r,
      transform: Fr.degree
    };
  },
  prop: function(r, t, n) {
    return rf({
      property: r,
      scale: t
    }, t && {
      transform: tf({
        scale: t,
        transform: n
      })
    });
  },
  propT: function(r, t) {
    return {
      property: r,
      transform: t
    };
  },
  sizes: ao("sizes", Fr.px),
  sizesT: ao("sizes", Fr.fraction),
  shadows: ao("shadows"),
  logical: KV,
  blur: ao("blur", Fr.blur)
}, Sp = {
  background: F.colors("background"),
  backgroundColor: F.colors("backgroundColor"),
  backgroundImage: F.propT("backgroundImage", Fr.bgImage),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: {
    transform: Fr.bgClip
  },
  bgSize: F.prop("backgroundSize"),
  bgPosition: F.prop("backgroundPosition"),
  bg: F.colors("background"),
  bgColor: F.colors("backgroundColor"),
  bgPos: F.prop("backgroundPosition"),
  bgRepeat: F.prop("backgroundRepeat"),
  bgAttachment: F.prop("backgroundAttachment"),
  bgGradient: F.propT("backgroundImage", Fr.gradient),
  bgClip: {
    transform: Fr.bgClip
  }
};
Object.assign(Sp, {
  bgImage: Sp.backgroundImage,
  bgImg: Sp.backgroundImage
});
var Cr = {
  border: F.borders("border"),
  borderWidth: F.borderWidths("borderWidth"),
  borderStyle: F.borderStyles("borderStyle"),
  borderColor: F.colors("borderColor"),
  borderRadius: F.radii("borderRadius"),
  borderTop: F.borders("borderTop"),
  borderBlockStart: F.borders("borderBlockStart"),
  borderTopLeftRadius: F.radii("borderTopLeftRadius"),
  borderStartStartRadius: F.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: F.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: F.radii("borderTopRightRadius"),
  borderStartEndRadius: F.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: F.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: F.borders("borderRight"),
  borderInlineEnd: F.borders("borderInlineEnd"),
  borderBottom: F.borders("borderBottom"),
  borderBlockEnd: F.borders("borderBlockEnd"),
  borderBottomLeftRadius: F.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: F.radii("borderBottomRightRadius"),
  borderLeft: F.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: F.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: F.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: F.borders(["borderLeft", "borderRight"]),
  borderInline: F.borders("borderInline"),
  borderY: F.borders(["borderTop", "borderBottom"]),
  borderBlock: F.borders("borderBlock"),
  borderTopWidth: F.borderWidths("borderTopWidth"),
  borderBlockStartWidth: F.borderWidths("borderBlockStartWidth"),
  borderTopColor: F.colors("borderTopColor"),
  borderBlockStartColor: F.colors("borderBlockStartColor"),
  borderTopStyle: F.borderStyles("borderTopStyle"),
  borderBlockStartStyle: F.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: F.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: F.borderWidths("borderBlockEndWidth"),
  borderBottomColor: F.colors("borderBottomColor"),
  borderBlockEndColor: F.colors("borderBlockEndColor"),
  borderBottomStyle: F.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: F.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: F.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: F.borderWidths("borderInlineStartWidth"),
  borderLeftColor: F.colors("borderLeftColor"),
  borderInlineStartColor: F.colors("borderInlineStartColor"),
  borderLeftStyle: F.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: F.borderStyles("borderInlineStartStyle"),
  borderRightWidth: F.borderWidths("borderRightWidth"),
  borderInlineEndWidth: F.borderWidths("borderInlineEndWidth"),
  borderRightColor: F.colors("borderRightColor"),
  borderInlineEndColor: F.colors("borderInlineEndColor"),
  borderRightStyle: F.borderStyles("borderRightStyle"),
  borderInlineEndStyle: F.borderStyles("borderInlineEndStyle"),
  borderTopRadius: F.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: F.radii(["borderBottomLeftRadius", "borderBottomRightRadius"]),
  borderLeftRadius: F.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: F.radii(["borderTopRightRadius", "borderBottomRightRadius"])
};
Object.assign(Cr, {
  rounded: Cr.borderRadius,
  roundedTop: Cr.borderTopRadius,
  roundedTopLeft: Cr.borderTopLeftRadius,
  roundedTopRight: Cr.borderTopRightRadius,
  roundedTopStart: Cr.borderStartStartRadius,
  roundedTopEnd: Cr.borderStartEndRadius,
  roundedBottom: Cr.borderBottomRadius,
  roundedBottomLeft: Cr.borderBottomLeftRadius,
  roundedBottomRight: Cr.borderBottomRightRadius,
  roundedBottomStart: Cr.borderEndStartRadius,
  roundedBottomEnd: Cr.borderEndEndRadius,
  roundedLeft: Cr.borderLeftRadius,
  roundedRight: Cr.borderRightRadius,
  roundedStart: Cr.borderInlineStartRadius,
  roundedEnd: Cr.borderInlineEndRadius,
  borderStart: Cr.borderInlineStart,
  borderEnd: Cr.borderInlineEnd,
  borderTopStartRadius: Cr.borderStartStartRadius,
  borderTopEndRadius: Cr.borderStartEndRadius,
  borderBottomStartRadius: Cr.borderEndStartRadius,
  borderBottomEndRadius: Cr.borderEndEndRadius,
  borderStartRadius: Cr.borderInlineStartRadius,
  borderEndRadius: Cr.borderInlineEndRadius,
  borderStartWidth: Cr.borderInlineStartWidth,
  borderEndWidth: Cr.borderInlineEndWidth,
  borderStartColor: Cr.borderInlineStartColor,
  borderEndColor: Cr.borderInlineEndColor,
  borderStartStyle: Cr.borderInlineStartStyle,
  borderEndStyle: Cr.borderInlineEndStyle
});
var uW = {
  color: F.colors("color"),
  textColor: F.colors("color"),
  fill: F.colors("fill"),
  stroke: F.colors("stroke")
}, SS = {
  boxShadow: F.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: F.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: F.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(SS, {
  shadow: SS.boxShadow
});
var cW = {
  filter: {
    transform: Fr.filter
  },
  blur: F.blur("--chakra-blur"),
  brightness: F.propT("--chakra-brightness", Fr.brightness),
  contrast: F.propT("--chakra-contrast", Fr.contrast),
  hueRotate: F.degreeT("--chakra-hue-rotate"),
  invert: F.propT("--chakra-invert", Fr.invert),
  saturate: F.propT("--chakra-saturate", Fr.saturate),
  dropShadow: F.propT("--chakra-drop-shadow", Fr.dropShadow),
  backdropFilter: {
    transform: Fr.backdropFilter
  },
  backdropBlur: F.blur("--chakra-backdrop-blur"),
  backdropBrightness: F.propT("--chakra-backdrop-brightness", Fr.brightness),
  backdropContrast: F.propT("--chakra-backdrop-contrast", Fr.contrast),
  backdropHueRotate: F.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: F.propT("--chakra-backdrop-invert", Fr.invert),
  backdropSaturate: F.propT("--chakra-backdrop-saturate", Fr.saturate)
}, Zp = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: {
    transform: Fr.flexDirection
  },
  experimental_spaceX: {
    static: rW,
    transform: tf({
      scale: "space",
      transform: function(r) {
        return r !== null ? {
          "--chakra-space-x": r
        } : null;
      }
    })
  },
  experimental_spaceY: {
    static: tW,
    transform: tf({
      scale: "space",
      transform: function(r) {
        return r != null ? {
          "--chakra-space-y": r
        } : null;
      }
    })
  },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: F.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: F.space("gap"),
  rowGap: F.space("rowGap"),
  columnGap: F.space("columnGap")
};
Object.assign(Zp, {
  flexDir: Zp.flexDirection
});
var dM = {
  gridGap: F.space("gridGap"),
  gridColumnGap: F.space("gridColumnGap"),
  gridRowGap: F.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, dW = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: {
    transform: Fr.outline
  },
  outlineOffset: !0,
  outlineColor: F.colors("outlineColor")
}, Na = {
  width: F.sizesT("width"),
  inlineSize: F.sizesT("inlineSize"),
  height: F.sizes("height"),
  blockSize: F.sizes("blockSize"),
  boxSize: F.sizes(["width", "height"]),
  minWidth: F.sizes("minWidth"),
  minInlineSize: F.sizes("minInlineSize"),
  minHeight: F.sizes("minHeight"),
  minBlockSize: F.sizes("minBlockSize"),
  maxWidth: F.sizes("maxWidth"),
  maxInlineSize: F.sizes("maxInlineSize"),
  maxHeight: F.sizes("maxHeight"),
  maxBlockSize: F.sizes("maxBlockSize"),
  d: F.prop("display"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: F.propT("float", Fr.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(Na, {
  w: Na.width,
  h: Na.height,
  minW: Na.minWidth,
  maxW: Na.maxWidth,
  minH: Na.minHeight,
  maxH: Na.maxHeight,
  overscroll: Na.overscrollBehavior,
  overscrollX: Na.overscrollBehaviorX,
  overscrollY: Na.overscrollBehaviorY
});
var fW = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: F.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: F.prop("listStyleImage")
}, vW = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, hW = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, Pb = function(r, t, n) {
  var a = {}, i = lg(r, t, {});
  for (var l in i) {
    var u = l in n && n[l] != null;
    u || (a[l] = i[l]);
  }
  return a;
}, pW = {
  srOnly: {
    transform: function(r) {
      return r === !0 ? vW : r === "focusable" ? hW : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: function(r, t, n) {
      return Pb(t, "layerStyles." + r, n);
    }
  },
  textStyle: {
    processResult: !0,
    transform: function(r, t, n) {
      return Pb(t, "textStyles." + r, n);
    }
  },
  apply: {
    processResult: !0,
    transform: function(r, t, n) {
      return Pb(t, r, n);
    }
  }
}, Cd = {
  position: !0,
  pos: F.prop("position"),
  zIndex: F.prop("zIndex", "zIndices"),
  inset: F.spaceT("inset"),
  insetX: F.spaceT(["left", "right"]),
  insetInline: F.spaceT("insetInline"),
  insetY: F.spaceT(["top", "bottom"]),
  insetBlock: F.spaceT("insetBlock"),
  top: F.spaceT("top"),
  insetBlockStart: F.spaceT("insetBlockStart"),
  bottom: F.spaceT("bottom"),
  insetBlockEnd: F.spaceT("insetBlockEnd"),
  left: F.spaceT("left"),
  insetInlineStart: F.logical({
    scale: "space",
    property: {
      ltr: "left",
      rtl: "right"
    }
  }),
  right: F.spaceT("right"),
  insetInlineEnd: F.logical({
    scale: "space",
    property: {
      ltr: "right",
      rtl: "left"
    }
  })
};
Object.assign(Cd, {
  insetStart: Cd.insetInlineStart,
  insetEnd: Cd.insetInlineEnd
});
var gW = {
  ring: {
    transform: Fr.ring
  },
  ringColor: F.colors("--chakra-ring-color"),
  ringOffset: F.prop("--chakra-ring-offset-width"),
  ringOffsetColor: F.colors("--chakra-ring-offset-color"),
  ringInset: F.prop("--chakra-ring-inset")
}, st = {
  margin: F.spaceT("margin"),
  marginTop: F.spaceT("marginTop"),
  marginBlockStart: F.spaceT("marginBlockStart"),
  marginRight: F.spaceT("marginRight"),
  marginInlineEnd: F.spaceT("marginInlineEnd"),
  marginBottom: F.spaceT("marginBottom"),
  marginBlockEnd: F.spaceT("marginBlockEnd"),
  marginLeft: F.spaceT("marginLeft"),
  marginInlineStart: F.spaceT("marginInlineStart"),
  marginX: F.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: F.spaceT("marginInline"),
  marginY: F.spaceT(["marginTop", "marginBottom"]),
  marginBlock: F.spaceT("marginBlock"),
  padding: F.space("padding"),
  paddingTop: F.space("paddingTop"),
  paddingBlockStart: F.space("paddingBlockStart"),
  paddingRight: F.space("paddingRight"),
  paddingBottom: F.space("paddingBottom"),
  paddingBlockEnd: F.space("paddingBlockEnd"),
  paddingLeft: F.space("paddingLeft"),
  paddingInlineStart: F.space("paddingInlineStart"),
  paddingInlineEnd: F.space("paddingInlineEnd"),
  paddingX: F.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: F.space("paddingInline"),
  paddingY: F.space(["paddingTop", "paddingBottom"]),
  paddingBlock: F.space("paddingBlock")
};
Object.assign(st, {
  m: st.margin,
  mt: st.marginTop,
  mr: st.marginRight,
  me: st.marginInlineEnd,
  marginEnd: st.marginInlineEnd,
  mb: st.marginBottom,
  ml: st.marginLeft,
  ms: st.marginInlineStart,
  marginStart: st.marginInlineStart,
  mx: st.marginX,
  my: st.marginY,
  p: st.padding,
  pt: st.paddingTop,
  py: st.paddingY,
  px: st.paddingX,
  pb: st.paddingBottom,
  pl: st.paddingLeft,
  ps: st.paddingInlineStart,
  paddingStart: st.paddingInlineStart,
  pr: st.paddingRight,
  pe: st.paddingInlineEnd,
  paddingEnd: st.paddingInlineEnd
});
var mW = {
  textDecorationColor: F.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: {
    property: "textDecoration"
  },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: F.shadows("textShadow")
}, bW = {
  clipPath: !0,
  transform: F.propT("transform", Fr.transform),
  transformOrigin: !0,
  translateX: F.spaceT("--chakra-translate-x"),
  translateY: F.spaceT("--chakra-translate-y"),
  skewX: F.degreeT("--chakra-skew-x"),
  skewY: F.degreeT("--chakra-skew-y"),
  scaleX: F.prop("--chakra-scale-x"),
  scaleY: F.prop("--chakra-scale-y"),
  scale: F.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: F.degreeT("--chakra-rotate")
}, yW = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: F.prop("transitionDuration", "transition.duration"),
  transitionProperty: F.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: F.prop("transitionTimingFunction", "transition.easing")
}, SW = {
  fontFamily: F.prop("fontFamily", "fonts"),
  fontSize: F.prop("fontSize", "fontSizes", Fr.px),
  fontWeight: F.prop("fontWeight", "fontWeights"),
  lineHeight: F.prop("lineHeight", "lineHeights"),
  letterSpacing: F.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  },
  isTruncated: {
    transform: function(r) {
      if (r === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  }
}, xW = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: F.spaceT("scrollMargin"),
  scrollMarginTop: F.spaceT("scrollMarginTop"),
  scrollMarginBottom: F.spaceT("scrollMarginBottom"),
  scrollMarginLeft: F.spaceT("scrollMarginLeft"),
  scrollMarginRight: F.spaceT("scrollMarginRight"),
  scrollMarginX: F.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: F.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: F.spaceT("scrollPadding"),
  scrollPaddingTop: F.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: F.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: F.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: F.spaceT("scrollPaddingRight"),
  scrollPaddingX: F.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: F.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function iC(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function $W(e, r) {
  if (e) {
    if (typeof e == "string")
      return iC(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return iC(e, r);
  }
}
function wW(e, r) {
  var t = typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t)
    return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = $W(e)) || r && e && typeof e.length == "number") {
    t && (e = t);
    var n = 0;
    return function() {
      return n >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[n++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var tn = {
  hover: function(r, t) {
    return r + ":hover " + t + ", " + r + "[data-hover] " + t;
  },
  focus: function(r, t) {
    return r + ":focus " + t + ", " + r + "[data-focus] " + t;
  },
  focusVisible: function(r, t) {
    return r + ":focus-visible " + t;
  },
  focusWithin: function(r, t) {
    return r + ":focus-within " + t;
  },
  active: function(r, t) {
    return r + ":active " + t + ", " + r + "[data-active] " + t;
  },
  disabled: function(r, t) {
    return r + ":disabled " + t + ", " + r + "[data-disabled] " + t;
  },
  invalid: function(r, t) {
    return r + ":invalid " + t + ", " + r + "[data-invalid] " + t;
  },
  checked: function(r, t) {
    return r + ":checked " + t + ", " + r + "[data-checked] " + t;
  },
  indeterminate: function(r, t) {
    return r + ":indeterminate " + t + ", " + r + "[aria-checked=mixed] " + t + ", " + r + "[data-indeterminate] " + t;
  },
  readOnly: function(r, t) {
    return r + ":read-only " + t + ", " + r + "[readonly] " + t + ", " + r + "[data-read-only] " + t;
  },
  expanded: function(r, t) {
    return r + ":read-only " + t + ", " + r + "[aria-expanded=true] " + t + ", " + r + "[data-expanded] " + t;
  },
  placeholderShown: function(r, t) {
    return r + ":placeholder-shown " + t;
  }
}, vs = function(r) {
  return fM(function(t) {
    return r(t, "&");
  }, "[role=group]", "[data-group]", ".group");
}, _i = function(r) {
  return fM(function(t) {
    return r(t, "~ &");
  }, "[data-peer]", ".peer");
}, fM = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(r).join(", ");
}, nf = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   */
  _disabled: "&[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: vs(tn.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: _i(tn.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: vs(tn.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: _i(tn.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: vs(tn.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: _i(tn.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: vs(tn.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: _i(tn.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: vs(tn.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: _i(tn.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: vs(tn.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: _i(tn.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: vs(tn.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: _i(tn.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: vs(tn.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: _i(tn.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: _i(tn.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]"
}, _W = G2(nf), K2 = Ba({}, Sp, Cr, uW, Zp, Na, cW, gW, dW, dM, pW, Cd, SS, st, xW, SW, mW, bW, fW, yW);
Object.assign({}, st, Na, Zp, dM, Cd);
var TW = [].concat(G2(K2), _W), CW = rf({}, K2, nf), EW = function(r) {
  return r in CW;
}, AW = function(r) {
  return function(t) {
    if (!t.__breakpoints)
      return r;
    var n = t.__breakpoints, a = n.isResponsive, i = n.toArrayValue, l = n.media, u = {};
    for (var c in r) {
      var f = ei(r[c], t);
      if (f != null) {
        if (f = Rn(f) && a(f) ? i(f) : f, !Array.isArray(f)) {
          u[c] = f;
          continue;
        }
        for (var h = f.slice(0, l.length).length, p = 0; p < h; p += 1) {
          var g = l == null ? void 0 : l[p];
          if (!g) {
            u[c] = f[p];
            continue;
          }
          u[g] = u[g] || {}, f[p] != null && (u[g][c] = f[p]);
        }
      }
    }
    return u;
  };
}, IW = function(r, t) {
  return r.startsWith("--") && W2(t) && !qO(t);
}, OW = function(r, t) {
  var n, a;
  if (t == null)
    return t;
  var i = function(p) {
    var g, y;
    return (g = r.__cssMap) == null || (y = g[p]) == null ? void 0 : y.varRef;
  }, l = function(p) {
    var g;
    return (g = i(p)) != null ? g : p;
  }, u = t.split(",").map(function(h) {
    return h.trim();
  }), c = u[0], f = u[1];
  return t = (n = (a = i(c)) != null ? a : l(f)) != null ? n : l(t), t;
};
function MW(e) {
  var r = e.configs, t = r === void 0 ? {} : r, n = e.pseudos, a = n === void 0 ? {} : n, i = e.theme, l = function u(c, f) {
    f === void 0 && (f = !1);
    var h = ei(c, i), p = AW(h)(i), g = {};
    for (var y in p) {
      var S, x, T, A, O, P = p[y], j = ei(P, i);
      y in a && (y = a[y]), IW(y, j) && (j = OW(i, j));
      var k = t[y];
      if (k === !0 && (k = {
        property: y
      }), Rn(j)) {
        var L;
        g[y] = (L = g[y]) != null ? L : {}, g[y] = Ba({}, g[y], u(j, !0));
        continue;
      }
      var M = (S = (x = k) == null || x.transform == null ? void 0 : x.transform(j, i, h)) != null ? S : j;
      M = (T = k) != null && T.processResult ? u(M, !0) : M;
      var W = ei((A = k) == null ? void 0 : A.property, i);
      if (!f && (O = k) != null && O.static) {
        var q = ei(k.static, i);
        g = Ba({}, g, q);
      }
      if (W && Array.isArray(W)) {
        for (var oe = wW(W), Ae; !(Ae = oe()).done; ) {
          var Te = Ae.value;
          g[Te] = M;
        }
        continue;
      }
      if (W) {
        W === "&" && Rn(M) ? g = Ba({}, g, M) : g[W] = M;
        continue;
      }
      if (Rn(M)) {
        g = Ba({}, g, M);
        continue;
      }
      g[y] = M;
    }
    return g;
  };
  return l;
}
var vM = function(r) {
  return function(t) {
    var n = MW({
      theme: t,
      pseudos: nf,
      configs: K2
    });
    return n(r);
  };
};
function hM(e) {
  return Rn(e) && e.reference ? e.reference : String(e);
}
var ug = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(hM).join(" " + r + " ").replace(/calc/g, "");
}, sC = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + ug.apply(void 0, ["+"].concat(t)) + ")";
}, lC = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + ug.apply(void 0, ["-"].concat(t)) + ")";
}, xS = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + ug.apply(void 0, ["*"].concat(t)) + ")";
}, uC = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + ug.apply(void 0, ["/"].concat(t)) + ")";
}, cC = function(r) {
  var t = hM(r);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : "-" + t : xS(t, -1);
}, Ml = Object.assign(function(e) {
  return {
    add: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Ml(sC.apply(void 0, [e].concat(n)));
    },
    subtract: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Ml(lC.apply(void 0, [e].concat(n)));
    },
    multiply: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Ml(xS.apply(void 0, [e].concat(n)));
    },
    divide: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Ml(uC.apply(void 0, [e].concat(n)));
    },
    negate: function() {
      return Ml(cC(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: sC,
  subtract: lC,
  multiply: xS,
  divide: uC,
  negate: cC
});
function RW(e, r) {
  return r === void 0 && (r = "-"), e.replace(/\s+/g, r);
}
function pM(e) {
  var r = RW(e.toString());
  if (r.includes("\\."))
    return e;
  var t = !Number.isInteger(parseFloat(e.toString()));
  return t ? r.replace(".", "\\.") : e;
}
function PW(e, r) {
  return r === void 0 && (r = ""), [r, pM(e)].filter(Boolean).join("-");
}
function kW(e, r) {
  return "var(" + pM(e) + (r ? ", " + r : "") + ")";
}
function jW(e, r) {
  return r === void 0 && (r = ""), "--" + PW(e, r);
}
function DW(e, r, t) {
  var n = jW(e, t);
  return {
    variable: n,
    reference: kW(n, r)
  };
}
function dC(e, r) {
  return DW(String(e).replace(/\./g, "-"), void 0, r);
}
function NW(e, r) {
  for (var t = {}, n = {}, a = function() {
    var f = l[i], h = f[0], p = f[1], g = p.isSemantic, y = p.value, S = dC(h, r == null ? void 0 : r.cssVarPrefix), x = S.variable, T = S.reference;
    if (!g) {
      if (h.startsWith("space")) {
        var A = h.split("."), O = A[0], P = A.slice(1), j = O + ".-" + P.join("."), k = Ml.negate(y), L = Ml.negate(T);
        n[j] = {
          value: k,
          var: x,
          varRef: L
        };
      }
      return t[x] = y, n[h] = {
        value: y,
        var: x,
        varRef: T
      }, "continue";
    }
    var M = function(oe) {
      var Ae = String(h).split(".")[0], Te = [Ae, oe].join("."), $e = e[Te];
      if (!$e)
        return oe;
      var Ee = dC(Te, r == null ? void 0 : r.cssVarPrefix), ze = Ee.reference;
      return ze;
    }, W = Rn(y) ? y : {
      default: y
    };
    t = Ba(t, Object.entries(W).reduce(function(q, oe) {
      var Ae, Te, $e = oe[0], Ee = oe[1], ze = M(Ee);
      if ($e === "default")
        return q[x] = ze, q;
      var Ke = (Ae = nf == null ? void 0 : nf[$e]) != null ? Ae : $e;
      return q[Ke] = (Te = {}, Te[x] = ze, Te), q;
    }, {})), n[h] = {
      value: T,
      var: x,
      varRef: T
    };
  }, i = 0, l = Object.entries(e); i < l.length; i++)
    var u = a();
  return {
    cssVars: t,
    cssMap: n
  };
}
function LW(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var FW = ["__cssMap", "__cssVars", "__breakpoints"], zW = ["colors", "borders", "borderWidths", "borderStyles", "fonts", "fontSizes", "fontWeights", "letterSpacings", "lineHeights", "radii", "space", "shadows", "sizes", "zIndices", "transition", "blur"];
function BW(e) {
  var r = zW;
  return vV(e, r);
}
function UW(e) {
  return e.semanticTokens;
}
function VW(e) {
  e.__cssMap, e.__cssVars, e.__breakpoints;
  var r = LW(e, FW);
  return r;
}
function WW(e) {
  var r, t, n = e.tokens, a = e.semanticTokens, i = Object.entries((r = mS(n)) != null ? r : {}).map(function(u) {
    var c = u[0], f = u[1], h = {
      isSemantic: !1,
      value: f
    };
    return [c, h];
  }), l = Object.entries((t = mS(a, 1)) != null ? t : {}).map(function(u) {
    var c = u[0], f = u[1], h = {
      isSemantic: !0,
      value: f
    };
    return [c, h];
  });
  return Jd([].concat(i, l));
}
function HW(e) {
  var r, t = VW(e), n = BW(t), a = UW(t), i = WW({
    tokens: n,
    semanticTokens: a
  }), l = (r = t.config) == null ? void 0 : r.cssVarPrefix, u = NW(i, {
    cssVarPrefix: l
  }), c = u.cssMap, f = u.cssVars, h = {
    "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-ring-offset-width": "0px",
    "--chakra-ring-offset-color": "#fff",
    "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
    "--chakra-ring-offset-shadow": "0 0 #0000",
    "--chakra-ring-shadow": "0 0 #0000",
    "--chakra-space-x-reverse": "0",
    "--chakra-space-y-reverse": "0"
  };
  return Object.assign(t, {
    __cssVars: rf({}, h, f),
    __cssMap: c,
    __breakpoints: yV(t.breakpoints)
  }), t;
}
var GW = typeof Element != "undefined", YW = typeof Map == "function", KW = typeof Set == "function", qW = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function xp(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor)
      return !1;
    var t, n, a;
    if (Array.isArray(e)) {
      if (t = e.length, t != r.length)
        return !1;
      for (n = t; n-- !== 0; )
        if (!xp(e[n], r[n]))
          return !1;
      return !0;
    }
    var i;
    if (YW && e instanceof Map && r instanceof Map) {
      if (e.size !== r.size)
        return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!r.has(n.value[0]))
          return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!xp(n.value[1], r.get(n.value[0])))
          return !1;
      return !0;
    }
    if (KW && e instanceof Set && r instanceof Set) {
      if (e.size !== r.size)
        return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!r.has(n.value[0]))
          return !1;
      return !0;
    }
    if (qW && ArrayBuffer.isView(e) && ArrayBuffer.isView(r)) {
      if (t = e.length, t != r.length)
        return !1;
      for (n = t; n-- !== 0; )
        if (e[n] !== r[n])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === r.toString();
    if (a = Object.keys(e), t = a.length, t !== Object.keys(r).length)
      return !1;
    for (n = t; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, a[n]))
        return !1;
    if (GW && e instanceof Element)
      return !1;
    for (n = t; n-- !== 0; )
      if (!((a[n] === "_owner" || a[n] === "__v" || a[n] === "__o") && e.$$typeof) && !xp(e[a[n]], r[a[n]]))
        return !1;
    return !0;
  }
  return e !== e && r !== r;
}
var ZW = function(r, t) {
  try {
    return xp(r, t);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
};
const QW = /* @__PURE__ */ G0(ZW);
var XW = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, JW = /* @__PURE__ */ jO(
  function(e) {
    return XW.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), eH = JW, rH = function(r) {
  return r !== "theme";
}, fC = function(r) {
  return typeof r == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  r.charCodeAt(0) > 96 ? eH : rH;
}, vC = function(r, t, n) {
  var a;
  if (t) {
    var i = t.shouldForwardProp;
    a = r.__emotion_forwardProp && i ? function(l) {
      return r.__emotion_forwardProp(l) && i(l);
    } : i;
  }
  return typeof a != "function" && n && (a = r.__emotion_forwardProp), a;
}, tH = function(r) {
  var t = r.cache, n = r.serialized, a = r.isStringTag;
  return F2(t, n, a), WO(function() {
    return z2(t, n, a);
  }), null;
}, nH = function e(r, t) {
  var n = r.__emotion_real === r, a = n && r.__emotion_base || r, i, l;
  t !== void 0 && (i = t.label, l = t.target);
  var u = vC(r, t, n), c = u || fC(a), f = !c("as");
  return function() {
    var h = arguments, p = n && r.__emotion_styles !== void 0 ? r.__emotion_styles.slice(0) : [];
    if (i !== void 0 && p.push("label:" + i + ";"), h[0] == null || h[0].raw === void 0)
      p.push.apply(p, h);
    else {
      p.push(h[0][0]);
      for (var g = h.length, y = 1; y < g; y++)
        p.push(h[y], h[0][y]);
    }
    var S = B2(function(x, T, A) {
      var O = f && x.as || a, P = "", j = [], k = x;
      if (x.theme == null) {
        k = {};
        for (var L in x)
          k[L] = x[L];
        k.theme = Ur(tu);
      }
      typeof x.className == "string" ? P = BO(T.registered, j, x.className) : x.className != null && (P = x.className + " ");
      var M = ig(p.concat(j), T.registered, k);
      P += T.key + "-" + M.name, l !== void 0 && (P += " " + l);
      var W = f && u === void 0 ? fC(O) : c, q = {};
      for (var oe in x)
        f && oe === "as" || // $FlowFixMe
        W(oe) && (q[oe] = x[oe]);
      return q.className = P, q.ref = A, /* @__PURE__ */ Di(R2, null, /* @__PURE__ */ Di(tH, {
        cache: T,
        serialized: M,
        isStringTag: typeof O == "string"
      }), /* @__PURE__ */ Di(O, q));
    });
    return S.displayName = i !== void 0 ? i : "Styled(" + (typeof a == "string" ? a : a.displayName || a.name || "Component") + ")", S.defaultProps = r.defaultProps, S.__emotion_real = S, S.__emotion_base = a, S.__emotion_styles = p, S.__emotion_forwardProp = u, Object.defineProperty(S, "toString", {
      value: function() {
        return "." + l;
      }
    }), S.withComponent = function(x, T) {
      return e(x, Yp({}, t, T, {
        shouldForwardProp: vC(S, T, !0)
      })).apply(void 0, p);
    }, S;
  };
}, aH = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], Qp = nH.bind();
aH.forEach(function(e) {
  Qp[e] = Qp(e);
});
function $S() {
  return $S = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, $S.apply(this, arguments);
}
var oH = function(r) {
  var t = r.cssVarsRoot, n = r.theme, a = r.children, i = I.useMemo(function() {
    return HW(n);
  }, [n]);
  return /* @__PURE__ */ I.createElement(aV, {
    theme: i
  }, /* @__PURE__ */ I.createElement(iH, {
    root: t
  }), a);
}, iH = function(r) {
  var t = r.root, n = t === void 0 ? ":host, :root" : t, a = [n, "[data-theme]"].join(",");
  return /* @__PURE__ */ I.createElement(U2, {
    styles: function(l) {
      var u;
      return u = {}, u[a] = l.__cssVars, u;
    }
  });
};
function sH() {
  var e = I.useContext(tu);
  if (!e)
    throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
  return e;
}
var lH = Ec({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
}), gM = lH[1], uH = function() {
  var r = iM(), t = r.colorMode;
  return /* @__PURE__ */ I.createElement(U2, {
    styles: function(a) {
      var i = lg(a, "styles.global"), l = ei(i, {
        theme: a,
        colorMode: t
      });
      if (l) {
        var u = vM(l)(a);
        return u;
      }
    }
  });
};
function cg(e) {
  return ZO(e, ["styleConfig", "size", "variant", "colorScheme"]);
}
function cH() {
  var e = iM(), r = sH();
  return $S({}, e, {
    theme: r
  });
}
function q2(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var dH = new Set([].concat(TW, ["textStyle", "layerStyle", "apply", "isTruncated", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"])), fH = /* @__PURE__ */ new Set(["htmlWidth", "htmlHeight", "htmlSize"]), vH = function(r) {
  return fH.has(r) || !dH.has(r);
}, hH = ["theme", "css", "__css", "sx"], pH = ["baseStyle"], gH = function(r) {
  var t = r.baseStyle;
  return function(n) {
    n.theme;
    var a = n.css, i = n.__css, l = n.sx, u = q2(n, hH), c = QO(u, function(g, y) {
      return EW(y);
    }), f = ei(t, n), h = Object.assign({}, i, f, H2(c), l), p = vM(h)(n.theme);
    return a ? [p, a] : p;
  };
};
function kb(e, r) {
  var t = r != null ? r : {}, n = t.baseStyle, a = q2(t, pH);
  a.shouldForwardProp || (a.shouldForwardProp = vH);
  var i = gH({
    baseStyle: n
  });
  return Qp(e, a)(i);
}
function kn(e) {
  return /* @__PURE__ */ I.forwardRef(e);
}
var mH = ["styleConfig"];
function dg(e, r, t) {
  var n;
  r === void 0 && (r = {}), t === void 0 && (t = {});
  var a = r, i = a.styleConfig, l = q2(a, mH), u = cH(), c = u.theme, f = u.colorMode, h = lg(c, "components." + e), p = i || h, g = Ba({
    theme: c,
    colorMode: f
  }, (n = p == null ? void 0 : p.defaultProps) != null ? n : {}, H2(ZO(l, ["children"]))), y = Ze({});
  if (p) {
    var S, x, T, A, O, P, j = ei((S = p.baseStyle) != null ? S : {}, g), k = ei((x = (T = p.variants) == null ? void 0 : T[g.variant]) != null ? x : {}, g), L = ei((A = (O = p.sizes) == null ? void 0 : O[g.size]) != null ? A : {}, g), M = Ba({}, j, L, k);
    (P = t) != null && P.isMultiPart && p.parts && p.parts.forEach(function(q) {
      var oe;
      M[q] = (oe = M[q]) != null ? oe : {};
    });
    var W = QW(y.current, M);
    W || (y.current = M);
  }
  return y.current;
}
function bH(e, r) {
  return dg(e, r, {
    isMultiPart: !0
  });
}
function yH() {
  var e = /* @__PURE__ */ new Map();
  return new Proxy(kb, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply: function(t, n, a) {
      return kb.apply(void 0, a);
    },
    /**
     * @example
     * <chakra.div />
     */
    get: function(t, n) {
      return e.has(n) || e.set(n, kb(n)), e.get(n);
    }
  });
}
var Ht = yH(), SH = function(r) {
  var t = r.children, n = r.colorModeManager, a = r.portalZIndex, i = r.resetCSS, l = i === void 0 ? !0 : i, u = r.theme, c = u === void 0 ? {} : u, f = r.environment, h = r.cssVarsRoot, p = /* @__PURE__ */ I.createElement(NV, {
    environment: f
  }, t);
  return /* @__PURE__ */ I.createElement(EV, null, /* @__PURE__ */ I.createElement(oH, {
    theme: c,
    cssVarsRoot: h
  }, /* @__PURE__ */ I.createElement(HV, {
    colorModeManager: n,
    options: c.config
  }, l && /* @__PURE__ */ I.createElement(lV, null), /* @__PURE__ */ I.createElement(uH, null), a ? /* @__PURE__ */ I.createElement(RV, {
    zIndex: a
  }, p) : p)));
}, mM = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
};
function It() {
  return It = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, It.apply(this, arguments);
}
var xH = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem"
}, $H = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, bM = It({}, mM, xH, {
  container: $H
});
function un(e, r) {
  wH(e) && (e = "100%");
  var t = _H(e);
  return e = r === 360 ? e : Math.min(r, Math.max(0, parseFloat(e))), t && (e = parseInt(String(e * r), 10) / 100), Math.abs(e - r) < 1e-6 ? 1 : (r === 360 ? e = (e < 0 ? e % r + r : e % r) / parseFloat(String(r)) : e = e % r / parseFloat(String(r)), e);
}
function qv(e) {
  return Math.min(1, Math.max(0, e));
}
function wH(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function _H(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function yM(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Zv(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function Ll(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function TH(e, r, t) {
  return {
    r: un(e, 255) * 255,
    g: un(r, 255) * 255,
    b: un(t, 255) * 255
  };
}
function hC(e, r, t) {
  e = un(e, 255), r = un(r, 255), t = un(t, 255);
  var n = Math.max(e, r, t), a = Math.min(e, r, t), i = 0, l = 0, u = (n + a) / 2;
  if (n === a)
    l = 0, i = 0;
  else {
    var c = n - a;
    switch (l = u > 0.5 ? c / (2 - n - a) : c / (n + a), n) {
      case e:
        i = (r - t) / c + (r < t ? 6 : 0);
        break;
      case r:
        i = (t - e) / c + 2;
        break;
      case t:
        i = (e - r) / c + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: l, l: u };
}
function jb(e, r, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? e + (r - e) * (6 * t) : t < 1 / 2 ? r : t < 2 / 3 ? e + (r - e) * (2 / 3 - t) * 6 : e;
}
function CH(e, r, t) {
  var n, a, i;
  if (e = un(e, 360), r = un(r, 100), t = un(t, 100), r === 0)
    a = t, i = t, n = t;
  else {
    var l = t < 0.5 ? t * (1 + r) : t + r - t * r, u = 2 * t - l;
    n = jb(u, l, e + 1 / 3), a = jb(u, l, e), i = jb(u, l, e - 1 / 3);
  }
  return { r: n * 255, g: a * 255, b: i * 255 };
}
function pC(e, r, t) {
  e = un(e, 255), r = un(r, 255), t = un(t, 255);
  var n = Math.max(e, r, t), a = Math.min(e, r, t), i = 0, l = n, u = n - a, c = n === 0 ? 0 : u / n;
  if (n === a)
    i = 0;
  else {
    switch (n) {
      case e:
        i = (r - t) / u + (r < t ? 6 : 0);
        break;
      case r:
        i = (t - e) / u + 2;
        break;
      case t:
        i = (e - r) / u + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: c, v: l };
}
function EH(e, r, t) {
  e = un(e, 360) * 6, r = un(r, 100), t = un(t, 100);
  var n = Math.floor(e), a = e - n, i = t * (1 - r), l = t * (1 - a * r), u = t * (1 - (1 - a) * r), c = n % 6, f = [t, l, i, i, u, t][c], h = [u, t, t, l, i, i][c], p = [i, i, u, t, t, l][c];
  return { r: f * 255, g: h * 255, b: p * 255 };
}
function gC(e, r, t, n) {
  var a = [
    Ll(Math.round(e).toString(16)),
    Ll(Math.round(r).toString(16)),
    Ll(Math.round(t).toString(16))
  ];
  return n && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
}
function AH(e, r, t, n, a) {
  var i = [
    Ll(Math.round(e).toString(16)),
    Ll(Math.round(r).toString(16)),
    Ll(Math.round(t).toString(16)),
    Ll(IH(n))
  ];
  return a && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) && i[3].startsWith(i[3].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function IH(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function mC(e) {
  return fa(e) / 255;
}
function fa(e) {
  return parseInt(e, 16);
}
function OH(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var wS = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function MH(e) {
  var r = { r: 0, g: 0, b: 0 }, t = 1, n = null, a = null, i = null, l = !1, u = !1;
  return typeof e == "string" && (e = kH(e)), typeof e == "object" && (Ti(e.r) && Ti(e.g) && Ti(e.b) ? (r = TH(e.r, e.g, e.b), l = !0, u = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Ti(e.h) && Ti(e.s) && Ti(e.v) ? (n = Zv(e.s), a = Zv(e.v), r = EH(e.h, n, a), l = !0, u = "hsv") : Ti(e.h) && Ti(e.s) && Ti(e.l) && (n = Zv(e.s), i = Zv(e.l), r = CH(e.h, n, i), l = !0, u = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (t = e.a)), t = yM(t), {
    ok: l,
    format: e.format || u,
    r: Math.min(255, Math.max(r.r, 0)),
    g: Math.min(255, Math.max(r.g, 0)),
    b: Math.min(255, Math.max(r.b, 0)),
    a: t
  };
}
var RH = "[-\\+]?\\d+%?", PH = "[-\\+]?\\d*\\.\\d+%?", As = "(?:".concat(PH, ")|(?:").concat(RH, ")"), Db = "[\\s|\\(]+(".concat(As, ")[,|\\s]+(").concat(As, ")[,|\\s]+(").concat(As, ")\\s*\\)?"), Nb = "[\\s|\\(]+(".concat(As, ")[,|\\s]+(").concat(As, ")[,|\\s]+(").concat(As, ")[,|\\s]+(").concat(As, ")\\s*\\)?"), vo = {
  CSS_UNIT: new RegExp(As),
  rgb: new RegExp("rgb" + Db),
  rgba: new RegExp("rgba" + Nb),
  hsl: new RegExp("hsl" + Db),
  hsla: new RegExp("hsla" + Nb),
  hsv: new RegExp("hsv" + Db),
  hsva: new RegExp("hsva" + Nb),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function kH(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var r = !1;
  if (wS[e])
    e = wS[e], r = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var t = vo.rgb.exec(e);
  return t ? { r: t[1], g: t[2], b: t[3] } : (t = vo.rgba.exec(e), t ? { r: t[1], g: t[2], b: t[3], a: t[4] } : (t = vo.hsl.exec(e), t ? { h: t[1], s: t[2], l: t[3] } : (t = vo.hsla.exec(e), t ? { h: t[1], s: t[2], l: t[3], a: t[4] } : (t = vo.hsv.exec(e), t ? { h: t[1], s: t[2], v: t[3] } : (t = vo.hsva.exec(e), t ? { h: t[1], s: t[2], v: t[3], a: t[4] } : (t = vo.hex8.exec(e), t ? {
    r: fa(t[1]),
    g: fa(t[2]),
    b: fa(t[3]),
    a: mC(t[4]),
    format: r ? "name" : "hex8"
  } : (t = vo.hex6.exec(e), t ? {
    r: fa(t[1]),
    g: fa(t[2]),
    b: fa(t[3]),
    format: r ? "name" : "hex"
  } : (t = vo.hex4.exec(e), t ? {
    r: fa(t[1] + t[1]),
    g: fa(t[2] + t[2]),
    b: fa(t[3] + t[3]),
    a: mC(t[4] + t[4]),
    format: r ? "name" : "hex8"
  } : (t = vo.hex3.exec(e), t ? {
    r: fa(t[1] + t[1]),
    g: fa(t[2] + t[2]),
    b: fa(t[3] + t[3]),
    format: r ? "name" : "hex"
  } : !1)))))))));
}
function Ti(e) {
  return !!vo.CSS_UNIT.exec(String(e));
}
var kf = (
  /** @class */
  function() {
    function e(r, t) {
      r === void 0 && (r = ""), t === void 0 && (t = {});
      var n;
      if (r instanceof e)
        return r;
      typeof r == "number" && (r = OH(r)), this.originalInput = r;
      var a = MH(r);
      this.originalInput = r, this.r = a.r, this.g = a.g, this.b = a.b, this.a = a.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (n = t.format) !== null && n !== void 0 ? n : a.format, this.gradientType = t.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = a.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var r = this.toRgb();
      return (r.r * 299 + r.g * 587 + r.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var r = this.toRgb(), t, n, a, i = r.r / 255, l = r.g / 255, u = r.b / 255;
      return i <= 0.03928 ? t = i / 12.92 : t = Math.pow((i + 0.055) / 1.055, 2.4), l <= 0.03928 ? n = l / 12.92 : n = Math.pow((l + 0.055) / 1.055, 2.4), u <= 0.03928 ? a = u / 12.92 : a = Math.pow((u + 0.055) / 1.055, 2.4), 0.2126 * t + 0.7152 * n + 0.0722 * a;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(r) {
      return this.a = yM(r), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var r = this.toHsl().s;
      return r === 0;
    }, e.prototype.toHsv = function() {
      var r = pC(this.r, this.g, this.b);
      return { h: r.h * 360, s: r.s, v: r.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var r = pC(this.r, this.g, this.b), t = Math.round(r.h * 360), n = Math.round(r.s * 100), a = Math.round(r.v * 100);
      return this.a === 1 ? "hsv(".concat(t, ", ").concat(n, "%, ").concat(a, "%)") : "hsva(".concat(t, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var r = hC(this.r, this.g, this.b);
      return { h: r.h * 360, s: r.s, l: r.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var r = hC(this.r, this.g, this.b), t = Math.round(r.h * 360), n = Math.round(r.s * 100), a = Math.round(r.l * 100);
      return this.a === 1 ? "hsl(".concat(t, ", ").concat(n, "%, ").concat(a, "%)") : "hsla(".concat(t, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(r) {
      return r === void 0 && (r = !1), gC(this.r, this.g, this.b, r);
    }, e.prototype.toHexString = function(r) {
      return r === void 0 && (r = !1), "#" + this.toHex(r);
    }, e.prototype.toHex8 = function(r) {
      return r === void 0 && (r = !1), AH(this.r, this.g, this.b, this.a, r);
    }, e.prototype.toHex8String = function(r) {
      return r === void 0 && (r = !1), "#" + this.toHex8(r);
    }, e.prototype.toHexShortString = function(r) {
      return r === void 0 && (r = !1), this.a === 1 ? this.toHexString(r) : this.toHex8String(r);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var r = Math.round(this.r), t = Math.round(this.g), n = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(r, ", ").concat(t, ", ").concat(n, ")") : "rgba(".concat(r, ", ").concat(t, ", ").concat(n, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var r = function(t) {
        return "".concat(Math.round(un(t, 255) * 100), "%");
      };
      return {
        r: r(this.r),
        g: r(this.g),
        b: r(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var r = function(t) {
        return Math.round(un(t, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(r(this.r), "%, ").concat(r(this.g), "%, ").concat(r(this.b), "%)") : "rgba(".concat(r(this.r), "%, ").concat(r(this.g), "%, ").concat(r(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var r = "#" + gC(this.r, this.g, this.b, !1), t = 0, n = Object.entries(wS); t < n.length; t++) {
        var a = n[t], i = a[0], l = a[1];
        if (r === l)
          return i;
      }
      return !1;
    }, e.prototype.toString = function(r) {
      var t = !!r;
      r = r != null ? r : this.format;
      var n = !1, a = this.a < 1 && this.a >= 0, i = !t && a && (r.startsWith("hex") || r === "name");
      return i ? r === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (r === "rgb" && (n = this.toRgbString()), r === "prgb" && (n = this.toPercentageRgbString()), (r === "hex" || r === "hex6") && (n = this.toHexString()), r === "hex3" && (n = this.toHexString(!0)), r === "hex4" && (n = this.toHex8String(!0)), r === "hex8" && (n = this.toHex8String()), r === "name" && (n = this.toName()), r === "hsl" && (n = this.toHslString()), r === "hsv" && (n = this.toHsvString()), n || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.l += r / 100, t.l = qv(t.l), new e(t);
    }, e.prototype.brighten = function(r) {
      r === void 0 && (r = 10);
      var t = this.toRgb();
      return t.r = Math.max(0, Math.min(255, t.r - Math.round(255 * -(r / 100)))), t.g = Math.max(0, Math.min(255, t.g - Math.round(255 * -(r / 100)))), t.b = Math.max(0, Math.min(255, t.b - Math.round(255 * -(r / 100)))), new e(t);
    }, e.prototype.darken = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.l -= r / 100, t.l = qv(t.l), new e(t);
    }, e.prototype.tint = function(r) {
      return r === void 0 && (r = 10), this.mix("white", r);
    }, e.prototype.shade = function(r) {
      return r === void 0 && (r = 10), this.mix("black", r);
    }, e.prototype.desaturate = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.s -= r / 100, t.s = qv(t.s), new e(t);
    }, e.prototype.saturate = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.s += r / 100, t.s = qv(t.s), new e(t);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(r) {
      var t = this.toHsl(), n = (t.h + r) % 360;
      return t.h = n < 0 ? 360 + n : n, new e(t);
    }, e.prototype.mix = function(r, t) {
      t === void 0 && (t = 50);
      var n = this.toRgb(), a = new e(r).toRgb(), i = t / 100, l = {
        r: (a.r - n.r) * i + n.r,
        g: (a.g - n.g) * i + n.g,
        b: (a.b - n.b) * i + n.b,
        a: (a.a - n.a) * i + n.a
      };
      return new e(l);
    }, e.prototype.analogous = function(r, t) {
      r === void 0 && (r = 6), t === void 0 && (t = 30);
      var n = this.toHsl(), a = 360 / t, i = [this];
      for (n.h = (n.h - (a * r >> 1) + 720) % 360; --r; )
        n.h = (n.h + a) % 360, i.push(new e(n));
      return i;
    }, e.prototype.complement = function() {
      var r = this.toHsl();
      return r.h = (r.h + 180) % 360, new e(r);
    }, e.prototype.monochromatic = function(r) {
      r === void 0 && (r = 6);
      for (var t = this.toHsv(), n = t.h, a = t.s, i = t.v, l = [], u = 1 / r; r--; )
        l.push(new e({ h: n, s: a, v: i })), i = (i + u) % 1;
      return l;
    }, e.prototype.splitcomplement = function() {
      var r = this.toHsl(), t = r.h;
      return [
        this,
        new e({ h: (t + 72) % 360, s: r.s, l: r.l }),
        new e({ h: (t + 216) % 360, s: r.s, l: r.l })
      ];
    }, e.prototype.onBackground = function(r) {
      var t = this.toRgb(), n = new e(r).toRgb(), a = t.a + n.a * (1 - t.a);
      return new e({
        r: (t.r * t.a + n.r * n.a * (1 - t.a)) / a,
        g: (t.g * t.a + n.g * n.a * (1 - t.a)) / a,
        b: (t.b * t.a + n.b * n.a * (1 - t.a)) / a,
        a
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(r) {
      for (var t = this.toHsl(), n = t.h, a = [this], i = 360 / r, l = 1; l < r; l++)
        a.push(new e({ h: (n + l * i) % 360, s: t.s, l: t.l }));
      return a;
    }, e.prototype.equals = function(r) {
      return this.toRgbString() === new e(r).toRgbString();
    }, e;
  }()
);
function SM(e) {
  if (e === void 0 && (e = {}), e.count !== void 0 && e.count !== null) {
    var r = e.count, t = [];
    for (e.count = void 0; r > t.length; )
      e.count = null, e.seed && (e.seed += 1), t.push(SM(e));
    return e.count = r, t;
  }
  var n = jH(e.hue, e.seed), a = DH(n, e), i = NH(n, a, e), l = { h: n, s: a, v: i };
  return e.alpha !== void 0 && (l.a = e.alpha), new kf(l);
}
function jH(e, r) {
  var t = FH(e), n = Xp(t, r);
  return n < 0 && (n = 360 + n), n;
}
function DH(e, r) {
  if (r.hue === "monochrome")
    return 0;
  if (r.luminosity === "random")
    return Xp([0, 100], r.seed);
  var t = xM(e).saturationRange, n = t[0], a = t[1];
  switch (r.luminosity) {
    case "bright":
      n = 55;
      break;
    case "dark":
      n = a - 10;
      break;
    case "light":
      a = 55;
      break;
  }
  return Xp([n, a], r.seed);
}
function NH(e, r, t) {
  var n = LH(e, r), a = 100;
  switch (t.luminosity) {
    case "dark":
      a = n + 20;
      break;
    case "light":
      n = (a + n) / 2;
      break;
    case "random":
      n = 0, a = 100;
      break;
  }
  return Xp([n, a], t.seed);
}
function LH(e, r) {
  for (var t = xM(e).lowerBounds, n = 0; n < t.length - 1; n++) {
    var a = t[n][0], i = t[n][1], l = t[n + 1][0], u = t[n + 1][1];
    if (r >= a && r <= l) {
      var c = (u - i) / (l - a), f = i - c * a;
      return c * r + f;
    }
  }
  return 0;
}
function FH(e) {
  var r = parseInt(e, 10);
  if (!Number.isNaN(r) && r < 360 && r > 0)
    return [r, r];
  if (typeof e == "string") {
    var t = wM.find(function(l) {
      return l.name === e;
    });
    if (t) {
      var n = $M(t);
      if (n.hueRange)
        return n.hueRange;
    }
    var a = new kf(e);
    if (a.isValid) {
      var i = a.toHsv().h;
      return [i, i];
    }
  }
  return [0, 360];
}
function xM(e) {
  e >= 334 && e <= 360 && (e -= 360);
  for (var r = 0, t = wM; r < t.length; r++) {
    var n = t[r], a = $M(n);
    if (a.hueRange && e >= a.hueRange[0] && e <= a.hueRange[1])
      return a;
  }
  throw Error("Color not found");
}
function Xp(e, r) {
  if (r === void 0)
    return Math.floor(e[0] + Math.random() * (e[1] + 1 - e[0]));
  var t = e[1] || 1, n = e[0] || 0;
  r = (r * 9301 + 49297) % 233280;
  var a = r / 233280;
  return Math.floor(n + a * (t - n));
}
function $M(e) {
  var r = e.lowerBounds[0][0], t = e.lowerBounds[e.lowerBounds.length - 1][0], n = e.lowerBounds[e.lowerBounds.length - 1][1], a = e.lowerBounds[0][1];
  return {
    name: e.name,
    hueRange: e.hueRange,
    lowerBounds: e.lowerBounds,
    saturationRange: [r, t],
    brightnessRange: [n, a]
  };
}
var wM = [
  {
    name: "monochrome",
    hueRange: null,
    lowerBounds: [
      [0, 0],
      [100, 0]
    ]
  },
  {
    name: "red",
    hueRange: [-26, 18],
    lowerBounds: [
      [20, 100],
      [30, 92],
      [40, 89],
      [50, 85],
      [60, 78],
      [70, 70],
      [80, 60],
      [90, 55],
      [100, 50]
    ]
  },
  {
    name: "orange",
    hueRange: [19, 46],
    lowerBounds: [
      [20, 100],
      [30, 93],
      [40, 88],
      [50, 86],
      [60, 85],
      [70, 70],
      [100, 70]
    ]
  },
  {
    name: "yellow",
    hueRange: [47, 62],
    lowerBounds: [
      [25, 100],
      [40, 94],
      [50, 89],
      [60, 86],
      [70, 84],
      [80, 82],
      [90, 80],
      [100, 75]
    ]
  },
  {
    name: "green",
    hueRange: [63, 178],
    lowerBounds: [
      [30, 100],
      [40, 90],
      [50, 85],
      [60, 81],
      [70, 74],
      [80, 64],
      [90, 50],
      [100, 40]
    ]
  },
  {
    name: "blue",
    hueRange: [179, 257],
    lowerBounds: [
      [20, 100],
      [30, 86],
      [40, 80],
      [50, 74],
      [60, 60],
      [70, 52],
      [80, 44],
      [90, 39],
      [100, 35]
    ]
  },
  {
    name: "purple",
    hueRange: [258, 282],
    lowerBounds: [
      [20, 100],
      [30, 87],
      [40, 79],
      [50, 70],
      [60, 65],
      [70, 59],
      [80, 52],
      [90, 45],
      [100, 42]
    ]
  },
  {
    name: "pink",
    hueRange: [283, 334],
    lowerBounds: [
      [20, 100],
      [30, 90],
      [40, 86],
      [60, 84],
      [80, 80],
      [90, 75],
      [100, 73]
    ]
  }
], Wt = function(r, t, n) {
  var a = lg(r, "colors." + t, t), i = new kf(a), l = i.isValid;
  return l ? a : n;
}, zH = function(r) {
  return function(t) {
    var n = Wt(t, r), a = new kf(n).isDark();
    return a ? "dark" : "light";
  };
}, BH = function(r) {
  return function(t) {
    return zH(r)(t) === "dark";
  };
}, gc = function(r, t) {
  return function(n) {
    var a = Wt(n, r);
    return new kf(a).setAlpha(t).toRgbString();
  };
};
function bC(e, r) {
  return e === void 0 && (e = "1rem"), r === void 0 && (r = "rgba(255, 255, 255, 0.15)"), {
    backgroundImage: `linear-gradient(
    45deg,
    ` + r + ` 25%,
    transparent 25%,
    transparent 50%,
    ` + r + ` 50%,
    ` + r + ` 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: e + " " + e
  };
}
function UH(e) {
  var r = SM().toHexString();
  return !e || dV(e) ? r : e.string && e.colors ? WH(e.string, e.colors) : e.string && !e.colors ? VH(e.string) : e.colors && !e.string ? HH(e.colors) : r;
}
function VH(e) {
  var r = 0;
  if (e.length === 0)
    return r.toString();
  for (var t = 0; t < e.length; t += 1)
    r = e.charCodeAt(t) + ((r << 5) - r), r = r & r;
  for (var n = "#", a = 0; a < 3; a += 1) {
    var i = r >> a * 8 & 255;
    n += ("00" + i.toString(16)).substr(-2);
  }
  return n;
}
function WH(e, r) {
  var t = 0;
  if (e.length === 0)
    return r[0];
  for (var n = 0; n < e.length; n += 1)
    t = e.charCodeAt(n) + ((t << 5) - t), t = t & t;
  return t = (t % r.length + r.length) % r.length, r[t];
}
function HH(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function re(e, r) {
  return function(t) {
    return t.colorMode === "dark" ? r : e;
  };
}
function jf(e) {
  var r = e.orientation, t = e.vertical, n = e.horizontal;
  return r ? r === "vertical" ? t : n : {};
}
function _S() {
  return _S = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, _S.apply(this, arguments);
}
var GH = function(r) {
  return $V({
    condition: !0,
    message: ["[chakra-ui]: createBreakpoints(...) will be deprecated pretty soon", "simply pass the breakpoints as an object. Remove the createBreakpoint(..) call"].join("")
  }), _S({
    base: "0em"
  }, r);
};
function yC(e, r) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function YH(e, r, t) {
  return r && yC(e.prototype, r), t && yC(e, t), e;
}
var KH = /* @__PURE__ */ function() {
  function e(r) {
    var t = this;
    this.map = {}, this.called = !1, this.assert = function() {
      if (!t.called) {
        t.called = !0;
        return;
      }
      throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
    }, this.parts = function() {
      t.assert();
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      for (var l = 0, u = a; l < u.length; l++) {
        var c = u[l];
        t.map[c] = t.toPart(c);
      }
      return t;
    }, this.extend = function() {
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      for (var l = 0, u = a; l < u.length; l++) {
        var c = u[l];
        c in t.map || (t.map[c] = t.toPart(c));
      }
      return t;
    }, this.toPart = function(n) {
      var a = ["container", "root"].includes(n != null ? n : "") ? [t.name] : [t.name, n], i = a.filter(Boolean).join("__"), l = "chakra-" + i, u = {
        className: l,
        selector: "." + l,
        toString: function() {
          return n;
        }
      };
      return u;
    }, this.__type = {};
  }
  return YH(e, [{
    key: "selectors",
    get: (
      /**
       * Get all selectors for the component anatomy
       */
      function() {
        var t = Jd(Object.entries(this.map).map(function(n) {
          var a = n[0], i = n[1];
          return [a, i.selector];
        }));
        return t;
      }
    )
    /**
     * Get all classNames for the component anatomy
     */
  }, {
    key: "classNames",
    get: function() {
      var t = Jd(Object.entries(this.map).map(function(n) {
        var a = n[0], i = n[1];
        return [a, i.className];
      }));
      return t;
    }
    /**
     * Get all parts as array of string
     */
  }, {
    key: "keys",
    get: function() {
      return Object.keys(this.map);
    }
    /**
     * Creates the part object for the given part
     */
  }]), e;
}();
function rt(e) {
  return new KH(e);
}
function _M(e) {
  return Rn(e) && e.reference ? e.reference : String(e);
}
var fg = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(_M).join(" " + r + " ").replace(/calc/g, "");
}, SC = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + fg.apply(void 0, ["+"].concat(t)) + ")";
}, xC = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + fg.apply(void 0, ["-"].concat(t)) + ")";
}, TS = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + fg.apply(void 0, ["*"].concat(t)) + ")";
}, $C = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + fg.apply(void 0, ["/"].concat(t)) + ")";
}, wC = function(r) {
  var t = _M(r);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : "-" + t : TS(t, -1);
}, ki = Object.assign(function(e) {
  return {
    add: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return ki(SC.apply(void 0, [e].concat(n)));
    },
    subtract: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return ki(xC.apply(void 0, [e].concat(n)));
    },
    multiply: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return ki(TS.apply(void 0, [e].concat(n)));
    },
    divide: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return ki($C.apply(void 0, [e].concat(n)));
    },
    negate: function() {
      return ki(wC(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: SC,
  subtract: xC,
  multiply: TS,
  divide: $C,
  negate: wC
});
function qH(e) {
  return !Number.isInteger(parseFloat(e.toString()));
}
function ZH(e, r) {
  return r === void 0 && (r = "-"), e.replace(/\s+/g, r);
}
function TM(e) {
  var r = ZH(e.toString());
  return r.includes("\\.") ? e : qH(e) ? r.replace(".", "\\.") : e;
}
function QH(e, r) {
  return r === void 0 && (r = ""), [r, TM(e)].filter(Boolean).join("-");
}
function XH(e, r) {
  return "var(" + TM(e) + (r ? ", " + r : "") + ")";
}
function JH(e, r) {
  return r === void 0 && (r = ""), "--" + QH(e, r);
}
function $a(e, r) {
  var t = JH(e, r == null ? void 0 : r.prefix);
  return {
    variable: t,
    reference: XH(t, eG(r == null ? void 0 : r.fallback))
  };
}
function eG(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.reference;
}
var rG = rt("accordion").parts("root", "container", "button", "panel").extend("icon"), tG = rt("alert").parts("title", "description", "container").extend("icon"), nG = rt("avatar").parts("label", "badge", "container").extend("excessLabel", "group"), aG = rt("breadcrumb").parts("link", "item", "container").extend("separator");
rt("button").parts();
var oG = rt("checkbox").parts("control", "icon", "container").extend("label");
rt("progress").parts("track", "filledTrack").extend("label");
var iG = rt("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), sG = rt("editable").parts("preview", "input", "textarea"), lG = rt("form").parts("container", "requiredIndicator", "helperText"), uG = rt("formError").parts("text", "icon"), cG = rt("input").parts("addon", "field", "element"), dG = rt("list").parts("container", "item", "icon"), fG = rt("menu").parts("button", "list", "item").extend("groupTitle", "command", "divider"), vG = rt("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), hG = rt("numberinput").parts("root", "field", "stepperGroup", "stepper");
rt("pininput").parts("field");
var pG = rt("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton"), gG = rt("progress").parts("label", "filledTrack", "track"), mG = rt("radio").parts("container", "control", "label"), bG = rt("select").parts("field", "icon"), yG = rt("slider").parts("container", "track", "thumb", "filledTrack"), SG = rt("stat").parts("container", "label", "helpText", "number", "icon"), xG = rt("switch").parts("container", "track", "thumb"), $G = rt("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption"), wG = rt("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator"), _G = rt("tag").parts("container", "label", "closeButton"), CM = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  }
}, TG = {
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
}, CG = {
  transitionProperty: "common",
  transitionDuration: "normal",
  fontSize: "1rem",
  _focus: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "blackAlpha.50"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: 4,
  py: 2
}, EG = {
  pt: 2,
  px: 4,
  pb: 5
}, AG = {
  fontSize: "1.25em"
}, IG = {
  root: {},
  container: TG,
  button: CG,
  panel: EG,
  icon: AG
}, OG = {
  parts: rG.keys,
  baseStyle: IG
}, MG = {
  container: {
    px: 4,
    py: 3
  },
  title: {
    fontWeight: "bold",
    lineHeight: 6,
    marginEnd: 2
  },
  description: {
    lineHeight: 6
  },
  icon: {
    flexShrink: 0,
    marginEnd: 3,
    w: 5,
    h: 6
  }
};
function Z2(e) {
  var r = e.theme, t = e.colorScheme, n = Wt(r, t + ".100", t), a = gc(t + ".200", 0.16)(r);
  return re(n, a)(e);
}
var RG = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      bg: Z2(r)
    },
    icon: {
      color: re(t + ".500", t + ".200")(r)
    }
  };
}, PG = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      paddingStart: 3,
      borderStartWidth: "4px",
      borderStartColor: re(t + ".500", t + ".200")(r),
      bg: Z2(r)
    },
    icon: {
      color: re(t + ".500", t + ".200")(r)
    }
  };
}, kG = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      pt: 2,
      borderTopWidth: "4px",
      borderTopColor: re(t + ".500", t + ".200")(r),
      bg: Z2(r)
    },
    icon: {
      color: re(t + ".500", t + ".200")(r)
    }
  };
}, jG = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      bg: re(t + ".500", t + ".200")(r),
      color: re("white", "gray.900")(r)
    }
  };
}, DG = {
  subtle: RG,
  "left-accent": PG,
  "top-accent": kG,
  solid: jG
}, NG = {
  variant: "subtle",
  colorScheme: "blue"
}, LG = {
  parts: tG.keys,
  baseStyle: MG,
  variants: DG,
  defaultProps: NG
}, FG = function(r) {
  return {
    transform: "translate(25%, 25%)",
    borderRadius: "full",
    border: "0.2em solid",
    borderColor: re("white", "gray.800")(r)
  };
}, zG = function(r) {
  return {
    bg: re("gray.200", "whiteAlpha.400")(r)
  };
}, BG = function(r) {
  var t = r.name, n = r.theme, a = t ? UH({
    string: t
  }) : "gray.400", i = BH(a)(n), l = "white";
  i || (l = "gray.800");
  var u = re("white", "gray.800")(r);
  return {
    bg: a,
    color: l,
    borderColor: u,
    verticalAlign: "top"
  };
}, UG = function(r) {
  return {
    badge: FG(r),
    excessLabel: zG(r),
    container: BG(r)
  };
};
function hs(e) {
  var r = bM[e];
  return {
    container: {
      width: e,
      height: e,
      fontSize: "calc(" + (r != null ? r : e) + " / 2.5)"
    },
    excessLabel: {
      width: e,
      height: e
    },
    label: {
      fontSize: "calc(" + (r != null ? r : e) + " / 2.5)",
      lineHeight: e !== "100%" ? r != null ? r : e : void 0
    }
  };
}
var VG = {
  "2xs": hs("4"),
  xs: hs("6"),
  sm: hs("8"),
  md: hs("12"),
  lg: hs("16"),
  xl: hs("24"),
  "2xl": hs("32"),
  full: hs("100%")
}, WG = {
  size: "md"
}, HG = {
  parts: nG.keys,
  baseStyle: UG,
  sizes: VG,
  defaultProps: WG
}, GG = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold"
}, YG = function(r) {
  var t = r.colorScheme, n = r.theme, a = gc(t + ".500", 0.6)(n);
  return {
    bg: re(t + ".500", a)(r),
    color: re("white", "whiteAlpha.800")(r)
  };
}, KG = function(r) {
  var t = r.colorScheme, n = r.theme, a = gc(t + ".200", 0.16)(n);
  return {
    bg: re(t + ".100", a)(r),
    color: re(t + ".800", t + ".200")(r)
  };
}, qG = function(r) {
  var t = r.colorScheme, n = r.theme, a = gc(t + ".200", 0.8)(n), i = Wt(n, t + ".500"), l = re(i, a)(r);
  return {
    color: l,
    boxShadow: "inset 0 0 0px 1px " + l
  };
}, ZG = {
  solid: YG,
  subtle: KG,
  outline: qG
}, QG = {
  variant: "subtle",
  colorScheme: "gray"
}, ac = {
  baseStyle: GG,
  variants: ZG,
  defaultProps: QG
}, XG = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focus: {
    boxShadow: "outline"
  }
}, JG = {
  link: XG
}, eY = {
  parts: aG.keys,
  baseStyle: JG
}, rY = {
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focus: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
}, EM = function(r) {
  var t = r.colorScheme, n = r.theme;
  if (t === "gray")
    return {
      color: re("inherit", "whiteAlpha.900")(r),
      _hover: {
        bg: re("gray.100", "whiteAlpha.200")(r)
      },
      _active: {
        bg: re("gray.200", "whiteAlpha.300")(r)
      }
    };
  var a = gc(t + ".200", 0.12)(n), i = gc(t + ".200", 0.24)(n);
  return {
    color: re(t + ".600", t + ".200")(r),
    bg: "transparent",
    _hover: {
      bg: re(t + ".50", a)(r)
    },
    _active: {
      bg: re(t + ".100", i)(r)
    }
  };
}, tY = function(r) {
  var t = r.colorScheme, n = re("gray.200", "whiteAlpha.300")(r);
  return It({
    border: "1px solid",
    borderColor: t === "gray" ? n : "currentColor"
  }, EM(r));
}, nY = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
}, aY = function(r) {
  var t, n = r.colorScheme;
  if (n === "gray") {
    var a = re("gray.100", "whiteAlpha.200")(r);
    return {
      bg: a,
      _hover: {
        bg: re("gray.200", "whiteAlpha.300")(r),
        _disabled: {
          bg: a
        }
      },
      _active: {
        bg: re("gray.300", "whiteAlpha.400")(r)
      }
    };
  }
  var i = (t = nY[n]) != null ? t : {}, l = i.bg, u = l === void 0 ? n + ".500" : l, c = i.color, f = c === void 0 ? "white" : c, h = i.hoverBg, p = h === void 0 ? n + ".600" : h, g = i.activeBg, y = g === void 0 ? n + ".700" : g, S = re(u, n + ".200")(r);
  return {
    bg: S,
    color: re(f, "gray.800")(r),
    _hover: {
      bg: re(p, n + ".300")(r),
      _disabled: {
        bg: S
      }
    },
    _active: {
      bg: re(y, n + ".400")(r)
    }
  };
}, oY = function(r) {
  var t = r.colorScheme;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: re(t + ".500", t + ".200")(r),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: re(t + ".700", t + ".500")(r)
    }
  };
}, iY = {
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: 0,
  p: 0
}, sY = {
  ghost: EM,
  outline: tY,
  solid: aY,
  link: oY,
  unstyled: iY
}, lY = {
  lg: {
    h: 12,
    minW: 12,
    fontSize: "lg",
    px: 6
  },
  md: {
    h: 10,
    minW: 10,
    fontSize: "md",
    px: 4
  },
  sm: {
    h: 8,
    minW: 8,
    fontSize: "sm",
    px: 3
  },
  xs: {
    h: 6,
    minW: 6,
    fontSize: "xs",
    px: 2
  }
}, uY = {
  variant: "solid",
  size: "md",
  colorScheme: "gray"
}, cY = {
  baseStyle: rY,
  variants: sY,
  sizes: lY,
  defaultProps: uY
}, dY = function(r) {
  var t = r.colorScheme;
  return {
    w: "100%",
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "inherit",
    color: "white",
    _checked: {
      bg: re(t + ".500", t + ".200")(r),
      borderColor: re(t + ".500", t + ".200")(r),
      color: re("white", "gray.900")(r),
      _hover: {
        bg: re(t + ".600", t + ".300")(r),
        borderColor: re(t + ".600", t + ".300")(r)
      },
      _disabled: {
        borderColor: re("gray.200", "transparent")(r),
        bg: re("gray.200", "whiteAlpha.300")(r),
        color: re("gray.500", "whiteAlpha.500")(r)
      }
    },
    _indeterminate: {
      bg: re(t + ".500", t + ".200")(r),
      borderColor: re(t + ".500", t + ".200")(r),
      color: re("white", "gray.900")(r)
    },
    _disabled: {
      bg: re("gray.100", "whiteAlpha.100")(r),
      borderColor: re("gray.100", "transparent")(r)
    },
    _focus: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: re("red.500", "red.300")(r)
    }
  };
}, fY = {
  _disabled: {
    cursor: "not-allowed"
  }
}, vY = {
  userSelect: "none",
  _disabled: {
    opacity: 0.4
  }
}, hY = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, pY = function(r) {
  return {
    icon: hY,
    container: fY,
    control: dY(r),
    label: vY
  };
}, gY = {
  sm: {
    control: {
      h: 3,
      w: 3
    },
    label: {
      fontSize: "sm"
    },
    icon: {
      fontSize: "0.45rem"
    }
  },
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    },
    icon: {
      fontSize: "0.625rem"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    },
    icon: {
      fontSize: "0.625rem"
    }
  }
}, mY = {
  size: "md",
  colorScheme: "blue"
}, Jp = {
  parts: oG.keys,
  baseStyle: pY,
  sizes: gY,
  defaultProps: mY
}, Qv, Xv, Jv, Ed = $a("close-button-size"), bY = function(r) {
  var t = re("blackAlpha.100", "whiteAlpha.100")(r), n = re("blackAlpha.200", "whiteAlpha.200")(r);
  return {
    w: [Ed.reference],
    h: [Ed.reference],
    borderRadius: "md",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
      boxShadow: "none"
    },
    _hover: {
      bg: t
    },
    _active: {
      bg: n
    },
    _focus: {
      boxShadow: "outline"
    }
  };
}, yY = {
  lg: (Qv = {}, Qv[Ed.variable] = "40px", Qv.fontSize = "16px", Qv),
  md: (Xv = {}, Xv[Ed.variable] = "32px", Xv.fontSize = "12px", Xv),
  sm: (Jv = {}, Jv[Ed.variable] = "24px", Jv.fontSize = "10px", Jv)
}, SY = {
  size: "md"
}, xY = {
  baseStyle: bY,
  sizes: yY,
  defaultProps: SY
}, $Y = ac.variants, wY = ac.defaultProps, _Y = {
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm"
}, TY = {
  baseStyle: _Y,
  variants: $Y,
  defaultProps: wY
}, CY = {
  w: "100%",
  mx: "auto",
  maxW: "60ch",
  px: "1rem"
}, EY = {
  baseStyle: CY
}, AY = {
  opacity: 0.6,
  borderColor: "inherit"
}, IY = {
  borderStyle: "solid"
}, OY = {
  borderStyle: "dashed"
}, MY = {
  solid: IY,
  dashed: OY
}, RY = {
  variant: "solid"
}, PY = {
  baseStyle: AY,
  variants: MY,
  defaultProps: RY
};
function Mu(e) {
  return e === "full" ? {
    dialog: {
      maxW: "100vw",
      h: "100vh"
    }
  } : {
    dialog: {
      maxW: e
    }
  };
}
var kY = {
  bg: "blackAlpha.600",
  zIndex: "overlay"
}, jY = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
}, DY = function(r) {
  var t = r.isFullHeight;
  return It({}, t && {
    height: "100vh"
  }, {
    zIndex: "modal",
    maxH: "100vh",
    bg: re("white", "gray.700")(r),
    color: "inherit",
    boxShadow: re("lg", "dark-lg")(r)
  });
}, NY = {
  px: 6,
  py: 4,
  fontSize: "xl",
  fontWeight: "semibold"
}, LY = {
  position: "absolute",
  top: 2,
  insetEnd: 3
}, FY = {
  px: 6,
  py: 2,
  flex: 1,
  overflow: "auto"
}, zY = {
  px: 6,
  py: 4
}, BY = function(r) {
  return {
    overlay: kY,
    dialogContainer: jY,
    dialog: DY(r),
    header: NY,
    closeButton: LY,
    body: FY,
    footer: zY
  };
}, UY = {
  xs: Mu("xs"),
  sm: Mu("md"),
  md: Mu("lg"),
  lg: Mu("2xl"),
  xl: Mu("4xl"),
  full: Mu("full")
}, VY = {
  size: "xs"
}, WY = {
  parts: iG.keys,
  baseStyle: BY,
  sizes: UY,
  defaultProps: VY
}, HY = {
  borderRadius: "md",
  py: "3px",
  transitionProperty: "common",
  transitionDuration: "normal"
}, GY = {
  borderRadius: "md",
  py: "3px",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focus: {
    boxShadow: "outline"
  },
  _placeholder: {
    opacity: 0.6
  }
}, YY = {
  borderRadius: "md",
  py: "3px",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focus: {
    boxShadow: "outline"
  },
  _placeholder: {
    opacity: 0.6
  }
}, KY = {
  preview: HY,
  input: GY,
  textarea: YY
}, qY = {
  parts: sG.keys,
  baseStyle: KY
}, ZY = function(r) {
  return {
    marginStart: 1,
    color: re("red.500", "red.300")(r)
  };
}, QY = function(r) {
  return {
    mt: 2,
    color: re("gray.500", "whiteAlpha.600")(r),
    lineHeight: "normal",
    fontSize: "sm"
  };
}, XY = function(r) {
  return {
    container: {
      width: "100%",
      position: "relative"
    },
    requiredIndicator: ZY(r),
    helperText: QY(r)
  };
}, JY = {
  parts: lG.keys,
  baseStyle: XY
}, eK = function(r) {
  return {
    color: re("red.500", "red.300")(r),
    mt: 2,
    fontSize: "sm",
    lineHeight: "normal"
  };
}, rK = function(r) {
  return {
    marginEnd: "0.5em",
    color: re("red.500", "red.300")(r)
  };
}, tK = function(r) {
  return {
    text: eK(r),
    icon: rK(r)
  };
}, nK = {
  parts: uG.keys,
  baseStyle: tK
}, aK = {
  fontSize: "md",
  marginEnd: 3,
  mb: 2,
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
}, oK = {
  baseStyle: aK
}, iK = {
  fontFamily: "heading",
  fontWeight: "bold"
}, sK = {
  "4xl": {
    fontSize: ["6xl", null, "7xl"],
    lineHeight: 1
  },
  "3xl": {
    fontSize: ["5xl", null, "6xl"],
    lineHeight: 1
  },
  "2xl": {
    fontSize: ["4xl", null, "5xl"],
    lineHeight: [1.2, null, 1]
  },
  xl: {
    fontSize: ["3xl", null, "4xl"],
    lineHeight: [1.33, null, 1.2]
  },
  lg: {
    fontSize: ["2xl", null, "3xl"],
    lineHeight: [1.33, null, 1.2]
  },
  md: {
    fontSize: "xl",
    lineHeight: 1.2
  },
  sm: {
    fontSize: "md",
    lineHeight: 1.2
  },
  xs: {
    fontSize: "sm",
    lineHeight: 1.2
  }
}, lK = {
  size: "xl"
}, uK = {
  baseStyle: iK,
  sizes: sK,
  defaultProps: lK
}, cK = {
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal"
  }
}, ps = {
  lg: {
    fontSize: "lg",
    px: 4,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    px: 4,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    px: 3,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    px: 2,
    h: 6,
    borderRadius: "sm"
  }
}, dK = {
  lg: {
    field: ps.lg,
    addon: ps.lg
  },
  md: {
    field: ps.md,
    addon: ps.md
  },
  sm: {
    field: ps.sm,
    addon: ps.sm
  },
  xs: {
    field: ps.xs,
    addon: ps.xs
  }
};
function Q2(e) {
  var r = e.focusBorderColor, t = e.errorBorderColor;
  return {
    focusBorderColor: r || re("blue.500", "blue.300")(e),
    errorBorderColor: t || re("red.500", "red.300")(e)
  };
}
var fK = function(r) {
  var t = r.theme, n = Q2(r), a = n.focusBorderColor, i = n.errorBorderColor;
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: re("gray.300", "whiteAlpha.400")(r)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      },
      _invalid: {
        borderColor: Wt(t, i),
        boxShadow: "0 0 0 1px " + Wt(t, i)
      },
      _focus: {
        zIndex: 1,
        borderColor: Wt(t, a),
        boxShadow: "0 0 0 1px " + Wt(t, a)
      }
    },
    addon: {
      border: "1px solid",
      borderColor: re("inherit", "whiteAlpha.50")(r),
      bg: re("gray.100", "whiteAlpha.300")(r)
    }
  };
}, vK = function(r) {
  var t = r.theme, n = Q2(r), a = n.focusBorderColor, i = n.errorBorderColor;
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: re("gray.100", "whiteAlpha.50")(r),
      _hover: {
        bg: re("gray.200", "whiteAlpha.100")(r)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      },
      _invalid: {
        borderColor: Wt(t, i)
      },
      _focus: {
        bg: "transparent",
        borderColor: Wt(t, a)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: re("gray.100", "whiteAlpha.50")(r)
    }
  };
}, hK = function(r) {
  var t = r.theme, n = Q2(r), a = n.focusBorderColor, i = n.errorBorderColor;
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: 0,
      px: 0,
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Wt(t, i),
        boxShadow: "0px 1px 0px 0px " + Wt(t, i)
      },
      _focus: {
        borderColor: Wt(t, a),
        boxShadow: "0px 1px 0px 0px " + Wt(t, a)
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: 0,
      px: 0,
      bg: "transparent"
    }
  };
}, pK = {
  field: {
    bg: "transparent",
    px: 0,
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: 0,
    height: "auto"
  }
}, gK = {
  outline: fK,
  filled: vK,
  flushed: hK,
  unstyled: pK
}, mK = {
  size: "md",
  variant: "outline"
}, ht = {
  parts: cG.keys,
  baseStyle: cK,
  sizes: dK,
  variants: gK,
  defaultProps: mK
}, bK = function(r) {
  return {
    bg: re("gray.100", "whiteAlpha")(r),
    borderRadius: "md",
    borderWidth: "1px",
    borderBottomWidth: "3px",
    fontSize: "0.8em",
    fontWeight: "bold",
    lineHeight: "normal",
    px: "0.4em",
    whiteSpace: "nowrap"
  };
}, yK = {
  baseStyle: bK
}, SK = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focus: {
    boxShadow: "outline"
  }
}, xK = {
  baseStyle: SK
}, $K = {
  marginEnd: "0.5rem",
  display: "inline",
  verticalAlign: "text-bottom"
}, wK = {
  container: {},
  item: {},
  icon: $K
}, _K = {
  parts: dG.keys,
  baseStyle: wK
}, TK = function(r) {
  return {
    bg: re("#fff", "gray.700")(r),
    boxShadow: re("sm", "dark-lg")(r),
    color: "inherit",
    minW: "3xs",
    py: "2",
    zIndex: 1,
    borderRadius: "md",
    borderWidth: "1px"
  };
}, CK = function(r) {
  return {
    py: "0.4rem",
    px: "0.8rem",
    transitionProperty: "background",
    transitionDuration: "ultra-fast",
    transitionTimingFunction: "ease-in",
    _focus: {
      bg: re("gray.100", "whiteAlpha.100")(r)
    },
    _active: {
      bg: re("gray.200", "whiteAlpha.200")(r)
    },
    _expanded: {
      bg: re("gray.100", "whiteAlpha.100")(r)
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  };
}, EK = {
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
}, AK = {
  opacity: 0.6
}, IK = {
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "0.5rem",
  opacity: 0.6
}, OK = {
  transitionProperty: "common",
  transitionDuration: "normal"
}, MK = function(r) {
  return {
    button: OK,
    list: TK(r),
    item: CK(r),
    groupTitle: EK,
    command: AK,
    divider: IK
  };
}, RK = {
  parts: fG.keys,
  baseStyle: MK
}, PK = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, kK = function(r) {
  var t = r.isCentered, n = r.scrollBehavior;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: t ? "center" : "flex-start",
    overflow: n === "inside" ? "hidden" : "auto"
  };
}, jK = function(r) {
  var t = r.scrollBehavior;
  return {
    borderRadius: "md",
    bg: re("white", "gray.700")(r),
    color: "inherit",
    my: "3.75rem",
    zIndex: "modal",
    maxH: t === "inside" ? "calc(100% - 7.5rem)" : void 0,
    boxShadow: re("lg", "dark-lg")(r)
  };
}, DK = {
  px: 6,
  py: 4,
  fontSize: "xl",
  fontWeight: "semibold"
}, NK = {
  position: "absolute",
  top: 2,
  insetEnd: 3
}, LK = function(r) {
  var t = r.scrollBehavior;
  return {
    px: 6,
    py: 2,
    flex: 1,
    overflow: t === "inside" ? "auto" : void 0
  };
}, FK = {
  px: 6,
  py: 4
}, zK = function(r) {
  return {
    overlay: PK,
    dialogContainer: kK(r),
    dialog: jK(r),
    header: DK,
    closeButton: NK,
    body: LK(r),
    footer: FK
  };
};
function oo(e) {
  return e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "100vh",
      "@supports(min-height: -webkit-fill-available)": {
        minH: "-webkit-fill-available"
      },
      my: 0
    }
  } : {
    dialog: {
      maxW: e
    }
  };
}
var BK = {
  xs: oo("xs"),
  sm: oo("sm"),
  md: oo("md"),
  lg: oo("lg"),
  xl: oo("xl"),
  "2xl": oo("2xl"),
  "3xl": oo("3xl"),
  "4xl": oo("4xl"),
  "5xl": oo("5xl"),
  "6xl": oo("6xl"),
  full: oo("full")
}, UK = {
  size: "md"
}, VK = {
  parts: vG.keys,
  baseStyle: zK,
  sizes: BK,
  defaultProps: UK
}, eh, _C, TC, WK = ht.variants, HK = ht.defaultProps, X2 = $a("number-input-stepper-width"), AM = $a("number-input-input-padding"), GK = ki(X2).add("0.5rem").toString(), YK = (eh = {}, eh[X2.variable] = "24px", eh[AM.variable] = GK, eh), KK = (_C = (TC = ht.baseStyle) == null ? void 0 : TC.field) != null ? _C : {}, qK = {
  width: [X2.reference]
}, ZK = function(r) {
  return {
    borderStart: "1px solid",
    borderStartColor: re("inherit", "whiteAlpha.300")(r),
    color: re("inherit", "whiteAlpha.800")(r),
    _active: {
      bg: re("gray.200", "whiteAlpha.300")(r)
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  };
}, QK = function(r) {
  return {
    root: YK,
    field: KK,
    stepperGroup: qK,
    stepper: ZK(r)
  };
};
function rh(e) {
  var r, t, n = ht.sizes[e], a = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  }, i = (r = (t = n.field) == null ? void 0 : t.fontSize) != null ? r : "md", l = CM.fontSizes[i.toString()];
  return {
    field: It({}, n.field, {
      paddingInlineEnd: AM.reference,
      verticalAlign: "top"
    }),
    stepper: {
      fontSize: ki(l).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: a[e]
      },
      _last: {
        borderBottomEndRadius: a[e],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  };
}
var XK = {
  xs: rh("xs"),
  sm: rh("sm"),
  md: rh("md"),
  lg: rh("lg")
}, JK = {
  parts: hG.keys,
  baseStyle: QK,
  sizes: XK,
  variants: WK,
  defaultProps: HK
}, CC, eq = It({}, ht.baseStyle.field, {
  textAlign: "center"
}), rq = {
  lg: {
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  }
}, tq = {
  outline: function(r) {
    var t;
    return (t = ht.variants.outline(r).field) != null ? t : {};
  },
  flushed: function(r) {
    var t;
    return (t = ht.variants.flushed(r).field) != null ? t : {};
  },
  filled: function(r) {
    var t;
    return (t = ht.variants.filled(r).field) != null ? t : {};
  },
  unstyled: (CC = ht.variants.unstyled.field) != null ? CC : {}
}, nq = ht.defaultProps, aq = {
  baseStyle: eq,
  sizes: rq,
  variants: tq,
  defaultProps: nq
}, Lb = $a("popper-bg"), oq = $a("popper-arrow-bg"), iq = $a("popper-arrow-shadow-color"), sq = {
  zIndex: 10
}, lq = function(r) {
  var t, n = re("white", "gray.700")(r), a = re("gray.200", "whiteAlpha.300")(r);
  return t = {}, t[Lb.variable] = "colors." + n, t.bg = Lb.reference, t[oq.variable] = Lb.reference, t[iq.variable] = "colors." + a, t.width = "xs", t.border = "1px solid", t.borderColor = "inherit", t.borderRadius = "md", t.boxShadow = "sm", t.zIndex = "inherit", t._focus = {
    outline: 0,
    boxShadow: "outline"
  }, t;
}, uq = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
}, cq = {
  px: 3,
  py: 2
}, dq = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, fq = {
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
}, vq = function(r) {
  return {
    popper: sq,
    content: lq(r),
    header: uq,
    body: cq,
    footer: dq,
    arrow: {},
    closeButton: fq
  };
}, hq = {
  parts: pG.keys,
  baseStyle: vq
};
function pq(e) {
  var r = e.colorScheme, t = e.theme, n = e.isIndeterminate, a = e.hasStripe, i = re(bC(), bC("1rem", "rgba(0,0,0,0.1)"))(e), l = re(r + ".500", r + ".200")(e), u = `linear-gradient(
    to right,
    transparent 0%,
    ` + Wt(t, l) + ` 50%,
    transparent 100%
  )`, c = !n && a;
  return It({}, c && i, n ? {
    bgImage: u
  } : {
    bgColor: l
  });
}
var gq = {
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
}, mq = function(r) {
  return {
    bg: re("gray.100", "whiteAlpha.300")(r)
  };
}, bq = function(r) {
  return It({
    transitionProperty: "common",
    transitionDuration: "slow"
  }, pq(r));
}, yq = function(r) {
  return {
    label: gq,
    filledTrack: bq(r),
    track: mq(r)
  };
}, Sq = {
  xs: {
    track: {
      h: "0.25rem"
    }
  },
  sm: {
    track: {
      h: "0.5rem"
    }
  },
  md: {
    track: {
      h: "0.75rem"
    }
  },
  lg: {
    track: {
      h: "1rem"
    }
  }
}, xq = {
  size: "md",
  colorScheme: "blue"
}, $q = {
  parts: gG.keys,
  sizes: Sq,
  baseStyle: yq,
  defaultProps: xq
}, wq = function(r) {
  var t = Jp.baseStyle(r), n = t.control, a = n === void 0 ? {} : n;
  return It({}, a, {
    borderRadius: "full",
    _checked: It({}, a._checked, {
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    })
  });
}, _q = function(r) {
  return {
    label: Jp.baseStyle(r).label,
    container: Jp.baseStyle(r).container,
    control: wq(r)
  };
}, Tq = {
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    }
  },
  sm: {
    control: {
      width: 3,
      height: 3
    },
    label: {
      fontSize: "sm"
    }
  }
}, Cq = {
  size: "md",
  colorScheme: "blue"
}, Eq = {
  parts: mG.keys,
  baseStyle: _q,
  sizes: Tq,
  defaultProps: Cq
}, Aq = function(r) {
  return It({}, ht.baseStyle.field, {
    bg: re("white", "gray.700")(r),
    appearance: "none",
    paddingBottom: "1px",
    lineHeight: "normal",
    "> option, > optgroup": {
      bg: re("white", "gray.700")(r)
    }
  });
}, Iq = {
  width: "1.5rem",
  height: "100%",
  insetEnd: "0.5rem",
  position: "relative",
  color: "currentColor",
  fontSize: "1.25rem",
  _disabled: {
    opacity: 0.5
  }
}, Oq = function(r) {
  return {
    field: Aq(r),
    icon: Iq
  };
}, th = {
  paddingInlineEnd: "2rem"
}, Mq = Ba({}, ht.sizes, {
  lg: {
    field: th
  },
  md: {
    field: th
  },
  sm: {
    field: th
  },
  xs: {
    field: th,
    icon: {
      insetEnd: "0.25rem"
    }
  }
}), Rq = {
  parts: bG.keys,
  baseStyle: Oq,
  sizes: Mq,
  variants: ht.variants,
  defaultProps: ht.defaultProps
}, Pq = function(r, t) {
  return KO({
    from: {
      borderColor: r,
      background: r
    },
    to: {
      borderColor: t,
      background: t
    }
  });
}, kq = function(r) {
  var t = re("gray.100", "gray.800")(r), n = re("gray.400", "gray.600")(r), a = r.startColor, i = a === void 0 ? t : a, l = r.endColor, u = l === void 0 ? n : l, c = r.speed, f = r.theme, h = Wt(f, i), p = Wt(f, u);
  return {
    opacity: 0.7,
    borderRadius: "2px",
    borderColor: h,
    background: p,
    animation: c + "s linear infinite alternate " + Pq(h, p)
  };
}, jq = {
  baseStyle: kq
}, Dq = function(r) {
  return {
    borderRadius: "md",
    fontWeight: "semibold",
    _focus: {
      boxShadow: "outline",
      padding: "1rem",
      position: "fixed",
      top: "1.5rem",
      insetStart: "1.5rem",
      bg: re("white", "gray.700")(r)
    }
  };
}, Nq = {
  baseStyle: Dq
};
function Lq(e) {
  return jf({
    orientation: e.orientation,
    vertical: {
      left: "50%",
      transform: "translateX(-50%)",
      _active: {
        transform: "translateX(-50%) scale(1.15)"
      }
    },
    horizontal: {
      top: "50%",
      transform: "translateY(-50%)",
      _active: {
        transform: "translateY(-50%) scale(1.15)"
      }
    }
  });
}
var Fq = function(r) {
  var t = r.orientation;
  return It({
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    }
  }, jf({
    orientation: t,
    vertical: {
      h: "100%"
    },
    horizontal: {
      w: "100%"
    }
  }));
}, zq = function(r) {
  return {
    overflow: "hidden",
    borderRadius: "sm",
    bg: re("gray.200", "whiteAlpha.200")(r),
    _disabled: {
      bg: re("gray.300", "whiteAlpha.300")(r)
    }
  };
}, Bq = function(r) {
  return It({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focus: {
      boxShadow: "outline"
    },
    _disabled: {
      bg: "gray.300"
    }
  }, Lq(r));
}, Uq = function(r) {
  var t = r.colorScheme;
  return {
    width: "inherit",
    height: "inherit",
    bg: re(t + ".500", t + ".200")(r)
  };
}, Vq = function(r) {
  return {
    container: Fq(r),
    track: zq(r),
    thumb: Bq(r),
    filledTrack: Uq(r)
  };
}, Wq = function(r) {
  return {
    thumb: {
      w: "16px",
      h: "16px"
    },
    track: jf({
      orientation: r.orientation,
      horizontal: {
        h: "4px"
      },
      vertical: {
        w: "4px"
      }
    })
  };
}, Hq = function(r) {
  return {
    thumb: {
      w: "14px",
      h: "14px"
    },
    track: jf({
      orientation: r.orientation,
      horizontal: {
        h: "4px"
      },
      vertical: {
        w: "4px"
      }
    })
  };
}, Gq = function(r) {
  return {
    thumb: {
      w: "10px",
      h: "10px"
    },
    track: jf({
      orientation: r.orientation,
      horizontal: {
        h: "2px"
      },
      vertical: {
        w: "2px"
      }
    })
  };
}, Yq = {
  lg: Wq,
  md: Hq,
  sm: Gq
}, Kq = {
  size: "md",
  colorScheme: "blue"
}, qq = {
  parts: yG.keys,
  sizes: Yq,
  baseStyle: Vq,
  defaultProps: Kq
}, Fb, zb, Bb, Ub, Vb, Rl = $a("spinner-size"), Zq = {
  width: [Rl.reference],
  height: [Rl.reference]
}, Qq = {
  xs: (Fb = {}, Fb[Rl.variable] = "0.75rem", Fb),
  sm: (zb = {}, zb[Rl.variable] = "1rem", zb),
  md: (Bb = {}, Bb[Rl.variable] = "1.5rem", Bb),
  lg: (Ub = {}, Ub[Rl.variable] = "2rem", Ub),
  xl: (Vb = {}, Vb[Rl.variable] = "3rem", Vb)
}, Xq = {
  size: "md"
}, Jq = {
  baseStyle: Zq,
  sizes: Qq,
  defaultProps: Xq
}, eZ = {
  fontWeight: "medium"
}, rZ = {
  opacity: 0.8,
  marginBottom: 2
}, tZ = {
  verticalAlign: "baseline",
  fontWeight: "semibold"
}, nZ = {
  marginEnd: 1,
  w: "14px",
  h: "14px",
  verticalAlign: "middle"
}, aZ = {
  container: {},
  label: eZ,
  helpText: rZ,
  number: tZ,
  icon: nZ
}, oZ = {
  md: {
    label: {
      fontSize: "sm"
    },
    helpText: {
      fontSize: "sm"
    },
    number: {
      fontSize: "2xl"
    }
  }
}, iZ = {
  size: "md"
}, sZ = {
  parts: SG.keys,
  baseStyle: aZ,
  sizes: oZ,
  defaultProps: iZ
}, nh, ah, oh, Ad = $a("switch-track-width"), Yl = $a("switch-track-height"), Wb = $a("switch-track-diff"), lZ = ki.subtract(Ad, Yl), CS = $a("switch-thumb-x"), uZ = function(r) {
  var t = r.colorScheme;
  return {
    borderRadius: "full",
    p: "2px",
    width: [Ad.reference],
    height: [Yl.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    bg: re("gray.300", "whiteAlpha.400")(r),
    _focus: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      bg: re(t + ".500", t + ".200")(r)
    }
  };
}, cZ = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [Yl.reference],
  height: [Yl.reference],
  _checked: {
    transform: "translateX(" + CS.reference + ")"
  }
}, dZ = function(r) {
  var t, n;
  return {
    container: (n = {}, n[Wb.variable] = lZ, n[CS.variable] = Wb.reference, n._rtl = (t = {}, t[CS.variable] = ki(Wb).negate().toString(), t), n),
    track: uZ(r),
    thumb: cZ
  };
}, fZ = {
  sm: {
    container: (nh = {}, nh[Ad.variable] = "1.375rem", nh[Yl.variable] = "0.75rem", nh)
  },
  md: {
    container: (ah = {}, ah[Ad.variable] = "1.875rem", ah[Yl.variable] = "1rem", ah)
  },
  lg: {
    container: (oh = {}, oh[Ad.variable] = "2.875rem", oh[Yl.variable] = "1.5rem", oh)
  }
}, vZ = {
  size: "md",
  colorScheme: "blue"
}, hZ = {
  parts: xG.keys,
  baseStyle: dZ,
  sizes: fZ,
  defaultProps: vZ
}, pZ = {
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "wider",
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
}, e0 = {
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}, gZ = function(r) {
  var t = r.colorScheme;
  return {
    th: It({
      color: re("gray.600", "gray.400")(r),
      borderBottom: "1px",
      borderColor: re(t + ".100", t + ".700")(r)
    }, e0),
    td: It({
      borderBottom: "1px",
      borderColor: re(t + ".100", t + ".700")(r)
    }, e0),
    caption: {
      color: re("gray.600", "gray.100")(r)
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
}, mZ = function(r) {
  var t = r.colorScheme;
  return {
    th: It({
      color: re("gray.600", "gray.400")(r),
      borderBottom: "1px",
      borderColor: re(t + ".100", t + ".700")(r)
    }, e0),
    td: It({
      borderBottom: "1px",
      borderColor: re(t + ".100", t + ".700")(r)
    }, e0),
    caption: {
      color: re("gray.600", "gray.100")(r)
    },
    tbody: {
      tr: {
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "1px",
            borderColor: re(t + ".100", t + ".700")(r)
          },
          td: {
            background: re(t + ".100", t + ".700")(r)
          }
        }
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
}, bZ = {
  simple: gZ,
  striped: mZ,
  unstyled: {}
}, yZ = {
  sm: {
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  },
  md: {
    th: {
      px: "6",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  },
  lg: {
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  }
}, SZ = {
  variant: "simple",
  size: "md",
  colorScheme: "gray"
}, xZ = {
  parts: $G.keys,
  baseStyle: pZ,
  variants: bZ,
  sizes: yZ,
  defaultProps: SZ
}, $Z = function(r) {
  var t = r.orientation;
  return {
    display: t === "vertical" ? "flex" : "block"
  };
}, wZ = function(r) {
  var t = r.isFitted;
  return {
    flex: t ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focus: {
      zIndex: 1,
      boxShadow: "outline"
    }
  };
}, _Z = function(r) {
  var t = r.align, n = t === void 0 ? "start" : t, a = r.orientation, i = {
    end: "flex-end",
    center: "center",
    start: "flex-start"
  };
  return {
    justifyContent: i[n],
    flexDirection: a === "vertical" ? "column" : "row"
  };
}, TZ = {
  p: 4
}, CZ = function(r) {
  return {
    root: $Z(r),
    tab: wZ(r),
    tablist: _Z(r),
    tabpanel: TZ
  };
}, EZ = {
  sm: {
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  },
  md: {
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  },
  lg: {
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  }
}, AZ = function(r) {
  var t, n, a = r.colorScheme, i = r.orientation, l = i === "vertical", u = i === "vertical" ? "borderStart" : "borderBottom", c = l ? "marginStart" : "marginBottom";
  return {
    tablist: (t = {}, t[u] = "2px solid", t.borderColor = "inherit", t),
    tab: (n = {}, n[u] = "2px solid", n.borderColor = "transparent", n[c] = "-2px", n._selected = {
      color: re(a + ".600", a + ".300")(r),
      borderColor: "currentColor"
    }, n._active = {
      bg: re("gray.200", "whiteAlpha.300")(r)
    }, n._disabled = {
      opacity: 0.4,
      cursor: "not-allowed"
    }, n)
  };
}, IZ = function(r) {
  var t = r.colorScheme;
  return {
    tab: {
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px",
      _selected: {
        color: re(t + ".600", t + ".300")(r),
        borderColor: "inherit",
        borderBottomColor: re("white", "gray.800")(r)
      }
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}, OZ = function(r) {
  var t = r.colorScheme;
  return {
    tab: {
      border: "1px solid",
      borderColor: "inherit",
      bg: re("gray.50", "whiteAlpha.50")(r),
      mb: "-1px",
      _notLast: {
        marginEnd: "-1px"
      },
      _selected: {
        bg: re("#fff", "gray.800")(r),
        color: re(t + ".600", t + ".300")(r),
        borderColor: "inherit",
        borderTopColor: "currentColor",
        borderBottomColor: "transparent"
      }
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}, MZ = function(r) {
  var t = r.colorScheme, n = r.theme;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: Wt(n, t + ".700"),
        bg: Wt(n, t + ".100")
      }
    }
  };
}, RZ = function(r) {
  var t = r.colorScheme;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: re("gray.600", "inherit")(r),
      _selected: {
        color: re("#fff", "gray.800")(r),
        bg: re(t + ".600", t + ".300")(r)
      }
    }
  };
}, PZ = {}, kZ = {
  line: AZ,
  enclosed: IZ,
  "enclosed-colored": OZ,
  "soft-rounded": MZ,
  "solid-rounded": RZ,
  unstyled: PZ
}, jZ = {
  size: "md",
  variant: "line",
  colorScheme: "blue"
}, DZ = {
  parts: wG.keys,
  baseStyle: CZ,
  sizes: EZ,
  variants: kZ,
  defaultProps: jZ
}, NZ = {
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0,
  _focus: {
    boxShadow: "outline"
  }
}, LZ = {
  lineHeight: 1.2,
  overflow: "visible"
}, FZ = {
  fontSize: "18px",
  w: "1.25rem",
  h: "1.25rem",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "0.375rem",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4
  },
  _focus: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _hover: {
    opacity: 0.8
  },
  _active: {
    opacity: 1
  }
}, zZ = {
  container: NZ,
  label: LZ,
  closeButton: FZ
}, BZ = {
  sm: {
    container: {
      minH: "1.25rem",
      minW: "1.25rem",
      fontSize: "xs",
      px: 2,
      borderRadius: "md"
    },
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  },
  md: {
    container: {
      minH: "1.5rem",
      minW: "1.5rem",
      fontSize: "sm",
      borderRadius: "md",
      px: 2
    }
  },
  lg: {
    container: {
      minH: 8,
      minW: 8,
      fontSize: "md",
      borderRadius: "md",
      px: 3
    }
  }
}, UZ = {
  subtle: function(r) {
    return {
      container: ac.variants.subtle(r)
    };
  },
  solid: function(r) {
    return {
      container: ac.variants.solid(r)
    };
  },
  outline: function(r) {
    return {
      container: ac.variants.outline(r)
    };
  }
}, VZ = {
  size: "md",
  variant: "subtle",
  colorScheme: "gray"
}, WZ = {
  parts: _G.keys,
  variants: UZ,
  baseStyle: zZ,
  sizes: BZ,
  defaultProps: VZ
}, EC, AC, IC, OC, MC, HZ = It({}, ht.baseStyle.field, {
  paddingY: "8px",
  minHeight: "80px",
  lineHeight: "short",
  verticalAlign: "top"
}), GZ = {
  outline: function(r) {
    var t;
    return (t = ht.variants.outline(r).field) != null ? t : {};
  },
  flushed: function(r) {
    var t;
    return (t = ht.variants.flushed(r).field) != null ? t : {};
  },
  filled: function(r) {
    var t;
    return (t = ht.variants.filled(r).field) != null ? t : {};
  },
  unstyled: (EC = ht.variants.unstyled.field) != null ? EC : {}
}, YZ = {
  xs: (AC = ht.sizes.xs.field) != null ? AC : {},
  sm: (IC = ht.sizes.sm.field) != null ? IC : {},
  md: (OC = ht.sizes.md.field) != null ? OC : {},
  lg: (MC = ht.sizes.lg.field) != null ? MC : {}
}, KZ = {
  size: "md",
  variant: "outline"
}, qZ = {
  baseStyle: HZ,
  sizes: YZ,
  variants: GZ,
  defaultProps: KZ
}, Hb = $a("tooltip-bg"), ZZ = $a("popper-arrow-bg"), QZ = function(r) {
  var t, n = re("gray.700", "gray.300")(r);
  return t = {}, t[Hb.variable] = "colors." + n, t.px = "8px", t.py = "2px", t.bg = [Hb.reference], t[ZZ.variable] = [Hb.reference], t.color = re("whiteAlpha.900", "gray.900")(r), t.borderRadius = "sm", t.fontWeight = "medium", t.fontSize = "sm", t.boxShadow = "md", t.maxW = "320px", t.zIndex = "tooltip", t;
}, XZ = {
  baseStyle: QZ
}, JZ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Accordion: OG,
  Alert: LG,
  Avatar: HG,
  Badge: ac,
  Breadcrumb: eY,
  Button: cY,
  Checkbox: Jp,
  CloseButton: xY,
  Code: TY,
  Container: EY,
  Divider: PY,
  Drawer: WY,
  Editable: qY,
  Form: JY,
  FormError: nK,
  FormLabel: oK,
  Heading: uK,
  Input: ht,
  Kbd: yK,
  Link: xK,
  List: _K,
  Menu: RK,
  Modal: VK,
  NumberInput: JK,
  PinInput: aq,
  Popover: hq,
  Progress: $q,
  Radio: Eq,
  Select: Rq,
  Skeleton: jq,
  SkipLink: Nq,
  Slider: qq,
  Spinner: Jq,
  Stat: sZ,
  Switch: hZ,
  Table: xZ,
  Tabs: DZ,
  Tag: WZ,
  Textarea: qZ,
  Tooltip: XZ
}), eQ = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid"
}, rQ = GH({
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
}), tQ = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
    400: "#A0AEC0",
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    800: "#1A202C",
    900: "#171923"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#E53E3E",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBC8",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#FAF089",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#2F855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  teal: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044"
  },
  blue: {
    50: "#ebf8ff",
    100: "#bee3f8",
    200: "#90cdf4",
    300: "#63b3ed",
    400: "#4299e1",
    500: "#3182ce",
    600: "#2b6cb0",
    700: "#2c5282",
    800: "#2a4365",
    900: "#1A365D"
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666"
  },
  purple: {
    50: "#FAF5FF",
    100: "#E9D8FD",
    200: "#D6BCFA",
    300: "#B794F4",
    400: "#9F7AEA",
    500: "#805AD5",
    600: "#6B46C1",
    700: "#553C9A",
    800: "#44337A",
    900: "#322659"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  },
  linkedin: {
    50: "#E8F4F9",
    100: "#CFEDFB",
    200: "#9BDAF3",
    300: "#68C7EC",
    400: "#34B3E4",
    500: "#00A0DC",
    600: "#008CC9",
    700: "#0077B5",
    800: "#005E93",
    900: "#004471"
  },
  facebook: {
    50: "#E8F4F9",
    100: "#D9DEE9",
    200: "#B7C2DA",
    300: "#6482C0",
    400: "#4267B2",
    500: "#385898",
    600: "#314E89",
    700: "#29487D",
    800: "#223B67",
    900: "#1E355B"
  },
  messenger: {
    50: "#D0E6FF",
    100: "#B9DAFF",
    200: "#A2CDFF",
    300: "#7AB8FF",
    400: "#2E90FF",
    500: "#0078FF",
    600: "#0063D1",
    700: "#0052AC",
    800: "#003C7E",
    900: "#002C5C"
  },
  whatsapp: {
    50: "#dffeec",
    100: "#b9f5d0",
    200: "#90edb3",
    300: "#65e495",
    400: "#3cdd78",
    500: "#22c35e",
    600: "#179848",
    700: "#0c6c33",
    800: "#01421c",
    900: "#001803"
  },
  twitter: {
    50: "#E5F4FD",
    100: "#C8E9FB",
    200: "#A8DCFA",
    300: "#83CDF7",
    400: "#57BBF5",
    500: "#1DA1F2",
    600: "#1A94DA",
    700: "#1681BF",
    800: "#136B9E",
    900: "#0D4D71"
  },
  telegram: {
    50: "#E3F2F9",
    100: "#C5E4F3",
    200: "#A2D4EC",
    300: "#7AC1E4",
    400: "#47A9DA",
    500: "#0088CC",
    600: "#007AB8",
    700: "#006BA1",
    800: "#005885",
    900: "#003F5E"
  }
}, nQ = {
  none: "0",
  sm: "0.125rem",
  base: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
}, aQ = {
  xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  none: "none",
  "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
}, oQ = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
}, iQ = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, sQ = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
}, lQ = {
  property: oQ,
  easing: iQ,
  duration: sQ
}, uQ = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, cQ = {
  none: 0,
  sm: "4px",
  base: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "40px",
  "3xl": "64px"
}, dQ = It({
  breakpoints: rQ,
  zIndices: uQ,
  radii: nQ,
  blur: cQ,
  colors: tQ
}, CM, {
  sizes: bM,
  shadows: aQ,
  space: mM,
  borders: eQ,
  transition: lQ
}), fQ = {
  global: function(r) {
    return {
      body: {
        fontFamily: "body",
        color: re("gray.800", "whiteAlpha.900")(r),
        bg: re("white", "gray.800")(r),
        transitionProperty: "background-color",
        transitionDuration: "normal",
        lineHeight: "base"
      },
      "*::placeholder": {
        color: re("gray.400", "whiteAlpha.400")(r)
      },
      "*, *::before, &::after": {
        borderColor: re("gray.200", "whiteAlpha.300")(r),
        wordWrap: "break-word"
      }
    };
  }
}, vQ = fQ, hQ = ["borders", "breakpoints", "colors", "components", "config", "direction", "fonts", "fontSizes", "fontWeights", "letterSpacings", "lineHeights", "radii", "shadows", "sizes", "space", "styles", "transition", "zIndices"];
function pQ(e) {
  return Rn(e) ? hQ.every(function(r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }) : !1;
}
var gQ = "ltr", mQ = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
}, Df = It({
  direction: gQ
}, dQ, {
  components: JZ,
  styles: vQ,
  config: mQ
});
function oc() {
  return oc = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, oc.apply(this, arguments);
}
function bQ(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var yQ = ["as", "viewBox", "color", "focusable", "children", "className", "__css"], RC = {
  path: /* @__PURE__ */ I.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "1.5"
  }, /* @__PURE__ */ I.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
  }), /* @__PURE__ */ I.createElement("path", {
    fill: "currentColor",
    strokeLinecap: "round",
    d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
  }), /* @__PURE__ */ I.createElement("circle", {
    fill: "none",
    strokeMiterlimit: "10",
    cx: "12",
    cy: "12",
    r: "11.25"
  })),
  viewBox: "0 0 24 24"
}, SQ = /* @__PURE__ */ kn(function(e, r) {
  var t = e.as, n = e.viewBox, a = e.color, i = a === void 0 ? "currentColor" : a, l = e.focusable, u = l === void 0 ? !1 : l, c = e.children, f = e.className, h = e.__css, p = bQ(e, yQ), g = Ha("chakra-icon", f), y = oc({
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: i
  }, h), S = {
    ref: r,
    focusable: u,
    className: g,
    __css: y
  }, x = n != null ? n : RC.viewBox;
  if (t && typeof t != "string")
    return /* @__PURE__ */ I.createElement(Ht.svg, oc({
      as: t
    }, S, p));
  var T = c != null ? c : RC.path;
  return /* @__PURE__ */ I.createElement(Ht.svg, oc({
    verticalAlign: "middle",
    viewBox: x
  }, S, p), T);
});
function Ne(e) {
  var r = e.viewBox, t = r === void 0 ? "0 0 24 24" : r, n = e.d;
  e.displayName;
  var a = e.defaultProps, i = a === void 0 ? {} : a, l = I.Children.toArray(e.path), u = /* @__PURE__ */ kn(function(c, f) {
    return /* @__PURE__ */ I.createElement(SQ, oc({
      ref: f,
      viewBox: t
    }, i, c), l.length ? l : /* @__PURE__ */ I.createElement("path", {
      fill: "currentColor",
      d: n
    }));
  });
  return u;
}
var ES = function(e, r) {
  return ES = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var a in n)
      Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
  }, ES(e, r);
};
function IM(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  ES(e, r);
  function t() {
    this.constructor = e;
  }
  e.prototype = r === null ? Object.create(r) : (t.prototype = r.prototype, new t());
}
var de = function() {
  return de = Object.assign || function(r) {
    for (var t, n = 1, a = arguments.length; n < a; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, de.apply(this, arguments);
};
function Ga(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      r.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (t[n[a]] = e[n[a]]);
  return t;
}
function Ac(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(l) {
      l(i);
    });
  }
  return new (t || (t = Promise))(function(i, l) {
    function u(h) {
      try {
        f(n.next(h));
      } catch (p) {
        l(p);
      }
    }
    function c(h) {
      try {
        f(n.throw(h));
      } catch (p) {
        l(p);
      }
    }
    function f(h) {
      h.done ? i(h.value) : a(h.value).then(u, c);
    }
    f((n = n.apply(e, r || [])).next());
  });
}
function Ic(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, l;
  return l = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function u(f) {
    return function(h) {
      return c([f, h]);
    };
  }
  function c(f) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; l && (l = 0, f[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = f[0] & 2 ? a.return : f[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, f[1])).done)
          return i;
        switch (a = 0, i && (f = [f[0] & 2, i.value]), f[0]) {
          case 0:
          case 1:
            i = f;
            break;
          case 4:
            return t.label++, { value: f[1], done: !1 };
          case 5:
            t.label++, a = f[1], f = [0];
            continue;
          case 7:
            f = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (f[0] === 6 || f[0] === 2)) {
              t = 0;
              continue;
            }
            if (f[0] === 3 && (!i || f[1] > i[0] && f[1] < i[3])) {
              t.label = f[1];
              break;
            }
            if (f[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = f;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(f);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        f = r.call(e, t);
      } catch (h) {
        f = [6, h], a = 0;
      } finally {
        n = i = 0;
      }
    if (f[0] & 5)
      throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}
function xQ(e) {
  var r = typeof Symbol == "function" && Symbol.iterator, t = r && e[r], n = 0;
  if (t)
    return t.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function gt(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], l;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (u) {
    l = { error: u };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (l)
        throw l.error;
    }
  }
  return i;
}
function ba(e, r, t) {
  if (t || arguments.length === 2)
    for (var n = 0, a = r.length, i; n < a; n++)
      (i || !(n in r)) && (i || (i = Array.prototype.slice.call(r, 0, n)), i[n] = r[n]);
  return e.concat(i || Array.prototype.slice.call(r));
}
var $Q = "production", J2 = typeof process == "undefined" || process.env === void 0 ? $Q : "production", Ci = function(e) {
  return {
    isEnabled: function(r) {
      return e.some(function(t) {
        return !!r[t];
      });
    }
  };
}, af = {
  measureLayout: Ci(["layout", "layoutId", "drag"]),
  animation: Ci([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: Ci(["exit"]),
  drag: Ci(["drag", "dragControls"]),
  focus: Ci(["whileFocus"]),
  hover: Ci(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: Ci(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: Ci([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: Ci([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function wQ(e) {
  for (var r in e)
    e[r] !== null && (r === "projectionNodeConstructor" ? af.projectionNodeConstructor = e[r] : af[r].Component = e[r]);
}
var _Q = function() {
}, r0 = function() {
}, OM = Pn({ strict: !1 }), MM = Object.keys(af), TQ = MM.length;
function CQ(e, r, t) {
  var n = [], a = Ur(OM);
  if (!r)
    return null;
  J2 !== "production" && t && a.strict;
  for (var i = 0; i < TQ; i++) {
    var l = MM[i], u = af[l], c = u.isEnabled, f = u.Component;
    c(e) && f && n.push(I.createElement(f, de({ key: l }, e, { visualElement: r })));
  }
  return n;
}
var e$ = Pn({
  transformPagePoint: function(e) {
    return e;
  },
  isStatic: !1,
  reducedMotion: "never"
}), vg = Pn({});
function EQ() {
  return Ur(vg).visualElement;
}
var Nf = Pn(null), Oc = typeof document != "undefined", t0 = Oc ? TO : er, AS = { current: null }, RM = !1;
function AQ() {
  if (RM = !0, !!Oc)
    if (window.matchMedia) {
      var e = window.matchMedia("(prefers-reduced-motion)"), r = function() {
        return AS.current = e.matches;
      };
      e.addListener(r), r();
    } else
      AS.current = !1;
}
function IQ() {
  !RM && AQ();
  var e = gt(He(AS.current), 1), r = e[0];
  return r;
}
function OQ() {
  var e = IQ(), r = Ur(e$).reducedMotion;
  return r === "never" ? !1 : r === "always" ? !0 : e;
}
function MQ(e, r, t, n) {
  var a = Ur(OM), i = EQ(), l = Ur(Nf), u = OQ(), c = Ze(void 0);
  n || (n = a.renderer), !c.current && n && (c.current = n(e, {
    visualState: r,
    parent: i,
    props: t,
    presenceId: l == null ? void 0 : l.id,
    blockInitialAnimation: (l == null ? void 0 : l.initial) === !1,
    shouldReduceMotion: u
  }));
  var f = c.current;
  return t0(function() {
    f == null || f.syncRender();
  }), er(function() {
    var h;
    (h = f == null ? void 0 : f.animationState) === null || h === void 0 || h.animateChanges();
  }), t0(function() {
    return function() {
      return f == null ? void 0 : f.notifyUnmount();
    };
  }, []), f;
}
function Yu(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function RQ(e, r, t) {
  return Le(
    function(n) {
      var a;
      n && ((a = e.mount) === null || a === void 0 || a.call(e, n)), r && (n ? r.mount(n) : r.unmount()), t && (typeof t == "function" ? t(n) : Yu(t) && (t.current = n));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [r]
  );
}
function PM(e) {
  return Array.isArray(e);
}
function bo(e) {
  return typeof e == "string" || PM(e);
}
function PQ(e) {
  var r = {};
  return e.forEachValue(function(t, n) {
    return r[n] = t.get();
  }), r;
}
function kQ(e) {
  var r = {};
  return e.forEachValue(function(t, n) {
    return r[n] = t.getVelocity();
  }), r;
}
function kM(e, r, t, n, a) {
  var i;
  return n === void 0 && (n = {}), a === void 0 && (a = {}), typeof r == "function" && (r = r(t != null ? t : e.custom, n, a)), typeof r == "string" && (r = (i = e.variants) === null || i === void 0 ? void 0 : i[r]), typeof r == "function" && (r = r(t != null ? t : e.custom, n, a)), r;
}
function hg(e, r, t) {
  var n = e.getProps();
  return kM(n, r, t != null ? t : n.custom, PQ(e), kQ(e));
}
function pg(e) {
  var r;
  return typeof ((r = e.animate) === null || r === void 0 ? void 0 : r.start) == "function" || bo(e.initial) || bo(e.animate) || bo(e.whileHover) || bo(e.whileDrag) || bo(e.whileTap) || bo(e.whileFocus) || bo(e.exit);
}
function jM(e) {
  return !!(pg(e) || e.variants);
}
function jQ(e, r) {
  if (pg(e)) {
    var t = e.initial, n = e.animate;
    return {
      initial: t === !1 || bo(t) ? t : void 0,
      animate: bo(n) ? n : void 0
    };
  }
  return e.inherit !== !1 ? r : {};
}
function DQ(e) {
  var r = jQ(e, Ur(vg)), t = r.initial, n = r.animate;
  return Rt(function() {
    return { initial: t, animate: n };
  }, [PC(t), PC(n)]);
}
function PC(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
function Lf(e) {
  var r = Ze(null);
  return r.current === null && (r.current = e()), r.current;
}
var Id = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, NQ = 1;
function LQ() {
  return Lf(function() {
    if (Id.hasEverUpdated)
      return NQ++;
  });
}
var r$ = Pn({}), DM = Pn({});
function FQ(e, r, t, n) {
  var a, i = r.layoutId, l = r.layout, u = r.drag, c = r.dragConstraints, f = r.layoutScroll, h = Ur(DM);
  !n || !t || t != null && t.projection || (t.projection = new n(e, t.getLatestValues(), (a = t.parent) === null || a === void 0 ? void 0 : a.projection), t.projection.setOptions({
    layoutId: i,
    layout: l,
    alwaysMeasureLayout: !!u || c && Yu(c),
    visualElement: t,
    scheduleRender: function() {
      return t.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof l == "string" ? l : "both",
    initialPromotionConfig: h,
    layoutScroll: f
  }));
}
var zQ = (
  /** @class */
  function(e) {
    IM(r, e);
    function r() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return r.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, r.prototype.componentDidUpdate = function() {
    }, r.prototype.updateProps = function() {
      var t = this.props, n = t.visualElement, a = t.props;
      n && n.setProps(a);
    }, r.prototype.render = function() {
      return this.props.children;
    }, r;
  }($o.Component)
);
function BQ(e) {
  var r = e.preloadedFeatures, t = e.createVisualElement, n = e.projectionNodeConstructor, a = e.useRender, i = e.useVisualState, l = e.Component;
  r && wQ(r);
  function u(c, f) {
    var h = UQ(c);
    c = de(de({}, c), { layoutId: h });
    var p = Ur(e$), g = null, y = DQ(c), S = p.isStatic ? void 0 : LQ(), x = i(c, p.isStatic);
    return !p.isStatic && Oc && (y.visualElement = MQ(l, x, de(de({}, p), c), t), FQ(S, c, y.visualElement, n || af.projectionNodeConstructor), g = CQ(c, y.visualElement, r)), I.createElement(
      zQ,
      { visualElement: y.visualElement, props: de(de({}, p), c) },
      g,
      I.createElement(vg.Provider, { value: y }, a(l, c, S, RQ(x, y.visualElement, f), x, p.isStatic, y.visualElement))
    );
  }
  return H0(u);
}
function UQ(e) {
  var r, t = e.layoutId, n = (r = Ur(r$)) === null || r === void 0 ? void 0 : r.id;
  return n && t !== void 0 ? n + "-" + t : t;
}
function VQ(e) {
  function r(n, a) {
    return a === void 0 && (a = {}), BQ(e(n, a));
  }
  if (typeof Proxy == "undefined")
    return r;
  var t = /* @__PURE__ */ new Map();
  return new Proxy(r, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(n, a) {
      return t.has(a) || t.set(a, r(a)), t.get(a);
    }
  });
}
var WQ = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function t$(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(WQ.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
var n0 = {};
function HQ(e) {
  Object.assign(n0, e);
}
var IS = ["", "X", "Y", "Z"], GQ = ["translate", "scale", "rotate", "skew"], of = ["transformPerspective", "x", "y", "z"];
GQ.forEach(function(e) {
  return IS.forEach(function(r) {
    return of.push(e + r);
  });
});
function YQ(e, r) {
  return of.indexOf(e) - of.indexOf(r);
}
var KQ = new Set(of);
function Ff(e) {
  return KQ.has(e);
}
var qQ = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function NM(e) {
  return qQ.has(e);
}
function LM(e, r) {
  var t = r.layout, n = r.layoutId;
  return Ff(e) || NM(e) || (t || n !== void 0) && (!!n0[e] || e === "opacity");
}
var Li = function(e) {
  return !!(e !== null && typeof e == "object" && e.getVelocity);
}, ZQ = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function QQ(e, r, t, n) {
  var a = e.transform, i = e.transformKeys, l = r.enableHardwareAcceleration, u = l === void 0 ? !0 : l, c = r.allowTransformNone, f = c === void 0 ? !0 : c, h = "";
  i.sort(YQ);
  for (var p = !1, g = i.length, y = 0; y < g; y++) {
    var S = i[y];
    h += "".concat(ZQ[S] || S, "(").concat(a[S], ") "), S === "z" && (p = !0);
  }
  return !p && u ? h += "translateZ(0)" : h = h.trim(), n ? h = n(a, t ? "" : h) : f && t && (h = "none"), h;
}
function XQ(e) {
  var r = e.originX, t = r === void 0 ? "50%" : r, n = e.originY, a = n === void 0 ? "50%" : n, i = e.originZ, l = i === void 0 ? 0 : i;
  return "".concat(t, " ").concat(a, " ").concat(l);
}
function FM(e) {
  return e.startsWith("--");
}
var JQ = function(e, r) {
  return r && typeof e == "number" ? r.transform(e) : e;
};
const zM = (e, r) => (t) => Math.max(Math.min(t, r), e), Od = (e) => e % 1 ? Number(e.toFixed(5)) : e, sf = /(-)?([\d]*\.?[\d])+/g, OS = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, eX = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function zf(e) {
  return typeof e == "string";
}
const su = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Md = Object.assign(Object.assign({}, su), { transform: zM(0, 1) }), ih = Object.assign(Object.assign({}, su), { default: 1 }), Bf = (e) => ({
  test: (r) => zf(r) && r.endsWith(e) && r.split(" ").length === 1,
  parse: parseFloat,
  transform: (r) => `${r}${e}`
}), Ts = Bf("deg"), ti = Bf("%"), Ge = Bf("px"), rX = Bf("vh"), tX = Bf("vw"), kC = Object.assign(Object.assign({}, ti), { parse: (e) => ti.parse(e) / 100, transform: (e) => ti.transform(e * 100) }), n$ = (e, r) => (t) => !!(zf(t) && eX.test(t) && t.startsWith(e) || r && Object.prototype.hasOwnProperty.call(t, r)), BM = (e, r, t) => (n) => {
  if (!zf(n))
    return n;
  const [a, i, l, u] = n.match(sf);
  return {
    [e]: parseFloat(a),
    [r]: parseFloat(i),
    [t]: parseFloat(l),
    alpha: u !== void 0 ? parseFloat(u) : 1
  };
}, Fl = {
  test: n$("hsl", "hue"),
  parse: BM("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: r, lightness: t, alpha: n = 1 }) => "hsla(" + Math.round(e) + ", " + ti.transform(Od(r)) + ", " + ti.transform(Od(t)) + ", " + Od(Md.transform(n)) + ")"
}, nX = zM(0, 255), Gb = Object.assign(Object.assign({}, su), { transform: (e) => Math.round(nX(e)) }), Is = {
  test: n$("rgb", "red"),
  parse: BM("red", "green", "blue"),
  transform: ({ red: e, green: r, blue: t, alpha: n = 1 }) => "rgba(" + Gb.transform(e) + ", " + Gb.transform(r) + ", " + Gb.transform(t) + ", " + Od(Md.transform(n)) + ")"
};
function aX(e) {
  let r = "", t = "", n = "", a = "";
  return e.length > 5 ? (r = e.substr(1, 2), t = e.substr(3, 2), n = e.substr(5, 2), a = e.substr(7, 2)) : (r = e.substr(1, 1), t = e.substr(2, 1), n = e.substr(3, 1), a = e.substr(4, 1), r += r, t += t, n += n, a += a), {
    red: parseInt(r, 16),
    green: parseInt(t, 16),
    blue: parseInt(n, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
const MS = {
  test: n$("#"),
  parse: aX,
  transform: Is.transform
}, Mn = {
  test: (e) => Is.test(e) || MS.test(e) || Fl.test(e),
  parse: (e) => Is.test(e) ? Is.parse(e) : Fl.test(e) ? Fl.parse(e) : MS.parse(e),
  transform: (e) => zf(e) ? e : e.hasOwnProperty("red") ? Is.transform(e) : Fl.transform(e)
}, UM = "${c}", VM = "${n}";
function oX(e) {
  var r, t, n, a;
  return isNaN(e) && zf(e) && ((t = (r = e.match(sf)) === null || r === void 0 ? void 0 : r.length) !== null && t !== void 0 ? t : 0) + ((a = (n = e.match(OS)) === null || n === void 0 ? void 0 : n.length) !== null && a !== void 0 ? a : 0) > 0;
}
function WM(e) {
  typeof e == "number" && (e = `${e}`);
  const r = [];
  let t = 0;
  const n = e.match(OS);
  n && (t = n.length, e = e.replace(OS, UM), r.push(...n.map(Mn.parse)));
  const a = e.match(sf);
  return a && (e = e.replace(sf, VM), r.push(...a.map(su.parse))), { values: r, numColors: t, tokenised: e };
}
function HM(e) {
  return WM(e).values;
}
function GM(e) {
  const { values: r, numColors: t, tokenised: n } = WM(e), a = r.length;
  return (i) => {
    let l = n;
    for (let u = 0; u < a; u++)
      l = l.replace(u < t ? UM : VM, u < t ? Mn.transform(i[u]) : Od(i[u]));
    return l;
  };
}
const iX = (e) => typeof e == "number" ? 0 : e;
function sX(e) {
  const r = HM(e);
  return GM(e)(r.map(iX));
}
const Fi = { test: oX, parse: HM, createTransformer: GM, getAnimatableNone: sX }, lX = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function uX(e) {
  let [r, t] = e.slice(0, -1).split("(");
  if (r === "drop-shadow")
    return e;
  const [n] = t.match(sf) || [];
  if (!n)
    return e;
  const a = t.replace(n, "");
  let i = lX.has(r) ? 1 : 0;
  return n !== t && (i *= 100), r + "(" + i + a + ")";
}
const cX = /([a-z-]*)\(.*?\)/g, RS = Object.assign(Object.assign({}, Fi), { getAnimatableNone: (e) => {
  const r = e.match(cX);
  return r ? r.map(uX).join(" ") : e;
} });
var jC = de(de({}, su), { transform: Math.round }), YM = {
  // Border props
  borderWidth: Ge,
  borderTopWidth: Ge,
  borderRightWidth: Ge,
  borderBottomWidth: Ge,
  borderLeftWidth: Ge,
  borderRadius: Ge,
  radius: Ge,
  borderTopLeftRadius: Ge,
  borderTopRightRadius: Ge,
  borderBottomRightRadius: Ge,
  borderBottomLeftRadius: Ge,
  // Positioning props
  width: Ge,
  maxWidth: Ge,
  height: Ge,
  maxHeight: Ge,
  size: Ge,
  top: Ge,
  right: Ge,
  bottom: Ge,
  left: Ge,
  // Spacing props
  padding: Ge,
  paddingTop: Ge,
  paddingRight: Ge,
  paddingBottom: Ge,
  paddingLeft: Ge,
  margin: Ge,
  marginTop: Ge,
  marginRight: Ge,
  marginBottom: Ge,
  marginLeft: Ge,
  // Transform props
  rotate: Ts,
  rotateX: Ts,
  rotateY: Ts,
  rotateZ: Ts,
  scale: ih,
  scaleX: ih,
  scaleY: ih,
  scaleZ: ih,
  skew: Ts,
  skewX: Ts,
  skewY: Ts,
  distance: Ge,
  translateX: Ge,
  translateY: Ge,
  translateZ: Ge,
  x: Ge,
  y: Ge,
  z: Ge,
  perspective: Ge,
  transformPerspective: Ge,
  opacity: Md,
  originX: kC,
  originY: kC,
  originZ: Ge,
  // Misc
  zIndex: jC,
  // SVG
  fillOpacity: Md,
  strokeOpacity: Md,
  numOctaves: jC
};
function a$(e, r, t, n) {
  var a, i = e.style, l = e.vars, u = e.transform, c = e.transformKeys, f = e.transformOrigin;
  c.length = 0;
  var h = !1, p = !1, g = !0;
  for (var y in r) {
    var S = r[y];
    if (FM(y)) {
      l[y] = S;
      continue;
    }
    var x = YM[y], T = JQ(S, x);
    if (Ff(y)) {
      if (h = !0, u[y] = T, c.push(y), !g)
        continue;
      S !== ((a = x.default) !== null && a !== void 0 ? a : 0) && (g = !1);
    } else
      NM(y) ? (f[y] = T, p = !0) : i[y] = T;
  }
  h ? i.transform = QQ(e, t, g, n) : n ? i.transform = n({}, "") : !r.transform && i.transform && (i.transform = "none"), p && (i.transformOrigin = XQ(f));
}
var o$ = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function KM(e, r, t) {
  for (var n in r)
    !Li(r[n]) && !LM(n, t) && (e[n] = r[n]);
}
function dX(e, r, t) {
  var n = e.transformTemplate;
  return Rt(function() {
    var a = o$();
    a$(a, r, { enableHardwareAcceleration: !t }, n);
    var i = a.vars, l = a.style;
    return de(de({}, i), l);
  }, [r]);
}
function fX(e, r, t) {
  var n = e.style || {}, a = {};
  return KM(a, n, e), Object.assign(a, dX(e, r, t)), e.transformValues && (a = e.transformValues(a)), a;
}
function vX(e, r, t) {
  var n = {}, a = fX(e, r, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, a.userSelect = a.WebkitUserSelect = a.WebkitTouchCallout = "none", a.touchAction = e.drag === !0 ? "none" : "pan-".concat(e.drag === "x" ? "y" : "x")), n.style = a, n;
}
var hX = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function a0(e) {
  return hX.has(e);
}
var qM = function(e) {
  return !a0(e);
};
function pX(e) {
  e && (qM = function(r) {
    return r.startsWith("on") ? !a0(r) : e(r);
  });
}
try {
  pX(require("@emotion/is-prop-valid").default);
} catch (e) {
}
function gX(e, r, t) {
  var n = {};
  for (var a in e)
    (qM(a) || t === !0 && a0(a) || !r && !a0(a) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && a.startsWith("onDrag")) && (n[a] = e[a]);
  return n;
}
function DC(e, r, t) {
  return typeof e == "string" ? e : Ge.transform(r + t * e);
}
function mX(e, r, t) {
  var n = DC(r, e.x, e.width), a = DC(t, e.y, e.height);
  return "".concat(n, " ").concat(a);
}
var bX = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, yX = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function SX(e, r, t, n, a) {
  t === void 0 && (t = 1), n === void 0 && (n = 0), a === void 0 && (a = !0), e.pathLength = 1;
  var i = a ? bX : yX;
  e[i.offset] = Ge.transform(-n);
  var l = Ge.transform(r), u = Ge.transform(t);
  e[i.array] = "".concat(l, " ").concat(u);
}
function i$(e, r, t, n) {
  var a = r.attrX, i = r.attrY, l = r.originX, u = r.originY, c = r.pathLength, f = r.pathSpacing, h = f === void 0 ? 1 : f, p = r.pathOffset, g = p === void 0 ? 0 : p, y = Ga(r, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  a$(e, y, t, n), e.attrs = e.style, e.style = {};
  var S = e.attrs, x = e.style, T = e.dimensions;
  S.transform && (T && (x.transform = S.transform), delete S.transform), T && (l !== void 0 || u !== void 0 || x.transform) && (x.transformOrigin = mX(T, l !== void 0 ? l : 0.5, u !== void 0 ? u : 0.5)), a !== void 0 && (S.x = a), i !== void 0 && (S.y = i), c !== void 0 && SX(S, c, h, g, !1);
}
var ZM = function() {
  return de(de({}, o$()), { attrs: {} });
};
function xX(e, r) {
  var t = Rt(function() {
    var a = ZM();
    return i$(a, r, { enableHardwareAcceleration: !1 }, e.transformTemplate), de(de({}, a.attrs), { style: de({}, a.style) });
  }, [r]);
  if (e.style) {
    var n = {};
    KM(n, e.style, e), t.style = de(de({}, n), t.style);
  }
  return t;
}
function $X(e) {
  e === void 0 && (e = !1);
  var r = function(t, n, a, i, l, u) {
    var c = l.latestValues, f = t$(t) ? xX : vX, h = f(n, c, u), p = gX(n, typeof t == "string", e), g = de(de(de({}, p), h), { ref: i });
    return a && (g["data-projection-id"] = a), Di(t, g);
  };
  return r;
}
var wX = /([a-z])([A-Z])/g, _X = "$1-$2", QM = function(e) {
  return e.replace(wX, _X).toLowerCase();
};
function XM(e, r, t, n) {
  var a = r.style, i = r.vars;
  Object.assign(e.style, a, n && n.getProjectionStyles(t));
  for (var l in i)
    e.style.setProperty(l, i[l]);
}
var JM = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function eR(e, r, t, n) {
  XM(e, r, void 0, n);
  for (var a in r.attrs)
    e.setAttribute(JM.has(a) ? a : QM(a), r.attrs[a]);
}
function s$(e) {
  var r = e.style, t = {};
  for (var n in r)
    (Li(r[n]) || LM(n, e)) && (t[n] = r[n]);
  return t;
}
function rR(e) {
  var r = s$(e);
  for (var t in e)
    if (Li(e[t])) {
      var n = t === "x" || t === "y" ? "attr" + t.toUpperCase() : t;
      r[n] = e[t];
    }
  return r;
}
function l$(e) {
  return typeof e == "object" && typeof e.start == "function";
}
var lf = function(e) {
  return Array.isArray(e);
}, TX = function(e) {
  return !!(e && typeof e == "object" && e.mix && e.toValue);
}, tR = function(e) {
  return lf(e) ? e[e.length - 1] || 0 : e;
};
function $p(e) {
  var r = Li(e) ? e.get() : e;
  return TX(r) ? r.toValue() : r;
}
function NC(e, r, t, n) {
  var a = e.scrapeMotionValuesFromProps, i = e.createRenderState, l = e.onMount, u = {
    latestValues: CX(r, t, n, a),
    renderState: i()
  };
  return l && (u.mount = function(c) {
    return l(r, c, u);
  }), u;
}
var nR = function(e) {
  return function(r, t) {
    var n = Ur(vg), a = Ur(Nf);
    return t ? NC(e, r, n, a) : Lf(function() {
      return NC(e, r, n, a);
    });
  };
};
function CX(e, r, t, n) {
  var a = {}, i = (t == null ? void 0 : t.initial) === !1, l = n(e);
  for (var u in l)
    a[u] = $p(l[u]);
  var c = e.initial, f = e.animate, h = pg(e), p = jM(e);
  r && p && !h && e.inherit !== !1 && (c != null || (c = r.initial), f != null || (f = r.animate));
  var g = i || c === !1, y = g ? f : c;
  if (y && typeof y != "boolean" && !l$(y)) {
    var S = Array.isArray(y) ? y : [y];
    S.forEach(function(x) {
      var T = kM(e, x);
      if (T) {
        var A = T.transitionEnd;
        T.transition;
        var O = Ga(T, ["transitionEnd", "transition"]);
        for (var P in O) {
          var j = O[P];
          if (Array.isArray(j)) {
            var k = g ? j.length - 1 : 0;
            j = j[k];
          }
          j !== null && (a[P] = j);
        }
        for (var P in A)
          a[P] = A[P];
      }
    });
  }
  return a;
}
var EX = {
  useVisualState: nR({
    scrapeMotionValuesFromProps: rR,
    createRenderState: ZM,
    onMount: function(e, r, t) {
      var n = t.renderState, a = t.latestValues;
      try {
        n.dimensions = typeof r.getBBox == "function" ? r.getBBox() : r.getBoundingClientRect();
      } catch (i) {
        n.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      i$(n, a, { enableHardwareAcceleration: !1 }, e.transformTemplate), eR(r, n);
    }
  })
}, AX = {
  useVisualState: nR({
    scrapeMotionValuesFromProps: s$,
    createRenderState: o$
  })
};
function IX(e, r, t, n, a) {
  var i = r.forwardMotionProps, l = i === void 0 ? !1 : i, u = t$(e) ? EX : AX;
  return de(de({}, u), { preloadedFeatures: t, useRender: $X(l), createVisualElement: n, projectionNodeConstructor: a, Component: e });
}
var nt;
(function(e) {
  e.Animate = "animate", e.Hover = "whileHover", e.Tap = "whileTap", e.Drag = "whileDrag", e.Focus = "whileFocus", e.InView = "whileInView", e.Exit = "exit";
})(nt || (nt = {}));
function gg(e, r, t, n) {
  return n === void 0 && (n = { passive: !0 }), e.addEventListener(r, t, n), function() {
    return e.removeEventListener(r, t);
  };
}
function PS(e, r, t, n) {
  er(function() {
    var a = e.current;
    if (t && a)
      return gg(a, r, t, n);
  }, [e, r, t, n]);
}
function OX(e) {
  var r = e.whileFocus, t = e.visualElement, n = function() {
    var i;
    (i = t.animationState) === null || i === void 0 || i.setActive(nt.Focus, !0);
  }, a = function() {
    var i;
    (i = t.animationState) === null || i === void 0 || i.setActive(nt.Focus, !1);
  };
  PS(t, "focus", r ? n : void 0), PS(t, "blur", r ? a : void 0);
}
function aR(e) {
  return typeof PointerEvent != "undefined" && e instanceof PointerEvent ? e.pointerType === "mouse" : e instanceof MouseEvent;
}
function oR(e) {
  var r = !!e.touches;
  return r;
}
function MX(e) {
  return function(r) {
    var t = r instanceof MouseEvent, n = !t || t && r.button === 0;
    n && e(r);
  };
}
var RX = { pageX: 0, pageY: 0 };
function PX(e, r) {
  r === void 0 && (r = "page");
  var t = e.touches[0] || e.changedTouches[0], n = t || RX;
  return {
    x: n[r + "X"],
    y: n[r + "Y"]
  };
}
function kX(e, r) {
  return r === void 0 && (r = "page"), {
    x: e[r + "X"],
    y: e[r + "Y"]
  };
}
function u$(e, r) {
  return r === void 0 && (r = "page"), {
    point: oR(e) ? PX(e, r) : kX(e, r)
  };
}
var iR = function(e, r) {
  r === void 0 && (r = !1);
  var t = function(n) {
    return e(n, u$(n));
  };
  return r ? MX(t) : t;
}, jX = function() {
  return Oc && window.onpointerdown === null;
}, DX = function() {
  return Oc && window.ontouchstart === null;
}, NX = function() {
  return Oc && window.onmousedown === null;
}, LX = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, FX = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function sR(e) {
  return jX() ? e : DX() ? FX[e] : NX() ? LX[e] : e;
}
function ic(e, r, t, n) {
  return gg(e, sR(r), iR(t, r === "pointerdown"), n);
}
function o0(e, r, t, n) {
  return PS(e, sR(r), t && iR(t, r === "pointerdown"), n);
}
function lR(e) {
  var r = null;
  return function() {
    var t = function() {
      r = null;
    };
    return r === null ? (r = e, t) : !1;
  };
}
var LC = lR("dragHorizontal"), FC = lR("dragVertical");
function uR(e) {
  var r = !1;
  if (e === "y")
    r = FC();
  else if (e === "x")
    r = LC();
  else {
    var t = LC(), n = FC();
    t && n ? r = function() {
      t(), n();
    } : (t && t(), n && n());
  }
  return r;
}
function cR() {
  var e = uR(!0);
  return e ? (e(), !1) : !0;
}
function zC(e, r, t) {
  return function(n, a) {
    var i;
    !aR(n) || cR() || ((i = e.animationState) === null || i === void 0 || i.setActive(nt.Hover, r), t == null || t(n, a));
  };
}
function zX(e) {
  var r = e.onHoverStart, t = e.onHoverEnd, n = e.whileHover, a = e.visualElement;
  o0(a, "pointerenter", r || n ? zC(a, !0, r) : void 0, { passive: !r }), o0(a, "pointerleave", t || n ? zC(a, !1, t) : void 0, { passive: !t });
}
var dR = function(e, r) {
  return r ? e === r ? !0 : dR(e, r.parentElement) : !1;
};
function c$(e) {
  return er(function() {
    return function() {
      return e();
    };
  }, []);
}
const i0 = (e, r, t) => Math.min(Math.max(t, e), r), Yb = 1e-3, BX = 0.01, BC = 10, UX = 0.05, VX = 1;
function WX({ duration: e = 800, bounce: r = 0.25, velocity: t = 0, mass: n = 1 }) {
  let a, i;
  _Q(e <= BC * 1e3);
  let l = 1 - r;
  l = i0(UX, VX, l), e = i0(BX, BC, e / 1e3), l < 1 ? (a = (f) => {
    const h = f * l, p = h * e, g = h - t, y = kS(f, l), S = Math.exp(-p);
    return Yb - g / y * S;
  }, i = (f) => {
    const p = f * l * e, g = p * t + t, y = Math.pow(l, 2) * Math.pow(f, 2) * e, S = Math.exp(-p), x = kS(Math.pow(f, 2), l);
    return (-a(f) + Yb > 0 ? -1 : 1) * ((g - y) * S) / x;
  }) : (a = (f) => {
    const h = Math.exp(-f * e), p = (f - t) * e + 1;
    return -Yb + h * p;
  }, i = (f) => {
    const h = Math.exp(-f * e), p = (t - f) * (e * e);
    return h * p;
  });
  const u = 5 / e, c = GX(a, i, u);
  if (e = e * 1e3, isNaN(c))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const f = Math.pow(c, 2) * n;
    return {
      stiffness: f,
      damping: l * 2 * Math.sqrt(n * f),
      duration: e
    };
  }
}
const HX = 12;
function GX(e, r, t) {
  let n = t;
  for (let a = 1; a < HX; a++)
    n = n - e(n) / r(n);
  return n;
}
function kS(e, r) {
  return e * Math.sqrt(1 - r * r);
}
const YX = ["duration", "bounce"], KX = ["stiffness", "damping", "mass"];
function UC(e, r) {
  return r.some((t) => e[t] !== void 0);
}
function qX(e) {
  let r = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, e);
  if (!UC(e, KX) && UC(e, YX)) {
    const t = WX(e);
    r = Object.assign(Object.assign(Object.assign({}, r), t), { velocity: 0, mass: 1 }), r.isResolvedFromDuration = !0;
  }
  return r;
}
function d$(e) {
  var { from: r = 0, to: t = 1, restSpeed: n = 2, restDelta: a } = e, i = Ga(e, ["from", "to", "restSpeed", "restDelta"]);
  const l = { done: !1, value: r };
  let { stiffness: u, damping: c, mass: f, velocity: h, duration: p, isResolvedFromDuration: g } = qX(i), y = VC, S = VC;
  function x() {
    const T = h ? -(h / 1e3) : 0, A = t - r, O = c / (2 * Math.sqrt(u * f)), P = Math.sqrt(u / f) / 1e3;
    if (a === void 0 && (a = Math.min(Math.abs(t - r) / 100, 0.4)), O < 1) {
      const j = kS(P, O);
      y = (k) => {
        const L = Math.exp(-O * P * k);
        return t - L * ((T + O * P * A) / j * Math.sin(j * k) + A * Math.cos(j * k));
      }, S = (k) => {
        const L = Math.exp(-O * P * k);
        return O * P * L * (Math.sin(j * k) * (T + O * P * A) / j + A * Math.cos(j * k)) - L * (Math.cos(j * k) * (T + O * P * A) - j * A * Math.sin(j * k));
      };
    } else if (O === 1)
      y = (j) => t - Math.exp(-P * j) * (A + (T + P * A) * j);
    else {
      const j = P * Math.sqrt(O * O - 1);
      y = (k) => {
        const L = Math.exp(-O * P * k), M = Math.min(j * k, 300);
        return t - L * ((T + O * P * A) * Math.sinh(M) + j * A * Math.cosh(M)) / j;
      };
    }
  }
  return x(), {
    next: (T) => {
      const A = y(T);
      if (g)
        l.done = T >= p;
      else {
        const O = S(T) * 1e3, P = Math.abs(O) <= n, j = Math.abs(t - A) <= a;
        l.done = P && j;
      }
      return l.value = l.done ? t : A, l;
    },
    flipTarget: () => {
      h = -h, [r, t] = [t, r], x();
    }
  };
}
d$.needsInterpolation = (e, r) => typeof e == "string" || typeof r == "string";
const VC = (e) => 0, uf = (e, r, t) => {
  const n = r - e;
  return n === 0 ? 1 : (t - e) / n;
}, Tt = (e, r, t) => -t * e + t * r + e;
function Kb(e, r, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? e + (r - e) * 6 * t : t < 1 / 2 ? r : t < 2 / 3 ? e + (r - e) * (2 / 3 - t) * 6 : e;
}
function WC({ hue: e, saturation: r, lightness: t, alpha: n }) {
  e /= 360, r /= 100, t /= 100;
  let a = 0, i = 0, l = 0;
  if (!r)
    a = i = l = t;
  else {
    const u = t < 0.5 ? t * (1 + r) : t + r - t * r, c = 2 * t - u;
    a = Kb(c, u, e + 1 / 3), i = Kb(c, u, e), l = Kb(c, u, e - 1 / 3);
  }
  return {
    red: Math.round(a * 255),
    green: Math.round(i * 255),
    blue: Math.round(l * 255),
    alpha: n
  };
}
const ZX = (e, r, t) => {
  const n = e * e, a = r * r;
  return Math.sqrt(Math.max(0, t * (a - n) + n));
}, QX = [MS, Is, Fl], HC = (e) => QX.find((r) => r.test(e)), fR = (e, r) => {
  let t = HC(e), n = HC(r), a = t.parse(e), i = n.parse(r);
  t === Fl && (a = WC(a), t = Is), n === Fl && (i = WC(i), n = Is);
  const l = Object.assign({}, a);
  return (u) => {
    for (const c in l)
      c !== "alpha" && (l[c] = ZX(a[c], i[c], u));
    return l.alpha = Tt(a.alpha, i.alpha, u), t.transform(l);
  };
}, jS = (e) => typeof e == "number", XX = (e, r) => (t) => r(e(t)), mg = (...e) => e.reduce(XX);
function vR(e, r) {
  return jS(e) ? (t) => Tt(e, r, t) : Mn.test(e) ? fR(e, r) : pR(e, r);
}
const hR = (e, r) => {
  const t = [...e], n = t.length, a = e.map((i, l) => vR(i, r[l]));
  return (i) => {
    for (let l = 0; l < n; l++)
      t[l] = a[l](i);
    return t;
  };
}, JX = (e, r) => {
  const t = Object.assign(Object.assign({}, e), r), n = {};
  for (const a in t)
    e[a] !== void 0 && r[a] !== void 0 && (n[a] = vR(e[a], r[a]));
  return (a) => {
    for (const i in n)
      t[i] = n[i](a);
    return t;
  };
};
function GC(e) {
  const r = Fi.parse(e), t = r.length;
  let n = 0, a = 0, i = 0;
  for (let l = 0; l < t; l++)
    n || typeof r[l] == "number" ? n++ : r[l].hue !== void 0 ? i++ : a++;
  return { parsed: r, numNumbers: n, numRGB: a, numHSL: i };
}
const pR = (e, r) => {
  const t = Fi.createTransformer(r), n = GC(e), a = GC(r);
  return n.numHSL === a.numHSL && n.numRGB === a.numRGB && n.numNumbers >= a.numNumbers ? mg(hR(n.parsed, a.parsed), t) : (l) => `${l > 0 ? r : e}`;
}, eJ = (e, r) => (t) => Tt(e, r, t);
function rJ(e) {
  if (typeof e == "number")
    return eJ;
  if (typeof e == "string")
    return Mn.test(e) ? fR : pR;
  if (Array.isArray(e))
    return hR;
  if (typeof e == "object")
    return JX;
}
function tJ(e, r, t) {
  const n = [], a = t || rJ(e[0]), i = e.length - 1;
  for (let l = 0; l < i; l++) {
    let u = a(e[l], e[l + 1]);
    if (r) {
      const c = Array.isArray(r) ? r[l] : r;
      u = mg(c, u);
    }
    n.push(u);
  }
  return n;
}
function nJ([e, r], [t]) {
  return (n) => t(uf(e, r, n));
}
function aJ(e, r) {
  const t = e.length, n = t - 1;
  return (a) => {
    let i = 0, l = !1;
    if (a <= e[0] ? l = !0 : a >= e[n] && (i = n - 1, l = !0), !l) {
      let c = 1;
      for (; c < t && !(e[c] > a || c === n); c++)
        ;
      i = c - 1;
    }
    const u = uf(e[i], e[i + 1], a);
    return r[i](u);
  };
}
function gR(e, r, { clamp: t = !0, ease: n, mixer: a } = {}) {
  const i = e.length;
  r0(i === r.length), r0(!n || !Array.isArray(n) || n.length === i - 1), e[0] > e[i - 1] && (e = [].concat(e), r = [].concat(r), e.reverse(), r.reverse());
  const l = tJ(r, n, a), u = i === 2 ? nJ(e, l) : aJ(e, l);
  return t ? (c) => u(i0(e[0], e[i - 1], c)) : u;
}
const bg = (e) => (r) => 1 - e(1 - r), f$ = (e) => (r) => r <= 0.5 ? e(2 * r) / 2 : (2 - e(2 * (1 - r))) / 2, oJ = (e) => (r) => Math.pow(r, e), mR = (e) => (r) => r * r * ((e + 1) * r - e), iJ = (e) => {
  const r = mR(e);
  return (t) => (t *= 2) < 1 ? 0.5 * r(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1)));
}, bR = 1.525, sJ = 4 / 11, lJ = 8 / 11, uJ = 9 / 10, v$ = (e) => e, h$ = oJ(2), cJ = bg(h$), yR = f$(h$), SR = (e) => 1 - Math.sin(Math.acos(e)), p$ = bg(SR), dJ = f$(p$), g$ = mR(bR), fJ = bg(g$), vJ = f$(g$), hJ = iJ(bR), pJ = 4356 / 361, gJ = 35442 / 1805, mJ = 16061 / 1805, s0 = (e) => {
  if (e === 1 || e === 0)
    return e;
  const r = e * e;
  return e < sJ ? 7.5625 * r : e < lJ ? 9.075 * r - 9.9 * e + 3.4 : e < uJ ? pJ * r - gJ * e + mJ : 10.8 * e * e - 20.52 * e + 10.72;
}, bJ = bg(s0), yJ = (e) => e < 0.5 ? 0.5 * (1 - s0(1 - e * 2)) : 0.5 * s0(e * 2 - 1) + 0.5;
function SJ(e, r) {
  return e.map(() => r || yR).splice(0, e.length - 1);
}
function xJ(e) {
  const r = e.length;
  return e.map((t, n) => n !== 0 ? n / (r - 1) : 0);
}
function $J(e, r) {
  return e.map((t) => t * r);
}
function wp({ from: e = 0, to: r = 1, ease: t, offset: n, duration: a = 300 }) {
  const i = { done: !1, value: e }, l = Array.isArray(r) ? r : [e, r], u = $J(n && n.length === l.length ? n : xJ(l), a);
  function c() {
    return gR(u, l, {
      ease: Array.isArray(t) ? t : SJ(l, t)
    });
  }
  let f = c();
  return {
    next: (h) => (i.value = f(h), i.done = h >= a, i),
    flipTarget: () => {
      l.reverse(), f = c();
    }
  };
}
function wJ({ velocity: e = 0, from: r = 0, power: t = 0.8, timeConstant: n = 350, restDelta: a = 0.5, modifyTarget: i }) {
  const l = { done: !1, value: r };
  let u = t * e;
  const c = r + u, f = i === void 0 ? c : i(c);
  return f !== c && (u = f - r), {
    next: (h) => {
      const p = -u * Math.exp(-h / n);
      return l.done = !(p > a || p < -a), l.value = l.done ? f : f + p, l;
    },
    flipTarget: () => {
    }
  };
}
const YC = { keyframes: wp, spring: d$, decay: wJ };
function _J(e) {
  if (Array.isArray(e.to))
    return wp;
  if (YC[e.type])
    return YC[e.type];
  const r = new Set(Object.keys(e));
  return r.has("ease") || r.has("duration") && !r.has("dampingRatio") ? wp : r.has("dampingRatio") || r.has("stiffness") || r.has("mass") || r.has("damping") || r.has("restSpeed") || r.has("restDelta") ? d$ : wp;
}
const xR = 1 / 60 * 1e3, TJ = typeof performance != "undefined" ? () => performance.now() : () => Date.now(), $R = typeof window != "undefined" ? (e) => window.requestAnimationFrame(e) : (e) => setTimeout(() => e(TJ()), xR);
function CJ(e) {
  let r = [], t = [], n = 0, a = !1, i = !1;
  const l = /* @__PURE__ */ new WeakSet(), u = {
    schedule: (c, f = !1, h = !1) => {
      const p = h && a, g = p ? r : t;
      return f && l.add(c), g.indexOf(c) === -1 && (g.push(c), p && a && (n = r.length)), c;
    },
    cancel: (c) => {
      const f = t.indexOf(c);
      f !== -1 && t.splice(f, 1), l.delete(c);
    },
    process: (c) => {
      if (a) {
        i = !0;
        return;
      }
      if (a = !0, [r, t] = [t, r], t.length = 0, n = r.length, n)
        for (let f = 0; f < n; f++) {
          const h = r[f];
          h(c), l.has(h) && (u.schedule(h), e());
        }
      a = !1, i && (i = !1, u.process(c));
    }
  };
  return u;
}
const EJ = 40;
let DS = !0, cf = !1, NS = !1;
const sc = {
  delta: 0,
  timestamp: 0
}, Uf = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], yg = Uf.reduce((e, r) => (e[r] = CJ(() => cf = !0), e), {}), AJ = Uf.reduce((e, r) => {
  const t = yg[r];
  return e[r] = (n, a = !1, i = !1) => (cf || MJ(), t.schedule(n, a, i)), e;
}, {}), IJ = Uf.reduce((e, r) => (e[r] = yg[r].cancel, e), {});
Uf.reduce((e, r) => (e[r] = () => yg[r].process(sc), e), {});
const OJ = (e) => yg[e].process(sc), wR = (e) => {
  cf = !1, sc.delta = DS ? xR : Math.max(Math.min(e - sc.timestamp, EJ), 1), sc.timestamp = e, NS = !0, Uf.forEach(OJ), NS = !1, cf && (DS = !1, $R(wR));
}, MJ = () => {
  cf = !0, DS = !0, NS || $R(wR);
}, RJ = () => sc;
function _R(e, r, t = 0) {
  return e - r - t;
}
function PJ(e, r, t = 0, n = !0) {
  return n ? _R(r + -e, r, t) : r - (e - r) + t;
}
function kJ(e, r, t, n) {
  return n ? e >= r + t : e <= -t;
}
const jJ = (e) => {
  const r = ({ delta: t }) => e(t);
  return {
    start: () => AJ.update(r, !0),
    stop: () => IJ.update(r)
  };
};
function TR(e) {
  var r, t, { from: n, autoplay: a = !0, driver: i = jJ, elapsed: l = 0, repeat: u = 0, repeatType: c = "loop", repeatDelay: f = 0, onPlay: h, onStop: p, onComplete: g, onRepeat: y, onUpdate: S } = e, x = Ga(e, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: T } = x, A, O = 0, P = x.duration, j, k = !1, L = !0, M;
  const W = _J(x);
  !((t = (r = W).needsInterpolation) === null || t === void 0) && t.call(r, n, T) && (M = gR([0, 100], [n, T], {
    clamp: !1
  }), n = 0, T = 100);
  const q = W(Object.assign(Object.assign({}, x), { from: n, to: T }));
  function oe() {
    O++, c === "reverse" ? (L = O % 2 === 0, l = PJ(l, P, f, L)) : (l = _R(l, P, f), c === "mirror" && q.flipTarget()), k = !1, y && y();
  }
  function Ae() {
    A.stop(), g && g();
  }
  function Te(Ee) {
    if (L || (Ee = -Ee), l += Ee, !k) {
      const ze = q.next(Math.max(0, l));
      j = ze.value, M && (j = M(j)), k = L ? ze.done : l <= 0;
    }
    S == null || S(j), k && (O === 0 && (P != null || (P = l)), O < u ? kJ(l, P, f, L) && oe() : Ae());
  }
  function $e() {
    h == null || h(), A = i(Te), A.start();
  }
  return a && $e(), {
    stop: () => {
      p == null || p(), A.stop();
    }
  };
}
function CR(e, r) {
  return r ? e * (1e3 / r) : 0;
}
function DJ({ from: e = 0, velocity: r = 0, min: t, max: n, power: a = 0.8, timeConstant: i = 750, bounceStiffness: l = 500, bounceDamping: u = 10, restDelta: c = 1, modifyTarget: f, driver: h, onUpdate: p, onComplete: g, onStop: y }) {
  let S;
  function x(P) {
    return t !== void 0 && P < t || n !== void 0 && P > n;
  }
  function T(P) {
    return t === void 0 ? n : n === void 0 || Math.abs(t - P) < Math.abs(n - P) ? t : n;
  }
  function A(P) {
    S == null || S.stop(), S = TR(Object.assign(Object.assign({}, P), {
      driver: h,
      onUpdate: (j) => {
        var k;
        p == null || p(j), (k = P.onUpdate) === null || k === void 0 || k.call(P, j);
      },
      onComplete: g,
      onStop: y
    }));
  }
  function O(P) {
    A(Object.assign({ type: "spring", stiffness: l, damping: u, restDelta: c }, P));
  }
  if (x(e))
    O({ from: e, velocity: r, to: T(e) });
  else {
    let P = a * r + e;
    typeof f != "undefined" && (P = f(P));
    const j = T(P), k = j === t ? -1 : 1;
    let L, M;
    const W = (q) => {
      L = M, M = q, r = CR(q - L, RJ().delta), (k === 1 && q > j || k === -1 && q < j) && O({ from: q, to: j, velocity: r });
    };
    A({
      type: "decay",
      from: e,
      velocity: r,
      timeConstant: i,
      power: a,
      restDelta: c,
      modifyTarget: f,
      onUpdate: x(P) ? W : void 0
    });
  }
  return {
    stop: () => S == null ? void 0 : S.stop()
  };
}
const LS = (e) => e.hasOwnProperty("x") && e.hasOwnProperty("y"), KC = (e) => LS(e) && e.hasOwnProperty("z"), sh = (e, r) => Math.abs(e - r);
function ER(e, r) {
  if (jS(e) && jS(r))
    return sh(e, r);
  if (LS(e) && LS(r)) {
    const t = sh(e.x, r.x), n = sh(e.y, r.y), a = KC(e) && KC(r) ? sh(e.z, r.z) : 0;
    return Math.sqrt(Math.pow(t, 2) + Math.pow(n, 2) + Math.pow(a, 2));
  }
}
const AR = (e, r) => 1 - 3 * r + 3 * e, IR = (e, r) => 3 * r - 6 * e, OR = (e) => 3 * e, l0 = (e, r, t) => ((AR(r, t) * e + IR(r, t)) * e + OR(r)) * e, MR = (e, r, t) => 3 * AR(r, t) * e * e + 2 * IR(r, t) * e + OR(r), NJ = 1e-7, LJ = 10;
function FJ(e, r, t, n, a) {
  let i, l, u = 0;
  do
    l = r + (t - r) / 2, i = l0(l, n, a) - e, i > 0 ? t = l : r = l;
  while (Math.abs(i) > NJ && ++u < LJ);
  return l;
}
const zJ = 8, BJ = 1e-3;
function UJ(e, r, t, n) {
  for (let a = 0; a < zJ; ++a) {
    const i = MR(r, t, n);
    if (i === 0)
      return r;
    const l = l0(r, t, n) - e;
    r -= l / i;
  }
  return r;
}
const _p = 11, lh = 1 / (_p - 1);
function VJ(e, r, t, n) {
  if (e === r && t === n)
    return v$;
  const a = new Float32Array(_p);
  for (let l = 0; l < _p; ++l)
    a[l] = l0(l * lh, e, t);
  function i(l) {
    let u = 0, c = 1;
    const f = _p - 1;
    for (; c !== f && a[c] <= l; ++c)
      u += lh;
    --c;
    const h = (l - a[c]) / (a[c + 1] - a[c]), p = u + h * lh, g = MR(p, e, t);
    return g >= BJ ? UJ(l, p, e, t) : g === 0 ? p : FJ(l, u, u + lh, e, t);
  }
  return (l) => l === 0 || l === 1 ? l : l0(i(l), r, n);
}
function WJ(e) {
  var r = e.onTap, t = e.onTapStart, n = e.onTapCancel, a = e.whileTap, i = e.visualElement, l = r || t || n || a, u = Ze(!1), c = Ze(null), f = {
    passive: !(t || r || n || S)
  };
  function h() {
    var x;
    (x = c.current) === null || x === void 0 || x.call(c), c.current = null;
  }
  function p() {
    var x;
    return h(), u.current = !1, (x = i.animationState) === null || x === void 0 || x.setActive(nt.Tap, !1), !cR();
  }
  function g(x, T) {
    p() && (dR(i.getInstance(), x.target) ? r == null || r(x, T) : n == null || n(x, T));
  }
  function y(x, T) {
    p() && (n == null || n(x, T));
  }
  function S(x, T) {
    var A;
    h(), !u.current && (u.current = !0, c.current = mg(ic(window, "pointerup", g, f), ic(window, "pointercancel", y, f)), (A = i.animationState) === null || A === void 0 || A.setActive(nt.Tap, !0), t == null || t(x, T));
  }
  o0(i, "pointerdown", l ? S : void 0, f), c$(h);
}
var qC = /* @__PURE__ */ new Set();
function HJ(e, r, t) {
  e || qC.has(r) || (console.warn(r), t && console.warn(t), qC.add(r));
}
var FS = /* @__PURE__ */ new WeakMap(), qb = /* @__PURE__ */ new WeakMap(), GJ = function(e) {
  var r;
  (r = FS.get(e.target)) === null || r === void 0 || r(e);
}, YJ = function(e) {
  e.forEach(GJ);
};
function KJ(e) {
  var r = e.root, t = Ga(e, ["root"]), n = r || document;
  qb.has(n) || qb.set(n, {});
  var a = qb.get(n), i = JSON.stringify(t);
  return a[i] || (a[i] = new IntersectionObserver(YJ, de({ root: r }, t))), a[i];
}
function qJ(e, r, t) {
  var n = KJ(r);
  return FS.set(e, t), n.observe(e), function() {
    FS.delete(e), n.unobserve(e);
  };
}
function ZJ(e) {
  var r = e.visualElement, t = e.whileInView, n = e.onViewportEnter, a = e.onViewportLeave, i = e.viewport, l = i === void 0 ? {} : i, u = Ze({
    hasEnteredView: !1,
    isInView: !1
  }), c = !!(t || n || a);
  l.once && u.current.hasEnteredView && (c = !1);
  var f = typeof IntersectionObserver == "undefined" ? JJ : XJ;
  f(c, u.current, r, l);
}
var QJ = {
  some: 0,
  all: 1
};
function XJ(e, r, t, n) {
  var a = n.root, i = n.margin, l = n.amount, u = l === void 0 ? "some" : l, c = n.once;
  er(function() {
    if (e) {
      var f = {
        root: a == null ? void 0 : a.current,
        rootMargin: i,
        threshold: typeof u == "number" ? u : QJ[u]
      }, h = function(p) {
        var g, y = p.isIntersecting;
        if (r.isInView !== y && (r.isInView = y, !(c && !y && r.hasEnteredView))) {
          y && (r.hasEnteredView = !0), (g = t.animationState) === null || g === void 0 || g.setActive(nt.InView, y);
          var S = t.getProps(), x = y ? S.onViewportEnter : S.onViewportLeave;
          x == null || x(p);
        }
      };
      return qJ(t.getInstance(), f, h);
    }
  }, [e, a, i, u]);
}
function JJ(e, r, t, n) {
  var a = n.fallback, i = a === void 0 ? !0 : a;
  er(function() {
    !e || !i || (J2 !== "production" && HJ(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var l;
      r.hasEnteredView = !0;
      var u = t.getProps().onViewportEnter;
      u == null || u(null), (l = t.animationState) === null || l === void 0 || l.setActive(nt.InView, !0);
    }));
  }, [e]);
}
var Os = function(e) {
  return function(r) {
    return e(r), null;
  };
}, eee = {
  inView: Os(ZJ),
  tap: Os(WJ),
  focus: Os(OX),
  hover: Os(zX)
}, ree = 0, tee = function() {
  return ree++;
}, RR = function() {
  return Lf(tee);
};
function PR() {
  var e = Ur(Nf);
  if (e === null)
    return [!0, null];
  var r = e.isPresent, t = e.onExitComplete, n = e.register, a = RR();
  er(function() {
    return n(a);
  }, []);
  var i = function() {
    return t == null ? void 0 : t(a);
  };
  return !r && t ? [!1, i] : [!0];
}
function kR(e, r) {
  if (!Array.isArray(r))
    return !1;
  var t = r.length;
  if (t !== e.length)
    return !1;
  for (var n = 0; n < t; n++)
    if (r[n] !== e[n])
      return !1;
  return !0;
}
var u0 = function(e) {
  return e * 1e3;
}, nee = {
  linear: v$,
  easeIn: h$,
  easeInOut: yR,
  easeOut: cJ,
  circIn: SR,
  circInOut: dJ,
  circOut: p$,
  backIn: g$,
  backInOut: vJ,
  backOut: fJ,
  anticipate: hJ,
  bounceIn: bJ,
  bounceInOut: yJ,
  bounceOut: s0
}, ZC = function(e) {
  if (Array.isArray(e)) {
    r0(e.length === 4);
    var r = gt(e, 4), t = r[0], n = r[1], a = r[2], i = r[3];
    return VJ(t, n, a, i);
  } else if (typeof e == "string")
    return nee[e];
  return e;
}, aee = function(e) {
  return Array.isArray(e) && typeof e[0] != "number";
}, QC = function(e, r) {
  return e === "zIndex" ? !1 : !!(typeof r == "number" || Array.isArray(r) || typeof r == "string" && // It's animatable if we have a string
  Fi.test(r) && // And it contains numbers and/or colors
  !r.startsWith("url("));
}, wl = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, uh = function(e) {
  return {
    type: "spring",
    stiffness: 550,
    damping: e === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, Zb = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, oee = function(e) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: e
  };
}, XC = {
  x: wl,
  y: wl,
  z: wl,
  rotate: wl,
  rotateX: wl,
  rotateY: wl,
  rotateZ: wl,
  scaleX: uh,
  scaleY: uh,
  scale: uh,
  opacity: Zb,
  backgroundColor: Zb,
  color: Zb,
  default: uh
}, iee = function(e, r) {
  var t;
  return lf(r) ? t = oee : t = XC[e] || XC.default, de({ to: r }, t(r));
}, see = de(de({}, YM), {
  // Color props
  color: Mn,
  backgroundColor: Mn,
  outlineColor: Mn,
  fill: Mn,
  stroke: Mn,
  // Border props
  borderColor: Mn,
  borderTopColor: Mn,
  borderRightColor: Mn,
  borderBottomColor: Mn,
  borderLeftColor: Mn,
  filter: RS,
  WebkitFilter: RS
}), m$ = function(e) {
  return see[e];
};
function b$(e, r) {
  var t, n = m$(e);
  return n !== RS && (n = Fi), (t = n.getAnimatableNone) === null || t === void 0 ? void 0 : t.call(n, r);
}
function lee(e) {
  e.when, e.delay, e.delayChildren, e.staggerChildren, e.staggerDirection, e.repeat, e.repeatType, e.repeatDelay, e.from;
  var r = Ga(e, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(r).length;
}
function uee(e) {
  var r = e.ease, t = e.times, n = e.yoyo, a = e.flip, i = e.loop, l = Ga(e, ["ease", "times", "yoyo", "flip", "loop"]), u = de({}, l);
  return t && (u.offset = t), l.duration && (u.duration = u0(l.duration)), l.repeatDelay && (u.repeatDelay = u0(l.repeatDelay)), r && (u.ease = aee(r) ? r.map(ZC) : ZC(r)), l.type === "tween" && (u.type = "keyframes"), (n || i || a) && (n ? u.repeatType = "reverse" : i ? u.repeatType = "loop" : a && (u.repeatType = "mirror"), u.repeat = i || n || a || l.repeat), l.type !== "spring" && (u.type = "keyframes"), u;
}
function cee(e, r) {
  var t, n, a = y$(e, r) || {};
  return (n = (t = a.delay) !== null && t !== void 0 ? t : e.delay) !== null && n !== void 0 ? n : 0;
}
function dee(e) {
  return Array.isArray(e.to) && e.to[0] === null && (e.to = ba([], gt(e.to), !1), e.to[0] = e.from), e;
}
function fee(e, r, t) {
  var n;
  return Array.isArray(r.to) && ((n = e.duration) !== null && n !== void 0 || (e.duration = 0.8)), dee(r), lee(e) || (e = de(de({}, e), iee(t, r.to))), de(de({}, r), uee(e));
}
function vee(e, r, t, n, a) {
  var i, l = y$(n, e), u = (i = l.from) !== null && i !== void 0 ? i : r.get(), c = QC(e, t);
  u === "none" && c && typeof t == "string" ? u = b$(e, t) : JC(u) && typeof t == "string" ? u = e4(t) : !Array.isArray(t) && JC(t) && typeof u == "string" && (t = e4(u));
  var f = QC(e, u);
  function h() {
    var g = {
      from: u,
      to: t,
      velocity: r.getVelocity(),
      onComplete: a,
      onUpdate: function(y) {
        return r.set(y);
      }
    };
    return l.type === "inertia" || l.type === "decay" ? DJ(de(de({}, g), l)) : TR(de(de({}, fee(l, g, e)), { onUpdate: function(y) {
      var S;
      g.onUpdate(y), (S = l.onUpdate) === null || S === void 0 || S.call(l, y);
    }, onComplete: function() {
      var y;
      g.onComplete(), (y = l.onComplete) === null || y === void 0 || y.call(l);
    } }));
  }
  function p() {
    var g, y, S = tR(t);
    return r.set(S), a(), (g = l == null ? void 0 : l.onUpdate) === null || g === void 0 || g.call(l, S), (y = l == null ? void 0 : l.onComplete) === null || y === void 0 || y.call(l), { stop: function() {
    } };
  }
  return !f || !c || l.type === !1 ? p : h;
}
function JC(e) {
  return e === 0 || typeof e == "string" && parseFloat(e) === 0 && e.indexOf(" ") === -1;
}
function e4(e) {
  return typeof e == "number" ? 0 : b$("", e);
}
function y$(e, r) {
  return e[r] || e.default || e;
}
function S$(e, r, t, n) {
  return n === void 0 && (n = {}), r.start(function(a) {
    var i, l, u = vee(e, r, t, n, a), c = cee(n, e), f = function() {
      return l = u();
    };
    return c ? i = window.setTimeout(f, u0(c)) : f(), function() {
      clearTimeout(i), l == null || l.stop();
    };
  });
}
var hee = function(e) {
  return /^\-?\d*\.?\d+$/.test(e);
}, pee = function(e) {
  return /^0[^.\s]+$/.test(e);
};
const jR = 1 / 60 * 1e3, gee = typeof performance != "undefined" ? () => performance.now() : () => Date.now(), DR = typeof window != "undefined" ? (e) => window.requestAnimationFrame(e) : (e) => setTimeout(() => e(gee()), jR);
function mee(e) {
  let r = [], t = [], n = 0, a = !1, i = !1;
  const l = /* @__PURE__ */ new WeakSet(), u = {
    schedule: (c, f = !1, h = !1) => {
      const p = h && a, g = p ? r : t;
      return f && l.add(c), g.indexOf(c) === -1 && (g.push(c), p && a && (n = r.length)), c;
    },
    cancel: (c) => {
      const f = t.indexOf(c);
      f !== -1 && t.splice(f, 1), l.delete(c);
    },
    process: (c) => {
      if (a) {
        i = !0;
        return;
      }
      if (a = !0, [r, t] = [t, r], t.length = 0, n = r.length, n)
        for (let f = 0; f < n; f++) {
          const h = r[f];
          h(c), l.has(h) && (u.schedule(h), e());
        }
      a = !1, i && (i = !1, u.process(c));
    }
  };
  return u;
}
const bee = 40;
let zS = !0, df = !1, BS = !1;
const lc = {
  delta: 0,
  timestamp: 0
}, Vf = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], Sg = Vf.reduce((e, r) => (e[r] = mee(() => df = !0), e), {}), ni = Vf.reduce((e, r) => {
  const t = Sg[r];
  return e[r] = (n, a = !1, i = !1) => (df || See(), t.schedule(n, a, i)), e;
}, {}), ff = Vf.reduce((e, r) => (e[r] = Sg[r].cancel, e), {}), Qb = Vf.reduce((e, r) => (e[r] = () => Sg[r].process(lc), e), {}), yee = (e) => Sg[e].process(lc), NR = (e) => {
  df = !1, lc.delta = zS ? jR : Math.max(Math.min(e - lc.timestamp, bee), 1), lc.timestamp = e, BS = !0, Vf.forEach(yee), BS = !1, df && (zS = !1, DR(NR));
}, See = () => {
  df = !0, zS = !0, BS || DR(NR);
}, US = () => lc;
function x$(e, r) {
  e.indexOf(r) === -1 && e.push(r);
}
function $$(e, r) {
  var t = e.indexOf(r);
  t > -1 && e.splice(t, 1);
}
var Rd = (
  /** @class */
  function() {
    function e() {
      this.subscriptions = [];
    }
    return e.prototype.add = function(r) {
      var t = this;
      return x$(this.subscriptions, r), function() {
        return $$(t.subscriptions, r);
      };
    }, e.prototype.notify = function(r, t, n) {
      var a = this.subscriptions.length;
      if (a)
        if (a === 1)
          this.subscriptions[0](r, t, n);
        else
          for (var i = 0; i < a; i++) {
            var l = this.subscriptions[i];
            l && l(r, t, n);
          }
    }, e.prototype.getSize = function() {
      return this.subscriptions.length;
    }, e.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, e;
  }()
), xee = function(e) {
  return !isNaN(parseFloat(e));
}, $ee = (
  /** @class */
  function() {
    function e(r) {
      var t = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new Rd(), this.velocityUpdateSubscribers = new Rd(), this.renderSubscribers = new Rd(), this.canTrackVelocity = !1, this.updateAndNotify = function(n, a) {
        a === void 0 && (a = !0), t.prev = t.current, t.current = n;
        var i = US(), l = i.delta, u = i.timestamp;
        t.lastUpdated !== u && (t.timeDelta = l, t.lastUpdated = u, ni.postRender(t.scheduleVelocityCheck)), t.prev !== t.current && t.updateSubscribers.notify(t.current), t.velocityUpdateSubscribers.getSize() && t.velocityUpdateSubscribers.notify(t.getVelocity()), a && t.renderSubscribers.notify(t.current);
      }, this.scheduleVelocityCheck = function() {
        return ni.postRender(t.velocityCheck);
      }, this.velocityCheck = function(n) {
        var a = n.timestamp;
        a !== t.lastUpdated && (t.prev = t.current, t.velocityUpdateSubscribers.notify(t.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = r, this.canTrackVelocity = xee(this.current);
    }
    return e.prototype.onChange = function(r) {
      return this.updateSubscribers.add(r);
    }, e.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, e.prototype.onRenderRequest = function(r) {
      return r(this.get()), this.renderSubscribers.add(r);
    }, e.prototype.attach = function(r) {
      this.passiveEffect = r;
    }, e.prototype.set = function(r, t) {
      t === void 0 && (t = !0), !t || !this.passiveEffect ? this.updateAndNotify(r, t) : this.passiveEffect(r, this.updateAndNotify);
    }, e.prototype.get = function() {
      return this.current;
    }, e.prototype.getPrevious = function() {
      return this.prev;
    }, e.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        CR(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, e.prototype.start = function(r) {
      var t = this;
      return this.stop(), new Promise(function(n) {
        t.hasAnimated = !0, t.stopAnimation = r(n);
      }).then(function() {
        return t.clearAnimation();
      });
    }, e.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, e.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, e.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, e.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, e;
  }()
);
function mc(e) {
  return new $ee(e);
}
var LR = function(e) {
  return function(r) {
    return r.test(e);
  };
}, wee = {
  test: function(e) {
    return e === "auto";
  },
  parse: function(e) {
    return e;
  }
}, FR = [su, Ge, ti, Ts, tX, rX, wee], nd = function(e) {
  return FR.find(LR(e));
}, _ee = ba(ba([], gt(FR), !1), [Mn, Fi], !1), Tee = function(e) {
  return _ee.find(LR(e));
};
function Cee(e, r, t) {
  e.hasValue(r) ? e.getValue(r).set(t) : e.addValue(r, mc(t));
}
function Eee(e, r) {
  var t = hg(e, r), n = t ? e.makeTargetAnimatable(t, !1) : {}, a = n.transitionEnd, i = a === void 0 ? {} : a;
  n.transition;
  var l = Ga(n, ["transitionEnd", "transition"]);
  l = de(de({}, l), i);
  for (var u in l) {
    var c = tR(l[u]);
    Cee(e, u, c);
  }
}
function Aee(e, r, t) {
  var n, a, i, l, u = Object.keys(r).filter(function(y) {
    return !e.hasValue(y);
  }), c = u.length;
  if (c)
    for (var f = 0; f < c; f++) {
      var h = u[f], p = r[h], g = null;
      Array.isArray(p) && (g = p[0]), g === null && (g = (a = (n = t[h]) !== null && n !== void 0 ? n : e.readValue(h)) !== null && a !== void 0 ? a : r[h]), g != null && (typeof g == "string" && (hee(g) || pee(g)) ? g = parseFloat(g) : !Tee(g) && Fi.test(p) && (g = b$(h, p)), e.addValue(h, mc(g)), (i = (l = t)[h]) !== null && i !== void 0 || (l[h] = g), e.setBaseTarget(h, g));
    }
}
function Iee(e, r) {
  if (r) {
    var t = r[e] || r.default || r;
    return t.from;
  }
}
function Oee(e, r, t) {
  var n, a, i = {};
  for (var l in e)
    i[l] = (n = Iee(l, r)) !== null && n !== void 0 ? n : (a = t.getValue(l)) === null || a === void 0 ? void 0 : a.get();
  return i;
}
function Mee(e, r, t) {
  t === void 0 && (t = {}), e.notifyAnimationStart(r);
  var n;
  if (Array.isArray(r)) {
    var a = r.map(function(l) {
      return VS(e, l, t);
    });
    n = Promise.all(a);
  } else if (typeof r == "string")
    n = VS(e, r, t);
  else {
    var i = typeof r == "function" ? hg(e, r, t.custom) : r;
    n = zR(e, i, t);
  }
  return n.then(function() {
    return e.notifyAnimationComplete(r);
  });
}
function VS(e, r, t) {
  var n;
  t === void 0 && (t = {});
  var a = hg(e, r, t.custom), i = (a || {}).transition, l = i === void 0 ? e.getDefaultTransition() || {} : i;
  t.transitionOverride && (l = t.transitionOverride);
  var u = a ? function() {
    return zR(e, a, t);
  } : function() {
    return Promise.resolve();
  }, c = !((n = e.variantChildren) === null || n === void 0) && n.size ? function(y) {
    y === void 0 && (y = 0);
    var S = l.delayChildren, x = S === void 0 ? 0 : S, T = l.staggerChildren, A = l.staggerDirection;
    return Ree(e, r, x + y, T, A, t);
  } : function() {
    return Promise.resolve();
  }, f = l.when;
  if (f) {
    var h = gt(f === "beforeChildren" ? [u, c] : [c, u], 2), p = h[0], g = h[1];
    return p().then(g);
  } else
    return Promise.all([u(), c(t.delay)]);
}
function zR(e, r, t) {
  var n, a = t === void 0 ? {} : t, i = a.delay, l = i === void 0 ? 0 : i, u = a.transitionOverride, c = a.type, f = e.makeTargetAnimatable(r), h = f.transition, p = h === void 0 ? e.getDefaultTransition() : h, g = f.transitionEnd, y = Ga(f, ["transition", "transitionEnd"]);
  u && (p = u);
  var S = [], x = c && ((n = e.animationState) === null || n === void 0 ? void 0 : n.getState()[c]);
  for (var T in y) {
    var A = e.getValue(T), O = y[T];
    if (!(!A || O === void 0 || x && kee(x, T))) {
      var P = de({ delay: l }, p);
      e.shouldReduceMotion && Ff(T) && (P = de(de({}, P), { type: !1, delay: 0 }));
      var j = S$(T, A, O, P);
      S.push(j);
    }
  }
  return Promise.all(S).then(function() {
    g && Eee(e, g);
  });
}
function Ree(e, r, t, n, a, i) {
  t === void 0 && (t = 0), n === void 0 && (n = 0), a === void 0 && (a = 1);
  var l = [], u = (e.variantChildren.size - 1) * n, c = a === 1 ? function(f) {
    return f === void 0 && (f = 0), f * n;
  } : function(f) {
    return f === void 0 && (f = 0), u - f * n;
  };
  return Array.from(e.variantChildren).sort(Pee).forEach(function(f, h) {
    l.push(VS(f, r, de(de({}, i), { delay: t + c(h) })).then(function() {
      return f.notifyAnimationComplete(r);
    }));
  }), Promise.all(l);
}
function Pee(e, r) {
  return e.sortNodePosition(r);
}
function kee(e, r) {
  var t = e.protectedKeys, n = e.needsAnimating, a = t.hasOwnProperty(r) && n[r] !== !0;
  return n[r] = !1, a;
}
var w$ = [
  nt.Animate,
  nt.InView,
  nt.Focus,
  nt.Hover,
  nt.Tap,
  nt.Drag,
  nt.Exit
], jee = ba([], gt(w$), !1).reverse(), Dee = w$.length;
function Nee(e) {
  return function(r) {
    return Promise.all(r.map(function(t) {
      var n = t.animation, a = t.options;
      return Mee(e, n, a);
    }));
  };
}
function Lee(e) {
  var r = Nee(e), t = zee(), n = {}, a = !0, i = function(h, p) {
    var g = hg(e, p);
    if (g) {
      g.transition;
      var y = g.transitionEnd, S = Ga(g, ["transition", "transitionEnd"]);
      h = de(de(de({}, h), S), y);
    }
    return h;
  };
  function l(h) {
    return n[h] !== void 0;
  }
  function u(h) {
    r = h(e);
  }
  function c(h, p) {
    for (var g, y = e.getProps(), S = e.getVariantContext(!0) || {}, x = [], T = /* @__PURE__ */ new Set(), A = {}, O = 1 / 0, P = function(M) {
      var W = jee[M], q = t[W], oe = (g = y[W]) !== null && g !== void 0 ? g : S[W], Ae = bo(oe), Te = W === p ? q.isActive : null;
      Te === !1 && (O = M);
      var $e = oe === S[W] && oe !== y[W] && Ae;
      if ($e && a && e.manuallyAnimateOnMount && ($e = !1), q.protectedKeys = de({}, A), // If it isn't active and hasn't *just* been set as inactive
      !q.isActive && Te === null || // If we didn't and don't have any defined prop for this animation type
      !oe && !q.prevProp || // Or if the prop doesn't define an animation
      l$(oe) || typeof oe == "boolean")
        return "continue";
      var Ee = Fee(q.prevProp, oe), ze = Ee || // If we're making this variant active, we want to always make it active
      W === p && q.isActive && !$e && Ae || // If we removed a higher-priority variant (i is in reverse order)
      M > O && Ae, Ke = Array.isArray(oe) ? oe : [oe], Be = Ke.reduce(i, {});
      Te === !1 && (Be = {});
      var ue = q.prevResolvedValues, he = ue === void 0 ? {} : ue, _e = de(de({}, he), Be), Oe = function(te) {
        ze = !0, T.delete(te), q.needsAnimating[te] = !0;
      };
      for (var Me in _e) {
        var Z = Be[Me], se = he[Me];
        A.hasOwnProperty(Me) || (Z !== se ? lf(Z) && lf(se) ? !kR(Z, se) || Ee ? Oe(Me) : q.protectedKeys[Me] = !0 : Z !== void 0 ? Oe(Me) : T.add(Me) : Z !== void 0 && T.has(Me) ? Oe(Me) : q.protectedKeys[Me] = !0);
      }
      q.prevProp = oe, q.prevResolvedValues = Be, q.isActive && (A = de(de({}, A), Be)), a && e.blockInitialAnimation && (ze = !1), ze && !$e && x.push.apply(x, ba([], gt(Ke.map(function(te) {
        return {
          animation: te,
          options: de({ type: W }, h)
        };
      })), !1));
    }, j = 0; j < Dee; j++)
      P(j);
    if (n = de({}, A), T.size) {
      var k = {};
      T.forEach(function(M) {
        var W = e.getBaseTarget(M);
        W !== void 0 && (k[M] = W);
      }), x.push({ animation: k });
    }
    var L = !!x.length;
    return a && y.initial === !1 && !e.manuallyAnimateOnMount && (L = !1), a = !1, L ? r(x) : Promise.resolve();
  }
  function f(h, p, g) {
    var y;
    if (t[h].isActive === p)
      return Promise.resolve();
    (y = e.variantChildren) === null || y === void 0 || y.forEach(function(T) {
      var A;
      return (A = T.animationState) === null || A === void 0 ? void 0 : A.setActive(h, p);
    }), t[h].isActive = p;
    var S = c(g, h);
    for (var x in t)
      t[x].protectedKeys = {};
    return S;
  }
  return {
    isAnimated: l,
    animateChanges: c,
    setActive: f,
    setAnimateFunction: u,
    getState: function() {
      return t;
    }
  };
}
function Fee(e, r) {
  return typeof r == "string" ? r !== e : PM(r) ? !kR(r, e) : !1;
}
function _l(e) {
  return e === void 0 && (e = !1), {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function zee() {
  var e;
  return e = {}, e[nt.Animate] = _l(!0), e[nt.InView] = _l(), e[nt.Hover] = _l(), e[nt.Tap] = _l(), e[nt.Drag] = _l(), e[nt.Focus] = _l(), e[nt.Exit] = _l(), e;
}
var Bee = {
  animation: Os(function(e) {
    var r = e.visualElement, t = e.animate;
    r.animationState || (r.animationState = Lee(r)), l$(t) && er(function() {
      return t.subscribe(r);
    }, [t]);
  }),
  exit: Os(function(e) {
    var r = e.custom, t = e.visualElement, n = gt(PR(), 2), a = n[0], i = n[1], l = Ur(Nf);
    er(function() {
      var u, c;
      t.isPresent = a;
      var f = (u = t.animationState) === null || u === void 0 ? void 0 : u.setActive(nt.Exit, !a, { custom: (c = l == null ? void 0 : l.custom) !== null && c !== void 0 ? c : r });
      !a && (f == null || f.then(i));
    }, [a]);
  })
}, BR = (
  /** @class */
  function() {
    function e(r, t, n) {
      var a = this, i = n === void 0 ? {} : n, l = i.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (a.lastMoveEvent && a.lastMoveEventInfo) {
          var g = Jb(a.lastMoveEventInfo, a.history), y = a.startEvent !== null, S = ER(g.offset, { x: 0, y: 0 }) >= 3;
          if (!(!y && !S)) {
            var x = g.point, T = US().timestamp;
            a.history.push(de(de({}, x), { timestamp: T }));
            var A = a.handlers, O = A.onStart, P = A.onMove;
            y || (O && O(a.lastMoveEvent, g), a.startEvent = a.lastMoveEvent), P && P(a.lastMoveEvent, g);
          }
        }
      }, this.handlePointerMove = function(g, y) {
        if (a.lastMoveEvent = g, a.lastMoveEventInfo = Xb(y, a.transformPagePoint), aR(g) && g.buttons === 0) {
          a.handlePointerUp(g, y);
          return;
        }
        ni.update(a.updatePoint, !0);
      }, this.handlePointerUp = function(g, y) {
        a.end();
        var S = a.handlers, x = S.onEnd, T = S.onSessionEnd, A = Jb(Xb(y, a.transformPagePoint), a.history);
        a.startEvent && x && x(g, A), T && T(g, A);
      }, !(oR(r) && r.touches.length > 1)) {
        this.handlers = t, this.transformPagePoint = l;
        var u = u$(r), c = Xb(u, this.transformPagePoint), f = c.point, h = US().timestamp;
        this.history = [de(de({}, f), { timestamp: h })];
        var p = t.onSessionStart;
        p && p(r, Jb(c, this.history)), this.removeListeners = mg(ic(window, "pointermove", this.handlePointerMove), ic(window, "pointerup", this.handlePointerUp), ic(window, "pointercancel", this.handlePointerUp));
      }
    }
    return e.prototype.updateHandlers = function(r) {
      this.handlers = r;
    }, e.prototype.end = function() {
      this.removeListeners && this.removeListeners(), ff.update(this.updatePoint);
    }, e;
  }()
);
function Xb(e, r) {
  return r ? { point: r(e.point) } : e;
}
function r4(e, r) {
  return { x: e.x - r.x, y: e.y - r.y };
}
function Jb(e, r) {
  var t = e.point;
  return {
    point: t,
    delta: r4(t, UR(r)),
    offset: r4(t, Uee(r)),
    velocity: Vee(r, 0.1)
  };
}
function Uee(e) {
  return e[0];
}
function UR(e) {
  return e[e.length - 1];
}
function Vee(e, r) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  for (var t = e.length - 1, n = null, a = UR(e); t >= 0 && (n = e[t], !(a.timestamp - n.timestamp > u0(r))); )
    t--;
  if (!n)
    return { x: 0, y: 0 };
  var i = (a.timestamp - n.timestamp) / 1e3;
  if (i === 0)
    return { x: 0, y: 0 };
  var l = {
    x: (a.x - n.x) / i,
    y: (a.y - n.y) / i
  };
  return l.x === 1 / 0 && (l.x = 0), l.y === 1 / 0 && (l.y = 0), l;
}
function zi(e) {
  return e.max - e.min;
}
function t4(e, r, t) {
  return r === void 0 && (r = 0), t === void 0 && (t = 0.01), ER(e, r) < t;
}
function n4(e, r, t, n) {
  n === void 0 && (n = 0.5), e.origin = n, e.originPoint = Tt(r.min, r.max, e.origin), e.scale = zi(t) / zi(r), (t4(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = Tt(t.min, t.max, e.origin) - e.originPoint, (t4(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function Pd(e, r, t, n) {
  n4(e.x, r.x, t.x, n == null ? void 0 : n.originX), n4(e.y, r.y, t.y, n == null ? void 0 : n.originY);
}
function a4(e, r, t) {
  e.min = t.min + r.min, e.max = e.min + zi(r);
}
function Wee(e, r, t) {
  a4(e.x, r.x, t.x), a4(e.y, r.y, t.y);
}
function o4(e, r, t) {
  e.min = r.min - t.min, e.max = e.min + zi(r);
}
function kd(e, r, t) {
  o4(e.x, r.x, t.x), o4(e.y, r.y, t.y);
}
function Hee(e, r, t) {
  var n = r.min, a = r.max;
  return n !== void 0 && e < n ? e = t ? Tt(n, e, t.min) : Math.max(e, n) : a !== void 0 && e > a && (e = t ? Tt(a, e, t.max) : Math.min(e, a)), e;
}
function i4(e, r, t) {
  return {
    min: r !== void 0 ? e.min + r : void 0,
    max: t !== void 0 ? e.max + t - (e.max - e.min) : void 0
  };
}
function Gee(e, r) {
  var t = r.top, n = r.left, a = r.bottom, i = r.right;
  return {
    x: i4(e.x, n, i),
    y: i4(e.y, t, a)
  };
}
function s4(e, r) {
  var t, n = r.min - e.min, a = r.max - e.max;
  return r.max - r.min < e.max - e.min && (t = gt([a, n], 2), n = t[0], a = t[1]), { min: n, max: a };
}
function Yee(e, r) {
  return {
    x: s4(e.x, r.x),
    y: s4(e.y, r.y)
  };
}
function Kee(e, r) {
  var t = 0.5, n = zi(e), a = zi(r);
  return a > n ? t = uf(r.min, r.max - n, e.min) : n > a && (t = uf(e.min, e.max - a, r.min)), i0(0, 1, t);
}
function qee(e, r) {
  var t = {};
  return r.min !== void 0 && (t.min = r.min - e.min), r.max !== void 0 && (t.max = r.max - e.min), t;
}
var WS = 0.35;
function Zee(e) {
  return e === void 0 && (e = WS), e === !1 ? e = 0 : e === !0 && (e = WS), {
    x: l4(e, "left", "right"),
    y: l4(e, "top", "bottom")
  };
}
function l4(e, r, t) {
  return {
    min: u4(e, r),
    max: u4(e, t)
  };
}
function u4(e, r) {
  var t;
  return typeof e == "number" ? e : (t = e[r]) !== null && t !== void 0 ? t : 0;
}
var c4 = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, jd = function() {
  return {
    x: c4(),
    y: c4()
  };
}, d4 = function() {
  return { min: 0, max: 0 };
}, Tn = function() {
  return {
    x: d4(),
    y: d4()
  };
};
function Yo(e) {
  return [e("x"), e("y")];
}
function VR(e) {
  var r = e.top, t = e.left, n = e.right, a = e.bottom;
  return {
    x: { min: t, max: n },
    y: { min: r, max: a }
  };
}
function Qee(e) {
  var r = e.x, t = e.y;
  return { top: t.min, right: r.max, bottom: t.max, left: r.min };
}
function Xee(e, r) {
  if (!r)
    return e;
  var t = r({ x: e.left, y: e.top }), n = r({ x: e.right, y: e.bottom });
  return {
    top: t.y,
    left: t.x,
    bottom: n.y,
    right: n.x
  };
}
function e1(e) {
  return e === void 0 || e === 1;
}
function WR(e) {
  var r = e.scale, t = e.scaleX, n = e.scaleY;
  return !e1(r) || !e1(t) || !e1(n);
}
function Cs(e) {
  return WR(e) || f4(e.x) || f4(e.y) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function f4(e) {
  return e && e !== "0%";
}
function c0(e, r, t) {
  var n = e - t, a = r * n;
  return t + a;
}
function v4(e, r, t, n, a) {
  return a !== void 0 && (e = c0(e, a, n)), c0(e, t, n) + r;
}
function HS(e, r, t, n, a) {
  r === void 0 && (r = 0), t === void 0 && (t = 1), e.min = v4(e.min, r, t, n, a), e.max = v4(e.max, r, t, n, a);
}
function HR(e, r) {
  var t = r.x, n = r.y;
  HS(e.x, t.translate, t.scale, t.originPoint), HS(e.y, n.translate, n.scale, n.originPoint);
}
function Jee(e, r, t, n) {
  var a, i;
  n === void 0 && (n = !1);
  var l = t.length;
  if (l) {
    r.x = r.y = 1;
    for (var u, c, f = 0; f < l; f++)
      u = t[f], c = u.projectionDelta, ((i = (a = u.instance) === null || a === void 0 ? void 0 : a.style) === null || i === void 0 ? void 0 : i.display) !== "contents" && (n && u.options.layoutScroll && u.scroll && u !== u.root && Ku(e, { x: -u.scroll.x, y: -u.scroll.y }), c && (r.x *= c.x.scale, r.y *= c.y.scale, HR(e, c)), n && Cs(u.latestValues) && Ku(e, u.latestValues));
  }
}
function Es(e, r) {
  e.min = e.min + r, e.max = e.max + r;
}
function h4(e, r, t) {
  var n = gt(t, 3), a = n[0], i = n[1], l = n[2], u = r[l] !== void 0 ? r[l] : 0.5, c = Tt(e.min, e.max, u);
  HS(e, r[a], r[i], c, r.scale);
}
var ere = ["x", "scaleX", "originX"], rre = ["y", "scaleY", "originY"];
function Ku(e, r) {
  h4(e.x, r, ere), h4(e.y, r, rre);
}
function GR(e, r) {
  return VR(Xee(e.getBoundingClientRect(), r));
}
function tre(e, r, t) {
  var n = GR(e, t), a = r.scroll;
  return a && (Es(n.x, a.x), Es(n.y, a.y)), n;
}
var nre = /* @__PURE__ */ new WeakMap(), are = (
  /** @class */
  function() {
    function e(r) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Tn(), this.visualElement = r;
    }
    return e.prototype.start = function(r, t) {
      var n = this, a = t === void 0 ? {} : t, i = a.snapToCursor, l = i === void 0 ? !1 : i;
      if (this.visualElement.isPresent !== !1) {
        var u = function(p) {
          n.stopAnimation(), l && n.snapToCursor(u$(p, "page").point);
        }, c = function(p, g) {
          var y, S = n.getProps(), x = S.drag, T = S.dragPropagation, A = S.onDragStart;
          x && !T && (n.openGlobalLock && n.openGlobalLock(), n.openGlobalLock = uR(x), !n.openGlobalLock) || (n.isDragging = !0, n.currentDirection = null, n.resolveConstraints(), n.visualElement.projection && (n.visualElement.projection.isAnimationBlocked = !0, n.visualElement.projection.target = void 0), Yo(function(O) {
            var P, j, k = n.getAxisMotionValue(O).get() || 0;
            if (ti.test(k)) {
              var L = (j = (P = n.visualElement.projection) === null || P === void 0 ? void 0 : P.layout) === null || j === void 0 ? void 0 : j.actual[O];
              if (L) {
                var M = zi(L);
                k = M * (parseFloat(k) / 100);
              }
            }
            n.originPoint[O] = k;
          }), A == null || A(p, g), (y = n.visualElement.animationState) === null || y === void 0 || y.setActive(nt.Drag, !0));
        }, f = function(p, g) {
          var y = n.getProps(), S = y.dragPropagation, x = y.dragDirectionLock, T = y.onDirectionLock, A = y.onDrag;
          if (!(!S && !n.openGlobalLock)) {
            var O = g.offset;
            if (x && n.currentDirection === null) {
              n.currentDirection = ore(O), n.currentDirection !== null && (T == null || T(n.currentDirection));
              return;
            }
            n.updateAxis("x", g.point, O), n.updateAxis("y", g.point, O), n.visualElement.syncRender(), A == null || A(p, g);
          }
        }, h = function(p, g) {
          return n.stop(p, g);
        };
        this.panSession = new BR(r, {
          onSessionStart: u,
          onStart: c,
          onMove: f,
          onSessionEnd: h
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, e.prototype.stop = function(r, t) {
      var n = this.isDragging;
      if (this.cancel(), !!n) {
        var a = t.velocity;
        this.startAnimation(a);
        var i = this.getProps().onDragEnd;
        i == null || i(r, t);
      }
    }, e.prototype.cancel = function() {
      var r, t;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (r = this.panSession) === null || r === void 0 || r.end(), this.panSession = void 0;
      var n = this.getProps().dragPropagation;
      !n && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (t = this.visualElement.animationState) === null || t === void 0 || t.setActive(nt.Drag, !1);
    }, e.prototype.updateAxis = function(r, t, n) {
      var a = this.getProps().drag;
      if (!(!n || !ch(r, a, this.currentDirection))) {
        var i = this.getAxisMotionValue(r), l = this.originPoint[r] + n[r];
        this.constraints && this.constraints[r] && (l = Hee(l, this.constraints[r], this.elastic[r])), i.set(l);
      }
    }, e.prototype.resolveConstraints = function() {
      var r = this, t = this.getProps(), n = t.dragConstraints, a = t.dragElastic, i = (this.visualElement.projection || {}).layout, l = this.constraints;
      n && Yu(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && i ? this.constraints = Gee(i.actual, n) : this.constraints = !1, this.elastic = Zee(a), l !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && Yo(function(u) {
        r.getAxisMotionValue(u) && (r.constraints[u] = qee(i.actual[u], r.constraints[u]));
      });
    }, e.prototype.resolveRefConstraints = function() {
      var r = this.getProps(), t = r.dragConstraints, n = r.onMeasureDragConstraints;
      if (!t || !Yu(t))
        return !1;
      var a = t.current, i = this.visualElement.projection;
      if (!i || !i.layout)
        return !1;
      var l = tre(a, i.root, this.visualElement.getTransformPagePoint()), u = Yee(i.layout.actual, l);
      if (n) {
        var c = n(Qee(u));
        this.hasMutatedConstraints = !!c, c && (u = VR(c));
      }
      return u;
    }, e.prototype.startAnimation = function(r) {
      var t = this, n = this.getProps(), a = n.drag, i = n.dragMomentum, l = n.dragElastic, u = n.dragTransition, c = n.dragSnapToOrigin, f = n.onDragTransitionEnd, h = this.constraints || {}, p = Yo(function(g) {
        var y;
        if (ch(g, a, t.currentDirection)) {
          var S = (y = h == null ? void 0 : h[g]) !== null && y !== void 0 ? y : {};
          c && (S = { min: 0, max: 0 });
          var x = l ? 200 : 1e6, T = l ? 40 : 1e7, A = de(de({ type: "inertia", velocity: i ? r[g] : 0, bounceStiffness: x, bounceDamping: T, timeConstant: 750, restDelta: 1, restSpeed: 10 }, u), S);
          return t.startAxisValueAnimation(g, A);
        }
      });
      return Promise.all(p).then(f);
    }, e.prototype.startAxisValueAnimation = function(r, t) {
      var n = this.getAxisMotionValue(r);
      return S$(r, n, 0, t);
    }, e.prototype.stopAnimation = function() {
      var r = this;
      Yo(function(t) {
        return r.getAxisMotionValue(t).stop();
      });
    }, e.prototype.getAxisMotionValue = function(r) {
      var t, n, a = "_drag" + r.toUpperCase(), i = this.visualElement.getProps()[a];
      return i || this.visualElement.getValue(r, (n = (t = this.visualElement.getProps().initial) === null || t === void 0 ? void 0 : t[r]) !== null && n !== void 0 ? n : 0);
    }, e.prototype.snapToCursor = function(r) {
      var t = this;
      Yo(function(n) {
        var a = t.getProps().drag;
        if (ch(n, a, t.currentDirection)) {
          var i = t.visualElement.projection, l = t.getAxisMotionValue(n);
          if (i && i.layout) {
            var u = i.layout.actual[n], c = u.min, f = u.max;
            l.set(r[n] - Tt(c, f, 0.5));
          }
        }
      });
    }, e.prototype.scalePositionWithinConstraints = function() {
      var r = this, t, n = this.getProps(), a = n.drag, i = n.dragConstraints, l = this.visualElement.projection;
      if (!(!Yu(i) || !l || !this.constraints)) {
        this.stopAnimation();
        var u = { x: 0, y: 0 };
        Yo(function(f) {
          var h = r.getAxisMotionValue(f);
          if (h) {
            var p = h.get();
            u[f] = Kee({ min: p, max: p }, r.constraints[f]);
          }
        });
        var c = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = c ? c({}, "") : "none", (t = l.root) === null || t === void 0 || t.updateScroll(), l.updateLayout(), this.resolveConstraints(), Yo(function(f) {
          if (ch(f, a, null)) {
            var h = r.getAxisMotionValue(f), p = r.constraints[f], g = p.min, y = p.max;
            h.set(Tt(g, y, u[f]));
          }
        });
      }
    }, e.prototype.addListeners = function() {
      var r = this, t;
      nre.set(this.visualElement, this);
      var n = this.visualElement.getInstance(), a = ic(n, "pointerdown", function(f) {
        var h = r.getProps(), p = h.drag, g = h.dragListener, y = g === void 0 ? !0 : g;
        p && y && r.start(f);
      }), i = function() {
        var f = r.getProps().dragConstraints;
        Yu(f) && (r.constraints = r.resolveRefConstraints());
      }, l = this.visualElement.projection, u = l.addEventListener("measure", i);
      l && !l.layout && ((t = l.root) === null || t === void 0 || t.updateScroll(), l.updateLayout()), i();
      var c = gg(window, "resize", function() {
        return r.scalePositionWithinConstraints();
      });
      return l.addEventListener("didUpdate", function(f) {
        var h = f.delta, p = f.hasLayoutChanged;
        r.isDragging && p && (Yo(function(g) {
          var y = r.getAxisMotionValue(g);
          y && (r.originPoint[g] += h[g].translate, y.set(y.get() + h[g].translate));
        }), r.visualElement.syncRender());
      }), function() {
        c(), a(), u();
      };
    }, e.prototype.getProps = function() {
      var r = this.visualElement.getProps(), t = r.drag, n = t === void 0 ? !1 : t, a = r.dragDirectionLock, i = a === void 0 ? !1 : a, l = r.dragPropagation, u = l === void 0 ? !1 : l, c = r.dragConstraints, f = c === void 0 ? !1 : c, h = r.dragElastic, p = h === void 0 ? WS : h, g = r.dragMomentum, y = g === void 0 ? !0 : g;
      return de(de({}, r), { drag: n, dragDirectionLock: i, dragPropagation: u, dragConstraints: f, dragElastic: p, dragMomentum: y });
    }, e;
  }()
);
function ch(e, r, t) {
  return (r === !0 || r === e) && (t === null || t === e);
}
function ore(e, r) {
  r === void 0 && (r = 10);
  var t = null;
  return Math.abs(e.y) > r ? t = "y" : Math.abs(e.x) > r && (t = "x"), t;
}
function ire(e) {
  var r = e.dragControls, t = e.visualElement, n = Lf(function() {
    return new are(t);
  });
  er(function() {
    return r && r.subscribe(n);
  }, [n, r]), er(function() {
    return n.addListeners();
  }, [n]);
}
function sre(e) {
  var r = e.onPan, t = e.onPanStart, n = e.onPanEnd, a = e.onPanSessionStart, i = e.visualElement, l = r || t || n || a, u = Ze(null), c = Ur(e$).transformPagePoint, f = {
    onSessionStart: a,
    onStart: t,
    onMove: r,
    onEnd: function(p, g) {
      u.current = null, n && n(p, g);
    }
  };
  er(function() {
    u.current !== null && u.current.updateHandlers(f);
  });
  function h(p) {
    u.current = new BR(p, f, {
      transformPagePoint: c
    });
  }
  o0(i, "pointerdown", l && h), c$(function() {
    return u.current && u.current.end();
  });
}
var lre = {
  pan: Os(sre),
  drag: Os(ire)
}, dh = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function ure() {
  var e = dh.map(function() {
    return new Rd();
  }), r = {}, t = {
    clearAllListeners: function() {
      return e.forEach(function(n) {
        return n.clear();
      });
    },
    updatePropListeners: function(n) {
      dh.forEach(function(a) {
        var i, l = "on" + a, u = n[l];
        (i = r[a]) === null || i === void 0 || i.call(r), u && (r[a] = t[l](u));
      });
    }
  };
  return e.forEach(function(n, a) {
    t["on" + dh[a]] = function(i) {
      return n.add(i);
    }, t["notify" + dh[a]] = function() {
      for (var i = [], l = 0; l < arguments.length; l++)
        i[l] = arguments[l];
      return n.notify.apply(n, ba([], gt(i), !1));
    };
  }), t;
}
function cre(e, r, t) {
  var n;
  for (var a in r) {
    var i = r[a], l = t[a];
    if (Li(i))
      e.addValue(a, i);
    else if (Li(l))
      e.addValue(a, mc(i));
    else if (l !== i)
      if (e.hasValue(a)) {
        var u = e.getValue(a);
        !u.hasAnimated && u.set(i);
      } else
        e.addValue(a, mc((n = e.getStaticValue(a)) !== null && n !== void 0 ? n : i));
  }
  for (var a in t)
    r[a] === void 0 && e.removeValue(a);
  return r;
}
var YR = function(e) {
  var r = e.treeType, t = r === void 0 ? "" : r, n = e.build, a = e.getBaseTarget, i = e.makeTargetAnimatable, l = e.measureViewportBox, u = e.render, c = e.readValueFromInstance, f = e.removeValueFromRenderState, h = e.sortNodePosition, p = e.scrapeMotionValuesFromProps;
  return function(g, y) {
    var S = g.parent, x = g.props, T = g.presenceId, A = g.blockInitialAnimation, O = g.visualState, P = g.shouldReduceMotion;
    y === void 0 && (y = {});
    var j = !1, k = O.latestValues, L = O.renderState, M, W = ure(), q = /* @__PURE__ */ new Map(), oe = /* @__PURE__ */ new Map(), Ae = {}, Te = de({}, k), $e;
    function Ee() {
      !M || !j || (ze(), u(M, L, x.style, Z.projection));
    }
    function ze() {
      n(Z, L, k, y, x);
    }
    function Ke() {
      W.notifyUpdate(k);
    }
    function Be(se, te) {
      var fe = te.onChange(function(ve) {
        k[se] = ve, x.onUpdate && ni.update(Ke, !1, !0);
      }), je = te.onRenderRequest(Z.scheduleRender);
      oe.set(se, function() {
        fe(), je();
      });
    }
    var ue = p(x);
    for (var he in ue) {
      var _e = ue[he];
      k[he] !== void 0 && Li(_e) && _e.set(k[he], !1);
    }
    var Oe = pg(x), Me = jM(x), Z = de(de({
      treeType: t,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: S ? S.depth + 1 : 0,
      parent: S,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: T,
      shouldReduceMotion: P,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: Me ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!(S != null && S.isMounted()),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: A,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!M;
      },
      mount: function(se) {
        j = !0, M = Z.current = se, Z.projection && Z.projection.mount(se), Me && S && !Oe && ($e = S == null ? void 0 : S.addVariantChild(Z)), q.forEach(function(te, fe) {
          return Be(fe, te);
        }), S == null || S.children.add(Z), Z.setProps(x);
      },
      /**
       *
       */
      unmount: function() {
        var se;
        (se = Z.projection) === null || se === void 0 || se.unmount(), ff.update(Ke), ff.render(Ee), oe.forEach(function(te) {
          return te();
        }), $e == null || $e(), S == null || S.children.delete(Z), W.clearAllListeners(), M = void 0, j = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(se) {
        var te, fe = Z.getClosestVariantNode();
        if (fe)
          return (te = fe.variantChildren) === null || te === void 0 || te.add(se), function() {
            return fe.variantChildren.delete(se);
          };
      },
      sortNodePosition: function(se) {
        return !h || t !== se.treeType ? 0 : h(Z.getInstance(), se.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return Me ? Z : S == null ? void 0 : S.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return x.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return M;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(se) {
        return k[se];
      },
      setStaticValue: function(se, te) {
        return k[se] = te;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return k;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(se) {
        Z.isVisible !== se && (Z.isVisible = se, Z.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(se, te) {
        return te === void 0 && (te = !0), i(Z, se, x, te);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return l(M, x);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(se, te) {
        Z.hasValue(se) && Z.removeValue(se), q.set(se, te), k[se] = te.get(), Be(se, te);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(se) {
        var te;
        q.delete(se), (te = oe.get(se)) === null || te === void 0 || te(), oe.delete(se), delete k[se], f(se, L);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(se) {
        return q.has(se);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(se, te) {
        var fe = q.get(se);
        return fe === void 0 && te !== void 0 && (fe = mc(te), Z.addValue(se, fe)), fe;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(se) {
        return q.forEach(se);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(se) {
        var te;
        return (te = k[se]) !== null && te !== void 0 ? te : c(M, se, y);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(se, te) {
        Te[se] = te;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(se) {
        if (a) {
          var te = a(x, se);
          if (te !== void 0 && !Li(te))
            return te;
        }
        return Te[se];
      }
    }, W), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return ze(), L;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        ni.render(Ee, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: Ee,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(se) {
        (se.transformTemplate || x.transformTemplate) && Z.scheduleRender(), x = se, W.updatePropListeners(se), Ae = cre(Z, p(x), Ae);
      },
      getProps: function() {
        return x;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(se) {
        var te;
        return (te = x.variants) === null || te === void 0 ? void 0 : te[se];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return x.transition;
      },
      getTransformPagePoint: function() {
        return x.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(se) {
        if (se === void 0 && (se = !1), se)
          return S == null ? void 0 : S.getVariantContext();
        if (!Oe) {
          var te = (S == null ? void 0 : S.getVariantContext()) || {};
          return x.initial !== void 0 && (te.initial = x.initial), te;
        }
        for (var fe = {}, je = 0; je < dre; je++) {
          var ve = KR[je], rr = x[ve];
          (bo(rr) || rr === !1) && (fe[ve] = rr);
        }
        return fe;
      }
    });
    return Z;
  };
}, KR = ba(["initial"], gt(w$), !1), dre = KR.length;
function GS(e) {
  return typeof e == "string" && e.startsWith("var(--");
}
var qR = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function fre(e) {
  var r = qR.exec(e);
  if (!r)
    return [,];
  var t = gt(r, 3), n = t[1], a = t[2];
  return [n, a];
}
function YS(e, r, t) {
  var n = gt(fre(e), 2), a = n[0], i = n[1];
  if (a) {
    var l = window.getComputedStyle(r).getPropertyValue(a);
    return l ? l.trim() : GS(i) ? YS(i, r) : i;
  }
}
function vre(e, r, t) {
  var n, a = Ga(r, []), i = e.getInstance();
  if (!(i instanceof Element))
    return { target: a, transitionEnd: t };
  t && (t = de({}, t)), e.forEachValue(function(f) {
    var h = f.get();
    if (GS(h)) {
      var p = YS(h, i);
      p && f.set(p);
    }
  });
  for (var l in a) {
    var u = a[l];
    if (GS(u)) {
      var c = YS(u, i);
      c && (a[l] = c, t && ((n = t[l]) !== null && n !== void 0 || (t[l] = u)));
    }
  }
  return { target: a, transitionEnd: t };
}
var hre = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), ZR = function(e) {
  return hre.has(e);
}, pre = function(e) {
  return Object.keys(e).some(ZR);
}, QR = function(e, r) {
  e.set(r, !1), e.set(r);
}, p4 = function(e) {
  return e === su || e === Ge;
}, g4;
(function(e) {
  e.width = "width", e.height = "height", e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom";
})(g4 || (g4 = {}));
var m4 = function(e, r) {
  return parseFloat(e.split(", ")[r]);
}, b4 = function(e, r) {
  return function(t, n) {
    var a = n.transform;
    if (a === "none" || !a)
      return 0;
    var i = a.match(/^matrix3d\((.+)\)$/);
    if (i)
      return m4(i[1], r);
    var l = a.match(/^matrix\((.+)\)$/);
    return l ? m4(l[1], e) : 0;
  };
}, gre = /* @__PURE__ */ new Set(["x", "y", "z"]), mre = of.filter(function(e) {
  return !gre.has(e);
});
function bre(e) {
  var r = [];
  return mre.forEach(function(t) {
    var n = e.getValue(t);
    n !== void 0 && (r.push([t, n.get()]), n.set(t.startsWith("scale") ? 1 : 0));
  }), r.length && e.syncRender(), r;
}
var y4 = {
  // Dimensions
  width: function(e, r) {
    var t = e.x, n = r.paddingLeft, a = n === void 0 ? "0" : n, i = r.paddingRight, l = i === void 0 ? "0" : i;
    return t.max - t.min - parseFloat(a) - parseFloat(l);
  },
  height: function(e, r) {
    var t = e.y, n = r.paddingTop, a = n === void 0 ? "0" : n, i = r.paddingBottom, l = i === void 0 ? "0" : i;
    return t.max - t.min - parseFloat(a) - parseFloat(l);
  },
  top: function(e, r) {
    var t = r.top;
    return parseFloat(t);
  },
  left: function(e, r) {
    var t = r.left;
    return parseFloat(t);
  },
  bottom: function(e, r) {
    var t = e.y, n = r.top;
    return parseFloat(n) + (t.max - t.min);
  },
  right: function(e, r) {
    var t = e.x, n = r.left;
    return parseFloat(n) + (t.max - t.min);
  },
  // Transform
  x: b4(4, 13),
  y: b4(5, 14)
}, yre = function(e, r, t) {
  var n = r.measureViewportBox(), a = r.getInstance(), i = getComputedStyle(a), l = i.display, u = {};
  l === "none" && r.setStaticValue("display", e.display || "block"), t.forEach(function(f) {
    u[f] = y4[f](n, i);
  }), r.syncRender();
  var c = r.measureViewportBox();
  return t.forEach(function(f) {
    var h = r.getValue(f);
    QR(h, u[f]), e[f] = y4[f](c, i);
  }), e;
}, Sre = function(e, r, t, n) {
  t === void 0 && (t = {}), n === void 0 && (n = {}), r = de({}, r), n = de({}, n);
  var a = Object.keys(r).filter(ZR), i = [], l = !1, u = [];
  if (a.forEach(function(h) {
    var p = e.getValue(h);
    if (e.hasValue(h)) {
      var g = t[h], y = nd(g), S = r[h], x;
      if (lf(S)) {
        var T = S.length, A = S[0] === null ? 1 : 0;
        g = S[A], y = nd(g);
        for (var O = A; O < T; O++)
          x ? r0(nd(S[O]) === x) : x = nd(S[O]);
      } else
        x = nd(S);
      if (y !== x)
        if (p4(y) && p4(x)) {
          var P = p.get();
          typeof P == "string" && p.set(parseFloat(P)), typeof S == "string" ? r[h] = parseFloat(S) : Array.isArray(S) && x === Ge && (r[h] = S.map(parseFloat));
        } else
          y != null && y.transform && (x != null && x.transform) && (g === 0 || S === 0) ? g === 0 ? p.set(x.transform(g)) : r[h] = y.transform(S) : (l || (i = bre(e), l = !0), u.push(h), n[h] = n[h] !== void 0 ? n[h] : r[h], QR(p, S));
    }
  }), u.length) {
    var c = u.indexOf("height") >= 0 ? window.pageYOffset : null, f = yre(r, e, u);
    return i.length && i.forEach(function(h) {
      var p = gt(h, 2), g = p[0], y = p[1];
      e.getValue(g).set(y);
    }), e.syncRender(), c !== null && window.scrollTo({ top: c }), { target: f, transitionEnd: n };
  } else
    return { target: r, transitionEnd: n };
};
function xre(e, r, t, n) {
  return pre(r) ? Sre(e, r, t, n) : { target: r, transitionEnd: n };
}
var $re = function(e, r, t, n) {
  var a = vre(e, r, n);
  return r = a.target, n = a.transitionEnd, xre(e, r, t, n);
};
function wre(e) {
  return window.getComputedStyle(e);
}
var XR = {
  treeType: "dom",
  readValueFromInstance: function(e, r) {
    if (Ff(r)) {
      var t = m$(r);
      return t && t.default || 0;
    } else {
      var n = wre(e);
      return (FM(r) ? n.getPropertyValue(r) : n[r]) || 0;
    }
  },
  sortNodePosition: function(e, r) {
    return e.compareDocumentPosition(r) & 2 ? 1 : -1;
  },
  getBaseTarget: function(e, r) {
    var t;
    return (t = e.style) === null || t === void 0 ? void 0 : t[r];
  },
  measureViewportBox: function(e, r) {
    var t = r.transformPagePoint;
    return GR(e, t);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(e, r, t) {
    var n = t.transformTemplate;
    r.style.transform = n ? n({}, "") : "none", e.scheduleRender();
  },
  restoreTransform: function(e, r) {
    e.style.transform = r.style.transform;
  },
  removeValueFromRenderState: function(e, r) {
    var t = r.vars, n = r.style;
    delete t[e], delete n[e];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(e, r, t, n) {
    var a = t.transformValues;
    n === void 0 && (n = !0);
    var i = r.transition, l = r.transitionEnd, u = Ga(r, ["transition", "transitionEnd"]), c = Oee(u, i || {}, e);
    if (a && (l && (l = a(l)), u && (u = a(u)), c && (c = a(c))), n) {
      Aee(e, u, c);
      var f = $re(e, u, c, l);
      l = f.transitionEnd, u = f.target;
    }
    return de({ transition: i, transitionEnd: l }, u);
  },
  scrapeMotionValuesFromProps: s$,
  build: function(e, r, t, n, a) {
    e.isVisible !== void 0 && (r.style.visibility = e.isVisible ? "visible" : "hidden"), a$(r, t, n, a.transformTemplate);
  },
  render: XM
}, _re = YR(XR), Tre = YR(de(de({}, XR), { getBaseTarget: function(e, r) {
  return e[r];
}, readValueFromInstance: function(e, r) {
  var t;
  return Ff(r) ? ((t = m$(r)) === null || t === void 0 ? void 0 : t.default) || 0 : (r = JM.has(r) ? r : QM(r), e.getAttribute(r));
}, scrapeMotionValuesFromProps: rR, build: function(e, r, t, n, a) {
  i$(r, t, n, a.transformTemplate);
}, render: eR })), Cre = function(e, r) {
  return t$(e) ? Tre(r, { enableHardwareAcceleration: !1 }) : _re(r, { enableHardwareAcceleration: !0 });
};
function S4(e, r) {
  return r.max === r.min ? 0 : e / (r.max - r.min) * 100;
}
var ad = {
  correct: function(e, r) {
    if (!r.target)
      return e;
    if (typeof e == "string")
      if (Ge.test(e))
        e = parseFloat(e);
      else
        return e;
    var t = S4(e, r.target.x), n = S4(e, r.target.y);
    return "".concat(t, "% ").concat(n, "%");
  }
}, x4 = "_$css", Ere = {
  correct: function(e, r) {
    var t = r.treeScale, n = r.projectionDelta, a = e, i = e.includes("var("), l = [];
    i && (e = e.replace(qR, function(x) {
      return l.push(x), x4;
    }));
    var u = Fi.parse(e);
    if (u.length > 5)
      return a;
    var c = Fi.createTransformer(e), f = typeof u[0] != "number" ? 1 : 0, h = n.x.scale * t.x, p = n.y.scale * t.y;
    u[0 + f] /= h, u[1 + f] /= p;
    var g = Tt(h, p, 0.5);
    typeof u[2 + f] == "number" && (u[2 + f] /= g), typeof u[3 + f] == "number" && (u[3 + f] /= g);
    var y = c(u);
    if (i) {
      var S = 0;
      y = y.replace(x4, function() {
        var x = l[S];
        return S++, x;
      });
    }
    return y;
  }
}, Are = (
  /** @class */
  function(e) {
    IM(r, e);
    function r() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return r.prototype.componentDidMount = function() {
      var t = this, n = this.props, a = n.visualElement, i = n.layoutGroup, l = n.switchLayoutGroup, u = n.layoutId, c = a.projection;
      HQ(Ore), c && (i != null && i.group && i.group.add(c), l != null && l.register && u && l.register(c), c.root.didUpdate(), c.addEventListener("animationComplete", function() {
        t.safeToRemove();
      }), c.setOptions(de(de({}, c.options), { onExitComplete: function() {
        return t.safeToRemove();
      } }))), Id.hasEverUpdated = !0;
    }, r.prototype.getSnapshotBeforeUpdate = function(t) {
      var n = this, a = this.props, i = a.layoutDependency, l = a.visualElement, u = a.drag, c = a.isPresent, f = l.projection;
      return f && (f.isPresent = c, u || t.layoutDependency !== i || i === void 0 ? f.willUpdate() : this.safeToRemove(), t.isPresent !== c && (c ? f.promote() : f.relegate() || ni.postRender(function() {
        var h;
        !((h = f.getStack()) === null || h === void 0) && h.members.length || n.safeToRemove();
      }))), null;
    }, r.prototype.componentDidUpdate = function() {
      var t = this.props.visualElement.projection;
      t && (t.root.didUpdate(), !t.currentAnimation && t.isLead() && this.safeToRemove());
    }, r.prototype.componentWillUnmount = function() {
      var t = this.props, n = t.visualElement, a = t.layoutGroup, i = t.switchLayoutGroup, l = n.projection;
      l && (l.scheduleCheckAfterUnmount(), a != null && a.group && a.group.remove(l), i != null && i.deregister && i.deregister(l));
    }, r.prototype.safeToRemove = function() {
      var t = this.props.safeToRemove;
      t == null || t();
    }, r.prototype.render = function() {
      return null;
    }, r;
  }($o.Component)
);
function Ire(e) {
  var r = gt(PR(), 2), t = r[0], n = r[1], a = Ur(r$);
  return $o.createElement(Are, de({}, e, { layoutGroup: a, switchLayoutGroup: Ur(DM), isPresent: t, safeToRemove: n }));
}
var Ore = {
  borderRadius: de(de({}, ad), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: ad,
  borderTopRightRadius: ad,
  borderBottomLeftRadius: ad,
  borderBottomRightRadius: ad,
  boxShadow: Ere
}, Mre = {
  measureLayout: Ire
};
function Rre(e, r, t) {
  t === void 0 && (t = {});
  var n = Li(e) ? e : mc(e);
  return S$("", n, r, t), {
    stop: function() {
      return n.stop();
    },
    isAnimating: function() {
      return n.isAnimating();
    }
  };
}
var JR = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], Pre = JR.length, $4 = function(e) {
  return typeof e == "string" ? parseFloat(e) : e;
}, w4 = function(e) {
  return typeof e == "number" || Ge.test(e);
};
function kre(e, r, t, n, a, i) {
  var l, u, c, f;
  a ? (e.opacity = Tt(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (l = t.opacity) !== null && l !== void 0 ? l : 1,
    jre(n)
  ), e.opacityExit = Tt((u = r.opacity) !== null && u !== void 0 ? u : 1, 0, Dre(n))) : i && (e.opacity = Tt((c = r.opacity) !== null && c !== void 0 ? c : 1, (f = t.opacity) !== null && f !== void 0 ? f : 1, n));
  for (var h = 0; h < Pre; h++) {
    var p = "border".concat(JR[h], "Radius"), g = _4(r, p), y = _4(t, p);
    if (!(g === void 0 && y === void 0)) {
      g || (g = 0), y || (y = 0);
      var S = g === 0 || y === 0 || w4(g) === w4(y);
      S ? (e[p] = Math.max(Tt($4(g), $4(y), n), 0), (ti.test(y) || ti.test(g)) && (e[p] += "%")) : e[p] = y;
    }
  }
  (r.rotate || t.rotate) && (e.rotate = Tt(r.rotate || 0, t.rotate || 0, n));
}
function _4(e, r) {
  var t;
  return (t = e[r]) !== null && t !== void 0 ? t : e.borderRadius;
}
var jre = eP(0, 0.5, p$), Dre = eP(0.5, 0.95, v$);
function eP(e, r, t) {
  return function(n) {
    return n < e ? 0 : n > r ? 1 : t(uf(e, r, n));
  };
}
function T4(e, r) {
  e.min = r.min, e.max = r.max;
}
function io(e, r) {
  T4(e.x, r.x), T4(e.y, r.y);
}
function C4(e, r, t, n, a) {
  return e -= r, e = c0(e, 1 / t, n), a !== void 0 && (e = c0(e, 1 / a, n)), e;
}
function Nre(e, r, t, n, a, i, l) {
  if (r === void 0 && (r = 0), t === void 0 && (t = 1), n === void 0 && (n = 0.5), i === void 0 && (i = e), l === void 0 && (l = e), ti.test(r)) {
    r = parseFloat(r);
    var u = Tt(l.min, l.max, r / 100);
    r = u - l.min;
  }
  if (typeof r == "number") {
    var c = Tt(i.min, i.max, n);
    e === i && (c -= r), e.min = C4(e.min, r, t, c, a), e.max = C4(e.max, r, t, c, a);
  }
}
function E4(e, r, t, n, a) {
  var i = gt(t, 3), l = i[0], u = i[1], c = i[2];
  Nre(e, r[l], r[u], r[c], r.scale, n, a);
}
var Lre = ["x", "scaleX", "originX"], Fre = ["y", "scaleY", "originY"];
function A4(e, r, t, n) {
  E4(e.x, r, Lre, t == null ? void 0 : t.x, n == null ? void 0 : n.x), E4(e.y, r, Fre, t == null ? void 0 : t.y, n == null ? void 0 : n.y);
}
function I4(e) {
  return e.translate === 0 && e.scale === 1;
}
function rP(e) {
  return I4(e.x) && I4(e.y);
}
function tP(e, r) {
  return e.x.min === r.x.min && e.x.max === r.x.max && e.y.min === r.y.min && e.y.max === r.y.max;
}
var zre = (
  /** @class */
  function() {
    function e() {
      this.members = [];
    }
    return e.prototype.add = function(r) {
      x$(this.members, r), r.scheduleRender();
    }, e.prototype.remove = function(r) {
      if ($$(this.members, r), r === this.prevLead && (this.prevLead = void 0), r === this.lead) {
        var t = this.members[this.members.length - 1];
        t && this.promote(t);
      }
    }, e.prototype.relegate = function(r) {
      var t = this.members.findIndex(function(l) {
        return r === l;
      });
      if (t === 0)
        return !1;
      for (var n, a = t; a >= 0; a--) {
        var i = this.members[a];
        if (i.isPresent !== !1) {
          n = i;
          break;
        }
      }
      return n ? (this.promote(n), !0) : !1;
    }, e.prototype.promote = function(r, t) {
      var n, a = this.lead;
      if (r !== a && (this.prevLead = a, this.lead = r, r.show(), a)) {
        a.instance && a.scheduleRender(), r.scheduleRender(), r.resumeFrom = a, t && (r.resumeFrom.preserveOpacity = !0), a.snapshot && (r.snapshot = a.snapshot, r.snapshot.latestValues = a.animationValues || a.latestValues, r.snapshot.isShared = !0), !((n = r.root) === null || n === void 0) && n.isUpdating && (r.isLayoutDirty = !0);
        var i = r.options.crossfade;
        i === !1 && a.hide();
      }
    }, e.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(r) {
        var t, n, a, i, l;
        (n = (t = r.options).onExitComplete) === null || n === void 0 || n.call(t), (l = (a = r.resumingFrom) === null || a === void 0 ? void 0 : (i = a.options).onExitComplete) === null || l === void 0 || l.call(i);
      });
    }, e.prototype.scheduleRender = function() {
      this.members.forEach(function(r) {
        r.instance && r.scheduleRender(!1);
      });
    }, e.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, e;
  }()
), Bre = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function O4(e, r, t) {
  var n = e.x.translate / r.x, a = e.y.translate / r.y, i = "translate3d(".concat(n, "px, ").concat(a, "px, 0) ");
  if (i += "scale(".concat(1 / r.x, ", ").concat(1 / r.y, ") "), t) {
    var l = t.rotate, u = t.rotateX, c = t.rotateY;
    l && (i += "rotate(".concat(l, "deg) ")), u && (i += "rotateX(".concat(u, "deg) ")), c && (i += "rotateY(".concat(c, "deg) "));
  }
  var f = e.x.scale * r.x, h = e.y.scale * r.y;
  return i += "scale(".concat(f, ", ").concat(h, ")"), i === Bre ? "none" : i;
}
var Ure = function(e, r) {
  return e.depth - r.depth;
}, Vre = (
  /** @class */
  function() {
    function e() {
      this.children = [], this.isDirty = !1;
    }
    return e.prototype.add = function(r) {
      x$(this.children, r), this.isDirty = !0;
    }, e.prototype.remove = function(r) {
      $$(this.children, r), this.isDirty = !0;
    }, e.prototype.forEach = function(r) {
      this.isDirty && this.children.sort(Ure), this.isDirty = !1, this.children.forEach(r);
    }, e;
  }()
), M4 = 1e3;
function nP(e) {
  var r = e.attachResizeListener, t = e.defaultParent, n = e.measureScroll, a = e.checkIsScrollRoot, i = e.resetTransform;
  return (
    /** @class */
    function() {
      function l(u, c, f) {
        var h = this;
        c === void 0 && (c = {}), f === void 0 && (f = t == null ? void 0 : t()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          h.isUpdating && (h.isUpdating = !1, h.clearAllSnapshots());
        }, this.updateProjection = function() {
          h.nodes.forEach(qre), h.nodes.forEach(Zre);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = u, this.latestValues = c, this.root = f ? f.root || f : this, this.path = f ? ba(ba([], gt(f.path), !1), [f], !1) : [], this.parent = f, this.depth = f ? f.depth + 1 : 0, u && this.root.registerPotentialNode(u, this);
        for (var p = 0; p < this.path.length; p++)
          this.path[p].shouldResetTransform = !0;
        this.root === this && (this.nodes = new Vre());
      }
      return l.prototype.addEventListener = function(u, c) {
        return this.eventHandlers.has(u) || this.eventHandlers.set(u, new Rd()), this.eventHandlers.get(u).add(c);
      }, l.prototype.notifyListeners = function(u) {
        for (var c = [], f = 1; f < arguments.length; f++)
          c[f - 1] = arguments[f];
        var h = this.eventHandlers.get(u);
        h == null || h.notify.apply(h, ba([], gt(c), !1));
      }, l.prototype.hasListeners = function(u) {
        return this.eventHandlers.has(u);
      }, l.prototype.registerPotentialNode = function(u, c) {
        this.potentialNodes.set(u, c);
      }, l.prototype.mount = function(u, c) {
        var f = this, h;
        if (c === void 0 && (c = !1), !this.instance) {
          this.isSVG = u instanceof SVGElement && u.tagName !== "svg", this.instance = u;
          var p = this.options, g = p.layoutId, y = p.layout, S = p.visualElement;
          if (S && !S.getInstance() && S.mount(u), this.root.nodes.add(this), (h = this.parent) === null || h === void 0 || h.children.add(this), this.id && this.root.potentialNodes.delete(this.id), c && (y || g) && (this.isLayoutDirty = !0), r) {
            var x, T = function() {
              return f.root.updateBlockedByResize = !1;
            };
            r(u, function() {
              f.root.updateBlockedByResize = !0, clearTimeout(x), x = window.setTimeout(T, 250), Id.hasAnimatedSinceResize && (Id.hasAnimatedSinceResize = !1, f.nodes.forEach(Kre));
            });
          }
          g && this.root.registerSharedNode(g, this), this.options.animate !== !1 && S && (g || y) && this.addEventListener("didUpdate", function(A) {
            var O, P, j, k, L, M = A.delta, W = A.hasLayoutChanged, q = A.hasRelativeTargetChanged, oe = A.layout;
            if (f.isTreeAnimationBlocked()) {
              f.target = void 0, f.relativeTarget = void 0;
              return;
            }
            var Ae = (P = (O = f.options.transition) !== null && O !== void 0 ? O : S.getDefaultTransition()) !== null && P !== void 0 ? P : rte, Te = S.getProps(), $e = Te.onLayoutAnimationStart, Ee = Te.onLayoutAnimationComplete, ze = !f.targetLayout || !tP(f.targetLayout, oe) || q, Ke = !W && q;
            if (!((j = f.resumeFrom) === null || j === void 0) && j.instance || Ke || W && (ze || !f.currentAnimation)) {
              f.resumeFrom && (f.resumingFrom = f.resumeFrom, f.resumingFrom.resumingFrom = void 0), f.setAnimationOrigin(M, Ke);
              var Be = de(de({}, y$(Ae, "layout")), { onPlay: $e, onComplete: Ee });
              S.shouldReduceMotion && (Be.delay = 0, Be.type = !1), f.startAnimation(Be);
            } else
              !W && f.animationProgress === 0 && f.finishAnimation(), f.isLead() && ((L = (k = f.options).onExitComplete) === null || L === void 0 || L.call(k));
            f.targetLayout = oe;
          });
        }
      }, l.prototype.unmount = function() {
        var u, c;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (u = this.getStack()) === null || u === void 0 || u.remove(this), (c = this.parent) === null || c === void 0 || c.children.delete(this), this.instance = void 0, ff.preRender(this.updateProjection);
      }, l.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, l.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, l.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, l.prototype.isTreeAnimationBlocked = function() {
        var u;
        return this.isAnimationBlocked || ((u = this.parent) === null || u === void 0 ? void 0 : u.isTreeAnimationBlocked()) || !1;
      }, l.prototype.startUpdate = function() {
        var u;
        this.isUpdateBlocked() || (this.isUpdating = !0, (u = this.nodes) === null || u === void 0 || u.forEach(Qre));
      }, l.prototype.willUpdate = function(u) {
        var c, f, h;
        if (u === void 0 && (u = !0), this.root.isUpdateBlocked()) {
          (f = (c = this.options).onExitComplete) === null || f === void 0 || f.call(c);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var p = 0; p < this.path.length; p++) {
            var g = this.path[p];
            g.shouldResetTransform = !0, g.updateScroll();
          }
          var y = this.options, S = y.layoutId, x = y.layout;
          if (!(S === void 0 && !x)) {
            var T = (h = this.options.visualElement) === null || h === void 0 ? void 0 : h.getProps().transformTemplate;
            this.prevTransformTemplateValue = T == null ? void 0 : T(this.latestValues, ""), this.updateSnapshot(), u && this.notifyListeners("willUpdate");
          }
        }
      }, l.prototype.didUpdate = function() {
        var u = this.isUpdateBlocked();
        if (u) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(R4);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(tte), this.potentialNodes.clear()), this.nodes.forEach(Yre), this.nodes.forEach(Wre), this.nodes.forEach(Hre), this.clearAllSnapshots(), Qb.update(), Qb.preRender(), Qb.render());
      }, l.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(Gre), this.sharedNodes.forEach(Xre);
      }, l.prototype.scheduleUpdateProjection = function() {
        ni.preRender(this.updateProjection, !1, !0);
      }, l.prototype.scheduleCheckAfterUnmount = function() {
        var u = this;
        ni.postRender(function() {
          u.isLayoutDirty ? u.root.didUpdate() : u.root.checkUpdateFailed();
        });
      }, l.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var u = this.measure(), c = this.removeTransform(this.removeElementScroll(u));
          D4(c), this.snapshot = {
            measured: u,
            layout: c,
            latestValues: {}
          };
        }
      }, l.prototype.updateLayout = function() {
        var u;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var c = 0; c < this.path.length; c++) {
              var f = this.path[c];
              f.updateScroll();
            }
          var h = this.measure();
          D4(h);
          var p = this.layout;
          this.layout = {
            measured: h,
            actual: this.removeElementScroll(h)
          }, this.layoutCorrected = Tn(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (u = this.options.visualElement) === null || u === void 0 || u.notifyLayoutMeasure(this.layout.actual, p == null ? void 0 : p.actual);
        }
      }, l.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = a(this.instance), this.scroll = n(this.instance));
      }, l.prototype.resetTransform = function() {
        var u;
        if (i) {
          var c = this.isLayoutDirty || this.shouldResetTransform, f = this.projectionDelta && !rP(this.projectionDelta), h = (u = this.options.visualElement) === null || u === void 0 ? void 0 : u.getProps().transformTemplate, p = h == null ? void 0 : h(this.latestValues, ""), g = p !== this.prevTransformTemplateValue;
          c && (f || Cs(this.latestValues) || g) && (i(this.instance, p), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, l.prototype.measure = function() {
        var u = this.options.visualElement;
        if (!u)
          return Tn();
        var c = u.measureViewportBox(), f = this.root.scroll;
        return f && (Es(c.x, f.x), Es(c.y, f.y)), c;
      }, l.prototype.removeElementScroll = function(u) {
        var c = Tn();
        io(c, u);
        for (var f = 0; f < this.path.length; f++) {
          var h = this.path[f], p = h.scroll, g = h.options, y = h.isScrollRoot;
          if (h !== this.root && p && g.layoutScroll) {
            if (y) {
              io(c, u);
              var S = this.root.scroll;
              S && (Es(c.x, -S.x), Es(c.y, -S.y));
            }
            Es(c.x, p.x), Es(c.y, p.y);
          }
        }
        return c;
      }, l.prototype.applyTransform = function(u, c) {
        c === void 0 && (c = !1);
        var f = Tn();
        io(f, u);
        for (var h = 0; h < this.path.length; h++) {
          var p = this.path[h];
          !c && p.options.layoutScroll && p.scroll && p !== p.root && Ku(f, {
            x: -p.scroll.x,
            y: -p.scroll.y
          }), Cs(p.latestValues) && Ku(f, p.latestValues);
        }
        return Cs(this.latestValues) && Ku(f, this.latestValues), f;
      }, l.prototype.removeTransform = function(u) {
        var c, f = Tn();
        io(f, u);
        for (var h = 0; h < this.path.length; h++) {
          var p = this.path[h];
          if (p.instance && Cs(p.latestValues)) {
            WR(p.latestValues) && p.updateSnapshot();
            var g = Tn(), y = p.measure();
            io(g, y), A4(f, p.latestValues, (c = p.snapshot) === null || c === void 0 ? void 0 : c.layout, g);
          }
        }
        return Cs(this.latestValues) && A4(f, this.latestValues), f;
      }, l.prototype.setTargetDelta = function(u) {
        this.targetDelta = u, this.root.scheduleUpdateProjection();
      }, l.prototype.setOptions = function(u) {
        var c;
        this.options = de(de(de({}, this.options), u), { crossfade: (c = u.crossfade) !== null && c !== void 0 ? c : !0 });
      }, l.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, l.prototype.resolveTargetDelta = function() {
        var u, c = this.options, f = c.layout, h = c.layoutId;
        !this.layout || !(f || h) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = Tn(), this.relativeTargetOrigin = Tn(), kd(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), io(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = Tn(), this.targetWithTransforms = Tn()), this.relativeTarget && this.relativeTargetOrigin && (!((u = this.relativeParent) === null || u === void 0) && u.target) ? Wee(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : io(this.target, this.layout.actual), HR(this.target, this.targetDelta)) : io(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = Tn(), this.relativeTargetOrigin = Tn(), kd(this.relativeTargetOrigin, this.target, this.relativeParent.target), io(this.relativeTarget, this.relativeTargetOrigin)))));
      }, l.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || Cs(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, l.prototype.calcProjection = function() {
        var u, c = this.options, f = c.layout, h = c.layoutId;
        if (this.isTreeAnimating = !!(!((u = this.parent) === null || u === void 0) && u.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(f || h))) {
          var p = this.getLead();
          io(this.layoutCorrected, this.layout.actual), Jee(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== p);
          var g = p.target;
          if (g) {
            this.projectionDelta || (this.projectionDelta = jd(), this.projectionDeltaWithTransform = jd());
            var y = this.treeScale.x, S = this.treeScale.y, x = this.projectionTransform;
            Pd(this.projectionDelta, this.layoutCorrected, g, this.latestValues), this.projectionTransform = O4(this.projectionDelta, this.treeScale), (this.projectionTransform !== x || this.treeScale.x !== y || this.treeScale.y !== S) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", g));
          }
        }
      }, l.prototype.hide = function() {
        this.isVisible = !1;
      }, l.prototype.show = function() {
        this.isVisible = !0;
      }, l.prototype.scheduleRender = function(u) {
        var c, f, h;
        u === void 0 && (u = !0), (f = (c = this.options).scheduleRender) === null || f === void 0 || f.call(c), u && ((h = this.getStack()) === null || h === void 0 || h.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, l.prototype.setAnimationOrigin = function(u, c) {
        var f = this, h;
        c === void 0 && (c = !1);
        var p = this.snapshot, g = (p == null ? void 0 : p.latestValues) || {}, y = de({}, this.latestValues), S = jd();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !c;
        var x = Tn(), T = p == null ? void 0 : p.isShared, A = (((h = this.getStack()) === null || h === void 0 ? void 0 : h.members.length) || 0) <= 1, O = !!(T && !A && this.options.crossfade === !0 && !this.path.some(ete));
        this.animationProgress = 0, this.mixTargetDelta = function(P) {
          var j, k = P / 1e3;
          P4(S.x, u.x, k), P4(S.y, u.y, k), f.setTargetDelta(S), f.relativeTarget && f.relativeTargetOrigin && f.layout && (!((j = f.relativeParent) === null || j === void 0) && j.layout) && (kd(x, f.layout.actual, f.relativeParent.layout.actual), Jre(f.relativeTarget, f.relativeTargetOrigin, x, k)), T && (f.animationValues = y, kre(y, g, f.latestValues, k, O, A)), f.root.scheduleUpdateProjection(), f.scheduleRender(), f.animationProgress = k;
        }, this.mixTargetDelta(0);
      }, l.prototype.startAnimation = function(u) {
        var c = this, f, h;
        this.notifyListeners("animationStart"), (f = this.currentAnimation) === null || f === void 0 || f.stop(), this.resumingFrom && ((h = this.resumingFrom.currentAnimation) === null || h === void 0 || h.stop()), this.pendingAnimation && (ff.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = ni.update(function() {
          Id.hasAnimatedSinceResize = !0, c.currentAnimation = Rre(0, M4, de(de({}, u), { onUpdate: function(p) {
            var g;
            c.mixTargetDelta(p), (g = u.onUpdate) === null || g === void 0 || g.call(u, p);
          }, onComplete: function() {
            var p;
            (p = u.onComplete) === null || p === void 0 || p.call(u), c.completeAnimation();
          } })), c.resumingFrom && (c.resumingFrom.currentAnimation = c.currentAnimation), c.pendingAnimation = void 0;
        });
      }, l.prototype.completeAnimation = function() {
        var u;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (u = this.getStack()) === null || u === void 0 || u.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, l.prototype.finishAnimation = function() {
        var u;
        this.currentAnimation && ((u = this.mixTargetDelta) === null || u === void 0 || u.call(this, M4), this.currentAnimation.stop()), this.completeAnimation();
      }, l.prototype.applyTransformsToTarget = function() {
        var u = this.getLead(), c = u.targetWithTransforms, f = u.target, h = u.layout, p = u.latestValues;
        !c || !f || !h || (io(c, f), Ku(c, p), Pd(this.projectionDeltaWithTransform, this.layoutCorrected, c, p));
      }, l.prototype.registerSharedNode = function(u, c) {
        var f, h, p;
        this.sharedNodes.has(u) || this.sharedNodes.set(u, new zre());
        var g = this.sharedNodes.get(u);
        g.add(c), c.promote({
          transition: (f = c.options.initialPromotionConfig) === null || f === void 0 ? void 0 : f.transition,
          preserveFollowOpacity: (p = (h = c.options.initialPromotionConfig) === null || h === void 0 ? void 0 : h.shouldPreserveFollowOpacity) === null || p === void 0 ? void 0 : p.call(h, c)
        });
      }, l.prototype.isLead = function() {
        var u = this.getStack();
        return u ? u.lead === this : !0;
      }, l.prototype.getLead = function() {
        var u, c = this.options.layoutId;
        return c ? ((u = this.getStack()) === null || u === void 0 ? void 0 : u.lead) || this : this;
      }, l.prototype.getPrevLead = function() {
        var u, c = this.options.layoutId;
        return c ? (u = this.getStack()) === null || u === void 0 ? void 0 : u.prevLead : void 0;
      }, l.prototype.getStack = function() {
        var u = this.options.layoutId;
        if (u)
          return this.root.sharedNodes.get(u);
      }, l.prototype.promote = function(u) {
        var c = u === void 0 ? {} : u, f = c.needsReset, h = c.transition, p = c.preserveFollowOpacity, g = this.getStack();
        g && g.promote(this, p), f && (this.projectionDelta = void 0, this.needsReset = !0), h && this.setOptions({ transition: h });
      }, l.prototype.relegate = function() {
        var u = this.getStack();
        return u ? u.relegate(this) : !1;
      }, l.prototype.resetRotation = function() {
        var u = this.options.visualElement;
        if (u) {
          for (var c = !1, f = {}, h = 0; h < IS.length; h++) {
            var p = IS[h], g = "rotate" + p;
            u.getStaticValue(g) && (c = !0, f[g] = u.getStaticValue(g), u.setStaticValue(g, 0));
          }
          if (c) {
            u == null || u.syncRender();
            for (var g in f)
              u.setStaticValue(g, f[g]);
            u.scheduleRender();
          }
        }
      }, l.prototype.getProjectionStyles = function(u) {
        var c, f, h, p, g, y;
        u === void 0 && (u = {});
        var S = {};
        if (!this.instance || this.isSVG)
          return S;
        if (this.isVisible)
          S.visibility = "";
        else
          return { visibility: "hidden" };
        var x = (c = this.options.visualElement) === null || c === void 0 ? void 0 : c.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, S.opacity = "", S.pointerEvents = $p(u.pointerEvents) || "", S.transform = x ? x(this.latestValues, "") : "none", S;
        var T = this.getLead();
        if (!this.projectionDelta || !this.layout || !T.target) {
          var A = {};
          return this.options.layoutId && (A.opacity = (f = this.latestValues.opacity) !== null && f !== void 0 ? f : 1, A.pointerEvents = $p(u.pointerEvents) || ""), this.hasProjected && !Cs(this.latestValues) && (A.transform = x ? x({}, "") : "none", this.hasProjected = !1), A;
        }
        var O = T.animationValues || T.latestValues;
        this.applyTransformsToTarget(), S.transform = O4(this.projectionDeltaWithTransform, this.treeScale, O), x && (S.transform = x(O, S.transform));
        var P = this.projectionDelta, j = P.x, k = P.y;
        S.transformOrigin = "".concat(j.origin * 100, "% ").concat(k.origin * 100, "% 0"), T.animationValues ? S.opacity = T === this ? (p = (h = O.opacity) !== null && h !== void 0 ? h : this.latestValues.opacity) !== null && p !== void 0 ? p : 1 : this.preserveOpacity ? this.latestValues.opacity : O.opacityExit : S.opacity = T === this ? (g = O.opacity) !== null && g !== void 0 ? g : "" : (y = O.opacityExit) !== null && y !== void 0 ? y : 0;
        for (var L in n0)
          if (O[L] !== void 0) {
            var M = n0[L], W = M.correct, q = M.applyTo, oe = W(O[L], T);
            if (q)
              for (var Ae = q.length, Te = 0; Te < Ae; Te++)
                S[q[Te]] = oe;
            else
              S[L] = oe;
          }
        return this.options.layoutId && (S.pointerEvents = T === this ? $p(u.pointerEvents) || "" : "none"), S;
      }, l.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, l.prototype.resetTree = function() {
        this.root.nodes.forEach(function(u) {
          var c;
          return (c = u.currentAnimation) === null || c === void 0 ? void 0 : c.stop();
        }), this.root.nodes.forEach(R4), this.root.sharedNodes.clear();
      }, l;
    }()
  );
}
function Wre(e) {
  e.updateLayout();
}
function Hre(e) {
  var r, t, n, a, i = (t = (r = e.resumeFrom) === null || r === void 0 ? void 0 : r.snapshot) !== null && t !== void 0 ? t : e.snapshot;
  if (e.isLead() && e.layout && i && e.hasListeners("didUpdate")) {
    var l = e.layout, u = l.actual, c = l.measured;
    e.options.animationType === "size" ? Yo(function(O) {
      var P = i.isShared ? i.measured[O] : i.layout[O], j = zi(P);
      P.min = u[O].min, P.max = P.min + j;
    }) : e.options.animationType === "position" && Yo(function(O) {
      var P = i.isShared ? i.measured[O] : i.layout[O], j = zi(u[O]);
      P.max = P.min + j;
    });
    var f = jd();
    Pd(f, u, i.layout);
    var h = jd();
    i.isShared ? Pd(h, e.applyTransform(c, !0), i.measured) : Pd(h, u, i.layout);
    var p = !rP(f), g = !1;
    if (!e.resumeFrom && (e.relativeParent = e.getClosestProjectingParent(), e.relativeParent && !e.relativeParent.resumeFrom)) {
      var y = e.relativeParent, S = y.snapshot, x = y.layout;
      if (S && x) {
        var T = Tn();
        kd(T, i.layout, S.layout);
        var A = Tn();
        kd(A, u, x.actual), tP(T, A) || (g = !0);
      }
    }
    e.notifyListeners("didUpdate", {
      layout: u,
      snapshot: i,
      delta: h,
      layoutDelta: f,
      hasLayoutChanged: p,
      hasRelativeTargetChanged: g
    });
  } else
    e.isLead() && ((a = (n = e.options).onExitComplete) === null || a === void 0 || a.call(n));
  e.options.transition = void 0;
}
function Gre(e) {
  e.clearSnapshot();
}
function R4(e) {
  e.clearMeasurements();
}
function Yre(e) {
  var r = e.options.visualElement;
  r != null && r.getProps().onBeforeLayoutMeasure && r.notifyBeforeLayoutMeasure(), e.resetTransform();
}
function Kre(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0;
}
function qre(e) {
  e.resolveTargetDelta();
}
function Zre(e) {
  e.calcProjection();
}
function Qre(e) {
  e.resetRotation();
}
function Xre(e) {
  e.removeLeadSnapshot();
}
function P4(e, r, t) {
  e.translate = Tt(r.translate, 0, t), e.scale = Tt(r.scale, 1, t), e.origin = r.origin, e.originPoint = r.originPoint;
}
function k4(e, r, t, n) {
  e.min = Tt(r.min, t.min, n), e.max = Tt(r.max, t.max, n);
}
function Jre(e, r, t, n) {
  k4(e.x, r.x, t.x, n), k4(e.y, r.y, t.y, n);
}
function ete(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
var rte = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function tte(e, r) {
  for (var t = e.root, n = e.path.length - 1; n >= 0; n--)
    if (e.path[n].instance) {
      t = e.path[n];
      break;
    }
  var a = t && t !== e.root ? t.instance : document, i = a.querySelector('[data-projection-id="'.concat(r, '"]'));
  i && e.mount(i, !0);
}
function j4(e) {
  e.min = Math.round(e.min), e.max = Math.round(e.max);
}
function D4(e) {
  j4(e.x), j4(e.y);
}
var nte = nP({
  attachResizeListener: function(e, r) {
    return gg(e, "resize", r);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), r1 = {
  current: void 0
}, ate = nP({
  measureScroll: function(e) {
    return {
      x: e.scrollLeft,
      y: e.scrollTop
    };
  },
  defaultParent: function() {
    if (!r1.current) {
      var e = new nte(0, {});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), r1.current = e;
    }
    return r1.current;
  },
  resetTransform: function(e, r) {
    e.style.transform = r != null ? r : "none";
  },
  checkIsScrollRoot: function(e) {
    return window.getComputedStyle(e).position === "fixed";
  }
}), ote = de(de(de(de({}, Bee), eee), lre), Mre), Bs = /* @__PURE__ */ VQ(function(e, r) {
  return IX(e, r, ote, Cre, ate);
});
function aP() {
  var e = Ze(!1);
  return t0(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), e;
}
function ite() {
  var e = aP(), r = gt(He(0), 2), t = r[0], n = r[1], a = Le(function() {
    e.current && n(t + 1);
  }, [t]), i = Le(function() {
    return ni.postRender(a);
  }, [a]);
  return [i, t];
}
var t1 = function(e) {
  var r = e.children, t = e.initial, n = e.isPresent, a = e.onExitComplete, i = e.custom, l = e.presenceAffectsLayout, u = Lf(ste), c = RR(), f = Rt(
    function() {
      return {
        id: c,
        initial: t,
        isPresent: n,
        custom: i,
        onExitComplete: function(h) {
          var p, g;
          u.set(h, !0);
          try {
            for (var y = xQ(u.values()), S = y.next(); !S.done; S = y.next()) {
              var x = S.value;
              if (!x)
                return;
            }
          } catch (T) {
            p = { error: T };
          } finally {
            try {
              S && !S.done && (g = y.return) && g.call(y);
            } finally {
              if (p)
                throw p.error;
            }
          }
          a == null || a();
        },
        register: function(h) {
          return u.set(h, !1), function() {
            return u.delete(h);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    l ? void 0 : [n]
  );
  return Rt(function() {
    u.forEach(function(h, p) {
      return u.set(p, !1);
    });
  }, [n]), I.useEffect(function() {
    !n && !u.size && (a == null || a());
  }, [n]), I.createElement(Nf.Provider, { value: f }, r);
};
function ste() {
  return /* @__PURE__ */ new Map();
}
var Uu = function(e) {
  return e.key || "";
};
function lte(e, r) {
  e.forEach(function(t) {
    var n = Uu(t);
    r.set(n, t);
  });
}
function ute(e) {
  var r = [];
  return tU.forEach(e, function(t) {
    nU(t) && r.push(t);
  }), r;
}
var cte = function(e) {
  var r = e.children, t = e.custom, n = e.initial, a = n === void 0 ? !0 : n, i = e.onExitComplete, l = e.exitBeforeEnter, u = e.presenceAffectsLayout, c = u === void 0 ? !0 : u, f = gt(ite(), 1), h = f[0], p = Ur(r$).forceRender;
  p && (h = p);
  var g = aP(), y = ute(r), S = y, x = /* @__PURE__ */ new Set(), T = Ze(S), A = Ze(/* @__PURE__ */ new Map()).current, O = Ze(!0);
  if (t0(function() {
    O.current = !1, lte(y, A), T.current = S;
  }), c$(function() {
    O.current = !0, A.clear(), x.clear();
  }), O.current)
    return I.createElement(I.Fragment, null, S.map(function(W) {
      return I.createElement(t1, { key: Uu(W), isPresent: !0, initial: a ? void 0 : !1, presenceAffectsLayout: c }, W);
    }));
  S = ba([], gt(S), !1);
  for (var P = T.current.map(Uu), j = y.map(Uu), k = P.length, L = 0; L < k; L++) {
    var M = P[L];
    j.indexOf(M) === -1 && x.add(M);
  }
  return l && x.size && (S = []), x.forEach(function(W) {
    if (j.indexOf(W) === -1) {
      var q = A.get(W);
      if (q) {
        var oe = P.indexOf(W), Ae = function() {
          A.delete(W), x.delete(W);
          var Te = T.current.findIndex(function($e) {
            return $e.key === W;
          });
          if (T.current.splice(Te, 1), !x.size) {
            if (T.current = y, g.current === !1)
              return;
            h(), i && i();
          }
        };
        S.splice(oe, 0, I.createElement(t1, { key: Uu(q), isPresent: !1, onExitComplete: Ae, custom: t, presenceAffectsLayout: c }, q));
      }
    }
  }), S = S.map(function(W) {
    var q = W.key;
    return x.has(q) ? W : I.createElement(t1, { key: Uu(W), isPresent: !0, presenceAffectsLayout: c }, W);
  }), J2 !== "production" && l && S.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), I.createElement(I.Fragment, null, x.size ? S : S.map(function(W) {
    return rU(W);
  }));
}, oP = {
  border: "0px",
  clip: "rect(0px, 0px, 0px, 0px)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, dte = Ht("span", {
  baseStyle: oP
});
Ht("input", {
  baseStyle: oP
});
function d0() {
  return d0 = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, d0.apply(this, arguments);
}
function fte(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var vte = ["label", "thickness", "speed", "emptyColor", "className"], hte = KO({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), pte = /* @__PURE__ */ kn(function(e, r) {
  var t = dg("Spinner", e), n = cg(e), a = n.label, i = a === void 0 ? "Loading..." : a, l = n.thickness, u = l === void 0 ? "2px" : l, c = n.speed, f = c === void 0 ? "0.45s" : c, h = n.emptyColor, p = h === void 0 ? "transparent" : h, g = n.className, y = fte(n, vte), S = Ha("chakra-spinner", g), x = d0({
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: u,
    borderBottomColor: p,
    borderLeftColor: p,
    animation: hte + " " + f + " linear infinite"
  }, t);
  return /* @__PURE__ */ I.createElement(Ht.div, d0({
    ref: r,
    __css: x,
    className: S
  }, y), i && /* @__PURE__ */ I.createElement(dte, null, i));
});
function _$(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
function js() {
  return js = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, js.apply(this, arguments);
}
var gte = Ec({
  strict: !1,
  name: "ButtonGroupContext"
}), mte = gte[1], bte = ["label", "placement", "spacing", "children", "className", "__css"], N4 = function(r) {
  var t = r.label, n = r.placement, a = r.spacing, i = a === void 0 ? "0.5rem" : a, l = r.children, u = l === void 0 ? /* @__PURE__ */ I.createElement(pte, {
    color: "currentColor",
    width: "1em",
    height: "1em"
  }) : l, c = r.className, f = r.__css, h = _$(r, bte), p = Ha("chakra-button__spinner", c), g = n === "start" ? "marginEnd" : "marginStart", y = I.useMemo(function() {
    var S;
    return js((S = {
      display: "flex",
      alignItems: "center",
      position: t ? "relative" : "absolute"
    }, S[g] = t ? i : 0, S.fontSize = "1em", S.lineHeight = "normal", S), f);
  }, [f, t, g, i]);
  return /* @__PURE__ */ I.createElement(Ht.div, js({
    className: p
  }, h, {
    __css: y
  }), u);
}, yte = ["children", "className"], L4 = function(r) {
  var t = r.children, n = r.className, a = _$(r, yte), i = /* @__PURE__ */ I.isValidElement(t) ? /* @__PURE__ */ I.cloneElement(t, {
    "aria-hidden": !0,
    focusable: !1
  }) : t, l = Ha("chakra-button__icon", n);
  return /* @__PURE__ */ I.createElement(Ht.span, js({
    display: "inline-flex",
    alignSelf: "center",
    flexShrink: 0
  }, a, {
    className: l
  }), i);
};
function Ste(e) {
  var r = I.useState(!e), t = r[0], n = r[1], a = I.useCallback(function(l) {
    l && n(l.tagName === "BUTTON");
  }, []), i = t ? "button" : void 0;
  return {
    ref: a,
    type: i
  };
}
var xte = ["isDisabled", "isLoading", "isActive", "isFullWidth", "children", "leftIcon", "rightIcon", "loadingText", "iconSpacing", "type", "spinner", "spinnerPlacement", "className", "as"], xg = /* @__PURE__ */ kn(function(e, r) {
  var t = mte(), n = dg("Button", js({}, t, e)), a = cg(e), i = a.isDisabled, l = i === void 0 ? t == null ? void 0 : t.isDisabled : i, u = a.isLoading, c = a.isActive, f = a.isFullWidth, h = a.children, p = a.leftIcon, g = a.rightIcon, y = a.loadingText, S = a.iconSpacing, x = S === void 0 ? "0.5rem" : S, T = a.type, A = a.spinner, O = a.spinnerPlacement, P = O === void 0 ? "start" : O, j = a.className, k = a.as, L = _$(a, xte), M = I.useMemo(function() {
    var Te, $e = Ba({}, (Te = n == null ? void 0 : n._focus) != null ? Te : {}, {
      zIndex: 1
    });
    return js({
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none",
      width: f ? "100%" : "auto"
    }, n, !!t && {
      _focus: $e
    });
  }, [n, t, f]), W = Ste(k), q = W.ref, oe = W.type, Ae = {
    rightIcon: g,
    leftIcon: p,
    iconSpacing: x,
    children: h
  };
  return /* @__PURE__ */ I.createElement(Ht.button, js({
    disabled: l || u,
    ref: IV(r, q),
    as: k,
    type: T != null ? T : oe,
    "data-active": rC(c),
    "data-loading": rC(u),
    __css: M,
    className: Ha("chakra-button", j)
  }, L), u && P === "start" && /* @__PURE__ */ I.createElement(N4, {
    className: "chakra-button__spinner--start",
    label: y,
    placement: "start",
    spacing: x
  }, A), u ? y || /* @__PURE__ */ I.createElement(Ht.span, {
    opacity: 0
  }, /* @__PURE__ */ I.createElement(F4, Ae)) : /* @__PURE__ */ I.createElement(F4, Ae), u && P === "end" && /* @__PURE__ */ I.createElement(N4, {
    className: "chakra-button__spinner--end",
    label: y,
    placement: "end",
    spacing: x
  }, A));
});
function F4(e) {
  var r = e.leftIcon, t = e.rightIcon, n = e.children, a = e.iconSpacing;
  return /* @__PURE__ */ I.createElement(I.Fragment, null, r && /* @__PURE__ */ I.createElement(L4, {
    marginEnd: a
  }, r), n, t && /* @__PURE__ */ I.createElement(L4, {
    marginStart: a
  }, t));
}
function f0() {
  return f0 = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, f0.apply(this, arguments);
}
function iP(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var $te = Ec({
  strict: !1,
  name: "FormControlContext"
}), wte = $te[1], _te = ["isDisabled", "isInvalid", "isReadOnly", "isRequired"], Tte = ["id", "disabled", "readOnly", "required", "isRequired", "isInvalid", "isReadOnly", "isDisabled", "onFocus", "onBlur"];
function Cte(e) {
  var r = Ete(e), t = r.isDisabled, n = r.isInvalid, a = r.isReadOnly, i = r.isRequired, l = iP(r, _te);
  return f0({}, l, {
    disabled: t,
    readOnly: a,
    required: i,
    "aria-invalid": Ob(n),
    "aria-required": Ob(i),
    "aria-readonly": Ob(a)
  });
}
function Ete(e) {
  var r, t, n, a = wte(), i = e.id, l = e.disabled, u = e.readOnly, c = e.required, f = e.isRequired, h = e.isInvalid, p = e.isReadOnly, g = e.isDisabled, y = e.onFocus, S = e.onBlur, x = iP(e, Tte), T = e["aria-describedby"] ? [e["aria-describedby"]] : [];
  return a != null && a.hasFeedbackText && a != null && a.isInvalid && T.push(a.feedbackId), a != null && a.hasHelpText && T.push(a.helpTextId), f0({}, x, {
    "aria-describedby": T.join(" ") || void 0,
    id: i != null ? i : a == null ? void 0 : a.id,
    isDisabled: (r = l != null ? l : g) != null ? r : a == null ? void 0 : a.isDisabled,
    isReadOnly: (t = u != null ? u : p) != null ? t : a == null ? void 0 : a.isReadOnly,
    isRequired: (n = c != null ? c : f) != null ? n : a == null ? void 0 : a.isRequired,
    isInvalid: h != null ? h : a == null ? void 0 : a.isInvalid,
    onFocus: tC(a == null ? void 0 : a.onFocus, y),
    onBlur: tC(a == null ? void 0 : a.onBlur, S)
  });
}
function wo() {
  return wo = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, wo.apply(this, arguments);
}
function Wf(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var Ate = ["htmlSize"], KS = /* @__PURE__ */ kn(function(e, r) {
  var t = e.htmlSize, n = Wf(e, Ate), a = bH("Input", n), i = cg(n), l = Cte(i), u = Ha("chakra-input", e.className);
  return /* @__PURE__ */ I.createElement(Ht.input, wo({
    size: t
  }, l, {
    __css: a.field,
    ref: r,
    className: u
  }));
});
KS.id = "Input";
var Ite = ["placement"], Ote = {
  left: {
    marginEnd: "-1px",
    borderEndRadius: 0,
    borderEndColor: "transparent"
  },
  right: {
    marginStart: "-1px",
    borderStartRadius: 0,
    borderStartColor: "transparent"
  }
}, Mte = Ht("div", {
  baseStyle: {
    flex: "0 0 auto",
    width: "auto",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap"
  }
}), sP = /* @__PURE__ */ kn(function(e, r) {
  var t, n = e.placement, a = n === void 0 ? "left" : n, i = Wf(e, Ite), l = (t = Ote[a]) != null ? t : {}, u = gM();
  return /* @__PURE__ */ I.createElement(Mte, wo({
    ref: r
  }, i, {
    __css: wo({}, u.addon, l)
  }));
}), Rte = /* @__PURE__ */ kn(function(e, r) {
  return /* @__PURE__ */ I.createElement(sP, wo({
    ref: r,
    placement: "left"
  }, e, {
    className: Ha("chakra-input__left-addon", e.className)
  }));
});
Rte.id = "InputLeftAddon";
var Pte = /* @__PURE__ */ kn(function(e, r) {
  return /* @__PURE__ */ I.createElement(sP, wo({
    ref: r,
    placement: "right"
  }, e, {
    className: Ha("chakra-input__right-addon", e.className)
  }));
});
Pte.id = "InputRightAddon";
var kte = ["placement"], jte = ["className"], Dte = ["className"], Nte = Ht("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    zIndex: 2
  }
}), T$ = /* @__PURE__ */ kn(function(e, r) {
  var t, n, a, i = e.placement, l = i === void 0 ? "left" : i, u = Wf(e, kte), c = gM(), f = c.field, h = l === "left" ? "insetStart" : "insetEnd", p = wo((a = {}, a[h] = "0", a.width = (t = f == null ? void 0 : f.height) != null ? t : f == null ? void 0 : f.h, a.height = (n = f == null ? void 0 : f.height) != null ? n : f == null ? void 0 : f.h, a.fontSize = f == null ? void 0 : f.fontSize, a), c.element);
  return /* @__PURE__ */ I.createElement(Nte, wo({
    ref: r,
    __css: p
  }, u));
});
T$.id = "InputElement";
var Lte = /* @__PURE__ */ kn(function(e, r) {
  var t = e.className, n = Wf(e, jte), a = Ha("chakra-input__left-element", t);
  return /* @__PURE__ */ I.createElement(T$, wo({
    ref: r,
    placement: "left",
    className: a
  }, n));
});
Lte.id = "InputLeftElement";
var Fte = /* @__PURE__ */ kn(function(e, r) {
  var t = e.className, n = Wf(e, Dte), a = Ha("chakra-input__right-element", t);
  return /* @__PURE__ */ I.createElement(T$, wo({
    ref: r,
    placement: "right",
    className: a
  }, n));
});
Fte.id = "InputRightElement";
function Ns() {
  return Ns = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Ns.apply(this, arguments);
}
function C$(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var ln = Ht("div");
Ht("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});
var zte = ["direction", "align", "justify", "wrap", "basis", "grow", "shrink"], lP = /* @__PURE__ */ kn(function(e, r) {
  var t = e.direction, n = e.align, a = e.justify, i = e.wrap, l = e.basis, u = e.grow, c = e.shrink, f = C$(e, zte), h = {
    display: "flex",
    flexDirection: t,
    alignItems: n,
    justifyContent: a,
    flexWrap: i,
    flexBasis: l,
    flexGrow: u,
    flexShrink: c
  };
  return /* @__PURE__ */ I.createElement(Ht.div, Ns({
    ref: r,
    __css: h
  }, f));
});
Ec({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in a `<*List />` "
});
Ht("div", {
  baseStyle: {
    flex: 1,
    justifySelf: "stretch",
    alignSelf: "stretch"
  }
});
var qS = "& > *:not(style) ~ *:not(style)";
function Bte(e) {
  var r, t = e.spacing, n = e.direction, a = {
    column: {
      marginTop: t,
      marginEnd: 0,
      marginBottom: 0,
      marginStart: 0
    },
    row: {
      marginTop: 0,
      marginEnd: 0,
      marginBottom: 0,
      marginStart: t
    },
    "column-reverse": {
      marginTop: 0,
      marginEnd: 0,
      marginBottom: t,
      marginStart: 0
    },
    "row-reverse": {
      marginTop: 0,
      marginEnd: t,
      marginBottom: 0,
      marginStart: 0
    }
  };
  return r = {
    flexDirection: n
  }, r[qS] = JO(n, function(i) {
    return a[i];
  }), r;
}
function Ute(e) {
  var r = e.spacing, t = e.direction, n = {
    column: {
      my: r,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: r,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: r,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: r,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": JO(t, function(a) {
      return n[a];
    })
  };
}
var Vte = ["isInline", "direction", "align", "justify", "spacing", "wrap", "children", "divider", "className", "shouldWrapChildren"], Wte = function(r) {
  return /* @__PURE__ */ I.createElement(Ht.div, Ns({
    className: "chakra-stack__item"
  }, r, {
    __css: Ns({
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0
    }, r.__css)
  }));
}, uP = /* @__PURE__ */ kn(function(e, r) {
  var t, n = e.isInline, a = e.direction, i = e.align, l = e.justify, u = e.spacing, c = u === void 0 ? "0.5rem" : u, f = e.wrap, h = e.children, p = e.divider, g = e.className, y = e.shouldWrapChildren, S = C$(e, Vte), x = n ? "row" : a != null ? a : "column", T = I.useMemo(function() {
    return Bte({
      direction: x,
      spacing: c
    });
  }, [x, c]), A = I.useMemo(function() {
    return Ute({
      spacing: c,
      direction: x
    });
  }, [c, x]), O = !!p, P = !y && !O, j = _V(h), k = P ? j : j.map(function(M, W) {
    var q = typeof M.key != "undefined" ? M.key : W, oe = W + 1 === j.length, Ae = /* @__PURE__ */ I.createElement(Wte, {
      key: q
    }, M), Te = y ? Ae : M;
    if (!O)
      return Te;
    var $e = /* @__PURE__ */ I.cloneElement(p, {
      __css: A
    }), Ee = oe ? null : $e;
    return /* @__PURE__ */ I.createElement(I.Fragment, {
      key: q
    }, Te, Ee);
  }), L = Ha("chakra-stack", g);
  return /* @__PURE__ */ I.createElement(Ht.div, Ns({
    ref: r,
    display: "flex",
    alignItems: i,
    justifyContent: l,
    flexDirection: T.flexDirection,
    flexWrap: f,
    className: L,
    __css: O ? {} : (t = {}, t[qS] = T[qS], t)
  }, S), k);
}), ZS = /* @__PURE__ */ kn(function(e, r) {
  return /* @__PURE__ */ I.createElement(uP, Ns({
    align: "center"
  }, e, {
    direction: "row",
    ref: r
  }));
}), Hte = ["className", "align", "decoration", "casing"], bc = /* @__PURE__ */ kn(function(e, r) {
  var t = dg("Text", e), n = cg(e);
  n.className, n.align, n.decoration, n.casing;
  var a = C$(n, Hte), i = H2({
    textAlign: e.align,
    textDecoration: e.decoration,
    textTransform: e.casing
  });
  return /* @__PURE__ */ I.createElement(Ht.p, Ns({
    ref: r,
    className: Ha("chakra-text", e.className)
  }, i, a, {
    __css: t
  }));
}), Gte = Cc ? I.useLayoutEffect : I.useEffect;
function Yte(e) {
  var r = nM(), t = Array.isArray(e) ? e : [e], n = Cc && "matchMedia" in r.window, a = I.useState(t.map(function(u) {
    return n ? !!r.window.matchMedia(u).matches : !1;
  })), i = a[0], l = a[1];
  return Gte(function() {
    if (n) {
      var u = t.map(function(f) {
        return r.window.matchMedia(f);
      }), c = u.map(function(f, h) {
        var p = function(y) {
          var S = u.findIndex(function(x) {
            return x.media === y.media;
          });
          l(function(x) {
            var T = x.map(function(A) {
              return A;
            });
            return T[S] = y.matches, T;
          });
        };
        return typeof u[h].addEventListener == "function" ? u[h].addEventListener("change", p) : u[h].addListener(p), p;
      });
      return function() {
        u.forEach(function(f, h) {
          typeof u[h].removeEventListener == "function" ? u[h].removeEventListener("change", c[h]) : u[h].removeListener(c[h]);
        });
      };
    }
  }, []), i;
}
var cP = { exports: {} }, Kte = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", qte = Kte, Zte = qte;
function dP() {
}
function fP() {
}
fP.resetWarningCache = dP;
var Qte = function() {
  function e(n, a, i, l, u, c) {
    if (c !== Zte) {
      var f = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw f.name = "Invariant Violation", f;
    }
  }
  e.isRequired = e;
  function r() {
    return e;
  }
  var t = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: r,
    element: e,
    elementType: e,
    instanceOf: r,
    node: e,
    objectOf: r,
    oneOf: r,
    oneOfType: r,
    shape: r,
    exact: r,
    checkPropTypes: fP,
    resetWarningCache: dP
  };
  return t.PropTypes = t, t;
};
cP.exports = Qte();
var vP = cP.exports;
const et = /* @__PURE__ */ G0(vP);
var hP = SH;
hP.defaultProps = {
  theme: Df
};
function pP() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  var n = [].concat(r), a = r[r.length - 1];
  return pQ(a) && // this ensures backward compatibility
  // previously only `extendTheme(override, baseTheme?)` was allowed
  n.length > 1 ? n = n.slice(0, n.length - 1) : a = Df, wV.apply(void 0, n.map(function(i) {
    return function(l) {
      return Gu(i) ? i(l) : gP(l, i);
    };
  }))(a);
}
function gP() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return Ba.apply(void 0, [{}].concat(r, [mP]));
}
function mP(e, r, t, n) {
  if ((Gu(e) || Gu(r)) && Object.prototype.hasOwnProperty.call(n, t))
    return function() {
      var a = Gu(e) ? e.apply(void 0, arguments) : e, i = Gu(r) ? r.apply(void 0, arguments) : r;
      return Ba({}, a, i, mP);
    };
}
function Xte(e) {
  var r = e.colorScheme, t = e.components;
  return function(n) {
    var a = Object.keys(n.components || {});
    return Array.isArray(t) ? a = t : Rn(t) && (a = Object.keys(t)), gP(n, {
      components: Jd(a.map(function(i) {
        var l = {
          defaultProps: {
            colorScheme: r
          }
        };
        return [i, l];
      }))
    });
  };
}
function QS(e, r, t) {
  return sg.call(r, "css") ? _.jsx(YO, GO(e, r), t) : _.jsx(e, r, t);
}
function Jte(e, r, t) {
  return sg.call(r, "css") ? _.jsxs(YO, GO(e, r), t) : _.jsxs(e, r, t);
}
Ne({
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z",
  displayName: "CopyIcon"
});
Ne({
  d: "M23.384,21.619,16.855,15.09a9.284,9.284,0,1,0-1.768,1.768l6.529,6.529a1.266,1.266,0,0,0,1.768,0A1.251,1.251,0,0,0,23.384,21.619ZM2.75,9.5a6.75,6.75,0,1,1,6.75,6.75A6.758,6.758,0,0,1,2.75,9.5Z",
  displayName: "SearchIcon"
});
Ne({
  d: "M23.414,20.591l-4.645-4.645a10.256,10.256,0,1,0-2.828,2.829l4.645,4.644a2.025,2.025,0,0,0,2.828,0A2,2,0,0,0,23.414,20.591ZM10.25,3.005A7.25,7.25,0,1,1,3,10.255,7.258,7.258,0,0,1,10.25,3.005Z",
  displayName: "Search2Icon"
});
Ne({
  d: "M21.4,13.7C20.6,13.9,19.8,14,19,14c-5,0-9-4-9-9c0-0.8,0.1-1.6,0.3-2.4c0.1-0.3,0-0.7-0.3-1 c-0.3-0.3-0.6-0.4-1-0.3C4.3,2.7,1,7.1,1,12c0,6.1,4.9,11,11,11c4.9,0,9.3-3.3,10.6-8.1c0.1-0.3,0-0.7-0.3-1 C22.1,13.7,21.7,13.6,21.4,13.7z",
  displayName: "MoonIcon"
});
Ne({
  displayName: "SunIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: "2",
    fill: "none",
    stroke: "currentColor"
  }, /* @__PURE__ */ I.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "5"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M12 1v2"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M12 21v2"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M4.22 4.22l1.42 1.42"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M18.36 18.36l1.42 1.42"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M1 12h2"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M21 12h2"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M4.22 19.78l1.42-1.42"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M18.36 5.64l1.42-1.42"
  }))
});
Ne({
  d: "M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z",
  displayName: "AddIcon"
});
Ne({
  displayName: "SmallAddIcon",
  viewBox: "0 0 20 20",
  path: /* @__PURE__ */ I.createElement("path", {
    fill: "currentColor",
    d: "M14 9h-3V6c0-.55-.45-1-1-1s-1 .45-1 1v3H6c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1z",
    fillRule: "evenodd"
  })
});
Ne({
  viewBox: "0 0 14 14",
  d: "M14,7.77 L14,6.17 L12.06,5.53 L11.61,4.44 L12.49,2.6 L11.36,1.47 L9.55,2.38 L8.46,1.93 L7.77,0.01 L6.17,0.01 L5.54,1.95 L4.43,2.4 L2.59,1.52 L1.46,2.65 L2.37,4.46 L1.92,5.55 L0,6.23 L0,7.82 L1.94,8.46 L2.39,9.55 L1.51,11.39 L2.64,12.52 L4.45,11.61 L5.54,12.06 L6.23,13.98 L7.82,13.98 L8.45,12.04 L9.56,11.59 L11.4,12.47 L12.53,11.34 L11.61,9.53 L12.08,8.44 L14,7.75 L14,7.77 Z M7,10 C5.34,10 4,8.66 4,7 C4,5.34 5.34,4 7,4 C8.66,4 10,5.34 10,7 C10,8.66 8.66,10 7,10 Z",
  displayName: "SettingsIcon"
});
Ne({
  displayName: "CheckCircleIcon",
  d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
});
Ne({
  d: "M19.5,9.5h-.75V6.75a6.75,6.75,0,0,0-13.5,0V9.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5ZM7.75,6.75a4.25,4.25,0,0,1,8.5,0V9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5Z",
  displayName: "LockIcon"
});
Ne({
  d: "M19.5,9.5h-.75V6.75A6.751,6.751,0,0,0,5.533,4.811a1.25,1.25,0,1,0,2.395.717A4.251,4.251,0,0,1,16.25,6.75V9a.5.5,0,0,1-.5.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5Z",
  displayName: "UnlockIcon"
});
Ne({
  displayName: "ViewIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M23.432,10.524C20.787,7.614,16.4,4.538,12,4.6,7.6,4.537,3.213,7.615.568,10.524a2.211,2.211,0,0,0,0,2.948C3.182,16.351,7.507,19.4,11.839,19.4h.308c4.347,0,8.671-3.049,11.288-5.929A2.21,2.21,0,0,0,23.432,10.524ZM7.4,12A4.6,4.6,0,1,1,12,16.6,4.6,4.6,0,0,1,7.4,12Z"
  }), /* @__PURE__ */ I.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "2"
  }))
});
Ne({
  displayName: "ViewOffIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M23.2,10.549a20.954,20.954,0,0,0-4.3-3.6l4-3.995a1,1,0,1,0-1.414-1.414l-.018.018a.737.737,0,0,1-.173.291l-19.5,19.5c-.008.007-.018.009-.026.017a1,1,0,0,0,1.631,1.088l4.146-4.146a11.26,11.26,0,0,0,4.31.939h.3c4.256,0,8.489-2.984,11.051-5.8A2.171,2.171,0,0,0,23.2,10.549ZM16.313,13.27a4.581,4.581,0,0,1-3,3.028,4.3,4.3,0,0,1-3.1-.19.253.253,0,0,1-.068-.407l5.56-5.559a.252.252,0,0,1,.407.067A4.3,4.3,0,0,1,16.313,13.27Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M7.615,13.4a.244.244,0,0,0,.061-.24A4.315,4.315,0,0,1,7.5,12,4.5,4.5,0,0,1,12,7.5a4.276,4.276,0,0,1,1.16.173.244.244,0,0,0,.24-.062l1.941-1.942a.254.254,0,0,0-.1-.421A10.413,10.413,0,0,0,12,4.75C7.7,4.692,3.4,7.7.813,10.549a2.15,2.15,0,0,0-.007,2.9,21.209,21.209,0,0,0,3.438,3.03.256.256,0,0,0,.326-.029Z"
  }))
});
Ne({
  d: "M11.2857,6.05714 L10.08571,4.85714 L7.85714,7.14786 L7.85714,1 L6.14286,1 L6.14286,7.14786 L3.91429,4.85714 L2.71429,6.05714 L7,10.42857 L11.2857,6.05714 Z M1,11.2857 L1,13 L13,13 L13,11.2857 L1,11.2857 Z",
  displayName: "DownloadIcon",
  viewBox: "0 0 14 14"
});
Ne({
  displayName: "DeleteIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M19.452 7.5H4.547a.5.5 0 00-.5.545l1.287 14.136A2 2 0 007.326 24h9.347a2 2 0 001.992-1.819L19.95 8.045a.5.5 0 00-.129-.382.5.5 0 00-.369-.163zm-9.2 13a.75.75 0 01-1.5 0v-9a.75.75 0 011.5 0zm5 0a.75.75 0 01-1.5 0v-9a.75.75 0 011.5 0zM22 4h-4.75a.25.25 0 01-.25-.25V2.5A2.5 2.5 0 0014.5 0h-5A2.5 2.5 0 007 2.5v1.25a.25.25 0 01-.25.25H2a1 1 0 000 2h20a1 1 0 000-2zM9 3.75V2.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v1.25a.25.25 0 01-.25.25h-5.5A.25.25 0 019 3.75z"
  }))
});
Ne({
  displayName: "RepeatIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M10.319,4.936a7.239,7.239,0,0,1,7.1,2.252,1.25,1.25,0,1,0,1.872-1.657A9.737,9.737,0,0,0,9.743,2.5,10.269,10.269,0,0,0,2.378,9.61a.249.249,0,0,1-.271.178l-1.033-.13A.491.491,0,0,0,.6,9.877a.5.5,0,0,0-.019.526l2.476,4.342a.5.5,0,0,0,.373.248.43.43,0,0,0,.062,0,.5.5,0,0,0,.359-.152l3.477-3.593a.5.5,0,0,0-.3-.844L5.15,10.172a.25.25,0,0,1-.2-.333A7.7,7.7,0,0,1,10.319,4.936Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M23.406,14.1a.5.5,0,0,0,.015-.526l-2.5-4.329A.5.5,0,0,0,20.546,9a.489.489,0,0,0-.421.151l-3.456,3.614a.5.5,0,0,0,.3.842l1.848.221a.249.249,0,0,1,.183.117.253.253,0,0,1,.023.216,7.688,7.688,0,0,1-5.369,4.9,7.243,7.243,0,0,1-7.1-2.253,1.25,1.25,0,1,0-1.872,1.656,9.74,9.74,0,0,0,9.549,3.03,10.261,10.261,0,0,0,7.369-7.12.251.251,0,0,1,.27-.179l1.058.127a.422.422,0,0,0,.06,0A.5.5,0,0,0,23.406,14.1Z"
  }))
});
Ne({
  displayName: "RepeatClockIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M12.965,6a1,1,0,0,0-1,1v5.5a1,1,0,0,0,1,1h5a1,1,0,0,0,0-2h-3.75a.25.25,0,0,1-.25-.25V7A1,1,0,0,0,12.965,6Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M12.567,1.258A10.822,10.822,0,0,0,2.818,8.4a.25.25,0,0,1-.271.163L.858,8.309a.514.514,0,0,0-.485.213.5.5,0,0,0-.021.53l2.679,4.7a.5.5,0,0,0,.786.107l3.77-3.746a.5.5,0,0,0-.279-.85L5.593,9.007a.25.25,0,0,1-.192-.35,8.259,8.259,0,1,1,7.866,11.59,1.25,1.25,0,0,0,.045,2.5h.047a10.751,10.751,0,1,0-.792-21.487Z"
  }))
});
Ne({
  displayName: "EditIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
  }))
});
Ne({
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z",
  displayName: "ChevronLeftIcon"
});
Ne({
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z",
  displayName: "ChevronRightIcon"
});
Ne({
  displayName: "ChevronDownIcon",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
});
Ne({
  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z",
  displayName: "ChevronUpIcon"
});
Ne({
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z",
  displayName: "ArrowBackIcon"
});
Ne({
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z",
  displayName: "ArrowForwardIcon"
});
Ne({
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z",
  displayName: "ArrowUpIcon"
});
Ne({
  viewBox: "0 0 16 16",
  d: "M11.891 9.992a1 1 0 1 1 1.416 1.415l-4.3 4.3a1 1 0 0 1-1.414 0l-4.3-4.3A1 1 0 0 1 4.71 9.992l3.59 3.591 3.591-3.591zm0-3.984L8.3 2.417 4.709 6.008a1 1 0 0 1-1.416-1.415l4.3-4.3a1 1 0 0 1 1.414 0l4.3 4.3a1 1 0 1 1-1.416 1.415z",
  displayName: "ArrowUpDownIcon"
});
Ne({
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z",
  displayName: "ArrowDownIcon"
});
Ne({
  displayName: "ExternalLinkIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M15 3h6v6"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M10 14L21 3"
  }))
});
Ne({
  displayName: "LinkIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M10.458,18.374,7.721,21.11a2.853,2.853,0,0,1-3.942,0l-.892-.891a2.787,2.787,0,0,1,0-3.941l5.8-5.8a2.789,2.789,0,0,1,3.942,0l.893.892A1,1,0,0,0,14.94,9.952l-.893-.892a4.791,4.791,0,0,0-6.771,0l-5.8,5.8a4.787,4.787,0,0,0,0,6.77l.892.891a4.785,4.785,0,0,0,6.771,0l2.736-2.735a1,1,0,1,0-1.414-1.415Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M22.526,2.363l-.892-.892a4.8,4.8,0,0,0-6.77,0l-2.905,2.9a1,1,0,0,0,1.414,1.414l2.9-2.9a2.79,2.79,0,0,1,3.941,0l.893.893a2.786,2.786,0,0,1,0,3.942l-5.8,5.8a2.769,2.769,0,0,1-1.971.817h0a2.766,2.766,0,0,1-1.969-.816,1,1,0,1,0-1.415,1.412,4.751,4.751,0,0,0,3.384,1.4h0a4.752,4.752,0,0,0,3.385-1.4l5.8-5.8a4.786,4.786,0,0,0,0-6.771Z"
  }))
});
Ne({
  displayName: "PlusSquareIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, /* @__PURE__ */ I.createElement("rect", {
    height: "18",
    width: "18",
    rx: "2",
    ry: "2",
    x: "3",
    y: "3"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M12 8v8"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M8 12h8"
  }))
});
Ne({
  displayName: "CalendarIcon",
  viewBox: "0 0 14 14",
  d: "M10.8889,5.5 L3.11111,5.5 L3.11111,7.05556 L10.8889,7.05556 L10.8889,5.5 Z M12.4444,1.05556 L11.6667,1.05556 L11.6667,0 L10.1111,0 L10.1111,1.05556 L3.88889,1.05556 L3.88889,0 L2.33333,0 L2.33333,1.05556 L1.55556,1.05556 C0.692222,1.05556 0.00777777,1.75556 0.00777777,2.61111 L0,12.5 C0,13.3556 0.692222,14 1.55556,14 L12.4444,14 C13.3,14 14,13.3556 14,12.5 L14,2.61111 C14,1.75556 13.3,1.05556 12.4444,1.05556 Z M12.4444,12.5 L1.55556,12.5 L1.55556,3.94444 L12.4444,3.94444 L12.4444,12.5 Z M8.55556,8.61111 L3.11111,8.61111 L3.11111,10.1667 L8.55556,10.1667 L8.55556,8.61111 Z"
});
Ne({
  d: "M0.913134,0.920639 C1.49851,0.331726 2.29348,0 3.12342,0 L10.8766,0 C11.7065,0 12.5015,0.331725 13.0869,0.920639 C13.6721,1.50939 14,2.30689 14,3.13746 L14,8.12943 C13.9962,8.51443 13.9059,8.97125 13.7629,9.32852 C13.6128,9.683 13.3552,10.0709 13.0869,10.3462 C12.813,10.6163 12.4265,10.8761 12.0734,11.0274 C11.7172,11.1716 11.2607,11.263 10.8766,11.2669 L10.1234,11.2669 L10.1234,12.5676 L10.1209,12.5676 C10.1204,12.793 10.0633,13.0791 9.97807,13.262 C9.8627,13.466 9.61158,13.7198 9.40818,13.8382 L9.40824,13.8383 C9.4077,13.8386 9.40716,13.8388 9.40661,13.8391 C9.40621,13.8393 9.4058,13.8396 9.40539,13.8398 L9.40535,13.8397 C9.22958,13.9254 8.94505,13.9951 8.75059,14 L8.74789,14 C8.35724,13.9963 7.98473,13.8383 7.71035,13.5617 L5.39553,11.2669 L3.12342,11.2669 C2.29348,11.2669 1.49851,10.9352 0.913134,10.3462 C0.644826,10.0709 0.387187,9.683 0.23711,9.32852 C0.0941235,8.97125 0.00379528,8.51443 0,8.12943 L0,3.13746 C0,2.30689 0.327915,1.50939 0.913134,0.920639 Z M3.12342,1.59494 C2.71959,1.59494 2.33133,1.75628 2.04431,2.04503 C1.75713,2.33395 1.59494,2.72681 1.59494,3.13746 L1.59494,8.12943 C1.59114,8.35901 1.62114,8.51076 1.71193,8.72129 C1.79563,8.9346 1.88065,9.06264 2.04431,9.22185 C2.33133,9.5106 2.71959,9.67195 3.12342,9.67195 L5.72383,9.67195 C5.93413,9.67195 6.13592,9.75502 6.28527,9.90308 L8.52848,12.1269 L8.52848,10.4694 C8.52848,10.029 8.88552,9.67195 9.32595,9.67195 L10.8766,9.67195 C11.1034,9.67583 11.2517,9.64614 11.4599,9.55518 C11.6712,9.47132 11.7976,9.38635 11.9557,9.22185 C12.1193,9.06264 12.2044,8.9346 12.2881,8.72129 C12.3789,8.51076 12.4089,8.35901 12.4051,8.12943 L12.4051,3.13746 C12.4051,2.72681 12.2429,2.33394 11.9557,2.04503 C11.6687,1.75628 11.2804,1.59494 10.8766,1.59494 L3.12342,1.59494 Z",
  displayName: "ChatIcon",
  viewBox: "0 0 14 14"
});
Ne({
  displayName: "TimeIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M17.134,15.81,12.5,11.561V6.5a1,1,0,0,0-2,0V12a1,1,0,0,0,.324.738l4.959,4.545a1.01,1.01,0,0,0,1.413-.061A1,1,0,0,0,17.134,15.81Z"
  }))
});
Ne({
  displayName: "ArrowRightIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M13.584,12a2.643,2.643,0,0,1-.775,1.875L3.268,23.416a1.768,1.768,0,0,1-2.5-2.5l8.739-8.739a.25.25,0,0,0,0-.354L.768,3.084a1.768,1.768,0,0,1,2.5-2.5l9.541,9.541A2.643,2.643,0,0,1,13.584,12Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M23.75,12a2.643,2.643,0,0,1-.775,1.875l-9.541,9.541a1.768,1.768,0,0,1-2.5-2.5l8.739-8.739a.25.25,0,0,0,0-.354L10.934,3.084a1.768,1.768,0,0,1,2.5-2.5l9.541,9.541A2.643,2.643,0,0,1,23.75,12Z"
  }))
});
Ne({
  displayName: "ArrowLeftIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M10.416,12a2.643,2.643,0,0,1,.775-1.875L20.732.584a1.768,1.768,0,0,1,2.5,2.5l-8.739,8.739a.25.25,0,0,0,0,.354l8.739,8.739a1.768,1.768,0,0,1-2.5,2.5l-9.541-9.541A2.643,2.643,0,0,1,10.416,12Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M.25,12a2.643,2.643,0,0,1,.775-1.875L10.566.584a1.768,1.768,0,0,1,2.5,2.5L4.327,11.823a.25.25,0,0,0,0,.354l8.739,8.739a1.768,1.768,0,0,1-2.5,2.5L1.025,13.875A2.643,2.643,0,0,1,.25,12Z"
  }))
});
Ne({
  displayName: "AtSignIcon",
  d: "M12,.5A11.634,11.634,0,0,0,.262,12,11.634,11.634,0,0,0,12,23.5a11.836,11.836,0,0,0,6.624-2,1.25,1.25,0,1,0-1.393-2.076A9.34,9.34,0,0,1,12,21a9.132,9.132,0,0,1-9.238-9A9.132,9.132,0,0,1,12,3a9.132,9.132,0,0,1,9.238,9v.891a1.943,1.943,0,0,1-3.884,0V12A5.355,5.355,0,1,0,12,17.261a5.376,5.376,0,0,0,3.861-1.634,4.438,4.438,0,0,0,7.877-2.736V12A11.634,11.634,0,0,0,12,.5Zm0,14.261A2.763,2.763,0,1,1,14.854,12,2.812,2.812,0,0,1,12,14.761Z"
});
Ne({
  displayName: "AttachmentIcon",
  d: "M21.843,3.455a6.961,6.961,0,0,0-9.846,0L1.619,13.832a5.128,5.128,0,0,0,7.252,7.252L17.3,12.653A3.293,3.293,0,1,0,12.646,8L7.457,13.184A1,1,0,1,0,8.871,14.6L14.06,9.409a1.294,1.294,0,0,1,1.829,1.83L7.457,19.67a3.128,3.128,0,0,1-4.424-4.424L13.411,4.869a4.962,4.962,0,1,1,7.018,7.018L12.646,19.67a1,1,0,1,0,1.414,1.414L21.843,13.3a6.96,6.96,0,0,0,0-9.846Z"
});
Ne({
  displayName: "UpDownIcon",
  viewBox: "-1 -1 9 11",
  d: "M 3.5 0L 3.98809 -0.569442L 3.5 -0.987808L 3.01191 -0.569442L 3.5 0ZM 3.5 9L 3.01191 9.56944L 3.5 9.98781L 3.98809 9.56944L 3.5 9ZM 0.488094 3.56944L 3.98809 0.569442L 3.01191 -0.569442L -0.488094 2.43056L 0.488094 3.56944ZM 3.01191 0.569442L 6.51191 3.56944L 7.48809 2.43056L 3.98809 -0.569442L 3.01191 0.569442ZM -0.488094 6.56944L 3.01191 9.56944L 3.98809 8.43056L 0.488094 5.43056L -0.488094 6.56944ZM 3.98809 9.56944L 7.48809 6.56944L 6.51191 5.43056L 3.01191 8.43056L 3.98809 9.56944Z"
});
Ne({
  d: "M23.555,8.729a1.505,1.505,0,0,0-1.406-.98H16.062a.5.5,0,0,1-.472-.334L13.405,1.222a1.5,1.5,0,0,0-2.81,0l-.005.016L8.41,7.415a.5.5,0,0,1-.471.334H1.85A1.5,1.5,0,0,0,.887,10.4l5.184,4.3a.5.5,0,0,1,.155.543L4.048,21.774a1.5,1.5,0,0,0,2.31,1.684l5.346-3.92a.5.5,0,0,1,.591,0l5.344,3.919a1.5,1.5,0,0,0,2.312-1.683l-2.178-6.535a.5.5,0,0,1,.155-.543l5.194-4.306A1.5,1.5,0,0,0,23.555,8.729Z",
  displayName: "StarIcon"
});
Ne({
  displayName: "EmailIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M11.114,14.556a1.252,1.252,0,0,0,1.768,0L22.568,4.87a.5.5,0,0,0-.281-.849A1.966,1.966,0,0,0,22,4H2a1.966,1.966,0,0,0-.289.021.5.5,0,0,0-.281.849Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M23.888,5.832a.182.182,0,0,0-.2.039l-6.2,6.2a.251.251,0,0,0,0,.354l5.043,5.043a.75.75,0,1,1-1.06,1.061l-5.043-5.043a.25.25,0,0,0-.354,0l-2.129,2.129a2.75,2.75,0,0,1-3.888,0L7.926,13.488a.251.251,0,0,0-.354,0L2.529,18.531a.75.75,0,0,1-1.06-1.061l5.043-5.043a.251.251,0,0,0,0-.354l-6.2-6.2a.18.18,0,0,0-.2-.039A.182.182,0,0,0,0,6V18a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6A.181.181,0,0,0,23.888,5.832Z"
  }))
});
Ne({
  d: "M2.20731,0.0127209 C2.1105,-0.0066419 1.99432,-0.00664663 1.91687,0.032079 C0.871279,0.438698 0.212942,1.92964 0.0580392,2.95587 C-0.426031,6.28627 2.20731,9.17133 4.62766,11.0689 C6.77694,12.7534 10.9012,15.5223 13.3409,12.8503 C13.6507,12.5211 14.0186,12.037 13.9993,11.553 C13.9412,10.7397 13.186,10.1588 12.6051,9.71349 C12.1598,9.38432 11.2304,8.47427 10.6495,8.49363 C10.1267,8.51299 9.79754,9.05515 9.46837,9.38432 L8.88748,9.96521 C8.79067,10.062 7.55145,9.24878 7.41591,9.15197 C6.91248,8.8228 6.4284,8.45491 6.00242,8.04829 C5.57644,7.64167 5.18919,7.19632 4.86002,6.73161 C4.7632,6.59607 3.96933,5.41495 4.04678,5.31813 C4.04678,5.31813 4.72448,4.58234 4.91811,4.2919 C5.32473,3.67229 5.63453,3.18822 5.16982,2.45243 C4.99556,2.18135 4.78257,1.96836 4.55021,1.73601 C4.14359,1.34875 3.73698,0.942131 3.27227,0.612963 C3.02055,0.419335 2.59457,0.0708094 2.20731,0.0127209 Z",
  displayName: "PhoneIcon",
  viewBox: "0 0 14 14"
});
Ne({
  viewBox: "0 0 10 10",
  d: "M3,2 C2.44771525,2 2,1.55228475 2,1 C2,0.44771525 2.44771525,0 3,0 C3.55228475,0 4,0.44771525 4,1 C4,1.55228475 3.55228475,2 3,2 Z M3,6 C2.44771525,6 2,5.55228475 2,5 C2,4.44771525 2.44771525,4 3,4 C3.55228475,4 4,4.44771525 4,5 C4,5.55228475 3.55228475,6 3,6 Z M3,10 C2.44771525,10 2,9.55228475 2,9 C2,8.44771525 2.44771525,8 3,8 C3.55228475,8 4,8.44771525 4,9 C4,9.55228475 3.55228475,10 3,10 Z M7,2 C6.44771525,2 6,1.55228475 6,1 C6,0.44771525 6.44771525,0 7,0 C7.55228475,0 8,0.44771525 8,1 C8,1.55228475 7.55228475,2 7,2 Z M7,6 C6.44771525,6 6,5.55228475 6,5 C6,4.44771525 6.44771525,4 7,4 C7.55228475,4 8,4.44771525 8,5 C8,5.55228475 7.55228475,6 7,6 Z M7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 Z",
  displayName: "DragHandleIcon"
});
Ne({
  displayName: "SpinnerIcon",
  path: /* @__PURE__ */ I.createElement(I.Fragment, null, /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("linearGradient", {
    x1: "28.154%",
    y1: "63.74%",
    x2: "74.629%",
    y2: "17.783%",
    id: "a"
  }, /* @__PURE__ */ I.createElement("stop", {
    stopColor: "currentColor",
    offset: "0%"
  }), /* @__PURE__ */ I.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: "0",
    offset: "100%"
  }))), /* @__PURE__ */ I.createElement("g", {
    transform: "translate(2)",
    fill: "none"
  }, /* @__PURE__ */ I.createElement("circle", {
    stroke: "url(#a)",
    strokeWidth: "4",
    cx: "10",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M10 2C4.477 2 0 6.477 0 12",
    stroke: "currentColor",
    strokeWidth: "4"
  }), /* @__PURE__ */ I.createElement("rect", {
    fill: "currentColor",
    x: "8",
    width: "4",
    height: "4",
    rx: "8"
  })))
});
var ene = Ne({
  displayName: "CloseIcon",
  d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
});
Ne({
  displayName: "SmallCloseIcon",
  viewBox: "0 0 16 16",
  path: /* @__PURE__ */ I.createElement("path", {
    d: "M9.41 8l2.29-2.29c.19-.18.3-.43.3-.71a1.003 1.003 0 0 0-1.71-.71L8 6.59l-2.29-2.3a1.003 1.003 0 0 0-1.42 1.42L6.59 8 4.3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 0 0 1.71.71L8 9.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 0 0 .71-1.71L9.41 8z",
    fillRule: "evenodd",
    fill: "currentColor"
  })
});
Ne({
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z",
  displayName: "NotAllowedIcon"
});
Ne({
  d: "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z",
  displayName: "TriangleDownIcon"
});
Ne({
  d: "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z",
  displayName: "TriangleUpIcon"
});
Ne({
  displayName: "InfoOutlineIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, /* @__PURE__ */ I.createElement("circle", {
    cx: "12",
    cy: "12",
    fill: "none",
    r: "11",
    stroke: "currentColor"
  }), /* @__PURE__ */ I.createElement("line", {
    fill: "none",
    x1: "11.959",
    x2: "11.959",
    y1: "11",
    y2: "17"
  }), /* @__PURE__ */ I.createElement("circle", {
    cx: "11.959",
    cy: "7",
    r: "1",
    stroke: "none"
  }))
});
Ne({
  displayName: "BellIcon",
  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
});
Ne({
  d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
});
Ne({
  d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,19a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,19Zm1.6-6.08a1,1,0,0,0-.6.917,1,1,0,1,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,10,9.255a1,1,0,1,1-2,0,4,4,0,1,1,5.6,3.666Z",
  displayName: "QuestionIcon"
});
Ne({
  displayName: "QuestionOutlineIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "1.5"
  }, /* @__PURE__ */ I.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
  }), /* @__PURE__ */ I.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
  }), /* @__PURE__ */ I.createElement("circle", {
    fill: "none",
    strokeMiterlimit: "10",
    cx: "12",
    cy: "12",
    r: "11.25"
  }))
});
Ne({
  d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z",
  displayName: "WarningIcon"
});
Ne({
  displayName: "WarningTwoIcon",
  d: "M23.119,20,13.772,2.15h0a2,2,0,0,0-3.543,0L.881,20a2,2,0,0,0,1.772,2.928H21.347A2,2,0,0,0,23.119,20ZM11,8.423a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Zm1.05,11.51h-.028a1.528,1.528,0,0,1-1.522-1.47,1.476,1.476,0,0,1,1.448-1.53h.028A1.527,1.527,0,0,1,13.5,18.4,1.475,1.475,0,0,1,12.05,19.933Z"
});
Ne({
  viewBox: "0 0 14 14",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("polygon", {
    points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
  }))
});
Ne({
  displayName: "MinusIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("rect", {
    height: "4",
    width: "20",
    x: "2",
    y: "10"
  }))
});
Ne({
  displayName: "HamburgerIcon",
  viewBox: "0 0 24 24",
  d: "M 3 5 A 1.0001 1.0001 0 1 0 3 7 L 21 7 A 1.0001 1.0001 0 1 0 21 5 L 3 5 z M 3 11 A 1.0001 1.0001 0 1 0 3 13 L 21 13 A 1.0001 1.0001 0 1 0 21 11 L 3 11 z M 3 17 A 1.0001 1.0001 0 1 0 3 19 L 21 19 A 1.0001 1.0001 0 1 0 21 17 L 3 17 z"
});
var zl = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, fh = function(e) {
  return e && e.Math == Math && e;
}, fn = (
  // eslint-disable-next-line es/no-global-this -- safe
  fh(typeof globalThis == "object" && globalThis) || fh(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  fh(typeof self == "object" && self) || fh(typeof zl == "object" && zl) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || zl || Function("return this")()
), $g = {}, jn = function(e) {
  try {
    return !!e();
  } catch (r) {
    return !0;
  }
}, rne = jn, Ya = !rne(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] != 7;
}), tne = jn, wg = !tne(function() {
  var e = function() {
  }.bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), nne = wg, vh = Function.prototype.call, wa = nne ? vh.bind(vh) : function() {
  return vh.apply(vh, arguments);
}, E$ = {}, bP = {}.propertyIsEnumerable, yP = Object.getOwnPropertyDescriptor, ane = yP && !bP.call({ 1: 2 }, 1);
E$.f = ane ? function(r) {
  var t = yP(this, r);
  return !!t && t.enumerable;
} : bP;
var A$ = function(e, r) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: r
  };
}, SP = wg, xP = Function.prototype, XS = xP.call, one = SP && xP.bind.bind(XS, XS), Dn = SP ? one : function(e) {
  return function() {
    return XS.apply(e, arguments);
  };
}, $P = Dn, ine = $P({}.toString), sne = $P("".slice), _g = function(e) {
  return sne(ine(e), 8, -1);
}, lne = Dn, une = jn, cne = _g, n1 = Object, dne = lne("".split), wP = une(function() {
  return !n1("z").propertyIsEnumerable(0);
}) ? function(e) {
  return cne(e) == "String" ? dne(e, "") : n1(e);
} : n1, Tg = function(e) {
  return e == null;
}, fne = Tg, vne = TypeError, _P = function(e) {
  if (fne(e))
    throw vne("Can't call method on " + e);
  return e;
}, hne = wP, pne = _P, Hf = function(e) {
  return hne(pne(e));
}, JS = typeof document == "object" && document.all, gne = typeof JS == "undefined" && JS !== void 0, TP = {
  all: JS,
  IS_HTMLDDA: gne
}, CP = TP, mne = CP.all, Mt = CP.IS_HTMLDDA ? function(e) {
  return typeof e == "function" || e === mne;
} : function(e) {
  return typeof e == "function";
}, z4 = Mt, EP = TP, bne = EP.all, Us = EP.IS_HTMLDDA ? function(e) {
  return typeof e == "object" ? e !== null : z4(e) || e === bne;
} : function(e) {
  return typeof e == "object" ? e !== null : z4(e);
}, a1 = fn, yne = Mt, Sne = function(e) {
  return yne(e) ? e : void 0;
}, lu = function(e, r) {
  return arguments.length < 2 ? Sne(a1[e]) : a1[e] && a1[e][r];
}, xne = Dn, Gf = xne({}.isPrototypeOf), Cg = typeof navigator != "undefined" && String(navigator.userAgent) || "", AP = fn, o1 = Cg, B4 = AP.process, U4 = AP.Deno, V4 = B4 && B4.versions || U4 && U4.version, W4 = V4 && V4.v8, yo, v0;
W4 && (yo = W4.split("."), v0 = yo[0] > 0 && yo[0] < 4 ? 1 : +(yo[0] + yo[1]));
!v0 && o1 && (yo = o1.match(/Edge\/(\d+)/), (!yo || yo[1] >= 74) && (yo = o1.match(/Chrome\/(\d+)/), yo && (v0 = +yo[1])));
var IP = v0, H4 = IP, $ne = jn, wne = fn, _ne = wne.String, OP = !!Object.getOwnPropertySymbols && !$ne(function() {
  var e = Symbol();
  return !_ne(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && H4 && H4 < 41;
}), Tne = OP, MP = Tne && !Symbol.sham && typeof Symbol.iterator == "symbol", Cne = lu, Ene = Mt, Ane = Gf, Ine = MP, One = Object, RP = Ine ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var r = Cne("Symbol");
  return Ene(r) && Ane(r.prototype, One(e));
}, Mne = String, Eg = function(e) {
  try {
    return Mne(e);
  } catch (r) {
    return "Object";
  }
}, Rne = Mt, Pne = Eg, kne = TypeError, Vs = function(e) {
  if (Rne(e))
    return e;
  throw kne(Pne(e) + " is not a function");
}, jne = Vs, Dne = Tg, I$ = function(e, r) {
  var t = e[r];
  return Dne(t) ? void 0 : jne(t);
}, i1 = wa, s1 = Mt, l1 = Us, Nne = TypeError, Lne = function(e, r) {
  var t, n;
  if (r === "string" && s1(t = e.toString) && !l1(n = i1(t, e)) || s1(t = e.valueOf) && !l1(n = i1(t, e)) || r !== "string" && s1(t = e.toString) && !l1(n = i1(t, e)))
    return n;
  throw Nne("Can't convert object to primitive value");
}, O$ = { exports: {} }, G4 = fn, Fne = Object.defineProperty, M$ = function(e, r) {
  try {
    Fne(G4, e, { value: r, configurable: !0, writable: !0 });
  } catch (t) {
    G4[e] = r;
  }
  return r;
}, zne = fn, Bne = M$, Y4 = "__core-js_shared__", Une = zne[Y4] || Bne(Y4, {}), R$ = Une, K4 = R$;
(O$.exports = function(e, r) {
  return K4[e] || (K4[e] = r !== void 0 ? r : {});
})("versions", []).push({
  version: "3.31.0",
  mode: "global",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.31.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var Vne = _P, Wne = Object, P$ = function(e) {
  return Wne(Vne(e));
}, Hne = Dn, Gne = P$, Yne = Hne({}.hasOwnProperty), Ka = Object.hasOwn || function(r, t) {
  return Yne(Gne(r), t);
}, Kne = Dn, qne = 0, Zne = Math.random(), Qne = Kne(1 .toString), PP = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + Qne(++qne + Zne, 36);
}, Xne = fn, Jne = O$.exports, q4 = Ka, eae = PP, rae = OP, tae = MP, qu = Xne.Symbol, u1 = Jne("wks"), nae = tae ? qu.for || qu : qu && qu.withoutSetter || eae, Xn = function(e) {
  return q4(u1, e) || (u1[e] = rae && q4(qu, e) ? qu[e] : nae("Symbol." + e)), u1[e];
}, aae = wa, Z4 = Us, Q4 = RP, oae = I$, iae = Lne, sae = Xn, lae = TypeError, uae = sae("toPrimitive"), cae = function(e, r) {
  if (!Z4(e) || Q4(e))
    return e;
  var t = oae(e, uae), n;
  if (t) {
    if (r === void 0 && (r = "default"), n = aae(t, e, r), !Z4(n) || Q4(n))
      return n;
    throw lae("Can't convert object to primitive value");
  }
  return r === void 0 && (r = "number"), iae(e, r);
}, dae = cae, fae = RP, kP = function(e) {
  var r = dae(e, "string");
  return fae(r) ? r : r + "";
}, vae = fn, X4 = Us, ex = vae.document, hae = X4(ex) && X4(ex.createElement), Ag = function(e) {
  return hae ? ex.createElement(e) : {};
}, pae = Ya, gae = jn, mae = Ag, jP = !pae && !gae(function() {
  return Object.defineProperty(mae("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
}), bae = Ya, yae = wa, Sae = E$, xae = A$, $ae = Hf, wae = kP, _ae = Ka, Tae = jP, J4 = Object.getOwnPropertyDescriptor;
$g.f = bae ? J4 : function(r, t) {
  if (r = $ae(r), t = wae(t), Tae)
    try {
      return J4(r, t);
    } catch (n) {
    }
  if (_ae(r, t))
    return xae(!yae(Sae.f, r, t), r[t]);
};
var Bi = {}, Cae = Ya, Eae = jn, DP = Cae && Eae(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype != 42;
}), Aae = Us, Iae = String, Oae = TypeError, qa = function(e) {
  if (Aae(e))
    return e;
  throw Oae(Iae(e) + " is not an object");
}, Mae = Ya, Rae = jP, Pae = DP, hh = qa, eE = kP, kae = TypeError, c1 = Object.defineProperty, jae = Object.getOwnPropertyDescriptor, d1 = "enumerable", f1 = "configurable", v1 = "writable";
Bi.f = Mae ? Pae ? function(r, t, n) {
  if (hh(r), t = eE(t), hh(n), typeof r == "function" && t === "prototype" && "value" in n && v1 in n && !n[v1]) {
    var a = jae(r, t);
    a && a[v1] && (r[t] = n.value, n = {
      configurable: f1 in n ? n[f1] : a[f1],
      enumerable: d1 in n ? n[d1] : a[d1],
      writable: !1
    });
  }
  return c1(r, t, n);
} : c1 : function(r, t, n) {
  if (hh(r), t = eE(t), hh(n), Rae)
    try {
      return c1(r, t, n);
    } catch (a) {
    }
  if ("get" in n || "set" in n)
    throw kae("Accessors not supported");
  return "value" in n && (r[t] = n.value), r;
};
var Dae = Ya, Nae = Bi, Lae = A$, Ig = Dae ? function(e, r, t) {
  return Nae.f(e, r, Lae(1, t));
} : function(e, r, t) {
  return e[r] = t, e;
}, k$ = { exports: {} }, rx = Ya, Fae = Ka, NP = Function.prototype, zae = rx && Object.getOwnPropertyDescriptor, j$ = Fae(NP, "name"), Bae = j$ && function() {
}.name === "something", Uae = j$ && (!rx || rx && zae(NP, "name").configurable), D$ = {
  EXISTS: j$,
  PROPER: Bae,
  CONFIGURABLE: Uae
}, Vae = Dn, Wae = Mt, tx = R$, Hae = Vae(Function.toString);
Wae(tx.inspectSource) || (tx.inspectSource = function(e) {
  return Hae(e);
});
var N$ = tx.inspectSource, Gae = fn, Yae = Mt, rE = Gae.WeakMap, Kae = Yae(rE) && /native code/.test(String(rE)), qae = O$.exports, Zae = PP, tE = qae("keys"), L$ = function(e) {
  return tE[e] || (tE[e] = Zae(e));
}, F$ = {}, Qae = Kae, LP = fn, Xae = Us, Jae = Ig, h1 = Ka, p1 = R$, eoe = L$, roe = F$, nE = "Object already initialized", nx = LP.TypeError, toe = LP.WeakMap, h0, vf, p0, noe = function(e) {
  return p0(e) ? vf(e) : h0(e, {});
}, aoe = function(e) {
  return function(r) {
    var t;
    if (!Xae(r) || (t = vf(r)).type !== e)
      throw nx("Incompatible receiver, " + e + " required");
    return t;
  };
};
if (Qae || p1.state) {
  var Bo = p1.state || (p1.state = new toe());
  Bo.get = Bo.get, Bo.has = Bo.has, Bo.set = Bo.set, h0 = function(e, r) {
    if (Bo.has(e))
      throw nx(nE);
    return r.facade = e, Bo.set(e, r), r;
  }, vf = function(e) {
    return Bo.get(e) || {};
  }, p0 = function(e) {
    return Bo.has(e);
  };
} else {
  var Ru = eoe("state");
  roe[Ru] = !0, h0 = function(e, r) {
    if (h1(e, Ru))
      throw nx(nE);
    return r.facade = e, Jae(e, Ru, r), r;
  }, vf = function(e) {
    return h1(e, Ru) ? e[Ru] : {};
  }, p0 = function(e) {
    return h1(e, Ru);
  };
}
var z$ = {
  set: h0,
  get: vf,
  has: p0,
  enforce: noe,
  getterFor: aoe
}, B$ = Dn, ooe = jn, ioe = Mt, ph = Ka, ax = Ya, soe = D$.CONFIGURABLE, loe = N$, FP = z$, uoe = FP.enforce, coe = FP.get, aE = String, Tp = Object.defineProperty, doe = B$("".slice), foe = B$("".replace), voe = B$([].join), hoe = ax && !ooe(function() {
  return Tp(function() {
  }, "length", { value: 8 }).length !== 8;
}), poe = String(String).split("String"), goe = k$.exports = function(e, r, t) {
  doe(aE(r), 0, 7) === "Symbol(" && (r = "[" + foe(aE(r), /^Symbol\(([^)]*)\)/, "$1") + "]"), t && t.getter && (r = "get " + r), t && t.setter && (r = "set " + r), (!ph(e, "name") || soe && e.name !== r) && (ax ? Tp(e, "name", { value: r, configurable: !0 }) : e.name = r), hoe && t && ph(t, "arity") && e.length !== t.arity && Tp(e, "length", { value: t.arity });
  try {
    t && ph(t, "constructor") && t.constructor ? ax && Tp(e, "prototype", { writable: !1 }) : e.prototype && (e.prototype = void 0);
  } catch (a) {
  }
  var n = uoe(e);
  return ph(n, "source") || (n.source = voe(poe, typeof r == "string" ? r : "")), e;
};
Function.prototype.toString = goe(function() {
  return ioe(this) && coe(this).source || loe(this);
}, "toString");
var moe = Mt, boe = Bi, yoe = k$.exports, Soe = M$, Mc = function(e, r, t, n) {
  n || (n = {});
  var a = n.enumerable, i = n.name !== void 0 ? n.name : r;
  if (moe(t) && yoe(t, i, n), n.global)
    a ? e[r] = t : Soe(r, t);
  else {
    try {
      n.unsafe ? e[r] && (a = !0) : delete e[r];
    } catch (l) {
    }
    a ? e[r] = t : boe.f(e, r, {
      value: t,
      enumerable: !1,
      configurable: !n.nonConfigurable,
      writable: !n.nonWritable
    });
  }
  return e;
}, zP = {}, xoe = Math.ceil, $oe = Math.floor, woe = Math.trunc || function(r) {
  var t = +r;
  return (t > 0 ? $oe : xoe)(t);
}, _oe = woe, BP = function(e) {
  var r = +e;
  return r !== r || r === 0 ? 0 : _oe(r);
}, Toe = BP, Coe = Math.max, Eoe = Math.min, Aoe = function(e, r) {
  var t = Toe(e);
  return t < 0 ? Coe(t + r, 0) : Eoe(t, r);
}, Ioe = BP, Ooe = Math.min, Moe = function(e) {
  return e > 0 ? Ooe(Ioe(e), 9007199254740991) : 0;
}, Roe = Moe, UP = function(e) {
  return Roe(e.length);
}, Poe = Hf, koe = Aoe, joe = UP, oE = function(e) {
  return function(r, t, n) {
    var a = Poe(r), i = joe(a), l = koe(n, i), u;
    if (e && t != t) {
      for (; i > l; )
        if (u = a[l++], u != u)
          return !0;
    } else
      for (; i > l; l++)
        if ((e || l in a) && a[l] === t)
          return e || l || 0;
    return !e && -1;
  };
}, VP = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: oE(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: oE(!1)
}, Doe = Dn, g1 = Ka, Noe = Hf, Loe = VP.indexOf, Foe = F$, iE = Doe([].push), WP = function(e, r) {
  var t = Noe(e), n = 0, a = [], i;
  for (i in t)
    !g1(Foe, i) && g1(t, i) && iE(a, i);
  for (; r.length > n; )
    g1(t, i = r[n++]) && (~Loe(a, i) || iE(a, i));
  return a;
}, U$ = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], zoe = WP, Boe = U$, Uoe = Boe.concat("length", "prototype");
zP.f = Object.getOwnPropertyNames || function(r) {
  return zoe(r, Uoe);
};
var V$ = {};
V$.f = Object.getOwnPropertySymbols;
var Voe = lu, Woe = Dn, Hoe = zP, Goe = V$, Yoe = qa, Koe = Woe([].concat), qoe = Voe("Reflect", "ownKeys") || function(r) {
  var t = Hoe.f(Yoe(r)), n = Goe.f;
  return n ? Koe(t, n(r)) : t;
}, sE = Ka, Zoe = qoe, Qoe = $g, Xoe = Bi, HP = function(e, r, t) {
  for (var n = Zoe(r), a = Xoe.f, i = Qoe.f, l = 0; l < n.length; l++) {
    var u = n[l];
    !sE(e, u) && !(t && sE(t, u)) && a(e, u, i(r, u));
  }
}, Joe = jn, eie = Mt, rie = /#|\.prototype\./, Yf = function(e, r) {
  var t = nie[tie(e)];
  return t == oie ? !0 : t == aie ? !1 : eie(r) ? Joe(r) : !!r;
}, tie = Yf.normalize = function(e) {
  return String(e).replace(rie, ".").toLowerCase();
}, nie = Yf.data = {}, aie = Yf.NATIVE = "N", oie = Yf.POLYFILL = "P", GP = Yf, m1 = fn, iie = $g.f, sie = Ig, lie = Mc, uie = M$, cie = HP, die = GP, ii = function(e, r) {
  var t = e.target, n = e.global, a = e.stat, i, l, u, c, f, h;
  if (n ? l = m1 : a ? l = m1[t] || uie(t, {}) : l = (m1[t] || {}).prototype, l)
    for (u in r) {
      if (f = r[u], e.dontCallGetSet ? (h = iie(l, u), c = h && h.value) : c = l[u], i = die(n ? u : t + (a ? "." : "#") + u, e.forced), !i && c !== void 0) {
        if (typeof f == typeof c)
          continue;
        cie(f, c);
      }
      (e.sham || c && c.sham) && sie(f, "sham", !0), lie(l, u, f, e);
    }
}, fie = WP, vie = U$, YP = Object.keys || function(r) {
  return fie(r, vie);
}, lE = Ya, hie = Dn, pie = wa, gie = jn, b1 = YP, mie = V$, bie = E$, yie = P$, Sie = wP, Pu = Object.assign, uE = Object.defineProperty, xie = hie([].concat), $ie = !Pu || gie(function() {
  if (lE && Pu({ b: 1 }, Pu(uE({}, "a", {
    enumerable: !0,
    get: function() {
      uE(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1)
    return !0;
  var e = {}, r = {}, t = Symbol(), n = "abcdefghijklmnopqrst";
  return e[t] = 7, n.split("").forEach(function(a) {
    r[a] = a;
  }), Pu({}, e)[t] != 7 || b1(Pu({}, r)).join("") != n;
}) ? function(r, t) {
  for (var n = yie(r), a = arguments.length, i = 1, l = mie.f, u = bie.f; a > i; )
    for (var c = Sie(arguments[i++]), f = l ? xie(b1(c), l(c)) : b1(c), h = f.length, p = 0, g; h > p; )
      g = f[p++], (!lE || pie(u, c, g)) && (n[g] = c[g]);
  return n;
} : Pu, wie = ii, cE = $ie;
wie({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== cE }, {
  assign: cE
});
var Ds = function() {
  return Ds = Object.assign || function(r) {
    for (var t, n = 1, a = arguments.length; n < a; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, Ds.apply(this, arguments);
};
function W$(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      r.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (t[n[a]] = e[n[a]]);
  return t;
}
var _ie = "Invariant failed";
function Tie(e, r) {
  if (!e)
    throw new Error(_ie);
}
var gh = function(r) {
  var t = r.top, n = r.right, a = r.bottom, i = r.left, l = n - i, u = a - t, c = {
    top: t,
    right: n,
    bottom: a,
    left: i,
    width: l,
    height: u,
    x: i,
    y: t,
    center: {
      x: (n + i) / 2,
      y: (a + t) / 2
    }
  };
  return c;
}, Cie = function(r, t) {
  return {
    top: r.top - t.top,
    left: r.left - t.left,
    bottom: r.bottom + t.bottom,
    right: r.right + t.right
  };
}, dE = function(r, t) {
  return {
    top: r.top + t.top,
    left: r.left + t.left,
    bottom: r.bottom - t.bottom,
    right: r.right - t.right
  };
}, y1 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, Eie = function(r) {
  var t = r.borderBox, n = r.margin, a = n === void 0 ? y1 : n, i = r.border, l = i === void 0 ? y1 : i, u = r.padding, c = u === void 0 ? y1 : u, f = gh(Cie(t, a)), h = gh(dE(t, l)), p = gh(dE(h, c));
  return {
    marginBox: f,
    borderBox: gh(t),
    paddingBox: h,
    contentBox: p,
    margin: a,
    border: l,
    padding: c
  };
}, ja = function(r) {
  var t = r.slice(0, -2), n = r.slice(-2);
  if (n !== "px")
    return 0;
  var a = Number(t);
  return isNaN(a) && Tie(!1), a;
}, Aie = function(r, t) {
  var n = {
    top: ja(t.marginTop),
    right: ja(t.marginRight),
    bottom: ja(t.marginBottom),
    left: ja(t.marginLeft)
  }, a = {
    top: ja(t.paddingTop),
    right: ja(t.paddingRight),
    bottom: ja(t.paddingBottom),
    left: ja(t.paddingLeft)
  }, i = {
    top: ja(t.borderTopWidth),
    right: ja(t.borderRightWidth),
    bottom: ja(t.borderBottomWidth),
    left: ja(t.borderLeftWidth)
  };
  return Eie({
    borderBox: r,
    margin: n,
    padding: a,
    border: i
  });
}, KP = function(r) {
  var t = r.getBoundingClientRect(), n = window.getComputedStyle(r);
  return Aie(t, n);
}, ox = { exports: {} };
(function(e, r) {
  var t = 200, n = "__lodash_hash_undefined__", a = 800, i = 16, l = 9007199254740991, u = "[object Arguments]", c = "[object Array]", f = "[object AsyncFunction]", h = "[object Boolean]", p = "[object Date]", g = "[object Error]", y = "[object Function]", S = "[object GeneratorFunction]", x = "[object Map]", T = "[object Number]", A = "[object Null]", O = "[object Object]", P = "[object Proxy]", j = "[object RegExp]", k = "[object Set]", L = "[object String]", M = "[object Undefined]", W = "[object WeakMap]", q = "[object ArrayBuffer]", oe = "[object DataView]", Ae = "[object Float32Array]", Te = "[object Float64Array]", $e = "[object Int8Array]", Ee = "[object Int16Array]", ze = "[object Int32Array]", Ke = "[object Uint8Array]", Be = "[object Uint8ClampedArray]", ue = "[object Uint16Array]", he = "[object Uint32Array]", _e = /[\\^$.*+?()[\]{}|]/g, Oe = /^\[object .+?Constructor\]$/, Me = /^(?:0|[1-9]\d*)$/, Z = {};
  Z[Ae] = Z[Te] = Z[$e] = Z[Ee] = Z[ze] = Z[Ke] = Z[Be] = Z[ue] = Z[he] = !0, Z[u] = Z[c] = Z[q] = Z[h] = Z[oe] = Z[p] = Z[g] = Z[y] = Z[x] = Z[T] = Z[O] = Z[j] = Z[k] = Z[L] = Z[W] = !1;
  var se = typeof zl == "object" && zl && zl.Object === Object && zl, te = typeof self == "object" && self && self.Object === Object && self, fe = se || te || Function("return this")(), je = r && !r.nodeType && r, ve = je && !0 && e && !e.nodeType && e, rr = ve && ve.exports === je, br = rr && se.process, ur = function() {
    try {
      var v = ve && ve.require && ve.require("util").types;
      return v || br && br.binding && br.binding("util");
    } catch (b) {
    }
  }(), $r = ur && ur.isTypedArray;
  function Qe(v, b, $) {
    switch ($.length) {
      case 0:
        return v.call(b);
      case 1:
        return v.call(b, $[0]);
      case 2:
        return v.call(b, $[0], $[1]);
      case 3:
        return v.call(b, $[0], $[1], $[2]);
    }
    return v.apply(b, $);
  }
  function yr(v, b) {
    for (var $ = -1, N = Array(v); ++$ < v; )
      N[$] = b($);
    return N;
  }
  function at(v) {
    return function(b) {
      return v(b);
    };
  }
  function Zr(v, b) {
    return v == null ? void 0 : v[b];
  }
  function Nr(v, b) {
    return function($) {
      return v(b($));
    };
  }
  var jt = Array.prototype, mt = Function.prototype, gr = Object.prototype, Sr = fe["__core-js_shared__"], G = mt.toString, ne = gr.hasOwnProperty, Y = function() {
    var v = /[^.]+$/.exec(Sr && Sr.keys && Sr.keys.IE_PROTO || "");
    return v ? "Symbol(src)_1." + v : "";
  }(), Q = gr.toString, we = G.call(Object), be = RegExp(
    "^" + G.call(ne).replace(_e, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Re = rr ? fe.Buffer : void 0, cr = fe.Symbol, wr = fe.Uint8Array, lr = Re ? Re.allocUnsafe : void 0, dt = Nr(Object.getPrototypeOf, Object), ot = Object.create, bt = gr.propertyIsEnumerable, Ct = jt.splice, fr = cr ? cr.toStringTag : void 0, Qr = function() {
    try {
      var v = zn(Object, "defineProperty");
      return v({}, "", {}), v;
    } catch (b) {
    }
  }(), vn = Re ? Re.isBuffer : void 0, hn = Math.max, Za = Date.now, Cn = zn(fe, "Map"), ge = zn(Object, "create"), De = function() {
    function v() {
    }
    return function(b) {
      if (!Xr(b))
        return {};
      if (ot)
        return ot(b);
      v.prototype = b;
      var $ = new v();
      return v.prototype = void 0, $;
    };
  }();
  function tr(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Dt() {
    this.__data__ = ge ? ge(null) : {}, this.size = 0;
  }
  function it(v) {
    var b = this.has(v) && delete this.__data__[v];
    return this.size -= b ? 1 : 0, b;
  }
  function Fn(v) {
    var b = this.__data__;
    if (ge) {
      var $ = b[v];
      return $ === n ? void 0 : $;
    }
    return ne.call(b, v) ? b[v] : void 0;
  }
  function Se(v) {
    var b = this.__data__;
    return ge ? b[v] !== void 0 : ne.call(b, v);
  }
  function Ce(v, b) {
    var $ = this.__data__;
    return this.size += this.has(v) ? 0 : 1, $[v] = ge && b === void 0 ? n : b, this;
  }
  tr.prototype.clear = Dt, tr.prototype.delete = it, tr.prototype.get = Fn, tr.prototype.has = Se, tr.prototype.set = Ce;
  function ye(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Pe() {
    this.__data__ = [], this.size = 0;
  }
  function nr(v) {
    var b = this.__data__, $ = Nt(b, v);
    if ($ < 0)
      return !1;
    var N = b.length - 1;
    return $ == N ? b.pop() : Ct.call(b, $, 1), --this.size, !0;
  }
  function Hr(v) {
    var b = this.__data__, $ = Nt(b, v);
    return $ < 0 ? void 0 : b[$][1];
  }
  function Jt(v) {
    return Nt(this.__data__, v) > -1;
  }
  function en(v, b) {
    var $ = this.__data__, N = Nt($, v);
    return N < 0 ? (++this.size, $.push([v, b])) : $[N][1] = b, this;
  }
  ye.prototype.clear = Pe, ye.prototype.delete = nr, ye.prototype.get = Hr, ye.prototype.has = Jt, ye.prototype.set = en;
  function Rr(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Qa() {
    this.size = 0, this.__data__ = {
      hash: new tr(),
      map: new (Cn || ye)(),
      string: new tr()
    };
  }
  function Ks(v) {
    var b = mn(this, v).delete(v);
    return this.size -= b ? 1 : 0, b;
  }
  function qs(v) {
    return mn(this, v).get(v);
  }
  function Zs(v) {
    return mn(this, v).has(v);
  }
  function Qs(v, b) {
    var $ = mn(this, v), N = $.size;
    return $.set(v, b), this.size += $.size == N ? 0 : 1, this;
  }
  Rr.prototype.clear = Qa, Rr.prototype.delete = Ks, Rr.prototype.get = qs, Rr.prototype.has = Zs, Rr.prototype.set = Qs;
  function yt(v) {
    var b = this.__data__ = new ye(v);
    this.size = b.size;
  }
  function Xs() {
    this.__data__ = new ye(), this.size = 0;
  }
  function Js(v) {
    var b = this.__data__, $ = b.delete(v);
    return this.size = b.size, $;
  }
  function el(v) {
    return this.__data__.get(v);
  }
  function rl(v) {
    return this.__data__.has(v);
  }
  function tl(v, b) {
    var $ = this.__data__;
    if ($ instanceof ye) {
      var N = $.__data__;
      if (!Cn || N.length < t - 1)
        return N.push([v, b]), this.size = ++$.size, this;
      $ = this.__data__ = new Rr(N);
    }
    return $.set(v, b), this.size = $.size, this;
  }
  yt.prototype.clear = Xs, yt.prototype.delete = Js, yt.prototype.get = el, yt.prototype.has = rl, yt.prototype.set = tl;
  function nl(v, b) {
    var $ = na(v), N = !$ && ta(v), ie = !$ && !N && Mo(v), pe = !$ && !N && !ie && Po(v), ce = $ || N || ie || pe, ae = ce ? yr(v.length, String) : [], me = ae.length;
    for (var ar in v)
      (b || ne.call(v, ar)) && !(ce && // Safari 9 has enumerable `arguments.length` in strict mode.
      (ar == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      ie && (ar == "offset" || ar == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      pe && (ar == "buffer" || ar == "byteLength" || ar == "byteOffset") || // Skip index properties.
      Oo(ar, me))) && ae.push(ar);
    return ae;
  }
  function pn(v, b, $) {
    ($ !== void 0 && !bn(v[b], $) || $ === void 0 && !(b in v)) && ra(v, b, $);
  }
  function al(v, b, $) {
    var N = v[b];
    (!(ne.call(v, b) && bn(N, $)) || $ === void 0 && !(b in v)) && ra(v, b, $);
  }
  function Nt(v, b) {
    for (var $ = v.length; $--; )
      if (bn(v[$][0], b))
        return $;
    return -1;
  }
  function ra(v, b, $) {
    b == "__proto__" && Qr ? Qr(v, b, {
      configurable: !0,
      enumerable: !0,
      value: $,
      writable: !0
    }) : v[b] = $;
  }
  var ol = Zi();
  function gn(v) {
    return v == null ? v === void 0 ? M : A : fr && fr in Object(v) ? Qi(v) : es(v);
  }
  function Xa(v) {
    return Lt(v) && gn(v) == u;
  }
  function Wi(v) {
    if (!Xr(v) || hi(v))
      return !1;
    var b = aa(v) ? be : Oe;
    return b.test(ns(v));
  }
  function Hi(v) {
    return Lt(v) && Ro(v.length) && !!Z[gn(v)];
  }
  function il(v) {
    if (!Xr(v))
      return Ji(v);
    var b = En(v), $ = [];
    for (var N in v)
      N == "constructor" && (b || !ne.call(v, N)) || $.push(N);
    return $;
  }
  function Ao(v, b, $, N, ie) {
    v !== b && ol(b, function(pe, ce) {
      if (ie || (ie = new yt()), Xr(pe))
        sl(v, b, ce, $, Ao, N, ie);
      else {
        var ae = N ? N(Bn(v, ce), pe, ce + "", v, b, ie) : void 0;
        ae === void 0 && (ae = pe), pn(v, ce, ae);
      }
    }, ko);
  }
  function sl(v, b, $, N, ie, pe, ce) {
    var ae = Bn(v, $), me = Bn(b, $), ar = ce.get(me);
    if (ar) {
      pn(v, $, ar);
      return;
    }
    var qe = pe ? pe(ae, me, $ + "", v, b, ce) : void 0, Pr = qe === void 0;
    if (Pr) {
      var Vn = na(me), Wn = !Vn && Mo(me), Ja = !Vn && !Wn && Po(me);
      qe = me, Vn || Wn || Ja ? na(ae) ? qe = ae : dl(ae) ? qe = ul(ae) : Wn ? (Pr = !1, qe = Yi(me, !0)) : Ja ? (Pr = !1, qe = di(me, !0)) : qe = [] : fl(me) || ta(me) ? (qe = ae, ta(ae) ? qe = vl(ae) : (!Xr(ae) || aa(ae)) && (qe = fi(me))) : Pr = !1;
    }
    Pr && (ce.set(me, qe), ie(qe, me, N, pe, ce), ce.delete(me)), pn(v, $, qe);
  }
  function ll(v, b) {
    return rs(cl(v, b, jo), v + "");
  }
  var Gi = Qr ? function(v, b) {
    return Qr(v, "toString", {
      configurable: !0,
      enumerable: !1,
      value: xr(b),
      writable: !0
    });
  } : jo;
  function Yi(v, b) {
    if (b)
      return v.slice();
    var $ = v.length, N = lr ? lr($) : new v.constructor($);
    return v.copy(N), N;
  }
  function Ki(v) {
    var b = new v.constructor(v.byteLength);
    return new wr(b).set(new wr(v)), b;
  }
  function di(v, b) {
    var $ = b ? Ki(v.buffer) : v.buffer;
    return new v.constructor($, v.byteOffset, v.length);
  }
  function ul(v, b) {
    var $ = -1, N = v.length;
    for (b || (b = Array(N)); ++$ < N; )
      b[$] = v[$];
    return b;
  }
  function qi(v, b, $, N) {
    var ie = !$;
    $ || ($ = {});
    for (var pe = -1, ce = b.length; ++pe < ce; ) {
      var ae = b[pe], me = N ? N($[ae], v[ae], ae, $, v) : void 0;
      me === void 0 && (me = v[ae]), ie ? ra($, ae, me) : al($, ae, me);
    }
    return $;
  }
  function Io(v) {
    return ll(function(b, $) {
      var N = -1, ie = $.length, pe = ie > 1 ? $[ie - 1] : void 0, ce = ie > 2 ? $[2] : void 0;
      for (pe = v.length > 3 && typeof pe == "function" ? (ie--, pe) : void 0, ce && Xi($[0], $[1], ce) && (pe = ie < 3 ? void 0 : pe, ie = 1), b = Object(b); ++N < ie; ) {
        var ae = $[N];
        ae && v(b, ae, N, pe);
      }
      return b;
    });
  }
  function Zi(v) {
    return function(b, $, N) {
      for (var ie = -1, pe = Object(b), ce = N(b), ae = ce.length; ae--; ) {
        var me = ce[v ? ae : ++ie];
        if ($(pe[me], me, pe) === !1)
          break;
      }
      return b;
    };
  }
  function mn(v, b) {
    var $ = v.__data__;
    return vi(b) ? $[typeof b == "string" ? "string" : "hash"] : $.map;
  }
  function zn(v, b) {
    var $ = Zr(v, b);
    return Wi($) ? $ : void 0;
  }
  function Qi(v) {
    var b = ne.call(v, fr), $ = v[fr];
    try {
      v[fr] = void 0;
      var N = !0;
    } catch (pe) {
    }
    var ie = Q.call(v);
    return N && (b ? v[fr] = $ : delete v[fr]), ie;
  }
  function fi(v) {
    return typeof v.constructor == "function" && !En(v) ? De(dt(v)) : {};
  }
  function Oo(v, b) {
    var $ = typeof v;
    return b = b == null ? l : b, !!b && ($ == "number" || $ != "symbol" && Me.test(v)) && v > -1 && v % 1 == 0 && v < b;
  }
  function Xi(v, b, $) {
    if (!Xr($))
      return !1;
    var N = typeof b;
    return (N == "number" ? Un($) && Oo(b, $.length) : N == "string" && b in $) ? bn($[b], v) : !1;
  }
  function vi(v) {
    var b = typeof v;
    return b == "string" || b == "number" || b == "symbol" || b == "boolean" ? v !== "__proto__" : v === null;
  }
  function hi(v) {
    return !!Y && Y in v;
  }
  function En(v) {
    var b = v && v.constructor, $ = typeof b == "function" && b.prototype || gr;
    return v === $;
  }
  function Ji(v) {
    var b = [];
    if (v != null)
      for (var $ in Object(v))
        b.push($);
    return b;
  }
  function es(v) {
    return Q.call(v);
  }
  function cl(v, b, $) {
    return b = hn(b === void 0 ? v.length - 1 : b, 0), function() {
      for (var N = arguments, ie = -1, pe = hn(N.length - b, 0), ce = Array(pe); ++ie < pe; )
        ce[ie] = N[b + ie];
      ie = -1;
      for (var ae = Array(b + 1); ++ie < b; )
        ae[ie] = N[ie];
      return ae[b] = $(ce), Qe(v, this, ae);
    };
  }
  function Bn(v, b) {
    if (!(b === "constructor" && typeof v[b] == "function") && b != "__proto__")
      return v[b];
  }
  var rs = ts(Gi);
  function ts(v) {
    var b = 0, $ = 0;
    return function() {
      var N = Za(), ie = i - (N - $);
      if ($ = N, ie > 0) {
        if (++b >= a)
          return arguments[0];
      } else
        b = 0;
      return v.apply(void 0, arguments);
    };
  }
  function ns(v) {
    if (v != null) {
      try {
        return G.call(v);
      } catch (b) {
      }
      try {
        return v + "";
      } catch (b) {
      }
    }
    return "";
  }
  function bn(v, b) {
    return v === b || v !== v && b !== b;
  }
  var ta = Xa(function() {
    return arguments;
  }()) ? Xa : function(v) {
    return Lt(v) && ne.call(v, "callee") && !bt.call(v, "callee");
  }, na = Array.isArray;
  function Un(v) {
    return v != null && Ro(v.length) && !aa(v);
  }
  function dl(v) {
    return Lt(v) && Un(v);
  }
  var Mo = vn || hl;
  function aa(v) {
    if (!Xr(v))
      return !1;
    var b = gn(v);
    return b == y || b == S || b == f || b == P;
  }
  function Ro(v) {
    return typeof v == "number" && v > -1 && v % 1 == 0 && v <= l;
  }
  function Xr(v) {
    var b = typeof v;
    return v != null && (b == "object" || b == "function");
  }
  function Lt(v) {
    return v != null && typeof v == "object";
  }
  function fl(v) {
    if (!Lt(v) || gn(v) != O)
      return !1;
    var b = dt(v);
    if (b === null)
      return !0;
    var $ = ne.call(b, "constructor") && b.constructor;
    return typeof $ == "function" && $ instanceof $ && G.call($) == we;
  }
  var Po = $r ? at($r) : Hi;
  function vl(v) {
    return qi(v, ko(v));
  }
  function ko(v) {
    return Un(v) ? nl(v, !0) : il(v);
  }
  var _r = Io(function(v, b, $, N) {
    Ao(v, b, $, N);
  });
  function xr(v) {
    return function() {
      return v;
    };
  }
  function jo(v) {
    return v;
  }
  function hl() {
    return !1;
  }
  e.exports = _r;
})(ox, ox.exports);
var Bl = ox.exports, qP = 1 / 60 * 1e3, Iie = typeof performance != "undefined" ? function() {
  return performance.now();
} : function() {
  return Date.now();
}, ZP = typeof window != "undefined" ? function(e) {
  return window.requestAnimationFrame(e);
} : function(e) {
  return setTimeout(function() {
    return e(Iie());
  }, qP);
};
function Oie(e) {
  var r = [], t = [], n = 0, a = !1, i = /* @__PURE__ */ new WeakSet(), l = {
    schedule: function(u, c, f) {
      c === void 0 && (c = !1), f === void 0 && (f = !1);
      var h = f && a, p = h ? r : t;
      return c && i.add(u), p.indexOf(u) === -1 && (p.push(u), h && a && (n = r.length)), u;
    },
    cancel: function(u) {
      var c = t.indexOf(u);
      c !== -1 && t.splice(c, 1), i.delete(u);
    },
    process: function(u) {
      var c;
      if (a = !0, c = [t, r], r = c[0], t = c[1], t.length = 0, n = r.length, n)
        for (var f = 0; f < n; f++) {
          var h = r[f];
          h(u), i.has(h) && (l.schedule(h), e());
        }
      a = !1;
    }
  };
  return l;
}
var Mie = 40, ix = !0, hf = !1, sx = !1, Dd = {
  delta: 0,
  timestamp: 0
}, Og = ["read", "update", "preRender", "render", "postRender"], H$ = /* @__PURE__ */ Og.reduce(function(e, r) {
  return e[r] = Oie(function() {
    return hf = !0;
  }), e;
}, {}), Rie = /* @__PURE__ */ Og.reduce(function(e, r) {
  var t = H$[r];
  return e[r] = function(n, a, i) {
    return a === void 0 && (a = !1), i === void 0 && (i = !1), hf || jie(), t.schedule(n, a, i);
  }, e;
}, {}), Pie = /* @__PURE__ */ Og.reduce(function(e, r) {
  return e[r] = H$[r].cancel, e;
}, {}), kie = function(e) {
  return H$[e].process(Dd);
}, QP = function(e) {
  hf = !1, Dd.delta = ix ? qP : Math.max(Math.min(e - Dd.timestamp, Mie), 1), Dd.timestamp = e, sx = !0, Og.forEach(kie), sx = !1, hf && (ix = !1, ZP(QP));
}, jie = function() {
  hf = !0, ix = !0, sx || ZP(QP);
}, fE = function() {
  return Dd;
};
function Kl(e) {
  return typeof e == "number";
}
function Die(e) {
  return typeof e != "number" || Number.isNaN(e) || !Number.isFinite(e);
}
function Nie(e) {
  return Array.isArray(e);
}
function XP(e) {
  return typeof e == "function";
}
function ql(e) {
  var r = typeof e;
  return e != null && (r === "object" || r === "function") && !Nie(e);
}
function G$(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
function JP(e) {
  return /^var\(--.+\)$/.test(e);
}
var Lie = !1;
function Y$(e, r) {
  var t = {};
  return Object.keys(e).forEach(function(n) {
    r.includes(n) || (t[n] = e[n]);
  }), t;
}
function Fie(e, r, t, n) {
  var a = typeof r == "string" ? r.split(".") : [r];
  for (n = 0; n < a.length && e; n += 1)
    e = e[a[n]];
  return e === void 0 ? t : e;
}
var zie = function(r) {
  var t = /* @__PURE__ */ new WeakMap(), n = function(i, l, u, c) {
    if (typeof i == "undefined")
      return r(i, l, u);
    t.has(i) || t.set(i, /* @__PURE__ */ new Map());
    var f = t.get(i);
    if (f.has(l))
      return f.get(l);
    var h = r(i, l, u, c);
    return f.set(l, h), h;
  };
  return n;
}, K$ = zie(Fie);
function ek(e, r) {
  var t = {};
  return Object.keys(e).forEach(function(n) {
    var a = e[n], i = r(a, n, e);
    i && (t[n] = a);
  }), t;
}
var rk = function(r) {
  return ek(r, function(t) {
    return t != null;
  });
}, tk = function(r) {
  return Object.keys(r);
}, vE = function(r) {
  return r.reduce(function(t, n) {
    var a = n[0], i = n[1];
    return t[a] = i, t;
  }, {});
};
function nk(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
function ak(e) {
  var r;
  if (!nk(e))
    return !1;
  var t = (r = e.ownerDocument.defaultView) != null ? r : window;
  return e instanceof t.HTMLElement;
}
function ok(e) {
  var r;
  return nk(e) && (r = e.ownerDocument) != null ? r : document;
}
function q$(e) {
  var r;
  return (r = e.view) != null ? r : window;
}
function Bie() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
var Mg = Bie(), za = function(r) {
  return r ? "" : void 0;
}, uc = function(r) {
  return r ? !0 : void 0;
}, Z$ = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return t.filter(Boolean).join(" ");
};
function Uie(e, r, t, n) {
  return e.addEventListener(r, t, n), function() {
    e.removeEventListener(r, t, n);
  };
}
function ik(e) {
  var r = e.key, t = e.keyCode, n = t >= 37 && t <= 40 && r.indexOf("Arrow") !== 0, a = n ? "Arrow" + r : r;
  return a;
}
function Vie(e) {
  return ak(e) && e.tagName.toLowerCase() === "input" && "select" in e;
}
function Wie(e) {
  var r = ak(e) ? ok(e) : document;
  return r.activeElement === e;
}
function hE(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function Hie(e, r) {
  if (e) {
    if (typeof e == "string")
      return hE(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return hE(e, r);
  }
}
function Gie(e, r) {
  var t = typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t)
    return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = Hie(e)) || r && e && typeof e.length == "number") {
    t && (e = t);
    var n = 0;
    return function() {
      return n >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[n++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ua(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  return XP(e) ? e.apply(void 0, t) : e;
}
function cc() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(a) {
    r.some(function(i) {
      return i == null || i(a), a == null ? void 0 : a.defaultPrevented;
    });
  };
}
function Yie(e) {
  var r;
  return function() {
    if (e) {
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      r = e.apply(this, a), e = null;
    }
    return r;
  };
}
var sk = function() {
}, lk = Yie(function(e) {
  return function() {
    var r = e.condition, t = e.message;
    r && Lie && console.warn(t);
  };
}), Kie = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return function(a) {
    return t.reduce(function(i, l) {
      return l(i);
    }, a);
  };
}, S1 = function(r, t) {
  return Math.abs(r - t);
}, pE = function(r) {
  return "x" in r && "y" in r;
};
function qie(e, r) {
  if (Kl(e) && Kl(r))
    return S1(e, r);
  if (pE(e) && pE(r)) {
    var t = S1(e.x, r.x), n = S1(e.y, r.y);
    return Math.sqrt(Math.pow(t, 2) + Math.pow(n, 2));
  }
  return 0;
}
function uk(e, r) {
  r === void 0 && (r = {});
  var t = r, n = t.isActive, a = n === void 0 ? Wie : n, i = t.nextTick, l = t.preventScroll, u = l === void 0 ? !0 : l, c = t.selectTextIfInput, f = c === void 0 ? !0 : c;
  if (!e || a(e))
    return -1;
  function h() {
    if (!e) {
      lk({
        condition: !0,
        message: "[chakra-ui]: can't call focus() on `null` or `undefined` element"
      });
      return;
    }
    if (Zie())
      e.focus({
        preventScroll: u
      });
    else if (e.focus(), u) {
      var p = Qie(e);
      Xie(p);
    }
    Vie(e) && f && e.select();
  }
  return i ? requestAnimationFrame(h) : (h(), -1);
}
var mh = null;
function Zie() {
  if (mh == null) {
    mh = !1;
    try {
      var e = document.createElement("div");
      e.focus({
        get preventScroll() {
          return mh = !0, !0;
        }
      });
    } catch (r) {
    }
  }
  return mh;
}
function Qie(e) {
  for (var r, t = ok(e), n = (r = t.defaultView) != null ? r : window, a = e.parentNode, i = [], l = t.scrollingElement || t.documentElement; a instanceof n.HTMLElement && a !== l; )
    (a.offsetHeight < a.scrollHeight || a.offsetWidth < a.scrollWidth) && i.push({
      element: a,
      scrollTop: a.scrollTop,
      scrollLeft: a.scrollLeft
    }), a = a.parentNode;
  return l instanceof n.HTMLElement && i.push({
    element: l,
    scrollTop: l.scrollTop,
    scrollLeft: l.scrollLeft
  }), i;
}
function Xie(e) {
  for (var r = Gie(e), t; !(t = r()).done; ) {
    var n = t.value, a = n.element, i = n.scrollTop, l = n.scrollLeft;
    a.scrollTop = i, a.scrollLeft = l;
  }
}
function Jie(e) {
  var r = parseFloat(e);
  return Die(r) ? 0 : r;
}
function ese(e, r) {
  var t = Jie(e), n = Math.pow(10, r != null ? r : 10);
  return t = Math.round(t * n) / n, r ? t.toFixed(r) : t.toString();
}
function rse(e) {
  if (!Number.isFinite(e))
    return 0;
  for (var r = 1, t = 0; Math.round(e * r) / r !== e; )
    r *= 10, t += 1;
  return t;
}
function g0(e, r, t) {
  return (e - r) * 100 / (t - r);
}
function ck(e, r, t) {
  return (t - r) * e + r;
}
function lx(e, r, t) {
  var n = Math.round((e - r) / t) * t + r, a = rse(t);
  return ese(n, a);
}
function Nd(e, r, t) {
  return e == null ? e : (lk({
    condition: t < r,
    message: "clamp: max cannot be less than min"
  }), Math.min(Math.max(e, r), t));
}
function m0() {
  return m0 = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, m0.apply(this, arguments);
}
function tse(e) {
  var r = q$(e);
  return typeof r.PointerEvent != "undefined" && e instanceof r.PointerEvent ? e.pointerType === "mouse" : e instanceof r.MouseEvent;
}
function dk(e) {
  var r = !!e.touches;
  return r;
}
function nse(e) {
  return function(r) {
    var t = q$(r), n = r instanceof t.MouseEvent, a = !n || n && r.button === 0;
    a && e(r);
  };
}
var ase = {
  pageX: 0,
  pageY: 0
};
function ose(e, r) {
  r === void 0 && (r = "page");
  var t = e.touches[0] || e.changedTouches[0], n = t || ase;
  return {
    x: n[r + "X"],
    y: n[r + "Y"]
  };
}
function ise(e, r) {
  return r === void 0 && (r = "page"), {
    x: e[r + "X"],
    y: e[r + "Y"]
  };
}
function fk(e, r) {
  return r === void 0 && (r = "page"), {
    point: dk(e) ? ose(e, r) : ise(e, r)
  };
}
var vk = function(r, t) {
  t === void 0 && (t = !1);
  var n = function(i) {
    return r(i, fk(i));
  };
  return t ? nse(n) : n;
}, sse = function() {
  return Mg && window.onpointerdown === null;
}, lse = function() {
  return Mg && window.ontouchstart === null;
}, use = function() {
  return Mg && window.onmousedown === null;
}, cse = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, dse = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function hk(e) {
  return sse() ? e : lse() ? dse[e] : use() ? cse[e] : e;
}
function x1(e, r, t, n) {
  return Uie(e, hk(r), vk(t, r === "pointerdown"), n);
}
function fse(e) {
  return dk(e) && e.touches.length > 1;
}
var vse = /* @__PURE__ */ function() {
  function e(t, n, a) {
    var i = this;
    if (this.history = [], this.startEvent = null, this.lastEvent = null, this.lastEventInfo = null, this.handlers = {}, this.removeListeners = sk, this.threshold = 3, this.win = void 0, this.updatePoint = function() {
      if (i.lastEvent && i.lastEventInfo) {
        var h = $1(i.lastEventInfo, i.history), p = i.startEvent !== null, g = qie(h.offset, {
          x: 0,
          y: 0
        }) >= i.threshold;
        if (!(!p && !g)) {
          var y = fE(), S = y.timestamp;
          i.history.push(m0({}, h.point, {
            timestamp: S
          }));
          var x = i.handlers, T = x.onStart, A = x.onMove;
          p || (T == null || T(i.lastEvent, h), i.startEvent = i.lastEvent), A == null || A(i.lastEvent, h);
        }
      }
    }, this.onPointerMove = function(h, p) {
      if (i.lastEvent = h, i.lastEventInfo = p, tse(h) && h.buttons === 0) {
        i.onPointerUp(h, p);
        return;
      }
      Rie.update(i.updatePoint, !0);
    }, this.onPointerUp = function(h, p) {
      var g = $1(p, i.history), y = i.handlers, S = y.onEnd, x = y.onSessionEnd;
      x == null || x(h, g), i.end(), !(!S || !i.startEvent) && (S == null || S(h, g));
    }, this.win = q$(t), !fse(t)) {
      this.handlers = n, a && (this.threshold = a), t.stopPropagation(), t.preventDefault();
      var l = fk(t), u = fE(), c = u.timestamp;
      this.history = [m0({}, l.point, {
        timestamp: c
      })];
      var f = n.onSessionStart;
      f == null || f(t, $1(l, this.history)), this.removeListeners = Kie(x1(this.win, "pointermove", this.onPointerMove), x1(this.win, "pointerup", this.onPointerUp), x1(this.win, "pointercancel", this.onPointerUp));
    }
  }
  var r = e.prototype;
  return r.updateHandlers = function(n) {
    this.handlers = n;
  }, r.end = function() {
    var n;
    (n = this.removeListeners) == null || n.call(this), Pie.update(this.updatePoint);
  }, e;
}();
function gE(e, r) {
  return {
    x: e.x - r.x,
    y: e.y - r.y
  };
}
function hse(e) {
  return e[0];
}
function pse(e) {
  return e[e.length - 1];
}
function $1(e, r) {
  return {
    point: e.point,
    delta: gE(e.point, pse(r)),
    offset: gE(e.point, hse(r)),
    velocity: bse(r, 0.1)
  };
}
function gse(e) {
  return e[e.length - 1];
}
var mse = function(r) {
  return r * 1e3;
};
function bse(e, r) {
  if (e.length < 2)
    return {
      x: 0,
      y: 0
    };
  for (var t = e.length - 1, n = null, a = gse(e); t >= 0 && (n = e[t], !(a.timestamp - n.timestamp > mse(r))); )
    t--;
  if (!n)
    return {
      x: 0,
      y: 0
    };
  var i = (a.timestamp - n.timestamp) / 1e3;
  if (i === 0)
    return {
      x: 0,
      y: 0
    };
  var l = {
    x: (a.x - n.x) / i,
    y: (a.y - n.y) / i
  };
  return l.x === 1 / 0 && (l.x = 0), l.y === 1 / 0 && (l.y = 0), l;
}
var yse = /* @__PURE__ */ I.createContext({}), Sse = function() {
  var r = I.useContext(yse);
  if (r === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return r;
};
function b0() {
  return b0 = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, b0.apply(this, arguments);
}
var xse = function(r, t) {
  return function(n) {
    var a = String(t), i = r ? r + "." + a : a;
    return ql(n.__cssMap) && i in n.__cssMap ? n.__cssMap[i].varRef : t;
  };
};
function pf(e) {
  var r = e.scale, t = e.transform, n = e.compose, a = function(l, u) {
    var c, f = xse(r, l)(u), h = (c = t == null ? void 0 : t(f, u)) != null ? c : f;
    return n && (h = n(h, u)), h;
  };
  return a;
}
function so(e, r) {
  return function(t) {
    var n = {
      property: t,
      scale: e
    };
    return n.transform = pf({
      scale: e,
      transform: r
    }), n;
  };
}
var $se = function(r) {
  var t = r.rtl, n = r.ltr;
  return function(a) {
    return a.direction === "rtl" ? t : n;
  };
};
function wse(e) {
  var r = e.property, t = e.scale, n = e.transform;
  return {
    scale: t,
    property: $se(r),
    transform: t ? pf({
      scale: t,
      compose: n
    }) : n
  };
}
var w1, _1, pk = ["rotate(var(--chakra-rotate, 0))", "scaleX(var(--chakra-scale-x, 1))", "scaleY(var(--chakra-scale-y, 1))", "skewX(var(--chakra-skew-x, 0))", "skewY(var(--chakra-skew-y, 0))"];
function _se() {
  return ["translateX(var(--chakra-translate-x, 0))", "translateY(var(--chakra-translate-y, 0))"].concat(pk).join(" ");
}
function Tse() {
  return ["translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)"].concat(pk).join(" ");
}
var Cse = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: ["var(--chakra-blur)", "var(--chakra-brightness)", "var(--chakra-contrast)", "var(--chakra-grayscale)", "var(--chakra-hue-rotate)", "var(--chakra-invert)", "var(--chakra-saturate)", "var(--chakra-sepia)", "var(--chakra-drop-shadow)"].join(" ")
}, Ese = {
  backdropFilter: ["var(--chakra-backdrop-blur)", "var(--chakra-backdrop-brightness)", "var(--chakra-backdrop-contrast)", "var(--chakra-backdrop-grayscale)", "var(--chakra-backdrop-hue-rotate)", "var(--chakra-backdrop-invert)", "var(--chakra-backdrop-opacity)", "var(--chakra-backdrop-saturate)", "var(--chakra-backdrop-sepia)"].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function Ase(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: ["var(--chakra-ring-offset-shadow)", "var(--chakra-ring-shadow)", "var(--chakra-shadow, 0 0 #0000)"].join(", ")
  };
}
var Ise = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, gk = "& > :not(style) ~ :not(style)", Ose = (w1 = {}, w1[gk] = {
  marginInlineStart: "calc(var(--chakra-space-x) * calc(1 - var(--chakra-space-x-reverse)))",
  marginInlineEnd: "calc(var(--chakra-space-x) * var(--chakra-space-x-reverse))"
}, w1), Mse = (_1 = {}, _1[gk] = {
  marginTop: "calc(var(--chakra-space-y) * calc(1 - var(--chakra-space-y-reverse)))",
  marginBottom: "calc(var(--chakra-space-y) * var(--chakra-space-y-reverse))"
}, _1);
function y0(e, r) {
  return y0 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, y0(e, r);
}
function Rse(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), r && y0(e, r);
}
function ux() {
  ux = function(a, i) {
    return new t(a, void 0, i);
  };
  var e = RegExp.prototype, r = /* @__PURE__ */ new WeakMap();
  function t(a, i, l) {
    var u = new RegExp(a, i);
    return r.set(u, l || r.get(a)), y0(u, t.prototype);
  }
  Rse(t, RegExp), t.prototype.exec = function(a) {
    var i = e.exec.call(this, a);
    return i && (i.groups = n(i, this)), i;
  }, t.prototype[Symbol.replace] = function(a, i) {
    if (typeof i == "string") {
      var l = r.get(this);
      return e[Symbol.replace].call(this, a, i.replace(/\$<([^>]+)>/g, function(c, f) {
        return "$" + l[f];
      }));
    } else if (typeof i == "function") {
      var u = this;
      return e[Symbol.replace].call(this, a, function() {
        var c = arguments;
        return typeof c[c.length - 1] != "object" && (c = [].slice.call(c), c.push(n(c, u))), i.apply(this, c);
      });
    } else
      return e[Symbol.replace].call(this, a, i);
  };
  function n(a, i) {
    var l = r.get(i);
    return Object.keys(l).reduce(function(u, c) {
      return u[c] = a[l[c]], u;
    }, /* @__PURE__ */ Object.create(null));
  }
  return ux.apply(this, arguments);
}
var cx = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, Pse = new Set(Object.values(cx)), mk = /* @__PURE__ */ new Set(["none", "-moz-initial", "inherit", "initial", "revert", "unset"]), kse = function(r) {
  return r.trim();
};
function jse(e, r) {
  var t, n;
  if (e == null || mk.has(e))
    return e;
  var a = /* @__PURE__ */ ux(/(^[\x2DA-Za-z]+)\(((.*))\)/g, {
    type: 1,
    values: 2
  }), i = (t = (n = a.exec(e)) == null ? void 0 : n.groups) != null ? t : {}, l = i.type, u = i.values;
  if (!l || !u)
    return e;
  var c = l.includes("-gradient") ? l : l + "-gradient", f = u.split(",").map(kse).filter(Boolean), h = f[0], p = f.slice(1);
  if ((p == null ? void 0 : p.length) === 0)
    return e;
  var g = h in cx ? cx[h] : h;
  p.unshift(g);
  var y = p.map(function(S) {
    if (Pse.has(S))
      return S;
    var x = S.indexOf(" "), T = x !== -1 ? [S.substr(0, x), S.substr(x + 1)] : [S], A = T[0], O = T[1], P = bk(O) ? O : O && O.split(" "), j = "colors." + A, k = j in r.__cssMap ? r.__cssMap[j].varRef : A;
    return P ? [k].concat(Array.isArray(P) ? P : [P]).join(" ") : k;
  });
  return c + "(" + y.join(", ") + ")";
}
var bk = function(r) {
  return G$(r) && r.includes("(") && r.includes(")");
}, Dse = function(r, t) {
  return jse(r, t != null ? t : {});
}, Nse = function(r) {
  var t = parseFloat(r.toString()), n = r.toString().replace(String(t), "");
  return {
    unitless: !n,
    value: t,
    unit: n
  };
}, Uo = function(r) {
  return function(t) {
    return r + "(" + t + ")";
  };
}, zr = {
  filter: function(r) {
    return r !== "auto" ? r : Cse;
  },
  backdropFilter: function(r) {
    return r !== "auto" ? r : Ese;
  },
  ring: function(r) {
    return Ase(zr.px(r));
  },
  bgClip: function(r) {
    return r === "text" ? {
      color: "transparent",
      backgroundClip: "text"
    } : {
      backgroundClip: r
    };
  },
  transform: function(r) {
    return r === "auto" ? _se() : r === "auto-gpu" ? Tse() : r;
  },
  px: function(r) {
    if (r == null)
      return r;
    var t = Nse(r), n = t.unitless;
    return n || Kl(r) ? r + "px" : r;
  },
  fraction: function(r) {
    return !Kl(r) || r > 1 ? r : r * 100 + "%";
  },
  float: function(r, t) {
    var n = {
      left: "right",
      right: "left"
    };
    return t.direction === "rtl" ? n[r] : r;
  },
  degree: function(r) {
    if (JP(r) || r == null)
      return r;
    var t = G$(r) && !r.endsWith("deg");
    return Kl(r) || t ? r + "deg" : r;
  },
  gradient: Dse,
  blur: Uo("blur"),
  opacity: Uo("opacity"),
  brightness: Uo("brightness"),
  contrast: Uo("contrast"),
  dropShadow: Uo("drop-shadow"),
  grayscale: Uo("grayscale"),
  hueRotate: Uo("hue-rotate"),
  invert: Uo("invert"),
  saturate: Uo("saturate"),
  sepia: Uo("sepia"),
  bgImage: function(r) {
    if (r == null)
      return r;
    var t = bk(r) || mk.has(r);
    return t ? r : "url(" + r + ")";
  },
  outline: function(r) {
    var t = String(r) === "0" || String(r) === "none";
    return r !== null && t ? {
      outline: "2px solid transparent",
      outlineOffset: "2px"
    } : {
      outline: r
    };
  },
  flexDirection: function(r) {
    var t, n = (t = Ise[r]) != null ? t : {}, a = n.space, i = n.divide, l = {
      flexDirection: r
    };
    return a && (l[a] = 1), i && (l[i] = 1), l;
  }
}, z = {
  borderWidths: so("borderWidths"),
  borderStyles: so("borderStyles"),
  colors: so("colors"),
  borders: so("borders"),
  radii: so("radii", zr.px),
  space: so("space", zr.px),
  spaceT: so("space", zr.px),
  degreeT: function(r) {
    return {
      property: r,
      transform: zr.degree
    };
  },
  prop: function(r, t, n) {
    return b0({
      property: r,
      scale: t
    }, t && {
      transform: pf({
        scale: t,
        transform: n
      })
    });
  },
  propT: function(r, t) {
    return {
      property: r,
      transform: t
    };
  },
  sizes: so("sizes", zr.px),
  sizesT: so("sizes", zr.fraction),
  shadows: so("shadows"),
  logical: wse,
  blur: so("blur", zr.blur)
}, Cp = {
  background: z.colors("background"),
  backgroundColor: z.colors("backgroundColor"),
  backgroundImage: z.propT("backgroundImage", zr.bgImage),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: {
    transform: zr.bgClip
  },
  bgSize: z.prop("backgroundSize"),
  bgPosition: z.prop("backgroundPosition"),
  bg: z.colors("background"),
  bgColor: z.colors("backgroundColor"),
  bgPos: z.prop("backgroundPosition"),
  bgRepeat: z.prop("backgroundRepeat"),
  bgAttachment: z.prop("backgroundAttachment"),
  bgGradient: z.propT("backgroundImage", zr.gradient),
  bgClip: {
    transform: zr.bgClip
  }
};
Object.assign(Cp, {
  bgImage: Cp.backgroundImage,
  bgImg: Cp.backgroundImage
});
var Er = {
  border: z.borders("border"),
  borderWidth: z.borderWidths("borderWidth"),
  borderStyle: z.borderStyles("borderStyle"),
  borderColor: z.colors("borderColor"),
  borderRadius: z.radii("borderRadius"),
  borderTop: z.borders("borderTop"),
  borderBlockStart: z.borders("borderBlockStart"),
  borderTopLeftRadius: z.radii("borderTopLeftRadius"),
  borderStartStartRadius: z.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: z.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: z.radii("borderTopRightRadius"),
  borderStartEndRadius: z.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: z.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: z.borders("borderRight"),
  borderInlineEnd: z.borders("borderInlineEnd"),
  borderBottom: z.borders("borderBottom"),
  borderBlockEnd: z.borders("borderBlockEnd"),
  borderBottomLeftRadius: z.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: z.radii("borderBottomRightRadius"),
  borderLeft: z.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: z.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: z.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: z.borders(["borderLeft", "borderRight"]),
  borderInline: z.borders("borderInline"),
  borderY: z.borders(["borderTop", "borderBottom"]),
  borderBlock: z.borders("borderBlock"),
  borderTopWidth: z.borderWidths("borderTopWidth"),
  borderBlockStartWidth: z.borderWidths("borderBlockStartWidth"),
  borderTopColor: z.colors("borderTopColor"),
  borderBlockStartColor: z.colors("borderBlockStartColor"),
  borderTopStyle: z.borderStyles("borderTopStyle"),
  borderBlockStartStyle: z.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: z.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: z.borderWidths("borderBlockEndWidth"),
  borderBottomColor: z.colors("borderBottomColor"),
  borderBlockEndColor: z.colors("borderBlockEndColor"),
  borderBottomStyle: z.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: z.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: z.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: z.borderWidths("borderInlineStartWidth"),
  borderLeftColor: z.colors("borderLeftColor"),
  borderInlineStartColor: z.colors("borderInlineStartColor"),
  borderLeftStyle: z.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: z.borderStyles("borderInlineStartStyle"),
  borderRightWidth: z.borderWidths("borderRightWidth"),
  borderInlineEndWidth: z.borderWidths("borderInlineEndWidth"),
  borderRightColor: z.colors("borderRightColor"),
  borderInlineEndColor: z.colors("borderInlineEndColor"),
  borderRightStyle: z.borderStyles("borderRightStyle"),
  borderInlineEndStyle: z.borderStyles("borderInlineEndStyle"),
  borderTopRadius: z.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: z.radii(["borderBottomLeftRadius", "borderBottomRightRadius"]),
  borderLeftRadius: z.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: z.radii(["borderTopRightRadius", "borderBottomRightRadius"])
};
Object.assign(Er, {
  rounded: Er.borderRadius,
  roundedTop: Er.borderTopRadius,
  roundedTopLeft: Er.borderTopLeftRadius,
  roundedTopRight: Er.borderTopRightRadius,
  roundedTopStart: Er.borderStartStartRadius,
  roundedTopEnd: Er.borderStartEndRadius,
  roundedBottom: Er.borderBottomRadius,
  roundedBottomLeft: Er.borderBottomLeftRadius,
  roundedBottomRight: Er.borderBottomRightRadius,
  roundedBottomStart: Er.borderEndStartRadius,
  roundedBottomEnd: Er.borderEndEndRadius,
  roundedLeft: Er.borderLeftRadius,
  roundedRight: Er.borderRightRadius,
  roundedStart: Er.borderInlineStartRadius,
  roundedEnd: Er.borderInlineEndRadius,
  borderStart: Er.borderInlineStart,
  borderEnd: Er.borderInlineEnd,
  borderTopStartRadius: Er.borderStartStartRadius,
  borderTopEndRadius: Er.borderStartEndRadius,
  borderBottomStartRadius: Er.borderEndStartRadius,
  borderBottomEndRadius: Er.borderEndEndRadius,
  borderStartRadius: Er.borderInlineStartRadius,
  borderEndRadius: Er.borderInlineEndRadius,
  borderStartWidth: Er.borderInlineStartWidth,
  borderEndWidth: Er.borderInlineEndWidth,
  borderStartColor: Er.borderInlineStartColor,
  borderEndColor: Er.borderInlineEndColor,
  borderStartStyle: Er.borderInlineStartStyle,
  borderEndStyle: Er.borderInlineEndStyle
});
var Lse = {
  color: z.colors("color"),
  textColor: z.colors("color"),
  fill: z.colors("fill"),
  stroke: z.colors("stroke")
}, dx = {
  boxShadow: z.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: z.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: z.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(dx, {
  shadow: dx.boxShadow
});
var Fse = {
  filter: {
    transform: zr.filter
  },
  blur: z.blur("--chakra-blur"),
  brightness: z.propT("--chakra-brightness", zr.brightness),
  contrast: z.propT("--chakra-contrast", zr.contrast),
  hueRotate: z.degreeT("--chakra-hue-rotate"),
  invert: z.propT("--chakra-invert", zr.invert),
  saturate: z.propT("--chakra-saturate", zr.saturate),
  dropShadow: z.propT("--chakra-drop-shadow", zr.dropShadow),
  backdropFilter: {
    transform: zr.backdropFilter
  },
  backdropBlur: z.blur("--chakra-backdrop-blur"),
  backdropBrightness: z.propT("--chakra-backdrop-brightness", zr.brightness),
  backdropContrast: z.propT("--chakra-backdrop-contrast", zr.contrast),
  backdropHueRotate: z.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: z.propT("--chakra-backdrop-invert", zr.invert),
  backdropSaturate: z.propT("--chakra-backdrop-saturate", zr.saturate)
}, S0 = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: {
    transform: zr.flexDirection
  },
  experimental_spaceX: {
    static: Ose,
    transform: pf({
      scale: "space",
      transform: function(r) {
        return r !== null ? {
          "--chakra-space-x": r
        } : null;
      }
    })
  },
  experimental_spaceY: {
    static: Mse,
    transform: pf({
      scale: "space",
      transform: function(r) {
        return r != null ? {
          "--chakra-space-y": r
        } : null;
      }
    })
  },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: z.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: z.space("gap"),
  rowGap: z.space("rowGap"),
  columnGap: z.space("columnGap")
};
Object.assign(S0, {
  flexDir: S0.flexDirection
});
var yk = {
  gridGap: z.space("gridGap"),
  gridColumnGap: z.space("gridColumnGap"),
  gridRowGap: z.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, zse = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: {
    transform: zr.outline
  },
  outlineOffset: !0,
  outlineColor: z.colors("outlineColor")
}, La = {
  width: z.sizesT("width"),
  inlineSize: z.sizesT("inlineSize"),
  height: z.sizes("height"),
  blockSize: z.sizes("blockSize"),
  boxSize: z.sizes(["width", "height"]),
  minWidth: z.sizes("minWidth"),
  minInlineSize: z.sizes("minInlineSize"),
  minHeight: z.sizes("minHeight"),
  minBlockSize: z.sizes("minBlockSize"),
  maxWidth: z.sizes("maxWidth"),
  maxInlineSize: z.sizes("maxInlineSize"),
  maxHeight: z.sizes("maxHeight"),
  maxBlockSize: z.sizes("maxBlockSize"),
  d: z.prop("display"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: z.propT("float", zr.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(La, {
  w: La.width,
  h: La.height,
  minW: La.minWidth,
  maxW: La.maxWidth,
  minH: La.minHeight,
  maxH: La.maxHeight,
  overscroll: La.overscrollBehavior,
  overscrollX: La.overscrollBehaviorX,
  overscrollY: La.overscrollBehaviorY
});
var Bse = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: z.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: z.prop("listStyleImage")
}, Use = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, Vse = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, T1 = function(r, t, n) {
  var a = {}, i = K$(r, t, {});
  for (var l in i) {
    var u = l in n && n[l] != null;
    u || (a[l] = i[l]);
  }
  return a;
}, Wse = {
  srOnly: {
    transform: function(r) {
      return r === !0 ? Use : r === "focusable" ? Vse : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: function(r, t, n) {
      return T1(t, "layerStyles." + r, n);
    }
  },
  textStyle: {
    processResult: !0,
    transform: function(r, t, n) {
      return T1(t, "textStyles." + r, n);
    }
  },
  apply: {
    processResult: !0,
    transform: function(r, t, n) {
      return T1(t, r, n);
    }
  }
}, Ld = {
  position: !0,
  pos: z.prop("position"),
  zIndex: z.prop("zIndex", "zIndices"),
  inset: z.spaceT("inset"),
  insetX: z.spaceT(["left", "right"]),
  insetInline: z.spaceT("insetInline"),
  insetY: z.spaceT(["top", "bottom"]),
  insetBlock: z.spaceT("insetBlock"),
  top: z.spaceT("top"),
  insetBlockStart: z.spaceT("insetBlockStart"),
  bottom: z.spaceT("bottom"),
  insetBlockEnd: z.spaceT("insetBlockEnd"),
  left: z.spaceT("left"),
  insetInlineStart: z.logical({
    scale: "space",
    property: {
      ltr: "left",
      rtl: "right"
    }
  }),
  right: z.spaceT("right"),
  insetInlineEnd: z.logical({
    scale: "space",
    property: {
      ltr: "right",
      rtl: "left"
    }
  })
};
Object.assign(Ld, {
  insetStart: Ld.insetInlineStart,
  insetEnd: Ld.insetInlineEnd
});
var Hse = {
  ring: {
    transform: zr.ring
  },
  ringColor: z.colors("--chakra-ring-color"),
  ringOffset: z.prop("--chakra-ring-offset-width"),
  ringOffsetColor: z.colors("--chakra-ring-offset-color"),
  ringInset: z.prop("--chakra-ring-inset")
}, lt = {
  margin: z.spaceT("margin"),
  marginTop: z.spaceT("marginTop"),
  marginBlockStart: z.spaceT("marginBlockStart"),
  marginRight: z.spaceT("marginRight"),
  marginInlineEnd: z.spaceT("marginInlineEnd"),
  marginBottom: z.spaceT("marginBottom"),
  marginBlockEnd: z.spaceT("marginBlockEnd"),
  marginLeft: z.spaceT("marginLeft"),
  marginInlineStart: z.spaceT("marginInlineStart"),
  marginX: z.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: z.spaceT("marginInline"),
  marginY: z.spaceT(["marginTop", "marginBottom"]),
  marginBlock: z.spaceT("marginBlock"),
  padding: z.space("padding"),
  paddingTop: z.space("paddingTop"),
  paddingBlockStart: z.space("paddingBlockStart"),
  paddingRight: z.space("paddingRight"),
  paddingBottom: z.space("paddingBottom"),
  paddingBlockEnd: z.space("paddingBlockEnd"),
  paddingLeft: z.space("paddingLeft"),
  paddingInlineStart: z.space("paddingInlineStart"),
  paddingInlineEnd: z.space("paddingInlineEnd"),
  paddingX: z.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: z.space("paddingInline"),
  paddingY: z.space(["paddingTop", "paddingBottom"]),
  paddingBlock: z.space("paddingBlock")
};
Object.assign(lt, {
  m: lt.margin,
  mt: lt.marginTop,
  mr: lt.marginRight,
  me: lt.marginInlineEnd,
  marginEnd: lt.marginInlineEnd,
  mb: lt.marginBottom,
  ml: lt.marginLeft,
  ms: lt.marginInlineStart,
  marginStart: lt.marginInlineStart,
  mx: lt.marginX,
  my: lt.marginY,
  p: lt.padding,
  pt: lt.paddingTop,
  py: lt.paddingY,
  px: lt.paddingX,
  pb: lt.paddingBottom,
  pl: lt.paddingLeft,
  ps: lt.paddingInlineStart,
  paddingStart: lt.paddingInlineStart,
  pr: lt.paddingRight,
  pe: lt.paddingInlineEnd,
  paddingEnd: lt.paddingInlineEnd
});
var Gse = {
  textDecorationColor: z.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: {
    property: "textDecoration"
  },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: z.shadows("textShadow")
}, Yse = {
  clipPath: !0,
  transform: z.propT("transform", zr.transform),
  transformOrigin: !0,
  translateX: z.spaceT("--chakra-translate-x"),
  translateY: z.spaceT("--chakra-translate-y"),
  skewX: z.degreeT("--chakra-skew-x"),
  skewY: z.degreeT("--chakra-skew-y"),
  scaleX: z.prop("--chakra-scale-x"),
  scaleY: z.prop("--chakra-scale-y"),
  scale: z.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: z.degreeT("--chakra-rotate")
}, Kse = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: z.prop("transitionDuration", "transition.duration"),
  transitionProperty: z.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: z.prop("transitionTimingFunction", "transition.easing")
}, qse = {
  fontFamily: z.prop("fontFamily", "fonts"),
  fontSize: z.prop("fontSize", "fontSizes", zr.px),
  fontWeight: z.prop("fontWeight", "fontWeights"),
  lineHeight: z.prop("lineHeight", "lineHeights"),
  letterSpacing: z.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  },
  isTruncated: {
    transform: function(r) {
      if (r === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  }
}, Zse = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: z.spaceT("scrollMargin"),
  scrollMarginTop: z.spaceT("scrollMarginTop"),
  scrollMarginBottom: z.spaceT("scrollMarginBottom"),
  scrollMarginLeft: z.spaceT("scrollMarginLeft"),
  scrollMarginRight: z.spaceT("scrollMarginRight"),
  scrollMarginX: z.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: z.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: z.spaceT("scrollPadding"),
  scrollPaddingTop: z.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: z.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: z.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: z.spaceT("scrollPaddingRight"),
  scrollPaddingX: z.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: z.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function mE(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function Qse(e, r) {
  if (e) {
    if (typeof e == "string")
      return mE(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return mE(e, r);
  }
}
function Xse(e, r) {
  var t = typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t)
    return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = Qse(e)) || r && e && typeof e.length == "number") {
    t && (e = t);
    var n = 0;
    return function() {
      return n >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[n++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var nn = {
  hover: function(r, t) {
    return r + ":hover " + t + ", " + r + "[data-hover] " + t;
  },
  focus: function(r, t) {
    return r + ":focus " + t + ", " + r + "[data-focus] " + t;
  },
  focusVisible: function(r, t) {
    return r + ":focus-visible " + t;
  },
  focusWithin: function(r, t) {
    return r + ":focus-within " + t;
  },
  active: function(r, t) {
    return r + ":active " + t + ", " + r + "[data-active] " + t;
  },
  disabled: function(r, t) {
    return r + ":disabled " + t + ", " + r + "[data-disabled] " + t;
  },
  invalid: function(r, t) {
    return r + ":invalid " + t + ", " + r + "[data-invalid] " + t;
  },
  checked: function(r, t) {
    return r + ":checked " + t + ", " + r + "[data-checked] " + t;
  },
  indeterminate: function(r, t) {
    return r + ":indeterminate " + t + ", " + r + "[aria-checked=mixed] " + t + ", " + r + "[data-indeterminate] " + t;
  },
  readOnly: function(r, t) {
    return r + ":read-only " + t + ", " + r + "[readonly] " + t + ", " + r + "[data-read-only] " + t;
  },
  expanded: function(r, t) {
    return r + ":read-only " + t + ", " + r + "[aria-expanded=true] " + t + ", " + r + "[data-expanded] " + t;
  },
  placeholderShown: function(r, t) {
    return r + ":placeholder-shown " + t;
  }
}, gs = function(r) {
  return Sk(function(t) {
    return r(t, "&");
  }, "[role=group]", "[data-group]", ".group");
}, Ei = function(r) {
  return Sk(function(t) {
    return r(t, "~ &");
  }, "[data-peer]", ".peer");
}, Sk = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(r).join(", ");
}, Q$ = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   */
  _disabled: "&[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: gs(nn.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: Ei(nn.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: gs(nn.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: Ei(nn.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: gs(nn.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: Ei(nn.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: gs(nn.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: Ei(nn.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: gs(nn.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: Ei(nn.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: gs(nn.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: Ei(nn.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: gs(nn.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: Ei(nn.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: gs(nn.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: Ei(nn.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: Ei(nn.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]"
}, Jse = tk(Q$), X$ = Bl({}, Cp, Er, Lse, S0, La, Fse, Hse, zse, yk, Wse, Ld, dx, lt, Zse, qse, Gse, Yse, Bse, Kse);
Object.assign({}, lt, La, S0, yk, Ld);
var ele = [].concat(tk(X$), Jse), rle = b0({}, X$, Q$), tle = function(r) {
  return r in rle;
}, nle = function(r) {
  return function(t) {
    if (!t.__breakpoints)
      return r;
    var n = t.__breakpoints, a = n.isResponsive, i = n.toArrayValue, l = n.media, u = {};
    for (var c in r) {
      var f = Ua(r[c], t);
      if (f != null) {
        if (f = ql(f) && a(f) ? i(f) : f, !Array.isArray(f)) {
          u[c] = f;
          continue;
        }
        for (var h = f.slice(0, l.length).length, p = 0; p < h; p += 1) {
          var g = l == null ? void 0 : l[p];
          if (!g) {
            u[c] = f[p];
            continue;
          }
          u[g] = u[g] || {}, f[p] != null && (u[g][c] = f[p]);
        }
      }
    }
    return u;
  };
}, ale = function(r, t) {
  return r.startsWith("--") && G$(t) && !JP(t);
}, ole = function(r, t) {
  var n, a;
  if (t == null)
    return t;
  var i = function(p) {
    var g, y;
    return (g = r.__cssMap) == null || (y = g[p]) == null ? void 0 : y.varRef;
  }, l = function(p) {
    var g;
    return (g = i(p)) != null ? g : p;
  }, u = t.split(",").map(function(h) {
    return h.trim();
  }), c = u[0], f = u[1];
  return t = (n = (a = i(c)) != null ? a : l(f)) != null ? n : l(t), t;
};
function ile(e) {
  var r = e.configs, t = r === void 0 ? {} : r, n = e.pseudos, a = n === void 0 ? {} : n, i = e.theme, l = function u(c, f) {
    f === void 0 && (f = !1);
    var h = Ua(c, i), p = nle(h)(i), g = {};
    for (var y in p) {
      var S, x, T, A, O, P = p[y], j = Ua(P, i);
      y in a && (y = a[y]), ale(y, j) && (j = ole(i, j));
      var k = t[y];
      if (k === !0 && (k = {
        property: y
      }), ql(j)) {
        var L;
        g[y] = (L = g[y]) != null ? L : {}, g[y] = Bl({}, g[y], u(j, !0));
        continue;
      }
      var M = (S = (x = k) == null || x.transform == null ? void 0 : x.transform(j, i, h)) != null ? S : j;
      M = (T = k) != null && T.processResult ? u(M, !0) : M;
      var W = Ua((A = k) == null ? void 0 : A.property, i);
      if (!f && (O = k) != null && O.static) {
        var q = Ua(k.static, i);
        g = Bl({}, g, q);
      }
      if (W && Array.isArray(W)) {
        for (var oe = Xse(W), Ae; !(Ae = oe()).done; ) {
          var Te = Ae.value;
          g[Te] = M;
        }
        continue;
      }
      if (W) {
        W === "&" && ql(M) ? g = Bl({}, g, M) : g[W] = M;
        continue;
      }
      if (ql(M)) {
        g = Bl({}, g, M);
        continue;
      }
      g[y] = M;
    }
    return g;
  };
  return l;
}
var sle = function(r) {
  return function(t) {
    var n = ile({
      theme: t,
      pseudos: Q$,
      configs: X$
    });
    return n(r);
  };
};
function xk(e) {
  return ql(e) && e.reference ? e.reference : String(e);
}
var Rg = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(xk).join(" " + r + " ").replace(/calc/g, "");
}, bE = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Rg.apply(void 0, ["+"].concat(t)) + ")";
}, yE = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Rg.apply(void 0, ["-"].concat(t)) + ")";
}, fx = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Rg.apply(void 0, ["*"].concat(t)) + ")";
}, SE = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Rg.apply(void 0, ["/"].concat(t)) + ")";
}, xE = function(r) {
  var t = xk(r);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : "-" + t : fx(t, -1);
}, od = Object.assign(function(e) {
  return {
    add: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return od(bE.apply(void 0, [e].concat(n)));
    },
    subtract: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return od(yE.apply(void 0, [e].concat(n)));
    },
    multiply: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return od(fx.apply(void 0, [e].concat(n)));
    },
    divide: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return od(SE.apply(void 0, [e].concat(n)));
    },
    negate: function() {
      return od(xE(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: bE,
  subtract: yE,
  multiply: fx,
  divide: SE,
  negate: xE
}), lle = typeof Element != "undefined", ule = typeof Map == "function", cle = typeof Set == "function", dle = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Ep(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor)
      return !1;
    var t, n, a;
    if (Array.isArray(e)) {
      if (t = e.length, t != r.length)
        return !1;
      for (n = t; n-- !== 0; )
        if (!Ep(e[n], r[n]))
          return !1;
      return !0;
    }
    var i;
    if (ule && e instanceof Map && r instanceof Map) {
      if (e.size !== r.size)
        return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!r.has(n.value[0]))
          return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!Ep(n.value[1], r.get(n.value[0])))
          return !1;
      return !0;
    }
    if (cle && e instanceof Set && r instanceof Set) {
      if (e.size !== r.size)
        return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!r.has(n.value[0]))
          return !1;
      return !0;
    }
    if (dle && ArrayBuffer.isView(e) && ArrayBuffer.isView(r)) {
      if (t = e.length, t != r.length)
        return !1;
      for (n = t; n-- !== 0; )
        if (e[n] !== r[n])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === r.toString();
    if (a = Object.keys(e), t = a.length, t !== Object.keys(r).length)
      return !1;
    for (n = t; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, a[n]))
        return !1;
    if (lle && e instanceof Element)
      return !1;
    for (n = t; n-- !== 0; )
      if (!((a[n] === "_owner" || a[n] === "__v" || a[n] === "__o") && e.$$typeof) && !Ep(e[a[n]], r[a[n]]))
        return !1;
    return !0;
  }
  return e !== e && r !== r;
}
var fle = function(r, t) {
  try {
    return Ep(r, t);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
};
function vle(e, r) {
  if (e != null) {
    if (XP(e)) {
      e(r);
      return;
    }
    try {
      e.current = r;
    } catch (t) {
      throw new Error("Cannot assign value '" + r + "' to ref '" + e + "'");
    }
  }
}
function Fd() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(n) {
    r.forEach(function(a) {
      return vle(a, n);
    });
  };
}
function uu(e) {
  e === void 0 && (e = {});
  var r = e, t = r.strict, n = t === void 0 ? !0 : t, a = r.errorMessage, i = a === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : a, l = r.name, u = /* @__PURE__ */ I.createContext(void 0);
  u.displayName = l;
  function c() {
    var f = I.useContext(u);
    if (!f && n) {
      var h = new Error(i);
      throw h.name = "ContextError", Error.captureStackTrace == null || Error.captureStackTrace(h, c), h;
    }
    return f;
  }
  return [u.Provider, c, u];
}
function vx() {
  return vx = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, vx.apply(this, arguments);
}
function J$() {
  var e = I.useContext(tu);
  if (!e)
    throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
  return e;
}
var hle = uu({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
}), ew = hle[0];
function rw(e) {
  return Y$(e, ["styleConfig", "size", "variant", "colorScheme"]);
}
function ple() {
  var e = Sse(), r = J$();
  return vx({}, e, {
    theme: r
  });
}
function tw(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var gle = new Set([].concat(ele, ["textStyle", "layerStyle", "apply", "isTruncated", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"])), mle = /* @__PURE__ */ new Set(["htmlWidth", "htmlHeight", "htmlSize"]), ble = function(r) {
  return mle.has(r) || !gle.has(r);
}, yle = ["theme", "css", "__css", "sx"], Sle = ["baseStyle"], xle = function(r) {
  var t = r.baseStyle;
  return function(n) {
    n.theme;
    var a = n.css, i = n.__css, l = n.sx, u = tw(n, yle), c = ek(u, function(g, y) {
      return tle(y);
    }), f = Ua(t, n), h = Object.assign({}, i, f, rk(c), l), p = sle(h)(n.theme);
    return a ? [p, a] : p;
  };
};
function C1(e, r) {
  var t = r != null ? r : {}, n = t.baseStyle, a = tw(t, Sle);
  a.shouldForwardProp || (a.shouldForwardProp = ble);
  var i = xle({
    baseStyle: n
  });
  return Qp(e, a)(i);
}
function Pg(e) {
  return /* @__PURE__ */ I.forwardRef(e);
}
var $le = ["styleConfig"];
function wle(e, r, t) {
  var n;
  r === void 0 && (r = {}), t === void 0 && (t = {});
  var a = r, i = a.styleConfig, l = tw(a, $le), u = ple(), c = u.theme, f = u.colorMode, h = K$(c, "components." + e), p = i || h, g = Bl({
    theme: c,
    colorMode: f
  }, (n = p == null ? void 0 : p.defaultProps) != null ? n : {}, rk(Y$(l, ["children"]))), y = Ze({});
  if (p) {
    var S, x, T, A, O, P, j = Ua((S = p.baseStyle) != null ? S : {}, g), k = Ua((x = (T = p.variants) == null ? void 0 : T[g.variant]) != null ? x : {}, g), L = Ua((A = (O = p.sizes) == null ? void 0 : O[g.size]) != null ? A : {}, g), M = Bl({}, j, L, k);
    (P = t) != null && P.isMultiPart && p.parts && p.parts.forEach(function(q) {
      var oe;
      M[q] = (oe = M[q]) != null ? oe : {};
    });
    var W = fle(y.current, M);
    W || (y.current = M);
  }
  return y.current;
}
function nw(e, r) {
  return wle(e, r, {
    isMultiPart: !0
  });
}
function _le() {
  var e = /* @__PURE__ */ new Map();
  return new Proxy(C1, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply: function(t, n, a) {
      return C1.apply(void 0, a);
    },
    /**
     * @example
     * <chakra.div />
     */
    get: function(t, n) {
      return e.has(n) || e.set(n, C1(n)), e.get(n);
    }
  });
}
var Sa = _le();
function Tle(e) {
  const r = Bs;
  return "custom" in r && typeof r.custom == "function" ? r.custom(e) : r(e);
}
Tle(Sa.svg);
var aw = Mg ? I.useLayoutEffect : I.useEffect;
function Ni(e, r) {
  r === void 0 && (r = []);
  var t = I.useRef(e);
  return aw(function() {
    t.current = e;
  }), I.useCallback(function() {
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return t.current == null ? void 0 : t.current.apply(t, a);
  }, r);
}
function Cle(e, r, t, n) {
  var a = Ni(r);
  return I.useEffect(function() {
    var i, l = (i = Ua(t)) != null ? i : document;
    if (r)
      return l.addEventListener(e, a, n), function() {
        l.removeEventListener(e, a, n);
      };
  }, [e, t, n, a, r]), function() {
    var i, l = (i = Ua(t)) != null ? i : document;
    l.removeEventListener(e, a, n);
  };
}
function x0(e) {
  e === void 0 && (e = !1);
  var r = He(e), t = r[0], n = r[1], a = Rt(function() {
    return {
      on: function() {
        return n(!0);
      },
      off: function() {
        return n(!1);
      },
      toggle: function() {
        return n(function(l) {
          return !l;
        });
      }
    };
  }, []);
  return [t, a];
}
function $k(e) {
  var r = e.value, t = e.defaultValue, n = e.onChange, a = e.shouldUpdate, i = a === void 0 ? function(S, x) {
    return S !== x;
  } : a, l = Ni(n), u = Ni(i), c = I.useState(t), f = c[0], h = c[1], p = r !== void 0, g = p ? r : f, y = I.useCallback(function(S) {
    var x = Ua(S, g);
    u(g, x) && (p || h(x), l(x));
  }, [p, l, g, u]);
  return [g, y];
}
function Ele(e, r) {
  var t = I.useState(null), n = t[0], a = t[1], i = I.useRef();
  return aw(function() {
    if (!e.current)
      return;
    var l = e.current;
    function u() {
      i.current = requestAnimationFrame(function() {
        var c = KP(l);
        a(c);
      });
    }
    return u(), r && (window.addEventListener("resize", u), window.addEventListener("scroll", u)), function() {
      r && (window.removeEventListener("resize", u), window.removeEventListener("scroll", u)), i.current && cancelAnimationFrame(i.current);
    };
  }, [r]), n;
}
var Ale = {
  current: 1
}, Ile = /* @__PURE__ */ I.createContext(Ale), Ole = function(r) {
  return r.current++;
};
function wk(e, r) {
  var t = I.useContext(Ile), n = I.useState(t.current), a = n[0], i = n[1];
  return I.useEffect(function() {
    i(Ole(t));
  }, [t]), I.useMemo(function() {
    return e || [r, a].filter(Boolean).join("-");
  }, [e, r, a]);
}
function Mle(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  var a = wk(e);
  return I.useMemo(function() {
    return t.map(function(i) {
      return i + "-" + a;
    });
  }, [a, t]);
}
var _k = function(r, t) {
  var n = I.useRef(!1);
  return I.useEffect(function() {
    if (n.current)
      return r();
    n.current = !0;
  }, t), n.current;
};
function Rle(e, r, t, n) {
  return Cle(hk(r), vk(t, r === "pointerdown"), e, n);
}
function Ple(e, r) {
  return r === void 0 && (r = []), I.useEffect(
    function() {
      return function() {
        return e();
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
}
function Tk(e) {
  var r = I.useRef(null);
  return r.current = e, r;
}
function Ck(e, r) {
  var t = r.onPan, n = r.onPanStart, a = r.onPanEnd, i = r.onPanSessionStart, l = r.onPanSessionEnd, u = r.threshold, c = !!(t || n || a || i || l), f = Ze(null), h = {
    onSessionStart: i,
    onSessionEnd: l,
    onStart: n,
    onMove: t,
    onEnd: function(y, S) {
      f.current = null, a == null || a(y, S);
    }
  };
  er(function() {
    var g;
    (g = f.current) == null || g.updateHandlers(h);
  });
  function p(g) {
    f.current = new vse(g, h, u);
  }
  Rle(function() {
    return e.current;
  }, "pointerdown", c ? p : sk), Ple(function() {
    var g;
    (g = f.current) == null || g.end(), f.current = null;
  });
}
function Ul() {
  return Ul = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Ul.apply(this, arguments);
}
function Ek(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
function kle(e) {
  var r = e.loading, t = e.src, n = e.srcSet, a = e.onLoad, i = e.onError, l = e.crossOrigin, u = e.sizes, c = e.ignoreFallback, f = He("pending"), h = f[0], p = f[1];
  er(function() {
    p(t ? "loading" : "pending");
  }, [t]);
  var g = Ze(), y = Le(function() {
    if (t) {
      S();
      var x = new Image();
      x.src = t, l && (x.crossOrigin = l), n && (x.srcset = n), u && (x.sizes = u), r && (x.loading = r), x.onload = function(T) {
        S(), p("loaded"), a == null || a(T);
      }, x.onerror = function(T) {
        S(), p("failed"), i == null || i(T);
      }, g.current = x;
    }
  }, [t, l, n, u, a, i, r]), S = function() {
    g.current && (g.current.onload = null, g.current.onerror = null, g.current = null);
  };
  return aw(function() {
    if (!c)
      return h === "loading" && y(), function() {
        S();
      };
  }, [h, y, c]), c ? "loaded" : h;
}
var jle = ["htmlWidth", "htmlHeight", "alt"], Dle = ["fallbackSrc", "fallback", "src", "srcSet", "align", "fit", "loading", "ignoreFallback", "crossOrigin"], $E = /* @__PURE__ */ I.forwardRef(function(e, r) {
  var t = e.htmlWidth, n = e.htmlHeight, a = e.alt, i = Ek(e, jle);
  return /* @__PURE__ */ I.createElement("img", Ul({
    width: t,
    height: n,
    ref: r,
    alt: a
  }, i));
}), Nle = /* @__PURE__ */ Pg(function(e, r) {
  var t = e.fallbackSrc, n = e.fallback, a = e.src, i = e.srcSet, l = e.align, u = e.fit, c = e.loading, f = e.ignoreFallback, h = e.crossOrigin, p = Ek(e, Dle), g = c != null || f || t === void 0 && n === void 0, y = kle(Ul({}, e, {
    ignoreFallback: g
  })), S = Ul({
    ref: r,
    objectFit: u,
    objectPosition: l
  }, g ? p : Y$(p, ["onError", "onLoad"]));
  return y !== "loaded" ? n || /* @__PURE__ */ I.createElement(Sa.img, Ul({
    as: $E,
    className: "chakra-image__placeholder",
    src: t
  }, S)) : /* @__PURE__ */ I.createElement(Sa.img, Ul({
    as: $E,
    src: a,
    srcSet: i,
    crossOrigin: h,
    loading: c,
    className: "chakra-image"
  }, S));
});
function Lle(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
function gf() {
  return gf = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, gf.apply(this, arguments);
}
var Yr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qt = typeof Symbol == "function" && Symbol.for, ow = Qt ? Symbol.for("react.element") : 60103, iw = Qt ? Symbol.for("react.portal") : 60106, kg = Qt ? Symbol.for("react.fragment") : 60107, jg = Qt ? Symbol.for("react.strict_mode") : 60108, Dg = Qt ? Symbol.for("react.profiler") : 60114, Ng = Qt ? Symbol.for("react.provider") : 60109, Lg = Qt ? Symbol.for("react.context") : 60110, sw = Qt ? Symbol.for("react.async_mode") : 60111, Fg = Qt ? Symbol.for("react.concurrent_mode") : 60111, zg = Qt ? Symbol.for("react.forward_ref") : 60112, Bg = Qt ? Symbol.for("react.suspense") : 60113, Fle = Qt ? Symbol.for("react.suspense_list") : 60120, Ug = Qt ? Symbol.for("react.memo") : 60115, Vg = Qt ? Symbol.for("react.lazy") : 60116, zle = Qt ? Symbol.for("react.block") : 60121, Ble = Qt ? Symbol.for("react.fundamental") : 60117, Ule = Qt ? Symbol.for("react.responder") : 60118, Vle = Qt ? Symbol.for("react.scope") : 60119;
function _a(e) {
  if (typeof e == "object" && e !== null) {
    var r = e.$$typeof;
    switch (r) {
      case ow:
        switch (e = e.type, e) {
          case sw:
          case Fg:
          case kg:
          case Dg:
          case jg:
          case Bg:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case Lg:
              case zg:
              case Vg:
              case Ug:
              case Ng:
                return e;
              default:
                return r;
            }
        }
      case iw:
        return r;
    }
  }
}
function Ak(e) {
  return _a(e) === Fg;
}
Yr.AsyncMode = sw;
Yr.ConcurrentMode = Fg;
Yr.ContextConsumer = Lg;
Yr.ContextProvider = Ng;
Yr.Element = ow;
Yr.ForwardRef = zg;
Yr.Fragment = kg;
Yr.Lazy = Vg;
Yr.Memo = Ug;
Yr.Portal = iw;
Yr.Profiler = Dg;
Yr.StrictMode = jg;
Yr.Suspense = Bg;
Yr.isAsyncMode = function(e) {
  return Ak(e) || _a(e) === sw;
};
Yr.isConcurrentMode = Ak;
Yr.isContextConsumer = function(e) {
  return _a(e) === Lg;
};
Yr.isContextProvider = function(e) {
  return _a(e) === Ng;
};
Yr.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === ow;
};
Yr.isForwardRef = function(e) {
  return _a(e) === zg;
};
Yr.isFragment = function(e) {
  return _a(e) === kg;
};
Yr.isLazy = function(e) {
  return _a(e) === Vg;
};
Yr.isMemo = function(e) {
  return _a(e) === Ug;
};
Yr.isPortal = function(e) {
  return _a(e) === iw;
};
Yr.isProfiler = function(e) {
  return _a(e) === Dg;
};
Yr.isStrictMode = function(e) {
  return _a(e) === jg;
};
Yr.isSuspense = function(e) {
  return _a(e) === Bg;
};
Yr.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === kg || e === Fg || e === Dg || e === jg || e === Bg || e === Fle || typeof e == "object" && e !== null && (e.$$typeof === Vg || e.$$typeof === Ug || e.$$typeof === Ng || e.$$typeof === Lg || e.$$typeof === zg || e.$$typeof === Ble || e.$$typeof === Ule || e.$$typeof === Vle || e.$$typeof === zle);
};
Yr.typeOf = _a;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var wE = Object.getOwnPropertySymbols, Wle = Object.prototype.hasOwnProperty, Hle = Object.prototype.propertyIsEnumerable;
function Gle(e) {
  if (e == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
function Yle() {
  try {
    if (!Object.assign)
      return !1;
    var e = new String("abc");
    if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5")
      return !1;
    for (var r = {}, t = 0; t < 10; t++)
      r["_" + String.fromCharCode(t)] = t;
    var n = Object.getOwnPropertyNames(r).map(function(i) {
      return r[i];
    });
    if (n.join("") !== "0123456789")
      return !1;
    var a = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(i) {
      a[i] = i;
    }), Object.keys(Object.assign({}, a)).join("") === "abcdefghijklmnopqrst";
  } catch (i) {
    return !1;
  }
}
Yle();
var Kle = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", qle = Kle;
Function.call.bind(Object.prototype.hasOwnProperty);
var Zle = qle;
function Ik() {
}
function Ok() {
}
Ok.resetWarningCache = Ik;
var Qle = function() {
  function e(n, a, i, l, u, c) {
    if (c !== Zle) {
      var f = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw f.name = "Invariant Violation", f;
    }
  }
  e.isRequired = e;
  function r() {
    return e;
  }
  var t = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: r,
    element: e,
    elementType: e,
    instanceOf: r,
    node: e,
    objectOf: r,
    oneOf: r,
    oneOfType: r,
    shape: r,
    exact: r,
    checkPropTypes: Ok,
    resetWarningCache: Ik
  };
  return t.PropTypes = t, t;
};
Qle();
var hx = "data-focus-lock", Mk = "data-focus-lock-disabled", Xle = "data-no-focus-lock", Jle = "data-autofocus-inside";
function eue(e, r) {
  return typeof e == "function" ? e(r) : e && (e.current = r), e;
}
function rue(e, r) {
  var t = He(function() {
    return {
      // value
      value: e,
      // last callback
      callback: r,
      // "memoized" public interface
      facade: {
        get current() {
          return t.value;
        },
        set current(n) {
          var a = t.value;
          a !== n && (t.value = n, t.callback(n, a));
        }
      }
    };
  })[0];
  return t.callback = r, t.facade;
}
function Rk(e, r) {
  return rue(r || null, function(t) {
    return e.forEach(function(n) {
      return eue(n, t);
    });
  });
}
var E1 = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
function Pk(e) {
  return e;
}
function kk(e, r) {
  r === void 0 && (r = Pk);
  var t = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return t.length ? t[t.length - 1] : e;
    },
    useMedium: function(i) {
      var l = r(i, n);
      return t.push(l), function() {
        t = t.filter(function(u) {
          return u !== l;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; t.length; ) {
        var l = t;
        t = [], l.forEach(i);
      }
      t = {
        push: function(u) {
          return i(u);
        },
        filter: function() {
          return t;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var l = [];
      if (t.length) {
        var u = t;
        t = [], u.forEach(i), l = t;
      }
      var c = function() {
        var h = l;
        l = [], h.forEach(i);
      }, f = function() {
        return Promise.resolve().then(c);
      };
      f(), t = {
        push: function(h) {
          l.push(h), f();
        },
        filter: function(h) {
          return l = l.filter(h), t;
        }
      };
    }
  };
  return a;
}
function lw(e, r) {
  return r === void 0 && (r = Pk), kk(e, r);
}
function jk(e) {
  e === void 0 && (e = {});
  var r = kk(null);
  return r.options = Ds({ async: !0, ssr: !1 }, e), r;
}
var Dk = function(e) {
  var r = e.sideCar, t = W$(e, ["sideCar"]);
  if (!r)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = r.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return I.createElement(n, Ds({}, t));
};
Dk.isSideCarExport = !0;
function tue(e, r) {
  return e.useMedium(r), Dk;
}
var Nk = lw({}, function(e) {
  var r = e.target, t = e.currentTarget;
  return {
    target: r,
    currentTarget: t
  };
}), Lk = lw(), nue = lw(), aue = jk({
  async: !0
}), oue = [], uw = /* @__PURE__ */ I.forwardRef(function(r, t) {
  var n, a = I.useState(), i = a[0], l = a[1], u = I.useRef(), c = I.useRef(!1), f = I.useRef(null), h = r.children, p = r.disabled, g = r.noFocusGuards, y = r.persistentFocus, S = r.crossFrame, x = r.autoFocus;
  r.allowTextSelection;
  var T = r.group, A = r.className, O = r.whiteList, P = r.shards, j = P === void 0 ? oue : P, k = r.as, L = k === void 0 ? "div" : k, M = r.lockProps, W = M === void 0 ? {} : M, q = r.sideCar, oe = r.returnFocus, Ae = r.onActivation, Te = r.onDeactivation, $e = I.useState({}), Ee = $e[0], ze = I.useCallback(function() {
    f.current = f.current || document && document.activeElement, u.current && Ae && Ae(u.current), c.current = !0;
  }, [Ae]), Ke = I.useCallback(function() {
    c.current = !1, Te && Te(u.current);
  }, [Te]), Be = I.useCallback(function(te) {
    var fe = f.current;
    if (oe && fe && fe.focus) {
      var je = typeof oe == "object" ? oe : void 0;
      f.current = null, te ? Promise.resolve().then(function() {
        return fe.focus(je);
      }) : fe.focus(je);
    }
  }, [oe]), ue = I.useCallback(function(te) {
    c.current && Nk.useMedium(te);
  }, []), he = Lk.useMedium, _e = I.useCallback(function(te) {
    u.current !== te && (u.current = te, l(te));
  }, []), Oe = gf((n = {}, n[Mk] = p && "disabled", n[hx] = T, n), W), Me = g !== !0, Z = Me && g !== "tail", se = Rk([t, _e]);
  return /* @__PURE__ */ I.createElement(I.Fragment, null, Me && [
    /* @__PURE__ */ I.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: p ? -1 : 0,
      style: E1
    }),
    // nearest focus guard
    /* @__PURE__ */ I.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: p ? -1 : 1,
      style: E1
    })
    // first tabbed element guard
  ], !p && /* @__PURE__ */ I.createElement(q, {
    id: Ee,
    sideCar: aue,
    observed: i,
    disabled: p,
    persistentFocus: y,
    crossFrame: S,
    autoFocus: x,
    whiteList: O,
    shards: j,
    onActivation: ze,
    onDeactivation: Ke,
    returnFocus: Be
  }), /* @__PURE__ */ I.createElement(L, gf({
    ref: se
  }, Oe, {
    className: A,
    onBlur: he,
    onFocus: ue
  }), h), Z && /* @__PURE__ */ I.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: p ? -1 : 0,
    style: E1
  }));
});
uw.propTypes = {};
uw.defaultProps = {
  children: void 0,
  disabled: !1,
  returnFocus: !1,
  noFocusGuards: !1,
  autoFocus: !0,
  persistentFocus: !1,
  crossFrame: !0,
  allowTextSelection: void 0,
  group: void 0,
  className: void 0,
  whiteList: void 0,
  shards: void 0,
  as: "div",
  lockProps: {},
  onActivation: void 0,
  onDeactivation: void 0
};
var Fk = uw;
function px(e, r) {
  return px = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, px(e, r);
}
function iue(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, px(e, r);
}
function mf(e) {
  "@babel/helpers - typeof";
  return mf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, mf(e);
}
function sue(e, r) {
  if (mf(e) !== "object" || e === null)
    return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r || "default");
    if (mf(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function lue(e) {
  var r = sue(e, "string");
  return mf(r) === "symbol" ? r : String(r);
}
function uue(e, r, t) {
  return r = lue(r), r in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function cue(e, r) {
  function t(n) {
    return n.displayName || n.name || "Component";
  }
  return function(a) {
    var i = [], l;
    function u() {
      l = e(i.map(function(f) {
        return f.props;
      })), r(l);
    }
    var c = /* @__PURE__ */ function(f) {
      iue(h, f);
      function h() {
        return f.apply(this, arguments) || this;
      }
      h.peek = function() {
        return l;
      };
      var p = h.prototype;
      return p.componentDidMount = function() {
        i.push(this), u();
      }, p.componentDidUpdate = function() {
        u();
      }, p.componentWillUnmount = function() {
        var y = i.indexOf(this);
        i.splice(y, 1), u();
      }, p.render = function() {
        return /* @__PURE__ */ $o.createElement(a, this.props);
      }, h;
    }(aU);
    return uue(c, "displayName", "SideEffect(" + t(a) + ")"), c;
  };
}
var Ls = function(e) {
  for (var r = Array(e.length), t = 0; t < e.length; ++t)
    r[t] = e[t];
  return r;
}, gx = function(e) {
  return Array.isArray(e) ? e : [e];
}, due = function(e) {
  for (var r = /* @__PURE__ */ new Set(), t = e.length, n = 0; n < t; n += 1)
    for (var a = n + 1; a < t; a += 1) {
      var i = e[n].compareDocumentPosition(e[a]);
      (i & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && r.add(a), (i & Node.DOCUMENT_POSITION_CONTAINS) > 0 && r.add(n);
    }
  return e.filter(function(l, u) {
    return !r.has(u);
  });
}, zk = function(e) {
  return e.parentNode ? zk(e.parentNode) : e;
}, cw = function(e) {
  var r = gx(e);
  return r.filter(Boolean).reduce(function(t, n) {
    var a = n.getAttribute(hx);
    return t.push.apply(t, a ? due(Ls(zk(n).querySelectorAll("[" + hx + '="' + a + '"]:not([' + Mk + '="disabled"])'))) : [n]), t;
  }, []);
}, fue = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var r = window.getComputedStyle(e, null);
  return !r || !r.getPropertyValue ? !1 : r.getPropertyValue("display") === "none" || r.getPropertyValue("visibility") === "hidden";
}, vue = function(e, r) {
  return !e || e === document || e && e.nodeType === Node.DOCUMENT_NODE || !fue(e) && r(e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? e.parentNode.host : e.parentNode);
}, Bk = function(e, r) {
  var t = e.get(r);
  if (t !== void 0)
    return t;
  var n = vue(r, Bk.bind(void 0, e));
  return e.set(r, n), n;
}, hue = function(e) {
  return !((e.tagName === "INPUT" || e.tagName === "BUTTON") && (e.type === "hidden" || e.disabled));
}, dw = function(e) {
  return !!(e && e.dataset && e.dataset.focusGuard);
}, $0 = function(e) {
  return !dw(e);
}, pue = function(e) {
  return !!e;
}, gue = function(e, r) {
  var t = e.tabIndex - r.tabIndex, n = e.index - r.index;
  if (t) {
    if (!e.tabIndex)
      return 1;
    if (!r.tabIndex)
      return -1;
  }
  return t || n;
}, Uk = function(e, r, t) {
  return Ls(e).map(function(n, a) {
    return {
      node: n,
      index: a,
      tabIndex: t && n.tabIndex === -1 ? (n.dataset || {}).focusGuard ? 0 : -1 : n.tabIndex
    };
  }).filter(function(n) {
    return !r || n.tabIndex >= 0;
  }).sort(gue);
}, mue = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], mx = mue.join(","), bue = mx + ", [data-focus-guard]", fw = function(e, r) {
  return e.reduce(function(t, n) {
    return t.concat(Ls(n.querySelectorAll(r ? bue : mx)), n.parentNode ? Ls(n.parentNode.querySelectorAll(mx)).filter(function(a) {
      return a === n;
    }) : []);
  }, []);
}, yue = function(e) {
  var r = e.querySelectorAll("[" + Jle + "]");
  return Ls(r).map(function(t) {
    return fw([t]);
  }).reduce(function(t, n) {
    return t.concat(n);
  }, []);
}, vw = function(e, r) {
  return Ls(e).filter(function(t) {
    return Bk(r, t);
  }).filter(function(t) {
    return hue(t);
  });
}, bx = function(e, r, t) {
  return Uk(vw(fw(e, t), r), !0, t);
}, _E = function(e, r) {
  return Uk(vw(fw(e), r), !1);
}, Sue = function(e, r) {
  return vw(yue(e), r);
}, yx = function(e, r) {
  return r === void 0 && (r = []), r.push(e), e.parentNode && yx(e.parentNode, r), r;
}, A1 = function(e, r) {
  for (var t = yx(e), n = yx(r), a = 0; a < t.length; a += 1) {
    var i = t[a];
    if (n.indexOf(i) >= 0)
      return i;
  }
  return !1;
}, Vk = function(e, r, t) {
  var n = gx(e), a = gx(r), i = n[0], l = !1;
  return a.filter(Boolean).forEach(function(u) {
    l = A1(l || u, u) || l, t.filter(Boolean).forEach(function(c) {
      var f = A1(i, c);
      f && (!l || f.contains(l) ? l = f : l = A1(f, l));
    });
  }), l;
}, xue = function(e, r) {
  return e.reduce(function(t, n) {
    return t.concat(Sue(n, r));
  }, []);
}, $ue = function(e) {
  var r = cw(e).filter($0), t = Vk(e, e, r), n = /* @__PURE__ */ new Map(), a = bx([t], n, !0), i = bx(r, n).filter(function(l) {
    var u = l.node;
    return $0(u);
  }).map(function(l) {
    var u = l.node;
    return u;
  });
  return a.map(function(l) {
    var u = l.node, c = l.index;
    return {
      node: u,
      index: c,
      lockItem: i.indexOf(u) >= 0,
      guard: dw(u)
    };
  });
}, wue = function(e) {
  return e === document.activeElement;
}, _ue = function(e) {
  return !!Ls(e.querySelectorAll("iframe")).some(function(r) {
    return wue(r);
  });
}, Wk = function(e) {
  var r = document && document.activeElement;
  return !r || r.dataset && r.dataset.focusGuard ? !1 : cw(e).reduce(function(t, n) {
    return t || n.contains(r) || _ue(n);
  }, !1);
}, Tue = function() {
  return document && Ls(document.querySelectorAll("[" + Xle + "]")).some(function(e) {
    return e.contains(document.activeElement);
  });
}, Hk = function(e) {
  return e.tagName === "INPUT" && e.type === "radio";
}, Cue = function(e, r) {
  return r.filter(Hk).filter(function(t) {
    return t.name === e.name;
  }).filter(function(t) {
    return t.checked;
  })[0] || e;
}, hw = function(e, r) {
  return Hk(e) && e.name ? Cue(e, r) : e;
}, Eue = function(e) {
  var r = /* @__PURE__ */ new Set();
  return e.forEach(function(t) {
    return r.add(hw(t, e));
  }), e.filter(function(t) {
    return r.has(t);
  });
}, TE = function(e) {
  return e[0] && e.length > 1 ? hw(e[0], e) : e[0];
}, CE = function(e, r) {
  return e.length > 1 ? e.indexOf(hw(e[r], e)) : r;
}, Gk = "NEW_FOCUS", Aue = function(e, r, t, n) {
  var a = e.length, i = e[0], l = e[a - 1], u = dw(t);
  if (!(e.indexOf(t) >= 0)) {
    var c = r.indexOf(t), f = n ? r.indexOf(n) : c, h = n ? e.indexOf(n) : -1, p = c - f, g = r.indexOf(i), y = r.indexOf(l), S = Eue(r), x = S.indexOf(t) - (n ? S.indexOf(n) : c), T = CE(e, 0), A = CE(e, a - 1);
    if (c === -1 || h === -1)
      return Gk;
    if (!p && h >= 0)
      return h;
    if (c <= g && u && Math.abs(p) > 1)
      return A;
    if (c >= y && u && Math.abs(p) > 1)
      return T;
    if (p && Math.abs(x) > 1)
      return h;
    if (c <= g)
      return A;
    if (c > y)
      return T;
    if (p)
      return Math.abs(p) > 1 ? h : (a + h + p) % a;
  }
}, Iue = function(e) {
  return function(r) {
    return r.autofocus || r.dataset && !!r.dataset.autofocus || e.indexOf(r) >= 0;
  };
}, Oue = function(e, r) {
  var t = /* @__PURE__ */ new Map();
  return r.forEach(function(n) {
    return t.set(n.node, n);
  }), e.map(function(n) {
    return t.get(n);
  }).filter(pue);
}, Mue = function(e, r) {
  var t = document && document.activeElement, n = cw(e).filter($0), a = Vk(t || e, e, n), i = /* @__PURE__ */ new Map(), l = _E(n, i), u = bx(n, i).filter(function(y) {
    var S = y.node;
    return $0(S);
  });
  if (!(!u[0] && (u = l, !u[0]))) {
    var c = _E([a], i).map(function(y) {
      var S = y.node;
      return S;
    }), f = Oue(c, u), h = f.map(function(y) {
      var S = y.node;
      return S;
    }), p = Aue(h, c, t, r);
    if (p === Gk) {
      var g = l.map(function(y) {
        var S = y.node;
        return S;
      }).filter(Iue(xue(n, i)));
      return {
        node: g && g.length ? TE(g) : TE(h)
      };
    }
    return p === void 0 ? p : f[p];
  }
}, Rue = function(e) {
  e.focus(), "contentWindow" in e && e.contentWindow && e.contentWindow.focus();
}, I1 = 0, O1 = !1, Pue = function(e, r) {
  var t = Mue(e, r);
  if (!O1 && t) {
    if (I1 > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), O1 = !0, setTimeout(function() {
        O1 = !1;
      }, 1);
      return;
    }
    I1++, Rue(t.node), I1--;
  }
}, Yk = Pue;
function Kk(e) {
  var r = window, t = r.setImmediate;
  typeof t != "undefined" ? t(e) : setTimeout(e, 1);
}
var kue = function() {
  return document && document.activeElement === document.body;
}, jue = function() {
  return kue() || Tue();
}, dc = null, Zu = null, fc = null, bf = !1, Due = function() {
  return !0;
}, Nue = function(r) {
  return (dc.whiteList || Due)(r);
}, Lue = function(r, t) {
  fc = {
    observerNode: r,
    portaledElement: t
  };
}, Fue = function(r) {
  return fc && fc.portaledElement === r;
};
function EE(e, r, t, n) {
  var a = null, i = e;
  do {
    var l = n[i];
    if (l.guard)
      l.node.dataset.focusAutoGuard && (a = l);
    else if (l.lockItem) {
      if (i !== e)
        return;
      a = null;
    } else
      break;
  } while ((i += t) !== r);
  a && (a.node.tabIndex = 0);
}
var zue = function(r) {
  return r && "current" in r ? r.current : r;
}, Bue = function(r) {
  return r ? !!bf : bf === "meanwhile";
}, w0 = function() {
  var r = !1;
  if (dc) {
    var t = dc, n = t.observed, a = t.persistentFocus, i = t.autoFocus, l = t.shards, u = t.crossFrame, c = n || fc && fc.portaledElement, f = document && document.activeElement;
    if (c) {
      var h = [c].concat(l.map(zue).filter(Boolean));
      if ((!f || Nue(f)) && (a || Bue(u) || !jue() || !Zu && i) && (c && !(Wk(h) || Fue(f)) && (document && !Zu && f && !i ? (f.blur && f.blur(), document.body.focus()) : (r = Yk(h, Zu), fc = {})), bf = !1, Zu = document && document.activeElement), document) {
        var p = document && document.activeElement, g = $ue(h), y = g.map(function(S) {
          var x = S.node;
          return x;
        }).indexOf(p);
        y > -1 && (g.filter(function(S) {
          var x = S.guard, T = S.node;
          return x && T.dataset.focusAutoGuard;
        }).forEach(function(S) {
          var x = S.node;
          return x.removeAttribute("tabIndex");
        }), EE(y, g.length, 1, g), EE(y, -1, -1, g));
      }
    }
  }
  return r;
}, qk = function(r) {
  w0() && r && (r.stopPropagation(), r.preventDefault());
}, pw = function() {
  return Kk(w0);
}, Uue = function(r) {
  var t = r.target, n = r.currentTarget;
  n.contains(t) || Lue(n, t);
}, Vue = function() {
  return null;
}, Zk = function() {
  bf = "just", setTimeout(function() {
    bf = "meanwhile";
  }, 0);
}, Wue = function() {
  document.addEventListener("focusin", qk, !0), document.addEventListener("focusout", pw), window.addEventListener("blur", Zk);
}, Hue = function() {
  document.removeEventListener("focusin", qk, !0), document.removeEventListener("focusout", pw), window.removeEventListener("blur", Zk);
};
function Gue(e) {
  return e.filter(function(r) {
    var t = r.disabled;
    return !t;
  });
}
function Yue(e) {
  var r = e.slice(-1)[0];
  r && !dc && Wue();
  var t = dc, n = t && r && r.id === t.id;
  dc = r, t && !n && (t.onDeactivation(), e.filter(function(a) {
    var i = a.id;
    return i === t.id;
  }).length || t.returnFocus(!r)), r ? (Zu = null, (!n || t.observed !== r.observed) && r.onActivation(), w0(), Kk(w0)) : (Hue(), Zu = null);
}
Nk.assignSyncMedium(Uue);
Lk.assignMedium(pw);
nue.assignMedium(function(e) {
  return e({
    moveFocusInside: Yk,
    focusInside: Wk
  });
});
var Kue = cue(Gue, Yue)(Vue), que = /* @__PURE__ */ I.forwardRef(function(r, t) {
  return /* @__PURE__ */ I.createElement(Fk, gf({
    sideCar: Kue,
    ref: t
  }, r));
}), Qk = Fk.propTypes || {};
Qk.sideCar;
Lle(Qk, ["sideCar"]);
que.propTypes = {};
uu({
  strict: !1,
  name: "PortalManagerContext"
});
uu({
  strict: !1,
  name: "PortalContext"
});
function Zue(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
function Va() {
  return Va = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Va.apply(this, arguments);
}
var Sx = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
}, id = {
  scale: {
    enter: {
      scale: 1
    },
    exit: {
      scale: 0.95
    }
  },
  fade: {
    enter: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  },
  pushLeft: {
    enter: {
      x: "100%"
    },
    exit: {
      x: "-30%"
    }
  },
  pushRight: {
    enter: {
      x: "-100%"
    },
    exit: {
      x: "30%"
    }
  },
  pushUp: {
    enter: {
      y: "100%"
    },
    exit: {
      y: "-30%"
    }
  },
  pushDown: {
    enter: {
      y: "-100%"
    },
    exit: {
      y: "30%"
    }
  },
  slideLeft: {
    position: {
      left: 0,
      top: 0,
      bottom: 0,
      width: "100%"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: "-100%",
      y: 0
    }
  },
  slideRight: {
    position: {
      right: 0,
      top: 0,
      bottom: 0,
      width: "100%"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: "100%",
      y: 0
    }
  },
  slideUp: {
    position: {
      top: 0,
      left: 0,
      right: 0,
      maxWidth: "100vw"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: 0,
      y: "-100%"
    }
  },
  slideDown: {
    position: {
      bottom: 0,
      left: 0,
      right: 0,
      maxWidth: "100vw"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: 0,
      y: "100%"
    }
  }
};
function xx(e) {
  var r, t = (r = e == null ? void 0 : e.direction) != null ? r : "right";
  switch (t) {
    case "right":
      return id.slideRight;
    case "left":
      return id.slideLeft;
    case "bottom":
      return id.slideDown;
    case "top":
      return id.slideUp;
    default:
      return id.slideRight;
  }
}
var zd = {
  enter: {
    duration: 0.2,
    ease: Sx.easeOut
  },
  exit: {
    duration: 0.1,
    ease: Sx.easeIn
  }
}, Zl = {
  enter: function(r, t) {
    return Va({}, r, {
      delay: Kl(t) ? t : t == null ? void 0 : t.enter
    });
  },
  exit: function(r, t) {
    return Va({}, r, {
      delay: Kl(t) ? t : t == null ? void 0 : t.exit
    });
  }
}, Que = {
  exit: function(r) {
    var t, n = r.reverse, a = r.initialScale, i = r.transition, l = r.transitionEnd, u = r.delay;
    return Va({
      opacity: 0
    }, n ? {
      scale: a,
      transitionEnd: l == null ? void 0 : l.exit
    } : {
      transitionEnd: Va({
        scale: a
      }, l == null ? void 0 : l.exit)
    }, {
      transition: (t = i == null ? void 0 : i.exit) != null ? t : Zl.exit(zd.exit, u)
    });
  },
  enter: function(r) {
    var t, n = r.transitionEnd, a = r.transition, i = r.delay;
    return {
      opacity: 1,
      scale: 1,
      transition: (t = a == null ? void 0 : a.enter) != null ? t : Zl.enter(zd.enter, i),
      transitionEnd: n == null ? void 0 : n.enter
    };
  }
}, Xue = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: Que
}, Jue = ["direction", "style", "unmountOnExit", "in", "className", "transition", "transitionEnd", "delay"], AE = {
  exit: {
    duration: 0.15,
    ease: Sx.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
}, ece = {
  exit: function(r) {
    var t, n = r.direction, a = r.transition, i = r.transitionEnd, l = r.delay, u = xx({
      direction: n
    }), c = u.exit;
    return Va({}, c, {
      transition: (t = a == null ? void 0 : a.exit) != null ? t : Zl.exit(AE.exit, l),
      transitionEnd: i == null ? void 0 : i.exit
    });
  },
  enter: function(r) {
    var t, n = r.direction, a = r.transitionEnd, i = r.transition, l = r.delay, u = xx({
      direction: n
    }), c = u.enter;
    return Va({}, c, {
      transition: (t = i == null ? void 0 : i.enter) != null ? t : Zl.enter(AE.enter, l),
      transitionEnd: a == null ? void 0 : a.enter
    });
  }
}, rce = /* @__PURE__ */ I.forwardRef(function(e, r) {
  var t = e.direction, n = t === void 0 ? "right" : t, a = e.style, i = e.unmountOnExit, l = e.in, u = e.className, c = e.transition, f = e.transitionEnd, h = e.delay, p = Zue(e, Jue), g = xx({
    direction: n
  }), y = Object.assign({
    position: "fixed"
  }, g.position, a), S = i ? l && i : !0, x = l || i ? "enter" : "exit", T = {
    transitionEnd: f,
    transition: c,
    direction: n,
    delay: h
  };
  return /* @__PURE__ */ I.createElement(cte, {
    custom: T
  }, S && /* @__PURE__ */ I.createElement(Bs.div, Va({}, p, {
    ref: r,
    initial: "exit",
    className: Z$("chakra-slide", u),
    animate: x,
    exit: "exit",
    custom: T,
    variants: ece,
    style: y
  })));
}), tce = {
  initial: function(r) {
    var t, n = r.offsetX, a = r.offsetY, i = r.transition, l = r.transitionEnd, u = r.delay;
    return {
      opacity: 0,
      x: n,
      y: a,
      transition: (t = i == null ? void 0 : i.exit) != null ? t : Zl.exit(zd.exit, u),
      transitionEnd: l == null ? void 0 : l.exit
    };
  },
  enter: function(r) {
    var t, n = r.transition, a = r.transitionEnd, i = r.delay;
    return {
      opacity: 1,
      x: 0,
      y: 0,
      transition: (t = n == null ? void 0 : n.enter) != null ? t : Zl.enter(zd.enter, i),
      transitionEnd: a == null ? void 0 : a.enter
    };
  },
  exit: function(r) {
    var t, n = r.offsetY, a = r.offsetX, i = r.transition, l = r.transitionEnd, u = r.reverse, c = r.delay, f = {
      x: a,
      y: n
    };
    return Va({
      opacity: 0,
      transition: (t = i == null ? void 0 : i.exit) != null ? t : Zl.exit(zd.exit, c)
    }, u ? Va({}, f, {
      transitionEnd: l == null ? void 0 : l.exit
    }) : {
      transitionEnd: Va({}, f, l == null ? void 0 : l.exit)
    });
  }
}, IE = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: tce
}, Ap = "right-scroll-bar-position", Ip = "width-before-scroll-bar", nce = "with-scroll-bars-hidden", ace = "--removed-body-scroll-bar-size", Xk = jk(), M1 = function() {
}, Wg = I.forwardRef(function(e, r) {
  var t = I.useRef(null), n = I.useState({
    onScrollCapture: M1,
    onWheelCapture: M1,
    onTouchMoveCapture: M1
  }), a = n[0], i = n[1], l = e.forwardProps, u = e.children, c = e.className, f = e.removeScrollBar, h = e.enabled, p = e.shards, g = e.sideCar, y = e.noIsolation, S = e.inert, x = e.allowPinchZoom, T = e.as, A = T === void 0 ? "div" : T, O = W$(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), P = g, j = Rk([
    t,
    r
  ]), k = Ds({}, O, a);
  return I.createElement(
    I.Fragment,
    null,
    h && I.createElement(P, { sideCar: Xk, removeScrollBar: f, shards: p, noIsolation: y, inert: S, setCallbacks: i, allowPinchZoom: !!x, lockRef: t }),
    l ? I.cloneElement(I.Children.only(u), Ds({}, k, { ref: j })) : I.createElement(A, Ds({}, k, { className: c, ref: j }), u)
  );
});
Wg.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Wg.classNames = {
  fullWidth: Ip,
  zeroRight: Ap
};
var oce = function() {
  if (typeof __webpack_nonce__ != "undefined")
    return __webpack_nonce__;
};
function ice() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var r = oce();
  return r && e.setAttribute("nonce", r), e;
}
function sce(e, r) {
  e.styleSheet ? e.styleSheet.cssText = r : e.appendChild(document.createTextNode(r));
}
function lce(e) {
  var r = document.head || document.getElementsByTagName("head")[0];
  r.appendChild(e);
}
var uce = function() {
  var e = 0, r = null;
  return {
    add: function(t) {
      e == 0 && (r = ice()) && (sce(r, t), lce(r)), e++;
    },
    remove: function() {
      e--, !e && r && (r.parentNode && r.parentNode.removeChild(r), r = null);
    }
  };
}, cce = function() {
  var e = uce();
  return function(r, t) {
    I.useEffect(function() {
      return e.add(r), function() {
        e.remove();
      };
    }, [r && t]);
  };
}, Jk = function() {
  var e = cce(), r = function(t) {
    var n = t.styles, a = t.dynamic;
    return e(n, a), null;
  };
  return r;
}, dce = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, R1 = function(e) {
  return parseInt(e || "", 10) || 0;
}, fce = function(e) {
  var r = window.getComputedStyle(document.body), t = r[e === "padding" ? "paddingLeft" : "marginLeft"], n = r[e === "padding" ? "paddingTop" : "marginTop"], a = r[e === "padding" ? "paddingRight" : "marginRight"];
  return [R1(t), R1(n), R1(a)];
}, vce = function(e) {
  if (e === void 0 && (e = "margin"), typeof window == "undefined")
    return dce;
  var r = fce(e), t = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: r[0],
    top: r[1],
    right: r[2],
    gap: Math.max(0, n - t + r[2] - r[0])
  };
}, hce = Jk(), pce = function(e, r, t, n) {
  var a = e.left, i = e.top, l = e.right, u = e.gap;
  return t === void 0 && (t = "margin"), `
  .`.concat(nce, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(u, "px ").concat(n, `;
  }
  body {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    r && "position: relative ".concat(n, ";"),
    t === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(l, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(u, "px ").concat(n, `;
    `),
    t === "padding" && "padding-right: ".concat(u, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ap, ` {
    right: `).concat(u, "px ").concat(n, `;
  }
  
  .`).concat(Ip, ` {
    margin-right: `).concat(u, "px ").concat(n, `;
  }
  
  .`).concat(Ap, " .").concat(Ap, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Ip, " .").concat(Ip, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body {
    `).concat(ace, ": ").concat(u, `px;
  }
`);
}, gce = function(e) {
  var r = e.noRelative, t = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n, i = I.useMemo(function() {
    return vce(a);
  }, [a]);
  return I.createElement(hce, { styles: pce(i, !r, a, t ? "" : "!important") });
}, mce = function(e) {
  var r = window.getComputedStyle(e);
  return r.overflowY !== "hidden" && // not-not-scrollable
  !(r.overflowY === r.overflowX && r.overflowY === "visible");
}, bce = function(e) {
  var r = window.getComputedStyle(e);
  return r.overflowX !== "hidden" && // not-not-scrollable
  !(r.overflowY === r.overflowX && r.overflowX === "visible");
}, OE = function(e, r) {
  var t = r;
  do {
    var n = ej(e, t);
    if (n) {
      var a = rj(e, t), i = a[1], l = a[2];
      if (i > l)
        return !0;
    }
    t = t.parentNode;
  } while (t && t !== document.body);
  return !1;
}, yce = function(e) {
  var r = e.scrollTop, t = e.scrollHeight, n = e.clientHeight;
  return [r, t, n];
}, Sce = function(e) {
  var r = e.scrollLeft, t = e.scrollWidth, n = e.clientWidth;
  return [r, t, n];
}, ej = function(e, r) {
  return e === "v" ? mce(r) : bce(r);
}, rj = function(e, r) {
  return e === "v" ? yce(r) : Sce(r);
}, xce = function(e, r, t, n, a) {
  var i = n, l = t.target, u = r.contains(l), c = !1, f = i > 0, h = 0, p = 0;
  do {
    var g = rj(e, l), y = g[0], S = g[1], x = g[2], T = S - x - y;
    (y || T) && ej(e, l) && (h += T, p += y), l = l.parentNode;
  } while (
    // portaled content
    !u && l !== document.body || // self content
    u && (r.contains(l) || r === l)
  );
  return (f && (a && h === 0 || !a && i > h) || !f && (a && p === 0 || !a && -i > p)) && (c = !0), c;
}, $x = !1;
if (typeof window != "undefined")
  try {
    var bh = Object.defineProperty({}, "passive", {
      get: function() {
        return $x = !0, !0;
      }
    });
    window.addEventListener("test", bh, bh), window.removeEventListener("test", bh, bh);
  } catch (e) {
    $x = !1;
  }
var ku = $x ? { passive: !1 } : !1, yh = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ME = function(e) {
  return [e.deltaX, e.deltaY];
}, RE = function(e) {
  return e && "current" in e ? e.current : e;
}, $ce = function(e, r) {
  return e[0] === r[0] && e[1] === r[1];
}, wce = function(e) {
  return `
  .block-interactivity-` + e + ` {pointer-events: none;}
  .allow-interactivity-` + e + ` {pointer-events: all;}
`;
}, _ce = 0, ju = [];
function Tce(e) {
  var r = I.useRef([]), t = I.useRef([0, 0]), n = I.useRef(), a = I.useState(_ce++)[0], i = I.useState(function() {
    return Jk();
  })[0], l = I.useRef(e);
  I.useEffect(function() {
    l.current = e;
  }, [e]), I.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-" + a);
      var x = [
        e.lockRef.current
      ].concat((e.shards || []).map(RE)).filter(Boolean);
      return x.forEach(function(T) {
        return T.classList.add("allow-interactivity-" + a);
      }), function() {
        document.body.classList.remove("block-interactivity-" + a), x.forEach(function(T) {
          return T.classList.remove("allow-interactivity-" + a);
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var u = I.useCallback(function(x, T) {
    if ("touches" in x && x.touches.length === 2)
      return !l.current.allowPinchZoom;
    var A = yh(x), O = t.current, P = "deltaX" in x ? x.deltaX : O[0] - A[0], j = "deltaY" in x ? x.deltaY : O[1] - A[1], k, L = x.target, M = Math.abs(P) > Math.abs(j) ? "h" : "v", W = OE(M, L);
    if (!W)
      return !0;
    if (W ? k = M : (k = M === "v" ? "h" : "v", W = OE(M, L)), !W)
      return !1;
    if (!n.current && "changedTouches" in x && (P || j) && (n.current = k), !k)
      return !0;
    var q = n.current || k;
    return xce(q, T, x, q === "h" ? P : j, !0);
  }, []), c = I.useCallback(function(x) {
    var T = x;
    if (!(!ju.length || ju[ju.length - 1] !== i)) {
      var A = "deltaY" in T ? ME(T) : yh(T), O = r.current.filter(function(k) {
        return k.name === T.type && k.target === T.target && $ce(k.delta, A);
      })[0];
      if (O && O.should) {
        T.preventDefault();
        return;
      }
      if (!O) {
        var P = (l.current.shards || []).map(RE).filter(Boolean).filter(function(k) {
          return k.contains(T.target);
        }), j = P.length > 0 ? u(T, P[0]) : !l.current.noIsolation;
        j && T.preventDefault();
      }
    }
  }, []), f = I.useCallback(function(x, T, A, O) {
    var P = { name: x, delta: T, target: A, should: O };
    r.current.push(P), setTimeout(function() {
      r.current = r.current.filter(function(j) {
        return j !== P;
      });
    }, 1);
  }, []), h = I.useCallback(function(x) {
    t.current = yh(x), n.current = void 0;
  }, []), p = I.useCallback(function(x) {
    f(x.type, ME(x), x.target, u(x, e.lockRef.current));
  }, []), g = I.useCallback(function(x) {
    f(x.type, yh(x), x.target, u(x, e.lockRef.current));
  }, []);
  I.useEffect(function() {
    return ju.push(i), e.setCallbacks({
      onScrollCapture: p,
      onWheelCapture: p,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", c, ku), document.addEventListener("touchmove", c, ku), document.addEventListener("touchstart", h, ku), function() {
      ju = ju.filter(function(x) {
        return x !== i;
      }), document.removeEventListener("wheel", c, ku), document.removeEventListener("touchmove", c, ku), document.removeEventListener("touchstart", h, ku);
    };
  }, []);
  var y = e.removeScrollBar, S = e.inert;
  return I.createElement(
    I.Fragment,
    null,
    S ? I.createElement(i, { styles: wce(a) }) : null,
    y ? I.createElement(gce, { gapMode: "margin" }) : null
  );
}
var Cce = tue(Xk, Tce), Ece = I.forwardRef(function(e, r) {
  return I.createElement(Wg, Ds({}, e, { ref: r, sideCar: Cce }));
});
Ece.classNames = Wg.classNames;
function Bd() {
  return Bd = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Bd.apply(this, arguments);
}
Bd({}, IE, {
  custom: {
    offsetY: 16,
    reverse: !0
  }
}), Bd({}, IE, {
  custom: {
    offsetX: 16,
    reverse: !0
  }
}), Bd({}, Xue, {
  custom: {
    initialScale: 0.95,
    reverse: !0
  }
});
Sa(Bs.section);
uu({
  strict: !0,
  name: "ModalContext",
  errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
});
Sa(Bs.div);
uu();
Sa(rce);
var tj = {}, Ace = Ya, Ice = DP, Oce = Bi, Mce = qa, Rce = Hf, Pce = YP;
tj.f = Ace && !Ice ? Object.defineProperties : function(r, t) {
  Mce(r);
  for (var n = Rce(t), a = Pce(t), i = a.length, l = 0, u; i > l; )
    Oce.f(r, u = a[l++], n[u]);
  return r;
};
var kce = lu, nj = kce("document", "documentElement"), jce = qa, Dce = tj, PE = U$, Nce = F$, Lce = nj, Fce = Ag, zce = L$, kE = ">", jE = "<", wx = "prototype", _x = "script", aj = zce("IE_PROTO"), P1 = function() {
}, oj = function(e) {
  return jE + _x + kE + e + jE + "/" + _x + kE;
}, DE = function(e) {
  e.write(oj("")), e.close();
  var r = e.parentWindow.Object;
  return e = null, r;
}, Bce = function() {
  var e = Fce("iframe"), r = "java" + _x + ":", t;
  return e.style.display = "none", Lce.appendChild(e), e.src = String(r), t = e.contentWindow.document, t.open(), t.write(oj("document.F=Object")), t.close(), t.F;
}, Sh, Op = function() {
  try {
    Sh = new ActiveXObject("htmlfile");
  } catch (r) {
  }
  Op = typeof document != "undefined" ? document.domain && Sh ? DE(Sh) : Bce() : DE(Sh);
  for (var e = PE.length; e--; )
    delete Op[wx][PE[e]];
  return Op();
};
Nce[aj] = !0;
var ij = Object.create || function(r, t) {
  var n;
  return r !== null ? (P1[wx] = jce(r), n = new P1(), P1[wx] = null, n[aj] = r) : n = Op(), t === void 0 ? n : Dce.f(n, t);
}, Uce = Xn, Vce = ij, Wce = Bi.f, Tx = Uce("unscopables"), Cx = Array.prototype;
Cx[Tx] == null && Wce(Cx, Tx, {
  configurable: !0,
  value: Vce(null)
});
var sj = function(e) {
  Cx[Tx][e] = !0;
}, Kf = {}, Hce = jn, Gce = !Hce(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), Yce = Ka, Kce = Mt, qce = P$, Zce = L$, Qce = Gce, NE = Zce("IE_PROTO"), Ex = Object, Xce = Ex.prototype, lj = Qce ? Ex.getPrototypeOf : function(e) {
  var r = qce(e);
  if (Yce(r, NE))
    return r[NE];
  var t = r.constructor;
  return Kce(t) && r instanceof t ? t.prototype : r instanceof Ex ? Xce : null;
}, Jce = jn, ede = Mt, rde = Us, LE = lj, tde = Mc, nde = Xn, Ax = nde("iterator"), uj = !1, nu, k1, j1;
[].keys && (j1 = [].keys(), "next" in j1 ? (k1 = LE(LE(j1)), k1 !== Object.prototype && (nu = k1)) : uj = !0);
var ade = !rde(nu) || Jce(function() {
  var e = {};
  return nu[Ax].call(e) !== e;
});
ade && (nu = {});
ede(nu[Ax]) || tde(nu, Ax, function() {
  return this;
});
var cj = {
  IteratorPrototype: nu,
  BUGGY_SAFARI_ITERATORS: uj
}, ode = Bi.f, ide = Ka, sde = Xn, FE = sde("toStringTag"), gw = function(e, r, t) {
  e && !t && (e = e.prototype), e && !ide(e, FE) && ode(e, FE, { configurable: !0, value: r });
}, lde = cj.IteratorPrototype, ude = ij, cde = A$, dde = gw, fde = Kf, vde = function() {
  return this;
}, hde = function(e, r, t, n) {
  var a = r + " Iterator";
  return e.prototype = ude(lde, { next: cde(+!n, t) }), dde(e, a, !1), fde[a] = vde, e;
}, pde = Dn, gde = Vs, mde = function(e, r, t) {
  try {
    return pde(gde(Object.getOwnPropertyDescriptor(e, r)[t]));
  } catch (n) {
  }
}, bde = Mt, yde = String, Sde = TypeError, xde = function(e) {
  if (typeof e == "object" || bde(e))
    return e;
  throw Sde("Can't set " + yde(e) + " as a prototype");
}, $de = mde, wde = qa, _de = xde, dj = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var e = !1, r = {}, t;
  try {
    t = $de(Object.prototype, "__proto__", "set"), t(r, []), e = r instanceof Array;
  } catch (n) {
  }
  return function(a, i) {
    return wde(a), _de(i), e ? t(a, i) : a.__proto__ = i, a;
  };
}() : void 0), Tde = ii, Cde = wa, fj = D$, Ede = Mt, Ade = hde, zE = lj, BE = dj, Ide = gw, Ode = Ig, D1 = Mc, Mde = Xn, Rde = Kf, vj = cj, Pde = fj.PROPER, kde = fj.CONFIGURABLE, UE = vj.IteratorPrototype, xh = vj.BUGGY_SAFARI_ITERATORS, sd = Mde("iterator"), VE = "keys", ld = "values", WE = "entries", jde = function() {
  return this;
}, Dde = function(e, r, t, n, a, i, l) {
  Ade(t, r, n);
  var u = function(A) {
    if (A === a && g)
      return g;
    if (!xh && A in h)
      return h[A];
    switch (A) {
      case VE:
        return function() {
          return new t(this, A);
        };
      case ld:
        return function() {
          return new t(this, A);
        };
      case WE:
        return function() {
          return new t(this, A);
        };
    }
    return function() {
      return new t(this);
    };
  }, c = r + " Iterator", f = !1, h = e.prototype, p = h[sd] || h["@@iterator"] || a && h[a], g = !xh && p || u(a), y = r == "Array" && h.entries || p, S, x, T;
  if (y && (S = zE(y.call(new e())), S !== Object.prototype && S.next && (zE(S) !== UE && (BE ? BE(S, UE) : Ede(S[sd]) || D1(S, sd, jde)), Ide(S, c, !0))), Pde && a == ld && p && p.name !== ld && (kde ? Ode(h, "name", ld) : (f = !0, g = function() {
    return Cde(p, this);
  })), a)
    if (x = {
      values: u(ld),
      keys: i ? g : u(VE),
      entries: u(WE)
    }, l)
      for (T in x)
        (xh || f || !(T in h)) && D1(h, T, x[T]);
    else
      Tde({ target: r, proto: !0, forced: xh || f }, x);
  return h[sd] !== g && D1(h, sd, g, { name: a }), Rde[r] = g, x;
}, Nde = function(e, r) {
  return { value: e, done: r };
}, Lde = Hf, mw = sj, HE = Kf, hj = z$, Fde = Bi.f, zde = Dde, $h = Nde, Bde = Ya, pj = "Array Iterator", Ude = hj.set, Vde = hj.getterFor(pj), Wde = zde(Array, "Array", function(e, r) {
  Ude(this, {
    type: pj,
    target: Lde(e),
    // target
    index: 0,
    // next index
    kind: r
    // kind
  });
}, function() {
  var e = Vde(this), r = e.target, t = e.kind, n = e.index++;
  return !r || n >= r.length ? (e.target = void 0, $h(void 0, !0)) : t == "keys" ? $h(n, !1) : t == "values" ? $h(r[n], !1) : $h([n, r[n]], !1);
}, "values"), GE = HE.Arguments = HE.Array;
mw("keys");
mw("values");
mw("entries");
if (Bde && GE.name !== "values")
  try {
    Fde(GE, "name", { value: "values" });
  } catch (e) {
  }
var Hde = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, Gde = Ag, N1 = Gde("span").classList, YE = N1 && N1.constructor && N1.constructor.prototype, Yde = YE === Object.prototype ? void 0 : YE, KE = fn, gj = Hde, Kde = Yde, $d = Wde, L1 = Ig, mj = Xn, F1 = mj("iterator"), qE = mj("toStringTag"), z1 = $d.values, bj = function(e, r) {
  if (e) {
    if (e[F1] !== z1)
      try {
        L1(e, F1, z1);
      } catch (n) {
        e[F1] = z1;
      }
    if (e[qE] || L1(e, qE, r), gj[r]) {
      for (var t in $d)
        if (e[t] !== $d[t])
          try {
            L1(e, t, $d[t]);
          } catch (n) {
            e[t] = $d[t];
          }
    }
  }
};
for (var B1 in gj)
  bj(KE[B1] && KE[B1].prototype, B1);
bj(Kde, "DOMTokenList");
function mr() {
  return mr = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, mr.apply(this, arguments);
}
function Vl(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
function qde(e) {
  return {
    root: "slider-root-" + e,
    getThumb: function(t) {
      return "slider-thumb-" + e + "-" + t;
    },
    getInput: function(t) {
      return "slider-input-" + e + "-" + t;
    },
    track: "slider-track-" + e,
    innerTrack: "slider-filled-track-" + e,
    getMarker: function(t) {
      return "slider-marker-" + e + "-" + t;
    },
    output: "slider-output-" + e
  };
}
function wd(e) {
  var r = e.orientation, t = e.vertical, n = e.horizontal;
  return r === "vertical" ? t : n;
}
var ZE = {
  width: 0,
  height: 0
};
function yj(e) {
  var r = e.orientation, t = e.thumbPercents, n = e.thumbRects, a = e.isReversed, i = function(T) {
    return mr({
      position: "absolute",
      userSelect: "none",
      WebkitUserSelect: "none",
      MozUserSelect: "none",
      msUserSelect: "none",
      touchAction: "none"
    }, wd({
      orientation: r,
      vertical: {
        bottom: "calc(" + t[T] + "% - " + n[T].height / 2 + "px)"
      },
      horizontal: {
        left: "calc(" + t[T] + "% - " + n[T].width / 2 + "px)"
      }
    }));
  }, l = r === "vertical" ? n.reduce(function(x, T) {
    return x.height > T.height ? x : T;
  }, ZE) : n.reduce(function(x, T) {
    return x.width > T.width ? x : T;
  }, ZE), u = mr({
    position: "relative",
    touchAction: "none",
    WebkitTapHighlightColor: "rgba(0,0,0,0)",
    userSelect: "none",
    outline: 0
  }, wd({
    orientation: r,
    vertical: {
      paddingLeft: l.width / 2,
      paddingRight: l.width / 2
    },
    horizontal: {
      paddingTop: l.height / 2,
      paddingBottom: l.height / 2
    }
  })), c = mr({
    position: "absolute"
  }, wd({
    orientation: r,
    vertical: {
      left: "50%",
      transform: "translateX(-50%)",
      height: "100%"
    },
    horizontal: {
      top: "50%",
      transform: "translateY(-50%)",
      width: "100%"
    }
  })), f = t.length === 1, h = [0, a ? 100 - t[0] : t[0]], p = f ? h : t, g = p[0];
  !f && a && (g = 100 - g);
  var y = Math.abs(p[p.length - 1] - p[0]), S = mr({}, c, wd({
    orientation: r,
    vertical: a ? {
      height: y + "%",
      top: g + "%"
    } : {
      height: y + "%",
      bottom: g + "%"
    },
    horizontal: a ? {
      width: y + "%",
      right: g + "%"
    } : {
      width: y + "%",
      left: g + "%"
    }
  }));
  return {
    trackStyle: c,
    innerTrackStyle: S,
    rootStyle: u,
    getThumbStyle: i
  };
}
function Sj(e) {
  var r = e.isReversed, t = e.direction, n = e.orientation;
  return t === "ltr" || n === "vertical" ? r : !r;
}
var Zde = ["min", "max", "onChange", "value", "defaultValue", "isReversed", "direction", "orientation", "id", "isDisabled", "isReadOnly", "onChangeStart", "onChangeEnd", "step", "getAriaValueText", "aria-valuetext", "aria-label", "aria-labelledby", "name", "focusThumbOnChange", "minStepsBetweenThumbs"], Qde = ["index"], Xde = ["value"], Jde = ["index"];
function efe(e) {
  var r = e.min, t = r === void 0 ? 0 : r, n = e.max, a = n === void 0 ? 100 : n, i = e.onChange, l = e.value, u = e.defaultValue, c = e.isReversed, f = e.direction, h = f === void 0 ? "ltr" : f, p = e.orientation, g = p === void 0 ? "horizontal" : p, y = e.id, S = e.isDisabled, x = e.isReadOnly, T = e.onChangeStart, A = e.onChangeEnd, O = e.step, P = O === void 0 ? 1 : O, j = e.getAriaValueText, k = e["aria-valuetext"], L = e["aria-label"], M = e["aria-labelledby"], W = e.name, q = e.focusThumbOnChange, oe = q === void 0 ? !0 : q, Ae = e.minStepsBetweenThumbs, Te = Ae === void 0 ? 0 : Ae, $e = Vl(e, Zde), Ee = Ni(T), ze = Ni(A), Ke = Ni(j), Be = Sj({
    isReversed: c,
    direction: h,
    orientation: g
  }), ue = $k({
    value: l,
    defaultValue: u != null ? u : [25, 75],
    onChange: i
  }), he = ue[0], _e = ue[1];
  if (!Array.isArray(he))
    throw new TypeError("[range-slider] You passed an invalid value for `value` or `defaultValue`, expected `Array` but got `" + typeof he + "`");
  var Oe = x0(), Me = Oe[0], Z = Oe[1], se = x0(), te = se[0], fe = se[1], je = He(-1), ve = je[0], rr = je[1], br = Ze(null), ur = !(S || x), $r = Ze(he), Qe = he.map(function(Se) {
    return Nd(Se, t, a);
  }), yr = Tk(Qe), at = Te * P, Zr = rfe(Qe, t, a, at), Nr = Qe.map(function(Se) {
    return a - Se + t;
  }), jt = Be ? Nr : Qe, mt = jt.map(function(Se) {
    return g0(Se, t, a);
  }), gr = g === "vertical", Sr = He(Array.from({
    length: Qe.length
  }).map(function() {
    return {
      width: 0,
      height: 0
    };
  })), G = Sr[0], ne = Sr[1];
  er(function() {
    var Se;
    if (Q.current) {
      var Ce = Array.from((Se = Q.current) == null ? void 0 : Se.querySelectorAll("[role=slider]")), ye = Ce.map(function(Pe) {
        return {
          width: Pe.offsetWidth,
          height: Pe.offsetHeight
        };
      });
      ye.length && ne(ye);
    }
  }, []);
  var Y = Ze(null), Q = Ze(null), we = wk(y), be = qde(we), Re = Le(function(Se) {
    var Ce, ye;
    if (Y.current) {
      br.current = "pointer";
      var Pe = Y.current.getBoundingClientRect(), nr = (Ce = (ye = Se.touches) == null ? void 0 : ye[0]) != null ? Ce : Se, Hr = nr.clientX, Jt = nr.clientY, en = gr ? Pe.bottom - Jt : Hr - Pe.left, Rr = gr ? Pe.height : Pe.width, Qa = en / Rr;
      return Be && (Qa = 1 - Qa), ck(Qa, t, a);
    }
  }, [gr, Be, a, t]), cr = (a - t) / 10, wr = P || (a - t) / 100, lr = Rt(function() {
    return {
      setValueAtIndex: function(Ce, ye) {
        if (ur) {
          var Pe = Zr[Ce];
          ye = parseFloat(lx(ye, Pe.min, wr)), ye = Nd(ye, Pe.min, Pe.max);
          var nr = [].concat(Qe);
          nr[Ce] = ye, _e(nr);
        }
      },
      setActiveIndex: rr,
      stepUp: function(Ce, ye) {
        ye === void 0 && (ye = wr);
        var Pe = Qe[Ce], nr = Be ? Pe - ye : Pe + ye;
        lr.setValueAtIndex(Ce, nr);
      },
      stepDown: function(Ce, ye) {
        ye === void 0 && (ye = wr);
        var Pe = Qe[Ce], nr = Be ? Pe + ye : Pe - ye;
        lr.setValueAtIndex(Ce, nr);
      },
      reset: function() {
        return _e($r.current);
      }
    };
  }, [wr, Qe, Be, _e, ur, Zr]), dt = Le(function(Se) {
    var Ce = ik(Se), ye = {
      ArrowRight: function() {
        return lr.stepUp(ve);
      },
      ArrowUp: function() {
        return lr.stepUp(ve);
      },
      ArrowLeft: function() {
        return lr.stepDown(ve);
      },
      ArrowDown: function() {
        return lr.stepDown(ve);
      },
      PageUp: function() {
        return lr.stepUp(ve, cr);
      },
      PageDown: function() {
        return lr.stepDown(ve, cr);
      },
      Home: function() {
        var Hr = Zr[ve].min;
        lr.setValueAtIndex(ve, Hr);
      },
      End: function() {
        var Hr = Zr[ve].max;
        lr.setValueAtIndex(ve, Hr);
      }
    }, Pe = ye[Ce];
    Pe && (Se.preventDefault(), Se.stopPropagation(), Pe(Se), br.current = "keyboard");
  }, [lr, ve, cr, Zr]), ot = Rt(function() {
    return yj({
      isReversed: Be,
      orientation: g,
      thumbRects: G,
      thumbPercents: mt
    });
  }, [Be, g, mt, G]), bt = ot.getThumbStyle, Ct = ot.rootStyle, fr = ot.trackStyle, Qr = ot.innerTrackStyle, vn = Le(function(Se) {
    var Ce = Se != null ? Se : ve;
    if (Ce !== -1 && oe) {
      var ye, Pe = be.getThumb(Ce), nr = (ye = Q.current) == null ? void 0 : ye.ownerDocument.getElementById(Pe);
      nr && setTimeout(function() {
        return uk(nr);
      });
    }
  }, [oe, ve, be]);
  _k(function() {
    br.current === "keyboard" && (ze == null || ze(yr.current));
  }, [Qe, ze]);
  var hn = function(Ce) {
    var ye = Re(Ce) || 0, Pe = Qe.map(function(Rr) {
      return Math.abs(Rr - ye);
    }), nr = Math.min.apply(Math, Pe), Hr = Pe.indexOf(nr), Jt = Pe.filter(function(Rr) {
      return Rr === nr;
    }), en = Jt.length > 1;
    en && ye > Qe[Hr] && (Hr = Hr + Jt.length - 1), rr(Hr), lr.setValueAtIndex(Hr, ye), vn(Hr);
  }, Za = function(Ce) {
    if (ve != -1) {
      var ye = Re(Ce) || 0;
      rr(ve), lr.setValueAtIndex(ve, ye), vn(ve);
    }
  };
  Ck(Q, {
    onPanSessionStart: function(Ce) {
      ur && (Z.on(), hn(Ce), Ee == null || Ee(yr.current));
    },
    onPanSessionEnd: function() {
      ur && (Z.off(), ze == null || ze(yr.current));
    },
    onPan: function(Ce) {
      ur && Za(Ce);
    }
  });
  var Cn = Le(function(Se, Ce) {
    return Se === void 0 && (Se = {}), Ce === void 0 && (Ce = null), mr({}, Se, $e, {
      id: be.root,
      ref: Fd(Ce, Q),
      tabIndex: -1,
      "aria-disabled": uc(S),
      "data-focused": za(te),
      style: mr({}, Se.style, Ct)
    });
  }, [$e, S, te, Ct, be]), ge = Le(function(Se, Ce) {
    return Se === void 0 && (Se = {}), Ce === void 0 && (Ce = null), mr({}, Se, {
      ref: Fd(Ce, Y),
      id: be.track,
      "data-disabled": za(S),
      style: mr({}, Se.style, fr)
    });
  }, [S, fr, be]), De = Le(function(Se, Ce) {
    return Se === void 0 && (Se = {}), Ce === void 0 && (Ce = null), mr({}, Se, {
      ref: Ce,
      id: be.innerTrack,
      style: mr({}, Se.style, Qr)
    });
  }, [Qr, be]), tr = Le(function(Se, Ce) {
    var ye;
    Ce === void 0 && (Ce = null);
    var Pe = Se.index, nr = Vl(Se, Qde), Hr = Qe[Pe];
    if (Hr == null)
      throw new TypeError("[range-slider > thumb] Cannot find value at index `" + Pe + "`. The `value` or `defaultValue` length is : " + Qe.length);
    var Jt = Zr[Pe];
    return mr({}, nr, {
      ref: Ce,
      role: "slider",
      tabIndex: ur ? 0 : void 0,
      id: be.getThumb(Pe),
      "data-active": za(Me && ve === Pe),
      "aria-valuetext": (ye = Ke == null ? void 0 : Ke(Hr)) != null ? ye : k == null ? void 0 : k[Pe],
      "aria-valuemin": Jt.min,
      "aria-valuemax": Jt.max,
      "aria-valuenow": Hr,
      "aria-orientation": g,
      "aria-disabled": uc(S),
      "aria-readonly": uc(x),
      "aria-label": L == null ? void 0 : L[Pe],
      "aria-labelledby": L != null && L[Pe] || M == null ? void 0 : M[Pe],
      style: mr({}, Se.style, bt(Pe)),
      onKeyDown: cc(Se.onKeyDown, dt),
      onFocus: cc(Se.onFocus, function() {
        fe.on(), rr(Pe);
      }),
      onBlur: cc(Se.onBlur, function() {
        fe.off(), rr(-1);
      })
    });
  }, [be, Qe, Zr, ur, Me, ve, Ke, k, g, S, x, L, M, bt, dt, fe]), Dt = Le(function(Se, Ce) {
    return Se === void 0 && (Se = {}), Ce === void 0 && (Ce = null), mr({}, Se, {
      ref: Ce,
      id: be.output,
      htmlFor: Qe.map(function(ye, Pe) {
        return be.getThumb(Pe);
      }).join(" "),
      "aria-live": "off"
    });
  }, [be, Qe]), it = Le(function(Se, Ce) {
    Se === void 0 && (Se = {}), Ce === void 0 && (Ce = null);
    var ye = Se, Pe = ye.value, nr = Vl(ye, Xde), Hr = !(Pe < t || Pe > a), Jt = Pe >= Qe[0] && Pe <= Qe[Qe.length - 1], en = g0(Pe, t, a);
    en = Be ? 100 - en : en;
    var Rr = mr({
      position: "absolute",
      pointerEvents: "none"
    }, wd({
      orientation: g,
      vertical: {
        bottom: en + "%"
      },
      horizontal: {
        left: en + "%"
      }
    }));
    return mr({}, nr, {
      ref: Ce,
      id: be.getMarker(Se.value),
      role: "presentation",
      "aria-hidden": !0,
      "data-disabled": za(S),
      "data-invalid": za(!Hr),
      "data-highlighted": za(Jt),
      style: mr({}, Se.style, Rr)
    });
  }, [S, Be, a, t, g, Qe, be]), Fn = Le(function(Se, Ce) {
    Ce === void 0 && (Ce = null);
    var ye = Se.index, Pe = Vl(Se, Jde);
    return mr({}, Pe, {
      ref: Ce,
      id: be.getInput(ye),
      type: "hidden",
      value: Qe[ye],
      name: Array.isArray(W) ? W[ye] : W + "-" + ye
    });
  }, [W, Qe, be]);
  return {
    state: {
      value: Qe,
      isFocused: te,
      isDragging: Me,
      getThumbPercent: function(Ce) {
        return mt[Ce];
      },
      getThumbMinValue: function(Ce) {
        return Zr[Ce].min;
      },
      getThumbMaxValue: function(Ce) {
        return Zr[Ce].max;
      }
    },
    actions: lr,
    getRootProps: Cn,
    getTrackProps: ge,
    getInnerTrackProps: De,
    getThumbProps: tr,
    getMarkerProps: it,
    getInputProps: Fn,
    getOutputProps: Dt
  };
}
var rfe = function(r, t, n, a) {
  return r.map(function(i, l) {
    var u = l === 0 ? t : r[l - 1] + a, c = l === r.length - 1 ? n : r[l + 1] - a;
    return {
      min: u,
      max: c
    };
  });
}, tfe = ["getRootProps"], nfe = uu({
  name: "SliderContext",
  errorMessage: "useSliderContext: `context` is undefined. Seems you forgot to wrap all slider components within <RangeSlider />"
}), afe = nfe[0], ofe = /* @__PURE__ */ Pg(function(e, r) {
  var t = nw("Slider", e), n = rw(e), a = J$(), i = a.direction;
  n.direction = i;
  var l = efe(n), u = l.getRootProps, c = Vl(l, tfe), f = I.useMemo(function() {
    return mr({}, c, {
      name: e.name
    });
  }, [c, e.name]);
  return /* @__PURE__ */ I.createElement(afe, {
    value: f
  }, /* @__PURE__ */ I.createElement(ew, {
    value: t
  }, /* @__PURE__ */ I.createElement(Sa.div, mr({}, u({}, r), {
    className: "chakra-slider",
    __css: t.container
  }), e.children)));
});
ofe.defaultProps = {
  orientation: "horizontal"
};
var ife = ["min", "max", "onChange", "value", "defaultValue", "isReversed", "direction", "orientation", "id", "isDisabled", "isReadOnly", "onChangeStart", "onChangeEnd", "step", "getAriaValueText", "aria-valuetext", "aria-label", "aria-labelledby", "name", "focusThumbOnChange"];
function sfe(e) {
  var r, t = e.min, n = t === void 0 ? 0 : t, a = e.max, i = a === void 0 ? 100 : a, l = e.onChange, u = e.value, c = e.defaultValue, f = e.isReversed, h = e.direction, p = h === void 0 ? "ltr" : h, g = e.orientation, y = g === void 0 ? "horizontal" : g, S = e.id, x = e.isDisabled, T = e.isReadOnly, A = e.onChangeStart, O = e.onChangeEnd, P = e.step, j = P === void 0 ? 1 : P, k = e.getAriaValueText, L = e["aria-valuetext"], M = e["aria-label"], W = e["aria-labelledby"], q = e.name, oe = e.focusThumbOnChange, Ae = oe === void 0 ? !0 : oe, Te = Vl(e, ife), $e = Ni(A), Ee = Ni(O), ze = Ni(k), Ke = Sj({
    isReversed: f,
    direction: p,
    orientation: y
  }), Be = $k({
    value: u,
    defaultValue: c != null ? c : ufe(n, i),
    onChange: l
  }), ue = Be[0], he = Be[1], _e = x0(), Oe = _e[0], Me = _e[1], Z = x0(), se = Z[0], te = Z[1], fe = Ze(null), je = !(x || T), ve = Nd(ue, n, i), rr = Tk(ve), br = Ze(rr.current), ur = i - ve + n, $r = Ke ? ur : ve, Qe = g0($r, n, i), yr = y === "vertical", at = Ze(null), Zr = Ze(null), Nr = Ze(null), jt = Mle(S, "slider-thumb", "slider-track"), mt = jt[0], gr = jt[1], Sr = Le(function(ge) {
    var De, tr;
    if (at.current) {
      fe.current = "pointer";
      var Dt = KP(at.current).borderBox, it = (De = (tr = ge.touches) == null ? void 0 : tr[0]) != null ? De : ge, Fn = it.clientX, Se = it.clientY, Ce = yr ? Dt.bottom - Se : Fn - Dt.left, ye = yr ? Dt.height : Dt.width, Pe = Ce / ye;
      Ke && (Pe = 1 - Pe);
      var nr = ck(Pe, n, i);
      return j && (nr = parseFloat(lx(nr, n, j))), nr = Nd(nr, n, i), nr;
    }
  }, [yr, Ke, i, n, j]), G = (i - n) / 10, ne = j || (i - n) / 100, Y = Le(function(ge) {
    je && (ge = parseFloat(lx(ge, n, ne)), ge = Nd(ge, n, i), he(ge));
  }, [ne, i, n, he, je]), Q = Rt(function() {
    return {
      stepUp: function(De) {
        De === void 0 && (De = ne);
        var tr = Ke ? ve - De : ve + De;
        Y(tr);
      },
      stepDown: function(De) {
        De === void 0 && (De = ne);
        var tr = Ke ? ve + De : ve - De;
        Y(tr);
      },
      reset: function() {
        return Y(c || 0);
      },
      stepTo: function(De) {
        return Y(De);
      }
    };
  }, [Y, Ke, ve, ne, c]), we = Le(function(ge) {
    var De = ik(ge), tr = {
      ArrowRight: function() {
        return Q.stepUp();
      },
      ArrowUp: function() {
        return Q.stepUp();
      },
      ArrowLeft: function() {
        return Q.stepDown();
      },
      ArrowDown: function() {
        return Q.stepDown();
      },
      PageUp: function() {
        return Q.stepUp(G);
      },
      PageDown: function() {
        return Q.stepDown(G);
      },
      Home: function() {
        return Y(n);
      },
      End: function() {
        return Y(i);
      }
    }, Dt = tr[De];
    Dt && (ge.preventDefault(), ge.stopPropagation(), Dt(ge), fe.current = "keyboard");
  }, [Q, Y, i, n, G]), be = (r = ze == null ? void 0 : ze(ve)) != null ? r : L, Re = Ele(Zr), cr = Rt(function() {
    var ge, De = (ge = Re == null ? void 0 : Re.borderBox) != null ? ge : {
      width: 0,
      height: 0
    };
    return yj({
      isReversed: Ke,
      orientation: y,
      thumbRects: [De],
      thumbPercents: [Qe]
    });
  }, [Ke, y, Re == null ? void 0 : Re.borderBox, Qe]), wr = cr.getThumbStyle, lr = cr.rootStyle, dt = cr.trackStyle, ot = cr.innerTrackStyle, bt = Le(function() {
    Zr.current && Ae && setTimeout(function() {
      return uk(Zr.current);
    });
  }, [Ae]);
  _k(function() {
    bt(), fe.current === "keyboard" && (Ee == null || Ee(rr.current));
  }, [ve, Ee]);
  var Ct = function(De) {
    var tr = Sr(De);
    tr != null && tr !== rr.current && he(tr);
  };
  Ck(Nr, {
    onPanSessionStart: function(De) {
      je && (Me.on(), bt(), Ct(De), $e == null || $e(rr.current));
    },
    onPanSessionEnd: function() {
      je && (Me.off(), Ee == null || Ee(rr.current), br.current = rr.current);
    },
    onPan: function(De) {
      je && Ct(De);
    }
  });
  var fr = Le(function(ge, De) {
    return ge === void 0 && (ge = {}), De === void 0 && (De = null), mr({}, ge, Te, {
      ref: Fd(De, Nr),
      tabIndex: -1,
      "aria-disabled": uc(x),
      "data-focused": za(se),
      style: mr({}, ge.style, lr)
    });
  }, [Te, x, se, lr]), Qr = Le(function(ge, De) {
    return ge === void 0 && (ge = {}), De === void 0 && (De = null), mr({}, ge, {
      ref: Fd(De, at),
      id: gr,
      "data-disabled": za(x),
      style: mr({}, ge.style, dt)
    });
  }, [x, gr, dt]), vn = Le(function(ge, De) {
    return ge === void 0 && (ge = {}), De === void 0 && (De = null), mr({}, ge, {
      ref: De,
      style: mr({}, ge.style, ot)
    });
  }, [ot]), hn = Le(function(ge, De) {
    return ge === void 0 && (ge = {}), De === void 0 && (De = null), mr({}, ge, {
      ref: Fd(De, Zr),
      role: "slider",
      tabIndex: je ? 0 : void 0,
      id: mt,
      "data-active": za(Oe),
      "aria-valuetext": be,
      "aria-valuemin": n,
      "aria-valuemax": i,
      "aria-valuenow": ve,
      "aria-orientation": y,
      "aria-disabled": uc(x),
      "aria-readonly": uc(T),
      "aria-label": M,
      "aria-labelledby": M ? void 0 : W,
      style: mr({}, ge.style, wr(0)),
      onKeyDown: cc(ge.onKeyDown, we),
      onFocus: cc(ge.onFocus, te.on),
      onBlur: cc(ge.onBlur, te.off)
    });
  }, [je, mt, Oe, be, n, i, ve, y, x, T, M, W, wr, we, te.on, te.off]), Za = Le(function(ge, De) {
    ge === void 0 && (ge = {}), De === void 0 && (De = null);
    var tr = !(ge.value < n || ge.value > i), Dt = ve >= ge.value, it = g0(ge.value, n, i), Fn = mr({
      position: "absolute",
      pointerEvents: "none"
    }, lfe({
      orientation: y,
      vertical: {
        bottom: Ke ? 100 - it + "%" : it + "%"
      },
      horizontal: {
        left: Ke ? 100 - it + "%" : it + "%"
      }
    }));
    return mr({}, ge, {
      ref: De,
      role: "presentation",
      "aria-hidden": !0,
      "data-disabled": za(x),
      "data-invalid": za(!tr),
      "data-highlighted": za(Dt),
      style: mr({}, ge.style, Fn)
    });
  }, [x, Ke, i, n, y, ve]), Cn = Le(function(ge, De) {
    return ge === void 0 && (ge = {}), De === void 0 && (De = null), mr({}, ge, {
      ref: De,
      type: "hidden",
      value: ve,
      name: q
    });
  }, [q, ve]);
  return {
    state: {
      value: ve,
      isFocused: se,
      isDragging: Oe
    },
    actions: Q,
    getRootProps: fr,
    getTrackProps: Qr,
    getInnerTrackProps: vn,
    getThumbProps: hn,
    getMarkerProps: Za,
    getInputProps: Cn
  };
}
function lfe(e) {
  var r = e.orientation, t = e.vertical, n = e.horizontal;
  return r === "vertical" ? t : n;
}
function ufe(e, r) {
  return r < e ? e : e + (r - e) / 2;
}
var cfe = ["getInputProps", "getRootProps"], dfe = uu({
  name: "SliderContext",
  errorMessage: "useSliderContext: `context` is undefined. Seems you forgot to wrap all slider components within <Slider />"
}), ffe = dfe[0], vfe = /* @__PURE__ */ Pg(function(e, r) {
  var t = nw("Slider", e), n = rw(e), a = J$(), i = a.direction;
  n.direction = i;
  var l = sfe(n), u = l.getInputProps, c = l.getRootProps, f = Vl(l, cfe), h = c(), p = u({}, r);
  return /* @__PURE__ */ I.createElement(ffe, {
    value: f
  }, /* @__PURE__ */ I.createElement(ew, {
    value: t
  }, /* @__PURE__ */ I.createElement(Sa.div, mr({}, h, {
    className: Z$("chakra-slider", e.className),
    __css: t.container
  }), e.children, /* @__PURE__ */ I.createElement("input", p))));
});
vfe.defaultProps = {
  orientation: "horizontal"
};
var hfe = Xn, pfe = hfe("toStringTag"), xj = {};
xj[pfe] = "z";
var gfe = String(xj) === "[object z]", mfe = gfe, bfe = Mt, Mp = _g, yfe = Xn, Sfe = yfe("toStringTag"), xfe = Object, $fe = Mp(function() {
  return arguments;
}()) == "Arguments", wfe = function(e, r) {
  try {
    return e[r];
  } catch (t) {
  }
}, bw = mfe ? Mp : function(e) {
  var r, t, n;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (t = wfe(r = xfe(e), Sfe)) == "string" ? t : $fe ? Mp(r) : (n = Mp(r)) == "Object" && bfe(r.callee) ? "Arguments" : n;
}, _fe = bw, Tfe = String, $j = function(e) {
  if (_fe(e) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return Tfe(e);
}, QE = k$.exports, Cfe = Bi, wj = function(e, r, t) {
  return t.get && QE(t.get, r, { getter: !0 }), t.set && QE(t.set, r, { setter: !0 }), Cfe.f(e, r, t);
}, Efe = ii, Afe = Ya, Ife = fn, wh = Dn, Ofe = Ka, Mfe = Mt, Rfe = Gf, Pfe = $j, kfe = wj, jfe = HP, Ri = Ife.Symbol, Tl = Ri && Ri.prototype;
if (Afe && Mfe(Ri) && (!("description" in Tl) || // Safari 12 bug
Ri().description !== void 0)) {
  var XE = {}, _h = function() {
    var r = arguments.length < 1 || arguments[0] === void 0 ? void 0 : Pfe(arguments[0]), t = Rfe(Tl, this) ? new Ri(r) : r === void 0 ? Ri() : Ri(r);
    return r === "" && (XE[t] = !0), t;
  };
  jfe(_h, Ri), _h.prototype = Tl, Tl.constructor = _h;
  var Dfe = String(Ri("test")) == "Symbol(test)", Nfe = wh(Tl.valueOf), Lfe = wh(Tl.toString), Ffe = /^Symbol\((.*)\)[^)]+$/, zfe = wh("".replace), Bfe = wh("".slice);
  kfe(Tl, "description", {
    configurable: !0,
    get: function() {
      var r = Nfe(this);
      if (Ofe(XE, r))
        return "";
      var t = Lfe(r), n = Dfe ? Bfe(t, 7, -1) : zfe(t, Ffe, "$1");
      return n === "" ? void 0 : n;
    }
  }), Efe({ global: !0, constructor: !0, forced: !0 }, {
    Symbol: _h
  });
}
const Ufe = /* @__PURE__ */ I.createContext({
  activeStep: 0
}), Vfe = ({
  value: e,
  children: r
}) => {
  const [t, n] = I.useState([]), a = e.state === "error", i = e.state === "loading", l = e.orientation === "vertical", u = e.orientation !== "vertical" && e.labelOrientation === "vertical";
  return QS(Ufe.Provider, Object.assign({
    value: Object.assign(Object.assign({}, e), {
      widths: t,
      setWidths: n,
      isError: a,
      isLoading: i,
      isVertical: l,
      isLabelVertical: u
    })
  }, {
    children: r
  }));
};
function cn(e, r) {
  Wfe(e) && (e = "100%");
  var t = Hfe(e);
  return e = r === 360 ? e : Math.min(r, Math.max(0, parseFloat(e))), t && (e = parseInt(String(e * r), 10) / 100), Math.abs(e - r) < 1e-6 ? 1 : (r === 360 ? e = (e < 0 ? e % r + r : e % r) / parseFloat(String(r)) : e = e % r / parseFloat(String(r)), e);
}
function Th(e) {
  return Math.min(1, Math.max(0, e));
}
function Wfe(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function Hfe(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function _j(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Ch(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function Wl(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function Gfe(e, r, t) {
  return {
    r: cn(e, 255) * 255,
    g: cn(r, 255) * 255,
    b: cn(t, 255) * 255
  };
}
function JE(e, r, t) {
  e = cn(e, 255), r = cn(r, 255), t = cn(t, 255);
  var n = Math.max(e, r, t), a = Math.min(e, r, t), i = 0, l = 0, u = (n + a) / 2;
  if (n === a)
    l = 0, i = 0;
  else {
    var c = n - a;
    switch (l = u > 0.5 ? c / (2 - n - a) : c / (n + a), n) {
      case e:
        i = (r - t) / c + (r < t ? 6 : 0);
        break;
      case r:
        i = (t - e) / c + 2;
        break;
      case t:
        i = (e - r) / c + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: l, l: u };
}
function U1(e, r, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? e + (r - e) * (6 * t) : t < 1 / 2 ? r : t < 2 / 3 ? e + (r - e) * (2 / 3 - t) * 6 : e;
}
function Yfe(e, r, t) {
  var n, a, i;
  if (e = cn(e, 360), r = cn(r, 100), t = cn(t, 100), r === 0)
    a = t, i = t, n = t;
  else {
    var l = t < 0.5 ? t * (1 + r) : t + r - t * r, u = 2 * t - l;
    n = U1(u, l, e + 1 / 3), a = U1(u, l, e), i = U1(u, l, e - 1 / 3);
  }
  return { r: n * 255, g: a * 255, b: i * 255 };
}
function eA(e, r, t) {
  e = cn(e, 255), r = cn(r, 255), t = cn(t, 255);
  var n = Math.max(e, r, t), a = Math.min(e, r, t), i = 0, l = n, u = n - a, c = n === 0 ? 0 : u / n;
  if (n === a)
    i = 0;
  else {
    switch (n) {
      case e:
        i = (r - t) / u + (r < t ? 6 : 0);
        break;
      case r:
        i = (t - e) / u + 2;
        break;
      case t:
        i = (e - r) / u + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: c, v: l };
}
function Kfe(e, r, t) {
  e = cn(e, 360) * 6, r = cn(r, 100), t = cn(t, 100);
  var n = Math.floor(e), a = e - n, i = t * (1 - r), l = t * (1 - a * r), u = t * (1 - (1 - a) * r), c = n % 6, f = [t, l, i, i, u, t][c], h = [u, t, t, l, i, i][c], p = [i, i, u, t, t, l][c];
  return { r: f * 255, g: h * 255, b: p * 255 };
}
function rA(e, r, t, n) {
  var a = [
    Wl(Math.round(e).toString(16)),
    Wl(Math.round(r).toString(16)),
    Wl(Math.round(t).toString(16))
  ];
  return n && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
}
function qfe(e, r, t, n, a) {
  var i = [
    Wl(Math.round(e).toString(16)),
    Wl(Math.round(r).toString(16)),
    Wl(Math.round(t).toString(16)),
    Wl(Zfe(n))
  ];
  return a && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) && i[3].startsWith(i[3].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function Zfe(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function tA(e) {
  return va(e) / 255;
}
function va(e) {
  return parseInt(e, 16);
}
function Qfe(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var Ix = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Xfe(e) {
  var r = { r: 0, g: 0, b: 0 }, t = 1, n = null, a = null, i = null, l = !1, u = !1;
  return typeof e == "string" && (e = rve(e)), typeof e == "object" && (Ai(e.r) && Ai(e.g) && Ai(e.b) ? (r = Gfe(e.r, e.g, e.b), l = !0, u = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Ai(e.h) && Ai(e.s) && Ai(e.v) ? (n = Ch(e.s), a = Ch(e.v), r = Kfe(e.h, n, a), l = !0, u = "hsv") : Ai(e.h) && Ai(e.s) && Ai(e.l) && (n = Ch(e.s), i = Ch(e.l), r = Yfe(e.h, n, i), l = !0, u = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (t = e.a)), t = _j(t), {
    ok: l,
    format: e.format || u,
    r: Math.min(255, Math.max(r.r, 0)),
    g: Math.min(255, Math.max(r.g, 0)),
    b: Math.min(255, Math.max(r.b, 0)),
    a: t
  };
}
var Jfe = "[-\\+]?\\d+%?", eve = "[-\\+]?\\d*\\.\\d+%?", Ms = "(?:".concat(eve, ")|(?:").concat(Jfe, ")"), V1 = "[\\s|\\(]+(".concat(Ms, ")[,|\\s]+(").concat(Ms, ")[,|\\s]+(").concat(Ms, ")\\s*\\)?"), W1 = "[\\s|\\(]+(".concat(Ms, ")[,|\\s]+(").concat(Ms, ")[,|\\s]+(").concat(Ms, ")[,|\\s]+(").concat(Ms, ")\\s*\\)?"), ho = {
  CSS_UNIT: new RegExp(Ms),
  rgb: new RegExp("rgb" + V1),
  rgba: new RegExp("rgba" + W1),
  hsl: new RegExp("hsl" + V1),
  hsla: new RegExp("hsla" + W1),
  hsv: new RegExp("hsv" + V1),
  hsva: new RegExp("hsva" + W1),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function rve(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var r = !1;
  if (Ix[e])
    e = Ix[e], r = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var t = ho.rgb.exec(e);
  return t ? { r: t[1], g: t[2], b: t[3] } : (t = ho.rgba.exec(e), t ? { r: t[1], g: t[2], b: t[3], a: t[4] } : (t = ho.hsl.exec(e), t ? { h: t[1], s: t[2], l: t[3] } : (t = ho.hsla.exec(e), t ? { h: t[1], s: t[2], l: t[3], a: t[4] } : (t = ho.hsv.exec(e), t ? { h: t[1], s: t[2], v: t[3] } : (t = ho.hsva.exec(e), t ? { h: t[1], s: t[2], v: t[3], a: t[4] } : (t = ho.hex8.exec(e), t ? {
    r: va(t[1]),
    g: va(t[2]),
    b: va(t[3]),
    a: tA(t[4]),
    format: r ? "name" : "hex8"
  } : (t = ho.hex6.exec(e), t ? {
    r: va(t[1]),
    g: va(t[2]),
    b: va(t[3]),
    format: r ? "name" : "hex"
  } : (t = ho.hex4.exec(e), t ? {
    r: va(t[1] + t[1]),
    g: va(t[2] + t[2]),
    b: va(t[3] + t[3]),
    a: tA(t[4] + t[4]),
    format: r ? "name" : "hex8"
  } : (t = ho.hex3.exec(e), t ? {
    r: va(t[1] + t[1]),
    g: va(t[2] + t[2]),
    b: va(t[3] + t[3]),
    format: r ? "name" : "hex"
  } : !1)))))))));
}
function Ai(e) {
  return !!ho.CSS_UNIT.exec(String(e));
}
var Hg = (
  /** @class */
  function() {
    function e(r, t) {
      r === void 0 && (r = ""), t === void 0 && (t = {});
      var n;
      if (r instanceof e)
        return r;
      typeof r == "number" && (r = Qfe(r)), this.originalInput = r;
      var a = Xfe(r);
      this.originalInput = r, this.r = a.r, this.g = a.g, this.b = a.b, this.a = a.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (n = t.format) !== null && n !== void 0 ? n : a.format, this.gradientType = t.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = a.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var r = this.toRgb();
      return (r.r * 299 + r.g * 587 + r.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var r = this.toRgb(), t, n, a, i = r.r / 255, l = r.g / 255, u = r.b / 255;
      return i <= 0.03928 ? t = i / 12.92 : t = Math.pow((i + 0.055) / 1.055, 2.4), l <= 0.03928 ? n = l / 12.92 : n = Math.pow((l + 0.055) / 1.055, 2.4), u <= 0.03928 ? a = u / 12.92 : a = Math.pow((u + 0.055) / 1.055, 2.4), 0.2126 * t + 0.7152 * n + 0.0722 * a;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(r) {
      return this.a = _j(r), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var r = this.toHsl().s;
      return r === 0;
    }, e.prototype.toHsv = function() {
      var r = eA(this.r, this.g, this.b);
      return { h: r.h * 360, s: r.s, v: r.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var r = eA(this.r, this.g, this.b), t = Math.round(r.h * 360), n = Math.round(r.s * 100), a = Math.round(r.v * 100);
      return this.a === 1 ? "hsv(".concat(t, ", ").concat(n, "%, ").concat(a, "%)") : "hsva(".concat(t, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var r = JE(this.r, this.g, this.b);
      return { h: r.h * 360, s: r.s, l: r.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var r = JE(this.r, this.g, this.b), t = Math.round(r.h * 360), n = Math.round(r.s * 100), a = Math.round(r.l * 100);
      return this.a === 1 ? "hsl(".concat(t, ", ").concat(n, "%, ").concat(a, "%)") : "hsla(".concat(t, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(r) {
      return r === void 0 && (r = !1), rA(this.r, this.g, this.b, r);
    }, e.prototype.toHexString = function(r) {
      return r === void 0 && (r = !1), "#" + this.toHex(r);
    }, e.prototype.toHex8 = function(r) {
      return r === void 0 && (r = !1), qfe(this.r, this.g, this.b, this.a, r);
    }, e.prototype.toHex8String = function(r) {
      return r === void 0 && (r = !1), "#" + this.toHex8(r);
    }, e.prototype.toHexShortString = function(r) {
      return r === void 0 && (r = !1), this.a === 1 ? this.toHexString(r) : this.toHex8String(r);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var r = Math.round(this.r), t = Math.round(this.g), n = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(r, ", ").concat(t, ", ").concat(n, ")") : "rgba(".concat(r, ", ").concat(t, ", ").concat(n, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var r = function(t) {
        return "".concat(Math.round(cn(t, 255) * 100), "%");
      };
      return {
        r: r(this.r),
        g: r(this.g),
        b: r(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var r = function(t) {
        return Math.round(cn(t, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(r(this.r), "%, ").concat(r(this.g), "%, ").concat(r(this.b), "%)") : "rgba(".concat(r(this.r), "%, ").concat(r(this.g), "%, ").concat(r(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var r = "#" + rA(this.r, this.g, this.b, !1), t = 0, n = Object.entries(Ix); t < n.length; t++) {
        var a = n[t], i = a[0], l = a[1];
        if (r === l)
          return i;
      }
      return !1;
    }, e.prototype.toString = function(r) {
      var t = !!r;
      r = r != null ? r : this.format;
      var n = !1, a = this.a < 1 && this.a >= 0, i = !t && a && (r.startsWith("hex") || r === "name");
      return i ? r === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (r === "rgb" && (n = this.toRgbString()), r === "prgb" && (n = this.toPercentageRgbString()), (r === "hex" || r === "hex6") && (n = this.toHexString()), r === "hex3" && (n = this.toHexString(!0)), r === "hex4" && (n = this.toHex8String(!0)), r === "hex8" && (n = this.toHex8String()), r === "name" && (n = this.toName()), r === "hsl" && (n = this.toHslString()), r === "hsv" && (n = this.toHsvString()), n || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.l += r / 100, t.l = Th(t.l), new e(t);
    }, e.prototype.brighten = function(r) {
      r === void 0 && (r = 10);
      var t = this.toRgb();
      return t.r = Math.max(0, Math.min(255, t.r - Math.round(255 * -(r / 100)))), t.g = Math.max(0, Math.min(255, t.g - Math.round(255 * -(r / 100)))), t.b = Math.max(0, Math.min(255, t.b - Math.round(255 * -(r / 100)))), new e(t);
    }, e.prototype.darken = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.l -= r / 100, t.l = Th(t.l), new e(t);
    }, e.prototype.tint = function(r) {
      return r === void 0 && (r = 10), this.mix("white", r);
    }, e.prototype.shade = function(r) {
      return r === void 0 && (r = 10), this.mix("black", r);
    }, e.prototype.desaturate = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.s -= r / 100, t.s = Th(t.s), new e(t);
    }, e.prototype.saturate = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.s += r / 100, t.s = Th(t.s), new e(t);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(r) {
      var t = this.toHsl(), n = (t.h + r) % 360;
      return t.h = n < 0 ? 360 + n : n, new e(t);
    }, e.prototype.mix = function(r, t) {
      t === void 0 && (t = 50);
      var n = this.toRgb(), a = new e(r).toRgb(), i = t / 100, l = {
        r: (a.r - n.r) * i + n.r,
        g: (a.g - n.g) * i + n.g,
        b: (a.b - n.b) * i + n.b,
        a: (a.a - n.a) * i + n.a
      };
      return new e(l);
    }, e.prototype.analogous = function(r, t) {
      r === void 0 && (r = 6), t === void 0 && (t = 30);
      var n = this.toHsl(), a = 360 / t, i = [this];
      for (n.h = (n.h - (a * r >> 1) + 720) % 360; --r; )
        n.h = (n.h + a) % 360, i.push(new e(n));
      return i;
    }, e.prototype.complement = function() {
      var r = this.toHsl();
      return r.h = (r.h + 180) % 360, new e(r);
    }, e.prototype.monochromatic = function(r) {
      r === void 0 && (r = 6);
      for (var t = this.toHsv(), n = t.h, a = t.s, i = t.v, l = [], u = 1 / r; r--; )
        l.push(new e({ h: n, s: a, v: i })), i = (i + u) % 1;
      return l;
    }, e.prototype.splitcomplement = function() {
      var r = this.toHsl(), t = r.h;
      return [
        this,
        new e({ h: (t + 72) % 360, s: r.s, l: r.l }),
        new e({ h: (t + 216) % 360, s: r.s, l: r.l })
      ];
    }, e.prototype.onBackground = function(r) {
      var t = this.toRgb(), n = new e(r).toRgb(), a = t.a + n.a * (1 - t.a);
      return new e({
        r: (t.r * t.a + n.r * n.a * (1 - t.a)) / a,
        g: (t.g * t.a + n.g * n.a * (1 - t.a)) / a,
        b: (t.b * t.a + n.b * n.a * (1 - t.a)) / a,
        a
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(r) {
      for (var t = this.toHsl(), n = t.h, a = [this], i = 360 / r, l = 1; l < r; l++)
        a.push(new e({ h: (n + l * i) % 360, s: t.s, l: t.l }));
      return a;
    }, e.prototype.equals = function(r) {
      return this.toRgbString() === new e(r).toRgbString();
    }, e;
  }()
), Dr = function(r, t, n) {
  var a = K$(r, "colors." + t, t), i = new Hg(a), l = i.isValid;
  return l ? a : n;
}, yc = function(r, t) {
  return function(n) {
    var a = Dr(n, r);
    return new Hg(a).setAlpha(t).toRgbString();
  };
}, tve = function(r, t) {
  return function(n) {
    var a = Dr(n, r);
    return new Hg(a).darken(t).toHexString();
  };
}, nve = function(r, t) {
  return function(n) {
    return new Hg(Dr(n, r)).lighten(t).toHexString();
  };
};
function Fe(e, r) {
  return function(t) {
    return t.colorMode === "dark" ? r : e;
  };
}
function nA(e, r) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function ave(e, r, t) {
  return r && nA(e.prototype, r), t && nA(e, t), e;
}
var ove = /* @__PURE__ */ function() {
  function e(r) {
    var t = this;
    this.map = {}, this.called = !1, this.assert = function() {
      if (!t.called) {
        t.called = !0;
        return;
      }
      throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
    }, this.parts = function() {
      t.assert();
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      for (var l = 0, u = a; l < u.length; l++) {
        var c = u[l];
        t.map[c] = t.toPart(c);
      }
      return t;
    }, this.extend = function() {
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      for (var l = 0, u = a; l < u.length; l++) {
        var c = u[l];
        c in t.map || (t.map[c] = t.toPart(c));
      }
      return t;
    }, this.toPart = function(n) {
      var a = ["container", "root"].includes(n != null ? n : "") ? [t.name] : [t.name, n], i = a.filter(Boolean).join("__"), l = "chakra-" + i, u = {
        className: l,
        selector: "." + l,
        toString: function() {
          return n;
        }
      };
      return u;
    }, this.__type = {};
  }
  return ave(e, [{
    key: "selectors",
    get: (
      /**
       * Get all selectors for the component anatomy
       */
      function() {
        var t = vE(Object.entries(this.map).map(function(n) {
          var a = n[0], i = n[1];
          return [a, i.selector];
        }));
        return t;
      }
    )
    /**
     * Get all classNames for the component anatomy
     */
  }, {
    key: "classNames",
    get: function() {
      var t = vE(Object.entries(this.map).map(function(n) {
        var a = n[0], i = n[1];
        return [a, i.className];
      }));
      return t;
    }
    /**
     * Get all parts as array of string
     */
  }, {
    key: "keys",
    get: function() {
      return Object.keys(this.map);
    }
    /**
     * Creates the part object for the given part
     */
  }]), e;
}();
function Kr(e) {
  return new ove(e);
}
function Tj(e) {
  return ql(e) && e.reference ? e.reference : String(e);
}
var Gg = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(Tj).join(" " + r + " ").replace(/calc/g, "");
}, aA = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Gg.apply(void 0, ["+"].concat(t)) + ")";
}, oA = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Gg.apply(void 0, ["-"].concat(t)) + ")";
}, Ox = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Gg.apply(void 0, ["*"].concat(t)) + ")";
}, iA = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Gg.apply(void 0, ["/"].concat(t)) + ")";
}, sA = function(r) {
  var t = Tj(r);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : "-" + t : Ox(t, -1);
}, Pl = Object.assign(function(e) {
  return {
    add: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Pl(aA.apply(void 0, [e].concat(n)));
    },
    subtract: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Pl(oA.apply(void 0, [e].concat(n)));
    },
    multiply: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Pl(Ox.apply(void 0, [e].concat(n)));
    },
    divide: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Pl(iA.apply(void 0, [e].concat(n)));
    },
    negate: function() {
      return Pl(sA(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: aA,
  subtract: oA,
  multiply: Ox,
  divide: iA,
  negate: sA
});
function ive(e) {
  return !Number.isInteger(parseFloat(e.toString()));
}
function sve(e, r) {
  return r === void 0 && (r = "-"), e.replace(/\s+/g, r);
}
function Cj(e) {
  var r = sve(e.toString());
  return r.includes("\\.") ? e : ive(e) ? r.replace(".", "\\.") : e;
}
function lve(e, r) {
  return r === void 0 && (r = ""), [r, Cj(e)].filter(Boolean).join("-");
}
function uve(e, r) {
  return "var(" + Cj(e) + (r ? ", " + r : "") + ")";
}
function cve(e, r) {
  return r === void 0 && (r = ""), "--" + lve(e, r);
}
function si(e, r) {
  var t = cve(e, r == null ? void 0 : r.prefix);
  return {
    variable: t,
    reference: uve(t, dve(r == null ? void 0 : r.fallback))
  };
}
function dve(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.reference;
}
Bs(lP);
Bs(ene);
Bs(Sa.span);
var fve = _g, Yg = typeof process != "undefined" && fve(process) == "process", vve = lu, hve = wj, pve = Xn, gve = Ya, lA = pve("species"), mve = function(e) {
  var r = vve(e);
  gve && r && !r[lA] && hve(r, lA, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, bve = Gf, yve = TypeError, Sve = function(e, r) {
  if (bve(r, e))
    return e;
  throw yve("Incorrect invocation");
}, xve = Dn, $ve = jn, Ej = Mt, wve = bw, _ve = lu, Tve = N$, Aj = function() {
}, Cve = [], Ij = _ve("Reflect", "construct"), yw = /^\s*(?:class|function)\b/, Eve = xve(yw.exec), Ave = !yw.exec(Aj), ud = function(r) {
  if (!Ej(r))
    return !1;
  try {
    return Ij(Aj, Cve, r), !0;
  } catch (t) {
    return !1;
  }
}, Oj = function(r) {
  if (!Ej(r))
    return !1;
  switch (wve(r)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return Ave || !!Eve(yw, Tve(r));
  } catch (t) {
    return !0;
  }
};
Oj.sham = !0;
var Ive = !Ij || $ve(function() {
  var e;
  return ud(ud.call) || !ud(Object) || !ud(function() {
    e = !0;
  }) || e;
}) ? Oj : ud, Ove = Ive, Mve = Eg, Rve = TypeError, Pve = function(e) {
  if (Ove(e))
    return e;
  throw Rve(Mve(e) + " is not a constructor");
}, uA = qa, kve = Pve, jve = Tg, Dve = Xn, Nve = Dve("species"), Lve = function(e, r) {
  var t = uA(e).constructor, n;
  return t === void 0 || jve(n = uA(t)[Nve]) ? r : kve(n);
}, Fve = wg, Mj = Function.prototype, cA = Mj.apply, dA = Mj.call, zve = typeof Reflect == "object" && Reflect.apply || (Fve ? dA.bind(cA) : function() {
  return dA.apply(cA, arguments);
}), Bve = _g, Uve = Dn, Vve = function(e) {
  if (Bve(e) === "Function")
    return Uve(e);
}, fA = Vve, Wve = Vs, Hve = wg, Gve = fA(fA.bind), Sw = function(e, r) {
  return Wve(e), r === void 0 ? e : Hve ? Gve(e, r) : function() {
    return e.apply(r, arguments);
  };
}, Yve = Dn, Kve = Yve([].slice), qve = TypeError, Zve = function(e, r) {
  if (e < r)
    throw qve("Not enough arguments");
  return e;
}, Qve = Cg, Rj = /(?:ipad|iphone|ipod).*applewebkit/i.test(Qve), ga = fn, Xve = zve, Jve = Sw, vA = Mt, ehe = Ka, Pj = jn, hA = nj, rhe = Kve, pA = Ag, the = Zve, nhe = Rj, ahe = Yg, Mx = ga.setImmediate, Rx = ga.clearImmediate, ohe = ga.process, H1 = ga.Dispatch, ihe = ga.Function, gA = ga.MessageChannel, she = ga.String, G1 = 0, Ud = {}, mA = "onreadystatechange", yf, Cl, Y1, K1;
Pj(function() {
  yf = ga.location;
});
var xw = function(e) {
  if (ehe(Ud, e)) {
    var r = Ud[e];
    delete Ud[e], r();
  }
}, q1 = function(e) {
  return function() {
    xw(e);
  };
}, bA = function(e) {
  xw(e.data);
}, yA = function(e) {
  ga.postMessage(she(e), yf.protocol + "//" + yf.host);
};
(!Mx || !Rx) && (Mx = function(r) {
  the(arguments.length, 1);
  var t = vA(r) ? r : ihe(r), n = rhe(arguments, 1);
  return Ud[++G1] = function() {
    Xve(t, void 0, n);
  }, Cl(G1), G1;
}, Rx = function(r) {
  delete Ud[r];
}, ahe ? Cl = function(e) {
  ohe.nextTick(q1(e));
} : H1 && H1.now ? Cl = function(e) {
  H1.now(q1(e));
} : gA && !nhe ? (Y1 = new gA(), K1 = Y1.port2, Y1.port1.onmessage = bA, Cl = Jve(K1.postMessage, K1)) : ga.addEventListener && vA(ga.postMessage) && !ga.importScripts && yf && yf.protocol !== "file:" && !Pj(yA) ? (Cl = yA, ga.addEventListener("message", bA, !1)) : mA in pA("script") ? Cl = function(e) {
  hA.appendChild(pA("script"))[mA] = function() {
    hA.removeChild(this), xw(e);
  };
} : Cl = function(e) {
  setTimeout(q1(e), 0);
});
var kj = {
  set: Mx,
  clear: Rx
}, jj = function() {
  this.head = null, this.tail = null;
};
jj.prototype = {
  add: function(e) {
    var r = { item: e, next: null }, t = this.tail;
    t ? t.next = r : this.head = r, this.tail = r;
  },
  get: function() {
    var e = this.head;
    if (e) {
      var r = this.head = e.next;
      return r === null && (this.tail = null), e.item;
    }
  }
};
var Dj = jj, lhe = Cg, uhe = /ipad|iphone|ipod/i.test(lhe) && typeof Pebble != "undefined", che = Cg, dhe = /web0s(?!.*chrome)/i.test(che), au = fn, SA = Sw, fhe = $g.f, Z1 = kj.set, vhe = Dj, hhe = Rj, phe = uhe, ghe = dhe, Q1 = Yg, xA = au.MutationObserver || au.WebKitMutationObserver, $A = au.document, wA = au.process, Eh = au.Promise, _A = fhe(au, "queueMicrotask"), Px = _A && _A.value, Du, X1, J1, Ah, TA;
if (!Px) {
  var Ih = new vhe(), Oh = function() {
    var e, r;
    for (Q1 && (e = wA.domain) && e.exit(); r = Ih.get(); )
      try {
        r();
      } catch (t) {
        throw Ih.head && Du(), t;
      }
    e && e.enter();
  };
  !hhe && !Q1 && !ghe && xA && $A ? (X1 = !0, J1 = $A.createTextNode(""), new xA(Oh).observe(J1, { characterData: !0 }), Du = function() {
    J1.data = X1 = !X1;
  }) : !phe && Eh && Eh.resolve ? (Ah = Eh.resolve(void 0), Ah.constructor = Eh, TA = SA(Ah.then, Ah), Du = function() {
    TA(Oh);
  }) : Q1 ? Du = function() {
    wA.nextTick(Oh);
  } : (Z1 = SA(Z1, au), Du = function() {
    Z1(Oh);
  }), Px = function(e) {
    Ih.head || Du(), Ih.add(e);
  };
}
var mhe = Px, bhe = function(e, r) {
  try {
    arguments.length == 1 ? console.error(e) : console.error(e, r);
  } catch (t) {
  }
}, $w = function(e) {
  try {
    return { error: !1, value: e() };
  } catch (r) {
    return { error: !0, value: r };
  }
}, yhe = fn, Kg = yhe.Promise, Nj = typeof Deno == "object" && Deno && typeof Deno.version == "object", She = Nj, xhe = Yg, $he = !She && !xhe && typeof window == "object" && typeof document == "object", whe = fn, Vd = Kg, _he = Mt, The = GP, Che = N$, Ehe = Xn, Ahe = $he, Ihe = Nj, ey = IP;
Vd && Vd.prototype;
var Ohe = Ehe("species"), kx = !1, Lj = _he(whe.PromiseRejectionEvent), Mhe = The("Promise", function() {
  var e = Che(Vd), r = e !== String(Vd);
  if (!r && ey === 66)
    return !0;
  if (!ey || ey < 51 || !/native code/.test(e)) {
    var t = new Vd(function(i) {
      i(1);
    }), n = function(i) {
      i(function() {
      }, function() {
      });
    }, a = t.constructor = {};
    if (a[Ohe] = n, kx = t.then(function() {
    }) instanceof n, !kx)
      return !0;
  }
  return !r && (Ahe || Ihe) && !Lj;
}), qf = {
  CONSTRUCTOR: Mhe,
  REJECTION_EVENT: Lj,
  SUBCLASSING: kx
}, Rc = {}, CA = Vs, Rhe = TypeError, Phe = function(e) {
  var r, t;
  this.promise = new e(function(n, a) {
    if (r !== void 0 || t !== void 0)
      throw Rhe("Bad Promise constructor");
    r = n, t = a;
  }), this.resolve = CA(r), this.reject = CA(t);
};
Rc.f = function(e) {
  return new Phe(e);
};
var khe = ii, _0 = Yg, Fs = fn, Sc = wa, EA = Mc, AA = dj, jhe = gw, Dhe = mve, Nhe = Vs, Rp = Mt, Lhe = Us, Fhe = Sve, zhe = Lve, Fj = kj.set, ww = mhe, Bhe = bhe, Uhe = $w, Vhe = Dj, zj = z$, T0 = Kg, _w = qf, Bj = Rc, qg = "Promise", Uj = _w.CONSTRUCTOR, Whe = _w.REJECTION_EVENT, Hhe = _w.SUBCLASSING, ry = zj.getterFor(qg), Ghe = zj.set, Vu = T0 && T0.prototype, kl = T0, Mh = Vu, Vj = Fs.TypeError, jx = Fs.document, Tw = Fs.process, Dx = Bj.f, Yhe = Dx, Khe = !!(jx && jx.createEvent && Fs.dispatchEvent), Wj = "unhandledrejection", qhe = "rejectionhandled", IA = 0, Hj = 1, Zhe = 2, Cw = 1, Gj = 2, Rh, OA, Qhe, MA, Yj = function(e) {
  var r;
  return Lhe(e) && Rp(r = e.then) ? r : !1;
}, Kj = function(e, r) {
  var t = r.value, n = r.state == Hj, a = n ? e.ok : e.fail, i = e.resolve, l = e.reject, u = e.domain, c, f, h;
  try {
    a ? (n || (r.rejection === Gj && Jhe(r), r.rejection = Cw), a === !0 ? c = t : (u && u.enter(), c = a(t), u && (u.exit(), h = !0)), c === e.promise ? l(Vj("Promise-chain cycle")) : (f = Yj(c)) ? Sc(f, c, i, l) : i(c)) : l(t);
  } catch (p) {
    u && !h && u.exit(), l(p);
  }
}, qj = function(e, r) {
  e.notified || (e.notified = !0, ww(function() {
    for (var t = e.reactions, n; n = t.get(); )
      Kj(n, e);
    e.notified = !1, r && !e.rejection && Xhe(e);
  }));
}, Zj = function(e, r, t) {
  var n, a;
  Khe ? (n = jx.createEvent("Event"), n.promise = r, n.reason = t, n.initEvent(e, !1, !0), Fs.dispatchEvent(n)) : n = { promise: r, reason: t }, !Whe && (a = Fs["on" + e]) ? a(n) : e === Wj && Bhe("Unhandled promise rejection", t);
}, Xhe = function(e) {
  Sc(Fj, Fs, function() {
    var r = e.facade, t = e.value, n = RA(e), a;
    if (n && (a = Uhe(function() {
      _0 ? Tw.emit("unhandledRejection", t, r) : Zj(Wj, r, t);
    }), e.rejection = _0 || RA(e) ? Gj : Cw, a.error))
      throw a.value;
  });
}, RA = function(e) {
  return e.rejection !== Cw && !e.parent;
}, Jhe = function(e) {
  Sc(Fj, Fs, function() {
    var r = e.facade;
    _0 ? Tw.emit("rejectionHandled", r) : Zj(qhe, r, e.value);
  });
}, Qu = function(e, r, t) {
  return function(n) {
    e(r, n, t);
  };
}, vc = function(e, r, t) {
  e.done || (e.done = !0, t && (e = t), e.value = r, e.state = Zhe, qj(e, !0));
}, Nx = function(e, r, t) {
  if (!e.done) {
    e.done = !0, t && (e = t);
    try {
      if (e.facade === r)
        throw Vj("Promise can't be resolved itself");
      var n = Yj(r);
      n ? ww(function() {
        var a = { done: !1 };
        try {
          Sc(
            n,
            r,
            Qu(Nx, a, e),
            Qu(vc, a, e)
          );
        } catch (i) {
          vc(a, i, e);
        }
      }) : (e.value = r, e.state = Hj, qj(e, !1));
    } catch (a) {
      vc({ done: !1 }, a, e);
    }
  }
};
if (Uj && (kl = function(r) {
  Fhe(this, Mh), Nhe(r), Sc(Rh, this);
  var t = ry(this);
  try {
    r(Qu(Nx, t), Qu(vc, t));
  } catch (n) {
    vc(t, n);
  }
}, Mh = kl.prototype, Rh = function(r) {
  Ghe(this, {
    type: qg,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new Vhe(),
    rejection: !1,
    state: IA,
    value: void 0
  });
}, Rh.prototype = EA(Mh, "then", function(r, t) {
  var n = ry(this), a = Dx(zhe(this, kl));
  return n.parent = !0, a.ok = Rp(r) ? r : !0, a.fail = Rp(t) && t, a.domain = _0 ? Tw.domain : void 0, n.state == IA ? n.reactions.add(a) : ww(function() {
    Kj(a, n);
  }), a.promise;
}), OA = function() {
  var e = new Rh(), r = ry(e);
  this.promise = e, this.resolve = Qu(Nx, r), this.reject = Qu(vc, r);
}, Bj.f = Dx = function(e) {
  return e === kl || e === Qhe ? new OA(e) : Yhe(e);
}, Rp(T0) && Vu !== Object.prototype)) {
  MA = Vu.then, Hhe || EA(Vu, "then", function(r, t) {
    var n = this;
    return new kl(function(a, i) {
      Sc(MA, n, a, i);
    }).then(r, t);
  }, { unsafe: !0 });
  try {
    delete Vu.constructor;
  } catch (e) {
  }
  AA && AA(Vu, Mh);
}
khe({ global: !0, constructor: !0, wrap: !0, forced: Uj }, {
  Promise: kl
});
jhe(kl, qg, !1);
Dhe(qg);
var epe = Xn, rpe = Kf, tpe = epe("iterator"), npe = Array.prototype, ape = function(e) {
  return e !== void 0 && (rpe.Array === e || npe[tpe] === e);
}, ope = bw, PA = I$, ipe = Tg, spe = Kf, lpe = Xn, upe = lpe("iterator"), Qj = function(e) {
  if (!ipe(e))
    return PA(e, upe) || PA(e, "@@iterator") || spe[ope(e)];
}, cpe = wa, dpe = Vs, fpe = qa, vpe = Eg, hpe = Qj, ppe = TypeError, gpe = function(e, r) {
  var t = arguments.length < 2 ? hpe(e) : r;
  if (dpe(t))
    return fpe(cpe(t, e));
  throw ppe(vpe(e) + " is not iterable");
}, mpe = wa, kA = qa, bpe = I$, ype = function(e, r, t) {
  var n, a;
  kA(e);
  try {
    if (n = bpe(e, "return"), !n) {
      if (r === "throw")
        throw t;
      return t;
    }
    n = mpe(n, e);
  } catch (i) {
    a = !0, n = i;
  }
  if (r === "throw")
    throw t;
  if (a)
    throw n;
  return kA(n), t;
}, Spe = Sw, xpe = wa, $pe = qa, wpe = Eg, _pe = ape, Tpe = UP, jA = Gf, Cpe = gpe, Epe = Qj, DA = ype, Ape = TypeError, Pp = function(e, r) {
  this.stopped = e, this.result = r;
}, NA = Pp.prototype, Xj = function(e, r, t) {
  var n = t && t.that, a = !!(t && t.AS_ENTRIES), i = !!(t && t.IS_RECORD), l = !!(t && t.IS_ITERATOR), u = !!(t && t.INTERRUPTED), c = Spe(r, n), f, h, p, g, y, S, x, T = function(O) {
    return f && DA(f, "normal", O), new Pp(!0, O);
  }, A = function(O) {
    return a ? ($pe(O), u ? c(O[0], O[1], T) : c(O[0], O[1])) : u ? c(O, T) : c(O);
  };
  if (i)
    f = e.iterator;
  else if (l)
    f = e;
  else {
    if (h = Epe(e), !h)
      throw Ape(wpe(e) + " is not iterable");
    if (_pe(h)) {
      for (p = 0, g = Tpe(e); g > p; p++)
        if (y = A(e[p]), y && jA(NA, y))
          return y;
      return new Pp(!1);
    }
    f = Cpe(e, h);
  }
  for (S = i ? e.next : f.next; !(x = xpe(S, f)).done; ) {
    try {
      y = A(x.value);
    } catch (O) {
      DA(f, "throw", O);
    }
    if (typeof y == "object" && y && jA(NA, y))
      return y;
  }
  return new Pp(!1);
}, Ipe = Xn, Jj = Ipe("iterator"), e6 = !1;
try {
  var Ope = 0, LA = {
    next: function() {
      return { done: !!Ope++ };
    },
    return: function() {
      e6 = !0;
    }
  };
  LA[Jj] = function() {
    return this;
  }, Array.from(LA, function() {
    throw 2;
  });
} catch (e) {
}
var Mpe = function(e, r) {
  if (!r && !e6)
    return !1;
  var t = !1;
  try {
    var n = {};
    n[Jj] = function() {
      return {
        next: function() {
          return { done: t = !0 };
        }
      };
    }, e(n);
  } catch (a) {
  }
  return t;
}, Rpe = Kg, Ppe = Mpe, kpe = qf.CONSTRUCTOR, r6 = kpe || !Ppe(function(e) {
  Rpe.all(e).then(void 0, function() {
  });
}), jpe = ii, Dpe = wa, Npe = Vs, Lpe = Rc, Fpe = $w, zpe = Xj, Bpe = r6;
jpe({ target: "Promise", stat: !0, forced: Bpe }, {
  all: function(r) {
    var t = this, n = Lpe.f(t), a = n.resolve, i = n.reject, l = Fpe(function() {
      var u = Npe(t.resolve), c = [], f = 0, h = 1;
      zpe(r, function(p) {
        var g = f++, y = !1;
        h++, Dpe(u, t, p).then(function(S) {
          y || (y = !0, c[g] = S, --h || a(c));
        }, i);
      }), --h || a(c);
    });
    return l.error && i(l.value), n.promise;
  }
});
var Upe = ii, Vpe = qf.CONSTRUCTOR, Lx = Kg, Wpe = lu, Hpe = Mt, Gpe = Mc, FA = Lx && Lx.prototype;
Upe({ target: "Promise", proto: !0, forced: Vpe, real: !0 }, {
  catch: function(e) {
    return this.then(void 0, e);
  }
});
if (Hpe(Lx)) {
  var zA = Wpe("Promise").prototype.catch;
  FA.catch !== zA && Gpe(FA, "catch", zA, { unsafe: !0 });
}
var Ype = ii, Kpe = wa, qpe = Vs, Zpe = Rc, Qpe = $w, Xpe = Xj, Jpe = r6;
Ype({ target: "Promise", stat: !0, forced: Jpe }, {
  race: function(r) {
    var t = this, n = Zpe.f(t), a = n.reject, i = Qpe(function() {
      var l = qpe(t.resolve);
      Xpe(r, function(u) {
        Kpe(l, t, u).then(n.resolve, a);
      });
    });
    return i.error && a(i.value), n.promise;
  }
});
var e0e = ii, r0e = wa, t0e = Rc, n0e = qf.CONSTRUCTOR;
e0e({ target: "Promise", stat: !0, forced: n0e }, {
  reject: function(r) {
    var t = t0e.f(this);
    return r0e(t.reject, void 0, r), t.promise;
  }
});
var a0e = qa, o0e = Us, i0e = Rc, s0e = function(e, r) {
  if (a0e(e), o0e(r) && r.constructor === e)
    return r;
  var t = i0e.f(e), n = t.resolve;
  return n(r), t.promise;
}, l0e = ii, u0e = lu, c0e = qf.CONSTRUCTOR, d0e = s0e;
u0e("Promise");
l0e({ target: "Promise", stat: !0, forced: c0e }, {
  resolve: function(r) {
    return d0e(this, r);
  }
});
const f0e = Pg((e, r) => {
  const t = nw("Steps", e), n = Object.assign({}, t.steps), a = rw(e), {
    className: i,
    activeStep: l,
    children: u,
    orientation: c,
    state: f,
    responsive: h,
    checkIcon: p,
    onClickStep: g,
    labelOrientation: y,
    restrictedFordward: S,
    gap: x
  } = a, T = W$(a, ["className", "activeStep", "children", "orientation", "state", "responsive", "checkIcon", "onClickStep", "labelOrientation", "restrictedFordward", "gap"]), A = I.Children.toArray(u), O = A.length, P = () => l <= A.length ? I.Children.map(A[l], (M) => {
    if (/* @__PURE__ */ I.isValidElement(M))
      return I.Children.map(M.props.children, (W) => W);
  }) : null, j = !!g, [k] = Yte("(max-width: 43em)"), L = k && h ? "vertical" : c;
  return QS(ew, Object.assign({
    value: t
  }, {
    children: Jte(Vfe, Object.assign({
      value: {
        activeStep: l,
        orientation: L,
        state: f,
        responsive: h,
        checkIcon: p,
        onClickStep: g,
        labelOrientation: y,
        clickable: j,
        colorScheme: e.colorScheme,
        stepCount: O,
        restrictedFordward: S,
        gap: x
      }
    }, {
      children: [QS(Sa.ol, Object.assign({
        ref: r,
        __css: Object.assign({
          justifyContent: O === 1 ? "flex-end" : "space-between",
          flexDir: L === "vertical" ? "column" : "row"
        }, n),
        className: Z$("chakra-steps", i)
      }, T, {
        children: I.Children.map(u, (M, W) => {
          var q;
          const oe = (q = /* @__PURE__ */ I.isValidElement(M) && M.props.isCompletedStep) !== null && q !== void 0 ? q : W < l, Ae = W === O - 1, $e = {
            index: W,
            isCompletedStep: oe,
            isCurrentStep: W === l,
            isLastStep: Ae
          };
          return /* @__PURE__ */ I.isValidElement(M) ? /* @__PURE__ */ I.cloneElement(M, $e) : null;
        })
      })), L === "horizontal" && P()]
    }))
  }));
});
f0e.defaultProps = {
  activeStep: 0,
  colorScheme: "brand",
  orientation: "horizontal",
  responsive: !0
};
const v0e = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold"
}, h0e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = yc(`${r}.500`, 0.6)(t);
  return {
    bg: Fe(`${r}.500`, n)(e),
    color: Fe("white", "whiteAlpha.800")(e)
  };
}, p0e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = yc(`${r}.200`, 0.16)(t);
  return {
    bg: Fe(`${r}.100`, n)(e),
    color: Fe(`${r}.800`, `${r}.200`)(e)
  };
}, g0e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = yc(`${r}.200`, 0.8)(t), a = Dr(t, `${r}.500`), i = Fe(a, n)(e);
  return {
    color: i,
    boxShadow: `inset 0 0 0px 1px ${i}`
  };
}, m0e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = yc(`${r}.500`, 0.6)(t);
  return {
    bg: Fe(`${r}.500`, n)(e),
    color: Fe("white", "whiteAlpha.800")(e),
    borderRadius: "full",
    border: "1px",
    borderColor: "white",
    minWidth: "21.5px",
    boxShadow: "base",
    textAlign: "center"
  };
}, b0e = {
  solid: h0e,
  subtle: p0e,
  outline: g0e,
  number: m0e
}, y0e = {
  variant: "subtle",
  colorScheme: "gray"
}, S0e = {
  baseStyle: v0e,
  variants: b0e,
  defaultProps: y0e
};
var x0e = ii, $0e = VP.includes, w0e = jn, _0e = sj, T0e = w0e(function() {
  return !Array(1).includes();
});
x0e({ target: "Array", proto: !0, forced: T0e }, {
  includes: function(r) {
    return $0e(this, r, arguments.length > 1 ? arguments[1] : void 0);
  }
});
_0e("includes");
const C0e = {
  borderRadius: "50vh",
  fontWeight: "bold",
  _focus: "none",
  _disabled: {
    opacity: 1,
    cursor: "not-allowed",
    boxShadow: "none",
    border: "none",
    color: "gray.600",
    bg: "gray.300"
  },
  _hover: {
    _disabled: {
      color: "gray.600",
      bg: "gray.300"
    }
  }
}, t6 = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e;
  if (r === "brand") {
    yc(`${r}.500`, 0.12)(t);
    const n = yc(`${r}.500`, 0.24)(t);
    return {
      fontWeight: "normal",
      color: Fe(`${r}.500`, `${r}.200`)(e),
      bg: "transparent",
      _disabled: {
        bg: "transparent",
        color: "gray.500"
      },
      _hover: {
        bg: Fe(`${r}.100`, "whiteAlpha.200")(e),
        _disabled: {
          bg: "transparent",
          color: "gray.500"
        }
      },
      _active: {
        color: Fe("white", `${r}.200`)(e),
        borderColor: Fe(`${r}.600`, n)(e),
        bg: Fe(`${r}.300`, n)(e)
      }
    };
  }
  return r === "secondary" ? {
    fontWeight: "normal",
    color: Fe("gray.800", "whiteAlpha.900")(e),
    bg: "transparent",
    _disabled: {
      bg: "transparent",
      color: "gray.500"
    },
    _hover: {
      bg: Fe("gray.100", "whiteAlpha.200")(e),
      _disabled: {
        bg: "transparent",
        color: "gray.500"
      }
    },
    _active: {
      bg: Fe("gray.300", "whiteAlpha.300")(e)
    }
  } : Df.components.Button.variants.ghost(e);
}, BA = {
  xs: 1,
  sm: 1.5,
  md: 2,
  xl: 2
}, E0e = (e) => {
  const {
    colorScheme: r,
    size: t
  } = e, n = Fe("secondary.700", "whiteAlpha.300")(e), a = t6(e);
  return Object.assign(Object.assign({
    fontWeight: "normal",
    border: `${BA[t] || 2}px solid`,
    borderColor: ["secondary"].includes(r) ? n : "currentColor"
  }, a), {
    color: ["secondary"].includes(r) ? n : a.color,
    _hover: {
      bg: ["secondary"].includes(r) ? "secondary.50" : a._hover.bg,
      _disabled: {
        bg: "gray.300"
      }
    },
    _active: {
      bg: ["secondary"].includes(r) ? "secondary.200" : a._active.bg
    },
    _disabled: {
      border: `${BA[t] || 2}px solid`,
      borderColor: "gray.500",
      _hover: {
        borderColor: "gray.500"
      }
    }
  });
}, A0e = (e) => {
  const {
    colorScheme: r
  } = e;
  return r === "brand" ? {
    bg: Fe(`${r}.500`, `${r}.200`)(e),
    color: Fe("white", "gray.800")(e),
    _hover: {
      bg: Fe(`${r}.600`, `${r}.300`)(e),
      _disabled: {
        color: "gray.600",
        bg: "gray.300"
      }
    },
    _active: {
      bg: Fe(`${r}.700`, `${r}.400`)(e)
    }
  } : r === "secondary" ? {
    bg: Fe("secondary.700", "whiteAlpha.200")(e),
    color: "white",
    _hover: {
      bg: Fe(`${r}.400`, "whiteAlpha.300")(e),
      _disabled: {
        color: "gray.600",
        bg: "gray.300"
      }
    },
    _active: {
      bg: Fe(`${r}.800`, "whiteAlpha.400")(e)
    }
  } : Df.components.Button.variants.solid(e);
}, I0e = (e) => {
  const {
    colorScheme: r
  } = e, t = Df.components.Button.variants.link(e);
  let {
    color: n
  } = t;
  const {
    _active: a
  } = t;
  return t.textDecoration = "underline", t._disabled = Object.assign(Object.assign({}, t._disabled), {
    color: "gray.500",
    bg: "none"
  }), t._hover = Object.assign(Object.assign({}, t._hover), {
    fontWeight: "bold",
    _disabled: Object.assign(Object.assign({}, t._hover._disabled), {
      color: "gray.500",
      fontWeight: "normal",
      bg: "none",
      textDecoration: "underline"
    })
  }), r === "brand" && (t.fontWeight = "normal", n = Fe(`${r}.500`, `${r}.200`)(e), a.color = Fe(`${r}.600`, `${r}.400`)(e)), r === "secondary" && (t.fontWeight = "normal", n = Fe("gray.800", "whiteAlpha.900")(e), a.color = Fe("gray.600", "whiteAlpha.300")(e)), Object.assign(Object.assign({}, t), {
    color: n,
    _active: Object.assign({}, a)
  });
}, O0e = {
  ghost: t6,
  outline: E0e,
  solid: A0e,
  link: I0e
}, M0e = {
  lg: {
    h: "46px",
    minW: "46px",
    fontSize: "lg",
    px: 6
  },
  md: {
    h: "42px",
    minW: "42px",
    fontSize: "md",
    px: 5
  },
  sm: {
    h: "32px",
    minW: "32px",
    fontSize: "sm",
    px: 4
  },
  xs: {
    h: "26px",
    minW: "26px",
    fontSize: "xs",
    px: 3
  }
}, R0e = {
  variant: "solid",
  size: "md"
}, P0e = {
  baseStyle: C0e,
  sizes: M0e,
  variants: O0e,
  defaultProps: R0e
}, k0e = {
  display: "flex",
  flexDirection: "column",
  background: "white",
  alignItems: "center",
  gap: 6
}, j0e = {
  padding: {
    base: 4,
    md: 5
  },
  borderRadius: "1rem",
  boxShadow: "base"
}, D0e = {
  padding: {
    base: 4,
    md: 5
  },
  borderRadius: "none",
  boxShadow: "none"
}, N0e = {
  flat: D0e,
  rounded: j0e
}, L0e = {
  variant: "rounded"
}, F0e = {
  baseStyle: k0e,
  variants: N0e,
  defaultProps: L0e
};
Kr("accordion").parts("root", "container", "button", "panel").extend("icon");
Kr("alert").parts("title", "description", "container").extend("icon");
Kr("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
Kr("breadcrumb").parts("link", "item", "container").extend("separator");
Kr("button").parts();
var z0e = Kr("checkbox").parts("control", "icon", "container").extend("label");
Kr("progress").parts("track", "filledTrack").extend("label");
Kr("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
Kr("editable").parts("preview", "input", "textarea");
Kr("form").parts("container", "requiredIndicator", "helperText");
Kr("formError").parts("text", "icon");
var B0e = Kr("input").parts("addon", "field", "element");
Kr("list").parts("container", "item", "icon");
Kr("menu").parts("button", "list", "item").extend("groupTitle", "command", "divider");
var U0e = Kr("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
Kr("numberinput").parts("root", "field", "stepperGroup", "stepper");
Kr("pininput").parts("field");
var V0e = Kr("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
Kr("progress").parts("label", "filledTrack", "track");
var W0e = Kr("radio").parts("container", "control", "label");
Kr("select").parts("field", "icon");
Kr("slider").parts("container", "track", "thumb", "filledTrack");
Kr("stat").parts("container", "label", "helpText", "number", "icon");
var H0e = Kr("switch").parts("container", "track", "thumb");
Kr("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");
Kr("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");
Kr("tag").parts("container", "label", "closeButton");
const G0e = (e) => {
  const {
    colorScheme: r
  } = e;
  return {
    w: "100%",
    border: "1px",
    borderRadius: "base",
    borderColor: "gray.300",
    _indeterminate: {
      bg: "white",
      borderColor: "gray.300",
      color: Fe(`${r}.500`, `${r}.200`)(e)
    },
    _disabled: {
      borderColor: "gray.300",
      bg: "linear-gradient(to top left, #FAFAFA, #FAFAFA 48%, #D1D1D1 48%, #D1D1D1 52%, #FAFAFA 52%, #FAFAFA)"
    },
    _focus: {
      boxShadow: "none"
    }
  };
}, Y0e = {
  _disabled: {
    cursor: "not-allowed"
  }
}, K0e = {
  userSelect: "none",
  _disabled: {
    opacity: 0.4
  }
}, q0e = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, Sf = (e) => ({
  icon: q0e,
  container: Y0e,
  control: G0e(e),
  label: K0e
}), Z0e = {
  sm: {
    control: {
      h: 3,
      w: 3
    },
    label: {
      fontSize: "sm"
    },
    icon: {
      fontSize: "0.72rem"
    }
  },
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    },
    icon: {
      fontSize: "1rem"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    },
    icon: {
      fontSize: "1rem"
    }
  }
}, Q0e = {
  size: "md",
  colorScheme: "brand"
}, X0e = {
  parts: z0e.keys,
  baseStyle: Sf,
  sizes: Z0e,
  defaultProps: Q0e
}, J0e = {
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _placeholder: {
      color: "gray.400"
    }
  }
}, ms = {
  lg: {
    fontSize: "lg",
    px: 4,
    h: "50px",
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    px: 4,
    h: "44px",
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    px: 3,
    h: "32px",
    borderRadius: "md"
  },
  xs: {
    fontSize: "xs",
    px: 2,
    h: "24px",
    borderRadius: "md"
  }
}, ege = {
  lg: {
    field: ms.lg,
    addon: ms.lg
  },
  md: {
    field: ms.md,
    addon: ms.md
  },
  sm: {
    field: ms.sm,
    addon: ms.sm
  },
  xs: {
    field: ms.xs,
    addon: ms.xs
  }
};
function Ew(e) {
  const {
    focusBorderColor: r,
    errorBorderColor: t,
    fieldBorderColor: n,
    disabledColor: a
  } = e;
  return {
    focusBorderColor: r || Fe("secondary.700", "secondary.300")(e),
    errorBorderColor: t || Fe("#DB371F", "red.300")(e),
    fieldBorderColor: n || Fe("gray.400", "gray.200")(e),
    disabledColor: a || Fe("gray.300", "gray.100")(e)
  };
}
const rge = (e) => {
  const {
    theme: r
  } = e, {
    focusBorderColor: t,
    errorBorderColor: n,
    fieldBorderColor: a,
    disabledColor: i
  } = Ew(e);
  return {
    field: {
      border: "0.5px solid",
      borderColor: Dr(r, a),
      bg: "inherit",
      _hover: {
        borderColor: Dr(r, a)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        borderColor: Dr(r, i),
        boxShadow: `0 0 0 0.5px ${Dr(r, i)}`,
        _hover: {
          borderColor: Dr(r, i)
        },
        _placeholder: {
          color: Dr(r, i)
        }
      },
      _invalid: {
        borderColor: Dr(r, n),
        boxShadow: `0 0 0 0.5px ${Dr(r, n)}`
      },
      _focus: {
        zIndex: 1,
        borderColor: Dr(r, t),
        boxShadow: `0 0 0 0.5px ${Dr(r, t)}`
      }
    },
    addon: {
      border: "0.5px solid",
      borderColor: Dr(r, a),
      bg: Fe("gray.100", "whiteAlpha.300")(e)
    }
  };
}, tge = (e) => {
  const {
    theme: r
  } = e, {
    focusBorderColor: t,
    errorBorderColor: n,
    disabledColor: a
  } = Ew(e);
  return {
    field: {
      border: "1px solid",
      borderColor: "transparent",
      bg: Fe("gray.100", "whiteAlpha.50")(e),
      _hover: {
        bg: Fe("gray.100", "whiteAlpha.50")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        bg: Dr(r, a),
        _placeholder: {
          color: Fe("gray.700", "whiteAlpha.100")(e)
        },
        _hover: {
          bg: Dr(r, a)
        }
      },
      _invalid: {
        borderColor: Dr(r, n)
      },
      _focus: {
        bg: "transparent",
        borderColor: Dr(r, t)
      }
    },
    addon: {
      border: "1px solid",
      borderColor: "transparent",
      bg: Fe("gray.100", "whiteAlpha.50")(e)
    }
  };
}, nge = (e) => {
  const {
    theme: r
  } = e, {
    focusBorderColor: t,
    errorBorderColor: n,
    fieldBorderColor: a,
    disabledColor: i
  } = Ew(e);
  return {
    field: {
      borderBottom: "0px solid",
      borderColor: Dr(r, a),
      borderRadius: 0,
      px: 0,
      boxShadow: `0px 1px 0px ${Dr(r, a)}`,
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Dr(r, n),
        boxShadow: `0px 1px 0px ${Dr(r, n)}`
      },
      _focus: {
        borderColor: Dr(r, t),
        boxShadow: `0px 1px 0px ${Dr(r, t)}`
      },
      _disabled: {
        borderColor: Dr(r, i),
        boxShadow: `0px 1px 0px ${Dr(r, i)}`,
        _placeholder: {
          color: Dr(r, i)
        }
      }
    },
    addon: {
      borderBottom: "0px solid",
      borderColor: Dr(r, a),
      boxShadow: `0px 1px 0px ${Dr(r, a)}`,
      borderRadius: 0,
      px: 0,
      pr: 2,
      bg: "transparent"
    }
  };
}, age = {
  field: {
    bg: "transparent",
    px: 0,
    height: "auto",
    _disabled: {
      _placeholder: {
        color: "gray.300"
      }
    }
  },
  addon: {
    bg: "transparent",
    px: 0,
    height: "auto"
  }
}, oge = {
  outline: rge,
  filled: tge,
  flushed: nge,
  unstyled: age
}, ige = {
  size: "sm",
  variant: "flushed"
}, sge = {
  parts: B0e.keys,
  baseStyle: J0e,
  sizes: ege,
  variants: oge,
  defaultProps: ige
}, lge = {
  bg: "blackAlpha.400",
  zIndex: "modal"
}, uge = (e) => {
  const {
    isCentered: r,
    scrollBehavior: t
  } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: r ? "center" : "flex-start",
    overflow: t === "inside" ? "hidden" : "auto",
    fontSize: "sm"
  };
}, cge = (e) => {
  const {
    scrollBehavior: r
  } = e;
  return {
    borderRadius: "md",
    bg: Fe("white", "gray.700")(e),
    color: "inherit",
    my: "3.75rem",
    zIndex: "modal",
    maxH: r === "inside" ? "calc(100% - 7.5rem)" : void 0,
    boxShadow: Fe("lg", "dark-lg")(e)
  };
}, dge = {
  px: 6,
  py: 3,
  fontSize: "md",
  fontWeight: "normal",
  borderBottom: "1px solid",
  borderBottomColor: "gray.100"
}, fge = {
  position: "absolute",
  top: 2,
  insetEnd: 3,
  color: "gray.400"
}, vge = (e) => {
  const {
    scrollBehavior: r
  } = e;
  return {
    px: 6,
    py: 6,
    flex: 1,
    overflow: r === "inside" ? "auto" : void 0,
    fontSize: "sm"
  };
}, hge = (e) => ({
  px: 6,
  py: 3,
  bg: Fe("gray.100", "gray.700")(e),
  borderBottomRadius: "md"
}), pge = (e) => ({
  overlay: lge,
  dialogContainer: uge(e),
  dialog: cge(e),
  header: dge,
  closeButton: fge,
  body: vge(e),
  footer: hge(e)
});
function lo(e) {
  return e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "100vh",
      "@supports(min-height: -webkit-fill-available)": {
        minH: "-webkit-fill-available"
      },
      my: 0
    }
  } : {
    dialog: {
      maxW: e
    }
  };
}
const gge = {
  xs: lo("xs"),
  sm: lo("sm"),
  md: lo("md"),
  lg: lo("lg"),
  xl: lo("xl"),
  "2xl": lo("2xl"),
  "3xl": lo("3xl"),
  "4xl": lo("4xl"),
  "5xl": lo("5xl"),
  "6xl": lo("6xl"),
  full: lo("full")
}, mge = {
  size: "md",
  autoFocus: !1
}, bge = {
  parts: U0e.keys,
  baseStyle: pge,
  sizes: gge,
  defaultProps: mge
}, ty = si("popper-bg"), yge = si("popper-arrow-bg"), Sge = si("popper-arrow-shadow-color"), xge = {
  zIndex: 10
}, $ge = (e) => {
  const r = Fe("white", "gray.700")(e), t = Fe("gray.200", "whiteAlpha.300")(e);
  return {
    [ty.variable]: `colors.${r}`,
    bg: ty.reference,
    [yge.variable]: ty.reference,
    [Sge.variable]: `colors.${t}`,
    width: "xs",
    border: "1px solid",
    borderColor: "gray.300",
    borderRadius: "base",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
    zIndex: "inherit",
    _focus: {
      outline: 0,
      boxShadow: "node"
    }
  };
}, wge = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px",
  fontSize: "sm"
}, _ge = {
  fontSize: "xs",
  px: 3,
  py: 2
}, Tge = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, Cge = {
  position: "absolute",
  borderRadius: "md",
  top: 2,
  insetEnd: 2,
  color: "gray.400"
}, Ege = (e) => ({
  popper: xge,
  content: $ge(e),
  header: wge,
  body: _ge,
  footer: Tge,
  arrow: {},
  closeButton: Cge
}), Age = {
  parts: V0e.keys,
  baseStyle: Ege
}, Ige = (e) => {
  const {
    colorScheme: r,
    size: t
  } = e, {
    control: n = {}
  } = Sf(e);
  let a = "12px";
  return t === "md" ? a = "9px" : t === "sm" && (a = "6px"), Object.assign(Object.assign({}, n), {
    borderRadius: "full",
    _hover: {
      bg: "white",
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: a,
        h: a,
        borderRadius: "50%",
        bg: Fe(`${r}.500`, `${r}.200`)(e)
      },
      _disabled: {
        bg: "linear-gradient(to top left, #FAFAFA, #FAFAFA 48%, #D1D1D1 48%, #D1D1D1 52%, #FAFAFA 52%, #FAFAFA)",
        _before: {
          bg: "none"
        }
      }
    },
    _checked: {
      bg: "white",
      borderColor: Fe(`${r}.500`, `${r}.200`)(e),
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: a,
        h: a,
        borderRadius: "50%",
        bg: Fe(`${r}.500`, `${r}.200`)(e)
      },
      _hover: {
        _disabled: {
          bg: "gray.200",
          _before: {
            bg: "gray.500"
          }
        }
      },
      _disabled: {
        _before: {
          bg: "gray.500"
        }
      }
    },
    _active: {
      _before: {
        bg: Fe(`${r}.600`, `${r}.400`)(e)
      }
    }
  });
}, Oge = (e) => ({
  label: Sf(e).label,
  container: Sf(e).container,
  control: Ige(e)
}), Mge = {
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    }
  },
  sm: {
    control: {
      width: 3,
      height: 3
    },
    label: {
      fontSize: "sm"
    }
  }
}, Rge = {
  size: "md",
  colorScheme: "brand"
}, Pge = {
  parts: W0e.keys,
  baseStyle: Oge,
  sizes: Mge,
  defaultProps: Rge
}, Ko = si("spinner-size"), kge = {
  width: [Ko.reference],
  height: [Ko.reference]
}, jge = {
  xs: {
    [Ko.variable]: "0.75rem"
  },
  sm: {
    [Ko.variable]: "1rem"
  },
  md: {
    [Ko.variable]: "1.5rem"
  },
  lg: {
    [Ko.variable]: "2rem"
  },
  xl: {
    [Ko.variable]: "3rem"
  },
  "2xl": {
    [Ko.variable]: "4rem"
  },
  "3xl": {
    [Ko.variable]: "5rem"
  },
  "4xl": {
    [Ko.variable]: "6rem"
  }
}, Dge = {
  size: "md"
}, Nge = {
  baseStyle: kge,
  sizes: jge,
  defaultProps: Dge
}, Lge = Kr("steps").parts("connector", "description", "icon", "iconLabel", "label", "labelContainer", "step", "stepContainer", "stepIconContainer", "steps"), Fge = {
  strokeWidth: "2px"
}, UA = (e) => ({
  color: Fe("gray.800", "gray.100")(e),
  fontWeight: "medium",
  textAlign: "center",
  fontSize: "md",
  _activeStep: {
    color: "gray.900"
  }
}), zge = (e) => ({
  color: Fe("gray.800", "gray.200")(e),
  marginTop: "-2px",
  textAlign: "center",
  fontSize: "sm"
}), Bge = (e) => {
  const {
    colorScheme: r
  } = e, t = Fe("gray.200", "gray.700")(e);
  let n = `${r}.500`;
  r === "secondary" && (n = `${r}.700`);
  const a = Fe(n, `${r}.200`)(e);
  return {
    flex: 1,
    display: "flex",
    borderStyle: "solid",
    borderColor: t,
    transitionProperty: "border-color",
    transitionDuration: "normal",
    _highlighted: {
      borderColor: a
    }
  };
}, Uge = (e) => {
  const {
    colorScheme: r
  } = e, t = Fe("gray.400", "gray.700")(e);
  let n = `${r}.500`;
  return r === "secondary" && (n = `${r}.700`), {
    display: "flex",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    bg: t,
    borderStyle: "solid",
    borderColor: t,
    transitionProperty: "background, border-color",
    transitionDuration: "normal",
    _activeStep: {
      bg: Fe(tve("white", 0.5), nve(t, 0.5))(e),
      borderColor: n,
      _invalid: {
        bg: "red.500",
        borderColor: "red.500"
      }
    },
    _highlighted: {
      bg: n,
      borderColor: n
    },
    "&[data-clickable]:hover": {
      borderColor: n
    }
  };
}, Vge = (e) => {
  const {
    colorScheme: r
  } = e;
  let t = `${r}.500`;
  return r === "secondary" && (t = `${r}.700`), {
    connector: Bge(e),
    description: zge(e),
    icon: Fge,
    iconLabel: UA(e),
    label: Object.assign(Object.assign({}, UA(e)), {
      _activeStep: {
        color: t
      }
    }),
    labelContainer: {
      display: "flex",
      flexDir: "column",
      justifyContent: "center"
    },
    step: {
      display: "flex",
      position: "relative"
    },
    stepContainer: {
      display: "flex",
      alignItems: "center"
    },
    stepIconContainer: Uge(e),
    steps: {
      fontFamily: "heading",
      textAlign: "center",
      width: "100%",
      display: "flex",
      flex: 1
    }
  };
}, Wge = {
  sm: {
    stepIconContainer: {
      width: "26px",
      height: "26px",
      borderWidth: "2px"
    },
    icon: {
      width: "14px",
      height: "14px"
    },
    label: {
      fontWeight: "semibold",
      textAlign: "center",
      fontSize: "sm"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "xs"
    }
  },
  md: {
    stepIconContainer: {
      width: "40px",
      height: "40px",
      borderWidth: "2px"
    },
    icon: {
      width: "18px",
      height: "18px"
    },
    label: {
      fontWeight: "semibold",
      textAlign: "center",
      fontSize: "md"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "sm"
    }
  },
  lg: {
    stepIconContainer: {
      width: "48px",
      height: "48px",
      borderWidth: "2px"
    },
    icon: {
      width: "22px",
      height: "22px"
    },
    label: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: "lg"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "md"
    }
  }
}, Hge = {
  size: "md",
  colorScheme: "brand"
}, Gge = {
  parts: Lge.keys,
  baseStyle: Vge,
  sizes: Wge,
  defaultProps: Hge
};
var Yge = qa, Kge = function() {
  var e = Yge(this), r = "";
  return e.hasIndices && (r += "d"), e.global && (r += "g"), e.ignoreCase && (r += "i"), e.multiline && (r += "m"), e.dotAll && (r += "s"), e.unicode && (r += "u"), e.unicodeSets && (r += "v"), e.sticky && (r += "y"), r;
}, qge = wa, Zge = Ka, Qge = Gf, Xge = Kge, VA = RegExp.prototype, Jge = function(e) {
  var r = e.flags;
  return r === void 0 && !("flags" in VA) && !Zge(e, "flags") && Qge(VA, e) ? qge(Xge, e) : r;
}, eme = D$.PROPER, rme = Mc, tme = qa, WA = $j, nme = jn, ame = Jge, Aw = "toString", ome = RegExp.prototype, n6 = ome[Aw], ime = nme(function() {
  return n6.call({ source: "a", flags: "b" }) != "/a/b";
}), sme = eme && n6.name != Aw;
(ime || sme) && rme(RegExp.prototype, Aw, function() {
  var r = tme(this), t = WA(r.source), n = WA(ame(r));
  return "/" + t + "/" + n;
}, { unsafe: !0 });
const Wd = si("switch-track-width"), Ql = si("switch-track-height"), ny = si("switch-track-diff"), lme = Pl.subtract(Wd, Ql), Fx = si("switch-thumb-x"), ume = (e) => {
  const {
    colorScheme: r
  } = e;
  return {
    borderRadius: "full",
    p: "1px",
    width: [Wd.reference],
    height: [Ql.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    bg: Fe("gray.100", "whiteAlpha.400")(e),
    _focus: {
      boxShadow: "none"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      bg: Fe(`${r}.500`, `${r}.200`)(e)
    }
  };
}, cme = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [Ql.reference],
  height: [Ql.reference],
  _checked: {
    transform: `translateX(${Fx.reference})`
  }
}, dme = (e) => ({
  container: {
    [ny.variable]: lme,
    [Fx.variable]: ny.reference,
    _rtl: {
      [Fx.variable]: Pl(ny).negate().toString()
    }
  },
  track: ume(e),
  thumb: cme
}), fme = {
  sm: {
    container: {
      [Wd.variable]: "2.8rem",
      [Ql.variable]: "1.6rem"
    }
  },
  md: {
    container: {
      [Wd.variable]: "3.8rem",
      [Ql.variable]: "2.2rem"
    }
  },
  lg: {
    container: {
      // 50x30
      [Wd.variable]: "4.8rem",
      [Ql.variable]: "2.8rem"
    }
  }
}, vme = {
  size: "md",
  colorScheme: "brand"
}, hme = {
  parts: H0e.keys,
  baseStyle: dme,
  sizes: fme,
  defaultProps: vme
}, ay = si("tooltip-bg"), pme = si("popper-arrow-bg"), gme = (e) => {
  const r = Fe("white", "gray.700")(e);
  return {
    [ay.variable]: `colors.${r}`,
    bg: [ay.reference],
    [pme.variable]: [ay.reference],
    color: Fe("gray", "white")(e),
    px: "8px",
    py: "2px",
    fontWeight: "normal",
    fontSize: "xs",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
    maxW: "320px",
    zIndex: "tooltip"
  };
}, mme = {
  baseStyle: gme
};
var bme = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Badge: S0e,
  Button: P0e,
  Card: F0e,
  baseStyle: Sf,
  Checkbox: X0e,
  Input: sge,
  Modal: bge,
  Popover: Age,
  Radio: Pge,
  Spinner: Nge,
  Steps: Gge,
  Switch: hme,
  Tooltip: mme
});
const yme = {
  base: "0px",
  xs: "320px",
  sm: "480px",
  md: "768px",
  lg: "1024px",
  xl: "1440px"
}, Sme = {
  50: "#FFF0E8",
  100: "#FFD7BF",
  200: "#FFC7A5",
  300: "#FFB080",
  400: "#FF943E",
  500: "#FF6200",
  600: "#EE5601",
  700: "#D54D00",
  800: "#C14600",
  900: "#AC3F01"
}, xme = {
  50: "#E9EDF1",
  100: "#CAD1D9",
  200: "#A9B5C0",
  300: "#8998A7",
  400: "#758595",
  500: "#68717D",
  600: "#495867",
  700: "#3E5061",
  800: "#1E364B",
  900: "#0C2941"
}, $me = {
  50: "#FAFAFA",
  100: "#F1F1F1",
  200: "#E1E1E1",
  300: "#D1D1D1",
  400: "#ACACAC",
  500: "#717171",
  600: "#636363",
  700: "#515151",
  800: "#333333",
  900: "#131313"
}, wme = {
  brand: Sme,
  secondary: xme,
  gray: $me
}, _me = {
  none: "0",
  sm: "0.2rem",
  base: "0.4rem",
  md: "0.6rem",
  lg: "0.8rem",
  xl: "1.2rem",
  "2xl": "1.5rem",
  "3xl": "2.4rem",
  full: "9999px"
}, Tme = {
  // xs: '0 0 0 1px rgba(0, 0, 0, 0.05)',
  // sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  // base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  // md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  // lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  // xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  // '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  // outline: '0 0 0 3px rgba(66, 153, 225, 0.6)',
  // 'outline-md': '0 0 10px rgba(0, 0, 0, 0.1)',
  // inner: 'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
  // none: 'none',
  // 'dark-lg': 'rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px',
  base: "0px 2px 2px rgba(0, 0, 0, 0.1)",
  md: "0px 0px 10px rgba(0, 0, 0, 0.2)",
  lg: "0px 5px 20px rgba(0, 0, 0, 0.2)"
}, a6 = {
  px: "1px",
  0.5: "0.2rem",
  1: "0.4rem",
  1.5: "0.6rem",
  2: "0.8rem",
  2.5: "1rem",
  3: "1.2rem",
  3.5: "1.4rem",
  4: "1.6rem",
  5: "2rem",
  6: "2.4rem",
  7: "2.8rem",
  8: "3.2rem",
  9: "3.6rem",
  10: "4rem",
  12: "4.8rem",
  14: "5.6rem",
  16: "6.4rem",
  20: "8rem",
  24: "9.6rem",
  28: "11.2rem",
  32: "12.8rem",
  36: "14.4rem",
  40: "16rem",
  44: "17.6rem",
  48: "19.2rem",
  52: "20.8rem",
  56: "22.4rem",
  60: "24rem",
  64: "25.6rem",
  72: "28.8rem",
  80: "32rem",
  96: "38.4rem"
}, Cme = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "22.4rem",
  "2xs": "25.6rem",
  xs: "32rem",
  sm: "38.4rem",
  md: "44.8rem",
  lg: "51.2rem",
  xl: "57.6rem",
  "2xl": "67.2rem",
  "3xl": "76.8rem",
  "4xl": "89.6rem",
  "5xl": "102.4rem",
  "6xl": "115.2rem",
  "7xl": "128rem",
  "8xl": "144rem"
}, Eme = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, Ame = Object.assign(Object.assign(Object.assign({}, a6), Cme), {
  container: Eme
}), Ime = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: 'Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: 'Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    xxs: "1.3rem",
    xs: "1.4rem",
    sm: "1.6rem",
    md: "1.8rem",
    lg: "2.0rem",
    xl: "2.2rem",
    "2xl": "2.4rem",
    "3xl": "3.2rem",
    "4xl": "3.6rem",
    "5xl": "4.8rem",
    "6xl": "6rem",
    "7xl": "7.2rem",
    "8xl": "9.6rem",
    "9xl": "12.8rem"
  }
}, Ome = Object.assign(Object.assign({
  radii: _me,
  colors: wme
}, Ime), {
  sizes: Ame,
  space: a6,
  shadows: Tme,
  breakpoints: yme
}), Mme = {
  global: (e) => ({
    html: {
      fontSize: "10px"
    },
    "html, body, #__next": {
      height: "100vh",
      bg: Fe("white", "gray.800")(e)
    }
  })
}, Rme = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "fa-solar"
}, Pme = pP(Object.assign(Object.assign({}, Ome), {
  components: Object.assign({}, bme),
  styles: Mme,
  config: Rme
}), Xte({
  colorScheme: "brand"
}));
var o6 = {
  border: "0px",
  clip: "rect(0px, 0px, 0px, 0px)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
Sa("span", {
  baseStyle: o6
});
Sa("input", {
  baseStyle: o6
});
Sa(Bs.div);
function kme(e, r) {
  return r.forEach(function(t) {
    t && typeof t != "string" && !Array.isArray(t) && Object.keys(t).forEach(function(n) {
      if (n !== "default" && !(n in e)) {
        var a = Object.getOwnPropertyDescriptor(t, n);
        Object.defineProperty(e, n, a.get ? a : {
          enumerable: !0,
          get: function() {
            return t[n];
          }
        });
      }
    });
  }), Object.freeze(e);
}
var Hl = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, Ph = function(e) {
  return e && e.Math == Math && e;
}, _o = (
  // eslint-disable-next-line es/no-global-this -- safe
  Ph(typeof globalThis == "object" && globalThis) || Ph(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Ph(typeof self == "object" && self) || Ph(typeof Hl == "object" && Hl) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Hl || Function("return this")()
), Iw = {}, Ta = function(e) {
  try {
    return !!e();
  } catch (r) {
    return !0;
  }
}, jme = Ta, li = !jme(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] != 7;
}), Dme = Ta, i6 = !Dme(function() {
  var e = function() {
  }.bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), Nme = i6, kh = Function.prototype.call, Pc = Nme ? kh.bind(kh) : function() {
  return kh.apply(kh, arguments);
}, Ow = {}, s6 = {}.propertyIsEnumerable, l6 = Object.getOwnPropertyDescriptor, Lme = l6 && !s6.call({ 1: 2 }, 1);
Ow.f = Lme ? function(r) {
  var t = l6(this, r);
  return !!t && t.enumerable;
} : s6;
var Mw = function(e, r) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: r
  };
}, u6 = i6, c6 = Function.prototype, zx = c6.call, Fme = u6 && c6.bind.bind(zx, zx), To = u6 ? Fme : function(e) {
  return function() {
    return zx.apply(e, arguments);
  };
}, d6 = To, zme = d6({}.toString), Bme = d6("".slice), f6 = function(e) {
  return Bme(zme(e), 8, -1);
}, Ume = To, Vme = Ta, Wme = f6, oy = Object, Hme = Ume("".split), v6 = Vme(function() {
  return !oy("z").propertyIsEnumerable(0);
}) ? function(e) {
  return Wme(e) == "String" ? Hme(e, "") : oy(e);
} : oy, h6 = function(e) {
  return e == null;
}, Gme = h6, Yme = TypeError, p6 = function(e) {
  if (Gme(e))
    throw Yme("Can't call method on " + e);
  return e;
}, Kme = v6, qme = p6, Zf = function(e) {
  return Kme(qme(e));
}, Bx = typeof document == "object" && document.all, Zme = typeof Bx == "undefined" && Bx !== void 0, g6 = {
  all: Bx,
  IS_HTMLDDA: Zme
}, m6 = g6, Qme = m6.all, Nn = m6.IS_HTMLDDA ? function(e) {
  return typeof e == "function" || e === Qme;
} : function(e) {
  return typeof e == "function";
}, HA = Nn, b6 = g6, Xme = b6.all, kc = b6.IS_HTMLDDA ? function(e) {
  return typeof e == "object" ? e !== null : HA(e) || e === Xme;
} : function(e) {
  return typeof e == "object" ? e !== null : HA(e);
}, iy = _o, Jme = Nn, ebe = function(e) {
  return Jme(e) ? e : void 0;
}, Rw = function(e, r) {
  return arguments.length < 2 ? ebe(iy[e]) : iy[e] && iy[e][r];
}, rbe = To, y6 = rbe({}.isPrototypeOf), tbe = typeof navigator != "undefined" && String(navigator.userAgent) || "", S6 = _o, sy = tbe, GA = S6.process, YA = S6.Deno, KA = GA && GA.versions || YA && YA.version, qA = KA && KA.v8, So, C0;
qA && (So = qA.split("."), C0 = So[0] > 0 && So[0] < 4 ? 1 : +(So[0] + So[1]));
!C0 && sy && (So = sy.match(/Edge\/(\d+)/), (!So || So[1] >= 74) && (So = sy.match(/Chrome\/(\d+)/), So && (C0 = +So[1])));
var nbe = C0, ZA = nbe, abe = Ta, obe = _o, ibe = obe.String, x6 = !!Object.getOwnPropertySymbols && !abe(function() {
  var e = Symbol();
  return !ibe(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && ZA && ZA < 41;
}), sbe = x6, $6 = sbe && !Symbol.sham && typeof Symbol.iterator == "symbol", lbe = Rw, ube = Nn, cbe = y6, dbe = $6, fbe = Object, w6 = dbe ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var r = lbe("Symbol");
  return ube(r) && cbe(r.prototype, fbe(e));
}, vbe = String, hbe = function(e) {
  try {
    return vbe(e);
  } catch (r) {
    return "Object";
  }
}, pbe = Nn, gbe = hbe, mbe = TypeError, _6 = function(e) {
  if (pbe(e))
    return e;
  throw mbe(gbe(e) + " is not a function");
}, bbe = _6, ybe = h6, Sbe = function(e, r) {
  var t = e[r];
  return ybe(t) ? void 0 : bbe(t);
}, ly = Pc, uy = Nn, cy = kc, xbe = TypeError, $be = function(e, r) {
  var t, n;
  if (r === "string" && uy(t = e.toString) && !cy(n = ly(t, e)) || uy(t = e.valueOf) && !cy(n = ly(t, e)) || r !== "string" && uy(t = e.toString) && !cy(n = ly(t, e)))
    return n;
  throw xbe("Can't convert object to primitive value");
}, Pw = { exports: {} }, QA = _o, wbe = Object.defineProperty, kw = function(e, r) {
  try {
    wbe(QA, e, { value: r, configurable: !0, writable: !0 });
  } catch (t) {
    QA[e] = r;
  }
  return r;
}, _be = _o, Tbe = kw, XA = "__core-js_shared__", Cbe = _be[XA] || Tbe(XA, {}), jw = Cbe, JA = jw;
(Pw.exports = function(e, r) {
  return JA[e] || (JA[e] = r !== void 0 ? r : {});
})("versions", []).push({
  version: "3.31.0",
  mode: "global",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.31.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var Ebe = p6, Abe = Object, Dw = function(e) {
  return Abe(Ebe(e));
}, Ibe = To, Obe = Dw, Mbe = Ibe({}.hasOwnProperty), ui = Object.hasOwn || function(r, t) {
  return Mbe(Obe(r), t);
}, Rbe = To, Pbe = 0, kbe = Math.random(), jbe = Rbe(1 .toString), T6 = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + jbe(++Pbe + kbe, 36);
}, Dbe = _o, Nbe = Pw.exports, e3 = ui, Lbe = T6, Fbe = x6, zbe = $6, Xu = Dbe.Symbol, dy = Nbe("wks"), Bbe = zbe ? Xu.for || Xu : Xu && Xu.withoutSetter || Lbe, Ws = function(e) {
  return e3(dy, e) || (dy[e] = Fbe && e3(Xu, e) ? Xu[e] : Bbe("Symbol." + e)), dy[e];
}, Ube = Pc, r3 = kc, t3 = w6, Vbe = Sbe, Wbe = $be, Hbe = Ws, Gbe = TypeError, Ybe = Hbe("toPrimitive"), Kbe = function(e, r) {
  if (!r3(e) || t3(e))
    return e;
  var t = Vbe(e, Ybe), n;
  if (t) {
    if (r === void 0 && (r = "default"), n = Ube(t, e, r), !r3(n) || t3(n))
      return n;
    throw Gbe("Can't convert object to primitive value");
  }
  return r === void 0 && (r = "number"), Wbe(e, r);
}, qbe = Kbe, Zbe = w6, C6 = function(e) {
  var r = qbe(e, "string");
  return Zbe(r) ? r : r + "";
}, Qbe = _o, n3 = kc, Ux = Qbe.document, Xbe = n3(Ux) && n3(Ux.createElement), Nw = function(e) {
  return Xbe ? Ux.createElement(e) : {};
}, Jbe = li, e1e = Ta, r1e = Nw, E6 = !Jbe && !e1e(function() {
  return Object.defineProperty(r1e("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
}), t1e = li, n1e = Pc, a1e = Ow, o1e = Mw, i1e = Zf, s1e = C6, l1e = ui, u1e = E6, a3 = Object.getOwnPropertyDescriptor;
Iw.f = t1e ? a3 : function(r, t) {
  if (r = i1e(r), t = s1e(t), u1e)
    try {
      return a3(r, t);
    } catch (n) {
    }
  if (l1e(r, t))
    return o1e(!n1e(a1e.f, r, t), r[t]);
};
var Hs = {}, c1e = li, d1e = Ta, A6 = c1e && d1e(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype != 42;
}), f1e = kc, v1e = String, h1e = TypeError, cu = function(e) {
  if (f1e(e))
    return e;
  throw h1e(v1e(e) + " is not an object");
}, p1e = li, g1e = E6, m1e = A6, jh = cu, o3 = C6, b1e = TypeError, fy = Object.defineProperty, y1e = Object.getOwnPropertyDescriptor, vy = "enumerable", hy = "configurable", py = "writable";
Hs.f = p1e ? m1e ? function(r, t, n) {
  if (jh(r), t = o3(t), jh(n), typeof r == "function" && t === "prototype" && "value" in n && py in n && !n[py]) {
    var a = y1e(r, t);
    a && a[py] && (r[t] = n.value, n = {
      configurable: hy in n ? n[hy] : a[hy],
      enumerable: vy in n ? n[vy] : a[vy],
      writable: !1
    });
  }
  return fy(r, t, n);
} : fy : function(r, t, n) {
  if (jh(r), t = o3(t), jh(n), g1e)
    try {
      return fy(r, t, n);
    } catch (a) {
    }
  if ("get" in n || "set" in n)
    throw b1e("Accessors not supported");
  return "value" in n && (r[t] = n.value), r;
};
var S1e = li, x1e = Hs, $1e = Mw, Zg = S1e ? function(e, r, t) {
  return x1e.f(e, r, $1e(1, t));
} : function(e, r, t) {
  return e[r] = t, e;
}, I6 = { exports: {} }, Vx = li, w1e = ui, O6 = Function.prototype, _1e = Vx && Object.getOwnPropertyDescriptor, Lw = w1e(O6, "name"), T1e = Lw && function() {
}.name === "something", C1e = Lw && (!Vx || Vx && _1e(O6, "name").configurable), Fw = {
  EXISTS: Lw,
  PROPER: T1e,
  CONFIGURABLE: C1e
}, E1e = To, A1e = Nn, Wx = jw, I1e = E1e(Function.toString);
A1e(Wx.inspectSource) || (Wx.inspectSource = function(e) {
  return I1e(e);
});
var O1e = Wx.inspectSource, M1e = _o, R1e = Nn, i3 = M1e.WeakMap, P1e = R1e(i3) && /native code/.test(String(i3)), k1e = Pw.exports, j1e = T6, s3 = k1e("keys"), zw = function(e) {
  return s3[e] || (s3[e] = j1e(e));
}, Bw = {}, D1e = P1e, M6 = _o, N1e = kc, L1e = Zg, gy = ui, my = jw, F1e = zw, z1e = Bw, l3 = "Object already initialized", Hx = M6.TypeError, B1e = M6.WeakMap, E0, xf, A0, U1e = function(e) {
  return A0(e) ? xf(e) : E0(e, {});
}, V1e = function(e) {
  return function(r) {
    var t;
    if (!N1e(r) || (t = xf(r)).type !== e)
      throw Hx("Incompatible receiver, " + e + " required");
    return t;
  };
};
if (D1e || my.state) {
  var Vo = my.state || (my.state = new B1e());
  Vo.get = Vo.get, Vo.has = Vo.has, Vo.set = Vo.set, E0 = function(e, r) {
    if (Vo.has(e))
      throw Hx(l3);
    return r.facade = e, Vo.set(e, r), r;
  }, xf = function(e) {
    return Vo.get(e) || {};
  }, A0 = function(e) {
    return Vo.has(e);
  };
} else {
  var Nu = F1e("state");
  z1e[Nu] = !0, E0 = function(e, r) {
    if (gy(e, Nu))
      throw Hx(l3);
    return r.facade = e, L1e(e, Nu, r), r;
  }, xf = function(e) {
    return gy(e, Nu) ? e[Nu] : {};
  }, A0 = function(e) {
    return gy(e, Nu);
  };
}
var R6 = {
  set: E0,
  get: xf,
  has: A0,
  enforce: U1e,
  getterFor: V1e
}, Uw = To, W1e = Ta, H1e = Nn, Dh = ui, Gx = li, G1e = Fw.CONFIGURABLE, Y1e = O1e, P6 = R6, K1e = P6.enforce, q1e = P6.get, u3 = String, kp = Object.defineProperty, Z1e = Uw("".slice), Q1e = Uw("".replace), X1e = Uw([].join), J1e = Gx && !W1e(function() {
  return kp(function() {
  }, "length", { value: 8 }).length !== 8;
}), eye = String(String).split("String"), rye = I6.exports = function(e, r, t) {
  Z1e(u3(r), 0, 7) === "Symbol(" && (r = "[" + Q1e(u3(r), /^Symbol\(([^)]*)\)/, "$1") + "]"), t && t.getter && (r = "get " + r), t && t.setter && (r = "set " + r), (!Dh(e, "name") || G1e && e.name !== r) && (Gx ? kp(e, "name", { value: r, configurable: !0 }) : e.name = r), J1e && t && Dh(t, "arity") && e.length !== t.arity && kp(e, "length", { value: t.arity });
  try {
    t && Dh(t, "constructor") && t.constructor ? Gx && kp(e, "prototype", { writable: !1 }) : e.prototype && (e.prototype = void 0);
  } catch (a) {
  }
  var n = K1e(e);
  return Dh(n, "source") || (n.source = X1e(eye, typeof r == "string" ? r : "")), e;
};
Function.prototype.toString = rye(function() {
  return H1e(this) && q1e(this).source || Y1e(this);
}, "toString");
var tye = Nn, nye = Hs, aye = I6.exports, oye = kw, Qg = function(e, r, t, n) {
  n || (n = {});
  var a = n.enumerable, i = n.name !== void 0 ? n.name : r;
  if (tye(t) && aye(t, i, n), n.global)
    a ? e[r] = t : oye(r, t);
  else {
    try {
      n.unsafe ? e[r] && (a = !0) : delete e[r];
    } catch (l) {
    }
    a ? e[r] = t : nye.f(e, r, {
      value: t,
      enumerable: !1,
      configurable: !n.nonConfigurable,
      writable: !n.nonWritable
    });
  }
  return e;
}, k6 = {}, iye = Math.ceil, sye = Math.floor, lye = Math.trunc || function(r) {
  var t = +r;
  return (t > 0 ? sye : iye)(t);
}, uye = lye, j6 = function(e) {
  var r = +e;
  return r !== r || r === 0 ? 0 : uye(r);
}, cye = j6, dye = Math.max, fye = Math.min, vye = function(e, r) {
  var t = cye(e);
  return t < 0 ? dye(t + r, 0) : fye(t, r);
}, hye = j6, pye = Math.min, gye = function(e) {
  return e > 0 ? pye(hye(e), 9007199254740991) : 0;
}, mye = gye, bye = function(e) {
  return mye(e.length);
}, yye = Zf, Sye = vye, xye = bye, c3 = function(e) {
  return function(r, t, n) {
    var a = yye(r), i = xye(a), l = Sye(n, i), u;
    if (e && t != t) {
      for (; i > l; )
        if (u = a[l++], u != u)
          return !0;
    } else
      for (; i > l; l++)
        if ((e || l in a) && a[l] === t)
          return e || l || 0;
    return !e && -1;
  };
}, D6 = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: c3(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: c3(!1)
}, $ye = To, by = ui, wye = Zf, _ye = D6.indexOf, Tye = Bw, d3 = $ye([].push), N6 = function(e, r) {
  var t = wye(e), n = 0, a = [], i;
  for (i in t)
    !by(Tye, i) && by(t, i) && d3(a, i);
  for (; r.length > n; )
    by(t, i = r[n++]) && (~_ye(a, i) || d3(a, i));
  return a;
}, Vw = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], Cye = N6, Eye = Vw, Aye = Eye.concat("length", "prototype");
k6.f = Object.getOwnPropertyNames || function(r) {
  return Cye(r, Aye);
};
var Ww = {};
Ww.f = Object.getOwnPropertySymbols;
var Iye = Rw, Oye = To, Mye = k6, Rye = Ww, Pye = cu, kye = Oye([].concat), jye = Iye("Reflect", "ownKeys") || function(r) {
  var t = Mye.f(Pye(r)), n = Rye.f;
  return n ? kye(t, n(r)) : t;
}, f3 = ui, Dye = jye, Nye = Iw, Lye = Hs, Fye = function(e, r, t) {
  for (var n = Dye(r), a = Lye.f, i = Nye.f, l = 0; l < n.length; l++) {
    var u = n[l];
    !f3(e, u) && !(t && f3(t, u)) && a(e, u, i(r, u));
  }
}, zye = Ta, Bye = Nn, Uye = /#|\.prototype\./, Qf = function(e, r) {
  var t = Wye[Vye(e)];
  return t == Gye ? !0 : t == Hye ? !1 : Bye(r) ? zye(r) : !!r;
}, Vye = Qf.normalize = function(e) {
  return String(e).replace(Uye, ".").toLowerCase();
}, Wye = Qf.data = {}, Hye = Qf.NATIVE = "N", Gye = Qf.POLYFILL = "P", Yye = Qf, yy = _o, Kye = Iw.f, qye = Zg, Zye = Qg, Qye = kw, Xye = Fye, Jye = Yye, Hw = function(e, r) {
  var t = e.target, n = e.global, a = e.stat, i, l, u, c, f, h;
  if (n ? l = yy : a ? l = yy[t] || Qye(t, {}) : l = (yy[t] || {}).prototype, l)
    for (u in r) {
      if (f = r[u], e.dontCallGetSet ? (h = Kye(l, u), c = h && h.value) : c = l[u], i = Jye(n ? u : t + (a ? "." : "#") + u, e.forced), !i && c !== void 0) {
        if (typeof f == typeof c)
          continue;
        Xye(f, c);
      }
      (e.sham || c && c.sham) && qye(f, "sham", !0), Zye(l, u, f, e);
    }
}, eSe = N6, rSe = Vw, L6 = Object.keys || function(r) {
  return eSe(r, rSe);
}, v3 = li, tSe = To, nSe = Pc, aSe = Ta, Sy = L6, oSe = Ww, iSe = Ow, sSe = Dw, lSe = v6, Lu = Object.assign, h3 = Object.defineProperty, uSe = tSe([].concat), cSe = !Lu || aSe(function() {
  if (v3 && Lu({ b: 1 }, Lu(h3({}, "a", {
    enumerable: !0,
    get: function() {
      h3(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1)
    return !0;
  var e = {}, r = {}, t = Symbol(), n = "abcdefghijklmnopqrst";
  return e[t] = 7, n.split("").forEach(function(a) {
    r[a] = a;
  }), Lu({}, e)[t] != 7 || Sy(Lu({}, r)).join("") != n;
}) ? function(r, t) {
  for (var n = sSe(r), a = arguments.length, i = 1, l = oSe.f, u = iSe.f; a > i; )
    for (var c = lSe(arguments[i++]), f = l ? uSe(Sy(c), l(c)) : Sy(c), h = f.length, p = 0, g; h > p; )
      g = f[p++], (!v3 || nSe(u, c, g)) && (n[g] = c[g]);
  return n;
} : Lu, dSe = Hw, p3 = cSe;
dSe({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== p3 }, {
  assign: p3
});
var Ut = { exports: {} }, hr = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xf = Symbol.for("react.element"), fSe = Symbol.for("react.portal"), vSe = Symbol.for("react.fragment"), hSe = Symbol.for("react.strict_mode"), pSe = Symbol.for("react.profiler"), gSe = Symbol.for("react.provider"), mSe = Symbol.for("react.context"), bSe = Symbol.for("react.forward_ref"), ySe = Symbol.for("react.suspense"), SSe = Symbol.for("react.memo"), xSe = Symbol.for("react.lazy"), g3 = Symbol.iterator;
function $Se(e) {
  return e === null || typeof e != "object" ? null : (e = g3 && e[g3] || e["@@iterator"], typeof e == "function" ? e : null);
}
var F6 = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, z6 = Object.assign, B6 = {};
function jc(e, r, t) {
  this.props = e, this.context = r, this.refs = B6, this.updater = t || F6;
}
jc.prototype.isReactComponent = {};
jc.prototype.setState = function(e, r) {
  if (typeof e != "object" && typeof e != "function" && e != null)
    throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, e, r, "setState");
};
jc.prototype.forceUpdate = function(e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function U6() {
}
U6.prototype = jc.prototype;
function Gw(e, r, t) {
  this.props = e, this.context = r, this.refs = B6, this.updater = t || F6;
}
var Yw = Gw.prototype = new U6();
Yw.constructor = Gw;
z6(Yw, jc.prototype);
Yw.isPureReactComponent = !0;
var m3 = Array.isArray, V6 = Object.prototype.hasOwnProperty, Kw = { current: null }, W6 = { key: !0, ref: !0, __self: !0, __source: !0 };
function H6(e, r, t) {
  var n, a = {}, i = null, l = null;
  if (r != null)
    for (n in r.ref !== void 0 && (l = r.ref), r.key !== void 0 && (i = "" + r.key), r)
      V6.call(r, n) && !W6.hasOwnProperty(n) && (a[n] = r[n]);
  var u = arguments.length - 2;
  if (u === 1)
    a.children = t;
  else if (1 < u) {
    for (var c = Array(u), f = 0; f < u; f++)
      c[f] = arguments[f + 2];
    a.children = c;
  }
  if (e && e.defaultProps)
    for (n in u = e.defaultProps, u)
      a[n] === void 0 && (a[n] = u[n]);
  return { $$typeof: Xf, type: e, key: i, ref: l, props: a, _owner: Kw.current };
}
function wSe(e, r) {
  return { $$typeof: Xf, type: e.type, key: r, ref: e.ref, props: e.props, _owner: e._owner };
}
function qw(e) {
  return typeof e == "object" && e !== null && e.$$typeof === Xf;
}
function _Se(e) {
  var r = { "=": "=0", ":": "=2" };
  return "$" + e.replace(/[=:]/g, function(t) {
    return r[t];
  });
}
var b3 = /\/+/g;
function xy(e, r) {
  return typeof e == "object" && e !== null && e.key != null ? _Se("" + e.key) : r.toString(36);
}
function jp(e, r, t, n, a) {
  var i = typeof e;
  (i === "undefined" || i === "boolean") && (e = null);
  var l = !1;
  if (e === null)
    l = !0;
  else
    switch (i) {
      case "string":
      case "number":
        l = !0;
        break;
      case "object":
        switch (e.$$typeof) {
          case Xf:
          case fSe:
            l = !0;
        }
    }
  if (l)
    return l = e, a = a(l), e = n === "" ? "." + xy(l, 0) : n, m3(a) ? (t = "", e != null && (t = e.replace(b3, "$&/") + "/"), jp(a, r, t, "", function(f) {
      return f;
    })) : a != null && (qw(a) && (a = wSe(a, t + (!a.key || l && l.key === a.key ? "" : ("" + a.key).replace(b3, "$&/") + "/") + e)), r.push(a)), 1;
  if (l = 0, n = n === "" ? "." : n + ":", m3(e))
    for (var u = 0; u < e.length; u++) {
      i = e[u];
      var c = n + xy(i, u);
      l += jp(i, r, t, c, a);
    }
  else if (c = $Se(e), typeof c == "function")
    for (e = c.call(e), u = 0; !(i = e.next()).done; )
      i = i.value, c = n + xy(i, u++), l += jp(i, r, t, c, a);
  else if (i === "object")
    throw r = String(e), Error("Objects are not valid as a React child (found: " + (r === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
  return l;
}
function Nh(e, r, t) {
  if (e == null)
    return e;
  var n = [], a = 0;
  return jp(e, n, "", "", function(i) {
    return r.call(t, i, a++);
  }), n;
}
function TSe(e) {
  if (e._status === -1) {
    var r = e._result;
    r = r(), r.then(function(t) {
      (e._status === 0 || e._status === -1) && (e._status = 1, e._result = t);
    }, function(t) {
      (e._status === 0 || e._status === -1) && (e._status = 2, e._result = t);
    }), e._status === -1 && (e._status = 0, e._result = r);
  }
  if (e._status === 1)
    return e._result.default;
  throw e._result;
}
var Ln = { current: null }, Dp = { transition: null }, CSe = { ReactCurrentDispatcher: Ln, ReactCurrentBatchConfig: Dp, ReactCurrentOwner: Kw };
hr.Children = { map: Nh, forEach: function(e, r, t) {
  Nh(e, function() {
    r.apply(this, arguments);
  }, t);
}, count: function(e) {
  var r = 0;
  return Nh(e, function() {
    r++;
  }), r;
}, toArray: function(e) {
  return Nh(e, function(r) {
    return r;
  }) || [];
}, only: function(e) {
  if (!qw(e))
    throw Error("React.Children.only expected to receive a single React element child.");
  return e;
} };
hr.Component = jc;
hr.Fragment = vSe;
hr.Profiler = pSe;
hr.PureComponent = Gw;
hr.StrictMode = hSe;
hr.Suspense = ySe;
hr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = CSe;
hr.cloneElement = function(e, r, t) {
  if (e == null)
    throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
  var n = z6({}, e.props), a = e.key, i = e.ref, l = e._owner;
  if (r != null) {
    if (r.ref !== void 0 && (i = r.ref, l = Kw.current), r.key !== void 0 && (a = "" + r.key), e.type && e.type.defaultProps)
      var u = e.type.defaultProps;
    for (c in r)
      V6.call(r, c) && !W6.hasOwnProperty(c) && (n[c] = r[c] === void 0 && u !== void 0 ? u[c] : r[c]);
  }
  var c = arguments.length - 2;
  if (c === 1)
    n.children = t;
  else if (1 < c) {
    u = Array(c);
    for (var f = 0; f < c; f++)
      u[f] = arguments[f + 2];
    n.children = u;
  }
  return { $$typeof: Xf, type: e.type, key: a, ref: i, props: n, _owner: l };
};
hr.createContext = function(e) {
  return e = { $$typeof: mSe, _currentValue: e, _currentValue2: e, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, e.Provider = { $$typeof: gSe, _context: e }, e.Consumer = e;
};
hr.createElement = H6;
hr.createFactory = function(e) {
  var r = H6.bind(null, e);
  return r.type = e, r;
};
hr.createRef = function() {
  return { current: null };
};
hr.forwardRef = function(e) {
  return { $$typeof: bSe, render: e };
};
hr.isValidElement = qw;
hr.lazy = function(e) {
  return { $$typeof: xSe, _payload: { _status: -1, _result: e }, _init: TSe };
};
hr.memo = function(e, r) {
  return { $$typeof: SSe, type: e, compare: r === void 0 ? null : r };
};
hr.startTransition = function(e) {
  var r = Dp.transition;
  Dp.transition = {};
  try {
    e();
  } finally {
    Dp.transition = r;
  }
};
hr.unstable_act = function() {
  throw Error("act(...) is not supported in production builds of React.");
};
hr.useCallback = function(e, r) {
  return Ln.current.useCallback(e, r);
};
hr.useContext = function(e) {
  return Ln.current.useContext(e);
};
hr.useDebugValue = function() {
};
hr.useDeferredValue = function(e) {
  return Ln.current.useDeferredValue(e);
};
hr.useEffect = function(e, r) {
  return Ln.current.useEffect(e, r);
};
hr.useId = function() {
  return Ln.current.useId();
};
hr.useImperativeHandle = function(e, r, t) {
  return Ln.current.useImperativeHandle(e, r, t);
};
hr.useInsertionEffect = function(e, r) {
  return Ln.current.useInsertionEffect(e, r);
};
hr.useLayoutEffect = function(e, r) {
  return Ln.current.useLayoutEffect(e, r);
};
hr.useMemo = function(e, r) {
  return Ln.current.useMemo(e, r);
};
hr.useReducer = function(e, r, t) {
  return Ln.current.useReducer(e, r, t);
};
hr.useRef = function(e) {
  return Ln.current.useRef(e);
};
hr.useState = function(e) {
  return Ln.current.useState(e);
};
hr.useSyncExternalStore = function(e, r, t) {
  return Ln.current.useSyncExternalStore(e, r, t);
};
hr.useTransition = function() {
  return Ln.current.useTransition();
};
hr.version = "18.2.0";
Ut.exports = hr;
var ESe = Ut.exports, y3 = /* @__PURE__ */ kme({
  __proto__: null,
  default: ESe
}, [Ut.exports]);
function ASe(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function ISe(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var OSe = /* @__PURE__ */ function() {
  function e(t) {
    var n = this;
    this._insertTag = function(a) {
      var i;
      n.tags.length === 0 ? n.insertionPoint ? i = n.insertionPoint.nextSibling : n.prepend ? i = n.container.firstChild : i = n.before : i = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(a, i), n.tags.push(a);
    }, this.isSpeedy = t.speedy === void 0 ? !0 : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, r.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(ISe(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = ASe(a);
      try {
        i.insertRule(n, i.cssRules.length);
      } catch (l) {
      }
    } else
      a.appendChild(document.createTextNode(n));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), _n = "-ms-", I0 = "-moz-", Or = "-webkit-", G6 = "comm", Zw = "rule", Qw = "decl", MSe = "@import", Y6 = "@keyframes", RSe = Math.abs, Xg = String.fromCharCode, PSe = Object.assign;
function kSe(e, r) {
  return sn(e, 0) ^ 45 ? (((r << 2 ^ sn(e, 0)) << 2 ^ sn(e, 1)) << 2 ^ sn(e, 2)) << 2 ^ sn(e, 3) : 0;
}
function K6(e) {
  return e.trim();
}
function jSe(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function jr(e, r, t) {
  return e.replace(r, t);
}
function Yx(e, r) {
  return e.indexOf(r);
}
function sn(e, r) {
  return e.charCodeAt(r) | 0;
}
function $f(e, r, t) {
  return e.slice(r, t);
}
function Xo(e) {
  return e.length;
}
function Xw(e) {
  return e.length;
}
function Lh(e, r) {
  return r.push(e), e;
}
function DSe(e, r) {
  return e.map(r).join("");
}
var Jg = 1, xc = 1, q6 = 0, Qn = 0, kt = 0, Dc = "";
function em(e, r, t, n, a, i, l) {
  return { value: e, root: r, parent: t, type: n, props: a, children: i, line: Jg, column: xc, length: l, return: "" };
}
function cd(e, r) {
  return PSe(em("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function NSe() {
  return kt;
}
function LSe() {
  return kt = Qn > 0 ? sn(Dc, --Qn) : 0, xc--, kt === 10 && (xc = 1, Jg--), kt;
}
function ya() {
  return kt = Qn < q6 ? sn(Dc, Qn++) : 0, xc++, kt === 10 && (xc = 1, Jg++), kt;
}
function ai() {
  return sn(Dc, Qn);
}
function Np() {
  return Qn;
}
function Jf(e, r) {
  return $f(Dc, e, r);
}
function wf(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Z6(e) {
  return Jg = xc = 1, q6 = Xo(Dc = e), Qn = 0, [];
}
function Q6(e) {
  return Dc = "", e;
}
function Lp(e) {
  return K6(Jf(Qn - 1, Kx(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function FSe(e) {
  for (; (kt = ai()) && kt < 33; )
    ya();
  return wf(e) > 2 || wf(kt) > 3 ? "" : " ";
}
function zSe(e, r) {
  for (; --r && ya() && !(kt < 48 || kt > 102 || kt > 57 && kt < 65 || kt > 70 && kt < 97); )
    ;
  return Jf(e, Np() + (r < 6 && ai() == 32 && ya() == 32));
}
function Kx(e) {
  for (; ya(); )
    switch (kt) {
      case e:
        return Qn;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Kx(kt);
        break;
      case 40:
        e === 41 && Kx(e);
        break;
      case 92:
        ya();
        break;
    }
  return Qn;
}
function BSe(e, r) {
  for (; ya() && e + kt !== 47 + 10; )
    if (e + kt === 42 + 42 && ai() === 47)
      break;
  return "/*" + Jf(r, Qn - 1) + "*" + Xg(e === 47 ? e : ya());
}
function USe(e) {
  for (; !wf(ai()); )
    ya();
  return Jf(e, Qn);
}
function S3(e) {
  return Q6(Fp("", null, null, null, [""], e = Z6(e), 0, [0], e));
}
function Fp(e, r, t, n, a, i, l, u, c) {
  for (var f = 0, h = 0, p = l, g = 0, y = 0, S = 0, x = 1, T = 1, A = 1, O = 0, P = "", j = a, k = i, L = n, M = P; T; )
    switch (S = O, O = ya()) {
      case 40:
        if (S != 108 && sn(M, p - 1) == 58) {
          Yx(M += jr(Lp(O), "&", "&\f"), "&\f") != -1 && (A = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        M += Lp(O);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        M += FSe(S);
        break;
      case 92:
        M += zSe(Np() - 1, 7);
        continue;
      case 47:
        switch (ai()) {
          case 42:
          case 47:
            Lh(VSe(BSe(ya(), Np()), r, t), c);
            break;
          default:
            M += "/";
        }
        break;
      case 123 * x:
        u[f++] = Xo(M) * A;
      case 125 * x:
      case 59:
      case 0:
        switch (O) {
          case 0:
          case 125:
            T = 0;
          case 59 + h:
            y > 0 && Xo(M) - p && Lh(y > 32 ? $3(M + ";", n, t, p - 1) : $3(jr(M, " ", "") + ";", n, t, p - 2), c);
            break;
          case 59:
            M += ";";
          default:
            if (Lh(L = x3(M, r, t, f, h, a, u, P, j = [], k = [], p), i), O === 123)
              if (h === 0)
                Fp(M, r, L, L, j, i, p, u, k);
              else
                switch (g === 99 && sn(M, 3) === 110 ? 100 : g) {
                  case 100:
                  case 109:
                  case 115:
                    Fp(e, L, L, n && Lh(x3(e, L, L, 0, 0, a, u, P, a, j = [], p), k), a, k, p, u, n ? j : k);
                    break;
                  default:
                    Fp(M, L, L, L, [""], k, 0, u, k);
                }
        }
        f = h = y = 0, x = A = 1, P = M = "", p = l;
        break;
      case 58:
        p = 1 + Xo(M), y = S;
      default:
        if (x < 1) {
          if (O == 123)
            --x;
          else if (O == 125 && x++ == 0 && LSe() == 125)
            continue;
        }
        switch (M += Xg(O), O * x) {
          case 38:
            A = h > 0 ? 1 : (M += "\f", -1);
            break;
          case 44:
            u[f++] = (Xo(M) - 1) * A, A = 1;
            break;
          case 64:
            ai() === 45 && (M += Lp(ya())), g = ai(), h = p = Xo(P = M += USe(Np())), O++;
            break;
          case 45:
            S === 45 && Xo(M) == 2 && (x = 0);
        }
    }
  return i;
}
function x3(e, r, t, n, a, i, l, u, c, f, h) {
  for (var p = a - 1, g = a === 0 ? i : [""], y = Xw(g), S = 0, x = 0, T = 0; S < n; ++S)
    for (var A = 0, O = $f(e, p + 1, p = RSe(x = l[S])), P = e; A < y; ++A)
      (P = K6(x > 0 ? g[A] + " " + O : jr(O, /&\f/g, g[A]))) && (c[T++] = P);
  return em(e, r, t, a === 0 ? Zw : u, c, f, h);
}
function VSe(e, r, t) {
  return em(e, r, t, G6, Xg(NSe()), $f(e, 2, -2), 0);
}
function $3(e, r, t, n) {
  return em(e, r, t, Qw, $f(e, 0, n), $f(e, n + 1, -1), n);
}
function Xl(e, r) {
  for (var t = "", n = Xw(e), a = 0; a < n; a++)
    t += r(e[a], a, e, r) || "";
  return t;
}
function w3(e, r, t, n) {
  switch (e.type) {
    case MSe:
    case Qw:
      return e.return = e.return || e.value;
    case G6:
      return "";
    case Y6:
      return e.return = e.value + "{" + Xl(e.children, n) + "}";
    case Zw:
      e.value = e.props.join(",");
  }
  return Xo(t = Xl(e.children, n)) ? e.return = e.value + "{" + t + "}" : "";
}
function _3(e) {
  var r = Xw(e);
  return function(t, n, a, i) {
    for (var l = "", u = 0; u < r; u++)
      l += e[u](t, n, a, i) || "";
    return l;
  };
}
function WSe(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
var HSe = function(r) {
  var t = /* @__PURE__ */ new WeakMap();
  return function(n) {
    if (t.has(n))
      return t.get(n);
    var a = r(n);
    return t.set(n, a), a;
  };
};
function Jw(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var GSe = function(r, t, n) {
  for (var a = 0, i = 0; a = i, i = ai(), a === 38 && i === 12 && (t[n] = 1), !wf(i); )
    ya();
  return Jf(r, Qn);
}, YSe = function(r, t) {
  var n = -1, a = 44;
  do
    switch (wf(a)) {
      case 0:
        a === 38 && ai() === 12 && (t[n] = 1), r[n] += GSe(Qn - 1, t, n);
        break;
      case 2:
        r[n] += Lp(a);
        break;
      case 4:
        if (a === 44) {
          r[++n] = ai() === 58 ? "&\f" : "", t[n] = r[n].length;
          break;
        }
      default:
        r[n] += Xg(a);
    }
  while (a = ya());
  return r;
}, KSe = function(r, t) {
  return Q6(YSe(Z6(r), t));
}, T3 = /* @__PURE__ */ new WeakMap(), qSe = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, n = r.parent, a = r.column === n.column && r.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !T3.get(n)) && !a) {
      T3.set(r, !0);
      for (var i = [], l = KSe(t, i), u = n.props, c = 0, f = 0; c < l.length; c++)
        for (var h = 0; h < u.length; h++, f++)
          r.props[f] = i[c] ? l[c].replace(/&\f/g, u[h]) : u[h] + " " + l[c];
    }
  }
}, ZSe = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
};
function X6(e, r) {
  switch (kSe(e, r)) {
    case 5103:
      return Or + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Or + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Or + e + I0 + e + _n + e + e;
    case 6828:
    case 4268:
      return Or + e + _n + e + e;
    case 6165:
      return Or + e + _n + "flex-" + e + e;
    case 5187:
      return Or + e + jr(e, /(\w+).+(:[^]+)/, Or + "box-$1$2" + _n + "flex-$1$2") + e;
    case 5443:
      return Or + e + _n + "flex-item-" + jr(e, /flex-|-self/, "") + e;
    case 4675:
      return Or + e + _n + "flex-line-pack" + jr(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Or + e + _n + jr(e, "shrink", "negative") + e;
    case 5292:
      return Or + e + _n + jr(e, "basis", "preferred-size") + e;
    case 6060:
      return Or + "box-" + jr(e, "-grow", "") + Or + e + _n + jr(e, "grow", "positive") + e;
    case 4554:
      return Or + jr(e, /([^-])(transform)/g, "$1" + Or + "$2") + e;
    case 6187:
      return jr(jr(jr(e, /(zoom-|grab)/, Or + "$1"), /(image-set)/, Or + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return jr(e, /(image-set\([^]*)/, Or + "$1$`$1");
    case 4968:
      return jr(jr(e, /(.+:)(flex-)?(.*)/, Or + "box-pack:$3" + _n + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Or + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return jr(e, /(.+)-inline(.+)/, Or + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Xo(e) - 1 - r > 6)
        switch (sn(e, r + 1)) {
          case 109:
            if (sn(e, r + 4) !== 45)
              break;
          case 102:
            return jr(e, /(.+:)(.+)-([^]+)/, "$1" + Or + "$2-$3$1" + I0 + (sn(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~Yx(e, "stretch") ? X6(jr(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (sn(e, r + 1) !== 115)
        break;
    case 6444:
      switch (sn(e, Xo(e) - 3 - (~Yx(e, "!important") && 10))) {
        case 107:
          return jr(e, ":", ":" + Or) + e;
        case 101:
          return jr(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Or + (sn(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Or + "$2$3$1" + _n + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (sn(e, r + 11)) {
        case 114:
          return Or + e + _n + jr(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Or + e + _n + jr(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Or + e + _n + jr(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Or + e + _n + e + e;
  }
  return e;
}
var QSe = function(r, t, n, a) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case Qw:
        r.return = X6(r.value, r.length);
        break;
      case Y6:
        return Xl([cd(r, {
          value: jr(r.value, "@", "@" + Or)
        })], a);
      case Zw:
        if (r.length)
          return DSe(r.props, function(i) {
            switch (jSe(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Xl([cd(r, {
                  props: [jr(i, /:(read-\w+)/, ":" + I0 + "$1")]
                })], a);
              case "::placeholder":
                return Xl([cd(r, {
                  props: [jr(i, /:(plac\w+)/, ":" + Or + "input-$1")]
                }), cd(r, {
                  props: [jr(i, /:(plac\w+)/, ":" + I0 + "$1")]
                }), cd(r, {
                  props: [jr(i, /:(plac\w+)/, _n + "input-$1")]
                })], a);
            }
            return "";
          });
    }
}, zp = typeof document != "undefined", XSe = zp ? void 0 : HSe(function() {
  return Jw(function() {
    var e = {};
    return function(r) {
      return e[r];
    };
  });
}), JSe = [QSe], J6 = function(r) {
  var t = r.key;
  if (zp && t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(j) {
      var k = j.getAttribute("data-emotion");
      k.indexOf(" ") !== -1 && (document.head.appendChild(j), j.setAttribute("data-s", ""));
    });
  }
  var a = r.stylisPlugins || JSe, i = {}, l, u = [];
  zp && (l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(j) {
      for (var k = j.getAttribute("data-emotion").split(" "), L = 1; L < k.length; L++)
        i[k[L]] = !0;
      u.push(j);
    }
  ));
  var c, f = [qSe, ZSe];
  if (zp) {
    var h, p = [w3, WSe(function(j) {
      h.insert(j);
    })], g = _3(f.concat(a, p)), y = function(k) {
      return Xl(S3(k), g);
    };
    c = function(k, L, M, W) {
      h = M, y(k ? k + "{" + L.styles + "}" : L.styles), W && (P.inserted[L.name] = !0);
    };
  } else {
    var S = [w3], x = _3(f.concat(a, S)), T = function(k) {
      return Xl(S3(k), x);
    }, A = XSe(a)(t), O = function(k, L) {
      var M = L.name;
      return A[M] === void 0 && (A[M] = T(k ? k + "{" + L.styles + "}" : L.styles)), A[M];
    };
    c = function(k, L, M, W) {
      var q = L.name, oe = O(k, L);
      if (P.compat === void 0)
        return W && (P.inserted[q] = !0), oe;
      if (W)
        P.inserted[q] = oe;
      else
        return oe;
    };
  }
  var P = {
    key: t,
    sheet: new OSe({
      key: t,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return P.sheet.hydrate(u), P;
};
function qx() {
  return qx = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, qx.apply(this, arguments);
}
var e8 = { exports: {} }, Wr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xt = typeof Symbol == "function" && Symbol.for, e_ = Xt ? Symbol.for("react.element") : 60103, r_ = Xt ? Symbol.for("react.portal") : 60106, rm = Xt ? Symbol.for("react.fragment") : 60107, tm = Xt ? Symbol.for("react.strict_mode") : 60108, nm = Xt ? Symbol.for("react.profiler") : 60114, am = Xt ? Symbol.for("react.provider") : 60109, om = Xt ? Symbol.for("react.context") : 60110, t_ = Xt ? Symbol.for("react.async_mode") : 60111, im = Xt ? Symbol.for("react.concurrent_mode") : 60111, sm = Xt ? Symbol.for("react.forward_ref") : 60112, lm = Xt ? Symbol.for("react.suspense") : 60113, exe = Xt ? Symbol.for("react.suspense_list") : 60120, um = Xt ? Symbol.for("react.memo") : 60115, cm = Xt ? Symbol.for("react.lazy") : 60116, rxe = Xt ? Symbol.for("react.block") : 60121, txe = Xt ? Symbol.for("react.fundamental") : 60117, nxe = Xt ? Symbol.for("react.responder") : 60118, axe = Xt ? Symbol.for("react.scope") : 60119;
function Ca(e) {
  if (typeof e == "object" && e !== null) {
    var r = e.$$typeof;
    switch (r) {
      case e_:
        switch (e = e.type, e) {
          case t_:
          case im:
          case rm:
          case nm:
          case tm:
          case lm:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case om:
              case sm:
              case cm:
              case um:
              case am:
                return e;
              default:
                return r;
            }
        }
      case r_:
        return r;
    }
  }
}
function r8(e) {
  return Ca(e) === im;
}
Wr.AsyncMode = t_;
Wr.ConcurrentMode = im;
Wr.ContextConsumer = om;
Wr.ContextProvider = am;
Wr.Element = e_;
Wr.ForwardRef = sm;
Wr.Fragment = rm;
Wr.Lazy = cm;
Wr.Memo = um;
Wr.Portal = r_;
Wr.Profiler = nm;
Wr.StrictMode = tm;
Wr.Suspense = lm;
Wr.isAsyncMode = function(e) {
  return r8(e) || Ca(e) === t_;
};
Wr.isConcurrentMode = r8;
Wr.isContextConsumer = function(e) {
  return Ca(e) === om;
};
Wr.isContextProvider = function(e) {
  return Ca(e) === am;
};
Wr.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === e_;
};
Wr.isForwardRef = function(e) {
  return Ca(e) === sm;
};
Wr.isFragment = function(e) {
  return Ca(e) === rm;
};
Wr.isLazy = function(e) {
  return Ca(e) === cm;
};
Wr.isMemo = function(e) {
  return Ca(e) === um;
};
Wr.isPortal = function(e) {
  return Ca(e) === r_;
};
Wr.isProfiler = function(e) {
  return Ca(e) === nm;
};
Wr.isStrictMode = function(e) {
  return Ca(e) === tm;
};
Wr.isSuspense = function(e) {
  return Ca(e) === lm;
};
Wr.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === rm || e === im || e === nm || e === tm || e === lm || e === exe || typeof e == "object" && e !== null && (e.$$typeof === cm || e.$$typeof === um || e.$$typeof === am || e.$$typeof === om || e.$$typeof === sm || e.$$typeof === txe || e.$$typeof === nxe || e.$$typeof === axe || e.$$typeof === rxe);
};
Wr.typeOf = Ca;
e8.exports = Wr;
var t8 = e8.exports, oxe = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, ixe = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, n8 = {};
n8[t8.ForwardRef] = oxe;
n8[t8.Memo] = ixe;
var Zx = typeof document != "undefined";
function sxe(e, r, t) {
  var n = "";
  return t.split(" ").forEach(function(a) {
    e[a] !== void 0 ? r.push(e[a] + ";") : n += a + " ";
  }), n;
}
var a8 = function(r, t, n) {
  var a = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Zx === !1 && r.compat !== void 0) && r.registered[a] === void 0 && (r.registered[a] = t.styles);
}, lxe = function(r, t, n) {
  a8(r, t, n);
  var a = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var i = "", l = t;
    do {
      var u = r.insert(t === l ? "." + a : "", l, r.sheet, !0);
      !Zx && u !== void 0 && (i += u), l = l.next;
    } while (l !== void 0);
    if (!Zx && i.length !== 0)
      return i;
  }
};
function uxe(e) {
  for (var r = 0, t, n = 0, a = e.length; a >= 4; ++n, a -= 4)
    t = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      r ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(n) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var cxe = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, dxe = /[A-Z]|^ms/g, fxe = /_EMO_([^_]+?)_([^]*?)_EMO_/g, o8 = function(r) {
  return r.charCodeAt(1) === 45;
}, C3 = function(r) {
  return r != null && typeof r != "boolean";
}, $y = /* @__PURE__ */ Jw(function(e) {
  return o8(e) ? e : e.replace(dxe, "-$&").toLowerCase();
}), E3 = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(fxe, function(n, a, i) {
          return Jo = {
            name: a,
            styles: i,
            next: Jo
          }, a;
        });
  }
  return cxe[r] !== 1 && !o8(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
function _f(e, r, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0)
    return t;
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return Jo = {
          name: t.name,
          styles: t.styles,
          next: Jo
        }, t.name;
      if (t.styles !== void 0) {
        var n = t.next;
        if (n !== void 0)
          for (; n !== void 0; )
            Jo = {
              name: n.name,
              styles: n.styles,
              next: Jo
            }, n = n.next;
        var a = t.styles + ";";
        return a;
      }
      return vxe(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var i = Jo, l = t(e);
        return Jo = i, _f(e, r, l);
      }
      break;
    }
  }
  if (r == null)
    return t;
  var u = r[t];
  return u !== void 0 ? u : t;
}
function vxe(e, r, t) {
  var n = "";
  if (Array.isArray(t))
    for (var a = 0; a < t.length; a++)
      n += _f(e, r, t[a]) + ";";
  else
    for (var i in t) {
      var l = t[i];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? n += i + "{" + r[l] + "}" : C3(l) && (n += $y(i) + ":" + E3(i, l) + ";");
      else if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
        for (var u = 0; u < l.length; u++)
          C3(l[u]) && (n += $y(i) + ":" + E3(i, l[u]) + ";");
      else {
        var c = _f(e, r, l);
        switch (i) {
          case "animation":
          case "animationName": {
            n += $y(i) + ":" + c + ";";
            break;
          }
          default:
            n += i + "{" + c + "}";
        }
      }
    }
  return n;
}
var A3 = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Jo, i8 = function(r, t, n) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var a = !0, i = "";
  Jo = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (a = !1, i += _f(n, t, l)) : i += l[0];
  for (var u = 1; u < r.length; u++)
    i += _f(n, t, r[u]), a && (i += l[u]);
  A3.lastIndex = 0;
  for (var c = "", f; (f = A3.exec(i)) !== null; )
    c += "-" + // $FlowFixMe we know it's not null
    f[1];
  var h = uxe(i) + c;
  return {
    name: h,
    styles: i,
    next: Jo
  };
}, hxe = typeof document != "undefined", I3 = function(r) {
  return r();
}, s8 = y3["useInsertionEffect"] ? y3["useInsertionEffect"] : !1, pxe = hxe && s8 || I3;
s8 || Ut.exports.useLayoutEffect;
var gxe = typeof document != "undefined", O0 = /* @__PURE__ */ Ut.exports.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement != "undefined" ? /* @__PURE__ */ J6({
    key: "css"
  }) : null
);
O0.Provider;
var l8 = function(r) {
  return /* @__PURE__ */ Ut.exports.forwardRef(function(t, n) {
    var a = Ut.exports.useContext(O0);
    return r(t, a, n);
  });
};
gxe || (l8 = function(r) {
  return function(t) {
    var n = Ut.exports.useContext(O0);
    return n === null ? (n = J6({
      key: "css"
    }), /* @__PURE__ */ Ut.exports.createElement(O0.Provider, {
      value: n
    }, r(t, n))) : r(t, n);
  };
});
var mxe = /* @__PURE__ */ Ut.exports.createContext({});
function bxe() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return i8(r);
}
var yxe = function() {
  var r = bxe.apply(void 0, arguments), t = "animation-" + r.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + r.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, Qx = { exports: {} };
(function(e, r) {
  var t = 200, n = "__lodash_hash_undefined__", a = 800, i = 16, l = 9007199254740991, u = "[object Arguments]", c = "[object Array]", f = "[object AsyncFunction]", h = "[object Boolean]", p = "[object Date]", g = "[object Error]", y = "[object Function]", S = "[object GeneratorFunction]", x = "[object Map]", T = "[object Number]", A = "[object Null]", O = "[object Object]", P = "[object Proxy]", j = "[object RegExp]", k = "[object Set]", L = "[object String]", M = "[object Undefined]", W = "[object WeakMap]", q = "[object ArrayBuffer]", oe = "[object DataView]", Ae = "[object Float32Array]", Te = "[object Float64Array]", $e = "[object Int8Array]", Ee = "[object Int16Array]", ze = "[object Int32Array]", Ke = "[object Uint8Array]", Be = "[object Uint8ClampedArray]", ue = "[object Uint16Array]", he = "[object Uint32Array]", _e = /[\\^$.*+?()[\]{}|]/g, Oe = /^\[object .+?Constructor\]$/, Me = /^(?:0|[1-9]\d*)$/, Z = {};
  Z[Ae] = Z[Te] = Z[$e] = Z[Ee] = Z[ze] = Z[Ke] = Z[Be] = Z[ue] = Z[he] = !0, Z[u] = Z[c] = Z[q] = Z[h] = Z[oe] = Z[p] = Z[g] = Z[y] = Z[x] = Z[T] = Z[O] = Z[j] = Z[k] = Z[L] = Z[W] = !1;
  var se = typeof Hl == "object" && Hl && Hl.Object === Object && Hl, te = typeof self == "object" && self && self.Object === Object && self, fe = se || te || Function("return this")(), je = r && !r.nodeType && r, ve = je && !0 && e && !e.nodeType && e, rr = ve && ve.exports === je, br = rr && se.process, ur = function() {
    try {
      var v = ve && ve.require && ve.require("util").types;
      return v || br && br.binding && br.binding("util");
    } catch (b) {
    }
  }(), $r = ur && ur.isTypedArray;
  function Qe(v, b, $) {
    switch ($.length) {
      case 0:
        return v.call(b);
      case 1:
        return v.call(b, $[0]);
      case 2:
        return v.call(b, $[0], $[1]);
      case 3:
        return v.call(b, $[0], $[1], $[2]);
    }
    return v.apply(b, $);
  }
  function yr(v, b) {
    for (var $ = -1, N = Array(v); ++$ < v; )
      N[$] = b($);
    return N;
  }
  function at(v) {
    return function(b) {
      return v(b);
    };
  }
  function Zr(v, b) {
    return v == null ? void 0 : v[b];
  }
  function Nr(v, b) {
    return function($) {
      return v(b($));
    };
  }
  var jt = Array.prototype, mt = Function.prototype, gr = Object.prototype, Sr = fe["__core-js_shared__"], G = mt.toString, ne = gr.hasOwnProperty, Y = function() {
    var v = /[^.]+$/.exec(Sr && Sr.keys && Sr.keys.IE_PROTO || "");
    return v ? "Symbol(src)_1." + v : "";
  }(), Q = gr.toString, we = G.call(Object), be = RegExp(
    "^" + G.call(ne).replace(_e, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Re = rr ? fe.Buffer : void 0, cr = fe.Symbol, wr = fe.Uint8Array, lr = Re ? Re.allocUnsafe : void 0, dt = Nr(Object.getPrototypeOf, Object), ot = Object.create, bt = gr.propertyIsEnumerable, Ct = jt.splice, fr = cr ? cr.toStringTag : void 0, Qr = function() {
    try {
      var v = zn(Object, "defineProperty");
      return v({}, "", {}), v;
    } catch (b) {
    }
  }(), vn = Re ? Re.isBuffer : void 0, hn = Math.max, Za = Date.now, Cn = zn(fe, "Map"), ge = zn(Object, "create"), De = function() {
    function v() {
    }
    return function(b) {
      if (!Xr(b))
        return {};
      if (ot)
        return ot(b);
      v.prototype = b;
      var $ = new v();
      return v.prototype = void 0, $;
    };
  }();
  function tr(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Dt() {
    this.__data__ = ge ? ge(null) : {}, this.size = 0;
  }
  function it(v) {
    var b = this.has(v) && delete this.__data__[v];
    return this.size -= b ? 1 : 0, b;
  }
  function Fn(v) {
    var b = this.__data__;
    if (ge) {
      var $ = b[v];
      return $ === n ? void 0 : $;
    }
    return ne.call(b, v) ? b[v] : void 0;
  }
  function Se(v) {
    var b = this.__data__;
    return ge ? b[v] !== void 0 : ne.call(b, v);
  }
  function Ce(v, b) {
    var $ = this.__data__;
    return this.size += this.has(v) ? 0 : 1, $[v] = ge && b === void 0 ? n : b, this;
  }
  tr.prototype.clear = Dt, tr.prototype.delete = it, tr.prototype.get = Fn, tr.prototype.has = Se, tr.prototype.set = Ce;
  function ye(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Pe() {
    this.__data__ = [], this.size = 0;
  }
  function nr(v) {
    var b = this.__data__, $ = Nt(b, v);
    if ($ < 0)
      return !1;
    var N = b.length - 1;
    return $ == N ? b.pop() : Ct.call(b, $, 1), --this.size, !0;
  }
  function Hr(v) {
    var b = this.__data__, $ = Nt(b, v);
    return $ < 0 ? void 0 : b[$][1];
  }
  function Jt(v) {
    return Nt(this.__data__, v) > -1;
  }
  function en(v, b) {
    var $ = this.__data__, N = Nt($, v);
    return N < 0 ? (++this.size, $.push([v, b])) : $[N][1] = b, this;
  }
  ye.prototype.clear = Pe, ye.prototype.delete = nr, ye.prototype.get = Hr, ye.prototype.has = Jt, ye.prototype.set = en;
  function Rr(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Qa() {
    this.size = 0, this.__data__ = {
      hash: new tr(),
      map: new (Cn || ye)(),
      string: new tr()
    };
  }
  function Ks(v) {
    var b = mn(this, v).delete(v);
    return this.size -= b ? 1 : 0, b;
  }
  function qs(v) {
    return mn(this, v).get(v);
  }
  function Zs(v) {
    return mn(this, v).has(v);
  }
  function Qs(v, b) {
    var $ = mn(this, v), N = $.size;
    return $.set(v, b), this.size += $.size == N ? 0 : 1, this;
  }
  Rr.prototype.clear = Qa, Rr.prototype.delete = Ks, Rr.prototype.get = qs, Rr.prototype.has = Zs, Rr.prototype.set = Qs;
  function yt(v) {
    var b = this.__data__ = new ye(v);
    this.size = b.size;
  }
  function Xs() {
    this.__data__ = new ye(), this.size = 0;
  }
  function Js(v) {
    var b = this.__data__, $ = b.delete(v);
    return this.size = b.size, $;
  }
  function el(v) {
    return this.__data__.get(v);
  }
  function rl(v) {
    return this.__data__.has(v);
  }
  function tl(v, b) {
    var $ = this.__data__;
    if ($ instanceof ye) {
      var N = $.__data__;
      if (!Cn || N.length < t - 1)
        return N.push([v, b]), this.size = ++$.size, this;
      $ = this.__data__ = new Rr(N);
    }
    return $.set(v, b), this.size = $.size, this;
  }
  yt.prototype.clear = Xs, yt.prototype.delete = Js, yt.prototype.get = el, yt.prototype.has = rl, yt.prototype.set = tl;
  function nl(v, b) {
    var $ = na(v), N = !$ && ta(v), ie = !$ && !N && Mo(v), pe = !$ && !N && !ie && Po(v), ce = $ || N || ie || pe, ae = ce ? yr(v.length, String) : [], me = ae.length;
    for (var ar in v)
      (b || ne.call(v, ar)) && !(ce && // Safari 9 has enumerable `arguments.length` in strict mode.
      (ar == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      ie && (ar == "offset" || ar == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      pe && (ar == "buffer" || ar == "byteLength" || ar == "byteOffset") || // Skip index properties.
      Oo(ar, me))) && ae.push(ar);
    return ae;
  }
  function pn(v, b, $) {
    ($ !== void 0 && !bn(v[b], $) || $ === void 0 && !(b in v)) && ra(v, b, $);
  }
  function al(v, b, $) {
    var N = v[b];
    (!(ne.call(v, b) && bn(N, $)) || $ === void 0 && !(b in v)) && ra(v, b, $);
  }
  function Nt(v, b) {
    for (var $ = v.length; $--; )
      if (bn(v[$][0], b))
        return $;
    return -1;
  }
  function ra(v, b, $) {
    b == "__proto__" && Qr ? Qr(v, b, {
      configurable: !0,
      enumerable: !0,
      value: $,
      writable: !0
    }) : v[b] = $;
  }
  var ol = Zi();
  function gn(v) {
    return v == null ? v === void 0 ? M : A : fr && fr in Object(v) ? Qi(v) : es(v);
  }
  function Xa(v) {
    return Lt(v) && gn(v) == u;
  }
  function Wi(v) {
    if (!Xr(v) || hi(v))
      return !1;
    var b = aa(v) ? be : Oe;
    return b.test(ns(v));
  }
  function Hi(v) {
    return Lt(v) && Ro(v.length) && !!Z[gn(v)];
  }
  function il(v) {
    if (!Xr(v))
      return Ji(v);
    var b = En(v), $ = [];
    for (var N in v)
      N == "constructor" && (b || !ne.call(v, N)) || $.push(N);
    return $;
  }
  function Ao(v, b, $, N, ie) {
    v !== b && ol(b, function(pe, ce) {
      if (ie || (ie = new yt()), Xr(pe))
        sl(v, b, ce, $, Ao, N, ie);
      else {
        var ae = N ? N(Bn(v, ce), pe, ce + "", v, b, ie) : void 0;
        ae === void 0 && (ae = pe), pn(v, ce, ae);
      }
    }, ko);
  }
  function sl(v, b, $, N, ie, pe, ce) {
    var ae = Bn(v, $), me = Bn(b, $), ar = ce.get(me);
    if (ar) {
      pn(v, $, ar);
      return;
    }
    var qe = pe ? pe(ae, me, $ + "", v, b, ce) : void 0, Pr = qe === void 0;
    if (Pr) {
      var Vn = na(me), Wn = !Vn && Mo(me), Ja = !Vn && !Wn && Po(me);
      qe = me, Vn || Wn || Ja ? na(ae) ? qe = ae : dl(ae) ? qe = ul(ae) : Wn ? (Pr = !1, qe = Yi(me, !0)) : Ja ? (Pr = !1, qe = di(me, !0)) : qe = [] : fl(me) || ta(me) ? (qe = ae, ta(ae) ? qe = vl(ae) : (!Xr(ae) || aa(ae)) && (qe = fi(me))) : Pr = !1;
    }
    Pr && (ce.set(me, qe), ie(qe, me, N, pe, ce), ce.delete(me)), pn(v, $, qe);
  }
  function ll(v, b) {
    return rs(cl(v, b, jo), v + "");
  }
  var Gi = Qr ? function(v, b) {
    return Qr(v, "toString", {
      configurable: !0,
      enumerable: !1,
      value: xr(b),
      writable: !0
    });
  } : jo;
  function Yi(v, b) {
    if (b)
      return v.slice();
    var $ = v.length, N = lr ? lr($) : new v.constructor($);
    return v.copy(N), N;
  }
  function Ki(v) {
    var b = new v.constructor(v.byteLength);
    return new wr(b).set(new wr(v)), b;
  }
  function di(v, b) {
    var $ = b ? Ki(v.buffer) : v.buffer;
    return new v.constructor($, v.byteOffset, v.length);
  }
  function ul(v, b) {
    var $ = -1, N = v.length;
    for (b || (b = Array(N)); ++$ < N; )
      b[$] = v[$];
    return b;
  }
  function qi(v, b, $, N) {
    var ie = !$;
    $ || ($ = {});
    for (var pe = -1, ce = b.length; ++pe < ce; ) {
      var ae = b[pe], me = N ? N($[ae], v[ae], ae, $, v) : void 0;
      me === void 0 && (me = v[ae]), ie ? ra($, ae, me) : al($, ae, me);
    }
    return $;
  }
  function Io(v) {
    return ll(function(b, $) {
      var N = -1, ie = $.length, pe = ie > 1 ? $[ie - 1] : void 0, ce = ie > 2 ? $[2] : void 0;
      for (pe = v.length > 3 && typeof pe == "function" ? (ie--, pe) : void 0, ce && Xi($[0], $[1], ce) && (pe = ie < 3 ? void 0 : pe, ie = 1), b = Object(b); ++N < ie; ) {
        var ae = $[N];
        ae && v(b, ae, N, pe);
      }
      return b;
    });
  }
  function Zi(v) {
    return function(b, $, N) {
      for (var ie = -1, pe = Object(b), ce = N(b), ae = ce.length; ae--; ) {
        var me = ce[v ? ae : ++ie];
        if ($(pe[me], me, pe) === !1)
          break;
      }
      return b;
    };
  }
  function mn(v, b) {
    var $ = v.__data__;
    return vi(b) ? $[typeof b == "string" ? "string" : "hash"] : $.map;
  }
  function zn(v, b) {
    var $ = Zr(v, b);
    return Wi($) ? $ : void 0;
  }
  function Qi(v) {
    var b = ne.call(v, fr), $ = v[fr];
    try {
      v[fr] = void 0;
      var N = !0;
    } catch (pe) {
    }
    var ie = Q.call(v);
    return N && (b ? v[fr] = $ : delete v[fr]), ie;
  }
  function fi(v) {
    return typeof v.constructor == "function" && !En(v) ? De(dt(v)) : {};
  }
  function Oo(v, b) {
    var $ = typeof v;
    return b = b == null ? l : b, !!b && ($ == "number" || $ != "symbol" && Me.test(v)) && v > -1 && v % 1 == 0 && v < b;
  }
  function Xi(v, b, $) {
    if (!Xr($))
      return !1;
    var N = typeof b;
    return (N == "number" ? Un($) && Oo(b, $.length) : N == "string" && b in $) ? bn($[b], v) : !1;
  }
  function vi(v) {
    var b = typeof v;
    return b == "string" || b == "number" || b == "symbol" || b == "boolean" ? v !== "__proto__" : v === null;
  }
  function hi(v) {
    return !!Y && Y in v;
  }
  function En(v) {
    var b = v && v.constructor, $ = typeof b == "function" && b.prototype || gr;
    return v === $;
  }
  function Ji(v) {
    var b = [];
    if (v != null)
      for (var $ in Object(v))
        b.push($);
    return b;
  }
  function es(v) {
    return Q.call(v);
  }
  function cl(v, b, $) {
    return b = hn(b === void 0 ? v.length - 1 : b, 0), function() {
      for (var N = arguments, ie = -1, pe = hn(N.length - b, 0), ce = Array(pe); ++ie < pe; )
        ce[ie] = N[b + ie];
      ie = -1;
      for (var ae = Array(b + 1); ++ie < b; )
        ae[ie] = N[ie];
      return ae[b] = $(ce), Qe(v, this, ae);
    };
  }
  function Bn(v, b) {
    if (!(b === "constructor" && typeof v[b] == "function") && b != "__proto__")
      return v[b];
  }
  var rs = ts(Gi);
  function ts(v) {
    var b = 0, $ = 0;
    return function() {
      var N = Za(), ie = i - (N - $);
      if ($ = N, ie > 0) {
        if (++b >= a)
          return arguments[0];
      } else
        b = 0;
      return v.apply(void 0, arguments);
    };
  }
  function ns(v) {
    if (v != null) {
      try {
        return G.call(v);
      } catch (b) {
      }
      try {
        return v + "";
      } catch (b) {
      }
    }
    return "";
  }
  function bn(v, b) {
    return v === b || v !== v && b !== b;
  }
  var ta = Xa(function() {
    return arguments;
  }()) ? Xa : function(v) {
    return Lt(v) && ne.call(v, "callee") && !bt.call(v, "callee");
  }, na = Array.isArray;
  function Un(v) {
    return v != null && Ro(v.length) && !aa(v);
  }
  function dl(v) {
    return Lt(v) && Un(v);
  }
  var Mo = vn || hl;
  function aa(v) {
    if (!Xr(v))
      return !1;
    var b = gn(v);
    return b == y || b == S || b == f || b == P;
  }
  function Ro(v) {
    return typeof v == "number" && v > -1 && v % 1 == 0 && v <= l;
  }
  function Xr(v) {
    var b = typeof v;
    return v != null && (b == "object" || b == "function");
  }
  function Lt(v) {
    return v != null && typeof v == "object";
  }
  function fl(v) {
    if (!Lt(v) || gn(v) != O)
      return !1;
    var b = dt(v);
    if (b === null)
      return !0;
    var $ = ne.call(b, "constructor") && b.constructor;
    return typeof $ == "function" && $ instanceof $ && G.call($) == we;
  }
  var Po = $r ? at($r) : Hi;
  function vl(v) {
    return qi(v, ko(v));
  }
  function ko(v) {
    return Un(v) ? nl(v, !0) : il(v);
  }
  var _r = Io(function(v, b, $, N) {
    Ao(v, b, $, N);
  });
  function xr(v) {
    return function() {
      return v;
    };
  }
  function jo(v) {
    return v;
  }
  function hl() {
    return !1;
  }
  e.exports = _r;
})(Qx, Qx.exports);
var Rs = Qx.exports;
function wy(e) {
  return typeof e == "number";
}
function Sxe(e) {
  return Array.isArray(e);
}
function Ju(e) {
  return typeof e == "function";
}
function oi(e) {
  var r = typeof e;
  return e != null && (r === "object" || r === "function") && !Sxe(e);
}
function xxe(e) {
  return oi(e) && Object.keys(e).length === 0;
}
function n_(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
function u8(e) {
  return /^var\(--.+\)$/.test(e);
}
var $xe = !1;
function wxe(e, r, t, n) {
  var a = typeof r == "string" ? r.split(".") : [r];
  for (n = 0; n < a.length && e; n += 1)
    e = e[a[n]];
  return e === void 0 ? t : e;
}
var _xe = function(r) {
  var t = /* @__PURE__ */ new WeakMap(), n = function(i, l, u, c) {
    if (typeof i == "undefined")
      return r(i, l, u);
    t.has(i) || t.set(i, /* @__PURE__ */ new Map());
    var f = t.get(i);
    if (f.has(l))
      return f.get(l);
    var h = r(i, l, u, c);
    return f.set(l, h), h;
  };
  return n;
}, c8 = _xe(wxe);
function d8(e, r) {
  var t = {};
  return Object.keys(e).forEach(function(n) {
    var a = e[n], i = r(a, n, e);
    i && (t[n] = a);
  }), t;
}
var Txe = function(r) {
  return d8(r, function(t) {
    return t != null;
  });
}, f8 = function(r) {
  return Object.keys(r);
}, Xx = function(r) {
  return r.reduce(function(t, n) {
    var a = n[0], i = n[1];
    return t[a] = i, t;
  }, {});
};
function ec(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  return Ju(e) ? e.apply(void 0, t) : e;
}
function Cxe(e) {
  var r;
  return function() {
    if (e) {
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      r = e.apply(this, a), e = null;
    }
    return r;
  };
}
var Exe = Cxe(function(e) {
  return function() {
    var r = e.condition, t = e.message;
    r && $xe && console.warn(t);
  };
}), Axe = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return function(a) {
    return t.reduce(function(i, l) {
      return l(i);
    }, a);
  };
};
function a_(e) {
  e === void 0 && (e = {});
  var r = e, t = r.strict, n = t === void 0 ? !0 : t, a = r.errorMessage, i = a === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : a, l = r.name, u = /* @__PURE__ */ Ut.exports.createContext(void 0);
  u.displayName = l;
  function c() {
    var f = Ut.exports.useContext(u);
    if (!f && n) {
      var h = new Error(i);
      throw h.name = "ContextError", Error.captureStackTrace == null || Error.captureStackTrace(h, c), h;
    }
    return f;
  }
  return [u.Provider, c, u];
}
var v8 = { exports: {} }, h8 = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(e) {
  function r(ue, he) {
    var _e = ue.length;
    ue.push(he);
    e:
      for (; 0 < _e; ) {
        var Oe = _e - 1 >>> 1, Me = ue[Oe];
        if (0 < a(Me, he))
          ue[Oe] = he, ue[_e] = Me, _e = Oe;
        else
          break e;
      }
  }
  function t(ue) {
    return ue.length === 0 ? null : ue[0];
  }
  function n(ue) {
    if (ue.length === 0)
      return null;
    var he = ue[0], _e = ue.pop();
    if (_e !== he) {
      ue[0] = _e;
      e:
        for (var Oe = 0, Me = ue.length, Z = Me >>> 1; Oe < Z; ) {
          var se = 2 * (Oe + 1) - 1, te = ue[se], fe = se + 1, je = ue[fe];
          if (0 > a(te, _e))
            fe < Me && 0 > a(je, te) ? (ue[Oe] = je, ue[fe] = _e, Oe = fe) : (ue[Oe] = te, ue[se] = _e, Oe = se);
          else if (fe < Me && 0 > a(je, _e))
            ue[Oe] = je, ue[fe] = _e, Oe = fe;
          else
            break e;
        }
    }
    return he;
  }
  function a(ue, he) {
    var _e = ue.sortIndex - he.sortIndex;
    return _e !== 0 ? _e : ue.id - he.id;
  }
  if (typeof performance == "object" && typeof performance.now == "function") {
    var i = performance;
    e.unstable_now = function() {
      return i.now();
    };
  } else {
    var l = Date, u = l.now();
    e.unstable_now = function() {
      return l.now() - u;
    };
  }
  var c = [], f = [], h = 1, p = null, g = 3, y = !1, S = !1, x = !1, T = typeof setTimeout == "function" ? setTimeout : null, A = typeof clearTimeout == "function" ? clearTimeout : null, O = typeof setImmediate != "undefined" ? setImmediate : null;
  typeof navigator != "undefined" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function P(ue) {
    for (var he = t(f); he !== null; ) {
      if (he.callback === null)
        n(f);
      else if (he.startTime <= ue)
        n(f), he.sortIndex = he.expirationTime, r(c, he);
      else
        break;
      he = t(f);
    }
  }
  function j(ue) {
    if (x = !1, P(ue), !S)
      if (t(c) !== null)
        S = !0, Ke(k);
      else {
        var he = t(f);
        he !== null && Be(j, he.startTime - ue);
      }
  }
  function k(ue, he) {
    S = !1, x && (x = !1, A(W), W = -1), y = !0;
    var _e = g;
    try {
      for (P(he), p = t(c); p !== null && (!(p.expirationTime > he) || ue && !Ae()); ) {
        var Oe = p.callback;
        if (typeof Oe == "function") {
          p.callback = null, g = p.priorityLevel;
          var Me = Oe(p.expirationTime <= he);
          he = e.unstable_now(), typeof Me == "function" ? p.callback = Me : p === t(c) && n(c), P(he);
        } else
          n(c);
        p = t(c);
      }
      if (p !== null)
        var Z = !0;
      else {
        var se = t(f);
        se !== null && Be(j, se.startTime - he), Z = !1;
      }
      return Z;
    } finally {
      p = null, g = _e, y = !1;
    }
  }
  var L = !1, M = null, W = -1, q = 5, oe = -1;
  function Ae() {
    return !(e.unstable_now() - oe < q);
  }
  function Te() {
    if (M !== null) {
      var ue = e.unstable_now();
      oe = ue;
      var he = !0;
      try {
        he = M(!0, ue);
      } finally {
        he ? $e() : (L = !1, M = null);
      }
    } else
      L = !1;
  }
  var $e;
  if (typeof O == "function")
    $e = function() {
      O(Te);
    };
  else if (typeof MessageChannel != "undefined") {
    var Ee = new MessageChannel(), ze = Ee.port2;
    Ee.port1.onmessage = Te, $e = function() {
      ze.postMessage(null);
    };
  } else
    $e = function() {
      T(Te, 0);
    };
  function Ke(ue) {
    M = ue, L || (L = !0, $e());
  }
  function Be(ue, he) {
    W = T(function() {
      ue(e.unstable_now());
    }, he);
  }
  e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(ue) {
    ue.callback = null;
  }, e.unstable_continueExecution = function() {
    S || y || (S = !0, Ke(k));
  }, e.unstable_forceFrameRate = function(ue) {
    0 > ue || 125 < ue ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : q = 0 < ue ? Math.floor(1e3 / ue) : 5;
  }, e.unstable_getCurrentPriorityLevel = function() {
    return g;
  }, e.unstable_getFirstCallbackNode = function() {
    return t(c);
  }, e.unstable_next = function(ue) {
    switch (g) {
      case 1:
      case 2:
      case 3:
        var he = 3;
        break;
      default:
        he = g;
    }
    var _e = g;
    g = he;
    try {
      return ue();
    } finally {
      g = _e;
    }
  }, e.unstable_pauseExecution = function() {
  }, e.unstable_requestPaint = function() {
  }, e.unstable_runWithPriority = function(ue, he) {
    switch (ue) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        ue = 3;
    }
    var _e = g;
    g = ue;
    try {
      return he();
    } finally {
      g = _e;
    }
  }, e.unstable_scheduleCallback = function(ue, he, _e) {
    var Oe = e.unstable_now();
    switch (typeof _e == "object" && _e !== null ? (_e = _e.delay, _e = typeof _e == "number" && 0 < _e ? Oe + _e : Oe) : _e = Oe, ue) {
      case 1:
        var Me = -1;
        break;
      case 2:
        Me = 250;
        break;
      case 5:
        Me = 1073741823;
        break;
      case 4:
        Me = 1e4;
        break;
      default:
        Me = 5e3;
    }
    return Me = _e + Me, ue = { id: h++, callback: he, priorityLevel: ue, startTime: _e, expirationTime: Me, sortIndex: -1 }, _e > Oe ? (ue.sortIndex = _e, r(f, ue), t(c) === null && ue === t(f) && (x ? (A(W), W = -1) : x = !0, Be(j, _e - Oe))) : (ue.sortIndex = Me, r(c, ue), S || y || (S = !0, Ke(k))), ue;
  }, e.unstable_shouldYield = Ae, e.unstable_wrapCallback = function(ue) {
    var he = g;
    return function() {
      var _e = g;
      g = he;
      try {
        return ue.apply(this, arguments);
      } finally {
        g = _e;
      }
    };
  };
})(h8);
v8.exports = h8;
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var p8 = Ut.exports, Co = v8.exports;
function Wu(e) {
  for (var r = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, t = 1; t < arguments.length; t++)
    r += "&args[]=" + encodeURIComponent(arguments[t]);
  return "Minified React error #" + e + "; visit " + r + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var Ixe = /* @__PURE__ */ new Set();
function du(e, r) {
  $c(e, r), $c(e + "Capture", r);
}
function $c(e, r) {
  for (e = 0; e < r.length; e++)
    Ixe.add(r[e]);
}
var M0 = !(typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined");
function Nc(e, r, t, n, a, i, l) {
  this.acceptsBooleans = r === 2 || r === 3 || r === 4, this.attributeName = n, this.attributeNamespace = a, this.mustUseProperty = t, this.propertyName = e, this.type = r, this.sanitizeURL = i, this.removeEmptyString = l;
}
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
  var r = e[0];
  new Nc(r, 1, !1, e[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
  new Nc(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
  new Nc(e, 3, !1, e.toLowerCase(), null, !1, !1);
});
["rowSpan", "start"].forEach(function(e) {
  new Nc(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var o_ = /[\-:]([a-z])/g;
function i_(e) {
  return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
  e.replace(
    o_,
    i_
  );
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
  e.replace(o_, i_);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(e) {
  e.replace(o_, i_);
});
["tabIndex", "crossOrigin"].forEach(function(e) {
  new Nc(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
["src", "href", "action", "formAction"].forEach(function(e) {
  new Nc(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
var Ui = p8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Jn = Object.assign, Fh;
(function(e) {
  return typeof MSApp != "undefined" && MSApp.execUnsafeLocalFunction ? function(r, t, n, a) {
    MSApp.execUnsafeLocalFunction(function() {
      return e(r, t, n, a);
    });
  } : e;
})(function(e, r) {
  if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e)
    e.innerHTML = r;
  else {
    for (Fh = Fh || document.createElement("div"), Fh.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>", r = Fh.firstChild; e.firstChild; )
      e.removeChild(e.firstChild);
    for (; r.firstChild; )
      e.appendChild(r.firstChild);
  }
});
var _y = {
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, Oxe = ["Webkit", "ms", "Moz", "O"];
Object.keys(_y).forEach(function(e) {
  Oxe.forEach(function(r) {
    r = r + e.charAt(0).toUpperCase() + e.substring(1), _y[r] = _y[e];
  });
});
Jn({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
var O3 = !1;
if (M0)
  try {
    var dd = {};
    Object.defineProperty(dd, "passive", { get: function() {
      O3 = !0;
    } }), window.addEventListener("test", dd, dd), window.removeEventListener("test", dd, dd);
  } catch (e) {
    O3 = !1;
  }
function g8(e) {
  var r = e, t = e;
  if (e.alternate)
    for (; r.return; )
      r = r.return;
  else {
    e = r;
    do
      r = e, r.flags & 4098 && (t = r.return), e = r.return;
    while (e);
  }
  return r.tag === 3 ? t : null;
}
function M3(e) {
  if (g8(e) !== e)
    throw Error(Wu(188));
}
function Mxe(e) {
  var r = e.alternate;
  if (!r) {
    if (r = g8(e), r === null)
      throw Error(Wu(188));
    return r !== e ? null : e;
  }
  for (var t = e, n = r; ; ) {
    var a = t.return;
    if (a === null)
      break;
    var i = a.alternate;
    if (i === null) {
      if (n = a.return, n !== null) {
        t = n;
        continue;
      }
      break;
    }
    if (a.child === i.child) {
      for (i = a.child; i; ) {
        if (i === t)
          return M3(a), e;
        if (i === n)
          return M3(a), r;
        i = i.sibling;
      }
      throw Error(Wu(188));
    }
    if (t.return !== n.return)
      t = a, n = i;
    else {
      for (var l = !1, u = a.child; u; ) {
        if (u === t) {
          l = !0, t = a, n = i;
          break;
        }
        if (u === n) {
          l = !0, n = a, t = i;
          break;
        }
        u = u.sibling;
      }
      if (!l) {
        for (u = i.child; u; ) {
          if (u === t) {
            l = !0, t = i, n = a;
            break;
          }
          if (u === n) {
            l = !0, n = i, t = a;
            break;
          }
          u = u.sibling;
        }
        if (!l)
          throw Error(Wu(189));
      }
    }
    if (t.alternate !== n)
      throw Error(Wu(190));
  }
  if (t.tag !== 3)
    throw Error(Wu(188));
  return t.stateNode.current === t ? e : r;
}
function Rxe(e) {
  return e = Mxe(e), e !== null ? m8(e) : null;
}
function m8(e) {
  if (e.tag === 5 || e.tag === 6)
    return e;
  for (e = e.child; e !== null; ) {
    var r = m8(e);
    if (r !== null)
      return r;
    e = e.sibling;
  }
  return null;
}
Co.unstable_scheduleCallback;
Co.unstable_cancelCallback;
Co.unstable_shouldYield;
Co.unstable_requestPaint;
Co.unstable_now;
Co.unstable_getCurrentPriorityLevel;
Co.unstable_ImmediatePriority;
Co.unstable_UserBlockingPriority;
Co.unstable_NormalPriority;
Co.unstable_LowPriority;
Co.unstable_IdlePriority;
var Pxe = null, kxe = null;
Ui.ReactCurrentBatchConfig;
function Ty(e) {
  var r = e.keyCode;
  return "charCode" in e ? (e = e.charCode, e === 0 && r === 13 && (e = 13)) : e = r, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
}
function zh() {
  return !0;
}
function R3() {
  return !1;
}
function Ea(e) {
  function r(t, n, a, i, l) {
    this._reactName = t, this._targetInst = a, this.type = n, this.nativeEvent = i, this.target = l, this.currentTarget = null;
    for (var u in e)
      e.hasOwnProperty(u) && (t = e[u], this[u] = t ? t(i) : i[u]);
    return this.isDefaultPrevented = (i.defaultPrevented != null ? i.defaultPrevented : i.returnValue === !1) ? zh : R3, this.isPropagationStopped = R3, this;
  }
  return Jn(r.prototype, { preventDefault: function() {
    this.defaultPrevented = !0;
    var t = this.nativeEvent;
    t && (t.preventDefault ? t.preventDefault() : typeof t.returnValue != "unknown" && (t.returnValue = !1), this.isDefaultPrevented = zh);
  }, stopPropagation: function() {
    var t = this.nativeEvent;
    t && (t.stopPropagation ? t.stopPropagation() : typeof t.cancelBubble != "unknown" && (t.cancelBubble = !0), this.isPropagationStopped = zh);
  }, persist: function() {
  }, isPersistent: zh }), r;
}
var Lc = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(e) {
  return e.timeStamp || Date.now();
}, defaultPrevented: 0, isTrusted: 0 };
Ea(Lc);
var ev = Jn({}, Lc, { view: 0, detail: 0 });
Ea(ev);
var Cy, Ey, fd, dm = Jn({}, ev, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: s_, button: 0, buttons: 0, relatedTarget: function(e) {
  return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
}, movementX: function(e) {
  return "movementX" in e ? e.movementX : (e !== fd && (fd && e.type === "mousemove" ? (Cy = e.screenX - fd.screenX, Ey = e.screenY - fd.screenY) : Ey = Cy = 0, fd = e), Cy);
}, movementY: function(e) {
  return "movementY" in e ? e.movementY : Ey;
} });
Ea(dm);
var jxe = Jn({}, dm, { dataTransfer: 0 });
Ea(jxe);
var Dxe = Jn({}, ev, { relatedTarget: 0 });
Ea(Dxe);
var Nxe = Jn({}, Lc, { animationName: 0, elapsedTime: 0, pseudoElement: 0 });
Ea(Nxe);
var Lxe = Jn({}, Lc, { clipboardData: function(e) {
  return "clipboardData" in e ? e.clipboardData : window.clipboardData;
} });
Ea(Lxe);
var Fxe = Jn({}, Lc, { data: 0 });
Ea(Fxe);
var zxe = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
}, Bxe = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, Uxe = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function Vxe(e) {
  var r = this.nativeEvent;
  return r.getModifierState ? r.getModifierState(e) : (e = Uxe[e]) ? !!r[e] : !1;
}
function s_() {
  return Vxe;
}
var Wxe = Jn({}, ev, { key: function(e) {
  if (e.key) {
    var r = zxe[e.key] || e.key;
    if (r !== "Unidentified")
      return r;
  }
  return e.type === "keypress" ? (e = Ty(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? Bxe[e.keyCode] || "Unidentified" : "";
}, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: s_, charCode: function(e) {
  return e.type === "keypress" ? Ty(e) : 0;
}, keyCode: function(e) {
  return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
}, which: function(e) {
  return e.type === "keypress" ? Ty(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
} });
Ea(Wxe);
var Hxe = Jn({}, dm, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 });
Ea(Hxe);
var Gxe = Jn({}, ev, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: s_ });
Ea(Gxe);
var Yxe = Jn({}, Lc, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 });
Ea(Yxe);
var Kxe = Jn({}, dm, {
  deltaX: function(e) {
    return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
  },
  deltaY: function(e) {
    return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
});
Ea(Kxe);
if (M0 && M0) {
  var P3 = "oninput" in document;
  if (!P3) {
    var k3 = document.createElement("div");
    k3.setAttribute("oninput", "return;"), P3 = typeof k3.oninput == "function";
  }
}
function Bh(e, r) {
  var t = {};
  return t[e.toLowerCase()] = r.toLowerCase(), t["Webkit" + e] = "webkit" + r, t["Moz" + e] = "moz" + r, t;
}
var rc = { animationend: Bh("Animation", "AnimationEnd"), animationiteration: Bh("Animation", "AnimationIteration"), animationstart: Bh("Animation", "AnimationStart"), transitionend: Bh("Transition", "TransitionEnd") }, Ay = {}, b8 = {};
M0 && (b8 = document.createElement("div").style, "AnimationEvent" in window || (delete rc.animationend.animation, delete rc.animationiteration.animation, delete rc.animationstart.animation), "TransitionEvent" in window || delete rc.transitionend.transition);
function fm(e) {
  if (Ay[e])
    return Ay[e];
  if (!rc[e])
    return e;
  var r = rc[e], t;
  for (t in r)
    if (r.hasOwnProperty(t) && t in b8)
      return Ay[e] = r[t];
  return e;
}
var qxe = fm("animationend"), Zxe = fm("animationiteration"), Qxe = fm("animationstart"), Xxe = fm("transitionend"), Jxe = /* @__PURE__ */ new Map(), j3 = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function Gs(e, r) {
  Jxe.set(e, r), du(r, [e]);
}
for (var Iy = 0; Iy < j3.length; Iy++) {
  var Oy = j3[Iy], e2e = Oy.toLowerCase(), r2e = Oy[0].toUpperCase() + Oy.slice(1);
  Gs(e2e, "on" + r2e);
}
Gs(qxe, "onAnimationEnd");
Gs(Zxe, "onAnimationIteration");
Gs(Qxe, "onAnimationStart");
Gs("dblclick", "onDoubleClick");
Gs("focusin", "onFocus");
Gs("focusout", "onBlur");
Gs(Xxe, "onTransitionEnd");
$c("onMouseEnter", ["mouseout", "mouseover"]);
$c("onMouseLeave", ["mouseout", "mouseover"]);
$c("onPointerEnter", ["pointerout", "pointerover"]);
$c("onPointerLeave", ["pointerout", "pointerover"]);
du("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
du("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
du("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
du("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
du("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
du("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var t2e = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
new Set("cancel close invalid load scroll toggle".split(" ").concat(t2e));
"" + Math.random().toString(36).slice(2);
function D3(e) {
  e = e.previousSibling;
  for (var r = 0; e; ) {
    if (e.nodeType === 8) {
      var t = e.data;
      if (t === "$" || t === "$!" || t === "$?") {
        if (r === 0)
          return e;
        r--;
      } else
        t === "/$" && r++;
    }
    e = e.previousSibling;
  }
  return null;
}
var y8 = Math.random().toString(36).slice(2), My = "__reactFiber$" + y8, n2e = "__reactContainer$" + y8;
function a2e(e) {
  var r = e[My];
  if (r)
    return r;
  for (var t = e.parentNode; t; ) {
    if (r = t[n2e] || t[My]) {
      if (t = r.alternate, r.child !== null || t !== null && t.child !== null)
        for (e = D3(e); e !== null; ) {
          if (t = e[My])
            return t;
          e = D3(e);
        }
      return r;
    }
    e = t, t = e.parentNode;
  }
  return null;
}
Ui.ReactCurrentBatchConfig;
new p8.Component().refs;
Ui.ReactCurrentDispatcher;
Ui.ReactCurrentBatchConfig;
Ui.ReactCurrentOwner;
Ui.ReactCurrentDispatcher;
Ui.ReactCurrentOwner;
Ui.ReactCurrentBatchConfig;
function o2e() {
  return null;
}
var vd = { findFiberByHostInstance: a2e, bundleType: 0, version: "18.2.0", rendererPackageName: "react-dom" }, i2e = { bundleType: vd.bundleType, version: vd.version, rendererPackageName: vd.rendererPackageName, rendererConfig: vd.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: Ui.ReactCurrentDispatcher, findHostInstanceByFiber: function(e) {
  return e = Rxe(e), e === null ? null : e.stateNode;
}, findFiberByHostInstance: vd.findFiberByHostInstance || o2e, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.2.0-next-9e3b772b8-20220608" };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined") {
  var Uh = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!Uh.isDisabled && Uh.supportsFiber)
    try {
      Pxe = Uh.inject(i2e), kxe = Uh;
    } catch (e) {
    }
}
function S8() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ == "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(S8);
    } catch (e) {
      console.error(e);
    }
}
S8();
a_({
  strict: !1,
  name: "PortalManagerContext"
});
a_({
  strict: !1,
  name: "PortalContext"
});
function R0() {
  return R0 = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, R0.apply(this, arguments);
}
var s2e = function(r, t) {
  return function(n) {
    var a = String(t), i = r ? r + "." + a : a;
    return oi(n.__cssMap) && i in n.__cssMap ? n.__cssMap[i].varRef : t;
  };
};
function Tf(e) {
  var r = e.scale, t = e.transform, n = e.compose, a = function(l, u) {
    var c, f = s2e(r, l)(u), h = (c = t == null ? void 0 : t(f, u)) != null ? c : f;
    return n && (h = n(h, u)), h;
  };
  return a;
}
function uo(e, r) {
  return function(t) {
    var n = {
      property: t,
      scale: e
    };
    return n.transform = Tf({
      scale: e,
      transform: r
    }), n;
  };
}
var l2e = function(r) {
  var t = r.rtl, n = r.ltr;
  return function(a) {
    return a.direction === "rtl" ? t : n;
  };
};
function u2e(e) {
  var r = e.property, t = e.scale, n = e.transform;
  return {
    scale: t,
    property: l2e(r),
    transform: t ? Tf({
      scale: t,
      compose: n
    }) : n
  };
}
var Ry, Py, x8 = ["rotate(var(--chakra-rotate, 0))", "scaleX(var(--chakra-scale-x, 1))", "scaleY(var(--chakra-scale-y, 1))", "skewX(var(--chakra-skew-x, 0))", "skewY(var(--chakra-skew-y, 0))"];
function c2e() {
  return ["translateX(var(--chakra-translate-x, 0))", "translateY(var(--chakra-translate-y, 0))"].concat(x8).join(" ");
}
function d2e() {
  return ["translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)"].concat(x8).join(" ");
}
var f2e = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: ["var(--chakra-blur)", "var(--chakra-brightness)", "var(--chakra-contrast)", "var(--chakra-grayscale)", "var(--chakra-hue-rotate)", "var(--chakra-invert)", "var(--chakra-saturate)", "var(--chakra-sepia)", "var(--chakra-drop-shadow)"].join(" ")
}, v2e = {
  backdropFilter: ["var(--chakra-backdrop-blur)", "var(--chakra-backdrop-brightness)", "var(--chakra-backdrop-contrast)", "var(--chakra-backdrop-grayscale)", "var(--chakra-backdrop-hue-rotate)", "var(--chakra-backdrop-invert)", "var(--chakra-backdrop-opacity)", "var(--chakra-backdrop-saturate)", "var(--chakra-backdrop-sepia)"].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function h2e(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: ["var(--chakra-ring-offset-shadow)", "var(--chakra-ring-shadow)", "var(--chakra-shadow, 0 0 #0000)"].join(", ")
  };
}
var p2e = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, $8 = "& > :not(style) ~ :not(style)", g2e = (Ry = {}, Ry[$8] = {
  marginInlineStart: "calc(var(--chakra-space-x) * calc(1 - var(--chakra-space-x-reverse)))",
  marginInlineEnd: "calc(var(--chakra-space-x) * var(--chakra-space-x-reverse))"
}, Ry), m2e = (Py = {}, Py[$8] = {
  marginTop: "calc(var(--chakra-space-y) * calc(1 - var(--chakra-space-y-reverse)))",
  marginBottom: "calc(var(--chakra-space-y) * var(--chakra-space-y-reverse))"
}, Py);
function P0(e, r) {
  return P0 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, P0(e, r);
}
function b2e(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), r && P0(e, r);
}
function Jx() {
  Jx = function(a, i) {
    return new t(a, void 0, i);
  };
  var e = RegExp.prototype, r = /* @__PURE__ */ new WeakMap();
  function t(a, i, l) {
    var u = new RegExp(a, i);
    return r.set(u, l || r.get(a)), P0(u, t.prototype);
  }
  b2e(t, RegExp), t.prototype.exec = function(a) {
    var i = e.exec.call(this, a);
    return i && (i.groups = n(i, this)), i;
  }, t.prototype[Symbol.replace] = function(a, i) {
    if (typeof i == "string") {
      var l = r.get(this);
      return e[Symbol.replace].call(this, a, i.replace(/\$<([^>]+)>/g, function(c, f) {
        return "$" + l[f];
      }));
    } else if (typeof i == "function") {
      var u = this;
      return e[Symbol.replace].call(this, a, function() {
        var c = arguments;
        return typeof c[c.length - 1] != "object" && (c = [].slice.call(c), c.push(n(c, u))), i.apply(this, c);
      });
    } else
      return e[Symbol.replace].call(this, a, i);
  };
  function n(a, i) {
    var l = r.get(i);
    return Object.keys(l).reduce(function(u, c) {
      return u[c] = a[l[c]], u;
    }, /* @__PURE__ */ Object.create(null));
  }
  return Jx.apply(this, arguments);
}
var e2 = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, y2e = new Set(Object.values(e2)), w8 = /* @__PURE__ */ new Set(["none", "-moz-initial", "inherit", "initial", "revert", "unset"]), S2e = function(r) {
  return r.trim();
};
function x2e(e, r) {
  var t, n;
  if (e == null || w8.has(e))
    return e;
  var a = /* @__PURE__ */ Jx(/(^[\x2DA-Za-z]+)\(((.*))\)/g, {
    type: 1,
    values: 2
  }), i = (t = (n = a.exec(e)) == null ? void 0 : n.groups) != null ? t : {}, l = i.type, u = i.values;
  if (!l || !u)
    return e;
  var c = l.includes("-gradient") ? l : l + "-gradient", f = u.split(",").map(S2e).filter(Boolean), h = f[0], p = f.slice(1);
  if ((p == null ? void 0 : p.length) === 0)
    return e;
  var g = h in e2 ? e2[h] : h;
  p.unshift(g);
  var y = p.map(function(S) {
    if (y2e.has(S))
      return S;
    var x = S.indexOf(" "), T = x !== -1 ? [S.substr(0, x), S.substr(x + 1)] : [S], A = T[0], O = T[1], P = _8(O) ? O : O && O.split(" "), j = "colors." + A, k = j in r.__cssMap ? r.__cssMap[j].varRef : A;
    return P ? [k].concat(Array.isArray(P) ? P : [P]).join(" ") : k;
  });
  return c + "(" + y.join(", ") + ")";
}
var _8 = function(r) {
  return n_(r) && r.includes("(") && r.includes(")");
}, $2e = function(r, t) {
  return x2e(r, t != null ? t : {});
}, w2e = function(r) {
  var t = parseFloat(r.toString()), n = r.toString().replace(String(t), "");
  return {
    unitless: !n,
    value: t,
    unit: n
  };
}, Wo = function(r) {
  return function(t) {
    return r + "(" + t + ")";
  };
}, Br = {
  filter: function(r) {
    return r !== "auto" ? r : f2e;
  },
  backdropFilter: function(r) {
    return r !== "auto" ? r : v2e;
  },
  ring: function(r) {
    return h2e(Br.px(r));
  },
  bgClip: function(r) {
    return r === "text" ? {
      color: "transparent",
      backgroundClip: "text"
    } : {
      backgroundClip: r
    };
  },
  transform: function(r) {
    return r === "auto" ? c2e() : r === "auto-gpu" ? d2e() : r;
  },
  px: function(r) {
    if (r == null)
      return r;
    var t = w2e(r), n = t.unitless;
    return n || wy(r) ? r + "px" : r;
  },
  fraction: function(r) {
    return !wy(r) || r > 1 ? r : r * 100 + "%";
  },
  float: function(r, t) {
    var n = {
      left: "right",
      right: "left"
    };
    return t.direction === "rtl" ? n[r] : r;
  },
  degree: function(r) {
    if (u8(r) || r == null)
      return r;
    var t = n_(r) && !r.endsWith("deg");
    return wy(r) || t ? r + "deg" : r;
  },
  gradient: $2e,
  blur: Wo("blur"),
  opacity: Wo("opacity"),
  brightness: Wo("brightness"),
  contrast: Wo("contrast"),
  dropShadow: Wo("drop-shadow"),
  grayscale: Wo("grayscale"),
  hueRotate: Wo("hue-rotate"),
  invert: Wo("invert"),
  saturate: Wo("saturate"),
  sepia: Wo("sepia"),
  bgImage: function(r) {
    if (r == null)
      return r;
    var t = _8(r) || w8.has(r);
    return t ? r : "url(" + r + ")";
  },
  outline: function(r) {
    var t = String(r) === "0" || String(r) === "none";
    return r !== null && t ? {
      outline: "2px solid transparent",
      outlineOffset: "2px"
    } : {
      outline: r
    };
  },
  flexDirection: function(r) {
    var t, n = (t = p2e[r]) != null ? t : {}, a = n.space, i = n.divide, l = {
      flexDirection: r
    };
    return a && (l[a] = 1), i && (l[i] = 1), l;
  }
}, B = {
  borderWidths: uo("borderWidths"),
  borderStyles: uo("borderStyles"),
  colors: uo("colors"),
  borders: uo("borders"),
  radii: uo("radii", Br.px),
  space: uo("space", Br.px),
  spaceT: uo("space", Br.px),
  degreeT: function(r) {
    return {
      property: r,
      transform: Br.degree
    };
  },
  prop: function(r, t, n) {
    return R0({
      property: r,
      scale: t
    }, t && {
      transform: Tf({
        scale: t,
        transform: n
      })
    });
  },
  propT: function(r, t) {
    return {
      property: r,
      transform: t
    };
  },
  sizes: uo("sizes", Br.px),
  sizesT: uo("sizes", Br.fraction),
  shadows: uo("shadows"),
  logical: u2e,
  blur: uo("blur", Br.blur)
}, Bp = {
  background: B.colors("background"),
  backgroundColor: B.colors("backgroundColor"),
  backgroundImage: B.propT("backgroundImage", Br.bgImage),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: {
    transform: Br.bgClip
  },
  bgSize: B.prop("backgroundSize"),
  bgPosition: B.prop("backgroundPosition"),
  bg: B.colors("background"),
  bgColor: B.colors("backgroundColor"),
  bgPos: B.prop("backgroundPosition"),
  bgRepeat: B.prop("backgroundRepeat"),
  bgAttachment: B.prop("backgroundAttachment"),
  bgGradient: B.propT("backgroundImage", Br.gradient),
  bgClip: {
    transform: Br.bgClip
  }
};
Object.assign(Bp, {
  bgImage: Bp.backgroundImage,
  bgImg: Bp.backgroundImage
});
var Ar = {
  border: B.borders("border"),
  borderWidth: B.borderWidths("borderWidth"),
  borderStyle: B.borderStyles("borderStyle"),
  borderColor: B.colors("borderColor"),
  borderRadius: B.radii("borderRadius"),
  borderTop: B.borders("borderTop"),
  borderBlockStart: B.borders("borderBlockStart"),
  borderTopLeftRadius: B.radii("borderTopLeftRadius"),
  borderStartStartRadius: B.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: B.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: B.radii("borderTopRightRadius"),
  borderStartEndRadius: B.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: B.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: B.borders("borderRight"),
  borderInlineEnd: B.borders("borderInlineEnd"),
  borderBottom: B.borders("borderBottom"),
  borderBlockEnd: B.borders("borderBlockEnd"),
  borderBottomLeftRadius: B.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: B.radii("borderBottomRightRadius"),
  borderLeft: B.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: B.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: B.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: B.borders(["borderLeft", "borderRight"]),
  borderInline: B.borders("borderInline"),
  borderY: B.borders(["borderTop", "borderBottom"]),
  borderBlock: B.borders("borderBlock"),
  borderTopWidth: B.borderWidths("borderTopWidth"),
  borderBlockStartWidth: B.borderWidths("borderBlockStartWidth"),
  borderTopColor: B.colors("borderTopColor"),
  borderBlockStartColor: B.colors("borderBlockStartColor"),
  borderTopStyle: B.borderStyles("borderTopStyle"),
  borderBlockStartStyle: B.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: B.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: B.borderWidths("borderBlockEndWidth"),
  borderBottomColor: B.colors("borderBottomColor"),
  borderBlockEndColor: B.colors("borderBlockEndColor"),
  borderBottomStyle: B.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: B.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: B.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: B.borderWidths("borderInlineStartWidth"),
  borderLeftColor: B.colors("borderLeftColor"),
  borderInlineStartColor: B.colors("borderInlineStartColor"),
  borderLeftStyle: B.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: B.borderStyles("borderInlineStartStyle"),
  borderRightWidth: B.borderWidths("borderRightWidth"),
  borderInlineEndWidth: B.borderWidths("borderInlineEndWidth"),
  borderRightColor: B.colors("borderRightColor"),
  borderInlineEndColor: B.colors("borderInlineEndColor"),
  borderRightStyle: B.borderStyles("borderRightStyle"),
  borderInlineEndStyle: B.borderStyles("borderInlineEndStyle"),
  borderTopRadius: B.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: B.radii(["borderBottomLeftRadius", "borderBottomRightRadius"]),
  borderLeftRadius: B.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: B.radii(["borderTopRightRadius", "borderBottomRightRadius"])
};
Object.assign(Ar, {
  rounded: Ar.borderRadius,
  roundedTop: Ar.borderTopRadius,
  roundedTopLeft: Ar.borderTopLeftRadius,
  roundedTopRight: Ar.borderTopRightRadius,
  roundedTopStart: Ar.borderStartStartRadius,
  roundedTopEnd: Ar.borderStartEndRadius,
  roundedBottom: Ar.borderBottomRadius,
  roundedBottomLeft: Ar.borderBottomLeftRadius,
  roundedBottomRight: Ar.borderBottomRightRadius,
  roundedBottomStart: Ar.borderEndStartRadius,
  roundedBottomEnd: Ar.borderEndEndRadius,
  roundedLeft: Ar.borderLeftRadius,
  roundedRight: Ar.borderRightRadius,
  roundedStart: Ar.borderInlineStartRadius,
  roundedEnd: Ar.borderInlineEndRadius,
  borderStart: Ar.borderInlineStart,
  borderEnd: Ar.borderInlineEnd,
  borderTopStartRadius: Ar.borderStartStartRadius,
  borderTopEndRadius: Ar.borderStartEndRadius,
  borderBottomStartRadius: Ar.borderEndStartRadius,
  borderBottomEndRadius: Ar.borderEndEndRadius,
  borderStartRadius: Ar.borderInlineStartRadius,
  borderEndRadius: Ar.borderInlineEndRadius,
  borderStartWidth: Ar.borderInlineStartWidth,
  borderEndWidth: Ar.borderInlineEndWidth,
  borderStartColor: Ar.borderInlineStartColor,
  borderEndColor: Ar.borderInlineEndColor,
  borderStartStyle: Ar.borderInlineStartStyle,
  borderEndStyle: Ar.borderInlineEndStyle
});
var _2e = {
  color: B.colors("color"),
  textColor: B.colors("color"),
  fill: B.colors("fill"),
  stroke: B.colors("stroke")
}, r2 = {
  boxShadow: B.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: B.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: B.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(r2, {
  shadow: r2.boxShadow
});
var T2e = {
  filter: {
    transform: Br.filter
  },
  blur: B.blur("--chakra-blur"),
  brightness: B.propT("--chakra-brightness", Br.brightness),
  contrast: B.propT("--chakra-contrast", Br.contrast),
  hueRotate: B.degreeT("--chakra-hue-rotate"),
  invert: B.propT("--chakra-invert", Br.invert),
  saturate: B.propT("--chakra-saturate", Br.saturate),
  dropShadow: B.propT("--chakra-drop-shadow", Br.dropShadow),
  backdropFilter: {
    transform: Br.backdropFilter
  },
  backdropBlur: B.blur("--chakra-backdrop-blur"),
  backdropBrightness: B.propT("--chakra-backdrop-brightness", Br.brightness),
  backdropContrast: B.propT("--chakra-backdrop-contrast", Br.contrast),
  backdropHueRotate: B.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: B.propT("--chakra-backdrop-invert", Br.invert),
  backdropSaturate: B.propT("--chakra-backdrop-saturate", Br.saturate)
}, k0 = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: {
    transform: Br.flexDirection
  },
  experimental_spaceX: {
    static: g2e,
    transform: Tf({
      scale: "space",
      transform: function(r) {
        return r !== null ? {
          "--chakra-space-x": r
        } : null;
      }
    })
  },
  experimental_spaceY: {
    static: m2e,
    transform: Tf({
      scale: "space",
      transform: function(r) {
        return r != null ? {
          "--chakra-space-y": r
        } : null;
      }
    })
  },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: B.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: B.space("gap"),
  rowGap: B.space("rowGap"),
  columnGap: B.space("columnGap")
};
Object.assign(k0, {
  flexDir: k0.flexDirection
});
var T8 = {
  gridGap: B.space("gridGap"),
  gridColumnGap: B.space("gridColumnGap"),
  gridRowGap: B.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, C2e = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: {
    transform: Br.outline
  },
  outlineOffset: !0,
  outlineColor: B.colors("outlineColor")
}, Fa = {
  width: B.sizesT("width"),
  inlineSize: B.sizesT("inlineSize"),
  height: B.sizes("height"),
  blockSize: B.sizes("blockSize"),
  boxSize: B.sizes(["width", "height"]),
  minWidth: B.sizes("minWidth"),
  minInlineSize: B.sizes("minInlineSize"),
  minHeight: B.sizes("minHeight"),
  minBlockSize: B.sizes("minBlockSize"),
  maxWidth: B.sizes("maxWidth"),
  maxInlineSize: B.sizes("maxInlineSize"),
  maxHeight: B.sizes("maxHeight"),
  maxBlockSize: B.sizes("maxBlockSize"),
  d: B.prop("display"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: B.propT("float", Br.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(Fa, {
  w: Fa.width,
  h: Fa.height,
  minW: Fa.minWidth,
  maxW: Fa.maxWidth,
  minH: Fa.minHeight,
  maxH: Fa.maxHeight,
  overscroll: Fa.overscrollBehavior,
  overscrollX: Fa.overscrollBehaviorX,
  overscrollY: Fa.overscrollBehaviorY
});
var E2e = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: B.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: B.prop("listStyleImage")
}, A2e = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, I2e = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, ky = function(r, t, n) {
  var a = {}, i = c8(r, t, {});
  for (var l in i) {
    var u = l in n && n[l] != null;
    u || (a[l] = i[l]);
  }
  return a;
}, O2e = {
  srOnly: {
    transform: function(r) {
      return r === !0 ? A2e : r === "focusable" ? I2e : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: function(r, t, n) {
      return ky(t, "layerStyles." + r, n);
    }
  },
  textStyle: {
    processResult: !0,
    transform: function(r, t, n) {
      return ky(t, "textStyles." + r, n);
    }
  },
  apply: {
    processResult: !0,
    transform: function(r, t, n) {
      return ky(t, r, n);
    }
  }
}, Hd = {
  position: !0,
  pos: B.prop("position"),
  zIndex: B.prop("zIndex", "zIndices"),
  inset: B.spaceT("inset"),
  insetX: B.spaceT(["left", "right"]),
  insetInline: B.spaceT("insetInline"),
  insetY: B.spaceT(["top", "bottom"]),
  insetBlock: B.spaceT("insetBlock"),
  top: B.spaceT("top"),
  insetBlockStart: B.spaceT("insetBlockStart"),
  bottom: B.spaceT("bottom"),
  insetBlockEnd: B.spaceT("insetBlockEnd"),
  left: B.spaceT("left"),
  insetInlineStart: B.logical({
    scale: "space",
    property: {
      ltr: "left",
      rtl: "right"
    }
  }),
  right: B.spaceT("right"),
  insetInlineEnd: B.logical({
    scale: "space",
    property: {
      ltr: "right",
      rtl: "left"
    }
  })
};
Object.assign(Hd, {
  insetStart: Hd.insetInlineStart,
  insetEnd: Hd.insetInlineEnd
});
var M2e = {
  ring: {
    transform: Br.ring
  },
  ringColor: B.colors("--chakra-ring-color"),
  ringOffset: B.prop("--chakra-ring-offset-width"),
  ringOffsetColor: B.colors("--chakra-ring-offset-color"),
  ringInset: B.prop("--chakra-ring-inset")
}, ut = {
  margin: B.spaceT("margin"),
  marginTop: B.spaceT("marginTop"),
  marginBlockStart: B.spaceT("marginBlockStart"),
  marginRight: B.spaceT("marginRight"),
  marginInlineEnd: B.spaceT("marginInlineEnd"),
  marginBottom: B.spaceT("marginBottom"),
  marginBlockEnd: B.spaceT("marginBlockEnd"),
  marginLeft: B.spaceT("marginLeft"),
  marginInlineStart: B.spaceT("marginInlineStart"),
  marginX: B.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: B.spaceT("marginInline"),
  marginY: B.spaceT(["marginTop", "marginBottom"]),
  marginBlock: B.spaceT("marginBlock"),
  padding: B.space("padding"),
  paddingTop: B.space("paddingTop"),
  paddingBlockStart: B.space("paddingBlockStart"),
  paddingRight: B.space("paddingRight"),
  paddingBottom: B.space("paddingBottom"),
  paddingBlockEnd: B.space("paddingBlockEnd"),
  paddingLeft: B.space("paddingLeft"),
  paddingInlineStart: B.space("paddingInlineStart"),
  paddingInlineEnd: B.space("paddingInlineEnd"),
  paddingX: B.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: B.space("paddingInline"),
  paddingY: B.space(["paddingTop", "paddingBottom"]),
  paddingBlock: B.space("paddingBlock")
};
Object.assign(ut, {
  m: ut.margin,
  mt: ut.marginTop,
  mr: ut.marginRight,
  me: ut.marginInlineEnd,
  marginEnd: ut.marginInlineEnd,
  mb: ut.marginBottom,
  ml: ut.marginLeft,
  ms: ut.marginInlineStart,
  marginStart: ut.marginInlineStart,
  mx: ut.marginX,
  my: ut.marginY,
  p: ut.padding,
  pt: ut.paddingTop,
  py: ut.paddingY,
  px: ut.paddingX,
  pb: ut.paddingBottom,
  pl: ut.paddingLeft,
  ps: ut.paddingInlineStart,
  paddingStart: ut.paddingInlineStart,
  pr: ut.paddingRight,
  pe: ut.paddingInlineEnd,
  paddingEnd: ut.paddingInlineEnd
});
var R2e = {
  textDecorationColor: B.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: {
    property: "textDecoration"
  },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: B.shadows("textShadow")
}, P2e = {
  clipPath: !0,
  transform: B.propT("transform", Br.transform),
  transformOrigin: !0,
  translateX: B.spaceT("--chakra-translate-x"),
  translateY: B.spaceT("--chakra-translate-y"),
  skewX: B.degreeT("--chakra-skew-x"),
  skewY: B.degreeT("--chakra-skew-y"),
  scaleX: B.prop("--chakra-scale-x"),
  scaleY: B.prop("--chakra-scale-y"),
  scale: B.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: B.degreeT("--chakra-rotate")
}, k2e = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: B.prop("transitionDuration", "transition.duration"),
  transitionProperty: B.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: B.prop("transitionTimingFunction", "transition.easing")
}, j2e = {
  fontFamily: B.prop("fontFamily", "fonts"),
  fontSize: B.prop("fontSize", "fontSizes", Br.px),
  fontWeight: B.prop("fontWeight", "fontWeights"),
  lineHeight: B.prop("lineHeight", "lineHeights"),
  letterSpacing: B.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  },
  isTruncated: {
    transform: function(r) {
      if (r === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  }
}, D2e = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: B.spaceT("scrollMargin"),
  scrollMarginTop: B.spaceT("scrollMarginTop"),
  scrollMarginBottom: B.spaceT("scrollMarginBottom"),
  scrollMarginLeft: B.spaceT("scrollMarginLeft"),
  scrollMarginRight: B.spaceT("scrollMarginRight"),
  scrollMarginX: B.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: B.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: B.spaceT("scrollPadding"),
  scrollPaddingTop: B.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: B.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: B.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: B.spaceT("scrollPaddingRight"),
  scrollPaddingX: B.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: B.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function N3(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function N2e(e, r) {
  if (e) {
    if (typeof e == "string")
      return N3(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return N3(e, r);
  }
}
function L2e(e, r) {
  var t = typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t)
    return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = N2e(e)) || r && e && typeof e.length == "number") {
    t && (e = t);
    var n = 0;
    return function() {
      return n >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[n++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var an = {
  hover: function(r, t) {
    return r + ":hover " + t + ", " + r + "[data-hover] " + t;
  },
  focus: function(r, t) {
    return r + ":focus " + t + ", " + r + "[data-focus] " + t;
  },
  focusVisible: function(r, t) {
    return r + ":focus-visible " + t;
  },
  focusWithin: function(r, t) {
    return r + ":focus-within " + t;
  },
  active: function(r, t) {
    return r + ":active " + t + ", " + r + "[data-active] " + t;
  },
  disabled: function(r, t) {
    return r + ":disabled " + t + ", " + r + "[data-disabled] " + t;
  },
  invalid: function(r, t) {
    return r + ":invalid " + t + ", " + r + "[data-invalid] " + t;
  },
  checked: function(r, t) {
    return r + ":checked " + t + ", " + r + "[data-checked] " + t;
  },
  indeterminate: function(r, t) {
    return r + ":indeterminate " + t + ", " + r + "[aria-checked=mixed] " + t + ", " + r + "[data-indeterminate] " + t;
  },
  readOnly: function(r, t) {
    return r + ":read-only " + t + ", " + r + "[readonly] " + t + ", " + r + "[data-read-only] " + t;
  },
  expanded: function(r, t) {
    return r + ":read-only " + t + ", " + r + "[aria-expanded=true] " + t + ", " + r + "[data-expanded] " + t;
  },
  placeholderShown: function(r, t) {
    return r + ":placeholder-shown " + t;
  }
}, bs = function(r) {
  return C8(function(t) {
    return r(t, "&");
  }, "[role=group]", "[data-group]", ".group");
}, Ii = function(r) {
  return C8(function(t) {
    return r(t, "~ &");
  }, "[data-peer]", ".peer");
}, C8 = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(r).join(", ");
}, l_ = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   */
  _disabled: "&[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: bs(an.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: Ii(an.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: bs(an.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: Ii(an.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: bs(an.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: Ii(an.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: bs(an.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: Ii(an.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: bs(an.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: Ii(an.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: bs(an.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: Ii(an.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: bs(an.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: Ii(an.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: bs(an.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: Ii(an.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: Ii(an.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]"
}, F2e = f8(l_), u_ = Rs({}, Bp, Ar, _2e, k0, Fa, T2e, M2e, C2e, T8, O2e, Hd, r2, ut, D2e, j2e, R2e, P2e, E2e, k2e);
Object.assign({}, ut, Fa, k0, T8, Hd);
var z2e = [].concat(f8(u_), F2e), B2e = R0({}, u_, l_), U2e = function(r) {
  return r in B2e;
}, V2e = function(r) {
  return function(t) {
    if (!t.__breakpoints)
      return r;
    var n = t.__breakpoints, a = n.isResponsive, i = n.toArrayValue, l = n.media, u = {};
    for (var c in r) {
      var f = ec(r[c], t);
      if (f != null) {
        if (f = oi(f) && a(f) ? i(f) : f, !Array.isArray(f)) {
          u[c] = f;
          continue;
        }
        for (var h = f.slice(0, l.length).length, p = 0; p < h; p += 1) {
          var g = l == null ? void 0 : l[p];
          if (!g) {
            u[c] = f[p];
            continue;
          }
          u[g] = u[g] || {}, f[p] != null && (u[g][c] = f[p]);
        }
      }
    }
    return u;
  };
}, W2e = function(r, t) {
  return r.startsWith("--") && n_(t) && !u8(t);
}, H2e = function(r, t) {
  var n, a;
  if (t == null)
    return t;
  var i = function(p) {
    var g, y;
    return (g = r.__cssMap) == null || (y = g[p]) == null ? void 0 : y.varRef;
  }, l = function(p) {
    var g;
    return (g = i(p)) != null ? g : p;
  }, u = t.split(",").map(function(h) {
    return h.trim();
  }), c = u[0], f = u[1];
  return t = (n = (a = i(c)) != null ? a : l(f)) != null ? n : l(t), t;
};
function G2e(e) {
  var r = e.configs, t = r === void 0 ? {} : r, n = e.pseudos, a = n === void 0 ? {} : n, i = e.theme, l = function u(c, f) {
    f === void 0 && (f = !1);
    var h = ec(c, i), p = V2e(h)(i), g = {};
    for (var y in p) {
      var S, x, T, A, O, P = p[y], j = ec(P, i);
      y in a && (y = a[y]), W2e(y, j) && (j = H2e(i, j));
      var k = t[y];
      if (k === !0 && (k = {
        property: y
      }), oi(j)) {
        var L;
        g[y] = (L = g[y]) != null ? L : {}, g[y] = Rs({}, g[y], u(j, !0));
        continue;
      }
      var M = (S = (x = k) == null || x.transform == null ? void 0 : x.transform(j, i, h)) != null ? S : j;
      M = (T = k) != null && T.processResult ? u(M, !0) : M;
      var W = ec((A = k) == null ? void 0 : A.property, i);
      if (!f && (O = k) != null && O.static) {
        var q = ec(k.static, i);
        g = Rs({}, g, q);
      }
      if (W && Array.isArray(W)) {
        for (var oe = L2e(W), Ae; !(Ae = oe()).done; ) {
          var Te = Ae.value;
          g[Te] = M;
        }
        continue;
      }
      if (W) {
        W === "&" && oi(M) ? g = Rs({}, g, M) : g[W] = M;
        continue;
      }
      if (oi(M)) {
        g = Rs({}, g, M);
        continue;
      }
      g[y] = M;
    }
    return g;
  };
  return l;
}
var Y2e = function(r) {
  return function(t) {
    var n = G2e({
      theme: t,
      pseudos: l_,
      configs: u_
    });
    return n(r);
  };
};
function E8(e) {
  return oi(e) && e.reference ? e.reference : String(e);
}
var vm = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(E8).join(" " + r + " ").replace(/calc/g, "");
}, L3 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + vm.apply(void 0, ["+"].concat(t)) + ")";
}, F3 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + vm.apply(void 0, ["-"].concat(t)) + ")";
}, t2 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + vm.apply(void 0, ["*"].concat(t)) + ")";
}, z3 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + vm.apply(void 0, ["/"].concat(t)) + ")";
}, B3 = function(r) {
  var t = E8(r);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : "-" + t : t2(t, -1);
}, hd = Object.assign(function(e) {
  return {
    add: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return hd(L3.apply(void 0, [e].concat(n)));
    },
    subtract: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return hd(F3.apply(void 0, [e].concat(n)));
    },
    multiply: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return hd(t2.apply(void 0, [e].concat(n)));
    },
    divide: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return hd(z3.apply(void 0, [e].concat(n)));
    },
    negate: function() {
      return hd(B3(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: L3,
  subtract: F3,
  multiply: t2,
  divide: z3,
  negate: B3
}), K2e = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, q2e = /* @__PURE__ */ Jw(
  function(e) {
    return K2e.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Z2e = q2e, Q2e = function(r) {
  return r !== "theme";
}, U3 = function(r) {
  return typeof r == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  r.charCodeAt(0) > 96 ? Z2e : Q2e;
}, V3 = function(r, t, n) {
  var a;
  if (t) {
    var i = t.shouldForwardProp;
    a = r.__emotion_forwardProp && i ? function(l) {
      return r.__emotion_forwardProp(l) && i(l);
    } : i;
  }
  return typeof a != "function" && n && (a = r.__emotion_forwardProp), a;
}, X2e = typeof document != "undefined", J2e = function(r) {
  var t = r.cache, n = r.serialized, a = r.isStringTag;
  a8(t, n, a);
  var i = pxe(function() {
    return lxe(t, n, a);
  });
  if (!X2e && i !== void 0) {
    for (var l, u = n.name, c = n.next; c !== void 0; )
      u += " " + c.name, c = c.next;
    return /* @__PURE__ */ Ut.exports.createElement("style", (l = {}, l["data-emotion"] = t.key + " " + u, l.dangerouslySetInnerHTML = {
      __html: i
    }, l.nonce = t.sheet.nonce, l));
  }
  return null;
}, e$e = function e(r, t) {
  var n = r.__emotion_real === r, a = n && r.__emotion_base || r, i, l;
  t !== void 0 && (i = t.label, l = t.target);
  var u = V3(r, t, n), c = u || U3(a), f = !c("as");
  return function() {
    var h = arguments, p = n && r.__emotion_styles !== void 0 ? r.__emotion_styles.slice(0) : [];
    if (i !== void 0 && p.push("label:" + i + ";"), h[0] == null || h[0].raw === void 0)
      p.push.apply(p, h);
    else {
      p.push(h[0][0]);
      for (var g = h.length, y = 1; y < g; y++)
        p.push(h[y], h[0][y]);
    }
    var S = l8(function(x, T, A) {
      var O = f && x.as || a, P = "", j = [], k = x;
      if (x.theme == null) {
        k = {};
        for (var L in x)
          k[L] = x[L];
        k.theme = Ut.exports.useContext(mxe);
      }
      typeof x.className == "string" ? P = sxe(T.registered, j, x.className) : x.className != null && (P = x.className + " ");
      var M = i8(p.concat(j), T.registered, k);
      P += T.key + "-" + M.name, l !== void 0 && (P += " " + l);
      var W = f && u === void 0 ? U3(O) : c, q = {};
      for (var oe in x)
        f && oe === "as" || // $FlowFixMe
        W(oe) && (q[oe] = x[oe]);
      return q.className = P, q.ref = A, /* @__PURE__ */ Ut.exports.createElement(Ut.exports.Fragment, null, /* @__PURE__ */ Ut.exports.createElement(J2e, {
        cache: T,
        serialized: M,
        isStringTag: typeof O == "string"
      }), /* @__PURE__ */ Ut.exports.createElement(O, q));
    });
    return S.displayName = i !== void 0 ? i : "Styled(" + (typeof a == "string" ? a : a.displayName || a.name || "Component") + ")", S.defaultProps = r.defaultProps, S.__emotion_real = S, S.__emotion_base = a, S.__emotion_styles = p, S.__emotion_forwardProp = u, Object.defineProperty(S, "toString", {
      value: function() {
        return "." + l;
      }
    }), S.withComponent = function(x, T) {
      return e(x, qx({}, t, T, {
        shouldForwardProp: V3(S, T, !0)
      })).apply(void 0, p);
    }, S;
  };
}, r$e = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], n2 = e$e.bind();
r$e.forEach(function(e) {
  n2[e] = n2(e);
});
a_({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function A8(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var t$e = new Set([].concat(z2e, ["textStyle", "layerStyle", "apply", "isTruncated", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"])), n$e = /* @__PURE__ */ new Set(["htmlWidth", "htmlHeight", "htmlSize"]), a$e = function(r) {
  return n$e.has(r) || !t$e.has(r);
}, o$e = ["theme", "css", "__css", "sx"], i$e = ["baseStyle"], s$e = function(r) {
  var t = r.baseStyle;
  return function(n) {
    n.theme;
    var a = n.css, i = n.__css, l = n.sx, u = A8(n, o$e), c = d8(u, function(g, y) {
      return U2e(y);
    }), f = ec(t, n), h = Object.assign({}, i, f, Txe(c), l), p = Y2e(h)(n.theme);
    return a ? [p, a] : p;
  };
};
function jy(e, r) {
  var t = r != null ? r : {}, n = t.baseStyle, a = A8(t, i$e);
  a.shouldForwardProp || (a.shouldForwardProp = a$e);
  var i = s$e({
    baseStyle: n
  });
  return n2(e, a)(i);
}
function l$e() {
  var e = /* @__PURE__ */ new Map();
  return new Proxy(jy, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply: function(t, n, a) {
      return jy.apply(void 0, a);
    },
    /**
     * @example
     * <chakra.div />
     */
    get: function(t, n) {
      return e.has(n) || e.set(n, jy(n)), e.get(n);
    }
  });
}
l$e();
var I8 = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
};
function Ot() {
  return Ot = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Ot.apply(this, arguments);
}
var u$e = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem"
}, c$e = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, O8 = Ot({}, I8, u$e, {
  container: c$e
});
function dn(e, r) {
  d$e(e) && (e = "100%");
  var t = f$e(e);
  return e = r === 360 ? e : Math.min(r, Math.max(0, parseFloat(e))), t && (e = parseInt(String(e * r), 10) / 100), Math.abs(e - r) < 1e-6 ? 1 : (r === 360 ? e = (e < 0 ? e % r + r : e % r) / parseFloat(String(r)) : e = e % r / parseFloat(String(r)), e);
}
function Vh(e) {
  return Math.min(1, Math.max(0, e));
}
function d$e(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function f$e(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function M8(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Wh(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function Gl(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function v$e(e, r, t) {
  return {
    r: dn(e, 255) * 255,
    g: dn(r, 255) * 255,
    b: dn(t, 255) * 255
  };
}
function W3(e, r, t) {
  e = dn(e, 255), r = dn(r, 255), t = dn(t, 255);
  var n = Math.max(e, r, t), a = Math.min(e, r, t), i = 0, l = 0, u = (n + a) / 2;
  if (n === a)
    l = 0, i = 0;
  else {
    var c = n - a;
    switch (l = u > 0.5 ? c / (2 - n - a) : c / (n + a), n) {
      case e:
        i = (r - t) / c + (r < t ? 6 : 0);
        break;
      case r:
        i = (t - e) / c + 2;
        break;
      case t:
        i = (e - r) / c + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: l, l: u };
}
function Dy(e, r, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? e + (r - e) * (6 * t) : t < 1 / 2 ? r : t < 2 / 3 ? e + (r - e) * (2 / 3 - t) * 6 : e;
}
function h$e(e, r, t) {
  var n, a, i;
  if (e = dn(e, 360), r = dn(r, 100), t = dn(t, 100), r === 0)
    a = t, i = t, n = t;
  else {
    var l = t < 0.5 ? t * (1 + r) : t + r - t * r, u = 2 * t - l;
    n = Dy(u, l, e + 1 / 3), a = Dy(u, l, e), i = Dy(u, l, e - 1 / 3);
  }
  return { r: n * 255, g: a * 255, b: i * 255 };
}
function H3(e, r, t) {
  e = dn(e, 255), r = dn(r, 255), t = dn(t, 255);
  var n = Math.max(e, r, t), a = Math.min(e, r, t), i = 0, l = n, u = n - a, c = n === 0 ? 0 : u / n;
  if (n === a)
    i = 0;
  else {
    switch (n) {
      case e:
        i = (r - t) / u + (r < t ? 6 : 0);
        break;
      case r:
        i = (t - e) / u + 2;
        break;
      case t:
        i = (e - r) / u + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: c, v: l };
}
function p$e(e, r, t) {
  e = dn(e, 360) * 6, r = dn(r, 100), t = dn(t, 100);
  var n = Math.floor(e), a = e - n, i = t * (1 - r), l = t * (1 - a * r), u = t * (1 - (1 - a) * r), c = n % 6, f = [t, l, i, i, u, t][c], h = [u, t, t, l, i, i][c], p = [i, i, u, t, t, l][c];
  return { r: f * 255, g: h * 255, b: p * 255 };
}
function G3(e, r, t, n) {
  var a = [
    Gl(Math.round(e).toString(16)),
    Gl(Math.round(r).toString(16)),
    Gl(Math.round(t).toString(16))
  ];
  return n && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
}
function g$e(e, r, t, n, a) {
  var i = [
    Gl(Math.round(e).toString(16)),
    Gl(Math.round(r).toString(16)),
    Gl(Math.round(t).toString(16)),
    Gl(m$e(n))
  ];
  return a && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) && i[3].startsWith(i[3].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function m$e(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function Y3(e) {
  return ha(e) / 255;
}
function ha(e) {
  return parseInt(e, 16);
}
function b$e(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var a2 = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function y$e(e) {
  var r = { r: 0, g: 0, b: 0 }, t = 1, n = null, a = null, i = null, l = !1, u = !1;
  return typeof e == "string" && (e = $$e(e)), typeof e == "object" && (Oi(e.r) && Oi(e.g) && Oi(e.b) ? (r = v$e(e.r, e.g, e.b), l = !0, u = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Oi(e.h) && Oi(e.s) && Oi(e.v) ? (n = Wh(e.s), a = Wh(e.v), r = p$e(e.h, n, a), l = !0, u = "hsv") : Oi(e.h) && Oi(e.s) && Oi(e.l) && (n = Wh(e.s), i = Wh(e.l), r = h$e(e.h, n, i), l = !0, u = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (t = e.a)), t = M8(t), {
    ok: l,
    format: e.format || u,
    r: Math.min(255, Math.max(r.r, 0)),
    g: Math.min(255, Math.max(r.g, 0)),
    b: Math.min(255, Math.max(r.b, 0)),
    a: t
  };
}
var S$e = "[-\\+]?\\d+%?", x$e = "[-\\+]?\\d*\\.\\d+%?", Ps = "(?:".concat(x$e, ")|(?:").concat(S$e, ")"), Ny = "[\\s|\\(]+(".concat(Ps, ")[,|\\s]+(").concat(Ps, ")[,|\\s]+(").concat(Ps, ")\\s*\\)?"), Ly = "[\\s|\\(]+(".concat(Ps, ")[,|\\s]+(").concat(Ps, ")[,|\\s]+(").concat(Ps, ")[,|\\s]+(").concat(Ps, ")\\s*\\)?"), po = {
  CSS_UNIT: new RegExp(Ps),
  rgb: new RegExp("rgb" + Ny),
  rgba: new RegExp("rgba" + Ly),
  hsl: new RegExp("hsl" + Ny),
  hsla: new RegExp("hsla" + Ly),
  hsv: new RegExp("hsv" + Ny),
  hsva: new RegExp("hsva" + Ly),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $$e(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var r = !1;
  if (a2[e])
    e = a2[e], r = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var t = po.rgb.exec(e);
  return t ? { r: t[1], g: t[2], b: t[3] } : (t = po.rgba.exec(e), t ? { r: t[1], g: t[2], b: t[3], a: t[4] } : (t = po.hsl.exec(e), t ? { h: t[1], s: t[2], l: t[3] } : (t = po.hsla.exec(e), t ? { h: t[1], s: t[2], l: t[3], a: t[4] } : (t = po.hsv.exec(e), t ? { h: t[1], s: t[2], v: t[3] } : (t = po.hsva.exec(e), t ? { h: t[1], s: t[2], v: t[3], a: t[4] } : (t = po.hex8.exec(e), t ? {
    r: ha(t[1]),
    g: ha(t[2]),
    b: ha(t[3]),
    a: Y3(t[4]),
    format: r ? "name" : "hex8"
  } : (t = po.hex6.exec(e), t ? {
    r: ha(t[1]),
    g: ha(t[2]),
    b: ha(t[3]),
    format: r ? "name" : "hex"
  } : (t = po.hex4.exec(e), t ? {
    r: ha(t[1] + t[1]),
    g: ha(t[2] + t[2]),
    b: ha(t[3] + t[3]),
    a: Y3(t[4] + t[4]),
    format: r ? "name" : "hex8"
  } : (t = po.hex3.exec(e), t ? {
    r: ha(t[1] + t[1]),
    g: ha(t[2] + t[2]),
    b: ha(t[3] + t[3]),
    format: r ? "name" : "hex"
  } : !1)))))))));
}
function Oi(e) {
  return !!po.CSS_UNIT.exec(String(e));
}
var fu = (
  /** @class */
  function() {
    function e(r, t) {
      r === void 0 && (r = ""), t === void 0 && (t = {});
      var n;
      if (r instanceof e)
        return r;
      typeof r == "number" && (r = b$e(r)), this.originalInput = r;
      var a = y$e(r);
      this.originalInput = r, this.r = a.r, this.g = a.g, this.b = a.b, this.a = a.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (n = t.format) !== null && n !== void 0 ? n : a.format, this.gradientType = t.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = a.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var r = this.toRgb();
      return (r.r * 299 + r.g * 587 + r.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var r = this.toRgb(), t, n, a, i = r.r / 255, l = r.g / 255, u = r.b / 255;
      return i <= 0.03928 ? t = i / 12.92 : t = Math.pow((i + 0.055) / 1.055, 2.4), l <= 0.03928 ? n = l / 12.92 : n = Math.pow((l + 0.055) / 1.055, 2.4), u <= 0.03928 ? a = u / 12.92 : a = Math.pow((u + 0.055) / 1.055, 2.4), 0.2126 * t + 0.7152 * n + 0.0722 * a;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(r) {
      return this.a = M8(r), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var r = this.toHsl().s;
      return r === 0;
    }, e.prototype.toHsv = function() {
      var r = H3(this.r, this.g, this.b);
      return { h: r.h * 360, s: r.s, v: r.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var r = H3(this.r, this.g, this.b), t = Math.round(r.h * 360), n = Math.round(r.s * 100), a = Math.round(r.v * 100);
      return this.a === 1 ? "hsv(".concat(t, ", ").concat(n, "%, ").concat(a, "%)") : "hsva(".concat(t, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var r = W3(this.r, this.g, this.b);
      return { h: r.h * 360, s: r.s, l: r.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var r = W3(this.r, this.g, this.b), t = Math.round(r.h * 360), n = Math.round(r.s * 100), a = Math.round(r.l * 100);
      return this.a === 1 ? "hsl(".concat(t, ", ").concat(n, "%, ").concat(a, "%)") : "hsla(".concat(t, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(r) {
      return r === void 0 && (r = !1), G3(this.r, this.g, this.b, r);
    }, e.prototype.toHexString = function(r) {
      return r === void 0 && (r = !1), "#" + this.toHex(r);
    }, e.prototype.toHex8 = function(r) {
      return r === void 0 && (r = !1), g$e(this.r, this.g, this.b, this.a, r);
    }, e.prototype.toHex8String = function(r) {
      return r === void 0 && (r = !1), "#" + this.toHex8(r);
    }, e.prototype.toHexShortString = function(r) {
      return r === void 0 && (r = !1), this.a === 1 ? this.toHexString(r) : this.toHex8String(r);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var r = Math.round(this.r), t = Math.round(this.g), n = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(r, ", ").concat(t, ", ").concat(n, ")") : "rgba(".concat(r, ", ").concat(t, ", ").concat(n, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var r = function(t) {
        return "".concat(Math.round(dn(t, 255) * 100), "%");
      };
      return {
        r: r(this.r),
        g: r(this.g),
        b: r(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var r = function(t) {
        return Math.round(dn(t, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(r(this.r), "%, ").concat(r(this.g), "%, ").concat(r(this.b), "%)") : "rgba(".concat(r(this.r), "%, ").concat(r(this.g), "%, ").concat(r(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var r = "#" + G3(this.r, this.g, this.b, !1), t = 0, n = Object.entries(a2); t < n.length; t++) {
        var a = n[t], i = a[0], l = a[1];
        if (r === l)
          return i;
      }
      return !1;
    }, e.prototype.toString = function(r) {
      var t = !!r;
      r = r != null ? r : this.format;
      var n = !1, a = this.a < 1 && this.a >= 0, i = !t && a && (r.startsWith("hex") || r === "name");
      return i ? r === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (r === "rgb" && (n = this.toRgbString()), r === "prgb" && (n = this.toPercentageRgbString()), (r === "hex" || r === "hex6") && (n = this.toHexString()), r === "hex3" && (n = this.toHexString(!0)), r === "hex4" && (n = this.toHex8String(!0)), r === "hex8" && (n = this.toHex8String()), r === "name" && (n = this.toName()), r === "hsl" && (n = this.toHslString()), r === "hsv" && (n = this.toHsvString()), n || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.l += r / 100, t.l = Vh(t.l), new e(t);
    }, e.prototype.brighten = function(r) {
      r === void 0 && (r = 10);
      var t = this.toRgb();
      return t.r = Math.max(0, Math.min(255, t.r - Math.round(255 * -(r / 100)))), t.g = Math.max(0, Math.min(255, t.g - Math.round(255 * -(r / 100)))), t.b = Math.max(0, Math.min(255, t.b - Math.round(255 * -(r / 100)))), new e(t);
    }, e.prototype.darken = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.l -= r / 100, t.l = Vh(t.l), new e(t);
    }, e.prototype.tint = function(r) {
      return r === void 0 && (r = 10), this.mix("white", r);
    }, e.prototype.shade = function(r) {
      return r === void 0 && (r = 10), this.mix("black", r);
    }, e.prototype.desaturate = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.s -= r / 100, t.s = Vh(t.s), new e(t);
    }, e.prototype.saturate = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.s += r / 100, t.s = Vh(t.s), new e(t);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(r) {
      var t = this.toHsl(), n = (t.h + r) % 360;
      return t.h = n < 0 ? 360 + n : n, new e(t);
    }, e.prototype.mix = function(r, t) {
      t === void 0 && (t = 50);
      var n = this.toRgb(), a = new e(r).toRgb(), i = t / 100, l = {
        r: (a.r - n.r) * i + n.r,
        g: (a.g - n.g) * i + n.g,
        b: (a.b - n.b) * i + n.b,
        a: (a.a - n.a) * i + n.a
      };
      return new e(l);
    }, e.prototype.analogous = function(r, t) {
      r === void 0 && (r = 6), t === void 0 && (t = 30);
      var n = this.toHsl(), a = 360 / t, i = [this];
      for (n.h = (n.h - (a * r >> 1) + 720) % 360; --r; )
        n.h = (n.h + a) % 360, i.push(new e(n));
      return i;
    }, e.prototype.complement = function() {
      var r = this.toHsl();
      return r.h = (r.h + 180) % 360, new e(r);
    }, e.prototype.monochromatic = function(r) {
      r === void 0 && (r = 6);
      for (var t = this.toHsv(), n = t.h, a = t.s, i = t.v, l = [], u = 1 / r; r--; )
        l.push(new e({ h: n, s: a, v: i })), i = (i + u) % 1;
      return l;
    }, e.prototype.splitcomplement = function() {
      var r = this.toHsl(), t = r.h;
      return [
        this,
        new e({ h: (t + 72) % 360, s: r.s, l: r.l }),
        new e({ h: (t + 216) % 360, s: r.s, l: r.l })
      ];
    }, e.prototype.onBackground = function(r) {
      var t = this.toRgb(), n = new e(r).toRgb(), a = t.a + n.a * (1 - t.a);
      return new e({
        r: (t.r * t.a + n.r * n.a * (1 - t.a)) / a,
        g: (t.g * t.a + n.g * n.a * (1 - t.a)) / a,
        b: (t.b * t.a + n.b * n.a * (1 - t.a)) / a,
        a
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(r) {
      for (var t = this.toHsl(), n = t.h, a = [this], i = 360 / r, l = 1; l < r; l++)
        a.push(new e({ h: (n + l * i) % 360, s: t.s, l: t.l }));
      return a;
    }, e.prototype.equals = function(r) {
      return this.toRgbString() === new e(r).toRgbString();
    }, e;
  }()
);
function R8(e) {
  if (e === void 0 && (e = {}), e.count !== void 0 && e.count !== null) {
    var r = e.count, t = [];
    for (e.count = void 0; r > t.length; )
      e.count = null, e.seed && (e.seed += 1), t.push(R8(e));
    return e.count = r, t;
  }
  var n = w$e(e.hue, e.seed), a = _$e(n, e), i = T$e(n, a, e), l = { h: n, s: a, v: i };
  return e.alpha !== void 0 && (l.a = e.alpha), new fu(l);
}
function w$e(e, r) {
  var t = E$e(e), n = j0(t, r);
  return n < 0 && (n = 360 + n), n;
}
function _$e(e, r) {
  if (r.hue === "monochrome")
    return 0;
  if (r.luminosity === "random")
    return j0([0, 100], r.seed);
  var t = P8(e).saturationRange, n = t[0], a = t[1];
  switch (r.luminosity) {
    case "bright":
      n = 55;
      break;
    case "dark":
      n = a - 10;
      break;
    case "light":
      a = 55;
      break;
  }
  return j0([n, a], r.seed);
}
function T$e(e, r, t) {
  var n = C$e(e, r), a = 100;
  switch (t.luminosity) {
    case "dark":
      a = n + 20;
      break;
    case "light":
      n = (a + n) / 2;
      break;
    case "random":
      n = 0, a = 100;
      break;
  }
  return j0([n, a], t.seed);
}
function C$e(e, r) {
  for (var t = P8(e).lowerBounds, n = 0; n < t.length - 1; n++) {
    var a = t[n][0], i = t[n][1], l = t[n + 1][0], u = t[n + 1][1];
    if (r >= a && r <= l) {
      var c = (u - i) / (l - a), f = i - c * a;
      return c * r + f;
    }
  }
  return 0;
}
function E$e(e) {
  var r = parseInt(e, 10);
  if (!Number.isNaN(r) && r < 360 && r > 0)
    return [r, r];
  if (typeof e == "string") {
    var t = j8.find(function(l) {
      return l.name === e;
    });
    if (t) {
      var n = k8(t);
      if (n.hueRange)
        return n.hueRange;
    }
    var a = new fu(e);
    if (a.isValid) {
      var i = a.toHsv().h;
      return [i, i];
    }
  }
  return [0, 360];
}
function P8(e) {
  e >= 334 && e <= 360 && (e -= 360);
  for (var r = 0, t = j8; r < t.length; r++) {
    var n = t[r], a = k8(n);
    if (a.hueRange && e >= a.hueRange[0] && e <= a.hueRange[1])
      return a;
  }
  throw Error("Color not found");
}
function j0(e, r) {
  if (r === void 0)
    return Math.floor(e[0] + Math.random() * (e[1] + 1 - e[0]));
  var t = e[1] || 1, n = e[0] || 0;
  r = (r * 9301 + 49297) % 233280;
  var a = r / 233280;
  return Math.floor(n + a * (t - n));
}
function k8(e) {
  var r = e.lowerBounds[0][0], t = e.lowerBounds[e.lowerBounds.length - 1][0], n = e.lowerBounds[e.lowerBounds.length - 1][1], a = e.lowerBounds[0][1];
  return {
    name: e.name,
    hueRange: e.hueRange,
    lowerBounds: e.lowerBounds,
    saturationRange: [r, t],
    brightnessRange: [n, a]
  };
}
var j8 = [
  {
    name: "monochrome",
    hueRange: null,
    lowerBounds: [
      [0, 0],
      [100, 0]
    ]
  },
  {
    name: "red",
    hueRange: [-26, 18],
    lowerBounds: [
      [20, 100],
      [30, 92],
      [40, 89],
      [50, 85],
      [60, 78],
      [70, 70],
      [80, 60],
      [90, 55],
      [100, 50]
    ]
  },
  {
    name: "orange",
    hueRange: [19, 46],
    lowerBounds: [
      [20, 100],
      [30, 93],
      [40, 88],
      [50, 86],
      [60, 85],
      [70, 70],
      [100, 70]
    ]
  },
  {
    name: "yellow",
    hueRange: [47, 62],
    lowerBounds: [
      [25, 100],
      [40, 94],
      [50, 89],
      [60, 86],
      [70, 84],
      [80, 82],
      [90, 80],
      [100, 75]
    ]
  },
  {
    name: "green",
    hueRange: [63, 178],
    lowerBounds: [
      [30, 100],
      [40, 90],
      [50, 85],
      [60, 81],
      [70, 74],
      [80, 64],
      [90, 50],
      [100, 40]
    ]
  },
  {
    name: "blue",
    hueRange: [179, 257],
    lowerBounds: [
      [20, 100],
      [30, 86],
      [40, 80],
      [50, 74],
      [60, 60],
      [70, 52],
      [80, 44],
      [90, 39],
      [100, 35]
    ]
  },
  {
    name: "purple",
    hueRange: [258, 282],
    lowerBounds: [
      [20, 100],
      [30, 87],
      [40, 79],
      [50, 70],
      [60, 65],
      [70, 59],
      [80, 52],
      [90, 45],
      [100, 42]
    ]
  },
  {
    name: "pink",
    hueRange: [283, 334],
    lowerBounds: [
      [20, 100],
      [30, 90],
      [40, 86],
      [60, 84],
      [80, 80],
      [90, 75],
      [100, 73]
    ]
  }
], Ye = function(r, t, n) {
  var a = c8(r, "colors." + t, t), i = new fu(a), l = i.isValid;
  return l ? a : n;
}, A$e = function(r) {
  return function(t) {
    var n = Ye(t, r), a = new fu(n).isDark();
    return a ? "dark" : "light";
  };
}, I$e = function(r) {
  return function(t) {
    return A$e(r)(t) === "dark";
  };
}, Wa = function(r, t) {
  return function(n) {
    var a = Ye(n, r);
    return new fu(a).setAlpha(t).toRgbString();
  };
}, O$e = function(r, t) {
  return function(n) {
    var a = Ye(n, r);
    return new fu(a).darken(t).toHexString();
  };
}, M$e = function(r, t) {
  return function(n) {
    return new fu(Ye(n, r)).lighten(t).toHexString();
  };
};
function K3(e, r) {
  return e === void 0 && (e = "1rem"), r === void 0 && (r = "rgba(255, 255, 255, 0.15)"), {
    backgroundImage: `linear-gradient(
    45deg,
    ` + r + ` 25%,
    transparent 25%,
    transparent 50%,
    ` + r + ` 50%,
    ` + r + ` 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: e + " " + e
  };
}
function R$e(e) {
  var r = R8().toHexString();
  return !e || xxe(e) ? r : e.string && e.colors ? k$e(e.string, e.colors) : e.string && !e.colors ? P$e(e.string) : e.colors && !e.string ? j$e(e.colors) : r;
}
function P$e(e) {
  var r = 0;
  if (e.length === 0)
    return r.toString();
  for (var t = 0; t < e.length; t += 1)
    r = e.charCodeAt(t) + ((r << 5) - r), r = r & r;
  for (var n = "#", a = 0; a < 3; a += 1) {
    var i = r >> a * 8 & 255;
    n += ("00" + i.toString(16)).substr(-2);
  }
  return n;
}
function k$e(e, r) {
  var t = 0;
  if (e.length === 0)
    return r[0];
  for (var n = 0; n < e.length; n += 1)
    t = e.charCodeAt(n) + ((t << 5) - t), t = t & t;
  return t = (t % r.length + r.length) % r.length, r[t];
}
function j$e(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function H(e, r) {
  return function(t) {
    return t.colorMode === "dark" ? r : e;
  };
}
function rv(e) {
  var r = e.orientation, t = e.vertical, n = e.horizontal;
  return r ? r === "vertical" ? t : n : {};
}
function o2() {
  return o2 = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, o2.apply(this, arguments);
}
var D$e = function(r) {
  return Exe({
    condition: !0,
    message: ["[chakra-ui]: createBreakpoints(...) will be deprecated pretty soon", "simply pass the breakpoints as an object. Remove the createBreakpoint(..) call"].join("")
  }), o2({
    base: "0em"
  }, r);
};
function q3(e, r) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function N$e(e, r, t) {
  return r && q3(e.prototype, r), t && q3(e, t), e;
}
var L$e = /* @__PURE__ */ function() {
  function e(r) {
    var t = this;
    this.map = {}, this.called = !1, this.assert = function() {
      if (!t.called) {
        t.called = !0;
        return;
      }
      throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
    }, this.parts = function() {
      t.assert();
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      for (var l = 0, u = a; l < u.length; l++) {
        var c = u[l];
        t.map[c] = t.toPart(c);
      }
      return t;
    }, this.extend = function() {
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      for (var l = 0, u = a; l < u.length; l++) {
        var c = u[l];
        c in t.map || (t.map[c] = t.toPart(c));
      }
      return t;
    }, this.toPart = function(n) {
      var a = ["container", "root"].includes(n != null ? n : "") ? [t.name] : [t.name, n], i = a.filter(Boolean).join("__"), l = "chakra-" + i, u = {
        className: l,
        selector: "." + l,
        toString: function() {
          return n;
        }
      };
      return u;
    }, this.__type = {};
  }
  return N$e(e, [{
    key: "selectors",
    get: (
      /**
       * Get all selectors for the component anatomy
       */
      function() {
        var t = Xx(Object.entries(this.map).map(function(n) {
          var a = n[0], i = n[1];
          return [a, i.selector];
        }));
        return t;
      }
    )
    /**
     * Get all classNames for the component anatomy
     */
  }, {
    key: "classNames",
    get: function() {
      var t = Xx(Object.entries(this.map).map(function(n) {
        var a = n[0], i = n[1];
        return [a, i.className];
      }));
      return t;
    }
    /**
     * Get all parts as array of string
     */
  }, {
    key: "keys",
    get: function() {
      return Object.keys(this.map);
    }
    /**
     * Creates the part object for the given part
     */
  }]), e;
}();
function qr(e) {
  return new L$e(e);
}
function D8(e) {
  return oi(e) && e.reference ? e.reference : String(e);
}
var hm = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(D8).join(" " + r + " ").replace(/calc/g, "");
}, Z3 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + hm.apply(void 0, ["+"].concat(t)) + ")";
}, Q3 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + hm.apply(void 0, ["-"].concat(t)) + ")";
}, i2 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + hm.apply(void 0, ["*"].concat(t)) + ")";
}, X3 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + hm.apply(void 0, ["/"].concat(t)) + ")";
}, J3 = function(r) {
  var t = D8(r);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : "-" + t : i2(t, -1);
}, xo = Object.assign(function(e) {
  return {
    add: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return xo(Z3.apply(void 0, [e].concat(n)));
    },
    subtract: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return xo(Q3.apply(void 0, [e].concat(n)));
    },
    multiply: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return xo(i2.apply(void 0, [e].concat(n)));
    },
    divide: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return xo(X3.apply(void 0, [e].concat(n)));
    },
    negate: function() {
      return xo(J3(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: Z3,
  subtract: Q3,
  multiply: i2,
  divide: X3,
  negate: J3
});
function F$e(e) {
  return !Number.isInteger(parseFloat(e.toString()));
}
function z$e(e, r) {
  return r === void 0 && (r = "-"), e.replace(/\s+/g, r);
}
function N8(e) {
  var r = z$e(e.toString());
  return r.includes("\\.") ? e : F$e(e) ? r.replace(".", "\\.") : e;
}
function B$e(e, r) {
  return r === void 0 && (r = ""), [r, N8(e)].filter(Boolean).join("-");
}
function U$e(e, r) {
  return "var(" + N8(e) + (r ? ", " + r : "") + ")";
}
function V$e(e, r) {
  return r === void 0 && (r = ""), "--" + B$e(e, r);
}
function wt(e, r) {
  var t = V$e(e, r == null ? void 0 : r.prefix);
  return {
    variable: t,
    reference: U$e(t, W$e(r == null ? void 0 : r.fallback))
  };
}
function W$e(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.reference;
}
var H$e = qr("accordion").parts("root", "container", "button", "panel").extend("icon"), G$e = qr("alert").parts("title", "description", "container").extend("icon"), Y$e = qr("avatar").parts("label", "badge", "container").extend("excessLabel", "group"), K$e = qr("breadcrumb").parts("link", "item", "container").extend("separator");
qr("button").parts();
var L8 = qr("checkbox").parts("control", "icon", "container").extend("label");
qr("progress").parts("track", "filledTrack").extend("label");
var q$e = qr("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), Z$e = qr("editable").parts("preview", "input", "textarea"), Q$e = qr("form").parts("container", "requiredIndicator", "helperText"), X$e = qr("formError").parts("text", "icon"), F8 = qr("input").parts("addon", "field", "element"), J$e = qr("list").parts("container", "item", "icon"), ewe = qr("menu").parts("button", "list", "item").extend("groupTitle", "command", "divider"), z8 = qr("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), rwe = qr("numberinput").parts("root", "field", "stepperGroup", "stepper");
qr("pininput").parts("field");
var B8 = qr("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton"), twe = qr("progress").parts("label", "filledTrack", "track"), U8 = qr("radio").parts("container", "control", "label"), nwe = qr("select").parts("field", "icon"), awe = qr("slider").parts("container", "track", "thumb", "filledTrack"), owe = qr("stat").parts("container", "label", "helpText", "number", "icon"), V8 = qr("switch").parts("container", "track", "thumb"), iwe = qr("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption"), swe = qr("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator"), lwe = qr("tag").parts("container", "label", "closeButton"), W8 = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  }
}, uwe = {
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
}, cwe = {
  transitionProperty: "common",
  transitionDuration: "normal",
  fontSize: "1rem",
  _focus: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "blackAlpha.50"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: 4,
  py: 2
}, dwe = {
  pt: 2,
  px: 4,
  pb: 5
}, fwe = {
  fontSize: "1.25em"
}, vwe = {
  root: {},
  container: uwe,
  button: cwe,
  panel: dwe,
  icon: fwe
}, hwe = {
  parts: H$e.keys,
  baseStyle: vwe
}, pwe = {
  container: {
    px: 4,
    py: 3
  },
  title: {
    fontWeight: "bold",
    lineHeight: 6,
    marginEnd: 2
  },
  description: {
    lineHeight: 6
  },
  icon: {
    flexShrink: 0,
    marginEnd: 3,
    w: 5,
    h: 6
  }
};
function c_(e) {
  var r = e.theme, t = e.colorScheme, n = Ye(r, t + ".100", t), a = Wa(t + ".200", 0.16)(r);
  return H(n, a)(e);
}
var gwe = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      bg: c_(r)
    },
    icon: {
      color: H(t + ".500", t + ".200")(r)
    }
  };
}, mwe = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      paddingStart: 3,
      borderStartWidth: "4px",
      borderStartColor: H(t + ".500", t + ".200")(r),
      bg: c_(r)
    },
    icon: {
      color: H(t + ".500", t + ".200")(r)
    }
  };
}, bwe = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      pt: 2,
      borderTopWidth: "4px",
      borderTopColor: H(t + ".500", t + ".200")(r),
      bg: c_(r)
    },
    icon: {
      color: H(t + ".500", t + ".200")(r)
    }
  };
}, ywe = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      bg: H(t + ".500", t + ".200")(r),
      color: H("white", "gray.900")(r)
    }
  };
}, Swe = {
  subtle: gwe,
  "left-accent": mwe,
  "top-accent": bwe,
  solid: ywe
}, xwe = {
  variant: "subtle",
  colorScheme: "blue"
}, $we = {
  parts: G$e.keys,
  baseStyle: pwe,
  variants: Swe,
  defaultProps: xwe
}, wwe = function(r) {
  return {
    transform: "translate(25%, 25%)",
    borderRadius: "full",
    border: "0.2em solid",
    borderColor: H("white", "gray.800")(r)
  };
}, _we = function(r) {
  return {
    bg: H("gray.200", "whiteAlpha.400")(r)
  };
}, Twe = function(r) {
  var t = r.name, n = r.theme, a = t ? R$e({
    string: t
  }) : "gray.400", i = I$e(a)(n), l = "white";
  i || (l = "gray.800");
  var u = H("white", "gray.800")(r);
  return {
    bg: a,
    color: l,
    borderColor: u,
    verticalAlign: "top"
  };
}, Cwe = function(r) {
  return {
    badge: wwe(r),
    excessLabel: _we(r),
    container: Twe(r)
  };
};
function ys(e) {
  var r = O8[e];
  return {
    container: {
      width: e,
      height: e,
      fontSize: "calc(" + (r != null ? r : e) + " / 2.5)"
    },
    excessLabel: {
      width: e,
      height: e
    },
    label: {
      fontSize: "calc(" + (r != null ? r : e) + " / 2.5)",
      lineHeight: e !== "100%" ? r != null ? r : e : void 0
    }
  };
}
var Ewe = {
  "2xs": ys("4"),
  xs: ys("6"),
  sm: ys("8"),
  md: ys("12"),
  lg: ys("16"),
  xl: ys("24"),
  "2xl": ys("32"),
  full: ys("100%")
}, Awe = {
  size: "md"
}, Iwe = {
  parts: Y$e.keys,
  baseStyle: Cwe,
  sizes: Ewe,
  defaultProps: Awe
}, Owe = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold"
}, Mwe = function(r) {
  var t = r.colorScheme, n = r.theme, a = Wa(t + ".500", 0.6)(n);
  return {
    bg: H(t + ".500", a)(r),
    color: H("white", "whiteAlpha.800")(r)
  };
}, Rwe = function(r) {
  var t = r.colorScheme, n = r.theme, a = Wa(t + ".200", 0.16)(n);
  return {
    bg: H(t + ".100", a)(r),
    color: H(t + ".800", t + ".200")(r)
  };
}, Pwe = function(r) {
  var t = r.colorScheme, n = r.theme, a = Wa(t + ".200", 0.8)(n), i = Ye(n, t + ".500"), l = H(i, a)(r);
  return {
    color: l,
    boxShadow: "inset 0 0 0px 1px " + l
  };
}, kwe = {
  solid: Mwe,
  subtle: Rwe,
  outline: Pwe
}, jwe = {
  variant: "subtle",
  colorScheme: "gray"
}, hc = {
  baseStyle: Owe,
  variants: kwe,
  defaultProps: jwe
}, Dwe = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focus: {
    boxShadow: "outline"
  }
}, Nwe = {
  link: Dwe
}, Lwe = {
  parts: K$e.keys,
  baseStyle: Nwe
}, Fwe = {
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focus: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
}, H8 = function(r) {
  var t = r.colorScheme, n = r.theme;
  if (t === "gray")
    return {
      color: H("inherit", "whiteAlpha.900")(r),
      _hover: {
        bg: H("gray.100", "whiteAlpha.200")(r)
      },
      _active: {
        bg: H("gray.200", "whiteAlpha.300")(r)
      }
    };
  var a = Wa(t + ".200", 0.12)(n), i = Wa(t + ".200", 0.24)(n);
  return {
    color: H(t + ".600", t + ".200")(r),
    bg: "transparent",
    _hover: {
      bg: H(t + ".50", a)(r)
    },
    _active: {
      bg: H(t + ".100", i)(r)
    }
  };
}, zwe = function(r) {
  var t = r.colorScheme, n = H("gray.200", "whiteAlpha.300")(r);
  return Ot({
    border: "1px solid",
    borderColor: t === "gray" ? n : "currentColor"
  }, H8(r));
}, Bwe = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
}, Uwe = function(r) {
  var t, n = r.colorScheme;
  if (n === "gray") {
    var a = H("gray.100", "whiteAlpha.200")(r);
    return {
      bg: a,
      _hover: {
        bg: H("gray.200", "whiteAlpha.300")(r),
        _disabled: {
          bg: a
        }
      },
      _active: {
        bg: H("gray.300", "whiteAlpha.400")(r)
      }
    };
  }
  var i = (t = Bwe[n]) != null ? t : {}, l = i.bg, u = l === void 0 ? n + ".500" : l, c = i.color, f = c === void 0 ? "white" : c, h = i.hoverBg, p = h === void 0 ? n + ".600" : h, g = i.activeBg, y = g === void 0 ? n + ".700" : g, S = H(u, n + ".200")(r);
  return {
    bg: S,
    color: H(f, "gray.800")(r),
    _hover: {
      bg: H(p, n + ".300")(r),
      _disabled: {
        bg: S
      }
    },
    _active: {
      bg: H(y, n + ".400")(r)
    }
  };
}, Vwe = function(r) {
  var t = r.colorScheme;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: H(t + ".500", t + ".200")(r),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: H(t + ".700", t + ".500")(r)
    }
  };
}, Wwe = {
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: 0,
  p: 0
}, Hwe = {
  ghost: H8,
  outline: zwe,
  solid: Uwe,
  link: Vwe,
  unstyled: Wwe
}, Gwe = {
  lg: {
    h: 12,
    minW: 12,
    fontSize: "lg",
    px: 6
  },
  md: {
    h: 10,
    minW: 10,
    fontSize: "md",
    px: 4
  },
  sm: {
    h: 8,
    minW: 8,
    fontSize: "sm",
    px: 3
  },
  xs: {
    h: 6,
    minW: 6,
    fontSize: "xs",
    px: 2
  }
}, Ywe = {
  variant: "solid",
  size: "md",
  colorScheme: "gray"
}, Kwe = {
  baseStyle: Fwe,
  variants: Hwe,
  sizes: Gwe,
  defaultProps: Ywe
}, qwe = function(r) {
  var t = r.colorScheme;
  return {
    w: "100%",
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "inherit",
    color: "white",
    _checked: {
      bg: H(t + ".500", t + ".200")(r),
      borderColor: H(t + ".500", t + ".200")(r),
      color: H("white", "gray.900")(r),
      _hover: {
        bg: H(t + ".600", t + ".300")(r),
        borderColor: H(t + ".600", t + ".300")(r)
      },
      _disabled: {
        borderColor: H("gray.200", "transparent")(r),
        bg: H("gray.200", "whiteAlpha.300")(r),
        color: H("gray.500", "whiteAlpha.500")(r)
      }
    },
    _indeterminate: {
      bg: H(t + ".500", t + ".200")(r),
      borderColor: H(t + ".500", t + ".200")(r),
      color: H("white", "gray.900")(r)
    },
    _disabled: {
      bg: H("gray.100", "whiteAlpha.100")(r),
      borderColor: H("gray.100", "transparent")(r)
    },
    _focus: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: H("red.500", "red.300")(r)
    }
  };
}, Zwe = {
  _disabled: {
    cursor: "not-allowed"
  }
}, Qwe = {
  userSelect: "none",
  _disabled: {
    opacity: 0.4
  }
}, Xwe = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, Jwe = function(r) {
  return {
    icon: Xwe,
    container: Zwe,
    control: qwe(r),
    label: Qwe
  };
}, e_e = {
  sm: {
    control: {
      h: 3,
      w: 3
    },
    label: {
      fontSize: "sm"
    },
    icon: {
      fontSize: "0.45rem"
    }
  },
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    },
    icon: {
      fontSize: "0.625rem"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    },
    icon: {
      fontSize: "0.625rem"
    }
  }
}, r_e = {
  size: "md",
  colorScheme: "blue"
}, D0 = {
  parts: L8.keys,
  baseStyle: Jwe,
  sizes: e_e,
  defaultProps: r_e
}, Hh, Gh, Yh, Gd = wt("close-button-size"), t_e = function(r) {
  var t = H("blackAlpha.100", "whiteAlpha.100")(r), n = H("blackAlpha.200", "whiteAlpha.200")(r);
  return {
    w: [Gd.reference],
    h: [Gd.reference],
    borderRadius: "md",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
      boxShadow: "none"
    },
    _hover: {
      bg: t
    },
    _active: {
      bg: n
    },
    _focus: {
      boxShadow: "outline"
    }
  };
}, n_e = {
  lg: (Hh = {}, Hh[Gd.variable] = "40px", Hh.fontSize = "16px", Hh),
  md: (Gh = {}, Gh[Gd.variable] = "32px", Gh.fontSize = "12px", Gh),
  sm: (Yh = {}, Yh[Gd.variable] = "24px", Yh.fontSize = "10px", Yh)
}, a_e = {
  size: "md"
}, o_e = {
  baseStyle: t_e,
  sizes: n_e,
  defaultProps: a_e
}, i_e = hc.variants, s_e = hc.defaultProps, l_e = {
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm"
}, u_e = {
  baseStyle: l_e,
  variants: i_e,
  defaultProps: s_e
}, c_e = {
  w: "100%",
  mx: "auto",
  maxW: "60ch",
  px: "1rem"
}, d_e = {
  baseStyle: c_e
}, f_e = {
  opacity: 0.6,
  borderColor: "inherit"
}, v_e = {
  borderStyle: "solid"
}, h_e = {
  borderStyle: "dashed"
}, p_e = {
  solid: v_e,
  dashed: h_e
}, g_e = {
  variant: "solid"
}, m_e = {
  baseStyle: f_e,
  variants: p_e,
  defaultProps: g_e
};
function Fu(e) {
  return e === "full" ? {
    dialog: {
      maxW: "100vw",
      h: "100vh"
    }
  } : {
    dialog: {
      maxW: e
    }
  };
}
var b_e = {
  bg: "blackAlpha.600",
  zIndex: "overlay"
}, y_e = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
}, S_e = function(r) {
  var t = r.isFullHeight;
  return Ot({}, t && {
    height: "100vh"
  }, {
    zIndex: "modal",
    maxH: "100vh",
    bg: H("white", "gray.700")(r),
    color: "inherit",
    boxShadow: H("lg", "dark-lg")(r)
  });
}, x_e = {
  px: 6,
  py: 4,
  fontSize: "xl",
  fontWeight: "semibold"
}, $_e = {
  position: "absolute",
  top: 2,
  insetEnd: 3
}, w_e = {
  px: 6,
  py: 2,
  flex: 1,
  overflow: "auto"
}, __e = {
  px: 6,
  py: 4
}, T_e = function(r) {
  return {
    overlay: b_e,
    dialogContainer: y_e,
    dialog: S_e(r),
    header: x_e,
    closeButton: $_e,
    body: w_e,
    footer: __e
  };
}, C_e = {
  xs: Fu("xs"),
  sm: Fu("md"),
  md: Fu("lg"),
  lg: Fu("2xl"),
  xl: Fu("4xl"),
  full: Fu("full")
}, E_e = {
  size: "xs"
}, A_e = {
  parts: q$e.keys,
  baseStyle: T_e,
  sizes: C_e,
  defaultProps: E_e
}, I_e = {
  borderRadius: "md",
  py: "3px",
  transitionProperty: "common",
  transitionDuration: "normal"
}, O_e = {
  borderRadius: "md",
  py: "3px",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focus: {
    boxShadow: "outline"
  },
  _placeholder: {
    opacity: 0.6
  }
}, M_e = {
  borderRadius: "md",
  py: "3px",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focus: {
    boxShadow: "outline"
  },
  _placeholder: {
    opacity: 0.6
  }
}, R_e = {
  preview: I_e,
  input: O_e,
  textarea: M_e
}, P_e = {
  parts: Z$e.keys,
  baseStyle: R_e
}, k_e = function(r) {
  return {
    marginStart: 1,
    color: H("red.500", "red.300")(r)
  };
}, j_e = function(r) {
  return {
    mt: 2,
    color: H("gray.500", "whiteAlpha.600")(r),
    lineHeight: "normal",
    fontSize: "sm"
  };
}, D_e = function(r) {
  return {
    container: {
      width: "100%",
      position: "relative"
    },
    requiredIndicator: k_e(r),
    helperText: j_e(r)
  };
}, N_e = {
  parts: Q$e.keys,
  baseStyle: D_e
}, L_e = function(r) {
  return {
    color: H("red.500", "red.300")(r),
    mt: 2,
    fontSize: "sm",
    lineHeight: "normal"
  };
}, F_e = function(r) {
  return {
    marginEnd: "0.5em",
    color: H("red.500", "red.300")(r)
  };
}, z_e = function(r) {
  return {
    text: L_e(r),
    icon: F_e(r)
  };
}, B_e = {
  parts: X$e.keys,
  baseStyle: z_e
}, U_e = {
  fontSize: "md",
  marginEnd: 3,
  mb: 2,
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
}, V_e = {
  baseStyle: U_e
}, W_e = {
  fontFamily: "heading",
  fontWeight: "bold"
}, H_e = {
  "4xl": {
    fontSize: ["6xl", null, "7xl"],
    lineHeight: 1
  },
  "3xl": {
    fontSize: ["5xl", null, "6xl"],
    lineHeight: 1
  },
  "2xl": {
    fontSize: ["4xl", null, "5xl"],
    lineHeight: [1.2, null, 1]
  },
  xl: {
    fontSize: ["3xl", null, "4xl"],
    lineHeight: [1.33, null, 1.2]
  },
  lg: {
    fontSize: ["2xl", null, "3xl"],
    lineHeight: [1.33, null, 1.2]
  },
  md: {
    fontSize: "xl",
    lineHeight: 1.2
  },
  sm: {
    fontSize: "md",
    lineHeight: 1.2
  },
  xs: {
    fontSize: "sm",
    lineHeight: 1.2
  }
}, G_e = {
  size: "xl"
}, Y_e = {
  baseStyle: W_e,
  sizes: H_e,
  defaultProps: G_e
}, K_e = {
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal"
  }
}, Ss = {
  lg: {
    fontSize: "lg",
    px: 4,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    px: 4,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    px: 3,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    px: 2,
    h: 6,
    borderRadius: "sm"
  }
}, q_e = {
  lg: {
    field: Ss.lg,
    addon: Ss.lg
  },
  md: {
    field: Ss.md,
    addon: Ss.md
  },
  sm: {
    field: Ss.sm,
    addon: Ss.sm
  },
  xs: {
    field: Ss.xs,
    addon: Ss.xs
  }
};
function d_(e) {
  var r = e.focusBorderColor, t = e.errorBorderColor;
  return {
    focusBorderColor: r || H("blue.500", "blue.300")(e),
    errorBorderColor: t || H("red.500", "red.300")(e)
  };
}
var Z_e = function(r) {
  var t = r.theme, n = d_(r), a = n.focusBorderColor, i = n.errorBorderColor;
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: H("gray.300", "whiteAlpha.400")(r)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      },
      _invalid: {
        borderColor: Ye(t, i),
        boxShadow: "0 0 0 1px " + Ye(t, i)
      },
      _focus: {
        zIndex: 1,
        borderColor: Ye(t, a),
        boxShadow: "0 0 0 1px " + Ye(t, a)
      }
    },
    addon: {
      border: "1px solid",
      borderColor: H("inherit", "whiteAlpha.50")(r),
      bg: H("gray.100", "whiteAlpha.300")(r)
    }
  };
}, Q_e = function(r) {
  var t = r.theme, n = d_(r), a = n.focusBorderColor, i = n.errorBorderColor;
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: H("gray.100", "whiteAlpha.50")(r),
      _hover: {
        bg: H("gray.200", "whiteAlpha.100")(r)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      },
      _invalid: {
        borderColor: Ye(t, i)
      },
      _focus: {
        bg: "transparent",
        borderColor: Ye(t, a)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: H("gray.100", "whiteAlpha.50")(r)
    }
  };
}, X_e = function(r) {
  var t = r.theme, n = d_(r), a = n.focusBorderColor, i = n.errorBorderColor;
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: 0,
      px: 0,
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Ye(t, i),
        boxShadow: "0px 1px 0px 0px " + Ye(t, i)
      },
      _focus: {
        borderColor: Ye(t, a),
        boxShadow: "0px 1px 0px 0px " + Ye(t, a)
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: 0,
      px: 0,
      bg: "transparent"
    }
  };
}, J_e = {
  field: {
    bg: "transparent",
    px: 0,
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: 0,
    height: "auto"
  }
}, e5e = {
  outline: Z_e,
  filled: Q_e,
  flushed: X_e,
  unstyled: J_e
}, r5e = {
  size: "md",
  variant: "outline"
}, pt = {
  parts: F8.keys,
  baseStyle: K_e,
  sizes: q_e,
  variants: e5e,
  defaultProps: r5e
}, t5e = function(r) {
  return {
    bg: H("gray.100", "whiteAlpha")(r),
    borderRadius: "md",
    borderWidth: "1px",
    borderBottomWidth: "3px",
    fontSize: "0.8em",
    fontWeight: "bold",
    lineHeight: "normal",
    px: "0.4em",
    whiteSpace: "nowrap"
  };
}, n5e = {
  baseStyle: t5e
}, a5e = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focus: {
    boxShadow: "outline"
  }
}, o5e = {
  baseStyle: a5e
}, i5e = {
  marginEnd: "0.5rem",
  display: "inline",
  verticalAlign: "text-bottom"
}, s5e = {
  container: {},
  item: {},
  icon: i5e
}, l5e = {
  parts: J$e.keys,
  baseStyle: s5e
}, u5e = function(r) {
  return {
    bg: H("#fff", "gray.700")(r),
    boxShadow: H("sm", "dark-lg")(r),
    color: "inherit",
    minW: "3xs",
    py: "2",
    zIndex: 1,
    borderRadius: "md",
    borderWidth: "1px"
  };
}, c5e = function(r) {
  return {
    py: "0.4rem",
    px: "0.8rem",
    transitionProperty: "background",
    transitionDuration: "ultra-fast",
    transitionTimingFunction: "ease-in",
    _focus: {
      bg: H("gray.100", "whiteAlpha.100")(r)
    },
    _active: {
      bg: H("gray.200", "whiteAlpha.200")(r)
    },
    _expanded: {
      bg: H("gray.100", "whiteAlpha.100")(r)
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  };
}, d5e = {
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
}, f5e = {
  opacity: 0.6
}, v5e = {
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "0.5rem",
  opacity: 0.6
}, h5e = {
  transitionProperty: "common",
  transitionDuration: "normal"
}, p5e = function(r) {
  return {
    button: h5e,
    list: u5e(r),
    item: c5e(r),
    groupTitle: d5e,
    command: f5e,
    divider: v5e
  };
}, g5e = {
  parts: ewe.keys,
  baseStyle: p5e
}, m5e = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, b5e = function(r) {
  var t = r.isCentered, n = r.scrollBehavior;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: t ? "center" : "flex-start",
    overflow: n === "inside" ? "hidden" : "auto"
  };
}, y5e = function(r) {
  var t = r.scrollBehavior;
  return {
    borderRadius: "md",
    bg: H("white", "gray.700")(r),
    color: "inherit",
    my: "3.75rem",
    zIndex: "modal",
    maxH: t === "inside" ? "calc(100% - 7.5rem)" : void 0,
    boxShadow: H("lg", "dark-lg")(r)
  };
}, S5e = {
  px: 6,
  py: 4,
  fontSize: "xl",
  fontWeight: "semibold"
}, x5e = {
  position: "absolute",
  top: 2,
  insetEnd: 3
}, $5e = function(r) {
  var t = r.scrollBehavior;
  return {
    px: 6,
    py: 2,
    flex: 1,
    overflow: t === "inside" ? "auto" : void 0
  };
}, w5e = {
  px: 6,
  py: 4
}, _5e = function(r) {
  return {
    overlay: m5e,
    dialogContainer: b5e(r),
    dialog: y5e(r),
    header: S5e,
    closeButton: x5e,
    body: $5e(r),
    footer: w5e
  };
};
function co(e) {
  return e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "100vh",
      "@supports(min-height: -webkit-fill-available)": {
        minH: "-webkit-fill-available"
      },
      my: 0
    }
  } : {
    dialog: {
      maxW: e
    }
  };
}
var T5e = {
  xs: co("xs"),
  sm: co("sm"),
  md: co("md"),
  lg: co("lg"),
  xl: co("xl"),
  "2xl": co("2xl"),
  "3xl": co("3xl"),
  "4xl": co("4xl"),
  "5xl": co("5xl"),
  "6xl": co("6xl"),
  full: co("full")
}, C5e = {
  size: "md"
}, E5e = {
  parts: z8.keys,
  baseStyle: _5e,
  sizes: T5e,
  defaultProps: C5e
}, Kh, eI, rI, A5e = pt.variants, I5e = pt.defaultProps, f_ = wt("number-input-stepper-width"), G8 = wt("number-input-input-padding"), O5e = xo(f_).add("0.5rem").toString(), M5e = (Kh = {}, Kh[f_.variable] = "24px", Kh[G8.variable] = O5e, Kh), R5e = (eI = (rI = pt.baseStyle) == null ? void 0 : rI.field) != null ? eI : {}, P5e = {
  width: [f_.reference]
}, k5e = function(r) {
  return {
    borderStart: "1px solid",
    borderStartColor: H("inherit", "whiteAlpha.300")(r),
    color: H("inherit", "whiteAlpha.800")(r),
    _active: {
      bg: H("gray.200", "whiteAlpha.300")(r)
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  };
}, j5e = function(r) {
  return {
    root: M5e,
    field: R5e,
    stepperGroup: P5e,
    stepper: k5e(r)
  };
};
function qh(e) {
  var r, t, n = pt.sizes[e], a = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  }, i = (r = (t = n.field) == null ? void 0 : t.fontSize) != null ? r : "md", l = W8.fontSizes[i.toString()];
  return {
    field: Ot({}, n.field, {
      paddingInlineEnd: G8.reference,
      verticalAlign: "top"
    }),
    stepper: {
      fontSize: xo(l).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: a[e]
      },
      _last: {
        borderBottomEndRadius: a[e],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  };
}
var D5e = {
  xs: qh("xs"),
  sm: qh("sm"),
  md: qh("md"),
  lg: qh("lg")
}, N5e = {
  parts: rwe.keys,
  baseStyle: j5e,
  sizes: D5e,
  variants: A5e,
  defaultProps: I5e
}, tI, L5e = Ot({}, pt.baseStyle.field, {
  textAlign: "center"
}), F5e = {
  lg: {
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  }
}, z5e = {
  outline: function(r) {
    var t;
    return (t = pt.variants.outline(r).field) != null ? t : {};
  },
  flushed: function(r) {
    var t;
    return (t = pt.variants.flushed(r).field) != null ? t : {};
  },
  filled: function(r) {
    var t;
    return (t = pt.variants.filled(r).field) != null ? t : {};
  },
  unstyled: (tI = pt.variants.unstyled.field) != null ? tI : {}
}, B5e = pt.defaultProps, U5e = {
  baseStyle: L5e,
  sizes: F5e,
  variants: z5e,
  defaultProps: B5e
}, Fy = wt("popper-bg"), V5e = wt("popper-arrow-bg"), W5e = wt("popper-arrow-shadow-color"), H5e = {
  zIndex: 10
}, G5e = function(r) {
  var t, n = H("white", "gray.700")(r), a = H("gray.200", "whiteAlpha.300")(r);
  return t = {}, t[Fy.variable] = "colors." + n, t.bg = Fy.reference, t[V5e.variable] = Fy.reference, t[W5e.variable] = "colors." + a, t.width = "xs", t.border = "1px solid", t.borderColor = "inherit", t.borderRadius = "md", t.boxShadow = "sm", t.zIndex = "inherit", t._focus = {
    outline: 0,
    boxShadow: "outline"
  }, t;
}, Y5e = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
}, K5e = {
  px: 3,
  py: 2
}, q5e = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, Z5e = {
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
}, Q5e = function(r) {
  return {
    popper: H5e,
    content: G5e(r),
    header: Y5e,
    body: K5e,
    footer: q5e,
    arrow: {},
    closeButton: Z5e
  };
}, X5e = {
  parts: B8.keys,
  baseStyle: Q5e
};
function J5e(e) {
  var r = e.colorScheme, t = e.theme, n = e.isIndeterminate, a = e.hasStripe, i = H(K3(), K3("1rem", "rgba(0,0,0,0.1)"))(e), l = H(r + ".500", r + ".200")(e), u = `linear-gradient(
    to right,
    transparent 0%,
    ` + Ye(t, l) + ` 50%,
    transparent 100%
  )`, c = !n && a;
  return Ot({}, c && i, n ? {
    bgImage: u
  } : {
    bgColor: l
  });
}
var eTe = {
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
}, rTe = function(r) {
  return {
    bg: H("gray.100", "whiteAlpha.300")(r)
  };
}, tTe = function(r) {
  return Ot({
    transitionProperty: "common",
    transitionDuration: "slow"
  }, J5e(r));
}, nTe = function(r) {
  return {
    label: eTe,
    filledTrack: tTe(r),
    track: rTe(r)
  };
}, aTe = {
  xs: {
    track: {
      h: "0.25rem"
    }
  },
  sm: {
    track: {
      h: "0.5rem"
    }
  },
  md: {
    track: {
      h: "0.75rem"
    }
  },
  lg: {
    track: {
      h: "1rem"
    }
  }
}, oTe = {
  size: "md",
  colorScheme: "blue"
}, iTe = {
  parts: twe.keys,
  sizes: aTe,
  baseStyle: nTe,
  defaultProps: oTe
}, sTe = function(r) {
  var t = D0.baseStyle(r), n = t.control, a = n === void 0 ? {} : n;
  return Ot({}, a, {
    borderRadius: "full",
    _checked: Ot({}, a._checked, {
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    })
  });
}, lTe = function(r) {
  return {
    label: D0.baseStyle(r).label,
    container: D0.baseStyle(r).container,
    control: sTe(r)
  };
}, uTe = {
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    }
  },
  sm: {
    control: {
      width: 3,
      height: 3
    },
    label: {
      fontSize: "sm"
    }
  }
}, cTe = {
  size: "md",
  colorScheme: "blue"
}, dTe = {
  parts: U8.keys,
  baseStyle: lTe,
  sizes: uTe,
  defaultProps: cTe
}, fTe = function(r) {
  return Ot({}, pt.baseStyle.field, {
    bg: H("white", "gray.700")(r),
    appearance: "none",
    paddingBottom: "1px",
    lineHeight: "normal",
    "> option, > optgroup": {
      bg: H("white", "gray.700")(r)
    }
  });
}, vTe = {
  width: "1.5rem",
  height: "100%",
  insetEnd: "0.5rem",
  position: "relative",
  color: "currentColor",
  fontSize: "1.25rem",
  _disabled: {
    opacity: 0.5
  }
}, hTe = function(r) {
  return {
    field: fTe(r),
    icon: vTe
  };
}, Zh = {
  paddingInlineEnd: "2rem"
}, pTe = Rs({}, pt.sizes, {
  lg: {
    field: Zh
  },
  md: {
    field: Zh
  },
  sm: {
    field: Zh
  },
  xs: {
    field: Zh,
    icon: {
      insetEnd: "0.25rem"
    }
  }
}), gTe = {
  parts: nwe.keys,
  baseStyle: hTe,
  sizes: pTe,
  variants: pt.variants,
  defaultProps: pt.defaultProps
}, mTe = function(r, t) {
  return yxe({
    from: {
      borderColor: r,
      background: r
    },
    to: {
      borderColor: t,
      background: t
    }
  });
}, bTe = function(r) {
  var t = H("gray.100", "gray.800")(r), n = H("gray.400", "gray.600")(r), a = r.startColor, i = a === void 0 ? t : a, l = r.endColor, u = l === void 0 ? n : l, c = r.speed, f = r.theme, h = Ye(f, i), p = Ye(f, u);
  return {
    opacity: 0.7,
    borderRadius: "2px",
    borderColor: h,
    background: p,
    animation: c + "s linear infinite alternate " + mTe(h, p)
  };
}, yTe = {
  baseStyle: bTe
}, STe = function(r) {
  return {
    borderRadius: "md",
    fontWeight: "semibold",
    _focus: {
      boxShadow: "outline",
      padding: "1rem",
      position: "fixed",
      top: "1.5rem",
      insetStart: "1.5rem",
      bg: H("white", "gray.700")(r)
    }
  };
}, xTe = {
  baseStyle: STe
};
function $Te(e) {
  return rv({
    orientation: e.orientation,
    vertical: {
      left: "50%",
      transform: "translateX(-50%)",
      _active: {
        transform: "translateX(-50%) scale(1.15)"
      }
    },
    horizontal: {
      top: "50%",
      transform: "translateY(-50%)",
      _active: {
        transform: "translateY(-50%) scale(1.15)"
      }
    }
  });
}
var wTe = function(r) {
  var t = r.orientation;
  return Ot({
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    }
  }, rv({
    orientation: t,
    vertical: {
      h: "100%"
    },
    horizontal: {
      w: "100%"
    }
  }));
}, _Te = function(r) {
  return {
    overflow: "hidden",
    borderRadius: "sm",
    bg: H("gray.200", "whiteAlpha.200")(r),
    _disabled: {
      bg: H("gray.300", "whiteAlpha.300")(r)
    }
  };
}, TTe = function(r) {
  return Ot({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focus: {
      boxShadow: "outline"
    },
    _disabled: {
      bg: "gray.300"
    }
  }, $Te(r));
}, CTe = function(r) {
  var t = r.colorScheme;
  return {
    width: "inherit",
    height: "inherit",
    bg: H(t + ".500", t + ".200")(r)
  };
}, ETe = function(r) {
  return {
    container: wTe(r),
    track: _Te(r),
    thumb: TTe(r),
    filledTrack: CTe(r)
  };
}, ATe = function(r) {
  return {
    thumb: {
      w: "16px",
      h: "16px"
    },
    track: rv({
      orientation: r.orientation,
      horizontal: {
        h: "4px"
      },
      vertical: {
        w: "4px"
      }
    })
  };
}, ITe = function(r) {
  return {
    thumb: {
      w: "14px",
      h: "14px"
    },
    track: rv({
      orientation: r.orientation,
      horizontal: {
        h: "4px"
      },
      vertical: {
        w: "4px"
      }
    })
  };
}, OTe = function(r) {
  return {
    thumb: {
      w: "10px",
      h: "10px"
    },
    track: rv({
      orientation: r.orientation,
      horizontal: {
        h: "2px"
      },
      vertical: {
        w: "2px"
      }
    })
  };
}, MTe = {
  lg: ATe,
  md: ITe,
  sm: OTe
}, RTe = {
  size: "md",
  colorScheme: "blue"
}, PTe = {
  parts: awe.keys,
  sizes: MTe,
  baseStyle: ETe,
  defaultProps: RTe
}, zy, By, Uy, Vy, Wy, jl = wt("spinner-size"), kTe = {
  width: [jl.reference],
  height: [jl.reference]
}, jTe = {
  xs: (zy = {}, zy[jl.variable] = "0.75rem", zy),
  sm: (By = {}, By[jl.variable] = "1rem", By),
  md: (Uy = {}, Uy[jl.variable] = "1.5rem", Uy),
  lg: (Vy = {}, Vy[jl.variable] = "2rem", Vy),
  xl: (Wy = {}, Wy[jl.variable] = "3rem", Wy)
}, DTe = {
  size: "md"
}, NTe = {
  baseStyle: kTe,
  sizes: jTe,
  defaultProps: DTe
}, LTe = {
  fontWeight: "medium"
}, FTe = {
  opacity: 0.8,
  marginBottom: 2
}, zTe = {
  verticalAlign: "baseline",
  fontWeight: "semibold"
}, BTe = {
  marginEnd: 1,
  w: "14px",
  h: "14px",
  verticalAlign: "middle"
}, UTe = {
  container: {},
  label: LTe,
  helpText: FTe,
  number: zTe,
  icon: BTe
}, VTe = {
  md: {
    label: {
      fontSize: "sm"
    },
    helpText: {
      fontSize: "sm"
    },
    number: {
      fontSize: "2xl"
    }
  }
}, WTe = {
  size: "md"
}, HTe = {
  parts: owe.keys,
  baseStyle: UTe,
  sizes: VTe,
  defaultProps: WTe
}, Qh, Xh, Jh, Yd = wt("switch-track-width"), Jl = wt("switch-track-height"), Hy = wt("switch-track-diff"), GTe = xo.subtract(Yd, Jl), s2 = wt("switch-thumb-x"), YTe = function(r) {
  var t = r.colorScheme;
  return {
    borderRadius: "full",
    p: "2px",
    width: [Yd.reference],
    height: [Jl.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    bg: H("gray.300", "whiteAlpha.400")(r),
    _focus: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      bg: H(t + ".500", t + ".200")(r)
    }
  };
}, KTe = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [Jl.reference],
  height: [Jl.reference],
  _checked: {
    transform: "translateX(" + s2.reference + ")"
  }
}, qTe = function(r) {
  var t, n;
  return {
    container: (n = {}, n[Hy.variable] = GTe, n[s2.variable] = Hy.reference, n._rtl = (t = {}, t[s2.variable] = xo(Hy).negate().toString(), t), n),
    track: YTe(r),
    thumb: KTe
  };
}, ZTe = {
  sm: {
    container: (Qh = {}, Qh[Yd.variable] = "1.375rem", Qh[Jl.variable] = "0.75rem", Qh)
  },
  md: {
    container: (Xh = {}, Xh[Yd.variable] = "1.875rem", Xh[Jl.variable] = "1rem", Xh)
  },
  lg: {
    container: (Jh = {}, Jh[Yd.variable] = "2.875rem", Jh[Jl.variable] = "1.5rem", Jh)
  }
}, QTe = {
  size: "md",
  colorScheme: "blue"
}, XTe = {
  parts: V8.keys,
  baseStyle: qTe,
  sizes: ZTe,
  defaultProps: QTe
}, JTe = {
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "wider",
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
}, N0 = {
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}, eCe = function(r) {
  var t = r.colorScheme;
  return {
    th: Ot({
      color: H("gray.600", "gray.400")(r),
      borderBottom: "1px",
      borderColor: H(t + ".100", t + ".700")(r)
    }, N0),
    td: Ot({
      borderBottom: "1px",
      borderColor: H(t + ".100", t + ".700")(r)
    }, N0),
    caption: {
      color: H("gray.600", "gray.100")(r)
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
}, rCe = function(r) {
  var t = r.colorScheme;
  return {
    th: Ot({
      color: H("gray.600", "gray.400")(r),
      borderBottom: "1px",
      borderColor: H(t + ".100", t + ".700")(r)
    }, N0),
    td: Ot({
      borderBottom: "1px",
      borderColor: H(t + ".100", t + ".700")(r)
    }, N0),
    caption: {
      color: H("gray.600", "gray.100")(r)
    },
    tbody: {
      tr: {
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "1px",
            borderColor: H(t + ".100", t + ".700")(r)
          },
          td: {
            background: H(t + ".100", t + ".700")(r)
          }
        }
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
}, tCe = {
  simple: eCe,
  striped: rCe,
  unstyled: {}
}, nCe = {
  sm: {
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  },
  md: {
    th: {
      px: "6",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  },
  lg: {
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  }
}, aCe = {
  variant: "simple",
  size: "md",
  colorScheme: "gray"
}, oCe = {
  parts: iwe.keys,
  baseStyle: JTe,
  variants: tCe,
  sizes: nCe,
  defaultProps: aCe
}, iCe = function(r) {
  var t = r.orientation;
  return {
    display: t === "vertical" ? "flex" : "block"
  };
}, sCe = function(r) {
  var t = r.isFitted;
  return {
    flex: t ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focus: {
      zIndex: 1,
      boxShadow: "outline"
    }
  };
}, lCe = function(r) {
  var t = r.align, n = t === void 0 ? "start" : t, a = r.orientation, i = {
    end: "flex-end",
    center: "center",
    start: "flex-start"
  };
  return {
    justifyContent: i[n],
    flexDirection: a === "vertical" ? "column" : "row"
  };
}, uCe = {
  p: 4
}, cCe = function(r) {
  return {
    root: iCe(r),
    tab: sCe(r),
    tablist: lCe(r),
    tabpanel: uCe
  };
}, dCe = {
  sm: {
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  },
  md: {
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  },
  lg: {
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  }
}, fCe = function(r) {
  var t, n, a = r.colorScheme, i = r.orientation, l = i === "vertical", u = i === "vertical" ? "borderStart" : "borderBottom", c = l ? "marginStart" : "marginBottom";
  return {
    tablist: (t = {}, t[u] = "2px solid", t.borderColor = "inherit", t),
    tab: (n = {}, n[u] = "2px solid", n.borderColor = "transparent", n[c] = "-2px", n._selected = {
      color: H(a + ".600", a + ".300")(r),
      borderColor: "currentColor"
    }, n._active = {
      bg: H("gray.200", "whiteAlpha.300")(r)
    }, n._disabled = {
      opacity: 0.4,
      cursor: "not-allowed"
    }, n)
  };
}, vCe = function(r) {
  var t = r.colorScheme;
  return {
    tab: {
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px",
      _selected: {
        color: H(t + ".600", t + ".300")(r),
        borderColor: "inherit",
        borderBottomColor: H("white", "gray.800")(r)
      }
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}, hCe = function(r) {
  var t = r.colorScheme;
  return {
    tab: {
      border: "1px solid",
      borderColor: "inherit",
      bg: H("gray.50", "whiteAlpha.50")(r),
      mb: "-1px",
      _notLast: {
        marginEnd: "-1px"
      },
      _selected: {
        bg: H("#fff", "gray.800")(r),
        color: H(t + ".600", t + ".300")(r),
        borderColor: "inherit",
        borderTopColor: "currentColor",
        borderBottomColor: "transparent"
      }
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}, pCe = function(r) {
  var t = r.colorScheme, n = r.theme;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: Ye(n, t + ".700"),
        bg: Ye(n, t + ".100")
      }
    }
  };
}, gCe = function(r) {
  var t = r.colorScheme;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: H("gray.600", "inherit")(r),
      _selected: {
        color: H("#fff", "gray.800")(r),
        bg: H(t + ".600", t + ".300")(r)
      }
    }
  };
}, mCe = {}, bCe = {
  line: fCe,
  enclosed: vCe,
  "enclosed-colored": hCe,
  "soft-rounded": pCe,
  "solid-rounded": gCe,
  unstyled: mCe
}, yCe = {
  size: "md",
  variant: "line",
  colorScheme: "blue"
}, SCe = {
  parts: swe.keys,
  baseStyle: cCe,
  sizes: dCe,
  variants: bCe,
  defaultProps: yCe
}, xCe = {
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0,
  _focus: {
    boxShadow: "outline"
  }
}, $Ce = {
  lineHeight: 1.2,
  overflow: "visible"
}, wCe = {
  fontSize: "18px",
  w: "1.25rem",
  h: "1.25rem",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "0.375rem",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4
  },
  _focus: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _hover: {
    opacity: 0.8
  },
  _active: {
    opacity: 1
  }
}, _Ce = {
  container: xCe,
  label: $Ce,
  closeButton: wCe
}, TCe = {
  sm: {
    container: {
      minH: "1.25rem",
      minW: "1.25rem",
      fontSize: "xs",
      px: 2,
      borderRadius: "md"
    },
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  },
  md: {
    container: {
      minH: "1.5rem",
      minW: "1.5rem",
      fontSize: "sm",
      borderRadius: "md",
      px: 2
    }
  },
  lg: {
    container: {
      minH: 8,
      minW: 8,
      fontSize: "md",
      borderRadius: "md",
      px: 3
    }
  }
}, CCe = {
  subtle: function(r) {
    return {
      container: hc.variants.subtle(r)
    };
  },
  solid: function(r) {
    return {
      container: hc.variants.solid(r)
    };
  },
  outline: function(r) {
    return {
      container: hc.variants.outline(r)
    };
  }
}, ECe = {
  size: "md",
  variant: "subtle",
  colorScheme: "gray"
}, ACe = {
  parts: lwe.keys,
  variants: CCe,
  baseStyle: _Ce,
  sizes: TCe,
  defaultProps: ECe
}, nI, aI, oI, iI, sI, ICe = Ot({}, pt.baseStyle.field, {
  paddingY: "8px",
  minHeight: "80px",
  lineHeight: "short",
  verticalAlign: "top"
}), OCe = {
  outline: function(r) {
    var t;
    return (t = pt.variants.outline(r).field) != null ? t : {};
  },
  flushed: function(r) {
    var t;
    return (t = pt.variants.flushed(r).field) != null ? t : {};
  },
  filled: function(r) {
    var t;
    return (t = pt.variants.filled(r).field) != null ? t : {};
  },
  unstyled: (nI = pt.variants.unstyled.field) != null ? nI : {}
}, MCe = {
  xs: (aI = pt.sizes.xs.field) != null ? aI : {},
  sm: (oI = pt.sizes.sm.field) != null ? oI : {},
  md: (iI = pt.sizes.md.field) != null ? iI : {},
  lg: (sI = pt.sizes.lg.field) != null ? sI : {}
}, RCe = {
  size: "md",
  variant: "outline"
}, PCe = {
  baseStyle: ICe,
  sizes: MCe,
  variants: OCe,
  defaultProps: RCe
}, Gy = wt("tooltip-bg"), kCe = wt("popper-arrow-bg"), jCe = function(r) {
  var t, n = H("gray.700", "gray.300")(r);
  return t = {}, t[Gy.variable] = "colors." + n, t.px = "8px", t.py = "2px", t.bg = [Gy.reference], t[kCe.variable] = [Gy.reference], t.color = H("whiteAlpha.900", "gray.900")(r), t.borderRadius = "sm", t.fontWeight = "medium", t.fontSize = "sm", t.boxShadow = "md", t.maxW = "320px", t.zIndex = "tooltip", t;
}, DCe = {
  baseStyle: jCe
}, NCe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Accordion: hwe,
  Alert: $we,
  Avatar: Iwe,
  Badge: hc,
  Breadcrumb: Lwe,
  Button: Kwe,
  Checkbox: D0,
  CloseButton: o_e,
  Code: u_e,
  Container: d_e,
  Divider: m_e,
  Drawer: A_e,
  Editable: P_e,
  Form: N_e,
  FormError: B_e,
  FormLabel: V_e,
  Heading: Y_e,
  Input: pt,
  Kbd: n5e,
  Link: o5e,
  List: l5e,
  Menu: g5e,
  Modal: E5e,
  NumberInput: N5e,
  PinInput: U5e,
  Popover: X5e,
  Progress: iTe,
  Radio: dTe,
  Select: gTe,
  Skeleton: yTe,
  SkipLink: xTe,
  Slider: PTe,
  Spinner: NTe,
  Stat: HTe,
  Switch: XTe,
  Table: oCe,
  Tabs: SCe,
  Tag: ACe,
  Textarea: PCe,
  Tooltip: DCe
}), LCe = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid"
}, FCe = D$e({
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
}), zCe = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
    400: "#A0AEC0",
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    800: "#1A202C",
    900: "#171923"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#E53E3E",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBC8",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#FAF089",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#2F855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  teal: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044"
  },
  blue: {
    50: "#ebf8ff",
    100: "#bee3f8",
    200: "#90cdf4",
    300: "#63b3ed",
    400: "#4299e1",
    500: "#3182ce",
    600: "#2b6cb0",
    700: "#2c5282",
    800: "#2a4365",
    900: "#1A365D"
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666"
  },
  purple: {
    50: "#FAF5FF",
    100: "#E9D8FD",
    200: "#D6BCFA",
    300: "#B794F4",
    400: "#9F7AEA",
    500: "#805AD5",
    600: "#6B46C1",
    700: "#553C9A",
    800: "#44337A",
    900: "#322659"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  },
  linkedin: {
    50: "#E8F4F9",
    100: "#CFEDFB",
    200: "#9BDAF3",
    300: "#68C7EC",
    400: "#34B3E4",
    500: "#00A0DC",
    600: "#008CC9",
    700: "#0077B5",
    800: "#005E93",
    900: "#004471"
  },
  facebook: {
    50: "#E8F4F9",
    100: "#D9DEE9",
    200: "#B7C2DA",
    300: "#6482C0",
    400: "#4267B2",
    500: "#385898",
    600: "#314E89",
    700: "#29487D",
    800: "#223B67",
    900: "#1E355B"
  },
  messenger: {
    50: "#D0E6FF",
    100: "#B9DAFF",
    200: "#A2CDFF",
    300: "#7AB8FF",
    400: "#2E90FF",
    500: "#0078FF",
    600: "#0063D1",
    700: "#0052AC",
    800: "#003C7E",
    900: "#002C5C"
  },
  whatsapp: {
    50: "#dffeec",
    100: "#b9f5d0",
    200: "#90edb3",
    300: "#65e495",
    400: "#3cdd78",
    500: "#22c35e",
    600: "#179848",
    700: "#0c6c33",
    800: "#01421c",
    900: "#001803"
  },
  twitter: {
    50: "#E5F4FD",
    100: "#C8E9FB",
    200: "#A8DCFA",
    300: "#83CDF7",
    400: "#57BBF5",
    500: "#1DA1F2",
    600: "#1A94DA",
    700: "#1681BF",
    800: "#136B9E",
    900: "#0D4D71"
  },
  telegram: {
    50: "#E3F2F9",
    100: "#C5E4F3",
    200: "#A2D4EC",
    300: "#7AC1E4",
    400: "#47A9DA",
    500: "#0088CC",
    600: "#007AB8",
    700: "#006BA1",
    800: "#005885",
    900: "#003F5E"
  }
}, BCe = {
  none: "0",
  sm: "0.125rem",
  base: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
}, UCe = {
  xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  none: "none",
  "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
}, VCe = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
}, WCe = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, HCe = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
}, GCe = {
  property: VCe,
  easing: WCe,
  duration: HCe
}, YCe = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, KCe = {
  none: 0,
  sm: "4px",
  base: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "40px",
  "3xl": "64px"
}, qCe = Ot({
  breakpoints: FCe,
  zIndices: YCe,
  radii: BCe,
  blur: KCe,
  colors: zCe
}, W8, {
  sizes: O8,
  shadows: UCe,
  space: I8,
  borders: LCe,
  transition: GCe
}), ZCe = {
  global: function(r) {
    return {
      body: {
        fontFamily: "body",
        color: H("gray.800", "whiteAlpha.900")(r),
        bg: H("white", "gray.800")(r),
        transitionProperty: "background-color",
        transitionDuration: "normal",
        lineHeight: "base"
      },
      "*::placeholder": {
        color: H("gray.400", "whiteAlpha.400")(r)
      },
      "*, *::before, &::after": {
        borderColor: H("gray.200", "whiteAlpha.300")(r),
        wordWrap: "break-word"
      }
    };
  }
}, QCe = ZCe, XCe = ["borders", "breakpoints", "colors", "components", "config", "direction", "fonts", "fontSizes", "fontWeights", "letterSpacings", "lineHeights", "radii", "shadows", "sizes", "space", "styles", "transition", "zIndices"];
function JCe(e) {
  return oi(e) ? XCe.every(function(r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }) : !1;
}
var e4e = "ltr", r4e = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
}, pm = Ot({
  direction: e4e
}, qCe, {
  components: NCe,
  styles: QCe,
  config: r4e
});
function t4e() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  var n = [].concat(r), a = r[r.length - 1];
  return JCe(a) && // this ensures backward compatibility
  // previously only `extendTheme(override, baseTheme?)` was allowed
  n.length > 1 ? n = n.slice(0, n.length - 1) : a = pm, Axe.apply(void 0, n.map(function(i) {
    return function(l) {
      return Ju(i) ? i(l) : Y8(l, i);
    };
  }))(a);
}
function Y8() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return Rs.apply(void 0, [{}].concat(r, [K8]));
}
function K8(e, r, t, n) {
  if ((Ju(e) || Ju(r)) && Object.prototype.hasOwnProperty.call(n, t))
    return function() {
      var a = Ju(e) ? e.apply(void 0, arguments) : e, i = Ju(r) ? r.apply(void 0, arguments) : r;
      return Rs({}, a, i, K8);
    };
}
function n4e(e) {
  var r = e.colorScheme, t = e.components;
  return function(n) {
    var a = Object.keys(n.components || {});
    return Array.isArray(t) ? a = t : oi(t) && (a = Object.keys(t)), Y8(n, {
      components: Xx(a.map(function(i) {
        var l = {
          defaultProps: {
            colorScheme: r
          }
        };
        return [i, l];
      }))
    });
  };
}
const a4e = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold"
}, o4e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = Wa(`${r}.500`, 0.6)(t);
  return {
    bg: H(`${r}.500`, n)(e),
    color: H("white", "whiteAlpha.800")(e)
  };
}, i4e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = Wa(`${r}.200`, 0.16)(t);
  return {
    bg: H(`${r}.100`, n)(e),
    color: H(`${r}.800`, `${r}.200`)(e)
  };
}, s4e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = Wa(`${r}.200`, 0.8)(t), a = Ye(t, `${r}.500`), i = H(a, n)(e);
  return {
    color: i,
    boxShadow: `inset 0 0 0px 1px ${i}`
  };
}, l4e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = Wa(`${r}.500`, 0.6)(t);
  return {
    bg: H(`${r}.500`, n)(e),
    color: H("white", "whiteAlpha.800")(e)
  };
}, u4e = {
  solid: o4e,
  subtle: i4e,
  outline: s4e,
  number: l4e
}, c4e = {
  variant: "subtle",
  colorScheme: "gray"
}, d4e = {
  baseStyle: a4e,
  variants: u4e,
  defaultProps: c4e
};
var q8 = {}, f4e = li, v4e = A6, h4e = Hs, p4e = cu, g4e = Zf, m4e = L6;
q8.f = f4e && !v4e ? Object.defineProperties : function(r, t) {
  p4e(r);
  for (var n = g4e(t), a = m4e(t), i = a.length, l = 0, u; i > l; )
    h4e.f(r, u = a[l++], n[u]);
  return r;
};
var b4e = Rw, y4e = b4e("document", "documentElement"), S4e = cu, x4e = q8, lI = Vw, $4e = Bw, w4e = y4e, _4e = Nw, T4e = zw, uI = ">", cI = "<", l2 = "prototype", u2 = "script", Z8 = T4e("IE_PROTO"), Yy = function() {
}, Q8 = function(e) {
  return cI + u2 + uI + e + cI + "/" + u2 + uI;
}, dI = function(e) {
  e.write(Q8("")), e.close();
  var r = e.parentWindow.Object;
  return e = null, r;
}, C4e = function() {
  var e = _4e("iframe"), r = "java" + u2 + ":", t;
  return e.style.display = "none", w4e.appendChild(e), e.src = String(r), t = e.contentWindow.document, t.open(), t.write(Q8("document.F=Object")), t.close(), t.F;
}, ep, Up = function() {
  try {
    ep = new ActiveXObject("htmlfile");
  } catch (r) {
  }
  Up = typeof document != "undefined" ? document.domain && ep ? dI(ep) : C4e() : dI(ep);
  for (var e = lI.length; e--; )
    delete Up[l2][lI[e]];
  return Up();
};
$4e[Z8] = !0;
var X8 = Object.create || function(r, t) {
  var n;
  return r !== null ? (Yy[l2] = S4e(r), n = new Yy(), Yy[l2] = null, n[Z8] = r) : n = Up(), t === void 0 ? n : x4e.f(n, t);
}, E4e = Ws, A4e = X8, I4e = Hs.f, c2 = E4e("unscopables"), d2 = Array.prototype;
d2[c2] == null && I4e(d2, c2, {
  configurable: !0,
  value: A4e(null)
});
var J8 = function(e) {
  d2[c2][e] = !0;
}, O4e = Hw, M4e = D6.includes, R4e = Ta, P4e = J8, k4e = R4e(function() {
  return !Array(1).includes();
});
O4e({ target: "Array", proto: !0, forced: k4e }, {
  includes: function(r) {
    return M4e(this, r, arguments.length > 1 ? arguments[1] : void 0);
  }
});
P4e("includes");
const j4e = {
  borderRadius: "5px",
  fontWeight: "bold",
  _focus: "none",
  _disabled: {
    // opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none",
    border: "none",
    color: "gray.600",
    bg: "gray.300"
  },
  _hover: {
    _disabled: {
      color: "gray.600",
      bg: "gray.300"
    }
  }
}, eD = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e;
  if (r === "brand") {
    Wa(`${r}.500`, 0.12)(t);
    const n = Wa(`${r}.500`, 0.24)(t);
    return {
      fontWeight: "normal",
      color: H(`${r}.500`, `${r}.200`)(e),
      bg: "transparent",
      _disabled: {
        bg: "transparent"
      },
      _hover: {
        bg: H(`${r}.100`, "whiteAlpha.200")(e),
        _disabled: {
          bg: "transparent"
        }
      },
      _active: {
        color: H("white", `${r}.200`)(e),
        borderColor: H(`${r}.600`, n)(e),
        bg: H(`${r}.300`, n)(e)
      }
    };
  }
  return r === "secondary" ? {
    fontWeight: "normal",
    color: H("gray.700", "whiteAlpha.900")(e),
    bg: "transparent",
    _disabled: {
      bg: "transparent"
    },
    _hover: {
      bg: H("gray.100", "whiteAlpha.200")(e),
      _disabled: {
        bg: "transparent"
      }
    },
    _active: {
      bg: H("gray.300", "whiteAlpha.300")(e)
    }
  } : pm.components.Button.variants.ghost(e);
}, fI = {
  xs: 1,
  sm: 1.5,
  md: 2,
  xl: 2
}, D4e = (e) => {
  const {
    colorScheme: r,
    size: t
  } = e, n = H("gray.700", "whiteAlpha.300")(e), a = eD(e);
  return Object.assign(Object.assign({
    fontWeight: "normal",
    border: `${fI[t] || 2}px solid`,
    borderColor: ["gray", "secondary"].includes(r) ? n : "currentColor"
  }, a), {
    color: ["secondary"].includes(r) ? n : a.color,
    _hover: {
      bg: ["secondary"].includes(r) ? "secondary.50" : a._hover.bg,
      _disabled: {
        bg: "gray.300"
      }
    },
    _active: {
      bg: ["secondary"].includes(r) ? "secondary.200" : a._active.bg
    },
    _disabled: {
      border: `${fI[t] || 2}px solid`,
      borderColor: "gray.500",
      _hover: {
        borderColor: "gray.500"
      }
    }
  });
}, N4e = (e) => {
  const {
    colorScheme: r
  } = e;
  return r === "brand" ? {
    bg: H(`${r}.500`, `${r}.200`)(e),
    color: H("white", "gray.800")(e),
    _hover: {
      bg: H(`${r}.700`, `${r}.300`)(e),
      _disabled: {
        color: "gray.600",
        bg: "gray.300"
      }
    },
    _active: {
      bg: H(`${r}.900`, `${r}.400`)(e)
    }
  } : r === "secondary" ? {
    bg: H("secondary.800", "whiteAlpha.200")(e),
    color: "white",
    _hover: {
      bg: H(`${r}.600`, "whiteAlpha.300")(e),
      _disabled: {
        color: "gray.600",
        bg: "gray.100"
      }
    },
    _active: {
      bg: H(`${r}.900`, "whiteAlpha.400")(e)
    }
  } : pm.components.Button.variants.solid(e);
}, L4e = (e) => {
  const {
    colorScheme: r
  } = e, t = pm.components.Button.variants.link(e);
  let {
    color: n
  } = t;
  const {
    _active: a
  } = t;
  return t.textDecoration = "underline", t._disabled = Object.assign(Object.assign({}, t._disabled), {
    bg: "none"
  }), t._hover = Object.assign(Object.assign({}, t._hover), {
    fontWeight: "bold",
    _disabled: Object.assign(Object.assign({}, t._hover._disabled), {
      fontWeight: "normal",
      bg: "none",
      textDecoration: "underline"
    })
  }), r === "brand" && (t.fontWeight = "normal", n = H(`${r}.500`, `${r}.200`)(e), a.color = H(`${r}.600`, `${r}.400`)(e)), r === "secondary" && (t.fontWeight = "normal", n = H("gray.800", "whiteAlpha.900")(e), a.color = H("secondary.900", "whiteAlpha.300")(e)), Object.assign(Object.assign({}, t), {
    color: n,
    _active: Object.assign({}, a)
  });
}, F4e = {
  ghost: eD,
  outline: D4e,
  solid: N4e,
  link: L4e
}, z4e = {
  lg: {
    h: "46px",
    minW: "46px",
    fontSize: "lg",
    px: 6
  },
  md: {
    h: "42px",
    minW: "42px",
    fontSize: "md",
    px: 5
  },
  sm: {
    h: "32px",
    minW: "32px",
    fontSize: "sm",
    px: 4
  },
  xs: {
    h: "26px",
    minW: "26px",
    fontSize: "xs",
    px: 3
  }
}, B4e = {
  variant: "solid",
  size: "md"
}, U4e = {
  baseStyle: j4e,
  sizes: z4e,
  variants: F4e,
  defaultProps: B4e
}, V4e = {
  display: "flex",
  flexDirection: "column",
  background: "white",
  alignItems: "center",
  gap: 6
}, W4e = {
  padding: {
    base: 4,
    md: 5
  },
  borderRadius: "1rem",
  boxShadow: "base"
}, H4e = {
  padding: {
    base: 4,
    md: 5
  },
  borderRadius: "none",
  boxShadow: "none"
}, G4e = {
  flat: H4e,
  rounded: W4e
}, Y4e = {
  variant: "flat"
}, K4e = {
  baseStyle: V4e,
  variants: G4e,
  defaultProps: Y4e
};
var v_ = {}, q4e = Ta, Z4e = !q4e(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), Q4e = ui, X4e = Nn, J4e = Dw, eEe = zw, rEe = Z4e, vI = eEe("IE_PROTO"), f2 = Object, tEe = f2.prototype, rD = rEe ? f2.getPrototypeOf : function(e) {
  var r = J4e(e);
  if (Q4e(r, vI))
    return r[vI];
  var t = r.constructor;
  return X4e(t) && r instanceof t ? t.prototype : r instanceof f2 ? tEe : null;
}, nEe = Ta, aEe = Nn, oEe = kc, hI = rD, iEe = Qg, sEe = Ws, v2 = sEe("iterator"), tD = !1, ou, Ky, qy;
[].keys && (qy = [].keys(), "next" in qy ? (Ky = hI(hI(qy)), Ky !== Object.prototype && (ou = Ky)) : tD = !0);
var lEe = !oEe(ou) || nEe(function() {
  var e = {};
  return ou[v2].call(e) !== e;
});
lEe && (ou = {});
aEe(ou[v2]) || iEe(ou, v2, function() {
  return this;
});
var nD = {
  IteratorPrototype: ou,
  BUGGY_SAFARI_ITERATORS: tD
}, uEe = Hs.f, cEe = ui, dEe = Ws, pI = dEe("toStringTag"), aD = function(e, r, t) {
  e && !t && (e = e.prototype), e && !cEe(e, pI) && uEe(e, pI, { configurable: !0, value: r });
}, fEe = nD.IteratorPrototype, vEe = X8, hEe = Mw, pEe = aD, gEe = v_, mEe = function() {
  return this;
}, bEe = function(e, r, t, n) {
  var a = r + " Iterator";
  return e.prototype = vEe(fEe, { next: hEe(+!n, t) }), pEe(e, a, !1), gEe[a] = mEe, e;
}, yEe = To, SEe = _6, xEe = function(e, r, t) {
  try {
    return yEe(SEe(Object.getOwnPropertyDescriptor(e, r)[t]));
  } catch (n) {
  }
}, $Ee = Nn, wEe = String, _Ee = TypeError, TEe = function(e) {
  if (typeof e == "object" || $Ee(e))
    return e;
  throw _Ee("Can't set " + wEe(e) + " as a prototype");
}, CEe = xEe, EEe = cu, AEe = TEe, IEe = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var e = !1, r = {}, t;
  try {
    t = CEe(Object.prototype, "__proto__", "set"), t(r, []), e = r instanceof Array;
  } catch (n) {
  }
  return function(a, i) {
    return EEe(a), AEe(i), e ? t(a, i) : a.__proto__ = i, a;
  };
}() : void 0), OEe = Hw, MEe = Pc, oD = Fw, REe = Nn, PEe = bEe, gI = rD, mI = IEe, kEe = aD, jEe = Zg, Zy = Qg, DEe = Ws, NEe = v_, iD = nD, LEe = oD.PROPER, FEe = oD.CONFIGURABLE, bI = iD.IteratorPrototype, rp = iD.BUGGY_SAFARI_ITERATORS, pd = DEe("iterator"), yI = "keys", gd = "values", SI = "entries", zEe = function() {
  return this;
}, BEe = function(e, r, t, n, a, i, l) {
  PEe(t, r, n);
  var u = function(A) {
    if (A === a && g)
      return g;
    if (!rp && A in h)
      return h[A];
    switch (A) {
      case yI:
        return function() {
          return new t(this, A);
        };
      case gd:
        return function() {
          return new t(this, A);
        };
      case SI:
        return function() {
          return new t(this, A);
        };
    }
    return function() {
      return new t(this);
    };
  }, c = r + " Iterator", f = !1, h = e.prototype, p = h[pd] || h["@@iterator"] || a && h[a], g = !rp && p || u(a), y = r == "Array" && h.entries || p, S, x, T;
  if (y && (S = gI(y.call(new e())), S !== Object.prototype && S.next && (gI(S) !== bI && (mI ? mI(S, bI) : REe(S[pd]) || Zy(S, pd, zEe)), kEe(S, c, !0))), LEe && a == gd && p && p.name !== gd && (FEe ? jEe(h, "name", gd) : (f = !0, g = function() {
    return MEe(p, this);
  })), a)
    if (x = {
      values: u(gd),
      keys: i ? g : u(yI),
      entries: u(SI)
    }, l)
      for (T in x)
        (rp || f || !(T in h)) && Zy(h, T, x[T]);
    else
      OEe({ target: r, proto: !0, forced: rp || f }, x);
  return h[pd] !== g && Zy(h, pd, g, { name: a }), NEe[r] = g, x;
}, UEe = function(e, r) {
  return { value: e, done: r };
}, VEe = Zf, h_ = J8, xI = v_, sD = R6, WEe = Hs.f, HEe = BEe, tp = UEe, GEe = li, lD = "Array Iterator", YEe = sD.set, KEe = sD.getterFor(lD), qEe = HEe(Array, "Array", function(e, r) {
  YEe(this, {
    type: lD,
    target: VEe(e),
    // target
    index: 0,
    // next index
    kind: r
    // kind
  });
}, function() {
  var e = KEe(this), r = e.target, t = e.kind, n = e.index++;
  return !r || n >= r.length ? (e.target = void 0, tp(void 0, !0)) : t == "keys" ? tp(n, !1) : t == "values" ? tp(r[n], !1) : tp([n, r[n]], !1);
}, "values"), $I = xI.Arguments = xI.Array;
h_("keys");
h_("values");
h_("entries");
if (GEe && $I.name !== "values")
  try {
    WEe($I, "name", { value: "values" });
  } catch (e) {
  }
var ZEe = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, QEe = Nw, Qy = QEe("span").classList, wI = Qy && Qy.constructor && Qy.constructor.prototype, XEe = wI === Object.prototype ? void 0 : wI, _I = _o, uD = ZEe, JEe = XEe, _d = qEe, Xy = Zg, cD = Ws, Jy = cD("iterator"), TI = cD("toStringTag"), eS = _d.values, dD = function(e, r) {
  if (e) {
    if (e[Jy] !== eS)
      try {
        Xy(e, Jy, eS);
      } catch (n) {
        e[Jy] = eS;
      }
    if (e[TI] || Xy(e, TI, r), uD[r]) {
      for (var t in _d)
        if (e[t] !== _d[t])
          try {
            Xy(e, t, _d[t]);
          } catch (n) {
            e[t] = _d[t];
          }
    }
  }
};
for (var rS in uD)
  dD(_I[rS] && _I[rS].prototype, rS);
dD(JEe, "DOMTokenList");
const eAe = (e) => {
  const {
    colorScheme: r
  } = e;
  return {
    w: "100%",
    border: "1px",
    borderRadius: "base",
    borderColor: "gray.300",
    _indeterminate: {
      bg: "white",
      borderColor: "gray.300",
      color: H(`${r}.500`, `${r}.200`)(e)
    },
    _disabled: {
      borderColor: "gray.300",
      bg: "linear-gradient(to top left, #FAFAFA, #FAFAFA 48%, #D1D1D1 48%, #D1D1D1 52%, #FAFAFA 52%, #FAFAFA)"
    },
    _focus: {
      boxShadow: "none"
    }
  };
}, rAe = {
  _disabled: {
    cursor: "not-allowed"
  }
}, tAe = {
  userSelect: "none",
  _disabled: {
    opacity: 0.4
  }
}, nAe = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, aAe = (e) => ({
  icon: nAe,
  container: rAe,
  control: eAe(e),
  label: tAe
}), oAe = {
  sm: {
    control: {
      h: 3,
      w: 3
    },
    label: {
      fontSize: "sm"
    },
    icon: {
      fontSize: "0.72rem"
    }
  },
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    },
    icon: {
      fontSize: "1rem"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    },
    icon: {
      fontSize: "1rem"
    }
  }
}, iAe = {
  size: "md",
  colorScheme: "brand"
}, L0 = {
  parts: L8.keys,
  baseStyle: aAe,
  sizes: oAe,
  defaultProps: iAe
}, sAe = {
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _placeholder: {
      color: "gray.400"
    }
  }
}, xs = {
  lg: {
    fontSize: "lg",
    px: 4,
    h: "50px",
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    px: 4,
    h: "44px",
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    px: 3,
    h: "32px",
    borderRadius: "md"
  },
  xs: {
    fontSize: "xs",
    px: 2,
    h: "24px",
    borderRadius: "md"
  }
}, lAe = {
  lg: {
    field: xs.lg,
    addon: xs.lg
  },
  md: {
    field: xs.md,
    addon: xs.md
  },
  sm: {
    field: xs.sm,
    addon: xs.sm
  },
  xs: {
    field: xs.xs,
    addon: xs.xs
  }
};
function p_(e) {
  const {
    focusBorderColor: r,
    errorBorderColor: t,
    fieldBorderColor: n,
    disabledColor: a
  } = e;
  return {
    focusBorderColor: r || H("secondary.700", "secondary.300")(e),
    errorBorderColor: t || H("#DB371F", "red.300")(e),
    fieldBorderColor: n || H("gray.400", "gray.200")(e),
    disabledColor: a || H("gray.300", "gray.100")(e)
  };
}
const uAe = (e) => {
  const {
    theme: r
  } = e, {
    focusBorderColor: t,
    errorBorderColor: n,
    fieldBorderColor: a,
    disabledColor: i
  } = p_(e);
  return {
    field: {
      border: "0.5px solid",
      borderColor: Ye(r, a),
      bg: "inherit",
      _hover: {
        borderColor: Ye(r, a)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        borderColor: Ye(r, i),
        boxShadow: `0 0 0 0.5px ${Ye(r, i)}`,
        _hover: {
          borderColor: Ye(r, i)
        },
        _placeholder: {
          color: Ye(r, i)
        }
      },
      _invalid: {
        borderColor: Ye(r, n),
        boxShadow: `0 0 0 0.5px ${Ye(r, n)}`
      },
      _focus: {
        zIndex: 1,
        borderColor: Ye(r, t),
        boxShadow: `0 0 0 0.5px ${Ye(r, t)}`
      }
    },
    addon: {
      border: "0.5px solid",
      borderColor: Ye(r, a),
      bg: H("gray.100", "whiteAlpha.300")(e)
    }
  };
}, cAe = (e) => {
  const {
    theme: r
  } = e, {
    focusBorderColor: t,
    errorBorderColor: n,
    disabledColor: a
  } = p_(e);
  return {
    field: {
      border: "1px solid",
      borderColor: "transparent",
      bg: H("gray.100", "whiteAlpha.50")(e),
      _hover: {
        bg: H("gray.100", "whiteAlpha.50")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        bg: Ye(r, a),
        _placeholder: {
          color: H("gray.700", "whiteAlpha.100")(e)
        },
        _hover: {
          bg: Ye(r, a)
        }
      },
      _invalid: {
        borderColor: Ye(r, n)
      },
      _focus: {
        bg: "transparent",
        borderColor: Ye(r, t)
      }
    },
    addon: {
      border: "1px solid",
      borderColor: "transparent",
      bg: H("gray.100", "whiteAlpha.50")(e)
    }
  };
}, dAe = (e) => {
  const {
    theme: r
  } = e, {
    focusBorderColor: t,
    errorBorderColor: n,
    fieldBorderColor: a,
    disabledColor: i
  } = p_(e);
  return {
    field: {
      borderBottom: "0px solid",
      borderColor: Ye(r, a),
      borderRadius: 0,
      px: 0,
      boxShadow: `0px 1px 0px ${Ye(r, a)}`,
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Ye(r, n),
        boxShadow: `0px 1px 0px ${Ye(r, n)}`
      },
      _focus: {
        borderColor: Ye(r, t),
        boxShadow: `0px 1px 0px ${Ye(r, t)}`
      },
      _disabled: {
        borderColor: Ye(r, i),
        boxShadow: `0px 1px 0px ${Ye(r, i)}`,
        _placeholder: {
          color: Ye(r, i)
        }
      }
    },
    addon: {
      borderBottom: "0px solid",
      borderColor: Ye(r, a),
      boxShadow: `0px 1px 0px ${Ye(r, a)}`,
      borderRadius: 0,
      px: 0,
      pr: 2,
      bg: "transparent"
    }
  };
}, fAe = {
  field: {
    bg: "transparent",
    px: 0,
    height: "auto",
    _disabled: {
      _placeholder: {
        color: "gray.300"
      }
    }
  },
  addon: {
    bg: "transparent",
    px: 0,
    height: "auto"
  }
}, vAe = {
  outline: uAe,
  filled: cAe,
  flushed: dAe,
  unstyled: fAe
}, hAe = {
  size: "sm",
  variant: "flushed"
}, pAe = {
  parts: F8.keys,
  baseStyle: sAe,
  sizes: lAe,
  variants: vAe,
  defaultProps: hAe
}, gAe = {
  bg: "blackAlpha.400",
  zIndex: "modal"
}, mAe = (e) => {
  const {
    isCentered: r,
    scrollBehavior: t
  } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: r ? "center" : "flex-start",
    overflow: t === "inside" ? "hidden" : "auto",
    fontSize: "sm"
  };
}, bAe = (e) => {
  const {
    scrollBehavior: r
  } = e;
  return {
    borderRadius: "md",
    bg: H("white", "gray.700")(e),
    color: "inherit",
    my: "3.75rem",
    zIndex: "modal",
    maxH: r === "inside" ? "calc(100% - 7.5rem)" : void 0,
    boxShadow: H("lg", "dark-lg")(e)
  };
}, yAe = {
  px: 6,
  py: 3,
  fontSize: "md",
  fontWeight: "normal",
  borderBottom: "1px solid",
  borderBottomColor: "gray.100"
}, SAe = {
  position: "absolute",
  top: 2,
  insetEnd: 3,
  color: "gray.400"
}, xAe = (e) => {
  const {
    scrollBehavior: r
  } = e;
  return {
    px: 6,
    py: 6,
    flex: 1,
    overflow: r === "inside" ? "auto" : void 0,
    fontSize: "sm"
  };
}, $Ae = (e) => ({
  px: 6,
  py: 3,
  bg: H("gray.100", "gray.700")(e),
  borderBottomRadius: "md"
}), wAe = (e) => ({
  overlay: gAe,
  dialogContainer: mAe(e),
  dialog: bAe(e),
  header: yAe,
  closeButton: SAe,
  body: xAe(e),
  footer: $Ae(e)
});
function fo(e) {
  return e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "100vh",
      "@supports(min-height: -webkit-fill-available)": {
        minH: "-webkit-fill-available"
      },
      my: 0
    }
  } : {
    dialog: {
      maxW: e
    }
  };
}
const _Ae = {
  xs: fo("xs"),
  sm: fo("sm"),
  md: fo("md"),
  lg: fo("lg"),
  xl: fo("xl"),
  "2xl": fo("2xl"),
  "3xl": fo("3xl"),
  "4xl": fo("4xl"),
  "5xl": fo("5xl"),
  "6xl": fo("6xl"),
  full: fo("full")
}, TAe = {
  size: "md",
  autoFocus: !1
}, CAe = {
  parts: z8.keys,
  baseStyle: wAe,
  sizes: _Ae,
  defaultProps: TAe
}, tS = wt("popper-bg"), EAe = wt("popper-arrow-bg"), AAe = wt("popper-arrow-shadow-color"), IAe = {
  zIndex: 10
}, OAe = (e) => {
  const r = H("white", "gray.700")(e), t = H("gray.200", "whiteAlpha.300")(e);
  return {
    [tS.variable]: `colors.${r}`,
    bg: tS.reference,
    [EAe.variable]: tS.reference,
    [AAe.variable]: `colors.${t}`,
    width: "xs",
    border: "1px solid",
    borderColor: "gray.300",
    borderRadius: "base",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
    zIndex: "inherit",
    _focus: {
      outline: 0,
      boxShadow: "node"
    }
  };
}, MAe = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px",
  fontSize: "sm"
}, RAe = {
  fontSize: "xs",
  px: 3,
  py: 2
}, PAe = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, kAe = {
  position: "absolute",
  borderRadius: "md",
  top: 2,
  insetEnd: 2,
  color: "gray.400"
}, jAe = (e) => ({
  popper: IAe,
  content: OAe(e),
  header: MAe,
  body: RAe,
  footer: PAe,
  arrow: {},
  closeButton: kAe
}), DAe = {
  parts: B8.keys,
  baseStyle: jAe
}, NAe = (e) => {
  const {
    colorScheme: r,
    size: t
  } = e, {
    control: n = {}
  } = L0.baseStyle(e);
  let a = "12px";
  return t === "md" ? a = "9px" : t === "sm" && (a = "6px"), Object.assign(Object.assign({}, n), {
    borderRadius: "full",
    _hover: {
      bg: "white",
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: a,
        h: a,
        borderRadius: "50%",
        bg: H(`${r}.500`, `${r}.200`)(e)
      },
      _disabled: {
        bg: "linear-gradient(to top left, #FAFAFA, #FAFAFA 48%, #D1D1D1 48%, #D1D1D1 52%, #FAFAFA 52%, #FAFAFA)",
        _before: {
          bg: "none"
        }
      }
    },
    _checked: {
      bg: "white",
      borderColor: H(`${r}.500`, `${r}.200`)(e),
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: a,
        h: a,
        borderRadius: "50%",
        bg: H(`${r}.500`, `${r}.200`)(e)
      },
      _hover: {
        _disabled: {
          bg: "gray.200",
          _before: {
            bg: "gray.500"
          }
        }
      },
      _disabled: {
        _before: {
          bg: "gray.500"
        }
      }
    },
    _active: {
      _before: {
        bg: H(`${r}.900`, `${r}.400`)(e)
      }
    }
  });
}, LAe = (e) => ({
  label: L0.baseStyle(e).label,
  container: L0.baseStyle(e).container,
  control: NAe(e)
}), FAe = {
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    }
  },
  sm: {
    control: {
      width: 3,
      height: 3
    },
    label: {
      fontSize: "sm"
    }
  }
}, zAe = {
  size: "md",
  colorScheme: "brand"
}, BAe = {
  parts: U8.keys,
  baseStyle: LAe,
  sizes: FAe,
  defaultProps: zAe
}, qo = wt("spinner-size"), UAe = {
  width: [qo.reference],
  height: [qo.reference]
}, VAe = {
  xs: {
    [qo.variable]: "0.75rem"
  },
  sm: {
    [qo.variable]: "1rem"
  },
  md: {
    [qo.variable]: "1.5rem"
  },
  lg: {
    [qo.variable]: "2rem"
  },
  xl: {
    [qo.variable]: "3rem"
  },
  "2xl": {
    [qo.variable]: "4rem"
  },
  "3xl": {
    [qo.variable]: "5rem"
  },
  "4xl": {
    [qo.variable]: "6rem"
  }
}, WAe = {
  size: "md"
}, HAe = {
  baseStyle: UAe,
  sizes: VAe,
  defaultProps: WAe
}, GAe = qr("steps").parts("connector", "description", "icon", "iconLabel", "label", "labelContainer", "step", "stepContainer", "stepIconContainer", "steps"), YAe = {
  strokeWidth: "2px"
}, CI = (e) => ({
  color: H("gray.800", "gray.100")(e),
  fontWeight: "medium",
  textAlign: "center",
  fontSize: "md",
  _activeStep: {
    color: "gray.900"
  }
}), KAe = (e) => ({
  color: H("gray.800", "gray.200")(e),
  marginTop: "-2px",
  textAlign: "center",
  fontSize: "sm"
}), qAe = (e) => {
  const {
    colorScheme: r
  } = e, t = H("gray.200", "gray.700")(e);
  let n = `${r}.500`;
  r === "secondary" && (n = `${r}.700`);
  const a = H(n, `${r}.200`)(e);
  return {
    flex: 1,
    display: "flex",
    borderStyle: "solid",
    borderColor: t,
    transitionProperty: "border-color",
    transitionDuration: "normal",
    _highlighted: {
      borderColor: a
    }
  };
}, ZAe = (e) => {
  const {
    colorScheme: r
  } = e, t = H("gray.400", "gray.700")(e);
  let n = `${r}.500`;
  return r === "secondary" && (n = `${r}.700`), {
    display: "flex",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    bg: t,
    borderStyle: "solid",
    borderColor: t,
    transitionProperty: "background, border-color",
    transitionDuration: "normal",
    _activeStep: {
      bg: H(O$e("white", 0.5), M$e(t, 0.5))(e),
      borderColor: n,
      _invalid: {
        bg: "red.500",
        borderColor: "red.500"
      }
    },
    _highlighted: {
      bg: n,
      borderColor: n
    },
    "&[data-clickable]:hover": {
      borderColor: n
    }
  };
}, QAe = (e) => {
  const {
    colorScheme: r
  } = e;
  let t = `${r}.500`;
  return r === "secondary" && (t = `${r}.700`), {
    connector: qAe(e),
    description: KAe(e),
    icon: YAe,
    iconLabel: CI(e),
    label: Object.assign(Object.assign({}, CI(e)), {
      _activeStep: {
        color: t
      }
    }),
    labelContainer: {
      display: "flex",
      flexDir: "column",
      justifyContent: "center"
    },
    step: {
      display: "flex",
      position: "relative"
    },
    stepContainer: {
      display: "flex",
      alignItems: "center"
    },
    stepIconContainer: ZAe(e),
    steps: {
      fontFamily: "heading",
      textAlign: "center",
      width: "100%",
      display: "flex",
      flex: 1
    }
  };
}, XAe = {
  sm: {
    stepIconContainer: {
      width: "26px",
      height: "26px",
      borderWidth: "2px"
    },
    icon: {
      width: "14px",
      height: "14px"
    },
    label: {
      fontWeight: "semibold",
      textAlign: "center",
      fontSize: "sm"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "xs"
    }
  },
  md: {
    stepIconContainer: {
      width: "40px",
      height: "40px",
      borderWidth: "2px"
    },
    icon: {
      width: "18px",
      height: "18px"
    },
    label: {
      fontWeight: "semibold",
      textAlign: "center",
      fontSize: "md"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "sm"
    }
  },
  lg: {
    stepIconContainer: {
      width: "48px",
      height: "48px",
      borderWidth: "2px"
    },
    icon: {
      width: "22px",
      height: "22px"
    },
    label: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: "lg"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "md"
    }
  }
}, JAe = {
  size: "md",
  colorScheme: "brand"
}, e3e = {
  parts: GAe.keys,
  baseStyle: QAe,
  sizes: XAe,
  defaultProps: JAe
};
var r3e = Ws, t3e = r3e("toStringTag"), fD = {};
fD[t3e] = "z";
var n3e = String(fD) === "[object z]", a3e = n3e, o3e = Nn, Vp = f6, i3e = Ws, s3e = i3e("toStringTag"), l3e = Object, u3e = Vp(function() {
  return arguments;
}()) == "Arguments", c3e = function(e, r) {
  try {
    return e[r];
  } catch (t) {
  }
}, d3e = a3e ? Vp : function(e) {
  var r, t, n;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (t = c3e(r = l3e(e), s3e)) == "string" ? t : u3e ? Vp(r) : (n = Vp(r)) == "Object" && o3e(r.callee) ? "Arguments" : n;
}, f3e = d3e, v3e = String, h3e = function(e) {
  if (f3e(e) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return v3e(e);
}, p3e = cu, g3e = function() {
  var e = p3e(this), r = "";
  return e.hasIndices && (r += "d"), e.global && (r += "g"), e.ignoreCase && (r += "i"), e.multiline && (r += "m"), e.dotAll && (r += "s"), e.unicode && (r += "u"), e.unicodeSets && (r += "v"), e.sticky && (r += "y"), r;
}, m3e = Pc, b3e = ui, y3e = y6, S3e = g3e, EI = RegExp.prototype, x3e = function(e) {
  var r = e.flags;
  return r === void 0 && !("flags" in EI) && !b3e(e, "flags") && y3e(EI, e) ? m3e(S3e, e) : r;
}, $3e = Fw.PROPER, w3e = Qg, _3e = cu, AI = h3e, T3e = Ta, C3e = x3e, g_ = "toString", E3e = RegExp.prototype, vD = E3e[g_], A3e = T3e(function() {
  return vD.call({ source: "a", flags: "b" }) != "/a/b";
}), I3e = $3e && vD.name != g_;
(A3e || I3e) && w3e(RegExp.prototype, g_, function() {
  var r = _3e(this), t = AI(r.source), n = AI(C3e(r));
  return "/" + t + "/" + n;
}, { unsafe: !0 });
const Kd = wt("switch-track-width"), eu = wt("switch-track-height"), nS = wt("switch-track-diff"), O3e = xo.subtract(Kd, eu), h2 = wt("switch-thumb-x"), M3e = (e) => {
  const {
    colorScheme: r
  } = e;
  return {
    borderRadius: "full",
    p: "1px",
    width: [Kd.reference],
    height: [eu.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    bg: H("gray.100", "whiteAlpha.400")(e),
    _focus: {
      boxShadow: "none"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      bg: H(`${r}.500`, `${r}.200`)(e)
    }
  };
}, R3e = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [eu.reference],
  height: [eu.reference],
  _checked: {
    transform: `translateX(${h2.reference})`
  }
}, P3e = (e) => ({
  container: {
    [nS.variable]: O3e,
    [h2.variable]: nS.reference,
    _rtl: {
      [h2.variable]: xo(nS).negate().toString()
    }
  },
  track: M3e(e),
  thumb: R3e
}), k3e = {
  sm: {
    container: {
      [Kd.variable]: "2.8rem",
      [eu.variable]: "1.6rem"
    }
  },
  md: {
    container: {
      [Kd.variable]: "3.8rem",
      [eu.variable]: "2.2rem"
    }
  },
  lg: {
    container: {
      // 50x30
      [Kd.variable]: "4.8rem",
      [eu.variable]: "2.8rem"
    }
  }
}, j3e = {
  size: "md",
  colorScheme: "brand"
}, D3e = {
  parts: V8.keys,
  baseStyle: P3e,
  sizes: k3e,
  defaultProps: j3e
}, aS = wt("tooltip-bg"), N3e = wt("popper-arrow-bg"), L3e = (e) => {
  const r = H("white", "gray.700")(e);
  return {
    [aS.variable]: `colors.${r}`,
    bg: [aS.reference],
    [N3e.variable]: [aS.reference],
    color: H("gray", "white")(e),
    px: "8px",
    py: "2px",
    fontWeight: "normal",
    fontSize: "xs",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
    maxW: "320px",
    zIndex: "tooltip"
  };
}, F3e = {
  baseStyle: L3e
};
var z3e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Badge: d4e,
  Button: U4e,
  Card: K4e,
  Checkbox: L0,
  Input: pAe,
  Modal: CAe,
  Popover: DAe,
  Radio: BAe,
  Spinner: HAe,
  Steps: e3e,
  Switch: D3e,
  Tooltip: F3e
});
const B3e = {
  base: "0px",
  xs: "320px",
  sm: "480px",
  md: "768px",
  lg: "1024px",
  xl: "1440px"
}, U3e = {
  50: "#F2F9E5",
  100: "#DFEFBF",
  200: "#C9E595",
  300: "#B2DA68",
  400: "#A0D248",
  500: "#8FCA00",
  600: "#7DBA00",
  700: "#66A600",
  800: "#4F9200",
  900: "#1F7100"
}, II = {
  50: "#F7F7F7",
  100: "#EEEEEE",
  200: "#E3E3E3",
  300: "#D1D1D1",
  400: "#ACACAC",
  500: "#8B8B8B",
  600: "#646464",
  700: "#515151",
  800: "#333333",
  900: "#131313"
}, V3e = {
  brand: U3e,
  secondary: II,
  gray: II
}, W3e = {
  none: "0",
  sm: "0.2rem",
  base: "0.4rem",
  md: "0.6rem",
  lg: "0.8rem",
  xl: "1.2rem",
  "2xl": "1.5rem",
  "3xl": "2.4rem",
  full: "9999px"
}, H3e = {
  // xs: '0 0 0 1px rgba(0, 0, 0, 0.05)',
  // sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  // base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  // md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  // lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  // xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  // '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  // outline: '0 0 0 3px rgba(66, 153, 225, 0.6)',
  // 'outline-md': '0 0 10px rgba(0, 0, 0, 0.1)',
  // inner: 'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
  // none: 'none',
  // 'dark-lg': 'rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px',
  base: "0px 2px 2px rgba(0, 0, 0, 0.1)",
  md: "0px 0px 10px rgba(0, 0, 0, 0.2)",
  lg: "0px 5px 20px rgba(0, 0, 0, 0.2)"
}, hD = {
  px: "1px",
  0.5: "0.2rem",
  1: "0.4rem",
  1.5: "0.6rem",
  2: "0.8rem",
  2.5: "1rem",
  3: "1.2rem",
  3.5: "1.4rem",
  4: "1.6rem",
  5: "2rem",
  6: "2.4rem",
  7: "2.8rem",
  8: "3.2rem",
  9: "3.6rem",
  10: "4rem",
  12: "4.8rem",
  14: "5.6rem",
  16: "6.4rem",
  20: "8rem",
  24: "9.6rem",
  28: "11.2rem",
  32: "12.8rem",
  36: "14.4rem",
  40: "16rem",
  44: "17.6rem",
  48: "19.2rem",
  52: "20.8rem",
  56: "22.4rem",
  60: "24rem",
  64: "25.6rem",
  72: "28.8rem",
  80: "32rem",
  96: "38.4rem"
}, G3e = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "22.4rem",
  "2xs": "25.6rem",
  xs: "32rem",
  sm: "38.4rem",
  md: "44.8rem",
  lg: "51.2rem",
  xl: "57.6rem",
  "2xl": "67.2rem",
  "3xl": "76.8rem",
  "4xl": "89.6rem",
  "5xl": "102.4rem",
  "6xl": "115.2rem",
  "7xl": "128rem",
  "8xl": "144rem"
}, Y3e = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, K3e = Object.assign(Object.assign(Object.assign({}, hD), G3e), {
  container: Y3e
}), q3e = {
  fonts: {
    heading: 'Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: 'Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    xxs: "1.3rem",
    xs: "1.4rem",
    sm: "1.6rem",
    md: "1.8rem",
    lg: "2rem",
    xl: "2.2rem",
    "2xl": "2.4rem",
    "3xl": "3.2rem",
    "4xl": "3.6rem",
    "5xl": "4.8rem",
    "6xl": "6rem",
    "7xl": "7.2rem",
    "8xl": "9.6rem",
    "9xl": "12.8rem"
  }
}, Z3e = Object.assign(Object.assign({
  radii: W3e,
  colors: V3e
}, q3e), {
  sizes: K3e,
  space: hD,
  shadows: H3e,
  breakpoints: B3e
}), Q3e = {
  global: (e) => ({
    html: {
      fontSize: "10px"
    },
    "html, body, #__next": {
      height: "100vh",
      bg: H("white", "gray.800")(e)
    }
  })
}, X3e = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "ds-falabella"
}, J3e = t4e(Object.assign(Object.assign({}, Z3e), {
  components: Object.assign({}, z3e),
  styles: Q3e,
  config: X3e
}), n4e({
  colorScheme: "brand"
})), eIe = (e, r = {}) => e === "" || !e ? J3e : pP(r, Pme), rIe = "https://falabella.scene7.com/is/image/Falabella", tIe = {
  apiBaseUrl: {
    staging: "https://stg.api.bazaarvoice.com/data",
    uat: "https://api.bazaarvoice.com/data",
    production: "https://api.bazaarvoice.com/data"
  },
  apiKey: {
    cl: {
      staging: "cahaotOSiLcdFM9ncSI3xsc0cL8Iso9z1cmSkcj5H66Hk",
      uat: "caL72ZXmzt8PKT4tz1PqWxtuWcN1fP5TTT1ZPsbFIse2Y",
      production: "caL72ZXmzt8PKT4tz1PqWxtuWcN1fP5TTT1ZPsbFIse2Y"
    },
    pe: {
      staging: "caLnidnPbPImRWgruNrOrMCJUPolMcWOFYwJ1IGMoXHZI",
      uat: "caA1SPlXPQxP0ls9JbfylYuAHLRhIoV3tsUaqUBh8bnKc",
      production: "caA1SPlXPQxP0ls9JbfylYuAHLRhIoV3tsUaqUBh8bnKc"
    },
    co: {
      staging: "caOMDwkt9652ivjJ7kqogJaafEHLQnoRmbaxruAMok1P0",
      uat: "cawmzx4wqbOCOeeD2FH1bZOhUGUqH7ecMjnyqmfUu2SaI",
      production: "cawmzx4wqbOCOeeD2FH1bZOhUGUqH7ecMjnyqmfUu2SaI"
    },
    mx: {
      staging: "caU4gVRJ2eme3GfR8tYf4QUheGK2m1XORAMzqGkuzbfWo",
      uat: "can9aOddZnegqsJ4xd4pfUGqS1e5NEiGvQbibE2LYIeP0",
      production: "can9aOddZnegqsJ4xd4pfUGqS1e5NEiGvQbibE2LYIeP0"
    }
  },
  apiVersion: "5.4",
  apiAction: process.env.SUBMITION_ACTION || "submit"
  /* Submit */
}, Vt = {
  RATE_THIS_PRODUCT: "Califica este producto:",
  BE_THE_FIRST_TO_RATE: "Sé el primero en calificar este producto:",
  RECOMMENDATION_RATE_MESSAGE: "de los clientes recomiendan este producto.",
  COMMENT: "comentario",
  COMMENTS: "comentarios",
  SEE_COMMENTS_WITH_IMAGES: "Ver todos los comentarios con imagen",
  PEOPLE_FOUND_THIS_HELPFUL: "personas encuentran útil este comentario.",
  PERSON_FOUND_THIS_HELPFUL: "1 persona encuentra útil este comentario.",
  VIEW_MORE_COMMENTS: "Mostrar más opiniones",
  RECOMMENDATION: "recomendación",
  RECOMMENDATIONS: "recomendaciones",
  CLIENTS_RECOMMEND_THIS_PRODUCT: "Los clientes recomiendan este producto",
  GENERATED_WITH_AI: "Generado con Inteligencia Artificial",
  ORDER_BY: "Ordenar por:",
  BEST_RATING: "Mejor puntuación",
  RELEVANCY: "Relevancia",
  MOST_RECENT: "Más recientes",
  OLDEST: "Más viejos",
  MOST_HELPFUL: "Más útiles"
}, OI = {
  development: "dev",
  staging: "staging",
  production: "www",
  uat: "beta"
}, nIe = ({
  product: e,
  queryParams: r = "wid=100&hei=100&qlt=70"
}) => {
  var i;
  const t = `${rIe}/${e.id}?${r}`;
  if (!e || !e.variants || e.variants.length === 0)
    return t;
  const n = (i = e.variants[0].medias) == null ? void 0 : i[0], a = n == null ? void 0 : n.url;
  return a ? `${a}?${r}` : t;
}, pD = (e) => function(t) {
  const l = t, { rebrandingModifier: n = "solar" } = l, a = Hv(l, ["rebrandingModifier"]), i = eIe(n);
  return /* @__PURE__ */ _.jsx(hP, { theme: i, children: /* @__PURE__ */ _.jsx(e, Yt({}, a)) });
}, MI = {
  "bv-write-review": "_bv-write-review_1r59d_1",
  "write-comment-label": "_write-comment-label_1r59d_1"
};
function aIe({ reviewAdapter: e }) {
  function r(f) {
    return Gr(this, arguments, function* ({
      productId: i,
      offset: l,
      fetchStats: u,
      sort: c
    }) {
      return e.getReviews({ productId: i, offset: l, fetchStats: u, sort: c });
    });
  }
  function t(i) {
    return Gr(this, null, function* () {
      return e.saveReview(i);
    });
  }
  function n(i) {
    return Gr(this, null, function* () {
      return e.submitReviewFeedback(i);
    });
  }
  function a(i) {
    return Gr(this, null, function* () {
      return e.uploadPhoto(i);
    });
  }
  return {
    getReviews: r,
    saveReview: t,
    submitReviewFeedback: n,
    uploadPhoto: a
  };
}
function Hu(e, r) {
  return Gr(this, null, function* () {
    try {
      const t = yield fetch(e, r);
      return t.ok ? t.json() : Promise.resolve(
        `Error fetching data: ${t.statusText}`
      );
    } catch (t) {
      throw console.error("An error occurred:", t), t;
    }
  });
}
const { apiAction: oIe, apiBaseUrl: iIe, apiVersion: np, apiKey: sIe } = tIe;
function lIe({
  tenant: e,
  environment: r,
  fetchApiBaseUrl: t,
  enableEnglishReviews: n
}) {
  if (!e || !r)
    throw new Error("tenant and environment are required");
  const a = sIe[e][r], i = iIe[r];
  function l(S) {
    return Gr(this, arguments, function* ({
      productId: h,
      fetchStats: p,
      offset: g,
      sort: y = "Rating:desc"
    }) {
      const x = y || "Rating:desc", T = t ? `${t}?passKey=${a}&productId=${h}&offset=${g}&limit=9&fetchStats=${p}&multiLangReviews=${n}&sort=${x}` : `${i}/reviews.json?apiversion=${np}&passkey=${a}&Filter=ProductId%3A${h}${n ? "" : "&Filter=ContentLocale:eq:es_*"}&Sort=${x}&offset=${g}&limit=9${p ? "&Include=Products&FilteredStats=Reviews" : ""}`, A = `${i}/reviewsummary/?passKey=${a}&productId=${h}&formatType=paragraph&language=es`, O = yield Hu(T), P = yield Hu(A);
      return O && Fo(Yt({}, O), {
        Summary: P.summary
      });
    });
  }
  function u(h) {
    return Gr(this, null, function* () {
      const p = `${i}/submitreview.json`, g = new Headers();
      g.append("Content-Type", "application/x-www-form-urlencoded");
      const y = new URLSearchParams();
      y.append("apiversion", np), y.append("passkey", a), y.append("action", oIe), y.append("agreedtotermsandconditions", "true"), Object.entries(h).forEach(([T, A]) => {
        y.append(T, String(A));
      });
      const S = {
        method: "POST",
        headers: g,
        body: y.toString()
      };
      return yield Hu(p, S);
    });
  }
  function c(h) {
    return Gr(this, null, function* () {
      const p = `${i}/submitfeedback.json`, g = new Headers();
      g.append("Content-Type", "application/x-www-form-urlencoded");
      const y = new URLSearchParams();
      y.append("ApiVersion", np), y.append("ContentType", "review"), y.append("ContentId", h.reviewId), y.append("FeedbackType", "helpfulness"), y.append("Vote", h.vote), y.append("PassKey", a);
      const S = {
        method: "POST",
        headers: g,
        body: y.toString()
      };
      return yield Hu(p, S);
    });
  }
  function f(h) {
    return Gr(this, null, function* () {
      const p = new FormData();
      p.append("photo", h, h.name), p.append("apiversion", np), p.append("contenttype", "Review"), p.append("passkey", a);
      const g = `${i}/uploadphoto.json`, y = {
        method: "POST",
        body: p
      };
      try {
        return yield Hu(g, y);
      } catch (S) {
        throw console.error("An error occurred:", S), S;
      }
    });
  }
  return {
    getReviews: l,
    saveReview: u,
    submitReviewFeedback: c,
    uploadPhoto: f
  };
}
function m_({
  tenant: e,
  environment: r,
  fetchApiBaseUrl: t,
  enableEnglishReviews: n
}) {
  const a = lIe({
    tenant: e,
    environment: r,
    fetchApiBaseUrl: t,
    enableEnglishReviews: n
  }), i = aIe({
    reviewAdapter: a
  });
  function l(S) {
    return Gr(this, arguments, function* ({
      productId: h,
      offset: p,
      fetchStats: g,
      sort: y
    }) {
      return i.getReviews({ productId: h, offset: p, fetchStats: g, sort: y });
    });
  }
  function u(g) {
    return Gr(this, arguments, function* ({ product: h, values: p }) {
      const { photos: y } = p;
      let S = [];
      y && y.length && (S = yield f(y));
      const x = {};
      S && S.length && S.forEach((A, O) => {
        var P, j, k;
        x[`photourl_${O}`] = (k = (j = (P = A == null ? void 0 : A.Photo) == null ? void 0 : P.Sizes) == null ? void 0 : j.thumbnail) == null ? void 0 : k.Url;
      });
      const T = Yt(Fo(Yt({}, p), {
        productid: h.id
      }), x);
      return i.saveReview(T);
    });
  }
  function c(g) {
    return Gr(this, arguments, function* ({
      reviewId: h,
      vote: p
    }) {
      return i.submitReviewFeedback({ reviewId: h, vote: p });
    });
  }
  function f(h) {
    return Gr(this, null, function* () {
      const p = h.map((g) => i.uploadPhoto(g));
      return Promise.all(p);
    });
  }
  return {
    fetchReviews: l,
    saveReview: u,
    submitReviewFeedback: c
  };
}
const uIe = "_text_1ka41_10", cIe = "_options_1ka41_16", dIe = "_option_1ka41_16", fIe = "_checked_1ka41_41", vIe = "_line_1ka41_44", mo = {
  "bv-dots-radio-buttons": "_bv-dots-radio-buttons_1ka41_2",
  text: uIe,
  options: cIe,
  option: dIe,
  "with-line": "_with-line_1ka41_26",
  "dot-radio-button": "_dot-radio-button_1ka41_29",
  "dot-button": "_dot-button_1ka41_36",
  checked: fIe,
  line: vIe
};
function hIe({ isChecked: e, onChange: r }) {
  return /* @__PURE__ */ _.jsxs(ln, { className: mo["dot-radio-button"], as: "label", children: [
    /* @__PURE__ */ _.jsx("input", { type: "radio", checked: e, onChange: r }),
    /* @__PURE__ */ _.jsx(
      ln,
      {
        role: "dot-radio-button",
        className: `${mo["dot-button"]} ${e ? mo.checked : ""}`
      }
    )
  ] });
}
function pIe({
  options: e,
  selected: r,
  setSelected: t,
  fieldName: n
}) {
  return /* @__PURE__ */ _.jsxs("div", { className: mo["bv-dots-radio-buttons"], children: [
    /* @__PURE__ */ _.jsx("div", { className: mo.text, children: e[0] }),
    /* @__PURE__ */ _.jsx("div", { className: `${mo.text} ${mo.options}`, children: e.map((a, i) => {
      const l = e.indexOf(a) + 1;
      return /* @__PURE__ */ _.jsxs(
        "span",
        {
          className: `${mo.option} ${i < e.length - 1 ? mo["with-line"] : ""}`,
          children: [
            /* @__PURE__ */ _.jsx(
              hIe,
              {
                isChecked: r === l,
                onChange: () => t(n, l)
              },
              l
            ),
            Number(l) < e.length && /* @__PURE__ */ _.jsx("span", { className: mo.line })
          ]
        },
        `radio-${i}`
      );
    }) }),
    /* @__PURE__ */ _.jsx("div", { className: mo.text, children: e[e.length - 1] })
  ] });
}
const gIe = "data:image/svg+xml;base64,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", gD = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDkgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjkwNDI2MSAxLjM3Njg4TDcuMTU4MzEgNy45OTkyNEwwLjkwMzUwOCAxNC42MjE2QzAuNjA1NDA2IDE0LjkzNzMgMC42MDU0MDYgMTUuNDQ4MSAwLjkwMzUwOCAxNS43NjM4QzEuMjAxNjEgMTYuMDc4NyAxLjY4NDU4IDE2LjA3ODcgMS45ODI2OCAxNS43NjM4TDguNzc2MzYgOC41NzA3QzkuMDc0NDYgOC4yNTU3NyA5LjA3NDQ2IDcuNzQ0MjMgOC43NzYzNiA3LjQyOTI5TDEuOTgyNzUgMC4yMzYyMDFDMS42ODQ2NSAtMC4wNzg3MzM0IDEuMjAwOTIgLTAuMDc4NzMzNCAwLjkwMjgxOSAwLjIzNjIwMUMwLjYwNjE2IDAuNTUwMzQgMC42MDYxNiAxLjA2MTk0IDAuOTA0MjYxIDEuMzc2ODhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K", mIe = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Imljb24vMjQvYmFzaWNzLWNsb3NlIj4KPHBhdGggaWQ9IlNoYXBlIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE2LjIwNzIgMTQuNzkzTDkuNDE0MjEgOEw4IDkuNDE0MjFMMTQuNzkzIDE2LjIwNzJMOC4wMDAxNiAyM0w5LjQxNDM3IDI0LjQxNDJMMTYuMjA3MiAxNy42MjE0TDIzIDI0LjQxNDJMMjQuNDE0MiAyM0wxNy42MjE0IDE2LjIwNzJMMjQuNDE0NCA5LjQxNDIxTDIzLjAwMDIgOEwxNi4yMDcyIDE0Ljc5M1oiIGZpbGw9IiMzMzMzMzMiLz4KPC9nPgo8L3N2Zz4K", bIe = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMjAuODY2NCA0QzIxLjE1NjMgNCAyMS40NDYzIDQuMTEwOCAyMS42Njc5IDQuMzMxOTVDMjIuMTEwNyA0Ljc3NDIzIDIyLjExMDcgNS40OTIzOCAyMS42Njc5IDUuOTM1MTNMMTEuNjAzNCAxNS45OTk3TDIxLjY2NzkgMjYuMDY0OEMyMi4xMTA3IDI2LjUwNyAyMi4xMTA3IDI3LjIyNTIgMjEuNjY3OSAyNy42Njc5QzIxLjIyNTIgMjguMTEwNyAyMC41MDggMjguMTEwNyAyMC4wNjQ4IDI3LjY2NzlMOS4xOTg1OCAxNi44MDEzQzguNzU1ODQgMTYuMzU5IDguNzU1ODQgMTUuNjQwOSA5LjE5ODU4IDE1LjE5ODFMMjAuMDY0OCA0LjMzMTk1QzIwLjI4NjQgNC4xMTA4IDIwLjU3NjQgNCAyMC44NjY0IDRaIiBmaWxsPSIjMzMzMzMzIi8+Cjwvc3ZnPg==", yIe = ({
  color: e,
  fill: r,
  width: t,
  height: n
}) => /* @__PURE__ */ _.jsxs(
  "svg",
  {
    width: t,
    height: n,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ _.jsx(
        "path",
        {
          d: "M96.4073 49.0001C96.4073 75.1824 75.1823 96.4075 48.9999 96.4075C22.8175 96.4075 1.59253 75.1824 1.59253 49.0001C1.59253 22.8177 22.8175 1.59265 48.9999 1.59265C75.1823 1.59265 96.4073 22.8177 96.4073 49.0001Z",
          fill: r
        }
      ),
      /* @__PURE__ */ _.jsx(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M49 2.70379C23.4312 2.70379 2.70367 23.4313 2.70367 49.0001C2.70367 74.5688 23.4312 95.2964 49 95.2964C74.5687 95.2964 95.2963 74.5688 95.2963 49.0001C95.2963 23.4313 74.5687 2.70379 49 2.70379ZM0.481445 49.0001C0.481445 22.2041 22.2039 0.481567 49 0.481567C75.796 0.481567 97.5185 22.2041 97.5185 49.0001C97.5185 75.7961 75.796 97.5186 49 97.5186C22.2039 97.5186 0.481445 75.7961 0.481445 49.0001Z",
          fill: e
        }
      ),
      /* @__PURE__ */ _.jsx(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M45.0154 71.9425C43.486 72.0787 41.9748 71.53 40.8891 70.4443L26.0743 55.6295C24.0493 53.6045 24.0493 50.3214 26.0743 48.2965C28.0992 46.2716 31.3823 46.2716 33.4072 48.2965L43.8389 58.7282L64.0027 29.7426C65.6381 27.3918 68.8695 26.8118 71.2204 28.4472C73.5712 30.0825 74.1512 33.314 72.5158 35.6648L48.8121 69.7389C47.9353 70.9993 46.5448 71.8064 45.0154 71.9425Z",
          fill: e
        }
      ),
      /* @__PURE__ */ _.jsx(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M44.8182 69.7291C43.9443 69.8069 43.0808 69.4933 42.4603 68.8729L27.6455 54.0581C26.4884 52.901 26.4884 51.0249 27.6455 49.8678C28.8026 48.7107 30.6787 48.7107 31.8358 49.8678L44.146 62.178L65.8269 31.0117C66.7614 29.6683 68.6079 29.3369 69.9512 30.2714C71.2946 31.2059 71.626 33.0524 70.6915 34.3957L46.9878 68.4698C46.4867 69.1901 45.6922 69.6513 44.8182 69.7291Z",
          fill: "white"
        }
      )
    ]
  }
), SIe = () => /* @__PURE__ */ _.jsx(ln, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ _.jsx("img", { width: 32, height: 32, src: mIe, alt: "Close Modal Icon" }) }), xIe = () => /* @__PURE__ */ _.jsx(ln, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ _.jsx("img", { width: 80, height: 80, src: gIe, alt: "Upload Image" }) }), $Ie = () => /* @__PURE__ */ _.jsx(ln, { width: "8px", height: "16px", children: /* @__PURE__ */ _.jsx("img", { width: 8, height: 16, src: gD, alt: "right chevron" }) }), wIe = (e) => /* @__PURE__ */ _.jsx(ln, Fo(Yt({ width: "32px", height: "32px" }, e), { children: /* @__PURE__ */ _.jsx("img", { src: bIe, alt: "sample product image" }) })), oS = {
  "basic-modal-custom-header": "_basic-modal-custom-header_ejoga_2",
  "back-button": "_back-button_ejoga_6",
  "close-button": "_close-button_ejoga_18"
}, b_ = ({
  onClose: e,
  onBackClick: r,
  showBackButton: t
}) => /* @__PURE__ */ _.jsxs("div", { className: oS["basic-modal-custom-header"], children: [
  t && /* @__PURE__ */ _.jsx(wIe, { onClick: r, className: oS["back-button"] }),
  /* @__PURE__ */ _.jsx("button", { className: oS["close-button"], onClick: e, children: /* @__PURE__ */ _.jsx(SIe, {}) })
] }), Dl = {
  "bv-modal-overlay": "_bv-modal-overlay_i7sfy_3",
  "bv-modal": "_bv-modal_i7sfy_3",
  "bv-modal-close": "_bv-modal-close_i7sfy_34",
  "bv-modal-body": "_bv-modal-body_i7sfy_41",
  "bv-modal-continue": "_bv-modal-continue_i7sfy_53"
}, y_ = (e, r, t) => {
  er(() => {
    const n = (a) => {
      e.current && !e.current.contains(a.target) && window.innerWidth > 767 && t();
    };
    return r && document.addEventListener("mousedown", n), () => {
      document.removeEventListener("mousedown", n);
    };
  }, [r, t, e]);
}, _Ie = ({
  children: e,
  onClose: r,
  onContinue: t
}) => {
  let n = null, a = null, i = null;
  $o.Children.forEach(e, (c) => {
    if ($o.isValidElement(c)) {
      const { slot: f } = c.props;
      f === "header" ? n = c : f === "footer" ? i = c : a = c;
    } else
      a = c;
  });
  const l = () => /* @__PURE__ */ _.jsx("button", { className: Dl["bv-modal-close"], onClick: r, children: "X" }), u = () => /* @__PURE__ */ _.jsx(
    "button",
    {
      className: Dl["bv-modal-continue"],
      onClick: t || r,
      children: "Continuar"
    }
  );
  return {
    headerChild: n || /* @__PURE__ */ _.jsx(l, {}),
    bodyChild: a || null,
    footerChild: i || /* @__PURE__ */ _.jsx(u, {})
  };
}, RI = (e) => {
  e ? document.body.classList.add("bvwr-modal-open") : document.body.classList.remove("bvwr-modal-open");
}, TIe = (e) => {
  er(() => (RI(e), () => {
    RI(!1);
  }), [e]);
}, S_ = ({
  isOpen: e,
  onClose: r,
  onContinue: t,
  children: n,
  isApp: a
}) => {
  const i = Ze(null);
  TIe(e);
  const { headerChild: l, bodyChild: u, footerChild: c } = _Ie({
    children: n,
    onClose: r,
    onContinue: t
  });
  return y_(i, e, r), e ? /* @__PURE__ */ _.jsx(ln, { className: Dl["bv-modal-overlay"], children: /* @__PURE__ */ _.jsxs(ln, { className: Dl["bv-modal"], ref: i, children: [
    !a && /* @__PURE__ */ _.jsx(ln, { className: Dl["bv-modal-header"], children: l }),
    /* @__PURE__ */ _.jsx(ln, { className: Dl["bv-modal-body"], pt: a ? "48px" : "0", children: u }),
    /* @__PURE__ */ _.jsx(ln, { className: Dl["modal-footer"], children: c })
  ] }) }) : null;
}, mD = (n) => {
  var a = n, {
    product: e,
    queryParams: r
  } = a, t = Hv(a, [
    "product",
    "queryParams"
  ]);
  return /* @__PURE__ */ _.jsx(
    Nle,
    Yt({
      src: nIe({ product: e, queryParams: r }),
      fallbackSrc: "/product-image-fallback.jpeg",
      alt: "Product image",
      boxSize: t.boxSize || "80px",
      objectFit: t.objectFit || "cover"
    }, t)
  );
}, CIe = "_filled_3a18v_8", EIe = "_empty_3a18v_11", ap = {
  "bv-stars-section": "_bv-stars-section_3a18v_1",
  "star-icon": "_star-icon_3a18v_1",
  filled: CIe,
  empty: EIe
}, x_ = ({
  handleRatingClickHook: e,
  rating: r,
  fieldName: t = "rating"
}) => {
  const n = (i) => {
    e && e(t, i);
  }, a = ({ rating: i, index: l }) => i === 0 || i === null ? "" : i > l ? ap.filled : ap.empty;
  return /* @__PURE__ */ _.jsx(ZS, { className: ap["bv-stars-section"], spacing: "8px", children: [...Array(5)].map((i, l) => /* @__PURE__ */ _.jsx(
    "span",
    {
      role: "star-icon",
      "data-testid": `star-icon-${l + 1}`,
      className: `${ap["star-icon"]} ${a({
        rating: r,
        index: l
      })}`,
      onClick: () => n(l + 1)
    },
    l
  )) });
}, AIe = {
  "bv-separator": "_bv-separator_1khcz_1"
};
function PI() {
  return /* @__PURE__ */ _.jsx("div", { className: AIe["bv-separator"] });
}
const bD = Pn(
  void 0
), IIe = ({
  initialProduct: e,
  isSecondaryRatingsFormEnabled: r = !0,
  isReviewValidationWithOrder: t = !1,
  children: n
}) => {
  const [a, i] = He(e);
  return /* @__PURE__ */ _.jsx(
    bD.Provider,
    {
      value: {
        product: a,
        isSecondaryRatingsFormEnabled: r,
        isReviewValidationWithOrder: t,
        setProduct: i
      },
      children: n
    }
  );
}, gm = () => {
  const e = Ur(bD);
  if (!e)
    throw new Error("useProductContext must be used within a ProductProvider");
  return e;
}, yD = Pn(void 0), OIe = ({
  children: e,
  label: r = "Calificar",
  isLoggedIn: t = !0,
  openForm: n = !1,
  onClickSuccessButton: a,
  environment: i = "production",
  tenant: l = "cl",
  theme: u = { secondary_color: "#343E49" },
  recommendedThreshold: c = 80,
  isSodimacStandAlone: f = !1,
  fetchApiBaseUrl: h,
  enableEnglishReviews: p = !1
}) => /* @__PURE__ */ _.jsx(
  yD.Provider,
  {
    value: {
      label: r,
      isLoggedIn: t,
      openForm: n,
      onClickSuccessButton: a,
      environment: i,
      tenant: l,
      theme: u,
      recommendedThreshold: c,
      isSodimacStandAlone: f,
      fetchApiBaseUrl: h,
      enableEnglishReviews: p
    },
    children: e
  }
), Eo = () => {
  const e = Ur(yD);
  if (!e)
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  return e;
}, SD = Pn(
  void 0
), MIe = ({
  children: e
}) => {
  const { product: r } = gm(), { tenant: t, environment: n, fetchApiBaseUrl: a, enableEnglishReviews: i } = Eo(), l = m_({
    tenant: t,
    environment: n,
    fetchApiBaseUrl: a,
    enableEnglishReviews: i
  }), [u, c] = He(), [f, h] = He(), [p, g] = He(), [y, S] = He([]), [x, T] = He([]), [A, O] = He(), [P, j] = He(!1), [k, L] = He(), [M, W] = He(), [q, oe] = He([]), [Ae, Te] = He(0), [$e, Ee] = He([]), [ze, Ke] = He(), [Be, ue] = He("Rating:desc"), he = (te) => Number(te.toFixed(1)), _e = ({
    reviews: te
  }) => te.filter(
    (je) => {
      var ve;
      return ((ve = je == null ? void 0 : je.Photos) == null ? void 0 : ve.length) !== 0;
    }
  ), Oe = (te) => {
    var at;
    const {
      Results: fe,
      Includes: {
        Products: {
          [r.id]: {
            FilteredReviewStatistics: {
              AverageOverallRating: je,
              RatingDistribution: ve,
              RecommendedCount: rr,
              SecondaryRatingsAverages: br,
              SecondaryRatingsAveragesOrder: ur
            }
          }
        }
      },
      TotalResults: $r,
      HasErrors: Qe,
      Summary: yr
    } = te;
    Qe || !((at = te == null ? void 0 : te.Includes) != null && at.Products) || (je && c(he(je)), ve && O(ve), rr && g(rr), Object.keys(br).length !== 0 && (L(br), W(ur), j(!0)), fe && (oe(fe), Ee(_e({ reviews: fe }))), h($r), yr && Ke(yr));
  }, Me = () => Gr(void 0, null, function* () {
    const te = yield l.fetchReviews({
      productId: r.id,
      offset: Ae + 9,
      fetchStats: !1,
      sort: Be
    });
    Te((ve) => ve + 9);
    const { Results: fe, HasErrors: je } = te;
    je || fe && (oe((ve) => [...ve, ...fe]), Ee(
      (ve) => _e({ reviews: [...ve, ...fe] })
    ));
  }), Z = (te) => Gr(void 0, null, function* () {
    ue(te), Te(0);
    const fe = yield l.fetchReviews({
      productId: r.id,
      offset: 0,
      fetchStats: !0,
      sort: te
    });
    Oe(fe);
  }), se = ({
    reviewId: te,
    type: fe
  }) => {
    fe === "helpful" && S((je) => [...je, te]), fe === "not_helpful" && T((je) => [...je, te]);
  };
  return er(() => {
    (() => Gr(void 0, null, function* () {
      const fe = yield l.fetchReviews({
        productId: r.id,
        offset: 0,
        fetchStats: !0,
        sort: Be
      });
      Oe(fe);
    }))();
  }, [r.id]), er(() => {
    ue("Rating:desc"), Te(0);
  }, [r.id]), er(() => {
    (() => {
      const fe = document == null ? void 0 : document.cookie.split(";"), je = [], ve = [];
      fe.forEach((rr) => {
        const [br, ur] = rr.trim().split("=");
        if (br.startsWith("review_")) {
          const $r = br.substring(7);
          ur === "helpful" ? je.push($r) : ur === "not_helpful" && ve.push($r);
        }
      }), S(je), T(ve);
    })();
  }, []), /* @__PURE__ */ _.jsx(
    SD.Provider,
    {
      value: {
        averageRating: u,
        totalComments: f,
        ratingDistribution: A,
        recommendedCount: p,
        hasSecondaryRatings: P,
        secondaryRatingsAverages: k,
        secondaryRatingsAveragesOrder: M,
        userReviews: q,
        reviewsWithPhotos: $e,
        offset: Ae,
        getMoreReviews: Me,
        helpfulIds: y,
        notHelpfulIds: x,
        updateFeedbackReviewsList: se,
        reviewsSummary: ze,
        sort: Be,
        changeSort: Z
      },
      children: e
    }
  );
}, ea = () => {
  const e = Ur(SD);
  if (!e)
    throw new Error(
      "useReviewsStatsContext must be used within a ReviewsStatsProvider"
    );
  return e;
}, RIe = "_title_t0xbj_7", PIe = "_section_t0xbj_38", kIe = "_attributes_t0xbj_3", jIe = "_attribute_t0xbj_3", DIe = "_name_t0xbj_56", xn = {
  "attributes-by-category-form": "_attributes-by-category-form_t0xbj_3",
  title: RIe,
  "image-and-product-name": "_image-and-product-name_t0xbj_14",
  "product-name": "_product-name_t0xbj_24",
  "first-separator": "_first-separator_t0xbj_30",
  section: PIe,
  attributes: kIe,
  attribute: jIe,
  name: DIe,
  "dots-rating": "_dots-rating_t0xbj_62",
  "bv-dots-radio-buttons": "_bv-dots-radio-buttons_t0xbj_73",
  "footer-by-category-form": "_footer-by-category-form_t0xbj_78",
  "main-button-wrapper": "_main-button-wrapper_t0xbj_78",
  "back-button": "_back-button_t0xbj_88",
  "main-button": "_main-button_t0xbj_78"
};
var NIe = function(r) {
  return LIe(r) && !FIe(r);
};
function LIe(e) {
  return !!e && typeof e == "object";
}
function FIe(e) {
  var r = Object.prototype.toString.call(e);
  return r === "[object RegExp]" || r === "[object Date]" || UIe(e);
}
var zIe = typeof Symbol == "function" && Symbol.for, BIe = zIe ? Symbol.for("react.element") : 60103;
function UIe(e) {
  return e.$$typeof === BIe;
}
function VIe(e) {
  return Array.isArray(e) ? [] : {};
}
function F0(e, r) {
  return r.clone !== !1 && r.isMergeableObject(e) ? Cf(VIe(e), e, r) : e;
}
function WIe(e, r, t) {
  return e.concat(r).map(function(n) {
    return F0(n, t);
  });
}
function HIe(e, r, t) {
  var n = {};
  return t.isMergeableObject(e) && Object.keys(e).forEach(function(a) {
    n[a] = F0(e[a], t);
  }), Object.keys(r).forEach(function(a) {
    !t.isMergeableObject(r[a]) || !e[a] ? n[a] = F0(r[a], t) : n[a] = Cf(e[a], r[a], t);
  }), n;
}
function Cf(e, r, t) {
  t = t || {}, t.arrayMerge = t.arrayMerge || WIe, t.isMergeableObject = t.isMergeableObject || NIe;
  var n = Array.isArray(r), a = Array.isArray(e), i = n === a;
  return i ? n ? t.arrayMerge(e, r, t) : HIe(e, r, t) : F0(r, t);
}
Cf.all = function(r, t) {
  if (!Array.isArray(r))
    throw new Error("first argument should be an array");
  return r.reduce(function(n, a) {
    return Cf(n, a, t);
  }, {});
};
var p2 = Cf, GIe = typeof global == "object" && global && global.Object === Object && global;
const xD = GIe;
var YIe = typeof self == "object" && self && self.Object === Object && self, KIe = xD || YIe || Function("return this")();
const ci = KIe;
var qIe = ci.Symbol;
const zs = qIe;
var $D = Object.prototype, ZIe = $D.hasOwnProperty, QIe = $D.toString, md = zs ? zs.toStringTag : void 0;
function XIe(e) {
  var r = ZIe.call(e, md), t = e[md];
  try {
    e[md] = void 0;
    var n = !0;
  } catch (i) {
  }
  var a = QIe.call(e);
  return n && (r ? e[md] = t : delete e[md]), a;
}
var JIe = Object.prototype, eOe = JIe.toString;
function rOe(e) {
  return eOe.call(e);
}
var tOe = "[object Null]", nOe = "[object Undefined]", kI = zs ? zs.toStringTag : void 0;
function vu(e) {
  return e == null ? e === void 0 ? nOe : tOe : kI && kI in Object(e) ? XIe(e) : rOe(e);
}
function wD(e, r) {
  return function(t) {
    return e(r(t));
  };
}
var aOe = wD(Object.getPrototypeOf, Object);
const $_ = aOe;
function hu(e) {
  return e != null && typeof e == "object";
}
var oOe = "[object Object]", iOe = Function.prototype, sOe = Object.prototype, _D = iOe.toString, lOe = sOe.hasOwnProperty, uOe = _D.call(Object);
function jI(e) {
  if (!hu(e) || vu(e) != oOe)
    return !1;
  var r = $_(e);
  if (r === null)
    return !0;
  var t = lOe.call(r, "constructor") && r.constructor;
  return typeof t == "function" && t instanceof t && _D.call(t) == uOe;
}
var DI = Array.isArray, NI = Object.keys, cOe = Object.prototype.hasOwnProperty, dOe = typeof Element != "undefined";
function g2(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    var t = DI(e), n = DI(r), a, i, l;
    if (t && n) {
      if (i = e.length, i != r.length)
        return !1;
      for (a = i; a-- !== 0; )
        if (!g2(e[a], r[a]))
          return !1;
      return !0;
    }
    if (t != n)
      return !1;
    var u = e instanceof Date, c = r instanceof Date;
    if (u != c)
      return !1;
    if (u && c)
      return e.getTime() == r.getTime();
    var f = e instanceof RegExp, h = r instanceof RegExp;
    if (f != h)
      return !1;
    if (f && h)
      return e.toString() == r.toString();
    var p = NI(e);
    if (i = p.length, i !== NI(r).length)
      return !1;
    for (a = i; a-- !== 0; )
      if (!cOe.call(r, p[a]))
        return !1;
    if (dOe && e instanceof Element && r instanceof Element)
      return e === r;
    for (a = i; a-- !== 0; )
      if (l = p[a], !(l === "_owner" && e.$$typeof) && !g2(e[l], r[l]))
        return !1;
    return !0;
  }
  return e !== e && r !== r;
}
var fOe = function(r, t) {
  try {
    return g2(r, t);
  } catch (n) {
    if (n.message && n.message.match(/stack|recursion/i) || n.number === -2146828260)
      return console.warn("Warning: react-fast-compare does not handle circular references.", n.name, n.message), !1;
    throw n;
  }
};
const Il = /* @__PURE__ */ G0(fOe);
var vOe = !0;
function hOe(e, r) {
  if (!vOe) {
    if (e)
      return;
    var t = "Warning: " + r;
    typeof console != "undefined" && console.warn(t);
    try {
      throw Error(t);
    } catch (n) {
    }
  }
}
function pOe() {
  this.__data__ = [], this.size = 0;
}
function TD(e, r) {
  return e === r || e !== e && r !== r;
}
function mm(e, r) {
  for (var t = e.length; t--; )
    if (TD(e[t][0], r))
      return t;
  return -1;
}
var gOe = Array.prototype, mOe = gOe.splice;
function bOe(e) {
  var r = this.__data__, t = mm(r, e);
  if (t < 0)
    return !1;
  var n = r.length - 1;
  return t == n ? r.pop() : mOe.call(r, t, 1), --this.size, !0;
}
function yOe(e) {
  var r = this.__data__, t = mm(r, e);
  return t < 0 ? void 0 : r[t][1];
}
function SOe(e) {
  return mm(this.__data__, e) > -1;
}
function xOe(e, r) {
  var t = this.__data__, n = mm(t, e);
  return n < 0 ? (++this.size, t.push([e, r])) : t[n][1] = r, this;
}
function Vi(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
Vi.prototype.clear = pOe;
Vi.prototype.delete = bOe;
Vi.prototype.get = yOe;
Vi.prototype.has = SOe;
Vi.prototype.set = xOe;
function $Oe() {
  this.__data__ = new Vi(), this.size = 0;
}
function wOe(e) {
  var r = this.__data__, t = r.delete(e);
  return this.size = r.size, t;
}
function _Oe(e) {
  return this.__data__.get(e);
}
function TOe(e) {
  return this.__data__.has(e);
}
function tv(e) {
  var r = typeof e;
  return e != null && (r == "object" || r == "function");
}
var COe = "[object AsyncFunction]", EOe = "[object Function]", AOe = "[object GeneratorFunction]", IOe = "[object Proxy]";
function CD(e) {
  if (!tv(e))
    return !1;
  var r = vu(e);
  return r == EOe || r == AOe || r == COe || r == IOe;
}
var OOe = ci["__core-js_shared__"];
const iS = OOe;
var LI = function() {
  var e = /[^.]+$/.exec(iS && iS.keys && iS.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function MOe(e) {
  return !!LI && LI in e;
}
var ROe = Function.prototype, POe = ROe.toString;
function pu(e) {
  if (e != null) {
    try {
      return POe.call(e);
    } catch (r) {
    }
    try {
      return e + "";
    } catch (r) {
    }
  }
  return "";
}
var kOe = /[\\^$.*+?()[\]{}|]/g, jOe = /^\[object .+?Constructor\]$/, DOe = Function.prototype, NOe = Object.prototype, LOe = DOe.toString, FOe = NOe.hasOwnProperty, zOe = RegExp(
  "^" + LOe.call(FOe).replace(kOe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function BOe(e) {
  if (!tv(e) || MOe(e))
    return !1;
  var r = CD(e) ? zOe : jOe;
  return r.test(pu(e));
}
function UOe(e, r) {
  return e == null ? void 0 : e[r];
}
function gu(e, r) {
  var t = UOe(e, r);
  return BOe(t) ? t : void 0;
}
var VOe = gu(ci, "Map");
const Ef = VOe;
var WOe = gu(Object, "create");
const Af = WOe;
function HOe() {
  this.__data__ = Af ? Af(null) : {}, this.size = 0;
}
function GOe(e) {
  var r = this.has(e) && delete this.__data__[e];
  return this.size -= r ? 1 : 0, r;
}
var YOe = "__lodash_hash_undefined__", KOe = Object.prototype, qOe = KOe.hasOwnProperty;
function ZOe(e) {
  var r = this.__data__;
  if (Af) {
    var t = r[e];
    return t === YOe ? void 0 : t;
  }
  return qOe.call(r, e) ? r[e] : void 0;
}
var QOe = Object.prototype, XOe = QOe.hasOwnProperty;
function JOe(e) {
  var r = this.__data__;
  return Af ? r[e] !== void 0 : XOe.call(r, e);
}
var eMe = "__lodash_hash_undefined__";
function rMe(e, r) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = Af && r === void 0 ? eMe : r, this;
}
function iu(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
iu.prototype.clear = HOe;
iu.prototype.delete = GOe;
iu.prototype.get = ZOe;
iu.prototype.has = JOe;
iu.prototype.set = rMe;
function tMe() {
  this.size = 0, this.__data__ = {
    hash: new iu(),
    map: new (Ef || Vi)(),
    string: new iu()
  };
}
function nMe(e) {
  var r = typeof e;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
}
function bm(e, r) {
  var t = e.__data__;
  return nMe(r) ? t[typeof r == "string" ? "string" : "hash"] : t.map;
}
function aMe(e) {
  var r = bm(this, e).delete(e);
  return this.size -= r ? 1 : 0, r;
}
function oMe(e) {
  return bm(this, e).get(e);
}
function iMe(e) {
  return bm(this, e).has(e);
}
function sMe(e, r) {
  var t = bm(this, e), n = t.size;
  return t.set(e, r), this.size += t.size == n ? 0 : 1, this;
}
function Ys(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
Ys.prototype.clear = tMe;
Ys.prototype.delete = aMe;
Ys.prototype.get = oMe;
Ys.prototype.has = iMe;
Ys.prototype.set = sMe;
var lMe = 200;
function uMe(e, r) {
  var t = this.__data__;
  if (t instanceof Vi) {
    var n = t.__data__;
    if (!Ef || n.length < lMe - 1)
      return n.push([e, r]), this.size = ++t.size, this;
    t = this.__data__ = new Ys(n);
  }
  return t.set(e, r), this.size = t.size, this;
}
function Fc(e) {
  var r = this.__data__ = new Vi(e);
  this.size = r.size;
}
Fc.prototype.clear = $Oe;
Fc.prototype.delete = wOe;
Fc.prototype.get = _Oe;
Fc.prototype.has = TOe;
Fc.prototype.set = uMe;
function cMe(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length; ++t < n && r(e[t], t, e) !== !1; )
    ;
  return e;
}
var dMe = function() {
  try {
    var e = gu(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch (r) {
  }
}();
const FI = dMe;
function ED(e, r, t) {
  r == "__proto__" && FI ? FI(e, r, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : e[r] = t;
}
var fMe = Object.prototype, vMe = fMe.hasOwnProperty;
function AD(e, r, t) {
  var n = e[r];
  (!(vMe.call(e, r) && TD(n, t)) || t === void 0 && !(r in e)) && ED(e, r, t);
}
function ym(e, r, t, n) {
  var a = !t;
  t || (t = {});
  for (var i = -1, l = r.length; ++i < l; ) {
    var u = r[i], c = n ? n(t[u], e[u], u, t, e) : void 0;
    c === void 0 && (c = e[u]), a ? ED(t, u, c) : AD(t, u, c);
  }
  return t;
}
function hMe(e, r) {
  for (var t = -1, n = Array(e); ++t < e; )
    n[t] = r(t);
  return n;
}
var pMe = "[object Arguments]";
function zI(e) {
  return hu(e) && vu(e) == pMe;
}
var ID = Object.prototype, gMe = ID.hasOwnProperty, mMe = ID.propertyIsEnumerable, bMe = zI(function() {
  return arguments;
}()) ? zI : function(e) {
  return hu(e) && gMe.call(e, "callee") && !mMe.call(e, "callee");
};
const yMe = bMe;
var SMe = Array.isArray;
const nv = SMe;
function xMe() {
  return !1;
}
var OD = typeof exports == "object" && exports && !exports.nodeType && exports, BI = OD && typeof module == "object" && module && !module.nodeType && module, $Me = BI && BI.exports === OD, UI = $Me ? ci.Buffer : void 0, wMe = UI ? UI.isBuffer : void 0, _Me = wMe || xMe;
const MD = _Me;
var TMe = 9007199254740991, CMe = /^(?:0|[1-9]\d*)$/;
function EMe(e, r) {
  var t = typeof e;
  return r = r == null ? TMe : r, !!r && (t == "number" || t != "symbol" && CMe.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
var AMe = 9007199254740991;
function RD(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= AMe;
}
var IMe = "[object Arguments]", OMe = "[object Array]", MMe = "[object Boolean]", RMe = "[object Date]", PMe = "[object Error]", kMe = "[object Function]", jMe = "[object Map]", DMe = "[object Number]", NMe = "[object Object]", LMe = "[object RegExp]", FMe = "[object Set]", zMe = "[object String]", BMe = "[object WeakMap]", UMe = "[object ArrayBuffer]", VMe = "[object DataView]", WMe = "[object Float32Array]", HMe = "[object Float64Array]", GMe = "[object Int8Array]", YMe = "[object Int16Array]", KMe = "[object Int32Array]", qMe = "[object Uint8Array]", ZMe = "[object Uint8ClampedArray]", QMe = "[object Uint16Array]", XMe = "[object Uint32Array]", ct = {};
ct[WMe] = ct[HMe] = ct[GMe] = ct[YMe] = ct[KMe] = ct[qMe] = ct[ZMe] = ct[QMe] = ct[XMe] = !0;
ct[IMe] = ct[OMe] = ct[UMe] = ct[MMe] = ct[VMe] = ct[RMe] = ct[PMe] = ct[kMe] = ct[jMe] = ct[DMe] = ct[NMe] = ct[LMe] = ct[FMe] = ct[zMe] = ct[BMe] = !1;
function JMe(e) {
  return hu(e) && RD(e.length) && !!ct[vu(e)];
}
function w_(e) {
  return function(r) {
    return e(r);
  };
}
var PD = typeof exports == "object" && exports && !exports.nodeType && exports, qd = PD && typeof module == "object" && module && !module.nodeType && module, eRe = qd && qd.exports === PD, sS = eRe && xD.process, rRe = function() {
  try {
    var e = qd && qd.require && qd.require("util").types;
    return e || sS && sS.binding && sS.binding("util");
  } catch (r) {
  }
}();
const wc = rRe;
var VI = wc && wc.isTypedArray, tRe = VI ? w_(VI) : JMe;
const nRe = tRe;
var aRe = Object.prototype, oRe = aRe.hasOwnProperty;
function kD(e, r) {
  var t = nv(e), n = !t && yMe(e), a = !t && !n && MD(e), i = !t && !n && !a && nRe(e), l = t || n || a || i, u = l ? hMe(e.length, String) : [], c = u.length;
  for (var f in e)
    (r || oRe.call(e, f)) && !(l && // Safari 9 has enumerable `arguments.length` in strict mode.
    (f == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (f == "offset" || f == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (f == "buffer" || f == "byteLength" || f == "byteOffset") || // Skip index properties.
    EMe(f, c))) && u.push(f);
  return u;
}
var iRe = Object.prototype;
function __(e) {
  var r = e && e.constructor, t = typeof r == "function" && r.prototype || iRe;
  return e === t;
}
var sRe = wD(Object.keys, Object);
const lRe = sRe;
var uRe = Object.prototype, cRe = uRe.hasOwnProperty;
function dRe(e) {
  if (!__(e))
    return lRe(e);
  var r = [];
  for (var t in Object(e))
    cRe.call(e, t) && t != "constructor" && r.push(t);
  return r;
}
function jD(e) {
  return e != null && RD(e.length) && !CD(e);
}
function T_(e) {
  return jD(e) ? kD(e) : dRe(e);
}
function fRe(e, r) {
  return e && ym(r, T_(r), e);
}
function vRe(e) {
  var r = [];
  if (e != null)
    for (var t in Object(e))
      r.push(t);
  return r;
}
var hRe = Object.prototype, pRe = hRe.hasOwnProperty;
function gRe(e) {
  if (!tv(e))
    return vRe(e);
  var r = __(e), t = [];
  for (var n in e)
    n == "constructor" && (r || !pRe.call(e, n)) || t.push(n);
  return t;
}
function C_(e) {
  return jD(e) ? kD(e, !0) : gRe(e);
}
function mRe(e, r) {
  return e && ym(r, C_(r), e);
}
var DD = typeof exports == "object" && exports && !exports.nodeType && exports, WI = DD && typeof module == "object" && module && !module.nodeType && module, bRe = WI && WI.exports === DD, HI = bRe ? ci.Buffer : void 0, GI = HI ? HI.allocUnsafe : void 0;
function yRe(e, r) {
  if (r)
    return e.slice();
  var t = e.length, n = GI ? GI(t) : new e.constructor(t);
  return e.copy(n), n;
}
function ND(e, r) {
  var t = -1, n = e.length;
  for (r || (r = Array(n)); ++t < n; )
    r[t] = e[t];
  return r;
}
function SRe(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++t < n; ) {
    var l = e[t];
    r(l, t, e) && (i[a++] = l);
  }
  return i;
}
function LD() {
  return [];
}
var xRe = Object.prototype, $Re = xRe.propertyIsEnumerable, YI = Object.getOwnPropertySymbols, wRe = YI ? function(e) {
  return e == null ? [] : (e = Object(e), SRe(YI(e), function(r) {
    return $Re.call(e, r);
  }));
} : LD;
const E_ = wRe;
function _Re(e, r) {
  return ym(e, E_(e), r);
}
function FD(e, r) {
  for (var t = -1, n = r.length, a = e.length; ++t < n; )
    e[a + t] = r[t];
  return e;
}
var TRe = Object.getOwnPropertySymbols, CRe = TRe ? function(e) {
  for (var r = []; e; )
    FD(r, E_(e)), e = $_(e);
  return r;
} : LD;
const zD = CRe;
function ERe(e, r) {
  return ym(e, zD(e), r);
}
function BD(e, r, t) {
  var n = r(e);
  return nv(e) ? n : FD(n, t(e));
}
function ARe(e) {
  return BD(e, T_, E_);
}
function IRe(e) {
  return BD(e, C_, zD);
}
var ORe = gu(ci, "DataView");
const m2 = ORe;
var MRe = gu(ci, "Promise");
const b2 = MRe;
var RRe = gu(ci, "Set");
const y2 = RRe;
var PRe = gu(ci, "WeakMap");
const S2 = PRe;
var KI = "[object Map]", kRe = "[object Object]", qI = "[object Promise]", ZI = "[object Set]", QI = "[object WeakMap]", XI = "[object DataView]", jRe = pu(m2), DRe = pu(Ef), NRe = pu(b2), LRe = pu(y2), FRe = pu(S2), Ol = vu;
(m2 && Ol(new m2(new ArrayBuffer(1))) != XI || Ef && Ol(new Ef()) != KI || b2 && Ol(b2.resolve()) != qI || y2 && Ol(new y2()) != ZI || S2 && Ol(new S2()) != QI) && (Ol = function(e) {
  var r = vu(e), t = r == kRe ? e.constructor : void 0, n = t ? pu(t) : "";
  if (n)
    switch (n) {
      case jRe:
        return XI;
      case DRe:
        return KI;
      case NRe:
        return qI;
      case LRe:
        return ZI;
      case FRe:
        return QI;
    }
  return r;
});
const A_ = Ol;
var zRe = Object.prototype, BRe = zRe.hasOwnProperty;
function URe(e) {
  var r = e.length, t = new e.constructor(r);
  return r && typeof e[0] == "string" && BRe.call(e, "index") && (t.index = e.index, t.input = e.input), t;
}
var VRe = ci.Uint8Array;
const JI = VRe;
function I_(e) {
  var r = new e.constructor(e.byteLength);
  return new JI(r).set(new JI(e)), r;
}
function WRe(e, r) {
  var t = r ? I_(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.byteLength);
}
var HRe = /\w*$/;
function GRe(e) {
  var r = new e.constructor(e.source, HRe.exec(e));
  return r.lastIndex = e.lastIndex, r;
}
var eO = zs ? zs.prototype : void 0, rO = eO ? eO.valueOf : void 0;
function YRe(e) {
  return rO ? Object(rO.call(e)) : {};
}
function KRe(e, r) {
  var t = r ? I_(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.length);
}
var qRe = "[object Boolean]", ZRe = "[object Date]", QRe = "[object Map]", XRe = "[object Number]", JRe = "[object RegExp]", ePe = "[object Set]", rPe = "[object String]", tPe = "[object Symbol]", nPe = "[object ArrayBuffer]", aPe = "[object DataView]", oPe = "[object Float32Array]", iPe = "[object Float64Array]", sPe = "[object Int8Array]", lPe = "[object Int16Array]", uPe = "[object Int32Array]", cPe = "[object Uint8Array]", dPe = "[object Uint8ClampedArray]", fPe = "[object Uint16Array]", vPe = "[object Uint32Array]";
function hPe(e, r, t) {
  var n = e.constructor;
  switch (r) {
    case nPe:
      return I_(e);
    case qRe:
    case ZRe:
      return new n(+e);
    case aPe:
      return WRe(e, t);
    case oPe:
    case iPe:
    case sPe:
    case lPe:
    case uPe:
    case cPe:
    case dPe:
    case fPe:
    case vPe:
      return KRe(e, t);
    case QRe:
      return new n();
    case XRe:
    case rPe:
      return new n(e);
    case JRe:
      return GRe(e);
    case ePe:
      return new n();
    case tPe:
      return YRe(e);
  }
}
var tO = Object.create, pPe = function() {
  function e() {
  }
  return function(r) {
    if (!tv(r))
      return {};
    if (tO)
      return tO(r);
    e.prototype = r;
    var t = new e();
    return e.prototype = void 0, t;
  };
}();
const gPe = pPe;
function mPe(e) {
  return typeof e.constructor == "function" && !__(e) ? gPe($_(e)) : {};
}
var bPe = "[object Map]";
function yPe(e) {
  return hu(e) && A_(e) == bPe;
}
var nO = wc && wc.isMap, SPe = nO ? w_(nO) : yPe;
const xPe = SPe;
var $Pe = "[object Set]";
function wPe(e) {
  return hu(e) && A_(e) == $Pe;
}
var aO = wc && wc.isSet, _Pe = aO ? w_(aO) : wPe;
const TPe = _Pe;
var CPe = 1, EPe = 2, APe = 4, UD = "[object Arguments]", IPe = "[object Array]", OPe = "[object Boolean]", MPe = "[object Date]", RPe = "[object Error]", VD = "[object Function]", PPe = "[object GeneratorFunction]", kPe = "[object Map]", jPe = "[object Number]", WD = "[object Object]", DPe = "[object RegExp]", NPe = "[object Set]", LPe = "[object String]", FPe = "[object Symbol]", zPe = "[object WeakMap]", BPe = "[object ArrayBuffer]", UPe = "[object DataView]", VPe = "[object Float32Array]", WPe = "[object Float64Array]", HPe = "[object Int8Array]", GPe = "[object Int16Array]", YPe = "[object Int32Array]", KPe = "[object Uint8Array]", qPe = "[object Uint8ClampedArray]", ZPe = "[object Uint16Array]", QPe = "[object Uint32Array]", tt = {};
tt[UD] = tt[IPe] = tt[BPe] = tt[UPe] = tt[OPe] = tt[MPe] = tt[VPe] = tt[WPe] = tt[HPe] = tt[GPe] = tt[YPe] = tt[kPe] = tt[jPe] = tt[WD] = tt[DPe] = tt[NPe] = tt[LPe] = tt[FPe] = tt[KPe] = tt[qPe] = tt[ZPe] = tt[QPe] = !0;
tt[RPe] = tt[VD] = tt[zPe] = !1;
function Wp(e, r, t, n, a, i) {
  var l, u = r & CPe, c = r & EPe, f = r & APe;
  if (t && (l = a ? t(e, n, a, i) : t(e)), l !== void 0)
    return l;
  if (!tv(e))
    return e;
  var h = nv(e);
  if (h) {
    if (l = URe(e), !u)
      return ND(e, l);
  } else {
    var p = A_(e), g = p == VD || p == PPe;
    if (MD(e))
      return yRe(e, u);
    if (p == WD || p == UD || g && !a) {
      if (l = c || g ? {} : mPe(e), !u)
        return c ? ERe(e, mRe(l, e)) : _Re(e, fRe(l, e));
    } else {
      if (!tt[p])
        return a ? e : {};
      l = hPe(e, p, u);
    }
  }
  i || (i = new Fc());
  var y = i.get(e);
  if (y)
    return y;
  i.set(e, l), TPe(e) ? e.forEach(function(T) {
    l.add(Wp(T, r, t, T, e, i));
  }) : xPe(e) && e.forEach(function(T, A) {
    l.set(A, Wp(T, r, t, A, e, i));
  });
  var S = f ? c ? IRe : ARe : c ? C_ : T_, x = h ? void 0 : S(e);
  return cMe(x || e, function(T, A) {
    x && (A = T, T = e[A]), AD(l, A, Wp(T, r, t, A, e, i));
  }), l;
}
var XPe = 4;
function oO(e) {
  return Wp(e, XPe);
}
function HD(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, a = Array(n); ++t < n; )
    a[t] = r(e[t], t, e);
  return a;
}
var JPe = "[object Symbol]";
function O_(e) {
  return typeof e == "symbol" || hu(e) && vu(e) == JPe;
}
var eke = "Expected a function";
function M_(e, r) {
  if (typeof e != "function" || r != null && typeof r != "function")
    throw new TypeError(eke);
  var t = function() {
    var n = arguments, a = r ? r.apply(this, n) : n[0], i = t.cache;
    if (i.has(a))
      return i.get(a);
    var l = e.apply(this, n);
    return t.cache = i.set(a, l) || i, l;
  };
  return t.cache = new (M_.Cache || Ys)(), t;
}
M_.Cache = Ys;
var rke = 500;
function tke(e) {
  var r = M_(e, function(n) {
    return t.size === rke && t.clear(), n;
  }), t = r.cache;
  return r;
}
var nke = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ake = /\\(\\)?/g, oke = tke(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(nke, function(t, n, a, i) {
    r.push(a ? i.replace(ake, "$1") : n || t);
  }), r;
});
const ike = oke;
var ske = 1 / 0;
function lke(e) {
  if (typeof e == "string" || O_(e))
    return e;
  var r = e + "";
  return r == "0" && 1 / e == -ske ? "-0" : r;
}
var uke = 1 / 0, iO = zs ? zs.prototype : void 0, sO = iO ? iO.toString : void 0;
function GD(e) {
  if (typeof e == "string")
    return e;
  if (nv(e))
    return HD(e, GD) + "";
  if (O_(e))
    return sO ? sO.call(e) : "";
  var r = e + "";
  return r == "0" && 1 / e == -uke ? "-0" : r;
}
function cke(e) {
  return e == null ? "" : GD(e);
}
function YD(e) {
  return nv(e) ? HD(e, lke) : O_(e) ? [e] : ND(ike(cke(e)));
}
function Kt() {
  return Kt = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Kt.apply(this, arguments);
}
function KD(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var Sm = /* @__PURE__ */ Pn(void 0);
Sm.displayName = "FormikContext";
Sm.Provider;
Sm.Consumer;
function dke() {
  var e = Ur(Sm);
  return e || hOe(!1), e;
}
var go = function(r) {
  return typeof r == "function";
}, xm = function(r) {
  return r !== null && typeof r == "object";
}, fke = function(r) {
  return String(Math.floor(Number(r))) === r;
}, lS = function(r) {
  return Object.prototype.toString.call(r) === "[object String]";
}, uS = function(r) {
  return xm(r) && go(r.then);
};
function pa(e, r, t, n) {
  n === void 0 && (n = 0);
  for (var a = YD(r); e && n < a.length; )
    e = e[a[n++]];
  return n !== a.length && !e || e === void 0 ? t : e;
}
function ru(e, r, t) {
  for (var n = oO(e), a = n, i = 0, l = YD(r); i < l.length - 1; i++) {
    var u = l[i], c = pa(e, l.slice(0, i + 1));
    if (c && (xm(c) || Array.isArray(c)))
      a = a[u] = oO(c);
    else {
      var f = l[i + 1];
      a = a[u] = fke(f) && Number(f) >= 0 ? [] : {};
    }
  }
  return (i === 0 ? e : a)[l[i]] === t ? e : (t === void 0 ? delete a[l[i]] : a[l[i]] = t, i === 0 && t === void 0 && delete n[l[i]], n);
}
function qD(e, r, t, n) {
  t === void 0 && (t = /* @__PURE__ */ new WeakMap()), n === void 0 && (n = {});
  for (var a = 0, i = Object.keys(e); a < i.length; a++) {
    var l = i[a], u = e[l];
    xm(u) ? t.get(u) || (t.set(u, !0), n[l] = Array.isArray(u) ? [] : {}, qD(u, r, t, n[l])) : n[l] = r;
  }
  return n;
}
function vke(e, r) {
  switch (r.type) {
    case "SET_VALUES":
      return Kt({}, e, {
        values: r.payload
      });
    case "SET_TOUCHED":
      return Kt({}, e, {
        touched: r.payload
      });
    case "SET_ERRORS":
      return Il(e.errors, r.payload) ? e : Kt({}, e, {
        errors: r.payload
      });
    case "SET_STATUS":
      return Kt({}, e, {
        status: r.payload
      });
    case "SET_ISSUBMITTING":
      return Kt({}, e, {
        isSubmitting: r.payload
      });
    case "SET_ISVALIDATING":
      return Kt({}, e, {
        isValidating: r.payload
      });
    case "SET_FIELD_VALUE":
      return Kt({}, e, {
        values: ru(e.values, r.payload.field, r.payload.value)
      });
    case "SET_FIELD_TOUCHED":
      return Kt({}, e, {
        touched: ru(e.touched, r.payload.field, r.payload.value)
      });
    case "SET_FIELD_ERROR":
      return Kt({}, e, {
        errors: ru(e.errors, r.payload.field, r.payload.value)
      });
    case "RESET_FORM":
      return Kt({}, e, r.payload);
    case "SET_FORMIK_STATE":
      return r.payload(e);
    case "SUBMIT_ATTEMPT":
      return Kt({}, e, {
        touched: qD(e.values, !0),
        isSubmitting: !0,
        submitCount: e.submitCount + 1
      });
    case "SUBMIT_FAILURE":
      return Kt({}, e, {
        isSubmitting: !1
      });
    case "SUBMIT_SUCCESS":
      return Kt({}, e, {
        isSubmitting: !1
      });
    default:
      return e;
  }
}
var El = {}, op = {};
function ZD(e) {
  var r = e.validateOnChange, t = r === void 0 ? !0 : r, n = e.validateOnBlur, a = n === void 0 ? !0 : n, i = e.validateOnMount, l = i === void 0 ? !1 : i, u = e.isInitialValid, c = e.enableReinitialize, f = c === void 0 ? !1 : c, h = e.onSubmit, p = KD(e, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]), g = Kt({
    validateOnChange: t,
    validateOnBlur: a,
    validateOnMount: l,
    onSubmit: h
  }, p), y = Ze(g.initialValues), S = Ze(g.initialErrors || El), x = Ze(g.initialTouched || op), T = Ze(g.initialStatus), A = Ze(!1), O = Ze({});
  er(function() {
    return A.current = !0, function() {
      A.current = !1;
    };
  }, []);
  var P = He(0), j = P[1], k = Ze({
    values: g.initialValues,
    errors: g.initialErrors || El,
    touched: g.initialTouched || op,
    status: g.initialStatus,
    isSubmitting: !1,
    isValidating: !1,
    submitCount: 0
  }), L = k.current, M = Le(function(G) {
    var ne = k.current;
    k.current = vke(ne, G), ne !== k.current && j(function(Y) {
      return Y + 1;
    });
  }, []), W = Le(function(G, ne) {
    return new Promise(function(Y, Q) {
      var we = g.validate(G, ne);
      we == null ? Y(El) : uS(we) ? we.then(function(be) {
        Y(be || El);
      }, function(be) {
        Q(be);
      }) : Y(we);
    });
  }, [g.validate]), q = Le(function(G, ne) {
    var Y = g.validationSchema, Q = go(Y) ? Y(ne) : Y, we = ne && Q.validateAt ? Q.validateAt(ne, G) : pke(G, Q);
    return new Promise(function(be, Re) {
      we.then(function() {
        be(El);
      }, function(cr) {
        cr.name === "ValidationError" ? be(hke(cr)) : Re(cr);
      });
    });
  }, [g.validationSchema]), oe = Le(function(G, ne) {
    return new Promise(function(Y) {
      return Y(O.current[G].validate(ne));
    });
  }, []), Ae = Le(function(G) {
    var ne = Object.keys(O.current).filter(function(Q) {
      return go(O.current[Q].validate);
    }), Y = ne.length > 0 ? ne.map(function(Q) {
      return oe(Q, pa(G, Q));
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(Y).then(function(Q) {
      return Q.reduce(function(we, be, Re) {
        return be === "DO_NOT_DELETE_YOU_WILL_BE_FIRED" || be && (we = ru(we, ne[Re], be)), we;
      }, {});
    });
  }, [oe]), Te = Le(function(G) {
    return Promise.all([Ae(G), g.validationSchema ? q(G) : {}, g.validate ? W(G) : {}]).then(function(ne) {
      var Y = ne[0], Q = ne[1], we = ne[2], be = p2.all([Y, Q, we], {
        arrayMerge: gke
      });
      return be;
    });
  }, [g.validate, g.validationSchema, Ae, W, q]), $e = Da(function(G) {
    return G === void 0 && (G = L.values), M({
      type: "SET_ISVALIDATING",
      payload: !0
    }), Te(G).then(function(ne) {
      return A.current && (M({
        type: "SET_ISVALIDATING",
        payload: !1
      }), M({
        type: "SET_ERRORS",
        payload: ne
      })), ne;
    });
  });
  er(function() {
    l && A.current === !0 && Il(y.current, g.initialValues) && $e(y.current);
  }, [l, $e]);
  var Ee = Le(function(G) {
    var ne = G && G.values ? G.values : y.current, Y = G && G.errors ? G.errors : S.current ? S.current : g.initialErrors || {}, Q = G && G.touched ? G.touched : x.current ? x.current : g.initialTouched || {}, we = G && G.status ? G.status : T.current ? T.current : g.initialStatus;
    y.current = ne, S.current = Y, x.current = Q, T.current = we;
    var be = function() {
      M({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!G && !!G.isSubmitting,
          errors: Y,
          touched: Q,
          status: we,
          values: ne,
          isValidating: !!G && !!G.isValidating,
          submitCount: G && G.submitCount && typeof G.submitCount == "number" ? G.submitCount : 0
        }
      });
    };
    if (g.onReset) {
      var Re = g.onReset(L.values, Qe);
      uS(Re) ? Re.then(be) : be();
    } else
      be();
  }, [g.initialErrors, g.initialStatus, g.initialTouched, g.onReset]);
  er(function() {
    A.current === !0 && !Il(y.current, g.initialValues) && f && (y.current = g.initialValues, Ee(), l && $e(y.current));
  }, [f, g.initialValues, Ee, l, $e]), er(function() {
    f && A.current === !0 && !Il(S.current, g.initialErrors) && (S.current = g.initialErrors || El, M({
      type: "SET_ERRORS",
      payload: g.initialErrors || El
    }));
  }, [f, g.initialErrors]), er(function() {
    f && A.current === !0 && !Il(x.current, g.initialTouched) && (x.current = g.initialTouched || op, M({
      type: "SET_TOUCHED",
      payload: g.initialTouched || op
    }));
  }, [f, g.initialTouched]), er(function() {
    f && A.current === !0 && !Il(T.current, g.initialStatus) && (T.current = g.initialStatus, M({
      type: "SET_STATUS",
      payload: g.initialStatus
    }));
  }, [f, g.initialStatus, g.initialTouched]);
  var ze = Da(function(G) {
    if (O.current[G] && go(O.current[G].validate)) {
      var ne = pa(L.values, G), Y = O.current[G].validate(ne);
      return uS(Y) ? (M({
        type: "SET_ISVALIDATING",
        payload: !0
      }), Y.then(function(Q) {
        return Q;
      }).then(function(Q) {
        M({
          type: "SET_FIELD_ERROR",
          payload: {
            field: G,
            value: Q
          }
        }), M({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      })) : (M({
        type: "SET_FIELD_ERROR",
        payload: {
          field: G,
          value: Y
        }
      }), Promise.resolve(Y));
    } else if (g.validationSchema)
      return M({
        type: "SET_ISVALIDATING",
        payload: !0
      }), q(L.values, G).then(function(Q) {
        return Q;
      }).then(function(Q) {
        M({
          type: "SET_FIELD_ERROR",
          payload: {
            field: G,
            value: pa(Q, G)
          }
        }), M({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      });
    return Promise.resolve();
  }), Ke = Le(function(G, ne) {
    var Y = ne.validate;
    O.current[G] = {
      validate: Y
    };
  }, []), Be = Le(function(G) {
    delete O.current[G];
  }, []), ue = Da(function(G, ne) {
    M({
      type: "SET_TOUCHED",
      payload: G
    });
    var Y = ne === void 0 ? a : ne;
    return Y ? $e(L.values) : Promise.resolve();
  }), he = Le(function(G) {
    M({
      type: "SET_ERRORS",
      payload: G
    });
  }, []), _e = Da(function(G, ne) {
    var Y = go(G) ? G(L.values) : G;
    M({
      type: "SET_VALUES",
      payload: Y
    });
    var Q = ne === void 0 ? t : ne;
    return Q ? $e(Y) : Promise.resolve();
  }), Oe = Le(function(G, ne) {
    M({
      type: "SET_FIELD_ERROR",
      payload: {
        field: G,
        value: ne
      }
    });
  }, []), Me = Da(function(G, ne, Y) {
    M({
      type: "SET_FIELD_VALUE",
      payload: {
        field: G,
        value: ne
      }
    });
    var Q = Y === void 0 ? t : Y;
    return Q ? $e(ru(L.values, G, ne)) : Promise.resolve();
  }), Z = Le(function(G, ne) {
    var Y = ne, Q = G, we;
    if (!lS(G)) {
      G.persist && G.persist();
      var be = G.target ? G.target : G.currentTarget, Re = be.type, cr = be.name, wr = be.id, lr = be.value, dt = be.checked, ot = be.outerHTML, bt = be.options, Ct = be.multiple;
      Y = ne || cr || wr, Q = /number|range/.test(Re) ? (we = parseFloat(lr), isNaN(we) ? "" : we) : /checkbox/.test(Re) ? bke(pa(L.values, Y), dt, lr) : bt && Ct ? mke(bt) : lr;
    }
    Y && Me(Y, Q);
  }, [Me, L.values]), se = Da(function(G) {
    if (lS(G))
      return function(ne) {
        return Z(ne, G);
      };
    Z(G);
  }), te = Da(function(G, ne, Y) {
    ne === void 0 && (ne = !0), M({
      type: "SET_FIELD_TOUCHED",
      payload: {
        field: G,
        value: ne
      }
    });
    var Q = Y === void 0 ? a : Y;
    return Q ? $e(L.values) : Promise.resolve();
  }), fe = Le(function(G, ne) {
    G.persist && G.persist();
    var Y = G.target, Q = Y.name, we = Y.id, be = Y.outerHTML, Re = ne || Q || we;
    te(Re, !0);
  }, [te]), je = Da(function(G) {
    if (lS(G))
      return function(ne) {
        return fe(ne, G);
      };
    fe(G);
  }), ve = Le(function(G) {
    go(G) ? M({
      type: "SET_FORMIK_STATE",
      payload: G
    }) : M({
      type: "SET_FORMIK_STATE",
      payload: function() {
        return G;
      }
    });
  }, []), rr = Le(function(G) {
    M({
      type: "SET_STATUS",
      payload: G
    });
  }, []), br = Le(function(G) {
    M({
      type: "SET_ISSUBMITTING",
      payload: G
    });
  }, []), ur = Da(function() {
    return M({
      type: "SUBMIT_ATTEMPT"
    }), $e().then(function(G) {
      var ne = G instanceof Error, Y = !ne && Object.keys(G).length === 0;
      if (Y) {
        var Q;
        try {
          if (Q = yr(), Q === void 0)
            return;
        } catch (we) {
          throw we;
        }
        return Promise.resolve(Q).then(function(we) {
          return A.current && M({
            type: "SUBMIT_SUCCESS"
          }), we;
        }).catch(function(we) {
          if (A.current)
            throw M({
              type: "SUBMIT_FAILURE"
            }), we;
        });
      } else if (A.current && (M({
        type: "SUBMIT_FAILURE"
      }), ne))
        throw G;
    });
  }), $r = Da(function(G) {
    G && G.preventDefault && go(G.preventDefault) && G.preventDefault(), G && G.stopPropagation && go(G.stopPropagation) && G.stopPropagation(), ur().catch(function(ne) {
      console.warn("Warning: An unhandled error was caught from submitForm()", ne);
    });
  }), Qe = {
    resetForm: Ee,
    validateForm: $e,
    validateField: ze,
    setErrors: he,
    setFieldError: Oe,
    setFieldTouched: te,
    setFieldValue: Me,
    setStatus: rr,
    setSubmitting: br,
    setTouched: ue,
    setValues: _e,
    setFormikState: ve,
    submitForm: ur
  }, yr = Da(function() {
    return h(L.values, Qe);
  }), at = Da(function(G) {
    G && G.preventDefault && go(G.preventDefault) && G.preventDefault(), G && G.stopPropagation && go(G.stopPropagation) && G.stopPropagation(), Ee();
  }), Zr = Le(function(G) {
    return {
      value: pa(L.values, G),
      error: pa(L.errors, G),
      touched: !!pa(L.touched, G),
      initialValue: pa(y.current, G),
      initialTouched: !!pa(x.current, G),
      initialError: pa(S.current, G)
    };
  }, [L.errors, L.touched, L.values]), Nr = Le(function(G) {
    return {
      setValue: function(Y, Q) {
        return Me(G, Y, Q);
      },
      setTouched: function(Y, Q) {
        return te(G, Y, Q);
      },
      setError: function(Y) {
        return Oe(G, Y);
      }
    };
  }, [Me, te, Oe]), jt = Le(function(G) {
    var ne = xm(G), Y = ne ? G.name : G, Q = pa(L.values, Y), we = {
      name: Y,
      value: Q,
      onChange: se,
      onBlur: je
    };
    if (ne) {
      var be = G.type, Re = G.value, cr = G.as, wr = G.multiple;
      be === "checkbox" ? Re === void 0 ? we.checked = !!Q : (we.checked = !!(Array.isArray(Q) && ~Q.indexOf(Re)), we.value = Re) : be === "radio" ? (we.checked = Q === Re, we.value = Re) : cr === "select" && wr && (we.value = we.value || [], we.multiple = !0);
    }
    return we;
  }, [je, se, L.values]), mt = Rt(function() {
    return !Il(y.current, L.values);
  }, [y.current, L.values]), gr = Rt(function() {
    return typeof u != "undefined" ? mt ? L.errors && Object.keys(L.errors).length === 0 : u !== !1 && go(u) ? u(g) : u : L.errors && Object.keys(L.errors).length === 0;
  }, [u, mt, L.errors, g]), Sr = Kt({}, L, {
    initialValues: y.current,
    initialErrors: S.current,
    initialTouched: x.current,
    initialStatus: T.current,
    handleBlur: je,
    handleChange: se,
    handleReset: at,
    handleSubmit: $r,
    resetForm: Ee,
    setErrors: he,
    setFormikState: ve,
    setFieldTouched: te,
    setFieldValue: Me,
    setFieldError: Oe,
    setStatus: rr,
    setSubmitting: br,
    setTouched: ue,
    setValues: _e,
    submitForm: ur,
    validateForm: $e,
    validateField: ze,
    isValid: gr,
    dirty: mt,
    unregisterField: Be,
    registerField: Ke,
    getFieldProps: jt,
    getFieldMeta: Zr,
    getFieldHelpers: Nr,
    validateOnBlur: a,
    validateOnChange: t,
    validateOnMount: l
  });
  return Sr;
}
function hke(e) {
  var r = {};
  if (e.inner) {
    if (e.inner.length === 0)
      return ru(r, e.path, e.message);
    for (var a = e.inner, t = Array.isArray(a), n = 0, a = t ? a : a[Symbol.iterator](); ; ) {
      var i;
      if (t) {
        if (n >= a.length)
          break;
        i = a[n++];
      } else {
        if (n = a.next(), n.done)
          break;
        i = n.value;
      }
      var l = i;
      pa(r, l.path) || (r = ru(r, l.path, l.message));
    }
  }
  return r;
}
function pke(e, r, t, n) {
  t === void 0 && (t = !1);
  var a = x2(e);
  return r[t ? "validateSync" : "validate"](a, {
    abortEarly: !1,
    context: n || a
  });
}
function x2(e) {
  var r = Array.isArray(e) ? [] : {};
  for (var t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      var n = String(t);
      Array.isArray(e[n]) === !0 ? r[n] = e[n].map(function(a) {
        return Array.isArray(a) === !0 || jI(a) ? x2(a) : a !== "" ? a : void 0;
      }) : jI(e[n]) ? r[n] = x2(e[n]) : r[n] = e[n] !== "" ? e[n] : void 0;
    }
  return r;
}
function gke(e, r, t) {
  var n = e.slice();
  return r.forEach(function(i, l) {
    if (typeof n[l] == "undefined") {
      var u = t.clone !== !1, c = u && t.isMergeableObject(i);
      n[l] = c ? p2(Array.isArray(i) ? [] : {}, i, t) : i;
    } else
      t.isMergeableObject(i) ? n[l] = p2(e[l], i, t) : e.indexOf(i) === -1 && n.push(i);
  }), n;
}
function mke(e) {
  return Array.from(e).filter(function(r) {
    return r.selected;
  }).map(function(r) {
    return r.value;
  });
}
function bke(e, r, t) {
  if (typeof e == "boolean")
    return !!r;
  var n = [], a = !1, i = -1;
  if (Array.isArray(e))
    n = e, i = e.indexOf(t), a = i >= 0;
  else if (!t || t == "true" || t == "false")
    return !!r;
  return r && t && !a ? n.concat(t) : a ? n.slice(0, i).concat(n.slice(i + 1)) : n;
}
var yke = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? TO : er;
function Da(e) {
  var r = Ze(e);
  return yke(function() {
    r.current = e;
  }), Le(function() {
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    return r.current.apply(void 0, n);
  }, []);
}
var Ske = /* @__PURE__ */ H0(function(e, r) {
  var t = e.action, n = KD(e, ["action"]), a = t != null ? t : "#", i = dke(), l = i.handleReset, u = i.handleSubmit;
  return Di("form", Kt({
    onSubmit: u,
    ref: r,
    onReset: l,
    action: a
  }, n));
});
Ske.displayName = "Form";
const QD = Pn(void 0), xke = ({ firstName: e, children: r }) => {
  const t = {
    rating: 0,
    title: "",
    reviewtext: "",
    usernickname: e ? e.replace(/%[0-9]+/g, " ") : "",
    isrecommended: "",
    photos: []
  }, [n, a] = He(t), [i, l] = He(!1), [u, c] = He(!1), f = () => {
    a(t), c(!0);
  };
  return er(() => {
    a((h) => Fo(Yt({}, h), { usernickname: e }));
  }, [e]), er(() => {
    u && c(!1);
  }, [u]), /* @__PURE__ */ _.jsx(
    QD.Provider,
    {
      value: {
        data: n,
        setData: a,
        requestInProgress: i,
        setRequestInProgress: l,
        resetData: f
      },
      children: u ? "" : r
    }
  );
}, $m = () => {
  const e = Ur(QD);
  if (!e)
    throw new Error("useDataContext must be used within a ContextProvider");
  return e;
}, $ke = "_enabled_1cdzs_14", ip = {
  "main-button-wrapper": "_main-button-wrapper_1cdzs_2",
  "main-button": "_main-button_1cdzs_2",
  enabled: $ke,
  "so-com": "_so-com_1cdzs_18"
}, XD = ({
  handleButtonClick: e,
  label: r = "Continuar",
  disabled: t = !1
}) => {
  const { requestInProgress: n } = $m(), { theme: a, isSodimacStandAlone: i = !1 } = Eo();
  return /* @__PURE__ */ _.jsx(ln, { className: ip["main-button-wrapper"], children: /* @__PURE__ */ _.jsx(
    xg,
    {
      size: "lg",
      className: `${ip["main-button"]} ${t ? "" : ip.enabled} ${i ? ip["so-com"] : ""}`,
      disabled: n,
      onClick: e,
      style: { backgroundColor: t ? "" : a.secondary_color },
      children: r
    }
  ) });
};
function lO(e) {
  return e.reduce((r, t) => (r[t.Id] = 0, r), {});
}
const uO = (e, r) => e ? Object.values(e).filter(
  (t) => t.DisplayType === r
) : [], wke = (e) => {
  const { isOpen: r, onClose: t, onSubmit: n, onBackClick: a, isApp: i } = e, { product: l } = gm(), { data: u, setData: c, requestInProgress: f } = $m(), { secondaryRatingsAverages: h = {} } = ea(), p = uO(
    h,
    "NORMAL"
  ), g = uO(
    h,
    "SLIDER"
  ), y = lO(p), S = lO(g), x = Yt(Yt({}, S), y), T = ZD({
    initialValues: x,
    onSubmit: (L) => Gr(void 0, null, function* () {
      const M = Yt(Yt({}, u), L);
      c(M), n(M);
    })
  }), { activeModal: A } = P_(), O = () => {
    T.handleSubmit();
  };
  function P(L) {
    return Array.isArray(L) && L.length > 0;
  }
  const j = P(p), k = P(g);
  return /* @__PURE__ */ _.jsxs(S_, { isOpen: r, onClose: t, isApp: i, children: [
    /* @__PURE__ */ _.jsx("div", { slot: "header", children: /* @__PURE__ */ _.jsx(
      b_,
      {
        showBackButton: A === Of.AttributesByCategory,
        onBackClick: a,
        onClose: t
      }
    ) }),
    /* @__PURE__ */ _.jsxs(
      "div",
      {
        className: `${xn["attributes-by-category-form"]} ${xn.content}`,
        children: [
          /* @__PURE__ */ _.jsxs("div", { className: xn["image-and-product-name"], children: [
            /* @__PURE__ */ _.jsx(mD, { product: l, boxSize: "40px", borderRadius: "2px" }),
            /* @__PURE__ */ _.jsx(
              bc,
              {
                className: xn["product-name"],
                children: `${l.brandName} - ${l.name}`
              }
            )
          ] }),
          /* @__PURE__ */ _.jsx("div", { className: xn["first-separator"], children: /* @__PURE__ */ _.jsx(PI, {}) }),
          /* @__PURE__ */ _.jsxs("div", { className: xn.section, children: [
            /* @__PURE__ */ _.jsx(bc, { className: xn.title, children: "¿Cómo evaluarías los siguientes puntos?" }),
            /* @__PURE__ */ _.jsx("div", { className: xn.attributes, children: p && p.length > 0 && p.map((L, M) => /* @__PURE__ */ _.jsxs("div", { className: xn.attribute, children: [
              /* @__PURE__ */ _.jsx("div", { className: xn.name, children: L.Label }),
              /* @__PURE__ */ _.jsx(
                x_,
                {
                  handleRatingClickHook: T.setFieldValue,
                  rating: T.values[L.Id] || 0,
                  fieldName: L.Id
                }
              )
            ] }, M)) })
          ] }),
          j && k && /* @__PURE__ */ _.jsx("div", { style: { margin: "24px 0" }, children: /* @__PURE__ */ _.jsx(PI, {}) }),
          /* @__PURE__ */ _.jsx(_.Fragment, { children: g && g.length > 0 && g.map(
            (L, M) => L.ValueLabel && /* @__PURE__ */ _.jsxs(
              "div",
              {
                className: `${xn.section} ${xn["dots-rating"]}`,
                children: [
                  /* @__PURE__ */ _.jsx("div", { className: xn.title, children: L.Label }),
                  /* @__PURE__ */ _.jsx(
                    pIe,
                    {
                      options: L.ValueLabel,
                      selected: T.values[L.Id],
                      setSelected: T.setFieldValue,
                      fieldName: L.Id
                    }
                  )
                ]
              },
              M
            )
          ) })
        ]
      }
    ),
    /* @__PURE__ */ _.jsx("div", { slot: "footer", children: /* @__PURE__ */ _.jsxs(
      ln,
      {
        className: `${xn["footer-by-category-form"]} ${xn["main-button-wrapper"]}`,
        children: [
          /* @__PURE__ */ _.jsx(
            xg,
            {
              onClick: a,
              className: xn["back-button"],
              variant: "link",
              children: "Volver"
            }
          ),
          /* @__PURE__ */ _.jsx(
            XD,
            {
              handleButtonClick: O,
              label: "Finalizar",
              disabled: f
            }
          )
        ]
      }
    ) })
  ] });
}, _ke = "_title_5dey0_13", Tke = "_label_5dey0_67", Cke = "_input_5dey0_81", Eke = "_textarea_5dey0_89", Ake = "_warning_5dey0_113", Ike = "_success_5dey0_116", vt = {
  "review-form": "_review-form_5dey0_2",
  "form-header": "_form-header_5dey0_10",
  title: _ke,
  "main-header": "_main-header_5dey0_19",
  "title-and-rating": "_title-and-rating_5dey0_34",
  "product-name": "_product-name_5dey0_43",
  "rating-form-control": "_rating-form-control_5dey0_48",
  "form-body": "_form-body_5dey0_58",
  label: Tke,
  input: Cke,
  textarea: Eke,
  warning: Ake,
  success: Ike,
  "form-error-message": "_form-error-message_5dey0_119",
  "field-error": "_field-error_5dey0_123",
  "helper-text": "_helper-text_5dey0_126",
  "write-review-custom-footer": "_write-review-custom-footer_5dey0_138",
  "footer-button-wrapper": "_footer-button-wrapper_5dey0_146"
}, Oke = "_checked_h17jf_28", cS = {
  "bv-custom-radio-button": "_bv-custom-radio-button_h17jf_2",
  "bv-recommendation-button": "_bv-recommendation-button_h17jf_14",
  checked: Oke
};
function Mke({
  text: e,
  icon: r,
  isChecked: t,
  onChange: n
}) {
  return /* @__PURE__ */ _.jsxs(ln, { className: cS["bv-custom-radio-button"], as: "label", children: [
    /* @__PURE__ */ _.jsx(
      "input",
      {
        type: "radio",
        checked: t,
        onChange: n,
        role: "recommendation-radio-button"
      }
    ),
    /* @__PURE__ */ _.jsxs(
      ln,
      {
        className: `${cS["bv-recommendation-button"]} ${t ? cS.checked : ""}`,
        children: [
          e,
          " ",
          t && /* @__PURE__ */ _.jsx("span", { children: r })
        ]
      }
    )
  ] });
}
const Rke = "_wrapper_1o079_1", Pke = {
  wrapper: Rke
};
function kke({
  value: e,
  setValue: r,
  options: t
}) {
  const n = (a) => {
    r("isrecommended", a);
  };
  return /* @__PURE__ */ _.jsx("div", { className: Pke.wrapper, children: t.map((a) => /* @__PURE__ */ _.jsx(
    Mke,
    {
      text: a.text,
      icon: a.icon,
      isChecked: e === a.value,
      onChange: () => n(a.value)
    },
    a.text
  )) });
}
var jke = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function av(e, r) {
  var t = Dke(e);
  if (typeof t.path != "string") {
    var n = e.webkitRelativePath;
    Object.defineProperty(t, "path", {
      value: typeof r == "string" ? r : typeof n == "string" && n.length > 0 ? n : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return t;
}
function Dke(e) {
  var r = e.name, t = r && r.lastIndexOf(".") !== -1;
  if (t && !e.type) {
    var n = r.split(".").pop().toLowerCase(), a = jke.get(n);
    a && Object.defineProperty(e, "type", {
      value: a,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var Nke = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function Lke(e) {
  return Ac(this, void 0, void 0, function() {
    return Ic(this, function(r) {
      return z0(e) && Fke(e.dataTransfer) ? [2, Vke(e.dataTransfer, e.type)] : zke(e) ? [2, Bke(e)] : Array.isArray(e) && e.every(function(t) {
        return "getFile" in t && typeof t.getFile == "function";
      }) ? [2, Uke(e)] : [2, []];
    });
  });
}
function Fke(e) {
  return z0(e);
}
function zke(e) {
  return z0(e) && z0(e.target);
}
function z0(e) {
  return typeof e == "object" && e !== null;
}
function Bke(e) {
  return $2(e.target.files).map(function(r) {
    return av(r);
  });
}
function Uke(e) {
  return Ac(this, void 0, void 0, function() {
    var r;
    return Ic(this, function(t) {
      switch (t.label) {
        case 0:
          return [4, Promise.all(e.map(function(n) {
            return n.getFile();
          }))];
        case 1:
          return r = t.sent(), [2, r.map(function(n) {
            return av(n);
          })];
      }
    });
  });
}
function Vke(e, r) {
  return Ac(this, void 0, void 0, function() {
    var t, n;
    return Ic(this, function(a) {
      switch (a.label) {
        case 0:
          return e.items ? (t = $2(e.items).filter(function(i) {
            return i.kind === "file";
          }), r !== "drop" ? [2, t] : [4, Promise.all(t.map(Wke))]) : [3, 2];
        case 1:
          return n = a.sent(), [2, cO(JD(n))];
        case 2:
          return [2, cO($2(e.files).map(function(i) {
            return av(i);
          }))];
      }
    });
  });
}
function cO(e) {
  return e.filter(function(r) {
    return Nke.indexOf(r.name) === -1;
  });
}
function $2(e) {
  if (e === null)
    return [];
  for (var r = [], t = 0; t < e.length; t++) {
    var n = e[t];
    r.push(n);
  }
  return r;
}
function Wke(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return dO(e);
  var r = e.webkitGetAsEntry();
  return r && r.isDirectory ? eN(r) : dO(e);
}
function JD(e) {
  return e.reduce(function(r, t) {
    return ba(ba([], gt(r), !1), gt(Array.isArray(t) ? JD(t) : [t]), !1);
  }, []);
}
function dO(e) {
  var r = e.getAsFile();
  if (!r)
    return Promise.reject("".concat(e, " is not a File"));
  var t = av(r);
  return Promise.resolve(t);
}
function Hke(e) {
  return Ac(this, void 0, void 0, function() {
    return Ic(this, function(r) {
      return [2, e.isDirectory ? eN(e) : Gke(e)];
    });
  });
}
function eN(e) {
  var r = e.createReader();
  return new Promise(function(t, n) {
    var a = [];
    function i() {
      var l = this;
      r.readEntries(function(u) {
        return Ac(l, void 0, void 0, function() {
          var c, f, h;
          return Ic(this, function(p) {
            switch (p.label) {
              case 0:
                if (u.length)
                  return [3, 5];
                p.label = 1;
              case 1:
                return p.trys.push([1, 3, , 4]), [4, Promise.all(a)];
              case 2:
                return c = p.sent(), t(c), [3, 4];
              case 3:
                return f = p.sent(), n(f), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                h = Promise.all(u.map(Hke)), a.push(h), i(), p.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(u) {
        n(u);
      });
    }
    i();
  });
}
function Gke(e) {
  return Ac(this, void 0, void 0, function() {
    return Ic(this, function(r) {
      return [2, new Promise(function(t, n) {
        e.file(function(a) {
          var i = av(a, e.fullPath);
          t(i);
        }, function(a) {
          n(a);
        });
      })];
    });
  });
}
var Yke = function(e, r) {
  if (e && r) {
    var t = Array.isArray(r) ? r : r.split(","), n = e.name || "", a = (e.type || "").toLowerCase(), i = a.replace(/\/.*$/, "");
    return t.some(function(l) {
      var u = l.trim().toLowerCase();
      return u.charAt(0) === "." ? n.toLowerCase().endsWith(u) : u.endsWith("/*") ? i === u.replace(/\/.*$/, "") : a === u;
    });
  }
  return !0;
};
function fO(e) {
  return Zke(e) || qke(e) || tN(e) || Kke();
}
function Kke() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qke(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Zke(e) {
  if (Array.isArray(e))
    return w2(e);
}
function vO(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function hO(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? vO(Object(t), !0).forEach(function(n) {
      rN(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : vO(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function rN(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function If(e, r) {
  return Jke(e) || Xke(e, r) || tN(e, r) || Qke();
}
function Qke() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tN(e, r) {
  if (e) {
    if (typeof e == "string")
      return w2(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return w2(e, r);
  }
}
function w2(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function Xke(e, r) {
  var t = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], a = !0, i = !1, l, u;
    try {
      for (t = t.call(e); !(a = (l = t.next()).done) && (n.push(l.value), !(r && n.length === r)); a = !0)
        ;
    } catch (c) {
      i = !0, u = c;
    } finally {
      try {
        !a && t.return != null && t.return();
      } finally {
        if (i)
          throw u;
      }
    }
    return n;
  }
}
function Jke(e) {
  if (Array.isArray(e))
    return e;
}
var eje = "file-invalid-type", rje = "file-too-large", tje = "file-too-small", nje = "too-many-files", aje = function(r) {
  r = Array.isArray(r) && r.length === 1 ? r[0] : r;
  var t = Array.isArray(r) ? "one of ".concat(r.join(", ")) : r;
  return {
    code: eje,
    message: "File type must be ".concat(t)
  };
}, pO = function(r) {
  return {
    code: rje,
    message: "File is larger than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, gO = function(r) {
  return {
    code: tje,
    message: "File is smaller than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, oje = {
  code: nje,
  message: "Too many files"
};
function nN(e, r) {
  var t = e.type === "application/x-moz-file" || Yke(e, r);
  return [t, t ? null : aje(r)];
}
function aN(e, r, t) {
  if (Nl(e.size))
    if (Nl(r) && Nl(t)) {
      if (e.size > t)
        return [!1, pO(t)];
      if (e.size < r)
        return [!1, gO(r)];
    } else {
      if (Nl(r) && e.size < r)
        return [!1, gO(r)];
      if (Nl(t) && e.size > t)
        return [!1, pO(t)];
    }
  return [!0, null];
}
function Nl(e) {
  return e != null;
}
function ije(e) {
  var r = e.files, t = e.accept, n = e.minSize, a = e.maxSize, i = e.multiple, l = e.maxFiles, u = e.validator;
  return !i && r.length > 1 || i && l >= 1 && r.length > l ? !1 : r.every(function(c) {
    var f = nN(c, t), h = If(f, 1), p = h[0], g = aN(c, n, a), y = If(g, 1), S = y[0], x = u ? u(c) : null;
    return p && S && !x;
  });
}
function B0(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble != "undefined" ? e.cancelBubble : !1;
}
function sp(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(r) {
    return r === "Files" || r === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function mO(e) {
  e.preventDefault();
}
function sje(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function lje(e) {
  return e.indexOf("Edge/") !== -1;
}
function uje() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return sje(e) || lje(e);
}
function Ho() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(n) {
    for (var a = arguments.length, i = new Array(a > 1 ? a - 1 : 0), l = 1; l < a; l++)
      i[l - 1] = arguments[l];
    return r.some(function(u) {
      return !B0(n) && u && u.apply(void 0, [n].concat(i)), B0(n);
    });
  };
}
function cje() {
  return "showOpenFilePicker" in window;
}
function dje(e) {
  if (Nl(e)) {
    var r = Object.entries(e).filter(function(t) {
      var n = If(t, 2), a = n[0], i = n[1], l = !0;
      return oN(a) || (console.warn('Skipped "'.concat(a, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), l = !1), (!Array.isArray(i) || !i.every(iN)) && (console.warn('Skipped "'.concat(a, '" because an invalid file extension was provided.')), l = !1), l;
    }).reduce(function(t, n) {
      var a = If(n, 2), i = a[0], l = a[1];
      return hO(hO({}, t), {}, rN({}, i, l));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: r
    }];
  }
  return e;
}
function fje(e) {
  if (Nl(e))
    return Object.entries(e).reduce(function(r, t) {
      var n = If(t, 2), a = n[0], i = n[1];
      return [].concat(fO(r), [a], fO(i));
    }, []).filter(function(r) {
      return oN(r) || iN(r);
    }).join(",");
}
function vje(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function hje(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function oN(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function iN(e) {
  return /^.*\.[\w]+$/.test(e);
}
var pje = ["children"], gje = ["open"], mje = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], bje = ["refKey", "onChange", "onClick"];
function yje(e) {
  return $je(e) || xje(e) || sN(e) || Sje();
}
function Sje() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xje(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function $je(e) {
  if (Array.isArray(e))
    return _2(e);
}
function dS(e, r) {
  return Tje(e) || _je(e, r) || sN(e, r) || wje();
}
function wje() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sN(e, r) {
  if (e) {
    if (typeof e == "string")
      return _2(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return _2(e, r);
  }
}
function _2(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function _je(e, r) {
  var t = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], a = !0, i = !1, l, u;
    try {
      for (t = t.call(e); !(a = (l = t.next()).done) && (n.push(l.value), !(r && n.length === r)); a = !0)
        ;
    } catch (c) {
      i = !0, u = c;
    } finally {
      try {
        !a && t.return != null && t.return();
      } finally {
        if (i)
          throw u;
      }
    }
    return n;
  }
}
function Tje(e) {
  if (Array.isArray(e))
    return e;
}
function bO(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function $t(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? bO(Object(t), !0).forEach(function(n) {
      T2(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : bO(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function T2(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function U0(e, r) {
  if (e == null)
    return {};
  var t = Cje(e, r), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(r.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (t[n] = e[n]);
  }
  return t;
}
function Cje(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var R_ = /* @__PURE__ */ H0(function(e, r) {
  var t = e.children, n = U0(e, pje), a = uN(n), i = a.open, l = U0(a, gje);
  return iU(r, function() {
    return {
      open: i
    };
  }, [i]), /* @__PURE__ */ $o.createElement(R2, null, t($t($t({}, l), {}, {
    open: i
  })));
});
R_.displayName = "Dropzone";
var lN = {
  disabled: !1,
  getFilesFromEvent: Lke,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
R_.defaultProps = lN;
R_.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: et.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: et.objectOf(et.arrayOf(et.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: et.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: et.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: et.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: et.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: et.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: et.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: et.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: et.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: et.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: et.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: et.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: et.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: et.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: et.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: et.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: et.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: et.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: et.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: et.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: et.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: et.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: et.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: et.func
};
var C2 = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function uN() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = $t($t({}, lN), e), t = r.accept, n = r.disabled, a = r.getFilesFromEvent, i = r.maxSize, l = r.minSize, u = r.multiple, c = r.maxFiles, f = r.onDragEnter, h = r.onDragLeave, p = r.onDragOver, g = r.onDrop, y = r.onDropAccepted, S = r.onDropRejected, x = r.onFileDialogCancel, T = r.onFileDialogOpen, A = r.useFsAccessApi, O = r.autoFocus, P = r.preventDropOnDocument, j = r.noClick, k = r.noKeyboard, L = r.noDrag, M = r.noDragEventsBubbling, W = r.onError, q = r.validator, oe = Rt(function() {
    return fje(t);
  }, [t]), Ae = Rt(function() {
    return dje(t);
  }, [t]), Te = Rt(function() {
    return typeof T == "function" ? T : yO;
  }, [T]), $e = Rt(function() {
    return typeof x == "function" ? x : yO;
  }, [x]), Ee = Ze(null), ze = Ze(null), Ke = oU(Eje, C2), Be = dS(Ke, 2), ue = Be[0], he = Be[1], _e = ue.isFocused, Oe = ue.isFileDialogActive, Me = Ze(typeof window != "undefined" && window.isSecureContext && A && cje()), Z = function() {
    !Me.current && Oe && setTimeout(function() {
      if (ze.current) {
        var Q = ze.current.files;
        Q.length || (he({
          type: "closeDialog"
        }), $e());
      }
    }, 300);
  };
  er(function() {
    return window.addEventListener("focus", Z, !1), function() {
      window.removeEventListener("focus", Z, !1);
    };
  }, [ze, Oe, $e, Me]);
  var se = Ze([]), te = function(Q) {
    Ee.current && Ee.current.contains(Q.target) || (Q.preventDefault(), se.current = []);
  };
  er(function() {
    return P && (document.addEventListener("dragover", mO, !1), document.addEventListener("drop", te, !1)), function() {
      P && (document.removeEventListener("dragover", mO), document.removeEventListener("drop", te));
    };
  }, [Ee, P]), er(function() {
    return !n && O && Ee.current && Ee.current.focus(), function() {
    };
  }, [Ee, O, n]);
  var fe = Le(function(Y) {
    W ? W(Y) : console.error(Y);
  }, [W]), je = Le(function(Y) {
    Y.preventDefault(), Y.persist(), gr(Y), se.current = [].concat(yje(se.current), [Y.target]), sp(Y) && Promise.resolve(a(Y)).then(function(Q) {
      if (!(B0(Y) && !M)) {
        var we = Q.length, be = we > 0 && ije({
          files: Q,
          accept: oe,
          minSize: l,
          maxSize: i,
          multiple: u,
          maxFiles: c,
          validator: q
        }), Re = we > 0 && !be;
        he({
          isDragAccept: be,
          isDragReject: Re,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), f && f(Y);
      }
    }).catch(function(Q) {
      return fe(Q);
    });
  }, [a, f, fe, M, oe, l, i, u, c, q]), ve = Le(function(Y) {
    Y.preventDefault(), Y.persist(), gr(Y);
    var Q = sp(Y);
    if (Q && Y.dataTransfer)
      try {
        Y.dataTransfer.dropEffect = "copy";
      } catch (we) {
      }
    return Q && p && p(Y), !1;
  }, [p, M]), rr = Le(function(Y) {
    Y.preventDefault(), Y.persist(), gr(Y);
    var Q = se.current.filter(function(be) {
      return Ee.current && Ee.current.contains(be);
    }), we = Q.indexOf(Y.target);
    we !== -1 && Q.splice(we, 1), se.current = Q, !(Q.length > 0) && (he({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), sp(Y) && h && h(Y));
  }, [Ee, h, M]), br = Le(function(Y, Q) {
    var we = [], be = [];
    Y.forEach(function(Re) {
      var cr = nN(Re, oe), wr = dS(cr, 2), lr = wr[0], dt = wr[1], ot = aN(Re, l, i), bt = dS(ot, 2), Ct = bt[0], fr = bt[1], Qr = q ? q(Re) : null;
      if (lr && Ct && !Qr)
        we.push(Re);
      else {
        var vn = [dt, fr];
        Qr && (vn = vn.concat(Qr)), be.push({
          file: Re,
          errors: vn.filter(function(hn) {
            return hn;
          })
        });
      }
    }), (!u && we.length > 1 || u && c >= 1 && we.length > c) && (we.forEach(function(Re) {
      be.push({
        file: Re,
        errors: [oje]
      });
    }), we.splice(0)), he({
      acceptedFiles: we,
      fileRejections: be,
      type: "setFiles"
    }), g && g(we, be, Q), be.length > 0 && S && S(be, Q), we.length > 0 && y && y(we, Q);
  }, [he, u, oe, l, i, c, g, y, S, q]), ur = Le(function(Y) {
    Y.preventDefault(), Y.persist(), gr(Y), se.current = [], sp(Y) && Promise.resolve(a(Y)).then(function(Q) {
      B0(Y) && !M || br(Q, Y);
    }).catch(function(Q) {
      return fe(Q);
    }), he({
      type: "reset"
    });
  }, [a, br, fe, M]), $r = Le(function() {
    if (Me.current) {
      he({
        type: "openDialog"
      }), Te();
      var Y = {
        multiple: u,
        types: Ae
      };
      window.showOpenFilePicker(Y).then(function(Q) {
        return a(Q);
      }).then(function(Q) {
        br(Q, null), he({
          type: "closeDialog"
        });
      }).catch(function(Q) {
        vje(Q) ? ($e(Q), he({
          type: "closeDialog"
        })) : hje(Q) ? (Me.current = !1, ze.current ? (ze.current.value = null, ze.current.click()) : fe(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : fe(Q);
      });
      return;
    }
    ze.current && (he({
      type: "openDialog"
    }), Te(), ze.current.value = null, ze.current.click());
  }, [he, Te, $e, A, br, fe, Ae, u]), Qe = Le(function(Y) {
    !Ee.current || !Ee.current.isEqualNode(Y.target) || (Y.key === " " || Y.key === "Enter" || Y.keyCode === 32 || Y.keyCode === 13) && (Y.preventDefault(), $r());
  }, [Ee, $r]), yr = Le(function() {
    he({
      type: "focus"
    });
  }, []), at = Le(function() {
    he({
      type: "blur"
    });
  }, []), Zr = Le(function() {
    j || (uje() ? setTimeout($r, 0) : $r());
  }, [j, $r]), Nr = function(Q) {
    return n ? null : Q;
  }, jt = function(Q) {
    return k ? null : Nr(Q);
  }, mt = function(Q) {
    return L ? null : Nr(Q);
  }, gr = function(Q) {
    M && Q.stopPropagation();
  }, Sr = Rt(function() {
    return function() {
      var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Q = Y.refKey, we = Q === void 0 ? "ref" : Q, be = Y.role, Re = Y.onKeyDown, cr = Y.onFocus, wr = Y.onBlur, lr = Y.onClick, dt = Y.onDragEnter, ot = Y.onDragOver, bt = Y.onDragLeave, Ct = Y.onDrop, fr = U0(Y, mje);
      return $t($t(T2({
        onKeyDown: jt(Ho(Re, Qe)),
        onFocus: jt(Ho(cr, yr)),
        onBlur: jt(Ho(wr, at)),
        onClick: Nr(Ho(lr, Zr)),
        onDragEnter: mt(Ho(dt, je)),
        onDragOver: mt(Ho(ot, ve)),
        onDragLeave: mt(Ho(bt, rr)),
        onDrop: mt(Ho(Ct, ur)),
        role: typeof be == "string" && be !== "" ? be : "presentation"
      }, we, Ee), !n && !k ? {
        tabIndex: 0
      } : {}), fr);
    };
  }, [Ee, Qe, yr, at, Zr, je, ve, rr, ur, k, L, n]), G = Le(function(Y) {
    Y.stopPropagation();
  }, []), ne = Rt(function() {
    return function() {
      var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Q = Y.refKey, we = Q === void 0 ? "ref" : Q, be = Y.onChange, Re = Y.onClick, cr = U0(Y, bje), wr = T2({
        accept: oe,
        multiple: u,
        type: "file",
        style: {
          display: "none"
        },
        onChange: Nr(Ho(be, ur)),
        onClick: Nr(Ho(Re, G)),
        tabIndex: -1
      }, we, ze);
      return $t($t({}, wr), cr);
    };
  }, [ze, t, u, ur, n]);
  return $t($t({}, ue), {}, {
    isFocused: _e && !n,
    getRootProps: Sr,
    getInputProps: ne,
    rootRef: Ee,
    inputRef: ze,
    open: Nr($r)
  });
}
function Eje(e, r) {
  switch (r.type) {
    case "focus":
      return $t($t({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return $t($t({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return $t($t({}, C2), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return $t($t({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return $t($t({}, e), {}, {
        isDragActive: r.isDragActive,
        isDragAccept: r.isDragAccept,
        isDragReject: r.isDragReject
      });
    case "setFiles":
      return $t($t({}, e), {}, {
        acceptedFiles: r.acceptedFiles,
        fileRejections: r.fileRejections
      });
    case "reset":
      return $t({}, C2);
    default:
      return e;
  }
}
function yO() {
}
const Aje = "_thumb_1ha40_2", Ije = "_img_1ha40_34", bd = {
  "thumbs-container": "_thumbs-container_1ha40_2",
  thumb: Aje,
  "thumb-inner": "_thumb-inner_1ha40_26",
  img: Ije,
  "delete-button": "_delete-button_1ha40_41"
}, Oje = ({ files: e, handleDelete: r }) => {
  const t = e.map((n) => /* @__PURE__ */ _.jsxs("div", { className: bd.thumb, children: [
    /* @__PURE__ */ _.jsx("div", { className: bd["thumb-inner"], children: /* @__PURE__ */ _.jsx("img", { src: n.preview, className: bd.img, alt: "Preview" }) }),
    /* @__PURE__ */ _.jsx(
      "button",
      {
        onClick: () => r(n.name),
        className: bd["delete-button"],
        children: /* @__PURE__ */ _.jsx("span", {})
      }
    )
  ] }, n.name));
  return /* @__PURE__ */ _.jsx("aside", { className: bd["thumbs-container"], children: t });
}, Mje = "_dropzone_1dofu_13", Al = {
  "bv-multiple-image-uploader": "_bv-multiple-image-uploader_1dofu_1",
  "has-files": "_has-files_1dofu_9",
  "dropzone-container": "_dropzone-container_1dofu_13",
  dropzone: Mje,
  "text-info": "_text-info_1dofu_22",
  "dropzone-button": "_dropzone-button_1dofu_29",
  "so-com": "_so-com_1dofu_39"
}, E2 = {
  default: "Puedes subir hasta 6 archivos de hasta 5 MB.",
  "too-many-files": "Intentaste subir mas de 6 archivos permitidos.",
  "file-too-large": "El archivo es demasiado grande. Maximo de 5 MB.",
  "file-invalid-type": "Solo se admiten imagenes (.jpg, .jpeg, .png)"
}, Rje = (e) => {
  const r = e[0].errors[0].code;
  return E2[r] || E2.default;
}, Pje = ({
  files: e,
  error: r
}) => r || (e.length === 6 ? "Alcanzaste el máximo de 6 archivos." : "Puedes subir hasta 6 archivos de hasta 5 MB."), kje = ({
  handlePhotoUploadHook: e,
  photos: r
}) => {
  const { theme: t, isSodimacStandAlone: n = !1 } = Eo(), [a, i] = He([]), [l, u] = He(""), c = (p) => {
    i((g) => g.filter((y) => y.name !== p));
  }, { getRootProps: f, getInputProps: h } = uN({
    accept: {
      "image/jpg": [],
      "image/jpeg": [],
      "image/png": []
    },
    maxFiles: 6,
    maxSize: 5 * 1024 * 1024,
    // 5MB
    onDrop: (p, g) => {
      if (g.length > 0) {
        const x = Rje(g);
        u(x);
        return;
      }
      const y = p.map(
        (x) => Object.assign(x, { preview: URL.createObjectURL(x) })
      ), S = [...r, ...y];
      if (S.length > 6) {
        const x = E2["too-many-files"];
        u(x);
        return;
      }
      u(""), i(S);
    },
    disabled: r.length >= 6
  });
  return er(() => {
    e("photos", a);
  }, [a, e]), er(() => {
    r.length && i(r);
  }, [r]), /* @__PURE__ */ _.jsxs(
    ln,
    {
      className: `${Al["bv-multiple-image-uploader"]} ${a.length > 0 ? Al["has-files"] : ""}`,
      borderColor: t.secondary_color,
      children: [
        a.length === 0 ? /* @__PURE__ */ _.jsx(xIe, {}) : /* @__PURE__ */ _.jsx(Oje, { files: a, handleDelete: c }),
        /* @__PURE__ */ _.jsx("section", { className: Al["dropzone-container"], children: /* @__PURE__ */ _.jsxs(
          "div",
          Fo(Yt({
            "data-testid": "dropzone"
          }, f({ className: Al.dropzone })), {
            children: [
              /* @__PURE__ */ _.jsx("input", Yt({}, h())),
              /* @__PURE__ */ _.jsx(bc, { className: Al["text-info"], children: Pje({ files: a, error: l }) }),
              a.length === 6 ? null : /* @__PURE__ */ _.jsx(
                xg,
                {
                  className: `${Al["dropzone-button"]} ${n ? Al["so-com"] : ""}`,
                  color: "secondary",
                  variant: "outline",
                  bg: "secondary",
                  children: "Seleccionar Archivos"
                }
              )
            ]
          })
        ) })
      ]
    }
  );
}, jje = (e) => {
  const r = {};
  return e.indexOf("?") === -1 || e.substring(e.indexOf("?") + 1).split("&").filter((t) => t).filter((t) => !!t).forEach((t) => {
    const [n, a] = t.split("=");
    r[n] = a || "";
  }), r;
}, A2 = () => {
  const { href: e } = window.location;
  return jje(e).orderNumberForReview;
}, Dje = () => {
  const e = new URL(window.location.href);
  e.searchParams.delete("orderNumberForReview"), window.history.replaceState({}, document.title, e.toString());
}, Nje = () => {
  var r, t;
  const e = (r = document.cookie) == null ? void 0 : r.split("; ");
  return (t = e == null ? void 0 : e.find((n) => n == null ? void 0 : n.startsWith("sid="))) == null ? void 0 : t.split("=")[1];
}, Lje = (e) => {
  const r = new Headers();
  return r.set("Country", e), r.set("Authorization", Nje()), r;
}, Fje = (e, r) => {
  const t = e == null ? void 0 : e.toLocaleLowerCase();
  return t !== "cl" ? `https://${OI[r]}.falabella.com.${t}` : `https://${OI[r]}.falabella.com`;
}, zje = ({
  orderNumber: e,
  productId: r,
  tenant: t,
  environment: n
}) => `${Fje(
  t,
  n
)}/s/bff-orders/orders/${e}/item/${r}`, cN = (a) => Gr(void 0, [a], function* ({
  orderNumber: e,
  productId: r,
  tenant: t,
  environment: n
}) {
  const i = zje({
    orderNumber: e,
    productId: r,
    tenant: t,
    environment: n
  });
  return yield Hu(i, {
    headers: Lje(t)
  });
}), Bje = (e) => {
  const r = {};
  return e.usernickname || (r.usernickname = "Nombre es requerido"), e.rating || (r.rating = "Rating es requerido"), r;
}, dN = (e, r, t) => e.length ? e.length >= r && e.length < t ? {
  text: "¡Sigue así! Cuéntanos más detalles 😉."
} : {
  className: vt.success,
  text: "¡Bien hecho! 🎉"
} : { className: "", text: null }, lp = (e) => dN(e, 1, 30).className, Uje = (e) => dN(e, 1, 30).text;
function Vje(e) {
  const {
    product: r,
    isSecondaryRatingsFormEnabled: t,
    isReviewValidationWithOrder: n
  } = gm(), { hasSecondaryRatings: a } = ea(), { theme: i, tenant: l, environment: u } = Eo(), { isOpen: c, onClose: f, onSubmit: h, isApp: p } = e, { data: g, requestInProgress: y, setRequestInProgress: S } = $m(), x = () => {
    T.handleSubmit();
  }, T = ZD({
    initialValues: g,
    validate: Bje,
    onSubmit: (j) => Gr(this, null, function* () {
      h(j);
    })
  }), A = /* @__PURE__ */ _.jsxs("form", { className: vt["review-form"], onSubmit: T.handleSubmit, children: [
    /* @__PURE__ */ _.jsxs("div", { className: vt["form-header"], children: [
      /* @__PURE__ */ _.jsx(bc, { className: vt.title, children: "¿Cómo calificarías este producto?" }),
      /* @__PURE__ */ _.jsxs("div", { className: vt["main-header"], children: [
        /* @__PURE__ */ _.jsx(mD, { product: r }),
        /* @__PURE__ */ _.jsxs("div", { className: vt["title-and-rating"], children: [
          /* @__PURE__ */ _.jsx(
            bc,
            {
              className: vt["product-name"],
              children: `${r.brandName} - ${r.name}`
            }
          ),
          /* @__PURE__ */ _.jsx("div", { className: vt["rating-form-control"], children: /* @__PURE__ */ _.jsxs(lP, { direction: "column", alignItems: "center", children: [
            /* @__PURE__ */ _.jsx(
              x_,
              {
                rating: T.values.rating,
                handleRatingClickHook: T.setFieldValue
              }
            ),
            /* @__PURE__ */ _.jsx(
              "div",
              {
                className: `${vt["form-error-message"]} ${T.errors.rating ? vt["field-error"] : ""}`,
                children: T.errors.rating
              }
            )
          ] }) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ _.jsx("div", { className: vt["form-body"], children: /* @__PURE__ */ _.jsxs(uP, { spacing: "32px", children: [
      /* @__PURE__ */ _.jsxs("div", { children: [
        /* @__PURE__ */ _.jsx("label", { className: vt.label, children: "Describe tu calificación en una frase" }),
        /* @__PURE__ */ _.jsx(
          KS,
          {
            id: "title",
            name: "title",
            className: vt.input,
            placeholder: "¿Qué es lo que más destacas del producto?",
            onChange: T.handleChange,
            value: T.values.title
          }
        )
      ] }),
      /* @__PURE__ */ _.jsxs("div", { children: [
        /* @__PURE__ */ _.jsx("label", { className: vt.label, children: "¿Qué te gustaría decir acerca de este producto?" }),
        /* @__PURE__ */ _.jsx(
          "textarea",
          {
            id: "reviewtext",
            name: "reviewtext",
            className: `${vt.textarea} ${lp(
              T.values.reviewtext
            )}`,
            placeholder: "Comparte tu experiencia con el producto. ¿Es lo que esperabas? ¿Qué fue lo que más te gustó?",
            onChange: T.handleChange,
            value: T.values.reviewtext,
            style: { borderColor: i.secondary_color }
          }
        ),
        T.values.reviewtext.length > 0 && /* @__PURE__ */ _.jsx(
          "div",
          {
            className: `${vt["helper-text"]} ${lp(T.values.reviewtext) ? lp(T.values.reviewtext) : ""}`,
            style: {
              color: lp(T.values.reviewtext) ? "" : i.secondary_color
            },
            children: Uje(T.values.reviewtext)
          }
        )
      ] }),
      /* @__PURE__ */ _.jsxs("div", { children: [
        /* @__PURE__ */ _.jsx("label", { className: vt.label, children: "Comparte tus fotos del producto" }),
        /* @__PURE__ */ _.jsx(
          kje,
          {
            photos: T.values.photos,
            handlePhotoUploadHook: T.setFieldValue
          }
        )
      ] }),
      /* @__PURE__ */ _.jsxs("div", { children: [
        /* @__PURE__ */ _.jsx("label", { className: vt.label, children: "Déjanos tu nombre (*)" }),
        /* @__PURE__ */ _.jsx(
          KS,
          {
            id: "usernickname",
            name: "usernickname",
            placeholder: "¿Cuál es tu nombre?",
            className: vt.input,
            onChange: T.handleChange,
            value: T.values.usernickname
          }
        ),
        /* @__PURE__ */ _.jsx(
          "div",
          {
            className: `${vt["form-error-message"]} ${T.errors.usernickname ? vt["field-error"] : ""}`,
            children: T.errors.usernickname
          }
        )
      ] }),
      /* @__PURE__ */ _.jsxs("div", { children: [
        /* @__PURE__ */ _.jsx("label", { className: vt.label, children: "¿Recomiendas este producto?" }),
        /* @__PURE__ */ _.jsx(
          kke,
          {
            value: T.values.isrecommended,
            setValue: T.setFieldValue,
            options: [
              { text: "Sí", icon: "😀", value: "true" },
              { text: "No", icon: "😕", value: "false" }
            ]
          }
        )
      ] })
    ] }) })
  ] }), O = ({
    errors: j,
    values: k,
    requestInProgress: L = !1
  }) => {
    const M = !Object.keys(j).length, W = !!k.usernickname && !!k.rating;
    return M && W && !L;
  }, P = ({ formik: j }) => {
    const k = () => Gr(this, null, function* () {
      try {
        S(!0);
        const L = A2();
        L && n ? (yield cN({
          orderNumber: L,
          productId: r.id,
          tenant: l,
          environment: u
        })).success ? j.handleSubmit() : f() : j.handleSubmit(), S(!1);
      } catch (L) {
        S(!1), f();
      }
    });
    return /* @__PURE__ */ _.jsx("div", { className: vt["write-review-custom-footer"], children: /* @__PURE__ */ _.jsx("div", { className: vt["footer-button-wrapper"], children: /* @__PURE__ */ _.jsx(
      XD,
      {
        disabled: !O({
          errors: j.errors,
          values: j.values,
          requestInProgress: y
        }),
        label: t && a ? "Continuar" : "Finalizar",
        handleButtonClick: k
      }
    ) }) });
  };
  return /* @__PURE__ */ _.jsxs(
    S_,
    {
      onContinue: x,
      isOpen: c,
      onClose: f,
      isApp: p,
      children: [
        /* @__PURE__ */ _.jsx("div", { slot: "header", children: /* @__PURE__ */ _.jsx(b_, { onClose: f }) }),
        A,
        /* @__PURE__ */ _.jsx("div", { slot: "footer", children: /* @__PURE__ */ _.jsx(P, { formik: T }) })
      ]
    }
  );
}
const Wje = "_heading_yn98b_21", Hje = "_text_yn98b_25", $s = {
  "review-sent-modal": "_review-sent-modal_yn98b_2",
  "modal-body": "_modal-body_yn98b_11",
  "circle-icon": "_circle-icon_yn98b_18",
  heading: Wje,
  text: Hje,
  "custom-footer-wrapper": "_custom-footer-wrapper_yn98b_30",
  "sent-button": "_sent-button_yn98b_36",
  "so-com": "_so-com_yn98b_39"
}, Gje = (e) => {
  const { payloadFunction: r, onClose: t, isOpen: n, isApp: a } = e, { theme: i, isSodimacStandAlone: l = !1 } = Eo(), u = ({
    onContinue: c,
    onClose: f
  }) => /* @__PURE__ */ _.jsx("div", { className: $s["custom-footer-wrapper"], children: /* @__PURE__ */ _.jsx(
    xg,
    {
      className: `${$s["sent-button"]} ${l ? $s["so-com"] : ""}`,
      onClick: () => {
        f(), c && c();
      },
      style: { backgroundColor: i.secondary_color },
      size: "lg",
      rightIcon: /* @__PURE__ */ _.jsx($Ie, {}),
      children: "Seguir navegando"
    }
  ) });
  return /* @__PURE__ */ _.jsxs(
    S_,
    {
      isOpen: n,
      onClose: t,
      onContinue: r,
      isApp: a,
      children: [
        /* @__PURE__ */ _.jsx("div", { slot: "header", children: /* @__PURE__ */ _.jsx(b_, { onClose: t }) }),
        /* @__PURE__ */ _.jsx("div", { className: $s["review-sent-modal"], children: /* @__PURE__ */ _.jsxs("div", { className: $s["modal-body"], children: [
          /* @__PURE__ */ _.jsx(ln, { className: $s["circle-icon"], children: /* @__PURE__ */ _.jsx(
            yIe,
            {
              color: i.secondary_color,
              fill: "#D3D7DB",
              width: "97px",
              height: "97px"
            }
          ) }),
          /* @__PURE__ */ _.jsx("div", { className: $s.heading, children: "¡Gracias! Tu comentario ya se publicó." }),
          /* @__PURE__ */ _.jsx(bc, { className: $s.text, children: "Con tu opinión estás ayudando a otros clientes a mejorar su experiencia de compra." })
        ] }) }),
        /* @__PURE__ */ _.jsx("div", { slot: "footer", children: /* @__PURE__ */ _.jsx(u, { onContinue: r, onClose: t }) })
      ]
    }
  );
}, fN = Pn(void 0);
var Of = /* @__PURE__ */ ((e) => (e.MainForm = "MainForm", e.AttributesByCategory = "AttributesByCategory", e.SentReview = "SentReview", e))(Of || {});
const Yje = ({ children: e }) => {
  const { onClickSuccessButton: r, tenant: t, environment: n, isLoggedIn: a } = Eo(), [i, l] = He(null), { product: u, isSecondaryRatingsFormEnabled: c } = gm(), { hasSecondaryRatings: f } = ea(), { setData: h, setRequestInProgress: p, resetData: g } = $m(), y = m_({ tenant: t, environment: n }), [S, x] = He(!1), T = () => {
    const { protocol: W, host: q } = window.location;
    window.location.href = `${W}//${q}`;
  }, A = (W) => Gr(void 0, null, function* () {
    try {
      p(!0), yield y.saveReview({ values: W, product: u }), p(!1), l(
        "SentReview"
        /* SentReview */
      );
    } catch (q) {
      console.log(q);
    }
  }), O = () => {
    const W = A2();
    return !r && !W ? T() : (W && Dje(), r && r());
  }, P = () => {
    l(null);
  }, j = () => {
    const W = new URLSearchParams(window.location.search);
    if (W.get("bvcampaign") === "PUSH_APP" && !W.has("sent")) {
      let oe = window.location.href;
      oe.includes("?") ? oe += "&sent" : oe += "?sent", window.history.pushState({}, "", oe);
    }
  }, k = (W) => Gr(void 0, null, function* () {
    try {
      c && f ? (h(W), l(
        "AttributesByCategory"
        /* AttributesByCategory */
      )) : (p(!0), yield y.saveReview({ values: W, product: u }), p(!1), l(
        "SentReview"
        /* SentReview */
      ));
    } catch (q) {
      console.log(q);
    }
  });
  er(() => {
    const q = new URLSearchParams(window.location.search).get("bvcampaign");
    x(q === "PUSH_APP");
  }, []);
  const L = Ze(n), M = Ze(t);
  return er(() => {
    (() => Gr(void 0, null, function* () {
      try {
        const q = A2();
        if (q) {
          const oe = yield cN({
            orderNumber: q,
            productId: u.id,
            environment: L.current,
            tenant: M.current
          });
          console.log({ response: oe }), oe.success && a && (console.log({ isLoggedIn: a }), l(
            "MainForm"
            /* MainForm */
          ));
        }
      } catch (q) {
        console.error("Error validating order:", q);
      }
    }))();
  }, [u.id, a]), /* @__PURE__ */ _.jsxs(fN.Provider, { value: { activeModal: i, setActiveModal: l, isApp: S }, children: [
    e,
    /* @__PURE__ */ _.jsx(
      Vje,
      {
        isApp: S,
        isOpen: i === "MainForm",
        onClose: P,
        onSubmit: k
      }
    ),
    /* @__PURE__ */ _.jsx(
      wke,
      {
        isApp: S,
        isOpen: i === "AttributesByCategory",
        onBackClick: () => {
          P(), l(
            "MainForm"
            /* MainForm */
          );
        },
        onClose: P,
        onSubmit: A
      }
    ),
    /* @__PURE__ */ _.jsx(
      Gje,
      {
        isApp: S,
        isOpen: i === "SentReview",
        onClose: () => {
          P(), g(), j();
        },
        payloadFunction: O
      }
    )
  ] });
}, P_ = () => {
  const e = Ur(fN);
  if (!e)
    throw new Error("useModalsContext must be used within a ModalsProvider");
  return e;
}, Kje = pD(Yje);
function qje() {
  const { label: e, isLoggedIn: r, openForm: t } = Eo(), { setActiveModal: n } = P_(), a = () => {
    r && n(Of.MainForm);
  };
  return er(() => {
    new URLSearchParams(window.location.search).has("sent") || n(t ? Of.MainForm : null);
  }, [n, t]), /* @__PURE__ */ _.jsx("div", { className: MI["bv-write-review"], children: /* @__PURE__ */ _.jsxs("label", { onClick: a, className: MI["write-comment-label"], children: [
    " ",
    e,
    " "
  ] }) });
}
const $8e = pD(qje), w8e = (t) => {
  var n = t, { children: e } = n, r = Hv(n, ["children"]);
  const {
    product: a,
    firstName: i,
    isSecondaryRatingsFormEnabled: l,
    isReviewValidationWithOrder: u
  } = r;
  return /* @__PURE__ */ _.jsx(OIe, Fo(Yt({}, r), { children: /* @__PURE__ */ _.jsx(xke, { firstName: i, children: /* @__PURE__ */ _.jsx(
    IIe,
    {
      initialProduct: a,
      isSecondaryRatingsFormEnabled: l,
      isReviewValidationWithOrder: u,
      children: /* @__PURE__ */ _.jsx(MIe, { children: /* @__PURE__ */ _.jsxs(Kje, { children: [
        e,
        " "
      ] }) })
    }
  ) }) }));
}, Go = {
  "bv-stars-non-editable": "_bv-stars-non-editable_1iaw8_1",
  "star-icon": "_star-icon_1iaw8_1",
  "star-empty": "_star-empty_1iaw8_11",
  "star-full": "_star-full_1iaw8_14",
  "star-1": "_star-1_1iaw8_17",
  "star-2": "_star-2_1iaw8_20",
  "star-3": "_star-3_1iaw8_23",
  "star-4": "_star-4_1iaw8_26",
  "star-5": "_star-5_1iaw8_29",
  "star-6": "_star-6_1iaw8_32",
  "star-7": "_star-7_1iaw8_35",
  "star-8": "_star-8_1iaw8_38",
  "star-9": "_star-9_1iaw8_41"
}, Zje = (e) => parseInt((e % 1).toFixed(1).slice(2)), Qje = (e) => {
  const r = `star-${e}`;
  return Go[r];
}, k_ = ({
  rating: e,
  starsColor: r
}) => {
  if (!e)
    return /* @__PURE__ */ _.jsx(ZS, { className: Go["bv-stars-non-editable"], spacing: "4px", children: [...Array(5)].map((i, l) => /* @__PURE__ */ _.jsx(
      "span",
      {
        role: "star-icon",
        "data-testid": `star-icon-${l + 1}`,
        className: Go["star-icon"] + " " + Go["star-empty"]
      },
      l
    )) });
  const t = e > 5 ? 5 : Math.floor(e), n = e % 1 !== 0 && e <= 5, a = 5 - t - (n ? 1 : 0);
  return /* @__PURE__ */ _.jsxs(ZS, { className: Go["bv-stars-non-editable"], spacing: "4px", children: [
    [...Array(t)].map((i, l) => /* @__PURE__ */ _.jsx(
      "span",
      {
        role: "star-icon",
        className: `${Go["star-icon"]} ${Go["star-full"]}`,
        style: r ? { backgroundColor: r } : {}
      },
      l
    )),
    n && /* @__PURE__ */ _.jsx(
      "span",
      {
        role: "star-icon",
        className: `${Go["star-icon"]} ${Qje(
          Zje(e)
        )}`,
        style: r ? { backgroundColor: r } : {}
      }
    ),
    a > 0 && [...Array(a)].map((i, l) => /* @__PURE__ */ _.jsx(
      "span",
      {
        role: "star-icon",
        className: `${Go["star-icon"]} ${Go["star-empty"]}`
      },
      l
    ))
  ] });
}, Xje = "_text_i8pye_5", up = {
  "bv-summary-rating": "_bv-summary-rating_i8pye_1",
  text: Xje,
  "comparative-table-reviews": "_comparative-table-reviews_i8pye_14"
}, _8e = ({ isComparativeTable: e }) => {
  const { averageRating: r = 0, totalComments: t = 0 } = ea(), n = e ? `${up.text} ${up["comparative-table-reviews"]}` : up.text;
  return e && (r === 0 || t === 0) ? null : /* @__PURE__ */ _.jsxs("div", { className: up["bv-summary-rating"], children: [
    /* @__PURE__ */ _.jsx(k_, { rating: r }),
    r && t ? /* @__PURE__ */ _.jsx("span", { className: n, children: e ? `(${t})` : `${r} (${t})` }) : /* @__PURE__ */ _.jsx("span", { className: n, children: "(0)" })
  ] });
}, ks = {
  "rating-distribution": "_rating-distribution_1wk2j_2",
  "rating-count-wrapper": "_rating-count-wrapper_1wk2j_7",
  "dark-star": "_dark-star_1wk2j_13",
  "rating-value": "_rating-value_1wk2j_24",
  "rating-count": "_rating-count_1wk2j_7",
  "distribution-bar": "_distribution-bar_1wk2j_37",
  "bar-inner": "_bar-inner_1wk2j_42",
  "bar-fill": "_bar-fill_1wk2j_56"
}, Jje = ({ widthPercent: e }) => /* @__PURE__ */ _.jsx("div", { className: ks["distribution-bar"], "data-testid": "distribution-bar", children: /* @__PURE__ */ _.jsx("div", { className: ks["bar-inner"], children: /* @__PURE__ */ _.jsx(
  "div",
  {
    className: ks["bar-fill"],
    style: { width: e },
    "data-testid": "bar-fill"
  }
) }) }), e6e = ({
  index: e,
  ratingDistribution: r,
  totalComments: t
}) => {
  const n = r.find(
    ({ RatingValue: l }) => l === e
  ) || { RatingValue: 0, Count: 0 }, { Count: a } = n, i = t ? a / t * 100 : 0;
  return /* @__PURE__ */ _.jsxs("div", { className: ks["rating-count-wrapper"], children: [
    /* @__PURE__ */ _.jsx("div", { className: ks["rating-value"], children: e }),
    /* @__PURE__ */ _.jsx("div", { className: ks["dark-star"] }),
    /* @__PURE__ */ _.jsx(Jje, { widthPercent: `${i}%` }),
    t > 0 && /* @__PURE__ */ _.jsx("div", { className: ks["rating-count"], children: a })
  ] }, e);
}, r6e = () => {
  const { totalComments: e = 0, ratingDistribution: r = [] } = ea();
  return /* @__PURE__ */ _.jsx("div", { className: ks["rating-distribution"], children: /* @__PURE__ */ _.jsx(_.Fragment, { children: [...Array(5)].map((t, n) => /* @__PURE__ */ _.jsx("div", { children: /* @__PURE__ */ _.jsx(
    e6e,
    {
      index: n + 1,
      ratingDistribution: r,
      totalComments: e
    }
  ) }, n)) }) });
}, t6e = "_numerator_7vdzo_22", n6e = "_denominator_7vdzo_27", yd = {
  "summary-tile": "_summary-tile_7vdzo_2",
  "rating-fraction": "_rating-fraction_7vdzo_16",
  numerator: t6e,
  denominator: n6e,
  "total-comments-text": "_total-comments-text_7vdzo_33"
}, a6e = ({ starsColor: e = "#333" }) => {
  const { averageRating: r = 0, totalComments: t = 0 } = ea(), n = t === 1 ? Vt.COMMENT : Vt.COMMENTS;
  return /* @__PURE__ */ _.jsxs("div", { className: yd["summary-tile"], children: [
    t ? /* @__PURE__ */ _.jsxs("div", { className: yd["rating-fraction"], children: [
      /* @__PURE__ */ _.jsx("div", { className: yd.numerator, children: r }),
      /* @__PURE__ */ _.jsx("div", { className: yd.denominator, children: "/5" })
    ] }) : null,
    /* @__PURE__ */ _.jsx(k_, { rating: r, starsColor: e }),
    /* @__PURE__ */ _.jsxs("div", { className: yd["total-comments-text"], children: [
      t,
      " ",
      n
    ] })
  ] });
}, Mi = {
  "recommendation-rate-wrapper": "_recommendation-rate-wrapper_4vqev_2",
  "circular-progress": "_circular-progress_4vqev_7",
  "progress-svg": "_progress-svg_4vqev_13",
  "progress-background": "_progress-background_4vqev_18",
  "progress-circle": "_progress-circle_4vqev_21",
  "percentage-text": "_percentage-text_4vqev_25",
  "text-content": "_text-content_4vqev_35",
  "main-text": "_main-text_4vqev_41",
  "recommendations-count": "_recommendations-count_4vqev_47"
}, o6e = () => {
  const { totalComments: e = 0, recommendedCount: r = 0 } = ea(), { recommendedThreshold: t = 80 } = Eo(), n = Math.round(
    r / e * 100
  ), a = n >= t, i = 30, l = 2 * Math.PI * i, u = e ? n : 0, c = l - u / 100 * l;
  return e && a ? /* @__PURE__ */ _.jsxs("div", { className: Mi["recommendation-rate-wrapper"], children: [
    /* @__PURE__ */ _.jsxs("div", { className: Mi["circular-progress"], children: [
      /* @__PURE__ */ _.jsxs("svg", { className: Mi["progress-svg"], viewBox: "0 0 70 70", children: [
        /* @__PURE__ */ _.jsx(
          "circle",
          {
            className: Mi["progress-background"],
            cx: "35",
            cy: "35",
            r: i,
            fill: "none",
            strokeWidth: "4"
          }
        ),
        /* @__PURE__ */ _.jsx(
          "circle",
          {
            className: Mi["progress-circle"],
            cx: "35",
            cy: "35",
            r: i,
            fill: "none",
            strokeWidth: "6",
            strokeDasharray: l,
            strokeDashoffset: c,
            strokeLinecap: "round"
          }
        )
      ] }),
      /* @__PURE__ */ _.jsxs("div", { className: Mi["percentage-text"], children: [
        u,
        "%"
      ] })
    ] }),
    /* @__PURE__ */ _.jsxs("div", { className: Mi["text-content"], children: [
      /* @__PURE__ */ _.jsx("div", { className: Mi["main-text"], children: Vt.CLIENTS_RECOMMEND_THIS_PRODUCT }),
      /* @__PURE__ */ _.jsxs("div", { className: Mi["recommendations-count"], children: [
        r,
        " ",
        r === 1 ? Vt.RECOMMENDATION : Vt.RECOMMENDATIONS
      ] })
    ] })
  ] }) : null;
}, i6e = "_label_1b11q_27", s6e = "_rating_1b11q_37", l6e = "_stars_1b11q_43", u6e = "_value_1b11q_48", c6e = "_bar_1b11q_135", Bt = {
  "secondary-ratings-divider": "_secondary-ratings-divider_1b11q_2",
  "normal-secondary-ratings-wrapper": "_normal-secondary-ratings-wrapper_1b11q_7",
  "secondary-rating": "_secondary-rating_1b11q_2",
  label: i6e,
  rating: s6e,
  stars: l6e,
  value: u6e,
  "slider-secondary-ratings-wrapper": "_slider-secondary-ratings-wrapper_1b11q_56",
  "slider-ratings": "_slider-ratings_1b11q_67",
  "rating-label": "_rating-label_1b11q_73",
  "slider-container": "_slider-container_1b11q_81",
  "slider-track-wrapper": "_slider-track-wrapper_1b11q_88",
  "slider-track": "_slider-track_1b11q_88",
  "slider-thumb": "_slider-thumb_1b11q_99",
  "minmax-labels": "_minmax-labels_1b11q_109",
  "range-label": "_range-label_1b11q_117",
  "render-stars-and-bars": "_render-stars-and-bars_1b11q_121",
  "filled-star": "_filled-star_1b11q_125",
  "empty-star": "_empty-star_1b11q_130",
  bar: c6e,
  "highlighted-bar": "_highlighted-bar_1b11q_142"
}, SO = ({ count: e, type: r }) => e > 0 ? /* @__PURE__ */ _.jsx("div", { className: Bt["render-stars-and-bars"], children: [...Array(e)].map((t) => e && /* @__PURE__ */ _.jsx("div", { className: Bt[r], "data-testid": r }, t)) }) : null, d6e = ({
  normalRatings: e
}) => /* @__PURE__ */ _.jsx(
  "div",
  {
    className: Bt["normal-secondary-ratings-wrapper"],
    "data-testid": "normal-secondary-ratings",
    children: Object.keys(e).map((r) => {
      const { AverageRating: t = 0, Label: n } = e[r], a = Math.round(t);
      return /* @__PURE__ */ _.jsxs("div", { className: Bt["secondary-rating"], children: [
        /* @__PURE__ */ _.jsx("div", { className: Bt.label, children: n }),
        /* @__PURE__ */ _.jsxs("div", { className: Bt.rating, children: [
          /* @__PURE__ */ _.jsxs("div", { className: Bt.stars, children: [
            /* @__PURE__ */ _.jsx(SO, { count: a, type: "filled-star" }),
            /* @__PURE__ */ _.jsx(SO, { count: 5 - a, type: "empty-star" })
          ] }),
          /* @__PURE__ */ _.jsx("div", { className: Bt.value, children: t.toFixed(1) })
        ] })
      ] }, r);
    })
  }
), f6e = ({
  sliderRatings: e
}) => /* @__PURE__ */ _.jsx(
  "div",
  {
    className: Bt["slider-secondary-ratings-wrapper"],
    "data-testid": "slider-secondary-ratings",
    children: Object.keys(e).map((r) => {
      const t = e[r], n = t.ValueRange > 0 ? Math.max(
        0,
        Math.min(100, t.AverageRating / t.ValueRange * 100)
      ) : 0;
      return /* @__PURE__ */ _.jsxs("div", { className: Bt["slider-ratings"], children: [
        /* @__PURE__ */ _.jsx("div", { className: Bt["rating-label"], children: t.Label }),
        /* @__PURE__ */ _.jsxs("div", { className: Bt["slider-container"], children: [
          /* @__PURE__ */ _.jsx("div", { className: Bt["slider-track-wrapper"], children: /* @__PURE__ */ _.jsx("div", { className: Bt["slider-track"], children: /* @__PURE__ */ _.jsx(
            "div",
            {
              className: Bt["slider-thumb"],
              style: { left: `${n}%` }
            }
          ) }) }),
          /* @__PURE__ */ _.jsxs("div", { className: Bt["minmax-labels"], children: [
            /* @__PURE__ */ _.jsx("div", { className: Bt["range-label"], children: t.MinLabel }),
            /* @__PURE__ */ _.jsx("div", { className: Bt["range-label"], children: t.MaxLabel })
          ] })
        ] })
      ] }, r);
    })
  }
), v6e = () => {
  const { secondaryRatingsAverages: e = {}, secondaryRatingsAveragesOrder: r = [] } = ea(), t = {}, n = {};
  r.map((l) => {
    const u = e[l];
    u.DisplayType === "SLIDER" ? n[l] = u : t[l] = u;
  });
  const a = Object.keys(t).length > 0, i = Object.keys(n).length > 0;
  return /* @__PURE__ */ _.jsxs("div", { children: [
    a && /* @__PURE__ */ _.jsx(d6e, { normalRatings: t }),
    a && i && /* @__PURE__ */ _.jsx("div", { className: Bt["secondary-ratings-divider"] }),
    i && /* @__PURE__ */ _.jsx(f6e, { sliderRatings: n })
  ] });
}, h6e = "_divider_1nl8x_14", ws = {
  "review-section-top": "_review-section-top_1nl8x_2",
  divider: h6e,
  "desktop-divider": "_desktop-divider_1nl8x_24",
  "review-section-top-wrapper": "_review-section-top-wrapper_1nl8x_31",
  "rating-stats": "_rating-stats_1nl8x_46",
  "recommendation-rate": "_recommendation-rate_1nl8x_59"
}, T8e = ({
  starsColor: e = "#333"
}) => {
  const { secondaryRatingsAveragesOrder: r = [], totalComments: t = 0 } = ea();
  return /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
    /* @__PURE__ */ _.jsxs(
      "div",
      {
        className: ws["review-section-top"],
        "data-testid": "review-section-top",
        children: [
          /* @__PURE__ */ _.jsx("div", { className: ws["review-section-top-wrapper"], children: /* @__PURE__ */ _.jsxs("div", { className: ws["rating-stats"], "data-testid": "rating-stats", children: [
            /* @__PURE__ */ _.jsx(a6e, { starsColor: e }),
            /* @__PURE__ */ _.jsx(r6e, {})
          ] }) }),
          /* @__PURE__ */ _.jsx("div", { className: ws.divider }),
          r.length > 0 && /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
            /* @__PURE__ */ _.jsx(
              "div",
              {
                className: ws["review-section-top-wrapper"],
                "data-testid": "secondary-ratings",
                children: /* @__PURE__ */ _.jsx(v6e, {})
              }
            ),
            /* @__PURE__ */ _.jsx("div", { className: ws.divider })
          ] }),
          /* @__PURE__ */ _.jsx(
            "div",
            {
              "data-testid": "recommendation-rate",
              className: ws["recommendation-rate"],
              children: /* @__PURE__ */ _.jsx(o6e, {})
            }
          )
        ]
      }
    ),
    t > 0 && /* @__PURE__ */ _.jsx("div", { className: ws["desktop-divider"] })
  ] });
}, xO = {
  "write-comment-section": "_write-comment-section_1fxc9_2",
  "give-rating-label": "_give-rating-label_1fxc9_20",
  "give-rating-stars": "_give-rating-stars_1fxc9_32"
}, C8e = () => {
  const { totalComments: e = 0 } = ea(), { setActiveModal: r } = P_(), { isLoggedIn: t } = Eo(), n = e > 0 ? Vt.RATE_THIS_PRODUCT : Vt.BE_THE_FIRST_TO_RATE, a = () => {
    t && r(Of.MainForm);
  };
  return /* @__PURE__ */ _.jsxs(
    "div",
    {
      className: xO["write-comment-section"],
      onClick: a,
      id: "give-rating-button",
      children: [
        /* @__PURE__ */ _.jsx("div", { className: xO["give-rating-label"], children: n }),
        /* @__PURE__ */ _.jsx(x_, { rating: null })
      ]
    }
  );
}, p6e = "_modal_xpeer_13", g6e = "_header_xpeer_21", m6e = "_rating_xpeer_50", b6e = "_close_xpeer_61", y6e = "_footer_xpeer_82", S6e = "_helpfull_xpeer_101", $n = {
  "review-card": "_review-card_xpeer_2",
  modal: p6e,
  header: g6e,
  "review-modal": "_review-modal_xpeer_28",
  "user-name": "_user-name_xpeer_31",
  "review-title": "_review-title_xpeer_37",
  rating: m6e,
  "time-since": "_time-since_xpeer_55",
  close: b6e,
  "review-text": "_review-text_xpeer_69",
  "syndication-source": "_syndication-source_xpeer_76",
  footer: y6e,
  "review-helpfulness": "_review-helpfulness_xpeer_87",
  "review-helpfulness-clicked": "_review-helpfulness-clicked_xpeer_88",
  "review-helpfulness-disable": "_review-helpfulness-disable_xpeer_89",
  helpfull: S6e,
  "not-helpfull": "_not-helpfull_xpeer_108",
  "helpfulness-text": "_helpfulness-text_xpeer_124",
  "rating-close": "_rating-close_xpeer_132"
}, x6e = "_modal_mk17y_2", $6e = "_close_mk17y_34", cp = {
  modal: x6e,
  "modal-content": "_modal-content_mk17y_15",
  "photo-review-card": "_photo-review-card_mk17y_29",
  close: $6e
}, w6e = "_next_191xw_28", _6e = "_prev_191xw_49", T6e = "_close_191xw_69", C6e = "_dot_191xw_80", E6e = "_active_191xw_101", zu = {
  "modal-photo-slider": "_modal-photo-slider_191xw_2",
  "modal-photo": "_modal-photo_191xw_2",
  next: w6e,
  "next-arrow": "_next-arrow_191xw_41",
  prev: _6e,
  "prev-arrow": "_prev-arrow_191xw_62",
  close: T6e,
  "dots-container": "_dots-container_191xw_80",
  dot: C6e,
  active: E6e
};
var V0 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
V0.exports;
(function(e, r) {
  (function() {
    var t, n = "4.17.21", a = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", u = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", f = 500, h = "__lodash_placeholder__", p = 1, g = 2, y = 4, S = 1, x = 2, T = 1, A = 2, O = 4, P = 8, j = 16, k = 32, L = 64, M = 128, W = 256, q = 512, oe = 30, Ae = "...", Te = 800, $e = 16, Ee = 1, ze = 2, Ke = 3, Be = 1 / 0, ue = 9007199254740991, he = 17976931348623157e292, _e = 0 / 0, Oe = 4294967295, Me = Oe - 1, Z = Oe >>> 1, se = [
      ["ary", M],
      ["bind", T],
      ["bindKey", A],
      ["curry", P],
      ["curryRight", j],
      ["flip", q],
      ["partial", k],
      ["partialRight", L],
      ["rearg", W]
    ], te = "[object Arguments]", fe = "[object Array]", je = "[object AsyncFunction]", ve = "[object Boolean]", rr = "[object Date]", br = "[object DOMException]", ur = "[object Error]", $r = "[object Function]", Qe = "[object GeneratorFunction]", yr = "[object Map]", at = "[object Number]", Zr = "[object Null]", Nr = "[object Object]", jt = "[object Promise]", mt = "[object Proxy]", gr = "[object RegExp]", Sr = "[object Set]", G = "[object String]", ne = "[object Symbol]", Y = "[object Undefined]", Q = "[object WeakMap]", we = "[object WeakSet]", be = "[object ArrayBuffer]", Re = "[object DataView]", cr = "[object Float32Array]", wr = "[object Float64Array]", lr = "[object Int8Array]", dt = "[object Int16Array]", ot = "[object Int32Array]", bt = "[object Uint8Array]", Ct = "[object Uint8ClampedArray]", fr = "[object Uint16Array]", Qr = "[object Uint32Array]", vn = /\b__p \+= '';/g, hn = /\b(__p \+=) '' \+/g, Za = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Cn = /&(?:amp|lt|gt|quot|#39);/g, ge = /[&<>"']/g, De = RegExp(Cn.source), tr = RegExp(ge.source), Dt = /<%-([\s\S]+?)%>/g, it = /<%([\s\S]+?)%>/g, Fn = /<%=([\s\S]+?)%>/g, Se = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ce = /^\w*$/, ye = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Pe = /[\\^$.*+?()[\]{}|]/g, nr = RegExp(Pe.source), Hr = /^\s+/, Jt = /\s/, en = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Rr = /\{\n\/\* \[wrapped with (.+)\] \*/, Qa = /,? & /, Ks = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, qs = /[()=,{}\[\]\/\s]/, Zs = /\\(\\)?/g, Qs = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, yt = /\w*$/, Xs = /^[-+]0x[0-9a-f]+$/i, Js = /^0b[01]+$/i, el = /^\[object .+?Constructor\]$/, rl = /^0o[0-7]+$/i, tl = /^(?:0|[1-9]\d*)$/, nl = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, pn = /($^)/, al = /['\n\r\u2028\u2029\\]/g, Nt = "\\ud800-\\udfff", ra = "\\u0300-\\u036f", ol = "\\ufe20-\\ufe2f", gn = "\\u20d0-\\u20ff", Xa = ra + ol + gn, Wi = "\\u2700-\\u27bf", Hi = "a-z\\xdf-\\xf6\\xf8-\\xff", il = "\\xac\\xb1\\xd7\\xf7", Ao = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", sl = "\\u2000-\\u206f", ll = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Gi = "A-Z\\xc0-\\xd6\\xd8-\\xde", Yi = "\\ufe0e\\ufe0f", Ki = il + Ao + sl + ll, di = "['’]", ul = "[" + Nt + "]", qi = "[" + Ki + "]", Io = "[" + Xa + "]", Zi = "\\d+", mn = "[" + Wi + "]", zn = "[" + Hi + "]", Qi = "[^" + Nt + Ki + Zi + Wi + Hi + Gi + "]", fi = "\\ud83c[\\udffb-\\udfff]", Oo = "(?:" + Io + "|" + fi + ")", Xi = "[^" + Nt + "]", vi = "(?:\\ud83c[\\udde6-\\uddff]){2}", hi = "[\\ud800-\\udbff][\\udc00-\\udfff]", En = "[" + Gi + "]", Ji = "\\u200d", es = "(?:" + zn + "|" + Qi + ")", cl = "(?:" + En + "|" + Qi + ")", Bn = "(?:" + di + "(?:d|ll|m|re|s|t|ve))?", rs = "(?:" + di + "(?:D|LL|M|RE|S|T|VE))?", ts = Oo + "?", ns = "[" + Yi + "]?", bn = "(?:" + Ji + "(?:" + [Xi, vi, hi].join("|") + ")" + ns + ts + ")*", ta = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", na = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Un = ns + ts + bn, dl = "(?:" + [mn, vi, hi].join("|") + ")" + Un, Mo = "(?:" + [Xi + Io + "?", Io, vi, hi, ul].join("|") + ")", aa = RegExp(di, "g"), Ro = RegExp(Io, "g"), Xr = RegExp(fi + "(?=" + fi + ")|" + Mo + Un, "g"), Lt = RegExp([
      En + "?" + zn + "+" + Bn + "(?=" + [qi, En, "$"].join("|") + ")",
      cl + "+" + rs + "(?=" + [qi, En + es, "$"].join("|") + ")",
      En + "?" + es + "+" + Bn,
      En + "+" + rs,
      na,
      ta,
      Zi,
      dl
    ].join("|"), "g"), fl = RegExp("[" + Ji + Nt + Xa + Yi + "]"), Po = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, vl = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], ko = -1, _r = {};
    _r[cr] = _r[wr] = _r[lr] = _r[dt] = _r[ot] = _r[bt] = _r[Ct] = _r[fr] = _r[Qr] = !0, _r[te] = _r[fe] = _r[be] = _r[ve] = _r[Re] = _r[rr] = _r[ur] = _r[$r] = _r[yr] = _r[at] = _r[Nr] = _r[gr] = _r[Sr] = _r[G] = _r[Q] = !1;
    var xr = {};
    xr[te] = xr[fe] = xr[be] = xr[Re] = xr[ve] = xr[rr] = xr[cr] = xr[wr] = xr[lr] = xr[dt] = xr[ot] = xr[yr] = xr[at] = xr[Nr] = xr[gr] = xr[Sr] = xr[G] = xr[ne] = xr[bt] = xr[Ct] = xr[fr] = xr[Qr] = !0, xr[ur] = xr[$r] = xr[Q] = !1;
    var jo = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, hl = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, v = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, b = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, $ = parseFloat, N = parseInt, ie = typeof Pi == "object" && Pi && Pi.Object === Object && Pi, pe = typeof self == "object" && self && self.Object === Object && self, ce = ie || pe || Function("return this")(), ae = r && !r.nodeType && r, me = ae && !0 && e && !e.nodeType && e, ar = me && me.exports === ae, qe = ar && ie.process, Pr = function() {
      try {
        var U = me && me.require && me.require("util").types;
        return U || qe && qe.binding && qe.binding("util");
      } catch (X) {
      }
    }(), Vn = Pr && Pr.isArrayBuffer, Wn = Pr && Pr.isDate, Ja = Pr && Pr.isMap, z_ = Pr && Pr.isRegExp, B_ = Pr && Pr.isSet, U_ = Pr && Pr.isTypedArray;
    function oa(U, X, K) {
      switch (K.length) {
        case 0:
          return U.call(X);
        case 1:
          return U.call(X, K[0]);
        case 2:
          return U.call(X, K[0], K[1]);
        case 3:
          return U.call(X, K[0], K[1], K[2]);
      }
      return U.apply(X, K);
    }
    function xN(U, X, K, Ie) {
      for (var Xe = -1, Tr = U == null ? 0 : U.length; ++Xe < Tr; ) {
        var Ft = U[Xe];
        X(Ie, Ft, K(Ft), U);
      }
      return Ie;
    }
    function Aa(U, X) {
      for (var K = -1, Ie = U == null ? 0 : U.length; ++K < Ie && X(U[K], K, U) !== !1; )
        ;
      return U;
    }
    function $N(U, X) {
      for (var K = U == null ? 0 : U.length; K-- && X(U[K], K, U) !== !1; )
        ;
      return U;
    }
    function V_(U, X) {
      for (var K = -1, Ie = U == null ? 0 : U.length; ++K < Ie; )
        if (!X(U[K], K, U))
          return !1;
      return !0;
    }
    function as(U, X) {
      for (var K = -1, Ie = U == null ? 0 : U.length, Xe = 0, Tr = []; ++K < Ie; ) {
        var Ft = U[K];
        X(Ft, K, U) && (Tr[Xe++] = Ft);
      }
      return Tr;
    }
    function ov(U, X) {
      var K = U == null ? 0 : U.length;
      return !!K && mu(U, X, 0) > -1;
    }
    function Cm(U, X, K) {
      for (var Ie = -1, Xe = U == null ? 0 : U.length; ++Ie < Xe; )
        if (K(X, U[Ie]))
          return !0;
      return !1;
    }
    function ft(U, X) {
      for (var K = -1, Ie = U == null ? 0 : U.length, Xe = Array(Ie); ++K < Ie; )
        Xe[K] = X(U[K], K, U);
      return Xe;
    }
    function os(U, X) {
      for (var K = -1, Ie = X.length, Xe = U.length; ++K < Ie; )
        U[Xe + K] = X[K];
      return U;
    }
    function Em(U, X, K, Ie) {
      var Xe = -1, Tr = U == null ? 0 : U.length;
      for (Ie && Tr && (K = U[++Xe]); ++Xe < Tr; )
        K = X(K, U[Xe], Xe, U);
      return K;
    }
    function wN(U, X, K, Ie) {
      var Xe = U == null ? 0 : U.length;
      for (Ie && Xe && (K = U[--Xe]); Xe--; )
        K = X(K, U[Xe], Xe, U);
      return K;
    }
    function Am(U, X) {
      for (var K = -1, Ie = U == null ? 0 : U.length; ++K < Ie; )
        if (X(U[K], K, U))
          return !0;
      return !1;
    }
    var _N = Im("length");
    function TN(U) {
      return U.split("");
    }
    function CN(U) {
      return U.match(Ks) || [];
    }
    function W_(U, X, K) {
      var Ie;
      return K(U, function(Xe, Tr, Ft) {
        if (X(Xe, Tr, Ft))
          return Ie = Tr, !1;
      }), Ie;
    }
    function iv(U, X, K, Ie) {
      for (var Xe = U.length, Tr = K + (Ie ? 1 : -1); Ie ? Tr-- : ++Tr < Xe; )
        if (X(U[Tr], Tr, U))
          return Tr;
      return -1;
    }
    function mu(U, X, K) {
      return X === X ? LN(U, X, K) : iv(U, H_, K);
    }
    function EN(U, X, K, Ie) {
      for (var Xe = K - 1, Tr = U.length; ++Xe < Tr; )
        if (Ie(U[Xe], X))
          return Xe;
      return -1;
    }
    function H_(U) {
      return U !== U;
    }
    function G_(U, X) {
      var K = U == null ? 0 : U.length;
      return K ? Mm(U, X) / K : _e;
    }
    function Im(U) {
      return function(X) {
        return X == null ? t : X[U];
      };
    }
    function Om(U) {
      return function(X) {
        return U == null ? t : U[X];
      };
    }
    function Y_(U, X, K, Ie, Xe) {
      return Xe(U, function(Tr, Ft, Jr) {
        K = Ie ? (Ie = !1, Tr) : X(K, Tr, Ft, Jr);
      }), K;
    }
    function AN(U, X) {
      var K = U.length;
      for (U.sort(X); K--; )
        U[K] = U[K].value;
      return U;
    }
    function Mm(U, X) {
      for (var K, Ie = -1, Xe = U.length; ++Ie < Xe; ) {
        var Tr = X(U[Ie]);
        Tr !== t && (K = K === t ? Tr : K + Tr);
      }
      return K;
    }
    function Rm(U, X) {
      for (var K = -1, Ie = Array(U); ++K < U; )
        Ie[K] = X(K);
      return Ie;
    }
    function IN(U, X) {
      return ft(X, function(K) {
        return [K, U[K]];
      });
    }
    function K_(U) {
      return U && U.slice(0, X_(U) + 1).replace(Hr, "");
    }
    function ia(U) {
      return function(X) {
        return U(X);
      };
    }
    function Pm(U, X) {
      return ft(X, function(K) {
        return U[K];
      });
    }
    function Bc(U, X) {
      return U.has(X);
    }
    function q_(U, X) {
      for (var K = -1, Ie = U.length; ++K < Ie && mu(X, U[K], 0) > -1; )
        ;
      return K;
    }
    function Z_(U, X) {
      for (var K = U.length; K-- && mu(X, U[K], 0) > -1; )
        ;
      return K;
    }
    function ON(U, X) {
      for (var K = U.length, Ie = 0; K--; )
        U[K] === X && ++Ie;
      return Ie;
    }
    var MN = Om(jo), RN = Om(hl);
    function PN(U) {
      return "\\" + b[U];
    }
    function kN(U, X) {
      return U == null ? t : U[X];
    }
    function bu(U) {
      return fl.test(U);
    }
    function jN(U) {
      return Po.test(U);
    }
    function DN(U) {
      for (var X, K = []; !(X = U.next()).done; )
        K.push(X.value);
      return K;
    }
    function km(U) {
      var X = -1, K = Array(U.size);
      return U.forEach(function(Ie, Xe) {
        K[++X] = [Xe, Ie];
      }), K;
    }
    function Q_(U, X) {
      return function(K) {
        return U(X(K));
      };
    }
    function is(U, X) {
      for (var K = -1, Ie = U.length, Xe = 0, Tr = []; ++K < Ie; ) {
        var Ft = U[K];
        (Ft === X || Ft === h) && (U[K] = h, Tr[Xe++] = K);
      }
      return Tr;
    }
    function sv(U) {
      var X = -1, K = Array(U.size);
      return U.forEach(function(Ie) {
        K[++X] = Ie;
      }), K;
    }
    function NN(U) {
      var X = -1, K = Array(U.size);
      return U.forEach(function(Ie) {
        K[++X] = [Ie, Ie];
      }), K;
    }
    function LN(U, X, K) {
      for (var Ie = K - 1, Xe = U.length; ++Ie < Xe; )
        if (U[Ie] === X)
          return Ie;
      return -1;
    }
    function FN(U, X, K) {
      for (var Ie = K + 1; Ie--; )
        if (U[Ie] === X)
          return Ie;
      return Ie;
    }
    function yu(U) {
      return bu(U) ? BN(U) : _N(U);
    }
    function eo(U) {
      return bu(U) ? UN(U) : TN(U);
    }
    function X_(U) {
      for (var X = U.length; X-- && Jt.test(U.charAt(X)); )
        ;
      return X;
    }
    var zN = Om(v);
    function BN(U) {
      for (var X = Xr.lastIndex = 0; Xr.test(U); )
        ++X;
      return X;
    }
    function UN(U) {
      return U.match(Xr) || [];
    }
    function VN(U) {
      return U.match(Lt) || [];
    }
    var WN = function U(X) {
      X = X == null ? ce : Su.defaults(ce.Object(), X, Su.pick(ce, vl));
      var K = X.Array, Ie = X.Date, Xe = X.Error, Tr = X.Function, Ft = X.Math, Jr = X.Object, jm = X.RegExp, HN = X.String, Ia = X.TypeError, lv = K.prototype, GN = Tr.prototype, xu = Jr.prototype, uv = X["__core-js_shared__"], cv = GN.toString, Lr = xu.hasOwnProperty, YN = 0, J_ = function() {
        var o = /[^.]+$/.exec(uv && uv.keys && uv.keys.IE_PROTO || "");
        return o ? "Symbol(src)_1." + o : "";
      }(), dv = xu.toString, KN = cv.call(Jr), qN = ce._, ZN = jm(
        "^" + cv.call(Lr).replace(Pe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), fv = ar ? X.Buffer : t, ss = X.Symbol, vv = X.Uint8Array, e5 = fv ? fv.allocUnsafe : t, hv = Q_(Jr.getPrototypeOf, Jr), r5 = Jr.create, t5 = xu.propertyIsEnumerable, pv = lv.splice, n5 = ss ? ss.isConcatSpreadable : t, Uc = ss ? ss.iterator : t, pl = ss ? ss.toStringTag : t, gv = function() {
        try {
          var o = Sl(Jr, "defineProperty");
          return o({}, "", {}), o;
        } catch (s) {
        }
      }(), QN = X.clearTimeout !== ce.clearTimeout && X.clearTimeout, XN = Ie && Ie.now !== ce.Date.now && Ie.now, JN = X.setTimeout !== ce.setTimeout && X.setTimeout, mv = Ft.ceil, bv = Ft.floor, Dm = Jr.getOwnPropertySymbols, eL = fv ? fv.isBuffer : t, a5 = X.isFinite, rL = lv.join, tL = Q_(Jr.keys, Jr), zt = Ft.max, yn = Ft.min, nL = Ie.now, aL = X.parseInt, o5 = Ft.random, oL = lv.reverse, Nm = Sl(X, "DataView"), Vc = Sl(X, "Map"), Lm = Sl(X, "Promise"), $u = Sl(X, "Set"), Wc = Sl(X, "WeakMap"), Hc = Sl(Jr, "create"), yv = Wc && new Wc(), wu = {}, iL = xl(Nm), sL = xl(Vc), lL = xl(Lm), uL = xl($u), cL = xl(Wc), Sv = ss ? ss.prototype : t, Gc = Sv ? Sv.valueOf : t, i5 = Sv ? Sv.toString : t;
      function C(o) {
        if (_t(o) && !Je(o) && !(o instanceof vr)) {
          if (o instanceof Oa)
            return o;
          if (Lr.call(o, "__wrapped__"))
            return sT(o);
        }
        return new Oa(o);
      }
      var _u = function() {
        function o() {
        }
        return function(s) {
          if (!St(s))
            return {};
          if (r5)
            return r5(s);
          o.prototype = s;
          var d = new o();
          return o.prototype = t, d;
        };
      }();
      function xv() {
      }
      function Oa(o, s) {
        this.__wrapped__ = o, this.__actions__ = [], this.__chain__ = !!s, this.__index__ = 0, this.__values__ = t;
      }
      C.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Dt,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: it,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Fn,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: C
        }
      }, C.prototype = xv.prototype, C.prototype.constructor = C, Oa.prototype = _u(xv.prototype), Oa.prototype.constructor = Oa;
      function vr(o) {
        this.__wrapped__ = o, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Oe, this.__views__ = [];
      }
      function dL() {
        var o = new vr(this.__wrapped__);
        return o.__actions__ = Hn(this.__actions__), o.__dir__ = this.__dir__, o.__filtered__ = this.__filtered__, o.__iteratees__ = Hn(this.__iteratees__), o.__takeCount__ = this.__takeCount__, o.__views__ = Hn(this.__views__), o;
      }
      function fL() {
        if (this.__filtered__) {
          var o = new vr(this);
          o.__dir__ = -1, o.__filtered__ = !0;
        } else
          o = this.clone(), o.__dir__ *= -1;
        return o;
      }
      function vL() {
        var o = this.__wrapped__.value(), s = this.__dir__, d = Je(o), m = s < 0, w = d ? o.length : 0, E = T9(0, w, this.__views__), R = E.start, D = E.end, V = D - R, J = m ? D : R - 1, ee = this.__iteratees__, le = ee.length, xe = 0, ke = yn(V, this.__takeCount__);
        if (!d || !m && w == V && ke == V)
          return O5(o, this.__actions__);
        var Ve = [];
        e:
          for (; V-- && xe < ke; ) {
            J += s;
            for (var ir = -1, We = o[J]; ++ir < le; ) {
              var dr = ee[ir], pr = dr.iteratee, ua = dr.type, On = pr(We);
              if (ua == ze)
                We = On;
              else if (!On) {
                if (ua == Ee)
                  continue e;
                break e;
              }
            }
            Ve[xe++] = We;
          }
        return Ve;
      }
      vr.prototype = _u(xv.prototype), vr.prototype.constructor = vr;
      function gl(o) {
        var s = -1, d = o == null ? 0 : o.length;
        for (this.clear(); ++s < d; ) {
          var m = o[s];
          this.set(m[0], m[1]);
        }
      }
      function hL() {
        this.__data__ = Hc ? Hc(null) : {}, this.size = 0;
      }
      function pL(o) {
        var s = this.has(o) && delete this.__data__[o];
        return this.size -= s ? 1 : 0, s;
      }
      function gL(o) {
        var s = this.__data__;
        if (Hc) {
          var d = s[o];
          return d === c ? t : d;
        }
        return Lr.call(s, o) ? s[o] : t;
      }
      function mL(o) {
        var s = this.__data__;
        return Hc ? s[o] !== t : Lr.call(s, o);
      }
      function bL(o, s) {
        var d = this.__data__;
        return this.size += this.has(o) ? 0 : 1, d[o] = Hc && s === t ? c : s, this;
      }
      gl.prototype.clear = hL, gl.prototype.delete = pL, gl.prototype.get = gL, gl.prototype.has = mL, gl.prototype.set = bL;
      function pi(o) {
        var s = -1, d = o == null ? 0 : o.length;
        for (this.clear(); ++s < d; ) {
          var m = o[s];
          this.set(m[0], m[1]);
        }
      }
      function yL() {
        this.__data__ = [], this.size = 0;
      }
      function SL(o) {
        var s = this.__data__, d = $v(s, o);
        if (d < 0)
          return !1;
        var m = s.length - 1;
        return d == m ? s.pop() : pv.call(s, d, 1), --this.size, !0;
      }
      function xL(o) {
        var s = this.__data__, d = $v(s, o);
        return d < 0 ? t : s[d][1];
      }
      function $L(o) {
        return $v(this.__data__, o) > -1;
      }
      function wL(o, s) {
        var d = this.__data__, m = $v(d, o);
        return m < 0 ? (++this.size, d.push([o, s])) : d[m][1] = s, this;
      }
      pi.prototype.clear = yL, pi.prototype.delete = SL, pi.prototype.get = xL, pi.prototype.has = $L, pi.prototype.set = wL;
      function gi(o) {
        var s = -1, d = o == null ? 0 : o.length;
        for (this.clear(); ++s < d; ) {
          var m = o[s];
          this.set(m[0], m[1]);
        }
      }
      function _L() {
        this.size = 0, this.__data__ = {
          hash: new gl(),
          map: new (Vc || pi)(),
          string: new gl()
        };
      }
      function TL(o) {
        var s = kv(this, o).delete(o);
        return this.size -= s ? 1 : 0, s;
      }
      function CL(o) {
        return kv(this, o).get(o);
      }
      function EL(o) {
        return kv(this, o).has(o);
      }
      function AL(o, s) {
        var d = kv(this, o), m = d.size;
        return d.set(o, s), this.size += d.size == m ? 0 : 1, this;
      }
      gi.prototype.clear = _L, gi.prototype.delete = TL, gi.prototype.get = CL, gi.prototype.has = EL, gi.prototype.set = AL;
      function ml(o) {
        var s = -1, d = o == null ? 0 : o.length;
        for (this.__data__ = new gi(); ++s < d; )
          this.add(o[s]);
      }
      function IL(o) {
        return this.__data__.set(o, c), this;
      }
      function OL(o) {
        return this.__data__.has(o);
      }
      ml.prototype.add = ml.prototype.push = IL, ml.prototype.has = OL;
      function ro(o) {
        var s = this.__data__ = new pi(o);
        this.size = s.size;
      }
      function ML() {
        this.__data__ = new pi(), this.size = 0;
      }
      function RL(o) {
        var s = this.__data__, d = s.delete(o);
        return this.size = s.size, d;
      }
      function PL(o) {
        return this.__data__.get(o);
      }
      function kL(o) {
        return this.__data__.has(o);
      }
      function jL(o, s) {
        var d = this.__data__;
        if (d instanceof pi) {
          var m = d.__data__;
          if (!Vc || m.length < a - 1)
            return m.push([o, s]), this.size = ++d.size, this;
          d = this.__data__ = new gi(m);
        }
        return d.set(o, s), this.size = d.size, this;
      }
      ro.prototype.clear = ML, ro.prototype.delete = RL, ro.prototype.get = PL, ro.prototype.has = kL, ro.prototype.set = jL;
      function s5(o, s) {
        var d = Je(o), m = !d && $l(o), w = !d && !m && fs(o), E = !d && !m && !w && Au(o), R = d || m || w || E, D = R ? Rm(o.length, HN) : [], V = D.length;
        for (var J in o)
          (s || Lr.call(o, J)) && !(R && // Safari 9 has enumerable `arguments.length` in strict mode.
          (J == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          w && (J == "offset" || J == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          E && (J == "buffer" || J == "byteLength" || J == "byteOffset") || // Skip index properties.
          Si(J, V))) && D.push(J);
        return D;
      }
      function l5(o) {
        var s = o.length;
        return s ? o[qm(0, s - 1)] : t;
      }
      function DL(o, s) {
        return jv(Hn(o), bl(s, 0, o.length));
      }
      function NL(o) {
        return jv(Hn(o));
      }
      function Fm(o, s, d) {
        (d !== t && !to(o[s], d) || d === t && !(s in o)) && mi(o, s, d);
      }
      function Yc(o, s, d) {
        var m = o[s];
        (!(Lr.call(o, s) && to(m, d)) || d === t && !(s in o)) && mi(o, s, d);
      }
      function $v(o, s) {
        for (var d = o.length; d--; )
          if (to(o[d][0], s))
            return d;
        return -1;
      }
      function LL(o, s, d, m) {
        return ls(o, function(w, E, R) {
          s(m, w, d(w), R);
        }), m;
      }
      function u5(o, s) {
        return o && No(s, Gt(s), o);
      }
      function FL(o, s) {
        return o && No(s, Yn(s), o);
      }
      function mi(o, s, d) {
        s == "__proto__" && gv ? gv(o, s, {
          configurable: !0,
          enumerable: !0,
          value: d,
          writable: !0
        }) : o[s] = d;
      }
      function zm(o, s) {
        for (var d = -1, m = s.length, w = K(m), E = o == null; ++d < m; )
          w[d] = E ? t : Sb(o, s[d]);
        return w;
      }
      function bl(o, s, d) {
        return o === o && (d !== t && (o = o <= d ? o : d), s !== t && (o = o >= s ? o : s)), o;
      }
      function Ma(o, s, d, m, w, E) {
        var R, D = s & p, V = s & g, J = s & y;
        if (d && (R = w ? d(o, m, w, E) : d(o)), R !== t)
          return R;
        if (!St(o))
          return o;
        var ee = Je(o);
        if (ee) {
          if (R = E9(o), !D)
            return Hn(o, R);
        } else {
          var le = Sn(o), xe = le == $r || le == Qe;
          if (fs(o))
            return P5(o, D);
          if (le == Nr || le == te || xe && !w) {
            if (R = V || xe ? {} : X5(o), !D)
              return V ? g9(o, FL(R, o)) : p9(o, u5(R, o));
          } else {
            if (!xr[le])
              return w ? o : {};
            R = A9(o, le, D);
          }
        }
        E || (E = new ro());
        var ke = E.get(o);
        if (ke)
          return ke;
        E.set(o, R), ET(o) ? o.forEach(function(We) {
          R.add(Ma(We, s, d, We, o, E));
        }) : TT(o) && o.forEach(function(We, dr) {
          R.set(dr, Ma(We, s, d, dr, o, E));
        });
        var Ve = J ? V ? ib : ob : V ? Yn : Gt, ir = ee ? t : Ve(o);
        return Aa(ir || o, function(We, dr) {
          ir && (dr = We, We = o[dr]), Yc(R, dr, Ma(We, s, d, dr, o, E));
        }), R;
      }
      function zL(o) {
        var s = Gt(o);
        return function(d) {
          return c5(d, o, s);
        };
      }
      function c5(o, s, d) {
        var m = d.length;
        if (o == null)
          return !m;
        for (o = Jr(o); m--; ) {
          var w = d[m], E = s[w], R = o[w];
          if (R === t && !(w in o) || !E(R))
            return !1;
        }
        return !0;
      }
      function d5(o, s, d) {
        if (typeof o != "function")
          throw new Ia(l);
        return ed(function() {
          o.apply(t, d);
        }, s);
      }
      function Kc(o, s, d, m) {
        var w = -1, E = ov, R = !0, D = o.length, V = [], J = s.length;
        if (!D)
          return V;
        d && (s = ft(s, ia(d))), m ? (E = Cm, R = !1) : s.length >= a && (E = Bc, R = !1, s = new ml(s));
        e:
          for (; ++w < D; ) {
            var ee = o[w], le = d == null ? ee : d(ee);
            if (ee = m || ee !== 0 ? ee : 0, R && le === le) {
              for (var xe = J; xe--; )
                if (s[xe] === le)
                  continue e;
              V.push(ee);
            } else
              E(s, le, m) || V.push(ee);
          }
        return V;
      }
      var ls = L5(Do), f5 = L5(Um, !0);
      function BL(o, s) {
        var d = !0;
        return ls(o, function(m, w, E) {
          return d = !!s(m, w, E), d;
        }), d;
      }
      function wv(o, s, d) {
        for (var m = -1, w = o.length; ++m < w; ) {
          var E = o[m], R = s(E);
          if (R != null && (D === t ? R === R && !la(R) : d(R, D)))
            var D = R, V = E;
        }
        return V;
      }
      function UL(o, s, d, m) {
        var w = o.length;
        for (d = or(d), d < 0 && (d = -d > w ? 0 : w + d), m = m === t || m > w ? w : or(m), m < 0 && (m += w), m = d > m ? 0 : IT(m); d < m; )
          o[d++] = s;
        return o;
      }
      function v5(o, s) {
        var d = [];
        return ls(o, function(m, w, E) {
          s(m, w, E) && d.push(m);
        }), d;
      }
      function rn(o, s, d, m, w) {
        var E = -1, R = o.length;
        for (d || (d = O9), w || (w = []); ++E < R; ) {
          var D = o[E];
          s > 0 && d(D) ? s > 1 ? rn(D, s - 1, d, m, w) : os(w, D) : m || (w[w.length] = D);
        }
        return w;
      }
      var Bm = F5(), h5 = F5(!0);
      function Do(o, s) {
        return o && Bm(o, s, Gt);
      }
      function Um(o, s) {
        return o && h5(o, s, Gt);
      }
      function _v(o, s) {
        return as(s, function(d) {
          return xi(o[d]);
        });
      }
      function yl(o, s) {
        s = cs(s, o);
        for (var d = 0, m = s.length; o != null && d < m; )
          o = o[Lo(s[d++])];
        return d && d == m ? o : t;
      }
      function p5(o, s, d) {
        var m = s(o);
        return Je(o) ? m : os(m, d(o));
      }
      function An(o) {
        return o == null ? o === t ? Y : Zr : pl && pl in Jr(o) ? _9(o) : N9(o);
      }
      function Vm(o, s) {
        return o > s;
      }
      function VL(o, s) {
        return o != null && Lr.call(o, s);
      }
      function WL(o, s) {
        return o != null && s in Jr(o);
      }
      function HL(o, s, d) {
        return o >= yn(s, d) && o < zt(s, d);
      }
      function Wm(o, s, d) {
        for (var m = d ? Cm : ov, w = o[0].length, E = o.length, R = E, D = K(E), V = 1 / 0, J = []; R--; ) {
          var ee = o[R];
          R && s && (ee = ft(ee, ia(s))), V = yn(ee.length, V), D[R] = !d && (s || w >= 120 && ee.length >= 120) ? new ml(R && ee) : t;
        }
        ee = o[0];
        var le = -1, xe = D[0];
        e:
          for (; ++le < w && J.length < V; ) {
            var ke = ee[le], Ve = s ? s(ke) : ke;
            if (ke = d || ke !== 0 ? ke : 0, !(xe ? Bc(xe, Ve) : m(J, Ve, d))) {
              for (R = E; --R; ) {
                var ir = D[R];
                if (!(ir ? Bc(ir, Ve) : m(o[R], Ve, d)))
                  continue e;
              }
              xe && xe.push(Ve), J.push(ke);
            }
          }
        return J;
      }
      function GL(o, s, d, m) {
        return Do(o, function(w, E, R) {
          s(m, d(w), E, R);
        }), m;
      }
      function qc(o, s, d) {
        s = cs(s, o), o = tT(o, s);
        var m = o == null ? o : o[Lo(Pa(s))];
        return m == null ? t : oa(m, o, d);
      }
      function g5(o) {
        return _t(o) && An(o) == te;
      }
      function YL(o) {
        return _t(o) && An(o) == be;
      }
      function KL(o) {
        return _t(o) && An(o) == rr;
      }
      function Zc(o, s, d, m, w) {
        return o === s ? !0 : o == null || s == null || !_t(o) && !_t(s) ? o !== o && s !== s : qL(o, s, d, m, Zc, w);
      }
      function qL(o, s, d, m, w, E) {
        var R = Je(o), D = Je(s), V = R ? fe : Sn(o), J = D ? fe : Sn(s);
        V = V == te ? Nr : V, J = J == te ? Nr : J;
        var ee = V == Nr, le = J == Nr, xe = V == J;
        if (xe && fs(o)) {
          if (!fs(s))
            return !1;
          R = !0, ee = !1;
        }
        if (xe && !ee)
          return E || (E = new ro()), R || Au(o) ? q5(o, s, d, m, w, E) : $9(o, s, V, d, m, w, E);
        if (!(d & S)) {
          var ke = ee && Lr.call(o, "__wrapped__"), Ve = le && Lr.call(s, "__wrapped__");
          if (ke || Ve) {
            var ir = ke ? o.value() : o, We = Ve ? s.value() : s;
            return E || (E = new ro()), w(ir, We, d, m, E);
          }
        }
        return xe ? (E || (E = new ro()), w9(o, s, d, m, w, E)) : !1;
      }
      function ZL(o) {
        return _t(o) && Sn(o) == yr;
      }
      function Hm(o, s, d, m) {
        var w = d.length, E = w, R = !m;
        if (o == null)
          return !E;
        for (o = Jr(o); w--; ) {
          var D = d[w];
          if (R && D[2] ? D[1] !== o[D[0]] : !(D[0] in o))
            return !1;
        }
        for (; ++w < E; ) {
          D = d[w];
          var V = D[0], J = o[V], ee = D[1];
          if (R && D[2]) {
            if (J === t && !(V in o))
              return !1;
          } else {
            var le = new ro();
            if (m)
              var xe = m(J, ee, V, o, s, le);
            if (!(xe === t ? Zc(ee, J, S | x, m, le) : xe))
              return !1;
          }
        }
        return !0;
      }
      function m5(o) {
        if (!St(o) || R9(o))
          return !1;
        var s = xi(o) ? ZN : el;
        return s.test(xl(o));
      }
      function QL(o) {
        return _t(o) && An(o) == gr;
      }
      function XL(o) {
        return _t(o) && Sn(o) == Sr;
      }
      function JL(o) {
        return _t(o) && Bv(o.length) && !!_r[An(o)];
      }
      function b5(o) {
        return typeof o == "function" ? o : o == null ? Kn : typeof o == "object" ? Je(o) ? x5(o[0], o[1]) : S5(o) : zT(o);
      }
      function Gm(o) {
        if (!Jc(o))
          return tL(o);
        var s = [];
        for (var d in Jr(o))
          Lr.call(o, d) && d != "constructor" && s.push(d);
        return s;
      }
      function e9(o) {
        if (!St(o))
          return D9(o);
        var s = Jc(o), d = [];
        for (var m in o)
          m == "constructor" && (s || !Lr.call(o, m)) || d.push(m);
        return d;
      }
      function Ym(o, s) {
        return o < s;
      }
      function y5(o, s) {
        var d = -1, m = Gn(o) ? K(o.length) : [];
        return ls(o, function(w, E, R) {
          m[++d] = s(w, E, R);
        }), m;
      }
      function S5(o) {
        var s = lb(o);
        return s.length == 1 && s[0][2] ? eT(s[0][0], s[0][1]) : function(d) {
          return d === o || Hm(d, o, s);
        };
      }
      function x5(o, s) {
        return cb(o) && J5(s) ? eT(Lo(o), s) : function(d) {
          var m = Sb(d, o);
          return m === t && m === s ? xb(d, o) : Zc(s, m, S | x);
        };
      }
      function Tv(o, s, d, m, w) {
        o !== s && Bm(s, function(E, R) {
          if (w || (w = new ro()), St(E))
            r9(o, s, R, d, Tv, m, w);
          else {
            var D = m ? m(fb(o, R), E, R + "", o, s, w) : t;
            D === t && (D = E), Fm(o, R, D);
          }
        }, Yn);
      }
      function r9(o, s, d, m, w, E, R) {
        var D = fb(o, d), V = fb(s, d), J = R.get(V);
        if (J) {
          Fm(o, d, J);
          return;
        }
        var ee = E ? E(D, V, d + "", o, s, R) : t, le = ee === t;
        if (le) {
          var xe = Je(V), ke = !xe && fs(V), Ve = !xe && !ke && Au(V);
          ee = V, xe || ke || Ve ? Je(D) ? ee = D : Et(D) ? ee = Hn(D) : ke ? (le = !1, ee = P5(V, !0)) : Ve ? (le = !1, ee = k5(V, !0)) : ee = [] : rd(V) || $l(V) ? (ee = D, $l(D) ? ee = OT(D) : (!St(D) || xi(D)) && (ee = X5(V))) : le = !1;
        }
        le && (R.set(V, ee), w(ee, V, m, E, R), R.delete(V)), Fm(o, d, ee);
      }
      function $5(o, s) {
        var d = o.length;
        if (d)
          return s += s < 0 ? d : 0, Si(s, d) ? o[s] : t;
      }
      function w5(o, s, d) {
        s.length ? s = ft(s, function(E) {
          return Je(E) ? function(R) {
            return yl(R, E.length === 1 ? E[0] : E);
          } : E;
        }) : s = [Kn];
        var m = -1;
        s = ft(s, ia(Ue()));
        var w = y5(o, function(E, R, D) {
          var V = ft(s, function(J) {
            return J(E);
          });
          return { criteria: V, index: ++m, value: E };
        });
        return AN(w, function(E, R) {
          return h9(E, R, d);
        });
      }
      function t9(o, s) {
        return _5(o, s, function(d, m) {
          return xb(o, m);
        });
      }
      function _5(o, s, d) {
        for (var m = -1, w = s.length, E = {}; ++m < w; ) {
          var R = s[m], D = yl(o, R);
          d(D, R) && Qc(E, cs(R, o), D);
        }
        return E;
      }
      function n9(o) {
        return function(s) {
          return yl(s, o);
        };
      }
      function Km(o, s, d, m) {
        var w = m ? EN : mu, E = -1, R = s.length, D = o;
        for (o === s && (s = Hn(s)), d && (D = ft(o, ia(d))); ++E < R; )
          for (var V = 0, J = s[E], ee = d ? d(J) : J; (V = w(D, ee, V, m)) > -1; )
            D !== o && pv.call(D, V, 1), pv.call(o, V, 1);
        return o;
      }
      function T5(o, s) {
        for (var d = o ? s.length : 0, m = d - 1; d--; ) {
          var w = s[d];
          if (d == m || w !== E) {
            var E = w;
            Si(w) ? pv.call(o, w, 1) : Xm(o, w);
          }
        }
        return o;
      }
      function qm(o, s) {
        return o + bv(o5() * (s - o + 1));
      }
      function a9(o, s, d, m) {
        for (var w = -1, E = zt(mv((s - o) / (d || 1)), 0), R = K(E); E--; )
          R[m ? E : ++w] = o, o += d;
        return R;
      }
      function Zm(o, s) {
        var d = "";
        if (!o || s < 1 || s > ue)
          return d;
        do
          s % 2 && (d += o), s = bv(s / 2), s && (o += o);
        while (s);
        return d;
      }
      function sr(o, s) {
        return vb(rT(o, s, Kn), o + "");
      }
      function o9(o) {
        return l5(Iu(o));
      }
      function i9(o, s) {
        var d = Iu(o);
        return jv(d, bl(s, 0, d.length));
      }
      function Qc(o, s, d, m) {
        if (!St(o))
          return o;
        s = cs(s, o);
        for (var w = -1, E = s.length, R = E - 1, D = o; D != null && ++w < E; ) {
          var V = Lo(s[w]), J = d;
          if (V === "__proto__" || V === "constructor" || V === "prototype")
            return o;
          if (w != R) {
            var ee = D[V];
            J = m ? m(ee, V, D) : t, J === t && (J = St(ee) ? ee : Si(s[w + 1]) ? [] : {});
          }
          Yc(D, V, J), D = D[V];
        }
        return o;
      }
      var C5 = yv ? function(o, s) {
        return yv.set(o, s), o;
      } : Kn, s9 = gv ? function(o, s) {
        return gv(o, "toString", {
          configurable: !0,
          enumerable: !1,
          value: wb(s),
          writable: !0
        });
      } : Kn;
      function l9(o) {
        return jv(Iu(o));
      }
      function Ra(o, s, d) {
        var m = -1, w = o.length;
        s < 0 && (s = -s > w ? 0 : w + s), d = d > w ? w : d, d < 0 && (d += w), w = s > d ? 0 : d - s >>> 0, s >>>= 0;
        for (var E = K(w); ++m < w; )
          E[m] = o[m + s];
        return E;
      }
      function u9(o, s) {
        var d;
        return ls(o, function(m, w, E) {
          return d = s(m, w, E), !d;
        }), !!d;
      }
      function Cv(o, s, d) {
        var m = 0, w = o == null ? m : o.length;
        if (typeof s == "number" && s === s && w <= Z) {
          for (; m < w; ) {
            var E = m + w >>> 1, R = o[E];
            R !== null && !la(R) && (d ? R <= s : R < s) ? m = E + 1 : w = E;
          }
          return w;
        }
        return Qm(o, s, Kn, d);
      }
      function Qm(o, s, d, m) {
        var w = 0, E = o == null ? 0 : o.length;
        if (E === 0)
          return 0;
        s = d(s);
        for (var R = s !== s, D = s === null, V = la(s), J = s === t; w < E; ) {
          var ee = bv((w + E) / 2), le = d(o[ee]), xe = le !== t, ke = le === null, Ve = le === le, ir = la(le);
          if (R)
            var We = m || Ve;
          else
            J ? We = Ve && (m || xe) : D ? We = Ve && xe && (m || !ke) : V ? We = Ve && xe && !ke && (m || !ir) : ke || ir ? We = !1 : We = m ? le <= s : le < s;
          We ? w = ee + 1 : E = ee;
        }
        return yn(E, Me);
      }
      function E5(o, s) {
        for (var d = -1, m = o.length, w = 0, E = []; ++d < m; ) {
          var R = o[d], D = s ? s(R) : R;
          if (!d || !to(D, V)) {
            var V = D;
            E[w++] = R === 0 ? 0 : R;
          }
        }
        return E;
      }
      function A5(o) {
        return typeof o == "number" ? o : la(o) ? _e : +o;
      }
      function sa(o) {
        if (typeof o == "string")
          return o;
        if (Je(o))
          return ft(o, sa) + "";
        if (la(o))
          return i5 ? i5.call(o) : "";
        var s = o + "";
        return s == "0" && 1 / o == -Be ? "-0" : s;
      }
      function us(o, s, d) {
        var m = -1, w = ov, E = o.length, R = !0, D = [], V = D;
        if (d)
          R = !1, w = Cm;
        else if (E >= a) {
          var J = s ? null : S9(o);
          if (J)
            return sv(J);
          R = !1, w = Bc, V = new ml();
        } else
          V = s ? [] : D;
        e:
          for (; ++m < E; ) {
            var ee = o[m], le = s ? s(ee) : ee;
            if (ee = d || ee !== 0 ? ee : 0, R && le === le) {
              for (var xe = V.length; xe--; )
                if (V[xe] === le)
                  continue e;
              s && V.push(le), D.push(ee);
            } else
              w(V, le, d) || (V !== D && V.push(le), D.push(ee));
          }
        return D;
      }
      function Xm(o, s) {
        return s = cs(s, o), o = tT(o, s), o == null || delete o[Lo(Pa(s))];
      }
      function I5(o, s, d, m) {
        return Qc(o, s, d(yl(o, s)), m);
      }
      function Ev(o, s, d, m) {
        for (var w = o.length, E = m ? w : -1; (m ? E-- : ++E < w) && s(o[E], E, o); )
          ;
        return d ? Ra(o, m ? 0 : E, m ? E + 1 : w) : Ra(o, m ? E + 1 : 0, m ? w : E);
      }
      function O5(o, s) {
        var d = o;
        return d instanceof vr && (d = d.value()), Em(s, function(m, w) {
          return w.func.apply(w.thisArg, os([m], w.args));
        }, d);
      }
      function Jm(o, s, d) {
        var m = o.length;
        if (m < 2)
          return m ? us(o[0]) : [];
        for (var w = -1, E = K(m); ++w < m; )
          for (var R = o[w], D = -1; ++D < m; )
            D != w && (E[w] = Kc(E[w] || R, o[D], s, d));
        return us(rn(E, 1), s, d);
      }
      function M5(o, s, d) {
        for (var m = -1, w = o.length, E = s.length, R = {}; ++m < w; ) {
          var D = m < E ? s[m] : t;
          d(R, o[m], D);
        }
        return R;
      }
      function eb(o) {
        return Et(o) ? o : [];
      }
      function rb(o) {
        return typeof o == "function" ? o : Kn;
      }
      function cs(o, s) {
        return Je(o) ? o : cb(o, s) ? [o] : iT(kr(o));
      }
      var c9 = sr;
      function ds(o, s, d) {
        var m = o.length;
        return d = d === t ? m : d, !s && d >= m ? o : Ra(o, s, d);
      }
      var R5 = QN || function(o) {
        return ce.clearTimeout(o);
      };
      function P5(o, s) {
        if (s)
          return o.slice();
        var d = o.length, m = e5 ? e5(d) : new o.constructor(d);
        return o.copy(m), m;
      }
      function tb(o) {
        var s = new o.constructor(o.byteLength);
        return new vv(s).set(new vv(o)), s;
      }
      function d9(o, s) {
        var d = s ? tb(o.buffer) : o.buffer;
        return new o.constructor(d, o.byteOffset, o.byteLength);
      }
      function f9(o) {
        var s = new o.constructor(o.source, yt.exec(o));
        return s.lastIndex = o.lastIndex, s;
      }
      function v9(o) {
        return Gc ? Jr(Gc.call(o)) : {};
      }
      function k5(o, s) {
        var d = s ? tb(o.buffer) : o.buffer;
        return new o.constructor(d, o.byteOffset, o.length);
      }
      function j5(o, s) {
        if (o !== s) {
          var d = o !== t, m = o === null, w = o === o, E = la(o), R = s !== t, D = s === null, V = s === s, J = la(s);
          if (!D && !J && !E && o > s || E && R && V && !D && !J || m && R && V || !d && V || !w)
            return 1;
          if (!m && !E && !J && o < s || J && d && w && !m && !E || D && d && w || !R && w || !V)
            return -1;
        }
        return 0;
      }
      function h9(o, s, d) {
        for (var m = -1, w = o.criteria, E = s.criteria, R = w.length, D = d.length; ++m < R; ) {
          var V = j5(w[m], E[m]);
          if (V) {
            if (m >= D)
              return V;
            var J = d[m];
            return V * (J == "desc" ? -1 : 1);
          }
        }
        return o.index - s.index;
      }
      function D5(o, s, d, m) {
        for (var w = -1, E = o.length, R = d.length, D = -1, V = s.length, J = zt(E - R, 0), ee = K(V + J), le = !m; ++D < V; )
          ee[D] = s[D];
        for (; ++w < R; )
          (le || w < E) && (ee[d[w]] = o[w]);
        for (; J--; )
          ee[D++] = o[w++];
        return ee;
      }
      function N5(o, s, d, m) {
        for (var w = -1, E = o.length, R = -1, D = d.length, V = -1, J = s.length, ee = zt(E - D, 0), le = K(ee + J), xe = !m; ++w < ee; )
          le[w] = o[w];
        for (var ke = w; ++V < J; )
          le[ke + V] = s[V];
        for (; ++R < D; )
          (xe || w < E) && (le[ke + d[R]] = o[w++]);
        return le;
      }
      function Hn(o, s) {
        var d = -1, m = o.length;
        for (s || (s = K(m)); ++d < m; )
          s[d] = o[d];
        return s;
      }
      function No(o, s, d, m) {
        var w = !d;
        d || (d = {});
        for (var E = -1, R = s.length; ++E < R; ) {
          var D = s[E], V = m ? m(d[D], o[D], D, d, o) : t;
          V === t && (V = o[D]), w ? mi(d, D, V) : Yc(d, D, V);
        }
        return d;
      }
      function p9(o, s) {
        return No(o, ub(o), s);
      }
      function g9(o, s) {
        return No(o, Z5(o), s);
      }
      function Av(o, s) {
        return function(d, m) {
          var w = Je(d) ? xN : LL, E = s ? s() : {};
          return w(d, o, Ue(m, 2), E);
        };
      }
      function Tu(o) {
        return sr(function(s, d) {
          var m = -1, w = d.length, E = w > 1 ? d[w - 1] : t, R = w > 2 ? d[2] : t;
          for (E = o.length > 3 && typeof E == "function" ? (w--, E) : t, R && In(d[0], d[1], R) && (E = w < 3 ? t : E, w = 1), s = Jr(s); ++m < w; ) {
            var D = d[m];
            D && o(s, D, m, E);
          }
          return s;
        });
      }
      function L5(o, s) {
        return function(d, m) {
          if (d == null)
            return d;
          if (!Gn(d))
            return o(d, m);
          for (var w = d.length, E = s ? w : -1, R = Jr(d); (s ? E-- : ++E < w) && m(R[E], E, R) !== !1; )
            ;
          return d;
        };
      }
      function F5(o) {
        return function(s, d, m) {
          for (var w = -1, E = Jr(s), R = m(s), D = R.length; D--; ) {
            var V = R[o ? D : ++w];
            if (d(E[V], V, E) === !1)
              break;
          }
          return s;
        };
      }
      function m9(o, s, d) {
        var m = s & T, w = Xc(o);
        function E() {
          var R = this && this !== ce && this instanceof E ? w : o;
          return R.apply(m ? d : this, arguments);
        }
        return E;
      }
      function z5(o) {
        return function(s) {
          s = kr(s);
          var d = bu(s) ? eo(s) : t, m = d ? d[0] : s.charAt(0), w = d ? ds(d, 1).join("") : s.slice(1);
          return m[o]() + w;
        };
      }
      function Cu(o) {
        return function(s) {
          return Em(LT(NT(s).replace(aa, "")), o, "");
        };
      }
      function Xc(o) {
        return function() {
          var s = arguments;
          switch (s.length) {
            case 0:
              return new o();
            case 1:
              return new o(s[0]);
            case 2:
              return new o(s[0], s[1]);
            case 3:
              return new o(s[0], s[1], s[2]);
            case 4:
              return new o(s[0], s[1], s[2], s[3]);
            case 5:
              return new o(s[0], s[1], s[2], s[3], s[4]);
            case 6:
              return new o(s[0], s[1], s[2], s[3], s[4], s[5]);
            case 7:
              return new o(s[0], s[1], s[2], s[3], s[4], s[5], s[6]);
          }
          var d = _u(o.prototype), m = o.apply(d, s);
          return St(m) ? m : d;
        };
      }
      function b9(o, s, d) {
        var m = Xc(o);
        function w() {
          for (var E = arguments.length, R = K(E), D = E, V = Eu(w); D--; )
            R[D] = arguments[D];
          var J = E < 3 && R[0] !== V && R[E - 1] !== V ? [] : is(R, V);
          if (E -= J.length, E < d)
            return H5(
              o,
              s,
              Iv,
              w.placeholder,
              t,
              R,
              J,
              t,
              t,
              d - E
            );
          var ee = this && this !== ce && this instanceof w ? m : o;
          return oa(ee, this, R);
        }
        return w;
      }
      function B5(o) {
        return function(s, d, m) {
          var w = Jr(s);
          if (!Gn(s)) {
            var E = Ue(d, 3);
            s = Gt(s), d = function(D) {
              return E(w[D], D, w);
            };
          }
          var R = o(s, d, m);
          return R > -1 ? w[E ? s[R] : R] : t;
        };
      }
      function U5(o) {
        return yi(function(s) {
          var d = s.length, m = d, w = Oa.prototype.thru;
          for (o && s.reverse(); m--; ) {
            var E = s[m];
            if (typeof E != "function")
              throw new Ia(l);
            if (w && !R && Pv(E) == "wrapper")
              var R = new Oa([], !0);
          }
          for (m = R ? m : d; ++m < d; ) {
            E = s[m];
            var D = Pv(E), V = D == "wrapper" ? sb(E) : t;
            V && db(V[0]) && V[1] == (M | P | k | W) && !V[4].length && V[9] == 1 ? R = R[Pv(V[0])].apply(R, V[3]) : R = E.length == 1 && db(E) ? R[D]() : R.thru(E);
          }
          return function() {
            var J = arguments, ee = J[0];
            if (R && J.length == 1 && Je(ee))
              return R.plant(ee).value();
            for (var le = 0, xe = d ? s[le].apply(this, J) : ee; ++le < d; )
              xe = s[le].call(this, xe);
            return xe;
          };
        });
      }
      function Iv(o, s, d, m, w, E, R, D, V, J) {
        var ee = s & M, le = s & T, xe = s & A, ke = s & (P | j), Ve = s & q, ir = xe ? t : Xc(o);
        function We() {
          for (var dr = arguments.length, pr = K(dr), ua = dr; ua--; )
            pr[ua] = arguments[ua];
          if (ke)
            var On = Eu(We), ca = ON(pr, On);
          if (m && (pr = D5(pr, m, w, ke)), E && (pr = N5(pr, E, R, ke)), dr -= ca, ke && dr < J) {
            var At = is(pr, On);
            return H5(
              o,
              s,
              Iv,
              We.placeholder,
              d,
              pr,
              At,
              D,
              V,
              J - dr
            );
          }
          var no = le ? d : this, wi = xe ? no[o] : o;
          return dr = pr.length, D ? pr = L9(pr, D) : Ve && dr > 1 && pr.reverse(), ee && V < dr && (pr.length = V), this && this !== ce && this instanceof We && (wi = ir || Xc(wi)), wi.apply(no, pr);
        }
        return We;
      }
      function V5(o, s) {
        return function(d, m) {
          return GL(d, o, s(m), {});
        };
      }
      function Ov(o, s) {
        return function(d, m) {
          var w;
          if (d === t && m === t)
            return s;
          if (d !== t && (w = d), m !== t) {
            if (w === t)
              return m;
            typeof d == "string" || typeof m == "string" ? (d = sa(d), m = sa(m)) : (d = A5(d), m = A5(m)), w = o(d, m);
          }
          return w;
        };
      }
      function nb(o) {
        return yi(function(s) {
          return s = ft(s, ia(Ue())), sr(function(d) {
            var m = this;
            return o(s, function(w) {
              return oa(w, m, d);
            });
          });
        });
      }
      function Mv(o, s) {
        s = s === t ? " " : sa(s);
        var d = s.length;
        if (d < 2)
          return d ? Zm(s, o) : s;
        var m = Zm(s, mv(o / yu(s)));
        return bu(s) ? ds(eo(m), 0, o).join("") : m.slice(0, o);
      }
      function y9(o, s, d, m) {
        var w = s & T, E = Xc(o);
        function R() {
          for (var D = -1, V = arguments.length, J = -1, ee = m.length, le = K(ee + V), xe = this && this !== ce && this instanceof R ? E : o; ++J < ee; )
            le[J] = m[J];
          for (; V--; )
            le[J++] = arguments[++D];
          return oa(xe, w ? d : this, le);
        }
        return R;
      }
      function W5(o) {
        return function(s, d, m) {
          return m && typeof m != "number" && In(s, d, m) && (d = m = t), s = $i(s), d === t ? (d = s, s = 0) : d = $i(d), m = m === t ? s < d ? 1 : -1 : $i(m), a9(s, d, m, o);
        };
      }
      function Rv(o) {
        return function(s, d) {
          return typeof s == "string" && typeof d == "string" || (s = ka(s), d = ka(d)), o(s, d);
        };
      }
      function H5(o, s, d, m, w, E, R, D, V, J) {
        var ee = s & P, le = ee ? R : t, xe = ee ? t : R, ke = ee ? E : t, Ve = ee ? t : E;
        s |= ee ? k : L, s &= ~(ee ? L : k), s & O || (s &= ~(T | A));
        var ir = [
          o,
          s,
          w,
          ke,
          le,
          Ve,
          xe,
          D,
          V,
          J
        ], We = d.apply(t, ir);
        return db(o) && nT(We, ir), We.placeholder = m, aT(We, o, s);
      }
      function ab(o) {
        var s = Ft[o];
        return function(d, m) {
          if (d = ka(d), m = m == null ? 0 : yn(or(m), 292), m && a5(d)) {
            var w = (kr(d) + "e").split("e"), E = s(w[0] + "e" + (+w[1] + m));
            return w = (kr(E) + "e").split("e"), +(w[0] + "e" + (+w[1] - m));
          }
          return s(d);
        };
      }
      var S9 = $u && 1 / sv(new $u([, -0]))[1] == Be ? function(o) {
        return new $u(o);
      } : Cb;
      function G5(o) {
        return function(s) {
          var d = Sn(s);
          return d == yr ? km(s) : d == Sr ? NN(s) : IN(s, o(s));
        };
      }
      function bi(o, s, d, m, w, E, R, D) {
        var V = s & A;
        if (!V && typeof o != "function")
          throw new Ia(l);
        var J = m ? m.length : 0;
        if (J || (s &= ~(k | L), m = w = t), R = R === t ? R : zt(or(R), 0), D = D === t ? D : or(D), J -= w ? w.length : 0, s & L) {
          var ee = m, le = w;
          m = w = t;
        }
        var xe = V ? t : sb(o), ke = [
          o,
          s,
          d,
          m,
          w,
          ee,
          le,
          E,
          R,
          D
        ];
        if (xe && j9(ke, xe), o = ke[0], s = ke[1], d = ke[2], m = ke[3], w = ke[4], D = ke[9] = ke[9] === t ? V ? 0 : o.length : zt(ke[9] - J, 0), !D && s & (P | j) && (s &= ~(P | j)), !s || s == T)
          var Ve = m9(o, s, d);
        else
          s == P || s == j ? Ve = b9(o, s, D) : (s == k || s == (T | k)) && !w.length ? Ve = y9(o, s, d, m) : Ve = Iv.apply(t, ke);
        var ir = xe ? C5 : nT;
        return aT(ir(Ve, ke), o, s);
      }
      function Y5(o, s, d, m) {
        return o === t || to(o, xu[d]) && !Lr.call(m, d) ? s : o;
      }
      function K5(o, s, d, m, w, E) {
        return St(o) && St(s) && (E.set(s, o), Tv(o, s, t, K5, E), E.delete(s)), o;
      }
      function x9(o) {
        return rd(o) ? t : o;
      }
      function q5(o, s, d, m, w, E) {
        var R = d & S, D = o.length, V = s.length;
        if (D != V && !(R && V > D))
          return !1;
        var J = E.get(o), ee = E.get(s);
        if (J && ee)
          return J == s && ee == o;
        var le = -1, xe = !0, ke = d & x ? new ml() : t;
        for (E.set(o, s), E.set(s, o); ++le < D; ) {
          var Ve = o[le], ir = s[le];
          if (m)
            var We = R ? m(ir, Ve, le, s, o, E) : m(Ve, ir, le, o, s, E);
          if (We !== t) {
            if (We)
              continue;
            xe = !1;
            break;
          }
          if (ke) {
            if (!Am(s, function(dr, pr) {
              if (!Bc(ke, pr) && (Ve === dr || w(Ve, dr, d, m, E)))
                return ke.push(pr);
            })) {
              xe = !1;
              break;
            }
          } else if (!(Ve === ir || w(Ve, ir, d, m, E))) {
            xe = !1;
            break;
          }
        }
        return E.delete(o), E.delete(s), xe;
      }
      function $9(o, s, d, m, w, E, R) {
        switch (d) {
          case Re:
            if (o.byteLength != s.byteLength || o.byteOffset != s.byteOffset)
              return !1;
            o = o.buffer, s = s.buffer;
          case be:
            return !(o.byteLength != s.byteLength || !E(new vv(o), new vv(s)));
          case ve:
          case rr:
          case at:
            return to(+o, +s);
          case ur:
            return o.name == s.name && o.message == s.message;
          case gr:
          case G:
            return o == s + "";
          case yr:
            var D = km;
          case Sr:
            var V = m & S;
            if (D || (D = sv), o.size != s.size && !V)
              return !1;
            var J = R.get(o);
            if (J)
              return J == s;
            m |= x, R.set(o, s);
            var ee = q5(D(o), D(s), m, w, E, R);
            return R.delete(o), ee;
          case ne:
            if (Gc)
              return Gc.call(o) == Gc.call(s);
        }
        return !1;
      }
      function w9(o, s, d, m, w, E) {
        var R = d & S, D = ob(o), V = D.length, J = ob(s), ee = J.length;
        if (V != ee && !R)
          return !1;
        for (var le = V; le--; ) {
          var xe = D[le];
          if (!(R ? xe in s : Lr.call(s, xe)))
            return !1;
        }
        var ke = E.get(o), Ve = E.get(s);
        if (ke && Ve)
          return ke == s && Ve == o;
        var ir = !0;
        E.set(o, s), E.set(s, o);
        for (var We = R; ++le < V; ) {
          xe = D[le];
          var dr = o[xe], pr = s[xe];
          if (m)
            var ua = R ? m(pr, dr, xe, s, o, E) : m(dr, pr, xe, o, s, E);
          if (!(ua === t ? dr === pr || w(dr, pr, d, m, E) : ua)) {
            ir = !1;
            break;
          }
          We || (We = xe == "constructor");
        }
        if (ir && !We) {
          var On = o.constructor, ca = s.constructor;
          On != ca && "constructor" in o && "constructor" in s && !(typeof On == "function" && On instanceof On && typeof ca == "function" && ca instanceof ca) && (ir = !1);
        }
        return E.delete(o), E.delete(s), ir;
      }
      function yi(o) {
        return vb(rT(o, t, cT), o + "");
      }
      function ob(o) {
        return p5(o, Gt, ub);
      }
      function ib(o) {
        return p5(o, Yn, Z5);
      }
      var sb = yv ? function(o) {
        return yv.get(o);
      } : Cb;
      function Pv(o) {
        for (var s = o.name + "", d = wu[s], m = Lr.call(wu, s) ? d.length : 0; m--; ) {
          var w = d[m], E = w.func;
          if (E == null || E == o)
            return w.name;
        }
        return s;
      }
      function Eu(o) {
        var s = Lr.call(C, "placeholder") ? C : o;
        return s.placeholder;
      }
      function Ue() {
        var o = C.iteratee || _b;
        return o = o === _b ? b5 : o, arguments.length ? o(arguments[0], arguments[1]) : o;
      }
      function kv(o, s) {
        var d = o.__data__;
        return M9(s) ? d[typeof s == "string" ? "string" : "hash"] : d.map;
      }
      function lb(o) {
        for (var s = Gt(o), d = s.length; d--; ) {
          var m = s[d], w = o[m];
          s[d] = [m, w, J5(w)];
        }
        return s;
      }
      function Sl(o, s) {
        var d = kN(o, s);
        return m5(d) ? d : t;
      }
      function _9(o) {
        var s = Lr.call(o, pl), d = o[pl];
        try {
          o[pl] = t;
          var m = !0;
        } catch (E) {
        }
        var w = dv.call(o);
        return m && (s ? o[pl] = d : delete o[pl]), w;
      }
      var ub = Dm ? function(o) {
        return o == null ? [] : (o = Jr(o), as(Dm(o), function(s) {
          return t5.call(o, s);
        }));
      } : Eb, Z5 = Dm ? function(o) {
        for (var s = []; o; )
          os(s, ub(o)), o = hv(o);
        return s;
      } : Eb, Sn = An;
      (Nm && Sn(new Nm(new ArrayBuffer(1))) != Re || Vc && Sn(new Vc()) != yr || Lm && Sn(Lm.resolve()) != jt || $u && Sn(new $u()) != Sr || Wc && Sn(new Wc()) != Q) && (Sn = function(o) {
        var s = An(o), d = s == Nr ? o.constructor : t, m = d ? xl(d) : "";
        if (m)
          switch (m) {
            case iL:
              return Re;
            case sL:
              return yr;
            case lL:
              return jt;
            case uL:
              return Sr;
            case cL:
              return Q;
          }
        return s;
      });
      function T9(o, s, d) {
        for (var m = -1, w = d.length; ++m < w; ) {
          var E = d[m], R = E.size;
          switch (E.type) {
            case "drop":
              o += R;
              break;
            case "dropRight":
              s -= R;
              break;
            case "take":
              s = yn(s, o + R);
              break;
            case "takeRight":
              o = zt(o, s - R);
              break;
          }
        }
        return { start: o, end: s };
      }
      function C9(o) {
        var s = o.match(Rr);
        return s ? s[1].split(Qa) : [];
      }
      function Q5(o, s, d) {
        s = cs(s, o);
        for (var m = -1, w = s.length, E = !1; ++m < w; ) {
          var R = Lo(s[m]);
          if (!(E = o != null && d(o, R)))
            break;
          o = o[R];
        }
        return E || ++m != w ? E : (w = o == null ? 0 : o.length, !!w && Bv(w) && Si(R, w) && (Je(o) || $l(o)));
      }
      function E9(o) {
        var s = o.length, d = new o.constructor(s);
        return s && typeof o[0] == "string" && Lr.call(o, "index") && (d.index = o.index, d.input = o.input), d;
      }
      function X5(o) {
        return typeof o.constructor == "function" && !Jc(o) ? _u(hv(o)) : {};
      }
      function A9(o, s, d) {
        var m = o.constructor;
        switch (s) {
          case be:
            return tb(o);
          case ve:
          case rr:
            return new m(+o);
          case Re:
            return d9(o, d);
          case cr:
          case wr:
          case lr:
          case dt:
          case ot:
          case bt:
          case Ct:
          case fr:
          case Qr:
            return k5(o, d);
          case yr:
            return new m();
          case at:
          case G:
            return new m(o);
          case gr:
            return f9(o);
          case Sr:
            return new m();
          case ne:
            return v9(o);
        }
      }
      function I9(o, s) {
        var d = s.length;
        if (!d)
          return o;
        var m = d - 1;
        return s[m] = (d > 1 ? "& " : "") + s[m], s = s.join(d > 2 ? ", " : " "), o.replace(en, `{
/* [wrapped with ` + s + `] */
`);
      }
      function O9(o) {
        return Je(o) || $l(o) || !!(n5 && o && o[n5]);
      }
      function Si(o, s) {
        var d = typeof o;
        return s = s == null ? ue : s, !!s && (d == "number" || d != "symbol" && tl.test(o)) && o > -1 && o % 1 == 0 && o < s;
      }
      function In(o, s, d) {
        if (!St(d))
          return !1;
        var m = typeof s;
        return (m == "number" ? Gn(d) && Si(s, d.length) : m == "string" && s in d) ? to(d[s], o) : !1;
      }
      function cb(o, s) {
        if (Je(o))
          return !1;
        var d = typeof o;
        return d == "number" || d == "symbol" || d == "boolean" || o == null || la(o) ? !0 : Ce.test(o) || !Se.test(o) || s != null && o in Jr(s);
      }
      function M9(o) {
        var s = typeof o;
        return s == "string" || s == "number" || s == "symbol" || s == "boolean" ? o !== "__proto__" : o === null;
      }
      function db(o) {
        var s = Pv(o), d = C[s];
        if (typeof d != "function" || !(s in vr.prototype))
          return !1;
        if (o === d)
          return !0;
        var m = sb(d);
        return !!m && o === m[0];
      }
      function R9(o) {
        return !!J_ && J_ in o;
      }
      var P9 = uv ? xi : Ab;
      function Jc(o) {
        var s = o && o.constructor, d = typeof s == "function" && s.prototype || xu;
        return o === d;
      }
      function J5(o) {
        return o === o && !St(o);
      }
      function eT(o, s) {
        return function(d) {
          return d == null ? !1 : d[o] === s && (s !== t || o in Jr(d));
        };
      }
      function k9(o) {
        var s = Fv(o, function(m) {
          return d.size === f && d.clear(), m;
        }), d = s.cache;
        return s;
      }
      function j9(o, s) {
        var d = o[1], m = s[1], w = d | m, E = w < (T | A | M), R = m == M && d == P || m == M && d == W && o[7].length <= s[8] || m == (M | W) && s[7].length <= s[8] && d == P;
        if (!(E || R))
          return o;
        m & T && (o[2] = s[2], w |= d & T ? 0 : O);
        var D = s[3];
        if (D) {
          var V = o[3];
          o[3] = V ? D5(V, D, s[4]) : D, o[4] = V ? is(o[3], h) : s[4];
        }
        return D = s[5], D && (V = o[5], o[5] = V ? N5(V, D, s[6]) : D, o[6] = V ? is(o[5], h) : s[6]), D = s[7], D && (o[7] = D), m & M && (o[8] = o[8] == null ? s[8] : yn(o[8], s[8])), o[9] == null && (o[9] = s[9]), o[0] = s[0], o[1] = w, o;
      }
      function D9(o) {
        var s = [];
        if (o != null)
          for (var d in Jr(o))
            s.push(d);
        return s;
      }
      function N9(o) {
        return dv.call(o);
      }
      function rT(o, s, d) {
        return s = zt(s === t ? o.length - 1 : s, 0), function() {
          for (var m = arguments, w = -1, E = zt(m.length - s, 0), R = K(E); ++w < E; )
            R[w] = m[s + w];
          w = -1;
          for (var D = K(s + 1); ++w < s; )
            D[w] = m[w];
          return D[s] = d(R), oa(o, this, D);
        };
      }
      function tT(o, s) {
        return s.length < 2 ? o : yl(o, Ra(s, 0, -1));
      }
      function L9(o, s) {
        for (var d = o.length, m = yn(s.length, d), w = Hn(o); m--; ) {
          var E = s[m];
          o[m] = Si(E, d) ? w[E] : t;
        }
        return o;
      }
      function fb(o, s) {
        if (!(s === "constructor" && typeof o[s] == "function") && s != "__proto__")
          return o[s];
      }
      var nT = oT(C5), ed = JN || function(o, s) {
        return ce.setTimeout(o, s);
      }, vb = oT(s9);
      function aT(o, s, d) {
        var m = s + "";
        return vb(o, I9(m, F9(C9(m), d)));
      }
      function oT(o) {
        var s = 0, d = 0;
        return function() {
          var m = nL(), w = $e - (m - d);
          if (d = m, w > 0) {
            if (++s >= Te)
              return arguments[0];
          } else
            s = 0;
          return o.apply(t, arguments);
        };
      }
      function jv(o, s) {
        var d = -1, m = o.length, w = m - 1;
        for (s = s === t ? m : s; ++d < s; ) {
          var E = qm(d, w), R = o[E];
          o[E] = o[d], o[d] = R;
        }
        return o.length = s, o;
      }
      var iT = k9(function(o) {
        var s = [];
        return o.charCodeAt(0) === 46 && s.push(""), o.replace(ye, function(d, m, w, E) {
          s.push(w ? E.replace(Zs, "$1") : m || d);
        }), s;
      });
      function Lo(o) {
        if (typeof o == "string" || la(o))
          return o;
        var s = o + "";
        return s == "0" && 1 / o == -Be ? "-0" : s;
      }
      function xl(o) {
        if (o != null) {
          try {
            return cv.call(o);
          } catch (s) {
          }
          try {
            return o + "";
          } catch (s) {
          }
        }
        return "";
      }
      function F9(o, s) {
        return Aa(se, function(d) {
          var m = "_." + d[0];
          s & d[1] && !ov(o, m) && o.push(m);
        }), o.sort();
      }
      function sT(o) {
        if (o instanceof vr)
          return o.clone();
        var s = new Oa(o.__wrapped__, o.__chain__);
        return s.__actions__ = Hn(o.__actions__), s.__index__ = o.__index__, s.__values__ = o.__values__, s;
      }
      function z9(o, s, d) {
        (d ? In(o, s, d) : s === t) ? s = 1 : s = zt(or(s), 0);
        var m = o == null ? 0 : o.length;
        if (!m || s < 1)
          return [];
        for (var w = 0, E = 0, R = K(mv(m / s)); w < m; )
          R[E++] = Ra(o, w, w += s);
        return R;
      }
      function B9(o) {
        for (var s = -1, d = o == null ? 0 : o.length, m = 0, w = []; ++s < d; ) {
          var E = o[s];
          E && (w[m++] = E);
        }
        return w;
      }
      function U9() {
        var o = arguments.length;
        if (!o)
          return [];
        for (var s = K(o - 1), d = arguments[0], m = o; m--; )
          s[m - 1] = arguments[m];
        return os(Je(d) ? Hn(d) : [d], rn(s, 1));
      }
      var V9 = sr(function(o, s) {
        return Et(o) ? Kc(o, rn(s, 1, Et, !0)) : [];
      }), W9 = sr(function(o, s) {
        var d = Pa(s);
        return Et(d) && (d = t), Et(o) ? Kc(o, rn(s, 1, Et, !0), Ue(d, 2)) : [];
      }), H9 = sr(function(o, s) {
        var d = Pa(s);
        return Et(d) && (d = t), Et(o) ? Kc(o, rn(s, 1, Et, !0), t, d) : [];
      });
      function G9(o, s, d) {
        var m = o == null ? 0 : o.length;
        return m ? (s = d || s === t ? 1 : or(s), Ra(o, s < 0 ? 0 : s, m)) : [];
      }
      function Y9(o, s, d) {
        var m = o == null ? 0 : o.length;
        return m ? (s = d || s === t ? 1 : or(s), s = m - s, Ra(o, 0, s < 0 ? 0 : s)) : [];
      }
      function K9(o, s) {
        return o && o.length ? Ev(o, Ue(s, 3), !0, !0) : [];
      }
      function q9(o, s) {
        return o && o.length ? Ev(o, Ue(s, 3), !0) : [];
      }
      function Z9(o, s, d, m) {
        var w = o == null ? 0 : o.length;
        return w ? (d && typeof d != "number" && In(o, s, d) && (d = 0, m = w), UL(o, s, d, m)) : [];
      }
      function lT(o, s, d) {
        var m = o == null ? 0 : o.length;
        if (!m)
          return -1;
        var w = d == null ? 0 : or(d);
        return w < 0 && (w = zt(m + w, 0)), iv(o, Ue(s, 3), w);
      }
      function uT(o, s, d) {
        var m = o == null ? 0 : o.length;
        if (!m)
          return -1;
        var w = m - 1;
        return d !== t && (w = or(d), w = d < 0 ? zt(m + w, 0) : yn(w, m - 1)), iv(o, Ue(s, 3), w, !0);
      }
      function cT(o) {
        var s = o == null ? 0 : o.length;
        return s ? rn(o, 1) : [];
      }
      function Q9(o) {
        var s = o == null ? 0 : o.length;
        return s ? rn(o, Be) : [];
      }
      function X9(o, s) {
        var d = o == null ? 0 : o.length;
        return d ? (s = s === t ? 1 : or(s), rn(o, s)) : [];
      }
      function J9(o) {
        for (var s = -1, d = o == null ? 0 : o.length, m = {}; ++s < d; ) {
          var w = o[s];
          m[w[0]] = w[1];
        }
        return m;
      }
      function dT(o) {
        return o && o.length ? o[0] : t;
      }
      function eF(o, s, d) {
        var m = o == null ? 0 : o.length;
        if (!m)
          return -1;
        var w = d == null ? 0 : or(d);
        return w < 0 && (w = zt(m + w, 0)), mu(o, s, w);
      }
      function rF(o) {
        var s = o == null ? 0 : o.length;
        return s ? Ra(o, 0, -1) : [];
      }
      var tF = sr(function(o) {
        var s = ft(o, eb);
        return s.length && s[0] === o[0] ? Wm(s) : [];
      }), nF = sr(function(o) {
        var s = Pa(o), d = ft(o, eb);
        return s === Pa(d) ? s = t : d.pop(), d.length && d[0] === o[0] ? Wm(d, Ue(s, 2)) : [];
      }), aF = sr(function(o) {
        var s = Pa(o), d = ft(o, eb);
        return s = typeof s == "function" ? s : t, s && d.pop(), d.length && d[0] === o[0] ? Wm(d, t, s) : [];
      });
      function oF(o, s) {
        return o == null ? "" : rL.call(o, s);
      }
      function Pa(o) {
        var s = o == null ? 0 : o.length;
        return s ? o[s - 1] : t;
      }
      function iF(o, s, d) {
        var m = o == null ? 0 : o.length;
        if (!m)
          return -1;
        var w = m;
        return d !== t && (w = or(d), w = w < 0 ? zt(m + w, 0) : yn(w, m - 1)), s === s ? FN(o, s, w) : iv(o, H_, w, !0);
      }
      function sF(o, s) {
        return o && o.length ? $5(o, or(s)) : t;
      }
      var lF = sr(fT);
      function fT(o, s) {
        return o && o.length && s && s.length ? Km(o, s) : o;
      }
      function uF(o, s, d) {
        return o && o.length && s && s.length ? Km(o, s, Ue(d, 2)) : o;
      }
      function cF(o, s, d) {
        return o && o.length && s && s.length ? Km(o, s, t, d) : o;
      }
      var dF = yi(function(o, s) {
        var d = o == null ? 0 : o.length, m = zm(o, s);
        return T5(o, ft(s, function(w) {
          return Si(w, d) ? +w : w;
        }).sort(j5)), m;
      });
      function fF(o, s) {
        var d = [];
        if (!(o && o.length))
          return d;
        var m = -1, w = [], E = o.length;
        for (s = Ue(s, 3); ++m < E; ) {
          var R = o[m];
          s(R, m, o) && (d.push(R), w.push(m));
        }
        return T5(o, w), d;
      }
      function hb(o) {
        return o == null ? o : oL.call(o);
      }
      function vF(o, s, d) {
        var m = o == null ? 0 : o.length;
        return m ? (d && typeof d != "number" && In(o, s, d) ? (s = 0, d = m) : (s = s == null ? 0 : or(s), d = d === t ? m : or(d)), Ra(o, s, d)) : [];
      }
      function hF(o, s) {
        return Cv(o, s);
      }
      function pF(o, s, d) {
        return Qm(o, s, Ue(d, 2));
      }
      function gF(o, s) {
        var d = o == null ? 0 : o.length;
        if (d) {
          var m = Cv(o, s);
          if (m < d && to(o[m], s))
            return m;
        }
        return -1;
      }
      function mF(o, s) {
        return Cv(o, s, !0);
      }
      function bF(o, s, d) {
        return Qm(o, s, Ue(d, 2), !0);
      }
      function yF(o, s) {
        var d = o == null ? 0 : o.length;
        if (d) {
          var m = Cv(o, s, !0) - 1;
          if (to(o[m], s))
            return m;
        }
        return -1;
      }
      function SF(o) {
        return o && o.length ? E5(o) : [];
      }
      function xF(o, s) {
        return o && o.length ? E5(o, Ue(s, 2)) : [];
      }
      function $F(o) {
        var s = o == null ? 0 : o.length;
        return s ? Ra(o, 1, s) : [];
      }
      function wF(o, s, d) {
        return o && o.length ? (s = d || s === t ? 1 : or(s), Ra(o, 0, s < 0 ? 0 : s)) : [];
      }
      function _F(o, s, d) {
        var m = o == null ? 0 : o.length;
        return m ? (s = d || s === t ? 1 : or(s), s = m - s, Ra(o, s < 0 ? 0 : s, m)) : [];
      }
      function TF(o, s) {
        return o && o.length ? Ev(o, Ue(s, 3), !1, !0) : [];
      }
      function CF(o, s) {
        return o && o.length ? Ev(o, Ue(s, 3)) : [];
      }
      var EF = sr(function(o) {
        return us(rn(o, 1, Et, !0));
      }), AF = sr(function(o) {
        var s = Pa(o);
        return Et(s) && (s = t), us(rn(o, 1, Et, !0), Ue(s, 2));
      }), IF = sr(function(o) {
        var s = Pa(o);
        return s = typeof s == "function" ? s : t, us(rn(o, 1, Et, !0), t, s);
      });
      function OF(o) {
        return o && o.length ? us(o) : [];
      }
      function MF(o, s) {
        return o && o.length ? us(o, Ue(s, 2)) : [];
      }
      function RF(o, s) {
        return s = typeof s == "function" ? s : t, o && o.length ? us(o, t, s) : [];
      }
      function pb(o) {
        if (!(o && o.length))
          return [];
        var s = 0;
        return o = as(o, function(d) {
          if (Et(d))
            return s = zt(d.length, s), !0;
        }), Rm(s, function(d) {
          return ft(o, Im(d));
        });
      }
      function vT(o, s) {
        if (!(o && o.length))
          return [];
        var d = pb(o);
        return s == null ? d : ft(d, function(m) {
          return oa(s, t, m);
        });
      }
      var PF = sr(function(o, s) {
        return Et(o) ? Kc(o, s) : [];
      }), kF = sr(function(o) {
        return Jm(as(o, Et));
      }), jF = sr(function(o) {
        var s = Pa(o);
        return Et(s) && (s = t), Jm(as(o, Et), Ue(s, 2));
      }), DF = sr(function(o) {
        var s = Pa(o);
        return s = typeof s == "function" ? s : t, Jm(as(o, Et), t, s);
      }), NF = sr(pb);
      function LF(o, s) {
        return M5(o || [], s || [], Yc);
      }
      function FF(o, s) {
        return M5(o || [], s || [], Qc);
      }
      var zF = sr(function(o) {
        var s = o.length, d = s > 1 ? o[s - 1] : t;
        return d = typeof d == "function" ? (o.pop(), d) : t, vT(o, d);
      });
      function hT(o) {
        var s = C(o);
        return s.__chain__ = !0, s;
      }
      function BF(o, s) {
        return s(o), o;
      }
      function Dv(o, s) {
        return s(o);
      }
      var UF = yi(function(o) {
        var s = o.length, d = s ? o[0] : 0, m = this.__wrapped__, w = function(E) {
          return zm(E, o);
        };
        return s > 1 || this.__actions__.length || !(m instanceof vr) || !Si(d) ? this.thru(w) : (m = m.slice(d, +d + (s ? 1 : 0)), m.__actions__.push({
          func: Dv,
          args: [w],
          thisArg: t
        }), new Oa(m, this.__chain__).thru(function(E) {
          return s && !E.length && E.push(t), E;
        }));
      });
      function VF() {
        return hT(this);
      }
      function WF() {
        return new Oa(this.value(), this.__chain__);
      }
      function HF() {
        this.__values__ === t && (this.__values__ = AT(this.value()));
        var o = this.__index__ >= this.__values__.length, s = o ? t : this.__values__[this.__index__++];
        return { done: o, value: s };
      }
      function GF() {
        return this;
      }
      function YF(o) {
        for (var s, d = this; d instanceof xv; ) {
          var m = sT(d);
          m.__index__ = 0, m.__values__ = t, s ? w.__wrapped__ = m : s = m;
          var w = m;
          d = d.__wrapped__;
        }
        return w.__wrapped__ = o, s;
      }
      function KF() {
        var o = this.__wrapped__;
        if (o instanceof vr) {
          var s = o;
          return this.__actions__.length && (s = new vr(this)), s = s.reverse(), s.__actions__.push({
            func: Dv,
            args: [hb],
            thisArg: t
          }), new Oa(s, this.__chain__);
        }
        return this.thru(hb);
      }
      function qF() {
        return O5(this.__wrapped__, this.__actions__);
      }
      var ZF = Av(function(o, s, d) {
        Lr.call(o, d) ? ++o[d] : mi(o, d, 1);
      });
      function QF(o, s, d) {
        var m = Je(o) ? V_ : BL;
        return d && In(o, s, d) && (s = t), m(o, Ue(s, 3));
      }
      function XF(o, s) {
        var d = Je(o) ? as : v5;
        return d(o, Ue(s, 3));
      }
      var JF = B5(lT), e7 = B5(uT);
      function r7(o, s) {
        return rn(Nv(o, s), 1);
      }
      function t7(o, s) {
        return rn(Nv(o, s), Be);
      }
      function n7(o, s, d) {
        return d = d === t ? 1 : or(d), rn(Nv(o, s), d);
      }
      function pT(o, s) {
        var d = Je(o) ? Aa : ls;
        return d(o, Ue(s, 3));
      }
      function gT(o, s) {
        var d = Je(o) ? $N : f5;
        return d(o, Ue(s, 3));
      }
      var a7 = Av(function(o, s, d) {
        Lr.call(o, d) ? o[d].push(s) : mi(o, d, [s]);
      });
      function o7(o, s, d, m) {
        o = Gn(o) ? o : Iu(o), d = d && !m ? or(d) : 0;
        var w = o.length;
        return d < 0 && (d = zt(w + d, 0)), Uv(o) ? d <= w && o.indexOf(s, d) > -1 : !!w && mu(o, s, d) > -1;
      }
      var i7 = sr(function(o, s, d) {
        var m = -1, w = typeof s == "function", E = Gn(o) ? K(o.length) : [];
        return ls(o, function(R) {
          E[++m] = w ? oa(s, R, d) : qc(R, s, d);
        }), E;
      }), s7 = Av(function(o, s, d) {
        mi(o, d, s);
      });
      function Nv(o, s) {
        var d = Je(o) ? ft : y5;
        return d(o, Ue(s, 3));
      }
      function l7(o, s, d, m) {
        return o == null ? [] : (Je(s) || (s = s == null ? [] : [s]), d = m ? t : d, Je(d) || (d = d == null ? [] : [d]), w5(o, s, d));
      }
      var u7 = Av(function(o, s, d) {
        o[d ? 0 : 1].push(s);
      }, function() {
        return [[], []];
      });
      function c7(o, s, d) {
        var m = Je(o) ? Em : Y_, w = arguments.length < 3;
        return m(o, Ue(s, 4), d, w, ls);
      }
      function d7(o, s, d) {
        var m = Je(o) ? wN : Y_, w = arguments.length < 3;
        return m(o, Ue(s, 4), d, w, f5);
      }
      function f7(o, s) {
        var d = Je(o) ? as : v5;
        return d(o, zv(Ue(s, 3)));
      }
      function v7(o) {
        var s = Je(o) ? l5 : o9;
        return s(o);
      }
      function h7(o, s, d) {
        (d ? In(o, s, d) : s === t) ? s = 1 : s = or(s);
        var m = Je(o) ? DL : i9;
        return m(o, s);
      }
      function p7(o) {
        var s = Je(o) ? NL : l9;
        return s(o);
      }
      function g7(o) {
        if (o == null)
          return 0;
        if (Gn(o))
          return Uv(o) ? yu(o) : o.length;
        var s = Sn(o);
        return s == yr || s == Sr ? o.size : Gm(o).length;
      }
      function m7(o, s, d) {
        var m = Je(o) ? Am : u9;
        return d && In(o, s, d) && (s = t), m(o, Ue(s, 3));
      }
      var b7 = sr(function(o, s) {
        if (o == null)
          return [];
        var d = s.length;
        return d > 1 && In(o, s[0], s[1]) ? s = [] : d > 2 && In(s[0], s[1], s[2]) && (s = [s[0]]), w5(o, rn(s, 1), []);
      }), Lv = XN || function() {
        return ce.Date.now();
      };
      function y7(o, s) {
        if (typeof s != "function")
          throw new Ia(l);
        return o = or(o), function() {
          if (--o < 1)
            return s.apply(this, arguments);
        };
      }
      function mT(o, s, d) {
        return s = d ? t : s, s = o && s == null ? o.length : s, bi(o, M, t, t, t, t, s);
      }
      function bT(o, s) {
        var d;
        if (typeof s != "function")
          throw new Ia(l);
        return o = or(o), function() {
          return --o > 0 && (d = s.apply(this, arguments)), o <= 1 && (s = t), d;
        };
      }
      var gb = sr(function(o, s, d) {
        var m = T;
        if (d.length) {
          var w = is(d, Eu(gb));
          m |= k;
        }
        return bi(o, m, s, d, w);
      }), yT = sr(function(o, s, d) {
        var m = T | A;
        if (d.length) {
          var w = is(d, Eu(yT));
          m |= k;
        }
        return bi(s, m, o, d, w);
      });
      function ST(o, s, d) {
        s = d ? t : s;
        var m = bi(o, P, t, t, t, t, t, s);
        return m.placeholder = ST.placeholder, m;
      }
      function xT(o, s, d) {
        s = d ? t : s;
        var m = bi(o, j, t, t, t, t, t, s);
        return m.placeholder = xT.placeholder, m;
      }
      function $T(o, s, d) {
        var m, w, E, R, D, V, J = 0, ee = !1, le = !1, xe = !0;
        if (typeof o != "function")
          throw new Ia(l);
        s = ka(s) || 0, St(d) && (ee = !!d.leading, le = "maxWait" in d, E = le ? zt(ka(d.maxWait) || 0, s) : E, xe = "trailing" in d ? !!d.trailing : xe);
        function ke(At) {
          var no = m, wi = w;
          return m = w = t, J = At, R = o.apply(wi, no), R;
        }
        function Ve(At) {
          return J = At, D = ed(dr, s), ee ? ke(At) : R;
        }
        function ir(At) {
          var no = At - V, wi = At - J, BT = s - no;
          return le ? yn(BT, E - wi) : BT;
        }
        function We(At) {
          var no = At - V, wi = At - J;
          return V === t || no >= s || no < 0 || le && wi >= E;
        }
        function dr() {
          var At = Lv();
          if (We(At))
            return pr(At);
          D = ed(dr, ir(At));
        }
        function pr(At) {
          return D = t, xe && m ? ke(At) : (m = w = t, R);
        }
        function ua() {
          D !== t && R5(D), J = 0, m = V = w = D = t;
        }
        function On() {
          return D === t ? R : pr(Lv());
        }
        function ca() {
          var At = Lv(), no = We(At);
          if (m = arguments, w = this, V = At, no) {
            if (D === t)
              return Ve(V);
            if (le)
              return R5(D), D = ed(dr, s), ke(V);
          }
          return D === t && (D = ed(dr, s)), R;
        }
        return ca.cancel = ua, ca.flush = On, ca;
      }
      var S7 = sr(function(o, s) {
        return d5(o, 1, s);
      }), x7 = sr(function(o, s, d) {
        return d5(o, ka(s) || 0, d);
      });
      function $7(o) {
        return bi(o, q);
      }
      function Fv(o, s) {
        if (typeof o != "function" || s != null && typeof s != "function")
          throw new Ia(l);
        var d = function() {
          var m = arguments, w = s ? s.apply(this, m) : m[0], E = d.cache;
          if (E.has(w))
            return E.get(w);
          var R = o.apply(this, m);
          return d.cache = E.set(w, R) || E, R;
        };
        return d.cache = new (Fv.Cache || gi)(), d;
      }
      Fv.Cache = gi;
      function zv(o) {
        if (typeof o != "function")
          throw new Ia(l);
        return function() {
          var s = arguments;
          switch (s.length) {
            case 0:
              return !o.call(this);
            case 1:
              return !o.call(this, s[0]);
            case 2:
              return !o.call(this, s[0], s[1]);
            case 3:
              return !o.call(this, s[0], s[1], s[2]);
          }
          return !o.apply(this, s);
        };
      }
      function w7(o) {
        return bT(2, o);
      }
      var _7 = c9(function(o, s) {
        s = s.length == 1 && Je(s[0]) ? ft(s[0], ia(Ue())) : ft(rn(s, 1), ia(Ue()));
        var d = s.length;
        return sr(function(m) {
          for (var w = -1, E = yn(m.length, d); ++w < E; )
            m[w] = s[w].call(this, m[w]);
          return oa(o, this, m);
        });
      }), mb = sr(function(o, s) {
        var d = is(s, Eu(mb));
        return bi(o, k, t, s, d);
      }), wT = sr(function(o, s) {
        var d = is(s, Eu(wT));
        return bi(o, L, t, s, d);
      }), T7 = yi(function(o, s) {
        return bi(o, W, t, t, t, s);
      });
      function C7(o, s) {
        if (typeof o != "function")
          throw new Ia(l);
        return s = s === t ? s : or(s), sr(o, s);
      }
      function E7(o, s) {
        if (typeof o != "function")
          throw new Ia(l);
        return s = s == null ? 0 : zt(or(s), 0), sr(function(d) {
          var m = d[s], w = ds(d, 0, s);
          return m && os(w, m), oa(o, this, w);
        });
      }
      function A7(o, s, d) {
        var m = !0, w = !0;
        if (typeof o != "function")
          throw new Ia(l);
        return St(d) && (m = "leading" in d ? !!d.leading : m, w = "trailing" in d ? !!d.trailing : w), $T(o, s, {
          leading: m,
          maxWait: s,
          trailing: w
        });
      }
      function I7(o) {
        return mT(o, 1);
      }
      function O7(o, s) {
        return mb(rb(s), o);
      }
      function M7() {
        if (!arguments.length)
          return [];
        var o = arguments[0];
        return Je(o) ? o : [o];
      }
      function R7(o) {
        return Ma(o, y);
      }
      function P7(o, s) {
        return s = typeof s == "function" ? s : t, Ma(o, y, s);
      }
      function k7(o) {
        return Ma(o, p | y);
      }
      function j7(o, s) {
        return s = typeof s == "function" ? s : t, Ma(o, p | y, s);
      }
      function D7(o, s) {
        return s == null || c5(o, s, Gt(s));
      }
      function to(o, s) {
        return o === s || o !== o && s !== s;
      }
      var N7 = Rv(Vm), L7 = Rv(function(o, s) {
        return o >= s;
      }), $l = g5(function() {
        return arguments;
      }()) ? g5 : function(o) {
        return _t(o) && Lr.call(o, "callee") && !t5.call(o, "callee");
      }, Je = K.isArray, F7 = Vn ? ia(Vn) : YL;
      function Gn(o) {
        return o != null && Bv(o.length) && !xi(o);
      }
      function Et(o) {
        return _t(o) && Gn(o);
      }
      function z7(o) {
        return o === !0 || o === !1 || _t(o) && An(o) == ve;
      }
      var fs = eL || Ab, B7 = Wn ? ia(Wn) : KL;
      function U7(o) {
        return _t(o) && o.nodeType === 1 && !rd(o);
      }
      function V7(o) {
        if (o == null)
          return !0;
        if (Gn(o) && (Je(o) || typeof o == "string" || typeof o.splice == "function" || fs(o) || Au(o) || $l(o)))
          return !o.length;
        var s = Sn(o);
        if (s == yr || s == Sr)
          return !o.size;
        if (Jc(o))
          return !Gm(o).length;
        for (var d in o)
          if (Lr.call(o, d))
            return !1;
        return !0;
      }
      function W7(o, s) {
        return Zc(o, s);
      }
      function H7(o, s, d) {
        d = typeof d == "function" ? d : t;
        var m = d ? d(o, s) : t;
        return m === t ? Zc(o, s, t, d) : !!m;
      }
      function bb(o) {
        if (!_t(o))
          return !1;
        var s = An(o);
        return s == ur || s == br || typeof o.message == "string" && typeof o.name == "string" && !rd(o);
      }
      function G7(o) {
        return typeof o == "number" && a5(o);
      }
      function xi(o) {
        if (!St(o))
          return !1;
        var s = An(o);
        return s == $r || s == Qe || s == je || s == mt;
      }
      function _T(o) {
        return typeof o == "number" && o == or(o);
      }
      function Bv(o) {
        return typeof o == "number" && o > -1 && o % 1 == 0 && o <= ue;
      }
      function St(o) {
        var s = typeof o;
        return o != null && (s == "object" || s == "function");
      }
      function _t(o) {
        return o != null && typeof o == "object";
      }
      var TT = Ja ? ia(Ja) : ZL;
      function Y7(o, s) {
        return o === s || Hm(o, s, lb(s));
      }
      function K7(o, s, d) {
        return d = typeof d == "function" ? d : t, Hm(o, s, lb(s), d);
      }
      function q7(o) {
        return CT(o) && o != +o;
      }
      function Z7(o) {
        if (P9(o))
          throw new Xe(i);
        return m5(o);
      }
      function Q7(o) {
        return o === null;
      }
      function X7(o) {
        return o == null;
      }
      function CT(o) {
        return typeof o == "number" || _t(o) && An(o) == at;
      }
      function rd(o) {
        if (!_t(o) || An(o) != Nr)
          return !1;
        var s = hv(o);
        if (s === null)
          return !0;
        var d = Lr.call(s, "constructor") && s.constructor;
        return typeof d == "function" && d instanceof d && cv.call(d) == KN;
      }
      var yb = z_ ? ia(z_) : QL;
      function J7(o) {
        return _T(o) && o >= -ue && o <= ue;
      }
      var ET = B_ ? ia(B_) : XL;
      function Uv(o) {
        return typeof o == "string" || !Je(o) && _t(o) && An(o) == G;
      }
      function la(o) {
        return typeof o == "symbol" || _t(o) && An(o) == ne;
      }
      var Au = U_ ? ia(U_) : JL;
      function ez(o) {
        return o === t;
      }
      function rz(o) {
        return _t(o) && Sn(o) == Q;
      }
      function tz(o) {
        return _t(o) && An(o) == we;
      }
      var nz = Rv(Ym), az = Rv(function(o, s) {
        return o <= s;
      });
      function AT(o) {
        if (!o)
          return [];
        if (Gn(o))
          return Uv(o) ? eo(o) : Hn(o);
        if (Uc && o[Uc])
          return DN(o[Uc]());
        var s = Sn(o), d = s == yr ? km : s == Sr ? sv : Iu;
        return d(o);
      }
      function $i(o) {
        if (!o)
          return o === 0 ? o : 0;
        if (o = ka(o), o === Be || o === -Be) {
          var s = o < 0 ? -1 : 1;
          return s * he;
        }
        return o === o ? o : 0;
      }
      function or(o) {
        var s = $i(o), d = s % 1;
        return s === s ? d ? s - d : s : 0;
      }
      function IT(o) {
        return o ? bl(or(o), 0, Oe) : 0;
      }
      function ka(o) {
        if (typeof o == "number")
          return o;
        if (la(o))
          return _e;
        if (St(o)) {
          var s = typeof o.valueOf == "function" ? o.valueOf() : o;
          o = St(s) ? s + "" : s;
        }
        if (typeof o != "string")
          return o === 0 ? o : +o;
        o = K_(o);
        var d = Js.test(o);
        return d || rl.test(o) ? N(o.slice(2), d ? 2 : 8) : Xs.test(o) ? _e : +o;
      }
      function OT(o) {
        return No(o, Yn(o));
      }
      function oz(o) {
        return o ? bl(or(o), -ue, ue) : o === 0 ? o : 0;
      }
      function kr(o) {
        return o == null ? "" : sa(o);
      }
      var iz = Tu(function(o, s) {
        if (Jc(s) || Gn(s)) {
          No(s, Gt(s), o);
          return;
        }
        for (var d in s)
          Lr.call(s, d) && Yc(o, d, s[d]);
      }), MT = Tu(function(o, s) {
        No(s, Yn(s), o);
      }), Vv = Tu(function(o, s, d, m) {
        No(s, Yn(s), o, m);
      }), sz = Tu(function(o, s, d, m) {
        No(s, Gt(s), o, m);
      }), lz = yi(zm);
      function uz(o, s) {
        var d = _u(o);
        return s == null ? d : u5(d, s);
      }
      var cz = sr(function(o, s) {
        o = Jr(o);
        var d = -1, m = s.length, w = m > 2 ? s[2] : t;
        for (w && In(s[0], s[1], w) && (m = 1); ++d < m; )
          for (var E = s[d], R = Yn(E), D = -1, V = R.length; ++D < V; ) {
            var J = R[D], ee = o[J];
            (ee === t || to(ee, xu[J]) && !Lr.call(o, J)) && (o[J] = E[J]);
          }
        return o;
      }), dz = sr(function(o) {
        return o.push(t, K5), oa(RT, t, o);
      });
      function fz(o, s) {
        return W_(o, Ue(s, 3), Do);
      }
      function vz(o, s) {
        return W_(o, Ue(s, 3), Um);
      }
      function hz(o, s) {
        return o == null ? o : Bm(o, Ue(s, 3), Yn);
      }
      function pz(o, s) {
        return o == null ? o : h5(o, Ue(s, 3), Yn);
      }
      function gz(o, s) {
        return o && Do(o, Ue(s, 3));
      }
      function mz(o, s) {
        return o && Um(o, Ue(s, 3));
      }
      function bz(o) {
        return o == null ? [] : _v(o, Gt(o));
      }
      function yz(o) {
        return o == null ? [] : _v(o, Yn(o));
      }
      function Sb(o, s, d) {
        var m = o == null ? t : yl(o, s);
        return m === t ? d : m;
      }
      function Sz(o, s) {
        return o != null && Q5(o, s, VL);
      }
      function xb(o, s) {
        return o != null && Q5(o, s, WL);
      }
      var xz = V5(function(o, s, d) {
        s != null && typeof s.toString != "function" && (s = dv.call(s)), o[s] = d;
      }, wb(Kn)), $z = V5(function(o, s, d) {
        s != null && typeof s.toString != "function" && (s = dv.call(s)), Lr.call(o, s) ? o[s].push(d) : o[s] = [d];
      }, Ue), wz = sr(qc);
      function Gt(o) {
        return Gn(o) ? s5(o) : Gm(o);
      }
      function Yn(o) {
        return Gn(o) ? s5(o, !0) : e9(o);
      }
      function _z(o, s) {
        var d = {};
        return s = Ue(s, 3), Do(o, function(m, w, E) {
          mi(d, s(m, w, E), m);
        }), d;
      }
      function Tz(o, s) {
        var d = {};
        return s = Ue(s, 3), Do(o, function(m, w, E) {
          mi(d, w, s(m, w, E));
        }), d;
      }
      var Cz = Tu(function(o, s, d) {
        Tv(o, s, d);
      }), RT = Tu(function(o, s, d, m) {
        Tv(o, s, d, m);
      }), Ez = yi(function(o, s) {
        var d = {};
        if (o == null)
          return d;
        var m = !1;
        s = ft(s, function(E) {
          return E = cs(E, o), m || (m = E.length > 1), E;
        }), No(o, ib(o), d), m && (d = Ma(d, p | g | y, x9));
        for (var w = s.length; w--; )
          Xm(d, s[w]);
        return d;
      });
      function Az(o, s) {
        return PT(o, zv(Ue(s)));
      }
      var Iz = yi(function(o, s) {
        return o == null ? {} : t9(o, s);
      });
      function PT(o, s) {
        if (o == null)
          return {};
        var d = ft(ib(o), function(m) {
          return [m];
        });
        return s = Ue(s), _5(o, d, function(m, w) {
          return s(m, w[0]);
        });
      }
      function Oz(o, s, d) {
        s = cs(s, o);
        var m = -1, w = s.length;
        for (w || (w = 1, o = t); ++m < w; ) {
          var E = o == null ? t : o[Lo(s[m])];
          E === t && (m = w, E = d), o = xi(E) ? E.call(o) : E;
        }
        return o;
      }
      function Mz(o, s, d) {
        return o == null ? o : Qc(o, s, d);
      }
      function Rz(o, s, d, m) {
        return m = typeof m == "function" ? m : t, o == null ? o : Qc(o, s, d, m);
      }
      var kT = G5(Gt), jT = G5(Yn);
      function Pz(o, s, d) {
        var m = Je(o), w = m || fs(o) || Au(o);
        if (s = Ue(s, 4), d == null) {
          var E = o && o.constructor;
          w ? d = m ? new E() : [] : St(o) ? d = xi(E) ? _u(hv(o)) : {} : d = {};
        }
        return (w ? Aa : Do)(o, function(R, D, V) {
          return s(d, R, D, V);
        }), d;
      }
      function kz(o, s) {
        return o == null ? !0 : Xm(o, s);
      }
      function jz(o, s, d) {
        return o == null ? o : I5(o, s, rb(d));
      }
      function Dz(o, s, d, m) {
        return m = typeof m == "function" ? m : t, o == null ? o : I5(o, s, rb(d), m);
      }
      function Iu(o) {
        return o == null ? [] : Pm(o, Gt(o));
      }
      function Nz(o) {
        return o == null ? [] : Pm(o, Yn(o));
      }
      function Lz(o, s, d) {
        return d === t && (d = s, s = t), d !== t && (d = ka(d), d = d === d ? d : 0), s !== t && (s = ka(s), s = s === s ? s : 0), bl(ka(o), s, d);
      }
      function Fz(o, s, d) {
        return s = $i(s), d === t ? (d = s, s = 0) : d = $i(d), o = ka(o), HL(o, s, d);
      }
      function zz(o, s, d) {
        if (d && typeof d != "boolean" && In(o, s, d) && (s = d = t), d === t && (typeof s == "boolean" ? (d = s, s = t) : typeof o == "boolean" && (d = o, o = t)), o === t && s === t ? (o = 0, s = 1) : (o = $i(o), s === t ? (s = o, o = 0) : s = $i(s)), o > s) {
          var m = o;
          o = s, s = m;
        }
        if (d || o % 1 || s % 1) {
          var w = o5();
          return yn(o + w * (s - o + $("1e-" + ((w + "").length - 1))), s);
        }
        return qm(o, s);
      }
      var Bz = Cu(function(o, s, d) {
        return s = s.toLowerCase(), o + (d ? DT(s) : s);
      });
      function DT(o) {
        return $b(kr(o).toLowerCase());
      }
      function NT(o) {
        return o = kr(o), o && o.replace(nl, MN).replace(Ro, "");
      }
      function Uz(o, s, d) {
        o = kr(o), s = sa(s);
        var m = o.length;
        d = d === t ? m : bl(or(d), 0, m);
        var w = d;
        return d -= s.length, d >= 0 && o.slice(d, w) == s;
      }
      function Vz(o) {
        return o = kr(o), o && tr.test(o) ? o.replace(ge, RN) : o;
      }
      function Wz(o) {
        return o = kr(o), o && nr.test(o) ? o.replace(Pe, "\\$&") : o;
      }
      var Hz = Cu(function(o, s, d) {
        return o + (d ? "-" : "") + s.toLowerCase();
      }), Gz = Cu(function(o, s, d) {
        return o + (d ? " " : "") + s.toLowerCase();
      }), Yz = z5("toLowerCase");
      function Kz(o, s, d) {
        o = kr(o), s = or(s);
        var m = s ? yu(o) : 0;
        if (!s || m >= s)
          return o;
        var w = (s - m) / 2;
        return Mv(bv(w), d) + o + Mv(mv(w), d);
      }
      function qz(o, s, d) {
        o = kr(o), s = or(s);
        var m = s ? yu(o) : 0;
        return s && m < s ? o + Mv(s - m, d) : o;
      }
      function Zz(o, s, d) {
        o = kr(o), s = or(s);
        var m = s ? yu(o) : 0;
        return s && m < s ? Mv(s - m, d) + o : o;
      }
      function Qz(o, s, d) {
        return d || s == null ? s = 0 : s && (s = +s), aL(kr(o).replace(Hr, ""), s || 0);
      }
      function Xz(o, s, d) {
        return (d ? In(o, s, d) : s === t) ? s = 1 : s = or(s), Zm(kr(o), s);
      }
      function Jz() {
        var o = arguments, s = kr(o[0]);
        return o.length < 3 ? s : s.replace(o[1], o[2]);
      }
      var eB = Cu(function(o, s, d) {
        return o + (d ? "_" : "") + s.toLowerCase();
      });
      function rB(o, s, d) {
        return d && typeof d != "number" && In(o, s, d) && (s = d = t), d = d === t ? Oe : d >>> 0, d ? (o = kr(o), o && (typeof s == "string" || s != null && !yb(s)) && (s = sa(s), !s && bu(o)) ? ds(eo(o), 0, d) : o.split(s, d)) : [];
      }
      var tB = Cu(function(o, s, d) {
        return o + (d ? " " : "") + $b(s);
      });
      function nB(o, s, d) {
        return o = kr(o), d = d == null ? 0 : bl(or(d), 0, o.length), s = sa(s), o.slice(d, d + s.length) == s;
      }
      function aB(o, s, d) {
        var m = C.templateSettings;
        d && In(o, s, d) && (s = t), o = kr(o), s = Vv({}, s, m, Y5);
        var w = Vv({}, s.imports, m.imports, Y5), E = Gt(w), R = Pm(w, E), D, V, J = 0, ee = s.interpolate || pn, le = "__p += '", xe = jm(
          (s.escape || pn).source + "|" + ee.source + "|" + (ee === Fn ? Qs : pn).source + "|" + (s.evaluate || pn).source + "|$",
          "g"
        ), ke = "//# sourceURL=" + (Lr.call(s, "sourceURL") ? (s.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ko + "]") + `
`;
        o.replace(xe, function(We, dr, pr, ua, On, ca) {
          return pr || (pr = ua), le += o.slice(J, ca).replace(al, PN), dr && (D = !0, le += `' +
__e(` + dr + `) +
'`), On && (V = !0, le += `';
` + On + `;
__p += '`), pr && (le += `' +
((__t = (` + pr + `)) == null ? '' : __t) +
'`), J = ca + We.length, We;
        }), le += `';
`;
        var Ve = Lr.call(s, "variable") && s.variable;
        if (!Ve)
          le = `with (obj) {
` + le + `
}
`;
        else if (qs.test(Ve))
          throw new Xe(u);
        le = (V ? le.replace(vn, "") : le).replace(hn, "$1").replace(Za, "$1;"), le = "function(" + (Ve || "obj") + `) {
` + (Ve ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (D ? ", __e = _.escape" : "") + (V ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + le + `return __p
}`;
        var ir = FT(function() {
          return Tr(E, ke + "return " + le).apply(t, R);
        });
        if (ir.source = le, bb(ir))
          throw ir;
        return ir;
      }
      function oB(o) {
        return kr(o).toLowerCase();
      }
      function iB(o) {
        return kr(o).toUpperCase();
      }
      function sB(o, s, d) {
        if (o = kr(o), o && (d || s === t))
          return K_(o);
        if (!o || !(s = sa(s)))
          return o;
        var m = eo(o), w = eo(s), E = q_(m, w), R = Z_(m, w) + 1;
        return ds(m, E, R).join("");
      }
      function lB(o, s, d) {
        if (o = kr(o), o && (d || s === t))
          return o.slice(0, X_(o) + 1);
        if (!o || !(s = sa(s)))
          return o;
        var m = eo(o), w = Z_(m, eo(s)) + 1;
        return ds(m, 0, w).join("");
      }
      function uB(o, s, d) {
        if (o = kr(o), o && (d || s === t))
          return o.replace(Hr, "");
        if (!o || !(s = sa(s)))
          return o;
        var m = eo(o), w = q_(m, eo(s));
        return ds(m, w).join("");
      }
      function cB(o, s) {
        var d = oe, m = Ae;
        if (St(s)) {
          var w = "separator" in s ? s.separator : w;
          d = "length" in s ? or(s.length) : d, m = "omission" in s ? sa(s.omission) : m;
        }
        o = kr(o);
        var E = o.length;
        if (bu(o)) {
          var R = eo(o);
          E = R.length;
        }
        if (d >= E)
          return o;
        var D = d - yu(m);
        if (D < 1)
          return m;
        var V = R ? ds(R, 0, D).join("") : o.slice(0, D);
        if (w === t)
          return V + m;
        if (R && (D += V.length - D), yb(w)) {
          if (o.slice(D).search(w)) {
            var J, ee = V;
            for (w.global || (w = jm(w.source, kr(yt.exec(w)) + "g")), w.lastIndex = 0; J = w.exec(ee); )
              var le = J.index;
            V = V.slice(0, le === t ? D : le);
          }
        } else if (o.indexOf(sa(w), D) != D) {
          var xe = V.lastIndexOf(w);
          xe > -1 && (V = V.slice(0, xe));
        }
        return V + m;
      }
      function dB(o) {
        return o = kr(o), o && De.test(o) ? o.replace(Cn, zN) : o;
      }
      var fB = Cu(function(o, s, d) {
        return o + (d ? " " : "") + s.toUpperCase();
      }), $b = z5("toUpperCase");
      function LT(o, s, d) {
        return o = kr(o), s = d ? t : s, s === t ? jN(o) ? VN(o) : CN(o) : o.match(s) || [];
      }
      var FT = sr(function(o, s) {
        try {
          return oa(o, t, s);
        } catch (d) {
          return bb(d) ? d : new Xe(d);
        }
      }), vB = yi(function(o, s) {
        return Aa(s, function(d) {
          d = Lo(d), mi(o, d, gb(o[d], o));
        }), o;
      });
      function hB(o) {
        var s = o == null ? 0 : o.length, d = Ue();
        return o = s ? ft(o, function(m) {
          if (typeof m[1] != "function")
            throw new Ia(l);
          return [d(m[0]), m[1]];
        }) : [], sr(function(m) {
          for (var w = -1; ++w < s; ) {
            var E = o[w];
            if (oa(E[0], this, m))
              return oa(E[1], this, m);
          }
        });
      }
      function pB(o) {
        return zL(Ma(o, p));
      }
      function wb(o) {
        return function() {
          return o;
        };
      }
      function gB(o, s) {
        return o == null || o !== o ? s : o;
      }
      var mB = U5(), bB = U5(!0);
      function Kn(o) {
        return o;
      }
      function _b(o) {
        return b5(typeof o == "function" ? o : Ma(o, p));
      }
      function yB(o) {
        return S5(Ma(o, p));
      }
      function SB(o, s) {
        return x5(o, Ma(s, p));
      }
      var xB = sr(function(o, s) {
        return function(d) {
          return qc(d, o, s);
        };
      }), $B = sr(function(o, s) {
        return function(d) {
          return qc(o, d, s);
        };
      });
      function Tb(o, s, d) {
        var m = Gt(s), w = _v(s, m);
        d == null && !(St(s) && (w.length || !m.length)) && (d = s, s = o, o = this, w = _v(s, Gt(s)));
        var E = !(St(d) && "chain" in d) || !!d.chain, R = xi(o);
        return Aa(w, function(D) {
          var V = s[D];
          o[D] = V, R && (o.prototype[D] = function() {
            var J = this.__chain__;
            if (E || J) {
              var ee = o(this.__wrapped__), le = ee.__actions__ = Hn(this.__actions__);
              return le.push({ func: V, args: arguments, thisArg: o }), ee.__chain__ = J, ee;
            }
            return V.apply(o, os([this.value()], arguments));
          });
        }), o;
      }
      function wB() {
        return ce._ === this && (ce._ = qN), this;
      }
      function Cb() {
      }
      function _B(o) {
        return o = or(o), sr(function(s) {
          return $5(s, o);
        });
      }
      var TB = nb(ft), CB = nb(V_), EB = nb(Am);
      function zT(o) {
        return cb(o) ? Im(Lo(o)) : n9(o);
      }
      function AB(o) {
        return function(s) {
          return o == null ? t : yl(o, s);
        };
      }
      var IB = W5(), OB = W5(!0);
      function Eb() {
        return [];
      }
      function Ab() {
        return !1;
      }
      function MB() {
        return {};
      }
      function RB() {
        return "";
      }
      function PB() {
        return !0;
      }
      function kB(o, s) {
        if (o = or(o), o < 1 || o > ue)
          return [];
        var d = Oe, m = yn(o, Oe);
        s = Ue(s), o -= Oe;
        for (var w = Rm(m, s); ++d < o; )
          s(d);
        return w;
      }
      function jB(o) {
        return Je(o) ? ft(o, Lo) : la(o) ? [o] : Hn(iT(kr(o)));
      }
      function DB(o) {
        var s = ++YN;
        return kr(o) + s;
      }
      var NB = Ov(function(o, s) {
        return o + s;
      }, 0), LB = ab("ceil"), FB = Ov(function(o, s) {
        return o / s;
      }, 1), zB = ab("floor");
      function BB(o) {
        return o && o.length ? wv(o, Kn, Vm) : t;
      }
      function UB(o, s) {
        return o && o.length ? wv(o, Ue(s, 2), Vm) : t;
      }
      function VB(o) {
        return G_(o, Kn);
      }
      function WB(o, s) {
        return G_(o, Ue(s, 2));
      }
      function HB(o) {
        return o && o.length ? wv(o, Kn, Ym) : t;
      }
      function GB(o, s) {
        return o && o.length ? wv(o, Ue(s, 2), Ym) : t;
      }
      var YB = Ov(function(o, s) {
        return o * s;
      }, 1), KB = ab("round"), qB = Ov(function(o, s) {
        return o - s;
      }, 0);
      function ZB(o) {
        return o && o.length ? Mm(o, Kn) : 0;
      }
      function QB(o, s) {
        return o && o.length ? Mm(o, Ue(s, 2)) : 0;
      }
      return C.after = y7, C.ary = mT, C.assign = iz, C.assignIn = MT, C.assignInWith = Vv, C.assignWith = sz, C.at = lz, C.before = bT, C.bind = gb, C.bindAll = vB, C.bindKey = yT, C.castArray = M7, C.chain = hT, C.chunk = z9, C.compact = B9, C.concat = U9, C.cond = hB, C.conforms = pB, C.constant = wb, C.countBy = ZF, C.create = uz, C.curry = ST, C.curryRight = xT, C.debounce = $T, C.defaults = cz, C.defaultsDeep = dz, C.defer = S7, C.delay = x7, C.difference = V9, C.differenceBy = W9, C.differenceWith = H9, C.drop = G9, C.dropRight = Y9, C.dropRightWhile = K9, C.dropWhile = q9, C.fill = Z9, C.filter = XF, C.flatMap = r7, C.flatMapDeep = t7, C.flatMapDepth = n7, C.flatten = cT, C.flattenDeep = Q9, C.flattenDepth = X9, C.flip = $7, C.flow = mB, C.flowRight = bB, C.fromPairs = J9, C.functions = bz, C.functionsIn = yz, C.groupBy = a7, C.initial = rF, C.intersection = tF, C.intersectionBy = nF, C.intersectionWith = aF, C.invert = xz, C.invertBy = $z, C.invokeMap = i7, C.iteratee = _b, C.keyBy = s7, C.keys = Gt, C.keysIn = Yn, C.map = Nv, C.mapKeys = _z, C.mapValues = Tz, C.matches = yB, C.matchesProperty = SB, C.memoize = Fv, C.merge = Cz, C.mergeWith = RT, C.method = xB, C.methodOf = $B, C.mixin = Tb, C.negate = zv, C.nthArg = _B, C.omit = Ez, C.omitBy = Az, C.once = w7, C.orderBy = l7, C.over = TB, C.overArgs = _7, C.overEvery = CB, C.overSome = EB, C.partial = mb, C.partialRight = wT, C.partition = u7, C.pick = Iz, C.pickBy = PT, C.property = zT, C.propertyOf = AB, C.pull = lF, C.pullAll = fT, C.pullAllBy = uF, C.pullAllWith = cF, C.pullAt = dF, C.range = IB, C.rangeRight = OB, C.rearg = T7, C.reject = f7, C.remove = fF, C.rest = C7, C.reverse = hb, C.sampleSize = h7, C.set = Mz, C.setWith = Rz, C.shuffle = p7, C.slice = vF, C.sortBy = b7, C.sortedUniq = SF, C.sortedUniqBy = xF, C.split = rB, C.spread = E7, C.tail = $F, C.take = wF, C.takeRight = _F, C.takeRightWhile = TF, C.takeWhile = CF, C.tap = BF, C.throttle = A7, C.thru = Dv, C.toArray = AT, C.toPairs = kT, C.toPairsIn = jT, C.toPath = jB, C.toPlainObject = OT, C.transform = Pz, C.unary = I7, C.union = EF, C.unionBy = AF, C.unionWith = IF, C.uniq = OF, C.uniqBy = MF, C.uniqWith = RF, C.unset = kz, C.unzip = pb, C.unzipWith = vT, C.update = jz, C.updateWith = Dz, C.values = Iu, C.valuesIn = Nz, C.without = PF, C.words = LT, C.wrap = O7, C.xor = kF, C.xorBy = jF, C.xorWith = DF, C.zip = NF, C.zipObject = LF, C.zipObjectDeep = FF, C.zipWith = zF, C.entries = kT, C.entriesIn = jT, C.extend = MT, C.extendWith = Vv, Tb(C, C), C.add = NB, C.attempt = FT, C.camelCase = Bz, C.capitalize = DT, C.ceil = LB, C.clamp = Lz, C.clone = R7, C.cloneDeep = k7, C.cloneDeepWith = j7, C.cloneWith = P7, C.conformsTo = D7, C.deburr = NT, C.defaultTo = gB, C.divide = FB, C.endsWith = Uz, C.eq = to, C.escape = Vz, C.escapeRegExp = Wz, C.every = QF, C.find = JF, C.findIndex = lT, C.findKey = fz, C.findLast = e7, C.findLastIndex = uT, C.findLastKey = vz, C.floor = zB, C.forEach = pT, C.forEachRight = gT, C.forIn = hz, C.forInRight = pz, C.forOwn = gz, C.forOwnRight = mz, C.get = Sb, C.gt = N7, C.gte = L7, C.has = Sz, C.hasIn = xb, C.head = dT, C.identity = Kn, C.includes = o7, C.indexOf = eF, C.inRange = Fz, C.invoke = wz, C.isArguments = $l, C.isArray = Je, C.isArrayBuffer = F7, C.isArrayLike = Gn, C.isArrayLikeObject = Et, C.isBoolean = z7, C.isBuffer = fs, C.isDate = B7, C.isElement = U7, C.isEmpty = V7, C.isEqual = W7, C.isEqualWith = H7, C.isError = bb, C.isFinite = G7, C.isFunction = xi, C.isInteger = _T, C.isLength = Bv, C.isMap = TT, C.isMatch = Y7, C.isMatchWith = K7, C.isNaN = q7, C.isNative = Z7, C.isNil = X7, C.isNull = Q7, C.isNumber = CT, C.isObject = St, C.isObjectLike = _t, C.isPlainObject = rd, C.isRegExp = yb, C.isSafeInteger = J7, C.isSet = ET, C.isString = Uv, C.isSymbol = la, C.isTypedArray = Au, C.isUndefined = ez, C.isWeakMap = rz, C.isWeakSet = tz, C.join = oF, C.kebabCase = Hz, C.last = Pa, C.lastIndexOf = iF, C.lowerCase = Gz, C.lowerFirst = Yz, C.lt = nz, C.lte = az, C.max = BB, C.maxBy = UB, C.mean = VB, C.meanBy = WB, C.min = HB, C.minBy = GB, C.stubArray = Eb, C.stubFalse = Ab, C.stubObject = MB, C.stubString = RB, C.stubTrue = PB, C.multiply = YB, C.nth = sF, C.noConflict = wB, C.noop = Cb, C.now = Lv, C.pad = Kz, C.padEnd = qz, C.padStart = Zz, C.parseInt = Qz, C.random = zz, C.reduce = c7, C.reduceRight = d7, C.repeat = Xz, C.replace = Jz, C.result = Oz, C.round = KB, C.runInContext = U, C.sample = v7, C.size = g7, C.snakeCase = eB, C.some = m7, C.sortedIndex = hF, C.sortedIndexBy = pF, C.sortedIndexOf = gF, C.sortedLastIndex = mF, C.sortedLastIndexBy = bF, C.sortedLastIndexOf = yF, C.startCase = tB, C.startsWith = nB, C.subtract = qB, C.sum = ZB, C.sumBy = QB, C.template = aB, C.times = kB, C.toFinite = $i, C.toInteger = or, C.toLength = IT, C.toLower = oB, C.toNumber = ka, C.toSafeInteger = oz, C.toString = kr, C.toUpper = iB, C.trim = sB, C.trimEnd = lB, C.trimStart = uB, C.truncate = cB, C.unescape = dB, C.uniqueId = DB, C.upperCase = fB, C.upperFirst = $b, C.each = pT, C.eachRight = gT, C.first = dT, Tb(C, function() {
        var o = {};
        return Do(C, function(s, d) {
          Lr.call(C.prototype, d) || (o[d] = s);
        }), o;
      }(), { chain: !1 }), C.VERSION = n, Aa(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(o) {
        C[o].placeholder = C;
      }), Aa(["drop", "take"], function(o, s) {
        vr.prototype[o] = function(d) {
          d = d === t ? 1 : zt(or(d), 0);
          var m = this.__filtered__ && !s ? new vr(this) : this.clone();
          return m.__filtered__ ? m.__takeCount__ = yn(d, m.__takeCount__) : m.__views__.push({
            size: yn(d, Oe),
            type: o + (m.__dir__ < 0 ? "Right" : "")
          }), m;
        }, vr.prototype[o + "Right"] = function(d) {
          return this.reverse()[o](d).reverse();
        };
      }), Aa(["filter", "map", "takeWhile"], function(o, s) {
        var d = s + 1, m = d == Ee || d == Ke;
        vr.prototype[o] = function(w) {
          var E = this.clone();
          return E.__iteratees__.push({
            iteratee: Ue(w, 3),
            type: d
          }), E.__filtered__ = E.__filtered__ || m, E;
        };
      }), Aa(["head", "last"], function(o, s) {
        var d = "take" + (s ? "Right" : "");
        vr.prototype[o] = function() {
          return this[d](1).value()[0];
        };
      }), Aa(["initial", "tail"], function(o, s) {
        var d = "drop" + (s ? "" : "Right");
        vr.prototype[o] = function() {
          return this.__filtered__ ? new vr(this) : this[d](1);
        };
      }), vr.prototype.compact = function() {
        return this.filter(Kn);
      }, vr.prototype.find = function(o) {
        return this.filter(o).head();
      }, vr.prototype.findLast = function(o) {
        return this.reverse().find(o);
      }, vr.prototype.invokeMap = sr(function(o, s) {
        return typeof o == "function" ? new vr(this) : this.map(function(d) {
          return qc(d, o, s);
        });
      }), vr.prototype.reject = function(o) {
        return this.filter(zv(Ue(o)));
      }, vr.prototype.slice = function(o, s) {
        o = or(o);
        var d = this;
        return d.__filtered__ && (o > 0 || s < 0) ? new vr(d) : (o < 0 ? d = d.takeRight(-o) : o && (d = d.drop(o)), s !== t && (s = or(s), d = s < 0 ? d.dropRight(-s) : d.take(s - o)), d);
      }, vr.prototype.takeRightWhile = function(o) {
        return this.reverse().takeWhile(o).reverse();
      }, vr.prototype.toArray = function() {
        return this.take(Oe);
      }, Do(vr.prototype, function(o, s) {
        var d = /^(?:filter|find|map|reject)|While$/.test(s), m = /^(?:head|last)$/.test(s), w = C[m ? "take" + (s == "last" ? "Right" : "") : s], E = m || /^find/.test(s);
        w && (C.prototype[s] = function() {
          var R = this.__wrapped__, D = m ? [1] : arguments, V = R instanceof vr, J = D[0], ee = V || Je(R), le = function(dr) {
            var pr = w.apply(C, os([dr], D));
            return m && xe ? pr[0] : pr;
          };
          ee && d && typeof J == "function" && J.length != 1 && (V = ee = !1);
          var xe = this.__chain__, ke = !!this.__actions__.length, Ve = E && !xe, ir = V && !ke;
          if (!E && ee) {
            R = ir ? R : new vr(this);
            var We = o.apply(R, D);
            return We.__actions__.push({ func: Dv, args: [le], thisArg: t }), new Oa(We, xe);
          }
          return Ve && ir ? o.apply(this, D) : (We = this.thru(le), Ve ? m ? We.value()[0] : We.value() : We);
        });
      }), Aa(["pop", "push", "shift", "sort", "splice", "unshift"], function(o) {
        var s = lv[o], d = /^(?:push|sort|unshift)$/.test(o) ? "tap" : "thru", m = /^(?:pop|shift)$/.test(o);
        C.prototype[o] = function() {
          var w = arguments;
          if (m && !this.__chain__) {
            var E = this.value();
            return s.apply(Je(E) ? E : [], w);
          }
          return this[d](function(R) {
            return s.apply(Je(R) ? R : [], w);
          });
        };
      }), Do(vr.prototype, function(o, s) {
        var d = C[s];
        if (d) {
          var m = d.name + "";
          Lr.call(wu, m) || (wu[m] = []), wu[m].push({ name: s, func: d });
        }
      }), wu[Iv(t, A).name] = [{
        name: "wrapper",
        func: t
      }], vr.prototype.clone = dL, vr.prototype.reverse = fL, vr.prototype.value = vL, C.prototype.at = UF, C.prototype.chain = VF, C.prototype.commit = WF, C.prototype.next = HF, C.prototype.plant = YF, C.prototype.reverse = KF, C.prototype.toJSON = C.prototype.valueOf = C.prototype.value = qF, C.prototype.first = C.prototype.head, Uc && (C.prototype[Uc] = GF), C;
    }, Su = WN();
    me ? ((me.exports = Su)._ = Su, ae._ = Su) : ce._ = Su;
  }).call(Pi);
})(V0, V0.exports);
var A6e = V0.exports;
const I6e = "_dot_oe0wo_1", O6e = "_active_oe0wo_24", M6e = "_full_oe0wo_29", dp = {
  "dot-container": "_dot-container_oe0wo_1",
  dot: I6e,
  "slide-in-from-left": "_slide-in-from-left_oe0wo_1",
  active: O6e,
  full: M6e
}, R6e = ({
  maxDots: e,
  selectedIndex: r,
  allDots: t,
  onDotClick: n
}) => {
  const [a, i] = He([]), [l, u] = He(r), c = Le(
    (p, g, y, S) => {
      const x = p.slice(0, g), T = p.slice(g + 1);
      for (; x.length + T.length >= y; )
        S === "r" ? T.length > 1 ? T.pop() : x.shift() : x.length > 1 ? x.shift() : T.pop();
      return [
        ...x,
        p[g],
        ...T
      ];
    },
    [e, r, t]
  ), f = Rt(() => r > t.length - 1 ? 0 : r < 0 ? t.length - 1 : r, [r, t]), h = (p) => l ? ![...a].slice(1, a.length - 1).some((y) => y === p) : !0;
  return er(() => {
    const p = l && r >= l ? "r" : "l";
    if (h(f)) {
      const y = (h(f) ? c(t, f, e, p) : a).map((S) => S);
      i(y);
    }
    l !== r && u(f);
  }, [r, t]), /* @__PURE__ */ _.jsx("div", { children: /* @__PURE__ */ _.jsx("div", { className: dp["dot-container"], children: a.map((p) => {
    const g = `${dp.dot} ${t.length > e && f !== p && p !== 0 && p !== t.length - 1 ? dp.full : ""} 
            ${f === p ? dp.active : ""}`;
    return /* @__PURE__ */ _.jsx(
      "div",
      {
        role: "button",
        tabIndex: p,
        className: g,
        onClick: () => n(p),
        onKeyDown: A6e.noop,
        "data-testid": `dot${t.length > e && f !== p && p !== 0 && p !== t.length - 1 ? " full" : ""}${f === p ? " active" : ""}`
      },
      p
    );
  }) }) });
}, P6e = "_shimmer_kn4by_1", fp = {
  "modal-photo": "_modal-photo_kn4by_2",
  "img-container": "_img-container_kn4by_12",
  "skeleton-placeholder": "_skeleton-placeholder_kn4by_17",
  "skeleton-box": "_skeleton-box_kn4by_38",
  shimmer: P6e
};
var _c = {}, wm = {};
Object.defineProperty(wm, "__esModule", {
  value: !0
});
wm.on = k6e;
wm.off = j6e;
function k6e(e, r, t, n) {
  n = n || !1, e.addEventListener ? e.addEventListener(r, t, n) : e.attachEvent && e.attachEvent("on" + r, function(a) {
    t.call(e, a || window.event);
  });
}
function j6e(e, r, t, n) {
  n = n || !1, e.removeEventListener ? e.removeEventListener(r, t, n) : e.detachEvent && e.detachEvent("on" + r, t);
}
var j_ = {};
Object.defineProperty(j_, "__esModule", {
  value: !0
});
j_.default = function(e) {
  if (!(e instanceof HTMLElement))
    return document.documentElement;
  for (var r = e.style.position === "absolute", t = /(scroll|auto)/, n = e; n; ) {
    if (!n.parentNode)
      return e.ownerDocument || document.documentElement;
    var a = window.getComputedStyle(n), i = a.position, l = a.overflow, u = a["overflow-x"], c = a["overflow-y"];
    if (i === "static" && r) {
      n = n.parentNode;
      continue;
    }
    if (t.test(l) && t.test(u) && t.test(c))
      return n;
    n = n.parentNode;
  }
  return e.ownerDocument || e.documentElement || document.documentElement;
};
var D_ = {};
Object.defineProperty(D_, "__esModule", {
  value: !0
});
D_.default = D6e;
function D6e(e, r, t) {
  var n = void 0, a = void 0, i = void 0, l = void 0, u = void 0, c = function f() {
    var h = +/* @__PURE__ */ new Date() - l;
    h < r && h >= 0 ? n = setTimeout(f, r - h) : (n = null, t || (u = e.apply(i, a), n || (i = null, a = null)));
  };
  return function() {
    i = this, a = arguments, l = +/* @__PURE__ */ new Date();
    var h = t && !n;
    return n || (n = setTimeout(c, r)), h && (u = e.apply(i, a), i = null, a = null), u;
  };
}
var N_ = {};
Object.defineProperty(N_, "__esModule", {
  value: !0
});
N_.default = N6e;
function N6e(e, r, t) {
  r || (r = 250);
  var n, a;
  return function() {
    var i = t || this, l = +/* @__PURE__ */ new Date(), u = arguments;
    n && l < n + r ? (clearTimeout(a), a = setTimeout(function() {
      n = l, e.apply(i, u);
    }, r)) : (n = l, e.apply(i, u));
  };
}
Object.defineProperty(_c, "__esModule", {
  value: !0
});
_c.forceCheck = _c.lazyload = void 0;
var vN = function() {
  function e(r, t) {
    for (var n = 0; n < t.length; n++) {
      var a = t[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(r, a.key, a);
    }
  }
  return function(r, t, n) {
    return t && e(r.prototype, t), n && e(r, n), r;
  };
}(), L_ = $o, I2 = zc(L_), L6e = sU, Mf = zc(L6e), F6e = vP, xt = zc(F6e), Bu = wm, z6e = j_, O2 = zc(z6e), B6e = D_, U6e = zc(B6e), V6e = N_, W6e = zc(V6e);
function zc(e) {
  return e && e.__esModule ? e : { default: e };
}
function hN(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function pN(e, r) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r && (typeof r == "object" || typeof r == "function") ? r : e;
}
function gN(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof r);
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(e, r) : e.__proto__ = r);
}
var tc = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }, Sd = "data-lazyload-listened", ji = [], M2 = [], mN = !1;
try {
  var H6e = Object.defineProperty({}, "passive", {
    get: function() {
      mN = !0;
    }
  });
  window.addEventListener("test", null, H6e);
} catch (e) {
}
var _s = mN ? { capture: !1, passive: !0 } : !1, G6e = function(r, t) {
  var n = Mf.default.findDOMNode(r), a = void 0, i = void 0;
  try {
    var l = t.getBoundingClientRect();
    a = l.top, i = l.height;
  } catch (x) {
    a = tc.top, i = tc.height;
  }
  var u = window.innerHeight || document.documentElement.clientHeight, c = Math.max(a, 0), f = Math.min(u, a + i) - c, h = void 0, p = void 0;
  try {
    var g = n.getBoundingClientRect();
    h = g.top, p = g.height;
  } catch (x) {
    h = tc.top, p = tc.height;
  }
  var y = h - c, S = Array.isArray(r.props.offset) ? r.props.offset : [r.props.offset, r.props.offset];
  return y - S[0] <= f && y + p + S[1] >= 0;
}, Y6e = function(r) {
  var t = Mf.default.findDOMNode(r);
  if (!(t.offsetWidth || t.offsetHeight || t.getClientRects().length))
    return !1;
  var n = void 0, a = void 0;
  try {
    var i = t.getBoundingClientRect();
    n = i.top, a = i.height;
  } catch (c) {
    n = tc.top, a = tc.height;
  }
  var l = window.innerHeight || document.documentElement.clientHeight, u = Array.isArray(r.props.offset) ? r.props.offset : [r.props.offset, r.props.offset];
  return n - u[0] <= l && n + a + u[1] >= 0;
}, bN = function(r) {
  var t = Mf.default.findDOMNode(r);
  if (t instanceof HTMLElement) {
    var n = (0, O2.default)(t), a = r.props.overflow && n !== t.ownerDocument && n !== document && n !== document.documentElement, i = a ? G6e(r, n) : Y6e(r);
    i ? r.visible || (r.props.once && M2.push(r), r.visible = !0, r.forceUpdate()) : r.props.once && r.visible || (r.visible = !1, r.props.unmountIfInvisible && r.forceUpdate());
  }
}, K6e = function() {
  M2.forEach(function(r) {
    var t = ji.indexOf(r);
    t !== -1 && ji.splice(t, 1);
  }), M2 = [];
}, Hp = function() {
  for (var r = 0; r < ji.length; ++r) {
    var t = ji[r];
    bN(t);
  }
  K6e();
}, vp = void 0, da = null, q6e = function(r) {
  return typeof r == "string";
}, _m = function(e) {
  gN(r, e);
  function r(t) {
    hN(this, r);
    var n = pN(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, t));
    return n.visible = !1, n;
  }
  return vN(r, [{
    key: "componentDidMount",
    value: function() {
      var n = window, a = this.props.scrollContainer;
      a && q6e(a) && (n = n.document.querySelector(a));
      var i = this.props.debounce !== void 0 && vp === "throttle" || vp === "debounce" && this.props.debounce === void 0;
      if (i && ((0, Bu.off)(n, "scroll", da, _s), (0, Bu.off)(window, "resize", da, _s), da = null), da || (this.props.debounce !== void 0 ? (da = (0, U6e.default)(Hp, typeof this.props.debounce == "number" ? this.props.debounce : 300), vp = "debounce") : this.props.throttle !== void 0 ? (da = (0, W6e.default)(Hp, typeof this.props.throttle == "number" ? this.props.throttle : 300), vp = "throttle") : da = Hp), this.props.overflow) {
        var l = (0, O2.default)(Mf.default.findDOMNode(this));
        if (l && typeof l.getAttribute == "function") {
          var u = 1 + +l.getAttribute(Sd);
          u === 1 && l.addEventListener("scroll", da, _s), l.setAttribute(Sd, u);
        }
      } else if (ji.length === 0 || i) {
        var c = this.props, f = c.scroll, h = c.resize;
        f && (0, Bu.on)(n, "scroll", da, _s), h && (0, Bu.on)(window, "resize", da, _s);
      }
      ji.push(this), bN(this);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function() {
      return this.visible;
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (this.props.overflow) {
        var n = (0, O2.default)(Mf.default.findDOMNode(this));
        if (n && typeof n.getAttribute == "function") {
          var a = +n.getAttribute(Sd) - 1;
          a === 0 ? (n.removeEventListener("scroll", da, _s), n.removeAttribute(Sd)) : n.setAttribute(Sd, a);
        }
      }
      var i = ji.indexOf(this);
      i !== -1 && ji.splice(i, 1), ji.length === 0 && typeof window != "undefined" && ((0, Bu.off)(window, "resize", da, _s), (0, Bu.off)(window, "scroll", da, _s));
    }
  }, {
    key: "render",
    value: function() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : I2.default.createElement("div", { style: { height: this.props.height }, className: "lazyload-placeholder" });
    }
  }]), r;
}(L_.Component);
_m.propTypes = {
  once: xt.default.bool,
  height: xt.default.oneOfType([xt.default.number, xt.default.string]),
  offset: xt.default.oneOfType([xt.default.number, xt.default.arrayOf(xt.default.number)]),
  overflow: xt.default.bool,
  resize: xt.default.bool,
  scroll: xt.default.bool,
  children: xt.default.node,
  throttle: xt.default.oneOfType([xt.default.number, xt.default.bool]),
  debounce: xt.default.oneOfType([xt.default.number, xt.default.bool]),
  placeholder: xt.default.node,
  scrollContainer: xt.default.oneOfType([xt.default.string, xt.default.object]),
  unmountIfInvisible: xt.default.bool
};
_m.defaultProps = {
  once: !1,
  offset: 0,
  overflow: !1,
  resize: !1,
  scroll: !0,
  unmountIfInvisible: !1
};
var Z6e = function(r) {
  return r.displayName || r.name || "Component";
}, Q6e = function() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return function(n) {
    return function(a) {
      gN(i, a);
      function i() {
        hN(this, i);
        var l = pN(this, (i.__proto__ || Object.getPrototypeOf(i)).call(this));
        return l.displayName = "LazyLoad" + Z6e(n), l;
      }
      return vN(i, [{
        key: "render",
        value: function() {
          return I2.default.createElement(
            _m,
            r,
            I2.default.createElement(n, this.props)
          );
        }
      }]), i;
    }(L_.Component);
  };
};
_c.lazyload = Q6e;
var F_ = _c.default = _m;
_c.forceCheck = Hp;
const X6e = ({ src: e, alt: r }) => {
  const [t, n] = He(!1), a = () => /* @__PURE__ */ _.jsx("div", { style: { height: "100%" }, className: fp["img-container"], children: /* @__PURE__ */ _.jsx("div", { className: fp["skeleton-placeholder"], children: /* @__PURE__ */ _.jsx("div", { className: fp["skeleton-box"] }) }) });
  return /* @__PURE__ */ _.jsx(F_, { children: t ? /* @__PURE__ */ _.jsx(
    "img",
    {
      className: fp["modal-photo"],
      alt: r,
      onLoad: () => n(!0),
      src: e
    }
  ) : /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
    /* @__PURE__ */ _.jsx(
      "img",
      {
        alt: r,
        onLoad: () => n(!0),
        src: e,
        style: { display: "none" }
      }
    ),
    a()
  ] }) });
}, J6e = ({
  selectedIndex: e,
  photosWithReviewIndices: r,
  nextPhoto: t,
  prevPhoto: n,
  setPhoto: a
}) => {
  const i = Ze(null), l = Ze(null), u = (h) => {
    i.current = h.targetTouches[0].clientX;
  }, c = (h) => {
    l.current = h.targetTouches[0].clientX;
  }, f = () => {
    if (l.current && i.current) {
      const h = i.current - l.current;
      h > 0 ? t() : h < 0 && n();
    }
    i.current = null, l.current = null;
  };
  return /* @__PURE__ */ _.jsxs(
    "div",
    {
      className: zu["modal-photo-slider"],
      onTouchStart: u,
      onTouchMove: c,
      onTouchEnd: f,
      "data-testid": "modal-photo-slider",
      children: [
        /* @__PURE__ */ _.jsx(
          X6e,
          {
            src: r[e].Sizes.large.Url,
            alt: `modal-photo-${e}`
          }
        ),
        r.length >= 2 && /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
          /* @__PURE__ */ _.jsx(
            "div",
            {
              className: zu.next,
              "data-testid": "next-button",
              onClick: t,
              children: /* @__PURE__ */ _.jsx("i", { className: zu["next-arrow"] })
            }
          ),
          /* @__PURE__ */ _.jsx(
            "div",
            {
              className: zu.prev,
              "data-testid": "prev-button",
              onClick: n,
              children: /* @__PURE__ */ _.jsx("i", { className: zu["prev-arrow"] })
            }
          )
        ] }),
        r.length > 1 && /* @__PURE__ */ _.jsx("div", { className: zu["dots-container"], children: /* @__PURE__ */ _.jsx(
          R6e,
          {
            maxDots: 5,
            selectedIndex: e,
            allDots: [...Array(r == null ? void 0 : r.length).keys()],
            onDotClick: a
          }
        ) })
      ]
    }
  );
}, W0 = ({
  reviewsWithPhotos: e,
  setModalOpen: r,
  photoIndex: t
}) => {
  const n = e.flatMap(
    (p, g) => p.Photos.map((y) => Fo(Yt({}, y), { reviewIndex: g }))
  );
  er(() => {
    (() => Gr(void 0, null, function* () {
      const g = e.flatMap(
        (y) => y.Photos.map((S) => {
          var x, T;
          return (T = (x = S == null ? void 0 : S.Sizes) == null ? void 0 : x.large) == null ? void 0 : T.Url;
        })
      );
      yield Promise.all(
        g.map((y) => {
          const S = new Image();
          return S.src = y, new Promise((x) => {
            S.onload = x;
          });
        })
      );
    }))();
  }, [e]);
  const [a, i] = He(t), l = Ze(null), u = () => {
    r(!1), document.body.classList.remove("photo-modal-open");
  }, c = (p) => {
    i(p);
  }, f = () => {
    a < n.length - 1 ? i((p) => p + 1) : i(0);
  }, h = () => {
    a >= 1 ? i((p) => p - 1) : i(n.length - 1);
  };
  return y_(l, !0, u), /* @__PURE__ */ _.jsx("div", { className: cp.modal, children: /* @__PURE__ */ _.jsxs(
    "div",
    {
      className: cp["modal-content"],
      ref: l,
      "data-testid": "photo-modal-content",
      children: [
        /* @__PURE__ */ _.jsx(
          "span",
          {
            className: cp.close,
            "data-testid": "close-button",
            onClick: u
          }
        ),
        n && /* @__PURE__ */ _.jsx(
          J6e,
          {
            photosWithReviewIndices: n,
            selectedIndex: a,
            nextPhoto: f,
            prevPhoto: h,
            setPhoto: c
          }
        ),
        /* @__PURE__ */ _.jsx("div", { className: cp["photo-review-card"], children: /* @__PURE__ */ _.jsx(
          Tm,
          {
            review: e[n[a].reviewIndex],
            type: "photos-modal"
          }
        ) })
      ]
    }
  ) });
}, e8e = "_modal_1perd_2", r8e = "_close_1perd_15", hp = {
  modal: e8e,
  close: r8e,
  "modal-content": "_modal-content_1perd_27",
  "review-card": "_review-card_1perd_40"
}, t8e = ({ review: e, setModalOpen: r }) => {
  const t = Ze(null), n = () => {
    r(!1), document.body.classList.remove("review-modal-open");
  };
  return y_(t, !0, n), /* @__PURE__ */ _.jsx("div", { className: hp.modal, children: /* @__PURE__ */ _.jsx(
    "div",
    {
      className: hp["modal-content"],
      ref: t,
      "data-testid": "review-modal-content",
      children: /* @__PURE__ */ _.jsxs("div", { className: hp["review-card"], children: [
        /* @__PURE__ */ _.jsx(
          "div",
          {
            className: hp.close,
            "data-testid": "close-button",
            onClick: n
          }
        ),
        /* @__PURE__ */ _.jsx(Tm, { review: e, type: "review-modal" })
      ] })
    }
  ) });
}, n8e = (e) => !!(e && e.scrollHeight > e.clientHeight), $O = {
  "clamped-text": "_clamped-text_6ekn9_1",
  "read-more": "_read-more_6ekn9_9"
}, a8e = ({
  children: e,
  clampLineCount: r,
  onClampedClick: t
}) => {
  const n = Ze(null), [a, i] = He(!1);
  return er(() => {
    const l = n.current;
    i(n8e(l));
  }, []), /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
    /* @__PURE__ */ _.jsx(
      "div",
      {
        ref: n,
        className: $O["clamped-text"],
        style: { WebkitLineClamp: r },
        children: e
      }
    ),
    a && /* @__PURE__ */ _.jsx(
      "div",
      {
        className: $O["read-more"],
        "data-testId": "read-more",
        onClick: t,
        children: "Leer más"
      }
    )
  ] });
}, pp = {
  "review-text": "_review-text_aud9j_2",
  "translate-button": "_translate-button_aud9j_9",
  "translate-button-container": "_translate-button-container_aud9j_21"
}, o8e = ({ review: e, type: r }) => {
  var j;
  const [t, n] = He(null), [a, i] = He(!1), [l, u] = He(!1), [c, f] = He(!0), [h, p] = He(!1), [g, y] = He(!1), S = ((j = e.Photos) == null ? void 0 : j.length) > 0, { ReviewText: x } = e;
  er(() => {
    var k;
    i(
      ((k = e == null ? void 0 : e.ContentLocale) == null ? void 0 : k.split("_")[0]) === "en" || (e == null ? void 0 : e.ContentLocale) === "en"
    ), f(!1);
  }, [e]);
  const T = () => Gr(void 0, null, function* () {
    var k, L;
    if (p(!0), l) {
      const M = new CustomEvent("DDPDPOriginalReview", {
        bubbles: !0,
        detail: 1
      });
      window.dispatchEvent(M), u(!1);
    } else {
      if (!t)
        try {
          const W = yield (yield fetch(
            `https://api.mymemory.translated.net/get?q=${encodeURIComponent(
              x
            )}&langpair=en|es`
          )).json();
          if ((W == null ? void 0 : W.responseStatus) !== 200 || !((k = W == null ? void 0 : W.responseData) != null && k.translatedText))
            throw new Error(
              `Primary translation failed: ${(W == null ? void 0 : W.responseDetails) || "No text returned from MyMemory API"}`
            );
          n((L = W == null ? void 0 : W.responseData) == null ? void 0 : L.translatedText);
        } catch (M) {
          console.error(
            "TranslationError -> Primary MyMemory API Error : ",
            M
          );
          try {
            const W = (yield import("./index.min-40a99571.mjs")).default, q = yield W(x, {
              from: "en",
              to: "es"
            });
            if (!q || typeof q != "string")
              throw new Error("Secondary translation failed");
            n(q);
          } catch (W) {
            console.error(
              "TranslationError -> Secondary Translate Library Error : ",
              W
            ), n(x);
          }
        } finally {
          const M = new CustomEvent("DDPDPTranslateReview", {
            bubbles: !0,
            detail: 1
          });
          window.dispatchEvent(M);
        }
      u(!0);
    }
    p(!1);
  }), A = () => {
    S ? document.body.classList.add("photo-modal-open") : document.body.classList.add("review-modal-open"), y(!0);
  }, O = S ? 6 : 10, P = a && l ? t : x;
  return r === "photos-modal" || r === "review-modal" ? /* @__PURE__ */ _.jsx("div", { className: pp["review-text"], children: P }) : /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
    /* @__PURE__ */ _.jsx(
      a8e,
      {
        onClampedClick: A,
        clampLineCount: O,
        children: /* @__PURE__ */ _.jsx("div", { className: pp["review-text"], children: P })
      }
    ),
    g && (S ? /* @__PURE__ */ _.jsx(
      W0,
      {
        reviewsWithPhotos: [e],
        setModalOpen: y,
        photoIndex: 0
      }
    ) : /* @__PURE__ */ _.jsx(t8e, { review: e, setModalOpen: y })),
    !c && a && /* @__PURE__ */ _.jsx("div", { className: pp["translate-button-container"], children: /* @__PURE__ */ _.jsx(
      "button",
      {
        className: pp["translate-button"],
        onClick: T,
        disabled: h,
        id: "ratings_review_translation",
        children: h ? "Traduciendo..." : l ? "Mostrar original" : "Mostrar traducción"
      }
    ) })
  ] });
}, i8e = (e) => {
  const r = new Date(e).getTime(), n = (/* @__PURE__ */ new Date()).getTime() - r, a = Math.floor(n / 1e3), i = Math.floor(a / 60), l = Math.floor(i / 60), u = Math.floor(l / 24), c = Math.floor(u / 7), f = Math.floor(c / 4), h = Math.floor(f / 12);
  let p;
  return l < 24 ? p = "hoy" : u < 7 ? p = `hace ${u} dias` : c === 1 ? p = "hace 1 semana" : c < 4 ? p = `hace ${c} semanas` : f === 1 ? p = "hace 1 mes" : f < 12 ? p = `hace ${f} meses` : h === 1 ? p = "hace 1 año" : p = `hace ${h} años`, p;
}, s8e = "_photo_okc23_2", l8e = "_text_okc23_42", xd = {
  "photos-chain": "_photos-chain_okc23_2",
  "photo-chain-component": "_photo-chain-component_okc23_9",
  "photo-wrapper": "_photo-wrapper_okc23_14",
  photo: s8e,
  text: l8e
}, yN = ({ reviewsWithPhotos: e, limit: r, type: t }) => {
  const n = e.flatMap(
    (f, h) => f.Photos.map((p) => Fo(Yt({}, p), { reviewIndex: h }))
  ), [a, i] = He(!1), [l, u] = He(0);
  if (n.length === 0)
    return null;
  const c = (f) => {
    u(f), document.body.classList.add("photo-modal-open"), i(!0);
  };
  return /* @__PURE__ */ _.jsxs("div", { className: xd["photo-chain-component"], children: [
    /* @__PURE__ */ _.jsx("div", { className: xd["photos-chain"], "data-testid": "photos-chain", children: n.slice(0, r).map((f, h) => {
      var p, g;
      return /* @__PURE__ */ _.jsx(
        "div",
        {
          className: xd["photo-wrapper"],
          onClick: () => c(h),
          children: /* @__PURE__ */ _.jsx(F_, { children: /* @__PURE__ */ _.jsx(
            "img",
            {
              className: xd.photo,
              src: (g = (p = f == null ? void 0 : f.Sizes) == null ? void 0 : p.normal) == null ? void 0 : g.Url,
              id: `${t}-photo-${h + 1}`,
              "data-testid": `photo-${h}`
            }
          ) })
        },
        h
      );
    }) }),
    t === "top-photos" && n.length > 4 && /* @__PURE__ */ _.jsx(
      "button",
      {
        className: xd.text,
        onClick: () => c(0),
        id: "open-photos-modal",
        children: Vt.SEE_COMMENTS_WITH_IMAGES
      }
    ),
    a && /* @__PURE__ */ _.jsx(
      W0,
      {
        reviewsWithPhotos: e,
        setModalOpen: i,
        photoIndex: l
      }
    )
  ] });
}, wO = ({ reviewId: e, value: r }) => {
  const n = /* @__PURE__ */ new Date();
  n.setTime(n.getTime() + 2 * 60 * 60 * 1e3), document.cookie = `review_${e}=${r};expires=${n.toUTCString()};path=/; Priority=High`;
}, Tm = ({ review: e, type: r, starsColor: t }) => {
  const {
    Id: n,
    Title: a,
    Rating: i,
    ReviewText: l,
    TotalPositiveFeedbackCount: u,
    UserNickname: c,
    Photos: f,
    SyndicationSource: h,
    SubmissionTime: p
  } = e, { helpfulIds: g, notHelpfulIds: y, updateFeedbackReviewsList: S } = ea(), x = i8e(p);
  let T = c !== null ? c : "Anónimo";
  T = a ? `por ${T}` : T;
  const [A, O] = He(u), [P, j] = He(!1), [k, L] = He(!1), { tenant: M, environment: W, fetchApiBaseUrl: q } = Eo(), oe = m_({
    tenant: M,
    environment: W,
    fetchApiBaseUrl: q
  });
  er(() => {
    if (g.includes(n)) {
      j(!0), O(u + 1);
      return;
    } else if (y.includes(n)) {
      L(!0);
      return;
    }
    j(!1), L(!1), O(u);
  }, [e, g, y]);
  const Ae = () => Gr(void 0, null, function* () {
    j(!0);
    const $e = yield oe.submitReviewFeedback({
      reviewId: n,
      vote: "positive"
    });
    if (!$e || $e.HasErrors) {
      j(!1);
      return;
    }
    O((Ee) => Ee + 1), wO({ reviewId: e.Id, value: "helpful" }), S({ reviewId: n, type: "helpful" });
  }), Te = () => Gr(void 0, null, function* () {
    L(!0);
    const $e = yield oe.submitReviewFeedback({
      reviewId: n,
      vote: "negative"
    });
    if (!$e || $e.HasErrors) {
      L(!1);
      return;
    }
    wO({ reviewId: e.Id, value: "not_helpful" }), S({ reviewId: n, type: "not_helpful" });
  });
  return /* @__PURE__ */ _.jsxs(
    "div",
    {
      className: `
        ${$n["review-card"]}  ${$n[`${r === "photos-modal" || r === "review-modal" ? "modal" : ""}`]}
      `,
      children: [
        /* @__PURE__ */ _.jsxs(
          "div",
          {
            className: `${$n.header} ${$n[`${r === "review-modal" ? "review-modal" : ""}`]}`,
            children: [
              /* @__PURE__ */ _.jsxs("div", { children: [
                a && /* @__PURE__ */ _.jsx("div", { className: $n["review-title"], "data-testid": "title", children: a }),
                /* @__PURE__ */ _.jsx("div", { className: $n["user-name"], "data-testid": "user-name", children: T })
              ] }),
              /* @__PURE__ */ _.jsxs("div", { children: [
                /* @__PURE__ */ _.jsx("div", { className: $n.rating, "data-testid": "rating", children: /* @__PURE__ */ _.jsx(k_, { rating: i, starsColor: t }) }),
                /* @__PURE__ */ _.jsx("div", { className: $n["time-since"], "data-testid": "time-since", children: x })
              ] })
            ]
          }
        ),
        r !== "photos-modal" && f.length > 0 && /* @__PURE__ */ _.jsx(
          yN,
          {
            reviewsWithPhotos: [e],
            type: "review-card",
            limit: 3
          }
        ),
        l && /* @__PURE__ */ _.jsx("div", { className: $n["review-text"], children: /* @__PURE__ */ _.jsx(o8e, { review: e, type: r }) }),
        h != null && h.Name ? /* @__PURE__ */ _.jsxs(
          "div",
          {
            className: $n["syndication-source"],
            "data-testid": "syndication-source",
            children: [
              "Publicado originalmente en ",
              h.Name
            ]
          }
        ) : /* @__PURE__ */ _.jsxs("div", { className: $n.footer, children: [
          /* @__PURE__ */ _.jsx(
            "div",
            {
              className: $n[`review-helpfulness${P ? "-clicked" : k ? "-disable" : ""}`],
              "data-testid": `like${P || k ? "-disable" : ""}`,
              id: "review-helpful",
              onClick: Ae,
              children: /* @__PURE__ */ _.jsx("div", { className: $n.helpfull })
            }
          ),
          /* @__PURE__ */ _.jsx(
            "div",
            {
              className: $n[`review-helpfulness${k ? "-clicked" : P ? "-disable" : ""}`],
              id: "review-not-helpful",
              onClick: Te,
              "data-testid": `dislike${P || k ? "-disable" : ""}`,
              children: /* @__PURE__ */ _.jsx("div", { className: $n["not-helpfull"] })
            }
          ),
          A > 0 ? /* @__PURE__ */ _.jsx(
            "div",
            {
              className: $n["helpfulness-text"],
              "data-testid": "helpfulness-text",
              children: A === 1 ? Vt.PERSON_FOUND_THIS_HELPFUL : `${A} ${Vt.PEOPLE_FOUND_THIS_HELPFUL}`
            }
          ) : null
        ] })
      ]
    }
  );
}, u8e = "_open_xf0yd_57", c8e = "_selected_xf0yd_92", d8e = "_column_xf0yd_109", f8e = "_text_xf0yd_128", qt = {
  "user-reviews-container": "_user-reviews-container_xf0yd_2",
  "sort-dropdown-container": "_sort-dropdown-container_xf0yd_13",
  "sort-dropdown-button": "_sort-dropdown-button_xf0yd_24",
  "sort-label": "_sort-label_xf0yd_36",
  "sort-value": "_sort-value_xf0yd_41",
  "sort-chevron": "_sort-chevron_xf0yd_49",
  open: u8e,
  "sort-dropdown-menu": "_sort-dropdown-menu_xf0yd_60",
  "sort-option": "_sort-option_xf0yd_73",
  selected: c8e,
  "user-reviews": "_user-reviews_xf0yd_2",
  column: d8e,
  "more-comments-button": "_more-comments-button_xf0yd_116",
  text: f8e
}, SN = () => {
  const e = window.innerWidth;
  return e < 768 ? "Mobile" : e >= 768 && e < 1024 ? "Tablet" : "Desktop";
}, v8e = (e, r) => {
  const t = {
    0: [],
    1: [],
    2: []
  };
  for (let a = 0; a < e.length; a++) {
    const i = a % 3;
    t[i].push(e[a]);
  }
  const n = [];
  for (let a = 0; a < 3; a++) {
    const i = t[a], l = /* @__PURE__ */ _.jsx("div", { className: qt.column, "data-testid": "column", children: i.map((u, c) => /* @__PURE__ */ _.jsx("div", { "data-testid": "review", children: /* @__PURE__ */ _.jsx(
      Tm,
      {
        review: u,
        type: "reviews-container",
        starsColor: r
      }
    ) }, c)) });
    n.push(l);
  }
  return /* @__PURE__ */ _.jsx("div", { className: qt["user-reviews"], children: n });
}, fS = [
  { value: "Rating:desc", label: Vt.BEST_RATING },
  { value: "Relevancy:desc", label: Vt.RELEVANCY },
  { value: "SubmissionTime:desc", label: Vt.MOST_RECENT },
  { value: "SubmissionTime:asc", label: Vt.OLDEST },
  { value: "Helpfulness:desc", label: Vt.MOST_HELPFUL }
], _O = ({
  sort: e,
  changeSort: r
}) => {
  const [t, n] = He(!1), a = Ze(null), i = fS.find((u) => u.value === e) || fS[0];
  er(() => {
    const u = (c) => {
      a.current && !a.current.contains(c.target) && n(!1);
    };
    return document.addEventListener("mousedown", u), () => {
      document.removeEventListener("mousedown", u);
    };
  }, []);
  const l = (u) => {
    r(u), n(!1);
  };
  return /* @__PURE__ */ _.jsxs("div", { className: qt["sort-dropdown-container"], ref: a, children: [
    /* @__PURE__ */ _.jsxs(
      "button",
      {
        className: qt["sort-dropdown-button"],
        onClick: () => n(!t),
        "data-testid": "sort-dropdown-button",
        children: [
          /* @__PURE__ */ _.jsx("span", { className: qt["sort-label"], children: Vt.ORDER_BY }),
          /* @__PURE__ */ _.jsx("span", { className: qt["sort-value"], children: i.label }),
          /* @__PURE__ */ _.jsx(
            "img",
            {
              src: gD,
              alt: "",
              className: `${qt["sort-chevron"]} ${t ? qt.open : ""}`
            }
          )
        ]
      }
    ),
    t && /* @__PURE__ */ _.jsx("div", { className: qt["sort-dropdown-menu"], children: fS.map((u) => /* @__PURE__ */ _.jsx(
      "button",
      {
        className: `${qt["sort-option"]} ${u.value === e ? qt.selected : ""}`,
        onClick: () => l(u.value),
        children: u.label
      },
      u.value
    )) })
  ] });
}, E8e = ({
  starsColor: e = "#333",
  moreReviewsCallback: r
}) => {
  const {
    userReviews: t,
    getMoreReviews: n,
    offset: a,
    totalComments: i = 0,
    sort: l,
    changeSort: u
  } = ea(), { isSodimacStandAlone: c = !1 } = Eo(), f = SN(), h = () => {
    r == null || r(), n();
  };
  return i > 0 ? f === "Desktop" ? /* @__PURE__ */ _.jsxs(
    "div",
    {
      className: qt["user-reviews-container"],
      "data-testid": "user-reviews-container",
      children: [
        /* @__PURE__ */ _.jsx(_O, { sort: l, changeSort: u }),
        t.length > 0 && v8e(t, e),
        i > 0 && a + 9 < i && /* @__PURE__ */ _.jsx(
          "button",
          {
            className: `${qt["more-comments-button"]} ${c ? qt["so-com"] : ""}`,
            "data-testid": "more-comments-button",
            id: "more-comments-button",
            onClick: h,
            children: Vt.VIEW_MORE_COMMENTS
          }
        )
      ]
    }
  ) : /* @__PURE__ */ _.jsxs(
    "div",
    {
      className: qt["user-reviews-container"],
      "data-testid": "user-reviews-container",
      children: [
        /* @__PURE__ */ _.jsx(_O, { sort: l, changeSort: u }),
        t.length > 0 && /* @__PURE__ */ _.jsx("div", { className: qt["user-reviews"], children: t.map((p) => /* @__PURE__ */ _.jsx(
          Tm,
          {
            review: p,
            type: "reviews-container",
            starsColor: e,
            "data-testid": "review"
          }
        )) }),
        i > 0 && a + 9 < i && /* @__PURE__ */ _.jsx(
          "button",
          {
            className: `${qt["more-comments-button"]} ${c ? qt["so-com"] : ""}`,
            "data-testid": "more-comments-button",
            onClick: h,
            children: Vt.VIEW_MORE_COMMENTS
          }
        )
      ]
    }
  ) : null;
}, h8e = "_photo_zwm6x_2", p8e = "_text_zwm6x_76", qn = {
  "photos-chain": "_photos-chain_zwm6x_2",
  "photo-column": "_photo-column_zwm6x_9",
  "photo-wrapper": "_photo-wrapper_zwm6x_21",
  "photo-wrapper-even": "_photo-wrapper-even_zwm6x_38",
  "photo-wrapper-odd": "_photo-wrapper-odd_zwm6x_54",
  photo: h8e,
  text: p8e
}, g8e = ({ reviewsWithPhotos: e }) => {
  const r = e.flatMap(
    (u, c) => u.Photos.map((f) => Fo(Yt({}, f), { reviewIndex: c }))
  ), [t, n] = He(!1), [a, i] = He(0), l = (u) => {
    i(u), document.body.classList.add("photo-modal-open"), n(!0);
  };
  return r.length <= 3 ? /* @__PURE__ */ _.jsx("div", { className: qn["photos-chain"], "data-testid": "photos-chain-mosaic", children: /* @__PURE__ */ _.jsxs("div", { className: qn["photo-column"], children: [
    r.map((u, c) => {
      var f, h;
      return /* @__PURE__ */ _.jsx(
        "div",
        {
          className: qn["photo-wrapper"],
          onClick: () => l(c),
          id: `top-photos-photo-${c + 1}`,
          "data-testid": `no-mosaic-photo-${c}`,
          children: /* @__PURE__ */ _.jsx(F_, { children: /* @__PURE__ */ _.jsx(
            "img",
            {
              className: qn.photo,
              loading: "lazy",
              src: (h = (f = u == null ? void 0 : u.Sizes) == null ? void 0 : f.normal) == null ? void 0 : h.Url
            }
          ) })
        },
        c
      );
    }),
    t && /* @__PURE__ */ _.jsx(
      W0,
      {
        reviewsWithPhotos: e,
        setModalOpen: n,
        photoIndex: a
      }
    )
  ] }) }) : /* @__PURE__ */ _.jsxs("div", { className: qn["photos-chain"], "data-testid": "photos-chain-mosaic", children: [
    /* @__PURE__ */ _.jsx("div", { className: qn["photo-column"], children: r.map((u, c) => {
      var f;
      if (c % 3 === 0)
        return /* @__PURE__ */ _.jsx("div", { className: qn["photo-wrapper-odd"], children: /* @__PURE__ */ _.jsx(
          "div",
          {
            className: qn["photo-wrapper"],
            onClick: () => l(c),
            id: `top-photos-photo-${c + 1}`,
            "data-testid": `mosaic-photo-${c}`,
            children: /* @__PURE__ */ _.jsx(
              "img",
              {
                className: qn.photo,
                src: u.Sizes.normal.Url
              }
            )
          },
          c
        ) });
      if (c % 3 !== 2)
        return /* @__PURE__ */ _.jsxs("div", { className: qn["photo-wrapper-even"], children: [
          /* @__PURE__ */ _.jsx(
            "div",
            {
              className: qn["photo-wrapper"],
              onClick: () => l(c),
              id: `top-photos-photo-${c + 1}`,
              "data-testid": `mosaic-photo-${c}`,
              children: /* @__PURE__ */ _.jsx(
                "img",
                {
                  className: qn.photo,
                  src: u == null ? void 0 : u.Sizes.normal.Url
                }
              )
            },
            c
          ),
          c + 1 < r.length && /* @__PURE__ */ _.jsx(
            "div",
            {
              className: qn["photo-wrapper"],
              onClick: () => l(c + 1),
              id: `top-photos-photo-${c + 2}`,
              "data-testid": `mosaic-photo-${c + 1}`,
              children: /* @__PURE__ */ _.jsx(
                "img",
                {
                  className: qn.photo,
                  src: (f = r[c + 1]) == null ? void 0 : f.Sizes.normal.Url
                }
              )
            },
            c
          )
        ] });
    }) }),
    t && /* @__PURE__ */ _.jsx(
      W0,
      {
        reviewsWithPhotos: e,
        setModalOpen: n,
        photoIndex: a
      }
    )
  ] });
}, A8e = () => {
  const { reviewsWithPhotos: e } = ea();
  return e.length === 0 ? null : SN() === "Mobile" ? /* @__PURE__ */ _.jsx(_.Fragment, { children: /* @__PURE__ */ _.jsx(g8e, { reviewsWithPhotos: e }) }) : /* @__PURE__ */ _.jsx(_.Fragment, { children: /* @__PURE__ */ _.jsx(
    yN,
    {
      reviewsWithPhotos: e,
      limit: 4,
      type: "top-photos"
    }
  ) });
}, m8e = "_sparks_1v2l8_28", gp = {
  "reviews-summary": "_reviews-summary_1v2l8_2",
  "summary-text": "_summary-text_1v2l8_10",
  "generated-with-ai": "_generated-with-ai_1v2l8_17",
  sparks: m8e
}, b8e = ({ reviewsSummary: e }) => /* @__PURE__ */ _.jsxs("div", { className: gp["reviews-summary"], children: [
  /* @__PURE__ */ _.jsx("div", { className: gp["summary-text"], children: e }),
  /* @__PURE__ */ _.jsxs("div", { className: gp["generated-with-ai"], children: [
    /* @__PURE__ */ _.jsx("div", { className: gp.sparks }),
    Vt.GENERATED_WITH_AI
  ] })
] }), I8e = () => {
  const { reviewsSummary: e } = ea();
  return e ? /* @__PURE__ */ _.jsx(b8e, { reviewsSummary: e }) : null;
};
export {
  C8e as GiveRating,
  $8e as LabelToComment,
  w8e as RRProvider,
  _8e as RatingStars,
  T8e as ReviewMetricsPanel,
  I8e as ReviewSummary,
  E8e as Reviews,
  A8e as TopPhotos
};
